(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@mui/material"), require("@innovyze/stylovyze"), require("styled-components"), require("luxon"), require("@innovyze/inno-map"), require("@innovyze/shared-utils"), require("@innovyze/lib_asset_schema"), require("@innovyze/lib_asset_schema_store"), require("redux"), require("@redux-saga/core"), require("@reduxjs/toolkit"), require("@innovyze/map-components"), require("lodash"), require("@redux-saga/core/effects"), require("@innovyze/lib_get_service"), require("i18next"), require("react-redux"), require("@innovyze/shared-utils/lib/geometry/geojson"), require("react-i18next"), require("@mui/styles"), require("@mui/material/TextField"), require("@mui/material/Autocomplete"), require("@mui/icons-material"), require("@mui/icons-material/ExpandMore"), require("@innovyze/map-components/Translations"), require("@mui/material/AccordionSummary"), require("@mui/material/AccordionDetails"), require("@mui/styles/withStyles"), require("@mui/material/Grid"), require("react-router-dom"), require("@mui/lab/TimelineOppositeContent"), require("@mui/material/Paper"), require("@mui/lab/Timeline"), require("@mui/lab/TimelineConnector"), require("@mui/lab/TimelineContent"), require("@mui/lab/TimelineDot"), require("@mui/lab/TimelineItem"), require("@mui/lab/TimelineSeparator"), require("@mui/material/Typography"), require("@innovyze/summaryze"), require("@mui/icons-material/AssignmentLateOutlined"), require("react-player"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "@MaterialUi/Core", "@Innovyze/Stylovyze", "StyledComponents", "Luxon", "@Innovyze/InnoMap", "@innovyze/shared-utils", "@innovyze/lib_asset_schema", "@innovyze/lib_asset_schema_store", "Redux", "@redux-saga/core", "@Reduxjs/Toolkit", "@Innovyze/MapComponents", "Lodash", "@redux-saga/core/effects", "@innovyze/lib_get_service", "I18next", "ReactRedux", "@innovyze/shared-utils/lib/geometry/geojson", "ReactI18next", "@MaterialUi/styles", "@mui/material/TextField", "@mui/material/Autocomplete", "@mui/icons-material", "@mui/icons-material/ExpandMore", "@innovyze/map-components/Translations", "@mui/material/AccordionSummary", "@mui/material/AccordionDetails", "@mui/styles/withStyles", "@mui/material/Grid", "ReactRouterDom", "@mui/lab/TimelineOppositeContent", "@mui/material/Paper", "@mui/lab/Timeline", "@mui/lab/TimelineConnector", "@mui/lab/TimelineContent", "@mui/lab/TimelineDot", "@mui/lab/TimelineItem", "@mui/lab/TimelineSeparator", "@mui/material/Typography", "@innovyze/summaryze", "@mui/icons-material/AssignmentLateOutlined", "ReactPlayer"], factory);
	else if(typeof exports === 'object')
		exports["lib-am-common"] = factory(require("react"), require("@mui/material"), require("@innovyze/stylovyze"), require("styled-components"), require("luxon"), require("@innovyze/inno-map"), require("@innovyze/shared-utils"), require("@innovyze/lib_asset_schema"), require("@innovyze/lib_asset_schema_store"), require("redux"), require("@redux-saga/core"), require("@reduxjs/toolkit"), require("@innovyze/map-components"), require("lodash"), require("@redux-saga/core/effects"), require("@innovyze/lib_get_service"), require("i18next"), require("react-redux"), require("@innovyze/shared-utils/lib/geometry/geojson"), require("react-i18next"), require("@mui/styles"), require("@mui/material/TextField"), require("@mui/material/Autocomplete"), require("@mui/icons-material"), require("@mui/icons-material/ExpandMore"), require("@innovyze/map-components/Translations"), require("@mui/material/AccordionSummary"), require("@mui/material/AccordionDetails"), require("@mui/styles/withStyles"), require("@mui/material/Grid"), require("react-router-dom"), require("@mui/lab/TimelineOppositeContent"), require("@mui/material/Paper"), require("@mui/lab/Timeline"), require("@mui/lab/TimelineConnector"), require("@mui/lab/TimelineContent"), require("@mui/lab/TimelineDot"), require("@mui/lab/TimelineItem"), require("@mui/lab/TimelineSeparator"), require("@mui/material/Typography"), require("@innovyze/summaryze"), require("@mui/icons-material/AssignmentLateOutlined"), require("react-player"));
	else
		root["lib-am-common"] = factory(root["React"], root["@MaterialUi/Core"], root["@Innovyze/Stylovyze"], root["StyledComponents"], root["Luxon"], root["@Innovyze/InnoMap"], root["@innovyze/shared-utils"], root["@innovyze/lib_asset_schema"], root["@innovyze/lib_asset_schema_store"], root["Redux"], root["@redux-saga/core"], root["@Reduxjs/Toolkit"], root["@Innovyze/MapComponents"], root["Lodash"], root["@redux-saga/core/effects"], root["@innovyze/lib_get_service"], root["I18next"], root["ReactRedux"], root["@innovyze/shared-utils/lib/geometry/geojson"], root["ReactI18next"], root["@MaterialUi/styles"], root["@mui/material/TextField"], root["@mui/material/Autocomplete"], root["@mui/icons-material"], root["@mui/icons-material/ExpandMore"], root["@innovyze/map-components/Translations"], root["@mui/material/AccordionSummary"], root["@mui/material/AccordionDetails"], root["@mui/styles/withStyles"], root["@mui/material/Grid"], root["ReactRouterDom"], root["@mui/lab/TimelineOppositeContent"], root["@mui/material/Paper"], root["@mui/lab/Timeline"], root["@mui/lab/TimelineConnector"], root["@mui/lab/TimelineContent"], root["@mui/lab/TimelineDot"], root["@mui/lab/TimelineItem"], root["@mui/lab/TimelineSeparator"], root["@mui/material/Typography"], root["@innovyze/summaryze"], root["@mui/icons-material/AssignmentLateOutlined"], root["ReactPlayer"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__mui_material__, __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__, __WEBPACK_EXTERNAL_MODULE_styled_components__, __WEBPACK_EXTERNAL_MODULE_luxon__, __WEBPACK_EXTERNAL_MODULE__innovyze_inno_map__, __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__, __WEBPACK_EXTERNAL_MODULE_redux__, __WEBPACK_EXTERNAL_MODULE__redux_saga_core__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE__innovyze_map_components__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__, __WEBPACK_EXTERNAL_MODULE_i18next__, __WEBPACK_EXTERNAL_MODULE_react_redux__, __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils_lib_geometry_geojson__, __WEBPACK_EXTERNAL_MODULE_react_i18next__, __WEBPACK_EXTERNAL_MODULE__mui_styles__, __WEBPACK_EXTERNAL_MODULE__mui_material_TextField__, __WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ExpandMore__, __WEBPACK_EXTERNAL_MODULE__innovyze_map_components_Translations__, __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary__, __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails__, __WEBPACK_EXTERNAL_MODULE__mui_styles_withStyles__, __WEBPACK_EXTERNAL_MODULE__mui_material_Grid__, __WEBPACK_EXTERNAL_MODULE_react_router_dom__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineOppositeContent__, __WEBPACK_EXTERNAL_MODULE__mui_material_Paper__, __WEBPACK_EXTERNAL_MODULE__mui_lab_Timeline__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineConnector__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineContent__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineDot__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineItem__, __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineSeparator__, __WEBPACK_EXTERNAL_MODULE__mui_material_Typography__, __WEBPACK_EXTERNAL_MODULE__innovyze_summaryze__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_AssignmentLateOutlined__, __WEBPACK_EXTERNAL_MODULE_react_player__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../node_modules/css-loader/dist/cjs.js!./components/AssetDetails/InspDetails/InspDetails.component.style.css":
/*!********************************************************************************************************************!*\
  !*** ../node_modules/css-loader/dist/cjs.js!./components/AssetDetails/InspDetails/InspDetails.component.style.css ***!
  \********************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../node_modules/css-loader/dist/runtime/api.js */ "../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-arrow,
.rec-arrow:hover:enabled,
.rec-arrow:focus:enabled {
	background-color: white !important;
	box-shadow: 0 0 0 0 !important;
}

.rec-pagination {
	display: none !important;
}

.rec-arrow:hover:enabled,
.rec-arrow:focus:enabled {
	color: #333 !important;
}
`, "",{"version":3,"sources":["webpack://./components/AssetDetails/InspDetails/InspDetails.component.style.css"],"names":[],"mappings":"AAAA;;;CAGC,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,sBAAsB;AACvB","sourcesContent":[".rec-arrow,\n.rec-arrow:hover:enabled,\n.rec-arrow:focus:enabled {\n\tbackground-color: white !important;\n\tbox-shadow: 0 0 0 0 !important;\n}\n\n.rec-pagination {\n\tdisplay: none !important;\n}\n\n.rec-arrow:hover:enabled,\n.rec-arrow:focus:enabled {\n\tcolor: #333 !important;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../node_modules/css-loader/dist/cjs.js!./components/DetailsCard/DetailsCard.styles.css":
/*!**********************************************************************************************!*\
  !*** ../node_modules/css-loader/dist/cjs.js!./components/DetailsCard/DetailsCard.styles.css ***!
  \**********************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.normalCard {
    border-left: 6px solid #0071a4;
    padding: 5px 10px;
    width: 100%;
}

.errorCard {
    border-left: 6px solid red;
    padding: 5px 10px;
    width: 100%;
}

.warningCard {
    border-left: 6px solid yellow;
    padding: 5px 10px;
    width: 100%;
}

.informationCard {
    border-left: 6px solid green;
    padding: 5px 10px;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/DetailsCard/DetailsCard.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".normalCard {\n    border-left: 6px solid #0071a4;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.errorCard {\n    border-left: 6px solid red;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.warningCard {\n    border-left: 6px solid yellow;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.informationCard {\n    border-left: 6px solid green;\n    padding: 5px 10px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../node_modules/css-loader/dist/cjs.js!./components/ObservationPhoto/ObservationPhoto.style.css":
/*!*******************************************************************************************************!*\
  !*** ../node_modules/css-loader/dist/cjs.js!./components/ObservationPhoto/ObservationPhoto.style.css ***!
  \*******************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.observationPhoto:hover {
    transform: scale(1.2);
    transition: transform 0.5s cubic-bezier(0.25, 0.45, 0.45, 0.95);
}

.selected {
    border-width: 2px;
    border-style: solid;
    border-color: blue;
}`, "",{"version":3,"sources":["webpack://./components/ObservationPhoto/ObservationPhoto.style.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,+DAA+D;AACnE;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".observationPhoto:hover {\n    transform: scale(1.2);\n    transition: transform 0.5s cubic-bezier(0.25, 0.45, 0.45, 0.95);\n}\n\n.selected {\n    border-width: 2px;\n    border-style: solid;\n    border-color: blue;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!****************************************************!*\
  !*** ../node_modules/moment/locale/ sync ^\.\/.*$ ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./af": "../node_modules/moment/locale/af.js",
	"./af.js": "../node_modules/moment/locale/af.js",
	"./ar": "../node_modules/moment/locale/ar.js",
	"./ar-dz": "../node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "../node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "../node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "../node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "../node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "../node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "../node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "../node_modules/moment/locale/ar-ma.js",
	"./ar-ps": "../node_modules/moment/locale/ar-ps.js",
	"./ar-ps.js": "../node_modules/moment/locale/ar-ps.js",
	"./ar-sa": "../node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "../node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "../node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "../node_modules/moment/locale/ar-tn.js",
	"./ar.js": "../node_modules/moment/locale/ar.js",
	"./az": "../node_modules/moment/locale/az.js",
	"./az.js": "../node_modules/moment/locale/az.js",
	"./be": "../node_modules/moment/locale/be.js",
	"./be.js": "../node_modules/moment/locale/be.js",
	"./bg": "../node_modules/moment/locale/bg.js",
	"./bg.js": "../node_modules/moment/locale/bg.js",
	"./bm": "../node_modules/moment/locale/bm.js",
	"./bm.js": "../node_modules/moment/locale/bm.js",
	"./bn": "../node_modules/moment/locale/bn.js",
	"./bn-bd": "../node_modules/moment/locale/bn-bd.js",
	"./bn-bd.js": "../node_modules/moment/locale/bn-bd.js",
	"./bn.js": "../node_modules/moment/locale/bn.js",
	"./bo": "../node_modules/moment/locale/bo.js",
	"./bo.js": "../node_modules/moment/locale/bo.js",
	"./br": "../node_modules/moment/locale/br.js",
	"./br.js": "../node_modules/moment/locale/br.js",
	"./bs": "../node_modules/moment/locale/bs.js",
	"./bs.js": "../node_modules/moment/locale/bs.js",
	"./ca": "../node_modules/moment/locale/ca.js",
	"./ca.js": "../node_modules/moment/locale/ca.js",
	"./cs": "../node_modules/moment/locale/cs.js",
	"./cs.js": "../node_modules/moment/locale/cs.js",
	"./cv": "../node_modules/moment/locale/cv.js",
	"./cv.js": "../node_modules/moment/locale/cv.js",
	"./cy": "../node_modules/moment/locale/cy.js",
	"./cy.js": "../node_modules/moment/locale/cy.js",
	"./da": "../node_modules/moment/locale/da.js",
	"./da.js": "../node_modules/moment/locale/da.js",
	"./de": "../node_modules/moment/locale/de.js",
	"./de-at": "../node_modules/moment/locale/de-at.js",
	"./de-at.js": "../node_modules/moment/locale/de-at.js",
	"./de-ch": "../node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "../node_modules/moment/locale/de-ch.js",
	"./de.js": "../node_modules/moment/locale/de.js",
	"./dv": "../node_modules/moment/locale/dv.js",
	"./dv.js": "../node_modules/moment/locale/dv.js",
	"./el": "../node_modules/moment/locale/el.js",
	"./el.js": "../node_modules/moment/locale/el.js",
	"./en-au": "../node_modules/moment/locale/en-au.js",
	"./en-au.js": "../node_modules/moment/locale/en-au.js",
	"./en-ca": "../node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "../node_modules/moment/locale/en-ca.js",
	"./en-gb": "../node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "../node_modules/moment/locale/en-gb.js",
	"./en-ie": "../node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "../node_modules/moment/locale/en-ie.js",
	"./en-il": "../node_modules/moment/locale/en-il.js",
	"./en-il.js": "../node_modules/moment/locale/en-il.js",
	"./en-in": "../node_modules/moment/locale/en-in.js",
	"./en-in.js": "../node_modules/moment/locale/en-in.js",
	"./en-nz": "../node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "../node_modules/moment/locale/en-nz.js",
	"./en-sg": "../node_modules/moment/locale/en-sg.js",
	"./en-sg.js": "../node_modules/moment/locale/en-sg.js",
	"./eo": "../node_modules/moment/locale/eo.js",
	"./eo.js": "../node_modules/moment/locale/eo.js",
	"./es": "../node_modules/moment/locale/es.js",
	"./es-do": "../node_modules/moment/locale/es-do.js",
	"./es-do.js": "../node_modules/moment/locale/es-do.js",
	"./es-mx": "../node_modules/moment/locale/es-mx.js",
	"./es-mx.js": "../node_modules/moment/locale/es-mx.js",
	"./es-us": "../node_modules/moment/locale/es-us.js",
	"./es-us.js": "../node_modules/moment/locale/es-us.js",
	"./es.js": "../node_modules/moment/locale/es.js",
	"./et": "../node_modules/moment/locale/et.js",
	"./et.js": "../node_modules/moment/locale/et.js",
	"./eu": "../node_modules/moment/locale/eu.js",
	"./eu.js": "../node_modules/moment/locale/eu.js",
	"./fa": "../node_modules/moment/locale/fa.js",
	"./fa.js": "../node_modules/moment/locale/fa.js",
	"./fi": "../node_modules/moment/locale/fi.js",
	"./fi.js": "../node_modules/moment/locale/fi.js",
	"./fil": "../node_modules/moment/locale/fil.js",
	"./fil.js": "../node_modules/moment/locale/fil.js",
	"./fo": "../node_modules/moment/locale/fo.js",
	"./fo.js": "../node_modules/moment/locale/fo.js",
	"./fr": "../node_modules/moment/locale/fr.js",
	"./fr-ca": "../node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "../node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "../node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "../node_modules/moment/locale/fr-ch.js",
	"./fr.js": "../node_modules/moment/locale/fr.js",
	"./fy": "../node_modules/moment/locale/fy.js",
	"./fy.js": "../node_modules/moment/locale/fy.js",
	"./ga": "../node_modules/moment/locale/ga.js",
	"./ga.js": "../node_modules/moment/locale/ga.js",
	"./gd": "../node_modules/moment/locale/gd.js",
	"./gd.js": "../node_modules/moment/locale/gd.js",
	"./gl": "../node_modules/moment/locale/gl.js",
	"./gl.js": "../node_modules/moment/locale/gl.js",
	"./gom-deva": "../node_modules/moment/locale/gom-deva.js",
	"./gom-deva.js": "../node_modules/moment/locale/gom-deva.js",
	"./gom-latn": "../node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "../node_modules/moment/locale/gom-latn.js",
	"./gu": "../node_modules/moment/locale/gu.js",
	"./gu.js": "../node_modules/moment/locale/gu.js",
	"./he": "../node_modules/moment/locale/he.js",
	"./he.js": "../node_modules/moment/locale/he.js",
	"./hi": "../node_modules/moment/locale/hi.js",
	"./hi.js": "../node_modules/moment/locale/hi.js",
	"./hr": "../node_modules/moment/locale/hr.js",
	"./hr.js": "../node_modules/moment/locale/hr.js",
	"./hu": "../node_modules/moment/locale/hu.js",
	"./hu.js": "../node_modules/moment/locale/hu.js",
	"./hy-am": "../node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "../node_modules/moment/locale/hy-am.js",
	"./id": "../node_modules/moment/locale/id.js",
	"./id.js": "../node_modules/moment/locale/id.js",
	"./is": "../node_modules/moment/locale/is.js",
	"./is.js": "../node_modules/moment/locale/is.js",
	"./it": "../node_modules/moment/locale/it.js",
	"./it-ch": "../node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "../node_modules/moment/locale/it-ch.js",
	"./it.js": "../node_modules/moment/locale/it.js",
	"./ja": "../node_modules/moment/locale/ja.js",
	"./ja.js": "../node_modules/moment/locale/ja.js",
	"./jv": "../node_modules/moment/locale/jv.js",
	"./jv.js": "../node_modules/moment/locale/jv.js",
	"./ka": "../node_modules/moment/locale/ka.js",
	"./ka.js": "../node_modules/moment/locale/ka.js",
	"./kk": "../node_modules/moment/locale/kk.js",
	"./kk.js": "../node_modules/moment/locale/kk.js",
	"./km": "../node_modules/moment/locale/km.js",
	"./km.js": "../node_modules/moment/locale/km.js",
	"./kn": "../node_modules/moment/locale/kn.js",
	"./kn.js": "../node_modules/moment/locale/kn.js",
	"./ko": "../node_modules/moment/locale/ko.js",
	"./ko.js": "../node_modules/moment/locale/ko.js",
	"./ku": "../node_modules/moment/locale/ku.js",
	"./ku-kmr": "../node_modules/moment/locale/ku-kmr.js",
	"./ku-kmr.js": "../node_modules/moment/locale/ku-kmr.js",
	"./ku.js": "../node_modules/moment/locale/ku.js",
	"./ky": "../node_modules/moment/locale/ky.js",
	"./ky.js": "../node_modules/moment/locale/ky.js",
	"./lb": "../node_modules/moment/locale/lb.js",
	"./lb.js": "../node_modules/moment/locale/lb.js",
	"./lo": "../node_modules/moment/locale/lo.js",
	"./lo.js": "../node_modules/moment/locale/lo.js",
	"./lt": "../node_modules/moment/locale/lt.js",
	"./lt.js": "../node_modules/moment/locale/lt.js",
	"./lv": "../node_modules/moment/locale/lv.js",
	"./lv.js": "../node_modules/moment/locale/lv.js",
	"./me": "../node_modules/moment/locale/me.js",
	"./me.js": "../node_modules/moment/locale/me.js",
	"./mi": "../node_modules/moment/locale/mi.js",
	"./mi.js": "../node_modules/moment/locale/mi.js",
	"./mk": "../node_modules/moment/locale/mk.js",
	"./mk.js": "../node_modules/moment/locale/mk.js",
	"./ml": "../node_modules/moment/locale/ml.js",
	"./ml.js": "../node_modules/moment/locale/ml.js",
	"./mn": "../node_modules/moment/locale/mn.js",
	"./mn.js": "../node_modules/moment/locale/mn.js",
	"./mr": "../node_modules/moment/locale/mr.js",
	"./mr.js": "../node_modules/moment/locale/mr.js",
	"./ms": "../node_modules/moment/locale/ms.js",
	"./ms-my": "../node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "../node_modules/moment/locale/ms-my.js",
	"./ms.js": "../node_modules/moment/locale/ms.js",
	"./mt": "../node_modules/moment/locale/mt.js",
	"./mt.js": "../node_modules/moment/locale/mt.js",
	"./my": "../node_modules/moment/locale/my.js",
	"./my.js": "../node_modules/moment/locale/my.js",
	"./nb": "../node_modules/moment/locale/nb.js",
	"./nb.js": "../node_modules/moment/locale/nb.js",
	"./ne": "../node_modules/moment/locale/ne.js",
	"./ne.js": "../node_modules/moment/locale/ne.js",
	"./nl": "../node_modules/moment/locale/nl.js",
	"./nl-be": "../node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "../node_modules/moment/locale/nl-be.js",
	"./nl.js": "../node_modules/moment/locale/nl.js",
	"./nn": "../node_modules/moment/locale/nn.js",
	"./nn.js": "../node_modules/moment/locale/nn.js",
	"./oc-lnc": "../node_modules/moment/locale/oc-lnc.js",
	"./oc-lnc.js": "../node_modules/moment/locale/oc-lnc.js",
	"./pa-in": "../node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "../node_modules/moment/locale/pa-in.js",
	"./pl": "../node_modules/moment/locale/pl.js",
	"./pl.js": "../node_modules/moment/locale/pl.js",
	"./pt": "../node_modules/moment/locale/pt.js",
	"./pt-br": "../node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "../node_modules/moment/locale/pt-br.js",
	"./pt.js": "../node_modules/moment/locale/pt.js",
	"./ro": "../node_modules/moment/locale/ro.js",
	"./ro.js": "../node_modules/moment/locale/ro.js",
	"./ru": "../node_modules/moment/locale/ru.js",
	"./ru.js": "../node_modules/moment/locale/ru.js",
	"./sd": "../node_modules/moment/locale/sd.js",
	"./sd.js": "../node_modules/moment/locale/sd.js",
	"./se": "../node_modules/moment/locale/se.js",
	"./se.js": "../node_modules/moment/locale/se.js",
	"./si": "../node_modules/moment/locale/si.js",
	"./si.js": "../node_modules/moment/locale/si.js",
	"./sk": "../node_modules/moment/locale/sk.js",
	"./sk.js": "../node_modules/moment/locale/sk.js",
	"./sl": "../node_modules/moment/locale/sl.js",
	"./sl.js": "../node_modules/moment/locale/sl.js",
	"./sq": "../node_modules/moment/locale/sq.js",
	"./sq.js": "../node_modules/moment/locale/sq.js",
	"./sr": "../node_modules/moment/locale/sr.js",
	"./sr-cyrl": "../node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "../node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "../node_modules/moment/locale/sr.js",
	"./ss": "../node_modules/moment/locale/ss.js",
	"./ss.js": "../node_modules/moment/locale/ss.js",
	"./sv": "../node_modules/moment/locale/sv.js",
	"./sv.js": "../node_modules/moment/locale/sv.js",
	"./sw": "../node_modules/moment/locale/sw.js",
	"./sw.js": "../node_modules/moment/locale/sw.js",
	"./ta": "../node_modules/moment/locale/ta.js",
	"./ta.js": "../node_modules/moment/locale/ta.js",
	"./te": "../node_modules/moment/locale/te.js",
	"./te.js": "../node_modules/moment/locale/te.js",
	"./tet": "../node_modules/moment/locale/tet.js",
	"./tet.js": "../node_modules/moment/locale/tet.js",
	"./tg": "../node_modules/moment/locale/tg.js",
	"./tg.js": "../node_modules/moment/locale/tg.js",
	"./th": "../node_modules/moment/locale/th.js",
	"./th.js": "../node_modules/moment/locale/th.js",
	"./tk": "../node_modules/moment/locale/tk.js",
	"./tk.js": "../node_modules/moment/locale/tk.js",
	"./tl-ph": "../node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "../node_modules/moment/locale/tl-ph.js",
	"./tlh": "../node_modules/moment/locale/tlh.js",
	"./tlh.js": "../node_modules/moment/locale/tlh.js",
	"./tr": "../node_modules/moment/locale/tr.js",
	"./tr.js": "../node_modules/moment/locale/tr.js",
	"./tzl": "../node_modules/moment/locale/tzl.js",
	"./tzl.js": "../node_modules/moment/locale/tzl.js",
	"./tzm": "../node_modules/moment/locale/tzm.js",
	"./tzm-latn": "../node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "../node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "../node_modules/moment/locale/tzm.js",
	"./ug-cn": "../node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "../node_modules/moment/locale/ug-cn.js",
	"./uk": "../node_modules/moment/locale/uk.js",
	"./uk.js": "../node_modules/moment/locale/uk.js",
	"./ur": "../node_modules/moment/locale/ur.js",
	"./ur.js": "../node_modules/moment/locale/ur.js",
	"./uz": "../node_modules/moment/locale/uz.js",
	"./uz-latn": "../node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "../node_modules/moment/locale/uz-latn.js",
	"./uz.js": "../node_modules/moment/locale/uz.js",
	"./vi": "../node_modules/moment/locale/vi.js",
	"./vi.js": "../node_modules/moment/locale/vi.js",
	"./x-pseudo": "../node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "../node_modules/moment/locale/x-pseudo.js",
	"./yo": "../node_modules/moment/locale/yo.js",
	"./yo.js": "../node_modules/moment/locale/yo.js",
	"./zh-cn": "../node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "../node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "../node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "../node_modules/moment/locale/zh-hk.js",
	"./zh-mo": "../node_modules/moment/locale/zh-mo.js",
	"./zh-mo.js": "../node_modules/moment/locale/zh-mo.js",
	"./zh-tw": "../node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "../node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "../node_modules/@turf/bbox/dist/js/index.js":
/*!***************************************************!*\
  !*** ../node_modules/@turf/bbox/dist/js/index.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var meta_1 = __webpack_require__(/*! @turf/meta */ "../node_modules/@turf/meta/dist/js/index.js");
/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */
function bbox(geojson) {
    var result = [Infinity, Infinity, -Infinity, -Infinity];
    meta_1.coordEach(geojson, function (coord) {
        if (result[0] > coord[0]) {
            result[0] = coord[0];
        }
        if (result[1] > coord[1]) {
            result[1] = coord[1];
        }
        if (result[2] < coord[0]) {
            result[2] = coord[0];
        }
        if (result[3] < coord[1]) {
            result[3] = coord[1];
        }
    });
    return result;
}
bbox["default"] = bbox;
exports["default"] = bbox;


/***/ }),

/***/ "../node_modules/@turf/center/dist/js/index.js":
/*!*****************************************************!*\
  !*** ../node_modules/@turf/center/dist/js/index.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var bbox_1 = __importDefault(__webpack_require__(/*! @turf/bbox */ "../node_modules/@turf/bbox/dist/js/index.js"));
var helpers_1 = __webpack_require__(/*! @turf/helpers */ "../node_modules/@turf/helpers/dist/js/index.js");
/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.points([
 *   [-97.522259, 35.4691],
 *   [-97.502754, 35.463455],
 *   [-97.508269, 35.463245]
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */
function center(geojson, options) {
    if (options === void 0) { options = {}; }
    var ext = bbox_1.default(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return helpers_1.point([x, y], options.properties, options);
}
exports["default"] = center;


/***/ }),

/***/ "../node_modules/@turf/helpers/dist/js/index.js":
/*!******************************************************!*\
  !*** ../node_modules/@turf/helpers/dist/js/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * @module helpers
 */
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */
exports.earthRadius = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.factors = {
    centimeters: exports.earthRadius * 100,
    centimetres: exports.earthRadius * 100,
    degrees: exports.earthRadius / 111325,
    feet: exports.earthRadius * 3.28084,
    inches: exports.earthRadius * 39.37,
    kilometers: exports.earthRadius / 1000,
    kilometres: exports.earthRadius / 1000,
    meters: exports.earthRadius,
    metres: exports.earthRadius,
    miles: exports.earthRadius / 1609.344,
    millimeters: exports.earthRadius * 1000,
    millimetres: exports.earthRadius * 1000,
    nauticalmiles: exports.earthRadius / 1852,
    radians: 1,
    yards: exports.earthRadius * 1.0936,
};
/**
 * Units of measurement factors based on 1 meter.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 1 / 1000,
    kilometres: 1 / 1000,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / exports.earthRadius,
    yards: 1.0936133,
};
/**
 * Area of measurement factors based on 1 square meter.
 *
 * @memberof helpers
 * @type {Object}
 */
exports.areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046,
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */
function feature(geom, properties, options) {
    if (options === void 0) { options = {}; }
    var feat = { type: "Feature" };
    if (options.id === 0 || options.id) {
        feat.id = options.id;
    }
    if (options.bbox) {
        feat.bbox = options.bbox;
    }
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
exports.feature = feature;
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */
function geometry(type, coordinates, _options) {
    if (_options === void 0) { _options = {}; }
    switch (type) {
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
exports.geometry = geometry;
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */
function point(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (!coordinates) {
        throw new Error("coordinates is required");
    }
    if (!Array.isArray(coordinates)) {
        throw new Error("coordinates must be an Array");
    }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be at least 2 numbers long");
    }
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
        throw new Error("coordinates must contain numbers");
    }
    var geom = {
        type: "Point",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.point = point;
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */
function points(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return point(coords, properties);
    }), options);
}
exports.points = points;
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */
function polygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
        var ring = coordinates_1[_i];
        if (ring.length < 4) {
            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        }
        for (var j = 0; j < ring[ring.length - 1].length; j++) {
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) {
                throw new Error("First and last Position are not equivalent.");
            }
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.polygon = polygon;
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */
function polygons(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return polygon(coords, properties);
    }), options);
}
exports.polygons = polygons;
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */
function lineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be an array of two or more positions");
    }
    var geom = {
        type: "LineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.lineString = lineString;
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */
function lineStrings(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return lineString(coords, properties);
    }), options);
}
exports.lineStrings = lineStrings;
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */
function featureCollection(features, options) {
    if (options === void 0) { options = {}; }
    var fc = { type: "FeatureCollection" };
    if (options.id) {
        fc.id = options.id;
    }
    if (options.bbox) {
        fc.bbox = options.bbox;
    }
    fc.features = features;
    return fc;
}
exports.featureCollection = featureCollection;
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */
function multiLineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiLineString = multiLineString;
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */
function multiPoint(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiPoint = multiPoint;
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
exports.multiPolygon = multiPolygon;
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */
function geometryCollection(geometries, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "GeometryCollection",
        geometries: geometries,
    };
    return feature(geom, properties, options);
}
exports.geometryCollection = geometryCollection;
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */
function round(num, precision) {
    if (precision === void 0) { precision = 0; }
    if (precision && !(precision >= 0)) {
        throw new Error("precision must be a positive number");
    }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
exports.round = round;
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */
function radiansToLength(radians, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = exports.factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return radians * factor;
}
exports.radiansToLength = radiansToLength;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */
function lengthToRadians(distance, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = exports.factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return distance / factor;
}
exports.lengthToRadians = lengthToRadians;
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
exports.lengthToDegrees = lengthToDegrees;
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) {
        angle += 360;
    }
    return angle;
}
exports.bearingToAzimuth = bearingToAzimuth;
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return (degrees * 180) / Math.PI;
}
exports.radiansToDegrees = radiansToDegrees;
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return (radians * Math.PI) / 180;
}
exports.degreesToRadians = degreesToRadians;
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "kilometers"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(length >= 0)) {
        throw new Error("length must be a positive number");
    }
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
exports.convertLength = convertLength;
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "meters"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(area >= 0)) {
        throw new Error("area must be a positive number");
    }
    var startFactor = exports.areaFactors[originalUnit];
    if (!startFactor) {
        throw new Error("invalid original units");
    }
    var finalFactor = exports.areaFactors[finalUnit];
    if (!finalFactor) {
        throw new Error("invalid final units");
    }
    return (area / startFactor) * finalFactor;
}
exports.convertArea = convertArea;
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
exports.isNumber = isNumber;
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */
function isObject(input) {
    return !!input && input.constructor === Object;
}
exports.isObject = isObject;
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */
function validateBBox(bbox) {
    if (!bbox) {
        throw new Error("bbox is required");
    }
    if (!Array.isArray(bbox)) {
        throw new Error("bbox must be an Array");
    }
    if (bbox.length !== 4 && bbox.length !== 6) {
        throw new Error("bbox must be an Array of 4 or 6 numbers");
    }
    bbox.forEach(function (num) {
        if (!isNumber(num)) {
            throw new Error("bbox must only contain numbers");
        }
    });
}
exports.validateBBox = validateBBox;
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */
function validateId(id) {
    if (!id) {
        throw new Error("id is required");
    }
    if (["string", "number"].indexOf(typeof id) === -1) {
        throw new Error("id must be a number or a string");
    }
}
exports.validateId = validateId;


/***/ }),

/***/ "../node_modules/@turf/meta/dist/js/index.js":
/*!***************************************************!*\
  !*** ../node_modules/@turf/meta/dist/js/index.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var helpers = __webpack_require__(/*! @turf/helpers */ "../node_modules/@turf/helpers/dist/js/index.js");

/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function coordEach(geojson, callback, excludeWrapCoord) {
  // Handles null Geometry -- Skips this GeoJSON
  if (geojson === null) return;
  var j,
    k,
    l,
    geometry,
    stopG,
    coords,
    geometryMaybeCollection,
    wrapShrink = 0,
    coordIndex = 0,
    isGeometryCollection,
    type = geojson.type,
    isFeatureCollection = type === "FeatureCollection",
    isFeature = type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[featureIndex].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[geomIndex]
        : geometryMaybeCollection;

      // Handles null Geometry -- Skips this geometry
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;

      wrapShrink =
        excludeWrapCoord &&
        (geomType === "Polygon" || geomType === "MultiPolygon")
          ? 1
          : 0;

      switch (geomType) {
        case null:
          break;
        case "Point":
          if (
            callback(
              coords,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (
              callback(
                coords[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false
            )
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (
                callback(
                  coords[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false
              )
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (
                  callback(
                    coords[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false
                )
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (
              coordEach(geometry.geometries[j], callback, excludeWrapCoord) ===
              false
            )
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}

/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function (
      currentCoord,
      coordIndex,
      featureIndex,
      multiFeatureIndex,
      geometryIndex
    ) {
      if (coordIndex === 0 && initialValue === undefined)
        previousValue = currentCoord;
      else
        previousValue = callback(
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}

/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */
function propEach(geojson, callback) {
  var i;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i = 0; i < geojson.features.length; i++) {
        if (callback(geojson.features[i].properties, i) === false) break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}

/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function (currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}

/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i = 0; i < geojson.features.length; i++) {
      if (callback(geojson.features[i], i) === false) break;
    }
  }
}

/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach(geojson, function (currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === undefined)
      previousValue = currentFeature;
    else previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}

/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function (coord) {
    coords.push(coord);
  });
  return coords;
}

/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */
function geomEach(geojson, callback) {
  var i,
    j,
    g,
    geometry,
    stopG,
    geometryMaybeCollection,
    isGeometryCollection,
    featureProperties,
    featureBBox,
    featureId,
    featureIndex = 0,
    isFeatureCollection = geojson.type === "FeatureCollection",
    isFeature = geojson.type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[i].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    featureProperties = isFeatureCollection
      ? geojson.features[i].properties
      : isFeature
      ? geojson.properties
      : {};
    featureBBox = isFeatureCollection
      ? geojson.features[i].bbox
      : isFeature
      ? geojson.bbox
      : undefined;
    featureId = isFeatureCollection
      ? geojson.features[i].id
      : isFeature
      ? geojson.id
      : undefined;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[g]
        : geometryMaybeCollection;

      // Handle null Geometry
      if (geometry === null) {
        if (
          callback(
            null,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false
        )
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (
            callback(
              geometry,
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false
          )
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (
              callback(
                geometry.geometries[j],
                featureIndex,
                featureProperties,
                featureBBox,
                featureId
              ) === false
            )
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    // Only increase `featureIndex` per each feature
    featureIndex++;
  }
}

/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */

/**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function (
      currentGeometry,
      featureIndex,
      featureProperties,
      featureBBox,
      featureId
    ) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}

/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */
function flattenEach(geojson, callback) {
  geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
    // Callback for single geometry
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (
          callback(
            helpers.feature(geometry, properties, { bbox: bbox, id: id }),
            featureIndex,
            0
          ) === false
        )
          return false;
        return;
    }

    var geomType;

    // Callback for multi-geometry
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }

    for (
      var multiFeatureIndex = 0;
      multiFeatureIndex < geometry.coordinates.length;
      multiFeatureIndex++
    ) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate,
      };
      if (
        callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) ===
        false
      )
        return false;
    }
  });
}

/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */

/**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach(
    geojson,
    function (currentFeature, featureIndex, multiFeatureIndex) {
      if (
        featureIndex === 0 &&
        multiFeatureIndex === 0 &&
        initialValue === undefined
      )
        previousValue = currentFeature;
      else
        previousValue = callback(
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}

/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */

/**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */
function segmentEach(geojson, callback) {
  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;

    // Exclude null Geometries
    if (!feature.geometry) return;
    // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
    var type = feature.geometry.type;
    if (type === "Point" || type === "MultiPoint") return;

    // Generate 2-vertex line segments
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (
      coordEach(
        feature,
        function (
          currentCoord,
          coordIndex,
          featureIndexCoord,
          multiPartIndexCoord,
          geometryIndex
        ) {
          // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
          if (
            previousCoords === undefined ||
            featureIndex > previousFeatureIndex ||
            multiPartIndexCoord > previousMultiIndex ||
            geometryIndex > prevGeomIndex
          ) {
            previousCoords = currentCoord;
            previousFeatureIndex = featureIndex;
            previousMultiIndex = multiPartIndexCoord;
            prevGeomIndex = geometryIndex;
            segmentIndex = 0;
            return;
          }
          var currentSegment = helpers.lineString(
            [previousCoords, currentCoord],
            feature.properties
          );
          if (
            callback(
              currentSegment,
              featureIndex,
              multiFeatureIndex,
              geometryIndex,
              segmentIndex
            ) === false
          )
            return false;
          segmentIndex++;
          previousCoords = currentCoord;
        }
      ) === false
    )
      return false;
  });
}

/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */

/**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function (
      currentSegment,
      featureIndex,
      multiFeatureIndex,
      geometryIndex,
      segmentIndex
    ) {
      if (started === false && initialValue === undefined)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}

/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function lineEach(geojson, callback) {
  // validation
  if (!geojson) throw new Error("geojson is required");

  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
    if (feature.geometry === null) return;
    var type = feature.geometry.type;
    var coords = feature.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (
          var geometryIndex = 0;
          geometryIndex < coords.length;
          geometryIndex++
        ) {
          if (
            callback(
              helpers.lineString(coords[geometryIndex], feature.properties),
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
        }
        break;
    }
  });
}

/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */

/**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === undefined)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}

/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */
function findSegment(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!helpers.isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var segmentIndex = options.segmentIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find SegmentIndex
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
      return helpers.lineString(
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options
      );
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return helpers.lineString(
        [
          coords[geometryIndex][segmentIndex],
          coords[geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return helpers.lineString(
        [
          coords[multiFeatureIndex][segmentIndex],
          coords[multiFeatureIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex =
          coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return helpers.lineString(
        [
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1],
        ],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}

/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */
function findPoint(geojson, options) {
  // Optional Parameters
  options = options || {};
  if (!helpers.isObject(options)) throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var coordIndex = options.coordIndex || 0;

  // Find FeatureIndex
  var properties = options.properties;
  var geometry;

  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }

  // Find Coord Index
  if (geometry === null) return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
      return helpers.point(coords, properties, options);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return helpers.point(coords[multiFeatureIndex], properties, options);
    case "LineString":
      if (coordIndex < 0) coordIndex = coords.length + coordIndex;
      return helpers.point(coords[coordIndex], properties, options);
    case "Polygon":
      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return helpers.point(coords[geometryIndex][coordIndex], properties, options);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex =
          coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return helpers.point(
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}

exports.coordAll = coordAll;
exports.coordEach = coordEach;
exports.coordReduce = coordReduce;
exports.featureEach = featureEach;
exports.featureReduce = featureReduce;
exports.findPoint = findPoint;
exports.findSegment = findSegment;
exports.flattenEach = flattenEach;
exports.flattenReduce = flattenReduce;
exports.geomEach = geomEach;
exports.geomReduce = geomReduce;
exports.lineEach = lineEach;
exports.lineReduce = lineReduce;
exports.propEach = propEach;
exports.propReduce = propReduce;
exports.segmentEach = segmentEach;
exports.segmentReduce = segmentReduce;


/***/ }),

/***/ "../node_modules/browser-cookies/src/browser-cookies.js":
/*!**************************************************************!*\
  !*** ../node_modules/browser-cookies/src/browser-cookies.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports) => {

exports.defaults = {};

exports.set = function(name, value, options) {
  // Retrieve options and defaults
  var opts = options || {};
  var defaults = exports.defaults;

  // Apply default value for unspecified options
  var expires  = opts.expires  || defaults.expires;
  var domain   = opts.domain   || defaults.domain;
  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
  var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;

  // Determine cookie expiration date
  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
  var expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
      // else expires should be either a Date object or in a format recognized by Date.parse()
      expires
  ) : 0;

  // Set cookie
  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
  .replace('(', '%28')
  .replace(')', '%29') +
  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
  (domain   ? ';domain=' + domain     : '') +                                      // Add domain
  (path     ? ';path='   + path       : '') +                                      // Add path
  (secure   ? ';secure'               : '') +                                      // Add secure option
  (httponly ? ';httponly'             : '') +                                      // Add httponly option
  (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
};

exports.get = function(name) {
  var cookies = document.cookie.split(';');
  
  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));

    // Return cookie value if the name matches
    if (cookie_name === name) {
      return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
  }

  // Return `null` as the cookie was not found
  return null;
};

exports.erase = function(name, options) {
  exports.set(name, '', {
    expires:  -1,
    domain:   options && options.domain,
    path:     options && options.path,
    secure:   0,
    httponly: 0}
  );
};

exports.all = function() {
  var all = {};
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    // add the cookie name and value to the `all` object
    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
    all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
  }

  return all;
};


/***/ }),

/***/ "../node_modules/clsx/dist/clsx.js":
/*!*****************************************!*\
  !*** ../node_modules/clsx/dist/clsx.js ***!
  \*****************************************/
/***/ ((module) => {

function r(e){var o,t,f="";if("string"==typeof e||"number"==typeof e)f+=e;else if("object"==typeof e)if(Array.isArray(e)){var n=e.length;for(o=0;o<n;o++)e[o]&&(t=r(e[o]))&&(f&&(f+=" "),f+=t)}else for(t in e)e[t]&&(f&&(f+=" "),f+=t);return f}function e(){for(var e,o,t=0,f="",n=arguments.length;t<n;t++)(e=arguments[t])&&(o=r(e))&&(f&&(f+=" "),f+=o);return f}module.exports=e,module.exports.clsx=e;

/***/ }),

/***/ "../node_modules/css-loader/dist/runtime/api.js":
/*!******************************************************!*\
  !*** ../node_modules/css-loader/dist/runtime/api.js ***!
  \******************************************************/
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ "../node_modules/css-loader/dist/runtime/sourceMaps.js":
/*!*************************************************************!*\
  !*** ../node_modules/css-loader/dist/runtime/sourceMaps.js ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ "../node_modules/isomorphic-ws/browser.js":
/*!************************************************!*\
  !*** ../node_modules/isomorphic-ws/browser.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof __webpack_require__.g !== 'undefined') {
  ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
} else if (typeof self !== 'undefined') {
  ws = self.WebSocket || self.MozWebSocket
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ws);


/***/ }),

/***/ "../node_modules/moment/locale/af.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/af.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-dz.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-dz.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-kw.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-kw.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-ly.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-ly.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-ma.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-ma.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-ps.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-ps.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-sa.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-sa.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar-tn.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ar-tn.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ar.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ar.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ "../node_modules/moment/locale/az.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/az.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ "../node_modules/moment/locale/be.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/be.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bg.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/bg.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bm.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/bm.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bn-bd.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/bn-bd.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bn.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/bn.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bo.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/bo.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/br.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/br.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ "../node_modules/moment/locale/bs.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/bs.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ca.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ca.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ "../node_modules/moment/locale/cs.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/cs.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ "../node_modules/moment/locale/cv.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/cv.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ "../node_modules/moment/locale/cy.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/cy.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ "../node_modules/moment/locale/da.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/da.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ "../node_modules/moment/locale/de-at.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/de-at.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ "../node_modules/moment/locale/de-ch.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/de-ch.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ "../node_modules/moment/locale/de.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/de.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ "../node_modules/moment/locale/dv.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/dv.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ "../node_modules/moment/locale/el.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/el.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-au.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-au.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-ca.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-ca.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-gb.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-gb.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-ie.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-ie.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-il.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-il.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-in.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-in.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-nz.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-nz.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ "../node_modules/moment/locale/en-sg.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/en-sg.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ "../node_modules/moment/locale/eo.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/eo.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/es-do.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/es-do.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/es-mx.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/es-mx.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ "../node_modules/moment/locale/es-us.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/es-us.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ "../node_modules/moment/locale/es.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/es.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ "../node_modules/moment/locale/et.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/et.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ "../node_modules/moment/locale/eu.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/eu.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fa.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/fa.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fi.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/fi.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fil.js":
/*!********************************************!*\
  !*** ../node_modules/moment/locale/fil.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fo.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/fo.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fr-ca.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/fr-ca.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fr-ch.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/fr-ch.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fr.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/fr.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/fy.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/fy.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ga.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ga.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ "../node_modules/moment/locale/gd.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/gd.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ "../node_modules/moment/locale/gl.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/gl.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/gom-deva.js":
/*!*************************************************!*\
  !*** ../node_modules/moment/locale/gom-deva.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ "../node_modules/moment/locale/gom-latn.js":
/*!*************************************************!*\
  !*** ../node_modules/moment/locale/gom-latn.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/gu.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/gu.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ "../node_modules/moment/locale/he.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/he.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ "../node_modules/moment/locale/hi.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/hi.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ "../node_modules/moment/locale/hr.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/hr.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/hu.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/hu.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ "../node_modules/moment/locale/hy-am.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/hy-am.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ "../node_modules/moment/locale/id.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/id.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ "../node_modules/moment/locale/is.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/is.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ "../node_modules/moment/locale/it-ch.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/it-ch.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ "../node_modules/moment/locale/it.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/it.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ja.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ja.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ "../node_modules/moment/locale/jv.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/jv.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ka.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ka.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ "../node_modules/moment/locale/kk.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/kk.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/km.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/km.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ "../node_modules/moment/locale/kn.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/kn.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ko.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ko.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ku-kmr.js":
/*!***********************************************!*\
  !*** ../node_modules/moment/locale/ku-kmr.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ku.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ku.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ky.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ky.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ "../node_modules/moment/locale/lb.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/lb.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ "../node_modules/moment/locale/lo.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/lo.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/lt.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/lt.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ "../node_modules/moment/locale/lv.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/lv.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ "../node_modules/moment/locale/me.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/me.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ "../node_modules/moment/locale/mi.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/mi.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ "../node_modules/moment/locale/mk.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/mk.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ml.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ml.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ "../node_modules/moment/locale/mn.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/mn.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/mr.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/mr.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ms-my.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ms-my.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ms.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ms.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ "../node_modules/moment/locale/mt.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/mt.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ "../node_modules/moment/locale/my.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/my.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ "../node_modules/moment/locale/nb.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/nb.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ne.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ne.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ "../node_modules/moment/locale/nl-be.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/nl-be.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ "../node_modules/moment/locale/nl.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/nl.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/nn.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/nn.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/oc-lnc.js":
/*!***********************************************!*\
  !*** ../node_modules/moment/locale/oc-lnc.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ "../node_modules/moment/locale/pa-in.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/pa-in.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/pl.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/pl.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/pt-br.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/pt-br.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/pt.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/pt.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ro.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ro.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ru.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ru.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sd.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sd.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ "../node_modules/moment/locale/se.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/se.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ "../node_modules/moment/locale/si.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/si.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sk.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sk.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sl.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sl.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sq.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sq.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sr-cyrl.js":
/*!************************************************!*\
  !*** ../node_modules/moment/locale/sr-cyrl.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sr.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sr.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ss.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ss.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sv.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sv.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ "../node_modules/moment/locale/sw.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/sw.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ta.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ta.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ "../node_modules/moment/locale/te.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/te.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tet.js":
/*!********************************************!*\
  !*** ../node_modules/moment/locale/tet.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tg.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/tg.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ "../node_modules/moment/locale/th.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/th.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tk.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/tk.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tl-ph.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/tl-ph.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tlh.js":
/*!********************************************!*\
  !*** ../node_modules/moment/locale/tlh.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tr.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/tr.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tzl.js":
/*!********************************************!*\
  !*** ../node_modules/moment/locale/tzl.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tzm-latn.js":
/*!*************************************************!*\
  !*** ../node_modules/moment/locale/tzm-latn.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/tzm.js":
/*!********************************************!*\
  !*** ../node_modules/moment/locale/tzm.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ug-cn.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/ug-cn.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/uk.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/uk.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/ur.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/ur.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ "../node_modules/moment/locale/uz-latn.js":
/*!************************************************!*\
  !*** ../node_modules/moment/locale/uz-latn.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/uz.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/uz.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ "../node_modules/moment/locale/vi.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/vi.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ "../node_modules/moment/locale/x-pseudo.js":
/*!*************************************************!*\
  !*** ../node_modules/moment/locale/x-pseudo.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/yo.js":
/*!*******************************************!*\
  !*** ../node_modules/moment/locale/yo.js ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/zh-cn.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/zh-cn.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ "../node_modules/moment/locale/zh-hk.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/zh-hk.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ "../node_modules/moment/locale/zh-mo.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/zh-mo.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ "../node_modules/moment/locale/zh-tw.js":
/*!**********************************************!*\
  !*** ../node_modules/moment/locale/zh-tw.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ "../node_modules/moment/moment.js")) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ "../node_modules/moment/moment.js":
/*!****************************************!*\
  !*** ../node_modules/moment/moment.js ***!
  \****************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__("../node_modules/moment/locale sync recursive ^\\.\\/.*$")("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ "../node_modules/object-assign/index.js":
/*!**********************************************!*\
  !*** ../node_modules/object-assign/index.js ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../node_modules/react/cjs/react-jsx-runtime.development.js":
/*!******************************************************************!*\
  !*** ../node_modules/react/cjs/react-jsx-runtime.development.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var React = __webpack_require__(/*! react */ "react");
var _assign = __webpack_require__(/*! object-assign */ "../node_modules/object-assign/index.js");

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}


/***/ }),

/***/ "../node_modules/react/jsx-runtime.js":
/*!********************************************!*\
  !*** ../node_modules/react/jsx-runtime.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-jsx-runtime.development.js */ "../node_modules/react/cjs/react-jsx-runtime.development.js");
}


/***/ }),

/***/ "../node_modules/redux-devtools-extension/index.js":
/*!*********************************************************!*\
  !*** ../node_modules/redux-devtools-extension/index.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var compose = (__webpack_require__(/*! redux */ "redux").compose);

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),

/***/ "../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js":
/*!************************************************************************!*\
  !*** ../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _redux_saga_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @redux-saga/core */ "@redux-saga/core");
/* harmony import */ var _redux_saga_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_redux_saga_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _redux_saga_core__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _redux_saga_core__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_redux_saga_core__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js":
/*!***************************************************************************!*\
  !*** ../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);



/***/ }),

/***/ "../node_modules/style-loader/lib/addStyles.js":
/*!*****************************************************!*\
  !*** ../node_modules/style-loader/lib/addStyles.js ***!
  \*****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "../node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "../node_modules/style-loader/lib/urls.js":
/*!************************************************!*\
  !*** ../node_modules/style-loader/lib/urls.js ***!
  \************************************************/
/***/ ((module) => {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./components/AssetDetails/InspDetails/InspDetails.component.style.css":
/*!*****************************************************************************!*\
  !*** ./components/AssetDetails/InspDetails/InspDetails.component.style.css ***!
  \*****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(/*! !!../../../../node_modules/css-loader/dist/cjs.js!./InspDetails.component.style.css */ "../node_modules/css-loader/dist/cjs.js!./components/AssetDetails/InspDetails/InspDetails.component.style.css");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! !../../../../node_modules/style-loader/lib/addStyles.js */ "../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./components/DetailsCard/DetailsCard.styles.css":
/*!*******************************************************!*\
  !*** ./components/DetailsCard/DetailsCard.styles.css ***!
  \*******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(/*! !!../../../node_modules/css-loader/dist/cjs.js!./DetailsCard.styles.css */ "../node_modules/css-loader/dist/cjs.js!./components/DetailsCard/DetailsCard.styles.css");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! !../../../node_modules/style-loader/lib/addStyles.js */ "../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./components/ObservationPhoto/ObservationPhoto.style.css":
/*!****************************************************************!*\
  !*** ./components/ObservationPhoto/ObservationPhoto.style.css ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(/*! !!../../../node_modules/css-loader/dist/cjs.js!./ObservationPhoto.style.css */ "../node_modules/css-loader/dist/cjs.js!./components/ObservationPhoto/ObservationPhoto.style.css");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! !../../../node_modules/style-loader/lib/addStyles.js */ "../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./actions/Rehab.action.ts":
/*!*********************************!*\
  !*** ./actions/Rehab.action.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toggleRehabTreePublishStateRejected = exports.toggleRehabTreePublishStateResolved = exports.toggleRehabTreePublishState = exports.getRehabResultRejected = exports.getRehabResultResolved = exports.getRehabResult = exports.getRehabTreesResolved = exports.getRehabTreesRejected = exports.getRehabTrees = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getRehabTrees = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTrees'));
exports.getRehabTreesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTreesRejected'));
exports.getRehabTreesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabTrees/resolved'));
exports.getRehabResult = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult'));
exports.getRehabResultResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult/resolved'));
exports.getRehabResultRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('getRehabResult/rejected'));
exports.toggleRehabTreePublishState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState'));
exports.toggleRehabTreePublishStateResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState/resolved'));
exports.toggleRehabTreePublishStateRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('toggleRehabTreePublishState/rejected'));


/***/ }),

/***/ "./actions/assetDetail.actions.ts":
/*!****************************************!*\
  !*** ./actions/assetDetail.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetLocation = exports.setAssetLocationIsWaiting = exports.setAssetLocation = exports.setInspectionsValidatingAsset = exports.clearValidAssetIds = exports.checkAssetIdsRejected = exports.checkAssetIdsResolved = exports.checkAssetIds = exports.addAssetDetailNote = exports.setAssetDetailNotesIsWaiting = exports.setAssetDetailIsWaiting = exports.getAssetDetailMapInsertResolved = exports.getAssetDetailRejected = exports.getAssetDetailResolved = exports.getAssetDetail = exports.loadAssetDetails = exports.getAssetCountsRejected = exports.getAssetCountsResolved = exports.getAssetCounts = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetCounts = (0, toolkit_1.createAction)('assets/getAssetCounts');
exports.getAssetCountsResolved = (0, toolkit_1.createAction)('assets/getAssetCounts/resolved');
exports.getAssetCountsRejected = (0, toolkit_1.createAction)('assets/getAssetCounts/rejected');
exports.loadAssetDetails = (0, toolkit_1.createAction)('assets/loadAssetDetails');
exports.getAssetDetail = (0, toolkit_1.createAction)('assets/getAssetDetail');
exports.getAssetDetailResolved = (0, toolkit_1.createAction)('assets/getAssetDetail/resolved');
exports.getAssetDetailRejected = (0, toolkit_1.createAction)('assets/getAssetDetail/rejected');
exports.getAssetDetailMapInsertResolved = (0, toolkit_1.createAction)('assets/getAssetDetailMapInsert/resolved');
exports.setAssetDetailIsWaiting = (0, toolkit_1.createAction)('assets/getAssetDetail/isWaiting');
exports.setAssetDetailNotesIsWaiting = (0, toolkit_1.createAction)('assets/getAssetDetail/notesIsWaiting');
exports.addAssetDetailNote = (0, toolkit_1.createAction)('assets/addAssetDetailNote');
exports.checkAssetIds = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIds'));
exports.checkAssetIdsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIdsResolved'));
exports.checkAssetIdsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/checkAssetIdsRejected'));
exports.clearValidAssetIds = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/clear'));
exports.setInspectionsValidatingAsset = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/validatingAsset'));
exports.setAssetLocation = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/setAssetLocation'));
exports.setAssetLocationIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('assetDetail/setAssetLocationIsWaiting'));
exports.getAssetLocation = (0, toolkit_1.createAction)('assetDetail/getAssetLocation');


/***/ }),

/***/ "./actions/assetManhole.actions.ts":
/*!*****************************************!*\
  !*** ./actions/assetManhole.actions.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetManholeRejected = exports.getAssetManholeResolved = exports.getAssetManhole = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetManhole = (0, toolkit_1.createAction)('assets/getAssetManhole');
exports.getAssetManholeResolved = (0, toolkit_1.createAction)('assets/getAssetManhole/resolved');
exports.getAssetManholeRejected = (0, toolkit_1.createAction)('assets/getAssetManhole/rejected');


/***/ }),

/***/ "./actions/assetPipe.actions.ts":
/*!**************************************!*\
  !*** ./actions/assetPipe.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetPipeRejected = exports.getAssetPipeResolved = exports.getAssetPipe = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetPipe = (0, toolkit_1.createAction)('assets/getAssetPipe');
exports.getAssetPipeResolved = (0, toolkit_1.createAction)('assets/getAssetPipe/resolved');
exports.getAssetPipeRejected = (0, toolkit_1.createAction)('assets/getAssetPipe/rejected');


/***/ }),

/***/ "./actions/assetRisk.actions.ts":
/*!**************************************!*\
  !*** ./actions/assetRisk.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskSummaryRejected = exports.getRiskSummaryResolved = exports.getRiskSummary = exports.setRiskSummaryIsLoading = exports.getRiskSettingRejected = exports.getRiskSettingResolved = exports.getRiskSetting = exports.getAssetRiskHistoryRejected = exports.getAssetRiskHistoryResolved = exports.getAssetRiskHistory = exports.getAssetRiskRejected = exports.getAssetRiskWaiting = exports.getAssetRiskResolved = exports.getAssetRisk = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetRisk = (0, toolkit_1.createAction)('assets/getAssetRisk');
exports.getAssetRiskResolved = (0, toolkit_1.createAction)('assets/getAssetRisk/resolved');
exports.getAssetRiskWaiting = (0, toolkit_1.createAction)('assets/getAssetRisk/waiting');
exports.getAssetRiskRejected = (0, toolkit_1.createAction)('assets/getAssetRisk/rejected');
exports.getAssetRiskHistory = (0, toolkit_1.createAction)('assets/getAssetRiskHistory');
exports.getAssetRiskHistoryResolved = (0, toolkit_1.createAction)('assets/getAssetRiskHistory/resolved');
exports.getAssetRiskHistoryRejected = (0, toolkit_1.createAction)('assets/getAssetRiskHistory/rejected');
exports.getRiskSetting = (0, toolkit_1.createAction)('assets/getRiskSetting');
exports.getRiskSettingResolved = (0, toolkit_1.createAction)('assets/getRiskSetting/resolved');
exports.getRiskSettingRejected = (0, toolkit_1.createAction)('assets/getRiskSetting/rejected');
exports.setRiskSummaryIsLoading = (0, toolkit_1.createAction)('assets/setRiskSummaryIsLoading');
exports.getRiskSummary = (0, toolkit_1.createAction)('assets/getRiskSummary');
exports.getRiskSummaryResolved = (0, toolkit_1.createAction)('assets/getRiskSummary/resolved');
exports.getRiskSummaryRejected = (0, toolkit_1.createAction)('assets/getRiskSummary/rejected');


/***/ }),

/***/ "./actions/charts.actions.ts":
/*!***********************************!*\
  !*** ./actions/charts.actions.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearCharts = exports.clearChart = exports.getChartsRejected = exports.getChartsResolved = exports.getCharts = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getCharts = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts'));
exports.getChartsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/resolved'));
exports.getChartsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/rejected'));
exports.clearChart = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('chart/clear'));
exports.clearCharts = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('charts/clear'));


/***/ }),

/***/ "./actions/configuration.actions.ts":
/*!******************************************!*\
  !*** ./actions/configuration.actions.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getConfigurationRejected = exports.getConfigurationResolved = exports.getConfigurationWithUploadId = exports.getConfigurationWithMapping = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getConfigurationWithMapping = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfigurationWithMapping'));
exports.getConfigurationWithUploadId = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfigurationWithUploadId'));
exports.getConfigurationResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfiguration/resolved'));
exports.getConfigurationRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('configuration/getConfiguration/rejected'));


/***/ }),

/***/ "./actions/fullInspection.actions.ts":
/*!*******************************************!*\
  !*** ./actions/fullInspection.actions.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setNotesIsWaiting = exports.setFullInspectionIsWaiting = exports.addNoteRejected = exports.addNote = exports.getNotesRejected = exports.getNotesResolved = exports.getNotes = exports.clearFullInsp = exports.getFullInspRejected = exports.getFullInspResolved = exports.getFullInsp = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getFullInsp = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInsp'));
exports.getFullInspResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspResolved'));
exports.getFullInspRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspRejected'));
exports.clearFullInsp = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/clearFullInsp'));
exports.getNotes = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotes'));
exports.getNotesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotesResolved'));
exports.getNotesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/getFullInspNotesRejected'));
exports.addNote = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/addNote'));
exports.addNoteRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/addNoteRejected'));
exports.setFullInspectionIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/isWaiting'));
exports.setNotesIsWaiting = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspection/notesIsWaiting'));


/***/ }),

/***/ "./actions/index.ts":
/*!**************************!*\
  !*** ./actions/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getConfigurationWithMapping = exports.clearObservations = exports.clearFilters = exports.setTypeFilters = exports.setGradeFilters = exports.setStepOnly = exports.setContinuousOnly = exports.setJointOnly = exports.deleteObservations = exports.createObservations = exports.editObservations = exports.getObservations = exports.getAssetCounts = exports.clearValidAssetIds = exports.checkAssetIds = exports.addNote = exports.clearFullInsp = exports.getFullInsp = void 0;
__exportStar(__webpack_require__(/*! ./assetDetail.actions */ "./actions/assetDetail.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetManhole.actions */ "./actions/assetManhole.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetPipe.actions */ "./actions/assetPipe.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./assetRisk.actions */ "./actions/assetRisk.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspection.actions */ "./actions/inspection.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.actions */ "./actions/map.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./spatial.actions */ "./actions/spatial.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./observations.actions */ "./actions/observations.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./riskConfigs.actions */ "./actions/riskConfigs.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./charts.actions */ "./actions/charts.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./configuration.actions */ "./actions/configuration.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./Rehab.action */ "./actions/Rehab.action.ts"), exports);
var fullInspection_actions_1 = __webpack_require__(/*! ./fullInspection.actions */ "./actions/fullInspection.actions.ts");
Object.defineProperty(exports, "getFullInsp", ({ enumerable: true, get: function () { return fullInspection_actions_1.getFullInsp; } }));
Object.defineProperty(exports, "addNote", ({ enumerable: true, get: function () { return fullInspection_actions_1.addNote; } }));
Object.defineProperty(exports, "clearFullInsp", ({ enumerable: true, get: function () { return fullInspection_actions_1.clearFullInsp; } }));
var observations_actions_1 = __webpack_require__(/*! ./observations.actions */ "./actions/observations.actions.ts");
Object.defineProperty(exports, "getObservations", ({ enumerable: true, get: function () { return observations_actions_1.getObservations; } }));
Object.defineProperty(exports, "editObservations", ({ enumerable: true, get: function () { return observations_actions_1.editObservations; } }));
Object.defineProperty(exports, "createObservations", ({ enumerable: true, get: function () { return observations_actions_1.createObservations; } }));
Object.defineProperty(exports, "deleteObservations", ({ enumerable: true, get: function () { return observations_actions_1.deleteObservations; } }));
Object.defineProperty(exports, "setJointOnly", ({ enumerable: true, get: function () { return observations_actions_1.setJointOnly; } }));
Object.defineProperty(exports, "setContinuousOnly", ({ enumerable: true, get: function () { return observations_actions_1.setContinuousOnly; } }));
Object.defineProperty(exports, "setStepOnly", ({ enumerable: true, get: function () { return observations_actions_1.setStepOnly; } }));
Object.defineProperty(exports, "clearFilters", ({ enumerable: true, get: function () { return observations_actions_1.clearFilters; } }));
Object.defineProperty(exports, "setGradeFilters", ({ enumerable: true, get: function () { return observations_actions_1.setGradeFilters; } }));
Object.defineProperty(exports, "setTypeFilters", ({ enumerable: true, get: function () { return observations_actions_1.setTypeFilters; } }));
Object.defineProperty(exports, "clearObservations", ({ enumerable: true, get: function () { return observations_actions_1.clearObservations; } }));
var assetDetail_actions_1 = __webpack_require__(/*! ./assetDetail.actions */ "./actions/assetDetail.actions.ts");
Object.defineProperty(exports, "checkAssetIds", ({ enumerable: true, get: function () { return assetDetail_actions_1.checkAssetIds; } }));
Object.defineProperty(exports, "clearValidAssetIds", ({ enumerable: true, get: function () { return assetDetail_actions_1.clearValidAssetIds; } }));
Object.defineProperty(exports, "getAssetCounts", ({ enumerable: true, get: function () { return assetDetail_actions_1.getAssetCounts; } }));
var configuration_actions_1 = __webpack_require__(/*! ./configuration.actions */ "./actions/configuration.actions.ts");
Object.defineProperty(exports, "getConfigurationWithMapping", ({ enumerable: true, get: function () { return configuration_actions_1.getConfigurationWithMapping; } }));
exports["default"] = {
    getFullInsp: fullInspection_actions_1.getFullInsp,
    clearFullInsp: fullInspection_actions_1.clearFullInsp,
    addNote: fullInspection_actions_1.addNote,
    checkAssetIds: assetDetail_actions_1.checkAssetIds,
    clearValidAssetIds: assetDetail_actions_1.clearValidAssetIds,
    getObservations: observations_actions_1.getObservations,
    editObservations: observations_actions_1.editObservations,
    createObservations: observations_actions_1.createObservations,
    deleteObservations: observations_actions_1.deleteObservations,
    setJointOnly: observations_actions_1.setJointOnly,
    setContinuousOnly: observations_actions_1.setContinuousOnly,
    setGradeFilters: observations_actions_1.setGradeFilters,
    setTypeFilters: observations_actions_1.setTypeFilters,
    setStepOnly: observations_actions_1.setStepOnly,
    clearFilters: observations_actions_1.clearFilters,
    clearObservations: observations_actions_1.clearObservations,
    getConfigurationWithMapping: configuration_actions_1.getConfigurationWithMapping,
};


/***/ }),

/***/ "./actions/inspection.actions.ts":
/*!***************************************!*\
  !*** ./actions/inspection.actions.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setCreatingInspection = exports.setCreateInspectionId = exports.createInspection = exports.refreshInspection = exports.updateInspection = exports.getInspectionAttributesRejected = exports.getInspectionAttributesResolved = exports.getInspectionAttributesWaiting = exports.getInspectionAttributes = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getInspectionAttributes = (0, toolkit_1.createAction)('inspections/getInspectionAttributes');
exports.getInspectionAttributesWaiting = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/waiting');
exports.getInspectionAttributesResolved = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/resolved');
exports.getInspectionAttributesRejected = (0, toolkit_1.createAction)('inspections/getInspectionAttributes/rejected');
exports.updateInspection = (0, toolkit_1.createAction)('inspections/update');
exports.refreshInspection = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, toolkit_1.createAction)('refreshInspection');
exports.createInspection = (0, toolkit_1.createAction)('inspections/create');
exports.setCreateInspectionId = (0, toolkit_1.createAction)('inspections/createInspectionId');
exports.setCreatingInspection = (0, toolkit_1.createAction)('inspections/creatingInspection');


/***/ }),

/***/ "./actions/map.actions.ts":
/*!********************************!*\
  !*** ./actions/map.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getMapLayers = exports.getMapRehabLayersRejected = exports.getMapRehabLayersResolved = exports.getMapRehabLayers = exports.getMapRiskLayersRejected = exports.getMapRiskLayersResolved = exports.getMapRiskLayers = exports.mapMainSelection = exports.mapMainExtent = exports.mapMainPosition = exports.mapSpatialTilesSourceHide = exports.mapSpatial = exports.mapStateUrl = exports.mapMain = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var namespace = 'libAmCommon/map/';
exports.mapMain = (0, toolkit_1.createAction)(namespace + 'map_main');
exports.mapStateUrl = (0, toolkit_1.createAction)(namespace + 'map_state_url');
exports.mapSpatial = (0, toolkit_1.createAction)(namespace + 'map_spatial');
exports.mapSpatialTilesSourceHide = (0, toolkit_1.createAction)(namespace + 'map_spatial_tiles_source_hide');
exports.mapMainPosition = (0, toolkit_1.createAction)(namespace + 'map_main_position');
exports.mapMainExtent = (0, toolkit_1.createAction)(namespace + 'map_main_extent');
exports.mapMainSelection = (0, toolkit_1.createAction)(namespace + 'map_main_selection');
exports.getMapRiskLayers = (0, toolkit_1.createAction)('amCommon/getMapRiskLayers');
exports.getMapRiskLayersResolved = (0, toolkit_1.createAction)('amCommon/MapRiskLayersResolved');
exports.getMapRiskLayersRejected = (0, toolkit_1.createAction)('amCommon/getMapRiskLayersRejected');
exports.getMapRehabLayers = (0, toolkit_1.createAction)('amCommon/getMapRehabLayers');
exports.getMapRehabLayersResolved = (0, toolkit_1.createAction)('amCommon/getMapRehabLayersResolved');
exports.getMapRehabLayersRejected = (0, toolkit_1.createAction)('amCommon/getMapRehabLayersRejected');
exports.getMapLayers = (0, toolkit_1.createAction)('amCommon/getMapLayers');


/***/ }),

/***/ "./actions/observations.actions.ts":
/*!*****************************************!*\
  !*** ./actions/observations.actions.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearFilters = exports.setTypeFilters = exports.setGradeFilters = exports.setStepOnly = exports.setContinuousOnly = exports.setJointOnly = exports.deleteObservationsRejected = exports.deleteObservationsResolved = exports.deleteObservations = exports.editObservationsRejected = exports.editObservationsResolved = exports.editObservations = exports.createObservationsRejected = exports.createObservationsResolved = exports.createObservations = exports.clearObservations = exports.getObservationsRejected = exports.getObservationsResolved = exports.getObservations = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservations'));
exports.getObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservationsResolved'));
exports.getObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/getObservationsRejected'));
exports.clearObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/clearObservations'));
exports.createObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservations'));
exports.createObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservationsResolved'));
exports.createObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/createObservationsRejected'));
exports.editObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservation'));
exports.editObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservationResolved'));
exports.editObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/editObservationRejected'));
exports.deleteObservations = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservations'));
exports.deleteObservationsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservationsResolved'));
exports.deleteObservationsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/deleteObservationsRejected'));
exports.setJointOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setJointOnly'));
exports.setContinuousOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setContinuousOnly'));
exports.setStepOnly = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setStepOnly'));
exports.setGradeFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setGradeFilters'));
exports.setTypeFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/setTypeFilters'));
exports.clearFilters = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('observations/clearFilters'));


/***/ }),

/***/ "./actions/riskConfigs.actions.ts":
/*!****************************************!*\
  !*** ./actions/riskConfigs.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskConfigsListRejected = exports.getRiskConfigsListResolved = exports.getRiskConfigsList = exports.setRiskConfigsIsBusy = exports.currentRiskConfigsRow = exports.changeRiskConfigsPage = exports.changeRiskConfigsSlice = exports.changeRiskConfigsSort = exports.getRiskConfigsRejected = exports.getRiskConfigsResolved = exports.reloadRiskConfigs = exports.getRiskConfigsClear = exports.clearRiskConfigs = exports.getRiskConfigs = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.getRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs'));
exports.clearRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/clearRiskConfigs'));
var getRiskConfigsClear = function () {
    return (0, exports.clearRiskConfigs)((0, _Types_1.riskConfigsPaginationDefault)());
};
exports.getRiskConfigsClear = getRiskConfigsClear;
exports.reloadRiskConfigs = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/reloadRiskConfigs'));
exports.getRiskConfigsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs/resolved'));
exports.getRiskConfigsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigs/rejected'));
exports.changeRiskConfigsSort = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/sort'));
exports.changeRiskConfigsSlice = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/slice'));
exports.changeRiskConfigsPage = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('amCommon/page'));
exports.currentRiskConfigsRow = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/current/row'));
exports.setRiskConfigsIsBusy = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/isBusy'));
exports.getRiskConfigsList = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList'));
exports.getRiskConfigsListResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList/resolved'));
exports.getRiskConfigsListRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskConfigs/getRiskConfigsList/rejected'));


/***/ }),

/***/ "./actions/spatial.actions.ts":
/*!************************************!*\
  !*** ./actions/spatial.actions.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSpatialLayersRejected = exports.getSpatialLayersResolved = exports.getSpatialLayers = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getSpatialLayers = (0, toolkit_1.createAction)('amCommon/getSpatialLayers');
exports.getSpatialLayersResolved = (0, toolkit_1.createAction)('amCommon/getSpatialLayersResolved');
exports.getSpatialLayersRejected = (0, toolkit_1.createAction)('amCommon/getSpatialLayersRejected');


/***/ }),

/***/ "./apis/asset.api.ts":
/*!***************************!*\
  !*** ./apis/asset.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assetsBaseUrl = exports.baseAssetsUrl = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var apiEnv = localStorage.getItem('apiEnv') || undefined;
exports.baseAssetsUrl = (0, lib_get_service_1.getService)('assets', config_api_1.default, (0, stylovyze_1.getApiEnvironment)());
exports.assetsBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('assets', config_api_1.default, apiEnv));
var service = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'assets',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 30000,
    },
});
exports["default"] = service;


/***/ }),

/***/ "./apis/config.api.ts":
/*!****************************!*\
  !*** ./apis/config.api.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.apiEnv = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var config = (_a = {},
    // Sample config for overwritting service endpoints
    _a[stylovyze_1.Environments.LOCAL] = {
        assets: 'https://saas-asset-management.info360-dev.com/dev',
        amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
        amRisk: 'https://saas-risk-management.info360-dev.com/dev',
        amUpload: 'https://saas-upload-service.info360-dev.com/dev',
        tiles: 'https://tiles-dev.info360-dev.com/dev',
        amRehab: 'https://saas-rehab-management.info360-dev.com/dev',
    },
    _a[stylovyze_1.Environments.DEV] = {
        assets: 'https://saas-asset-management.info360-dev.com/dev',
        amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
        amRisk: 'https://saas-risk-management.info360-dev.com/dev',
        amUpload: 'https://saas-upload-service.info360-dev.com/dev',
        tiles: 'https://tiles-dev.info360-dev.com/dev',
        amRehab: 'https://saas-rehab-management.info360-dev.com/dev',
    },
    _a);
exports.apiEnv = localStorage.getItem('apiEnv') || undefined;
exports["default"] = config;


/***/ }),

/***/ "./apis/index.ts":
/*!***********************!*\
  !*** ./apis/index.ts ***!
  \***********************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./asset.api */ "./apis/asset.api.ts"), exports);
__exportStar(__webpack_require__(/*! ./tiles.api */ "./apis/tiles.api.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspection.api */ "./apis/inspection.api.ts"), exports);
__exportStar(__webpack_require__(/*! ./risks.api */ "./apis/risks.api.ts"), exports);
__exportStar(__webpack_require__(/*! ./upload.api */ "./apis/upload.api.ts"), exports);


/***/ }),

/***/ "./apis/inspection.api.ts":
/*!********************************!*\
  !*** ./apis/inspection.api.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.inspectionBaseUrl = void 0;
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var apiEnv = localStorage.getItem('apiEnv') || undefined;
exports.inspectionBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amInspection', config_api_1.default, apiEnv));
var service = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'amInspection',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports["default"] = service;


/***/ }),

/***/ "./apis/rehab.api.ts":
/*!***************************!*\
  !*** ./apis/rehab.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rehabBaseUrl = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
exports.rehabBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amRehab', config_api_1.default, (0, stylovyze_1.getApiEnvironment)()));
var rehabService = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'amRehab',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports["default"] = rehabService;


/***/ }),

/***/ "./apis/risks.api.ts":
/*!***************************!*\
  !*** ./apis/risks.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskBaseUrl = void 0;
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var apiEnv = localStorage.getItem('apiEnv') || undefined;
exports.riskBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amRisk', config_api_1.default, apiEnv));
var riskService = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'amRisk',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 30000,
    },
});
exports["default"] = riskService;


/***/ }),

/***/ "./apis/tiles.api.ts":
/*!***************************!*\
  !*** ./apis/tiles.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tilesBaseUrl = exports.baseTilesUrl = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var apiEnv = localStorage.getItem('apiEnv') || undefined;
exports.baseTilesUrl = (0, lib_get_service_1.getService)('tiles', config_api_1.default, (0, stylovyze_1.getApiEnvironment)());
exports.tilesBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('tiles', config_api_1.default, apiEnv));
var tiles = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'tiles',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 3000,
    },
});
exports["default"] = tiles;


/***/ }),

/***/ "./apis/upload.api.ts":
/*!****************************!*\
  !*** ./apis/upload.api.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var uploadService = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'amUpload',
    config: config_api_1.default,
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports["default"] = uploadService;


/***/ }),

/***/ "./components/AssetDetails/AssetDetails.component.tsx":
/*!************************************************************!*\
  !*** ./components/AssetDetails/AssetDetails.component.tsx ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AssetDetails = exports.getStandardFromVersion = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var AssetDetails_styles_1 = __webpack_require__(/*! ./AssetDetails.styles */ "./components/AssetDetails/AssetDetails.styles.tsx");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var __1 = __webpack_require__(/*! .. */ "./components/index.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var DetailsNotes_1 = __webpack_require__(/*! ./DetailsNotes */ "./components/AssetDetails/DetailsNotes/index.ts");
var DetailsOverview_1 = __webpack_require__(/*! ./DetailsOverview */ "./components/AssetDetails/DetailsOverview/index.ts");
var DetailsRehab_1 = __webpack_require__(/*! ./DetailsRehab */ "./components/AssetDetails/DetailsRehab/index.ts");
var DetailsWorkHistory_1 = __webpack_require__(/*! ./DetailsWorkHistory */ "./components/AssetDetails/DetailsWorkHistory/index.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var DetailsRisk_1 = __webpack_require__(/*! ./DetailsRisk */ "./components/AssetDetails/DetailsRisk/index.ts");
var NoRatings_component_1 = __webpack_require__(/*! @Components/Ratings/NoRatings.component */ "./components/Ratings/NoRatings.component.tsx");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var useWebSockets_1 = __webpack_require__(/*! ../../utils/useWebSockets */ "./utils/useWebSockets.ts");
var DetailsEvents_1 = __webpack_require__(/*! ./DetailsEvents */ "./components/AssetDetails/DetailsEvents/index.ts");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var useShowSections = function (localProps, assetType) {
    var _a, _b, _c, _d, _e, _f;
    var assetSchema = (0, react_redux_1.useSelector)(function (state) {
        return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, assetType);
    });
    return __assign({ showRehab: (_a = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Rehab')) !== null && _a !== void 0 ? _a : false, showRisk: (_b = ((assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Risk')) ||
            (assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('RiskScore')))) !== null && _b !== void 0 ? _b : false, showConditions: (_c = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Conditions')) !== null && _c !== void 0 ? _c : false, showRatings: (_d = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Ratings')) !== null && _d !== void 0 ? _d : false, showWorkHistory: (_e = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Tasks')) !== null && _e !== void 0 ? _e : false, showEvents: (_f = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Events')) !== null && _f !== void 0 ? _f : false }, localProps);
};
var getStandardFromVersion = function (inspectionVersion, task) {
    if (task) {
        return inspectionVersion;
    }
    else {
        if (inspectionVersion.toUpperCase().startsWith('MACP'))
            return _Types_1.InspectionStandard.MACP;
        else if (inspectionVersion.toUpperCase().startsWith('MSCC'))
            return _Types_1.InspectionStandard.MSCC;
        else if (inspectionVersion.toUpperCase().startsWith('WSA05'))
            return _Types_1.InspectionStandard.WSA05;
        else
            return _Types_1.InspectionStandard.PACP;
    }
};
exports.getStandardFromVersion = getStandardFromVersion;
// eslint-disable-next-line @typescript-eslint/naming-convention
var AssetDetails = function (_a) {
    var _b;
    var assetId = _a.assetId, back = _a.back, assetType = _a.assetType, actions = _a.actions, adminFullAccess = _a.adminFullAccess, systemType = _a.systemType, showSections = __rest(_a, ["assetId", "back", "assetType", "actions", "adminFullAccess", "systemType"]);
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var classes = (0, AssetDetails_styles_1.useStyle)();
    var isLoading = (0, _Selectors_1.selectInspectionsIsWaiting)();
    var isDetailsLoading = (0, _Selectors_1.selectAssetDetailIsWaiting)();
    var isNotesLoading = (0, _Selectors_1.selectAssetDetailNotesIsWaiting)();
    var inspAttributeList = (_b = (0, _Selectors_1.selectInspections)()) === null || _b === void 0 ? void 0 : _b.inspectionAttributes;
    var ratings;
    var fullInsp;
    var standard = _Types_1.InspectionStandard.PACP;
    if (inspAttributeList && inspAttributeList.length > 0) {
        // Find the first actual inspection
        fullInsp = inspAttributeList.find(function (insp) {
            return !insp.task;
        });
        if (fullInsp !== undefined) {
            ratings = fullInsp.ratings;
            standard = (0, exports.getStandardFromVersion)(fullInsp.inspectionVersion, false);
        }
    }
    var _c = useShowSections(showSections, assetType), showRehab = _c.showRehab, showRisk = _c.showRisk, showConditions = _c.showConditions, showRatings = _c.showRatings, showWorkHistory = _c.showWorkHistory, showEvents = _c.showEvents;
    var showEventsEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-events');
    var isWebSocketEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-web-socket');
    var webSocket = (0, useWebSockets_1.useWebSockets)();
    /* eslint-disable*/
    var riskSummaryResolved = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            response = data.payload;
            dispatch((0, _Actions_1.getRiskSummaryResolved)(response));
            return [2 /*return*/];
        });
    }); };
    var riskSummaryError = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, _Actions_1.getRiskSummaryRejected)());
            return [2 /*return*/];
        });
    }); };
    webSocket.setupRoutes('riskSummary', riskSummaryResolved, riskSummaryError);
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.loadAssetDetails)({
            assetId: assetId,
            assetType: assetType,
            formatDateUTC: formatDateUTC,
            systemType: systemType,
        }));
        if (isWebSocketEnabled) {
            dispatch((0, _Actions_1.setRiskSummaryIsLoading)(true));
            webSocket.sendMessage(JSON.stringify({
                path: 'risk',
                assetId: "".concat(assetType, "%23").concat(assetId),
                action: 'riskSummary',
            }));
        }
        else {
            dispatch((0, _Actions_1.getRiskSummary)({ assetId: assetId, assetType: assetType }));
        }
    }, [assetId, assetType, systemType]);
    var notesHeight = (0, react_1.useMemo)(function () {
        if (!showConditions && !showRatings)
            return '583px';
        if (!showConditions)
            return adminFullAccess ? '254px' : '336px';
        return undefined;
    }, [showConditions, showRatings]);
    var notesWaitingHeight = (0, react_1.useMemo)(function () {
        if (!showConditions && !showRatings)
            return '637px';
        if (!showConditions)
            return '286px';
        return undefined;
    }, [showConditions, showRatings]);
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, __assign({ className: isLoading || isDetailsLoading || isNotesLoading
            ? classes.rootWait
            : classes.root, applyPadding: true, title: "".concat(t('Asset ID'), ": ").concat(assetId), back: back, headerUnderline: true }, { children: (0, jsx_runtime_1.jsxs)(AssetDetails_styles_1.GridContainer, { children: [(0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6, rows: 2 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Map') }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { height: '637px' } }, { children: (0, jsx_runtime_1.jsx)(__1.MapInsertAsset, {}) })) })) })), showConditions && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6, rows: 2 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Component Conditions'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(__1.MACPComponentConditions, { fullInsp: fullInsp }) })) }))), showRatings && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Ratings'), applyBodyPadding: isLoading, className: classes.fullHeight, fullHeight: true }, { children: !isLoading ? (ratings ? ((0, jsx_runtime_1.jsx)(__1.Ratings, { standard: standard, ratings: ratings, mainScoreCardHeight: 116 })) : ((0, jsx_runtime_1.jsx)("div", __assign({ style: { height: '269px' } }, { children: (0, jsx_runtime_1.jsx)(NoRatings_component_1.NoRatings, {}) })))) : ((0, jsx_runtime_1.jsx)("div", __assign({ style: { height: '221px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) }))) })) }))), (0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6 }, { children: (0, jsx_runtime_1.jsx)(DetailsNotes_1.DetailsNotes, { assetId: assetId, assetType: assetType, keepHeightWhenWaiting: !showConditions, waitingHeight: notesWaitingHeight, bodyHeight: notesHeight }) })), (0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(DetailsOverview_1.DetailsOverview, { assetType: assetType, assetId: assetId }) })), showRisk && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(DetailsRisk_1.MultiRiskDetails, { adminFullAccess: adminFullAccess, assetId: assetId, assetType: assetType }) }))), showRehab && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(DetailsRehab_1.DetailsRehab, { adminFullAccess: adminFullAccess, assetId: assetId }) }))), showEventsEnabled && showEvents && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(DetailsEvents_1.DetailsEvents, { actions: actions }) }))), showWorkHistory && ((0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(DetailsWorkHistory_1.DetailsWorkHistory, { actions: actions }) })))] }) })));
};
exports.AssetDetails = AssetDetails;
exports["default"] = exports.AssetDetails;


/***/ }),

/***/ "./components/AssetDetails/AssetDetails.styles.tsx":
/*!*********************************************************!*\
  !*** ./components/AssetDetails/AssetDetails.styles.tsx ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GridItem = exports.GridContainer = exports.useStyle = void 0;
var styled_components_1 = __importStar(__webpack_require__(/*! styled-components */ "styled-components"));
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var styles_2 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
exports.useStyle = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            overflow: 'auto',
        },
        rootWait: {
            overflow: 'auto',
            cursor: 'wait !important',
        },
        fullHeight: {
            height: '100%',
        },
    });
});
exports.GridContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: grid;\n\tgrid-template-columns: repeat(12, 1fr);\n\tgrid-gap: ", ";\n\tpadding-bottom: ", ";\n"], ["\n\tdisplay: grid;\n\tgrid-template-columns: repeat(12, 1fr);\n\tgrid-gap: ", ";\n\tpadding-bottom: ", ";\n"])), (0, styles_2.rem)(24), (0, styles_2.rem)(24));
exports.GridItem = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tgrid-column: span ", ";\n\t", "\n"], ["\n\tgrid-column: span ", ";\n\t", "\n"])), function (_a) {
    var xs = _a.xs;
    return xs !== null && xs !== void 0 ? xs : 12;
}, function (_a) {
    var rows = _a.rows;
    return rows && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\tgrid-row: span ", ";\n\t\t"], ["\n\t\t\tgrid-row: span ", ";\n\t\t"])), rows);
});
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),

/***/ "./components/AssetDetails/DetailsEvents/DetailsEvents.component.tsx":
/*!***************************************************************************!*\
  !*** ./components/AssetDetails/DetailsEvents/DetailsEvents.component.tsx ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsEvents = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __webpack_require__(/*! react */ "react");
var TimelineOppositeContent_1 = __importStar(__webpack_require__(/*! @mui/lab/TimelineOppositeContent */ "@mui/lab/TimelineOppositeContent"));
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
// TEMP ICON
var AssignmentLateOutlined_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/AssignmentLateOutlined */ "@mui/icons-material/AssignmentLateOutlined"));
var NoDetailsEvents_component_1 = __webpack_require__(/*! ./NoDetailsEvents.component */ "./components/AssetDetails/DetailsEvents/NoDetailsEvents.component.tsx");
var Paper_1 = __importDefault(__webpack_require__(/*! @mui/material/Paper */ "@mui/material/Paper"));
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var DetailsEvents_styles_1 = __webpack_require__(/*! ./DetailsEvents.styles */ "./components/AssetDetails/DetailsEvents/DetailsEvents.styles.tsx");
var Timeline_1 = __importDefault(__webpack_require__(/*! @mui/lab/Timeline */ "@mui/lab/Timeline"));
var TimelineConnector_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineConnector */ "@mui/lab/TimelineConnector"));
var TimelineContent_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineContent */ "@mui/lab/TimelineContent"));
var TimelineDot_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineDot */ "@mui/lab/TimelineDot"));
var TimelineItem_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineItem */ "@mui/lab/TimelineItem"));
var TimelineSeparator_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineSeparator */ "@mui/lab/TimelineSeparator"));
var Typography_1 = __importDefault(__webpack_require__(/*! @mui/material/Typography */ "@mui/material/Typography"));
var ValueMapping_1 = __webpack_require__(/*! ../DetailsOverview/ValueMapping */ "./components/AssetDetails/DetailsOverview/ValueMapping.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var _Utilsluxon_1 = __webpack_require__(/*! @Utilsluxon */ "./utilsluxon/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var DetailsEvents = function (_a) {
    var _b;
    var _c;
    var actions = _a.actions;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var t = (0, _Translations_1.useGlobalization)().t;
    var isWaiting = (0, _Selectors_1.selectInspectionsIsWaiting)();
    var inspAttributeList = (_c = (0, _Selectors_1.selectInspections)()) === null || _c === void 0 ? void 0 : _c.inspectionAttributes;
    var hasEventHistory = (0, react_1.useMemo)(function () {
        if (inspAttributeList)
            return (inspAttributeList.findIndex(function (inspAttributes) {
                return inspAttributes === null || inspAttributes === void 0 ? void 0 : inspAttributes.event;
            }) !== -1);
        else
            return false;
    }, [inspAttributeList]);
    var handleOpenEvent = function (eventID, inspVersion) {
        if (actions && actions.onEventDetailClicked) {
            actions.onEventDetailClicked(eventID, inspVersion);
        }
    };
    var getRow = function (inspAttributes) {
        return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                height: '100%',
            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                        margin: '0 12px 0 2px',
                    } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                            height: '100%',
                        } }, { children: (0, jsx_runtime_1.jsx)(AssignmentLateOutlined_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'eventId',
                        }, textField: {
                            label: t('Event ID'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'eventTypeName',
                        }, textField: {
                            label: t('Event Type'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'opened',
                        }, textField: {
                            label: t('Opened Date'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'reported',
                        }, textField: {
                            label: t('Reported Date'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'verified',
                        }, textField: {
                            label: t('Verified Date'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'resolved',
                        }, textField: {
                            label: t('Resolved Date'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'closed',
                        }, textField: {
                            label: t('Closed Date'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                            name: 'status',
                        }, textField: {
                            label: t('Status'),
                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "flex-end", style: {
                            height: '100%',
                        } }, { children: (0, jsx_runtime_1.jsx)(DetailsEvents_styles_1.StyledButton, __assign({ size: "small", onClick: function () {
                                handleOpenEvent(inspAttributes._id, inspAttributes.inspectionVersion);
                            } }, { children: t('View Details >') })) })) }))] })));
    };
    var translateStatus = function (status) {
        switch (status) {
            case 'verified':
                return t('Active');
            case 'resolved':
                return t('Resolved');
            case 'closed':
                return t('Closed');
            default:
                return t('Active');
        }
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Events'), applyBodyPadding: isWaiting }, { children: !isWaiting ? (hasEventHistory ? ((0, jsx_runtime_1.jsx)(_Components_1.ShowMoreOverlay, __assign({ height: 220 }, { children: (0, jsx_runtime_1.jsx)(Timeline_1.default, __assign({ sx: (_b = {},
                    _b["& .".concat(TimelineOppositeContent_1.timelineOppositeContentClasses.root)] = {
                        flex: 0.2,
                    },
                    _b), style: {
                    paddingLeft: '11px',
                    paddingBottom: '25px',
                } }, { children: inspAttributeList === null || inspAttributeList === void 0 ? void 0 : inspAttributeList.filter(function (inspAttributes) { var _a; return (_a = inspAttributes === null || inspAttributes === void 0 ? void 0 : inspAttributes.event) !== null && _a !== void 0 ? _a : false; }).map(function (inspAttributes, index) {
                    var _a, _b, _c, _d, _e;
                    return ((0, jsx_runtime_1.jsxs)(TimelineItem_1.default, __assign({ style: { paddingLeft: 0 } }, { children: [(0, jsx_runtime_1.jsxs)(TimelineOppositeContent_1.default, __assign({ style: {
                                    flex: 0.2,
                                    maxWidth: '200px',
                                    paddingLeft: 0,
                                    paddingTop: '28px',
                                } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "body1", color: "textPrimary" }, { children: (0, _Utils_1.formatDateTimeWithFormatDate)(inspAttributes.surveyDateTime, formatDateUTC) })), (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ style: {
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                        }, color: "textSecondary" }, { children: (0, _Utilsluxon_1.getTimeDifferenceText)(new Date(inspAttributes.surveyDateTime), companySettings) }))] })), (0, jsx_runtime_1.jsxs)(TimelineSeparator_1.default, __assign({ style: index === 0
                                    ? {
                                        paddingTop: '27px',
                                    }
                                    : index ===
                                        inspAttributeList.length -
                                            1
                                        ? {
                                            paddingBottom: '27px',
                                        }
                                        : {} }, { children: [index === 0 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {})), (0, jsx_runtime_1.jsx)(TimelineDot_1.default, { variant: "outlined" }), index ===
                                        inspAttributeList.length -
                                            1 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {}))] })), (0, jsx_runtime_1.jsx)(TimelineContent_1.default, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: {
                                        eventId: inspAttributes.eventId,
                                        eventTypeName: inspAttributes.eventTypeName,
                                        status: translateStatus(inspAttributes.inspectionStatus),
                                        opened: (0, _Utils_1.formatDateTimeWithFormatDate)((_a = (0, ValueMapping_1.extractValue)(inspAttributes.openedDate)) !== null && _a !== void 0 ? _a : '', formatDateUTC),
                                        reported: (0, _Utils_1.formatDateTimeWithFormatDate)((_b = (0, ValueMapping_1.extractValue)(inspAttributes.reportedDate)) !== null && _b !== void 0 ? _b : '', formatDateUTC),
                                        closed: (0, _Utils_1.formatDateTimeWithFormatDate)((_c = (0, ValueMapping_1.extractValue)(inspAttributes.closedDate)) !== null && _c !== void 0 ? _c : '', formatDateUTC),
                                        verified: (0, _Utils_1.formatDateTimeWithFormatDate)((_d = (0, ValueMapping_1.extractValue)(inspAttributes.verifiedDate)) !== null && _d !== void 0 ? _d : '', formatDateUTC),
                                        resolved: (0, _Utils_1.formatDateTimeWithFormatDate)((_e = (0, ValueMapping_1.extractValue)(inspAttributes.resolvedDate)) !== null && _e !== void 0 ? _e : '', formatDateUTC),
                                    }, onSubmit: function (data) {
                                        console.log('should update the data', data);
                                    } }, { children: function () {
                                        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, __assign({ square: true, style: {
                                                    padding: '0px 10px',
                                                    height: '70px',
                                                } }, { children: getRow(inspAttributes) })) }));
                                    } })) })] }), inspAttributes._id));
                }) })) }))) : ((0, jsx_runtime_1.jsx)(NoDetailsEvents_component_1.NoDetailsEvents, {}))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.DetailsEvents = DetailsEvents;


/***/ }),

/***/ "./components/AssetDetails/DetailsEvents/DetailsEvents.styles.tsx":
/*!************************************************************************!*\
  !*** ./components/AssetDetails/DetailsEvents/DetailsEvents.styles.tsx ***!
  \************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButton = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.StyledButton = (0, styled_components_1.default)(stylovyze_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: black;\n"], ["\n\tcolor: black;\n"])));
var templateObject_1;


/***/ }),

/***/ "./components/AssetDetails/DetailsEvents/NoDetailsEvents.component.tsx":
/*!*****************************************************************************!*\
  !*** ./components/AssetDetails/DetailsEvents/NoDetailsEvents.component.tsx ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoDetailsEvents = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// TEMP ICON
var AssignmentLateOutlined_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/AssignmentLateOutlined */ "@mui/icons-material/AssignmentLateOutlined"));
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoDetailsEvents = function () {
    var t = (0, _Translations_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: { paddingTop: '40px', paddingBottom: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(AssignmentLateOutlined_1.default, { style: {
                        height: '72px',
                        width: '72px',
                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No Events to show') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('Once events have been added they will show up here.') })) }))] })));
};
exports.NoDetailsEvents = NoDetailsEvents;


/***/ }),

/***/ "./components/AssetDetails/DetailsEvents/index.ts":
/*!********************************************************!*\
  !*** ./components/AssetDetails/DetailsEvents/index.ts ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DetailsEvents.component */ "./components/AssetDetails/DetailsEvents/DetailsEvents.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./NoDetailsEvents.component */ "./components/AssetDetails/DetailsEvents/NoDetailsEvents.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsNotes/DetailsNotes.component.tsx":
/*!*************************************************************************!*\
  !*** ./components/AssetDetails/DetailsNotes/DetailsNotes.component.tsx ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsNotes = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var assetDetail_selectors_1 = __webpack_require__(/*! @Selectors/assetDetail.selectors */ "./selectors/assetDetail.selectors.ts");
var ObservationNotes_1 = __importDefault(__webpack_require__(/*! @Components/ObservationNotes */ "./components/ObservationNotes/index.ts"));
var assetDetail_actions_1 = __webpack_require__(/*! @Actions/assetDetail.actions */ "./actions/assetDetail.actions.ts");
var user_selectors_1 = __webpack_require__(/*! @Selectors/user.selectors */ "./selectors/user.selectors.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var AssetDetails_styles_1 = __webpack_require__(/*! ../AssetDetails.styles */ "./components/AssetDetails/AssetDetails.styles.tsx");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var DetailsNotes = function (_a) {
    var assetId = _a.assetId, assetType = _a.assetType, keepHeightWhenWaiting = _a.keepHeightWhenWaiting, bodyHeight = _a.bodyHeight, waitingHeight = _a.waitingHeight;
    var userContext = (0, user_selectors_1.selectUserContext)();
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasViewerAccess = (0, shared_utils_1.viewerAccess)(subscriptions);
    var assetDetailStoreState = (0, assetDetail_selectors_1.selectAssetDetail)();
    var notes = assetDetailStoreState === null || assetDetailStoreState === void 0 ? void 0 : assetDetailStoreState.notes;
    var isLoading = (0, assetDetail_selectors_1.selectAssetDetailIsWaiting)();
    var classNames = (0, AssetDetails_styles_1.useStyle)();
    var onSubmitNote = function (newNotes, userInitial) {
        dispatch((0, assetDetail_actions_1.addAssetDetailNote)({
            assetDetailParams: {
                assetId: assetId,
                assetType: assetType,
                formatDateUTC: formatDateUTC,
                forNotes: true,
            },
            addNoteParams: {
                note: newNotes,
                userName: userContext.name,
                userInitial: userInitial,
                dateTime: new Date().toISOString(),
            },
        }));
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes'), applyBodyPadding: isLoading, fullHeight: true, className: classNames.fullHeight }, { children: (0, jsx_runtime_1.jsx)(ObservationNotes_1.default, { Notes: notes !== null && notes !== void 0 ? notes : [], onSubmit: onSubmitNote, readOnly: hasViewerAccess, isWaiting: isLoading, keepHeightWhenWaiting: keepHeightWhenWaiting, waitingHeight: waitingHeight, bodyHeight: bodyHeight, entryHeight: hasViewerAccess ? '0px' : '90px' }) })));
};
exports.DetailsNotes = DetailsNotes;


/***/ }),

/***/ "./components/AssetDetails/DetailsNotes/index.ts":
/*!*******************************************************!*\
  !*** ./components/AssetDetails/DetailsNotes/index.ts ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DetailsNotes.component */ "./components/AssetDetails/DetailsNotes/DetailsNotes.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/DetailsOverview.component.tsx":
/*!*******************************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/DetailsOverview.component.tsx ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsOverview = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var mapUiI18nSettings = __importStar(__webpack_require__(/*! @innovyze/map-components/Translations */ "@innovyze/map-components/Translations"));
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var map_components_1 = __webpack_require__(/*! @innovyze/map-components */ "@innovyze/map-components");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var ValueMapping_1 = __webpack_require__(/*! ./ValueMapping */ "./components/AssetDetails/DetailsOverview/ValueMapping.ts");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var TabPanel_1 = __webpack_require__(/*! ../../Tabs/TabPanel */ "./components/Tabs/TabPanel.tsx");
var getType = function (type, unit) {
    if (unit === '$')
        return 'currency';
    if (unit)
        return 'unit';
    if (type) {
        if (type === 'string')
            return 'text';
        if (type === 'date')
            return 'dateonlyUTC';
        if (type === 'datetime' || type === 'time')
            return 'dateUTC';
        return type;
    }
    return 'text';
};
var convertFieldType = function (type, precision) {
    switch (type) {
        case 'Boolean':
            return { fieldType: 'boolean' };
        case 'Double':
            return { fieldType: 'number', precision: precision !== null && precision !== void 0 ? precision : 2 };
        case 'Integer':
        case 'Long Integer':
            return { fieldType: 'number', precision: precision !== null && precision !== void 0 ? precision : 0 };
        case 'Date / Time':
            return { fieldType: 'date' };
        case 'Text':
            return { fieldType: 'string' };
        case 'Memo':
            return { fieldType: 'string', multiline: true };
        default:
            return { fieldType: 'string' };
    }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
var DetailsOverview = function (_a) {
    var _b, _c;
    var assetType = _a.assetType, assetId = _a.assetId;
    var t = (0, _Translations_1.useGlobalization)().t;
    var _d = react_1.default.useState(0), value = _d[0], setValue = _d[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        if (assetType) {
            dispatch((0, lib_asset_schema_store_1.getAssetSchemaAction)({ assetType: assetType }));
        }
    }, [assetType, dispatch]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var assetSchema = (0, react_redux_1.useSelector)(function (state) {
        if (assetType) {
            return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, assetType);
        }
    });
    var sections = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.categories;
    var id = "".concat(assetType, "#").concat(assetId);
    var details = (0, react_redux_1.useSelector)(function (store) { return (0, map_components_1.selectAssetById)(store, id); });
    var segmentSchema = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.getProperties().find(function (p) { return p.id === 'segments'; });
    var segments = (0, react_1.useMemo)(function () {
        if (!segmentSchema)
            return;
        var segments = details === null || details === void 0 ? void 0 : details.segments;
        if (!segments)
            return;
        return (0, ValueMapping_1.mapSegments)(segments, t);
    }, [segmentSchema, details]);
    var userDefinedTables = (0, react_1.useMemo)(function () {
        var userDefined = details === null || details === void 0 ? void 0 : details.userDefined;
        if (!userDefined)
            return;
        return (0, ValueMapping_1.mapUserTables)(userDefined);
    }, [details]);
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var segmentsTabIndex = (_b = sections === null || sections === void 0 ? void 0 : sections.length) !== null && _b !== void 0 ? _b : 1;
    var customTablesIndex = segments
        ? segmentsTabIndex + 1
        : segmentsTabIndex;
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties') }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: value, onChange: handleChange }, { children: [Array.from(sections !== null && sections !== void 0 ? sections : []).map(function (section, i) { return ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t(section) }, (0, _Utils_1.a11yProps)(i)), i)); }), (sections === null || sections === void 0 ? void 0 : sections.length) === 0 && ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('General') }, (0, _Utils_1.a11yProps)(0)), 0)), segments && ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Segments') }, (0, _Utils_1.a11yProps)(segmentsTabIndex)))), userDefinedTables && ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Custom Tables') }, (0, _Utils_1.a11yProps)(customTablesIndex))))] })), Array.from(sections !== null && sections !== void 0 ? sections : []).map(function (section, i) {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(TabPanel_1.TabPanel, __assign({ value: value, index: i }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.PropertyCard, { title: t(section), properties: (_a = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.getProperties().filter(function (p) { return p.category === section; }).filter(function (p) { return p.type !== 'List'; }).map(function (p) {
                                // TS analyser in IDE is smart enough, but the compiler isn't
                                // so I have to tell ts the type.
                                return (p);
                            }).map(function (property) {
                                var _a = convertFieldType(property.type, property.precision), fieldType = _a.fieldType, precision = _a.precision;
                                return {
                                    title: t(property.displayName, {
                                        context: 'Asset Property',
                                        // the translations come from the map components library
                                        // so need to use the namespace from that
                                        ns: mapUiI18nSettings.ns,
                                    }),
                                    value: (0, ValueMapping_1.getValue)(t, details, property.id, property.units),
                                    cy: property.id,
                                    type: getType(fieldType, property.units),
                                    decimalPlaces: precision,
                                    loading: !details,
                                    ellipsis: true,
                                };
                            })) !== null && _a !== void 0 ? _a : [], columns: 4 }) }), i));
                }), (sections === null || sections === void 0 ? void 0 : sections.length) === 0 && ((0, jsx_runtime_1.jsx)(TabPanel_1.TabPanel, __assign({ value: value, index: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.PropertyCard, { title: t('General'), properties: (_c = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.getProperties().filter(function (p) { return p.type !== 'List'; }).map(function (p) {
                            // TS analyser in IDE is smart enough, but the compiler isn't
                            // so I have to tell ts the type.
                            return (p);
                        }).map(function (property) {
                            var _a = convertFieldType(property.type, property.precision), fieldType = _a.fieldType, precision = _a.precision;
                            return {
                                title: t(property.displayName, {
                                    context: 'Asset Property',
                                    // the translations come from the map components library
                                    // so need to use the namespace from that
                                    ns: mapUiI18nSettings.ns,
                                }),
                                value: (0, ValueMapping_1.getValue)(t, details, property.id, property.units),
                                cy: property.id,
                                type: getType(fieldType, property.units),
                                decimalPlaces: precision,
                                loading: !details,
                                ellipsis: true,
                            };
                        })) !== null && _c !== void 0 ? _c : [], columns: 4 }) }))), segments && ((0, jsx_runtime_1.jsx)(TabPanel_1.TabPanel, __assign({ value: value, index: segmentsTabIndex }, { children: segments.map(function (segment) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(stylovyze_1.PropertyCard, { title: t('Segment: {{segmentId}}', {
                                segmentId: segment.segmentId,
                            }), properties: (_a = segmentSchema === null || segmentSchema === void 0 ? void 0 : segmentSchema.properties.filter(function (p) { return p.id !== 'segmentId'; }).map(function (p) {
                                var _a = convertFieldType(p.type, p.precision), fieldType = _a.fieldType, precision = _a.precision;
                                return {
                                    title: t(p.displayName),
                                    value: (0, ValueMapping_1.getValue)(t, segment, p.id, p.units),
                                    cy: p.id,
                                    type: getType(fieldType, p.units),
                                    decimalPlaces: precision,
                                    loading: !details,
                                };
                            })) !== null && _a !== void 0 ? _a : [], columns: 4 }, segment.segmentId));
                    }) }))), userDefinedTables && ((0, jsx_runtime_1.jsx)(TabPanel_1.TabPanel, __assign({ value: value, index: customTablesIndex }, { children: userDefinedTables.map(function (_a) {
                        var section = _a.section, fields = _a.fields;
                        return ((0, jsx_runtime_1.jsx)(stylovyze_1.PropertyCard, { title: section, properties: fields.map(function (_a) {
                                var name = _a.name, value = _a.value;
                                return ({
                                    title: name,
                                    value: (0, ValueMapping_1.extractValue)(value),
                                    cy: name,
                                    type: getType((0, ValueMapping_1.extractFieldType)(value)),
                                });
                            }), columns: 4 }, section));
                    }) })))] }) })));
};
exports.DetailsOverview = DetailsOverview;


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.component.tsx":
/*!****************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.component.tsx ***!
  \****************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Segment = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Segment_styles_1 = __webpack_require__(/*! ./Segment.styles */ "./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.styles.tsx");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var hardCodeUnitFields = {
    startDistance: 'm',
    length: 'm',
    height: 'cm',
    width: 'mm',
    startLength: 'm',
};
// eslint-disable-next-line @typescript-eslint/naming-convention
var Segment = function (_a) {
    var id = _a.id, segmentAttrs = _a.segmentAttrs;
    var t = (0, _Translations_1.useGlobalization)().t;
    return segmentAttrs && Object.keys(segmentAttrs).length > 0 ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(Segment_styles_1.SegmentTitle, __assign({ item: true, xs: 12, container: true, alignItems: "center" }, { children: "".concat(t('Segment'), " ID ").concat(id) })), (0, jsx_runtime_1.jsxs)(Segment_styles_1.SegmentBody, __assign({ item: true, xs: 12, container: true }, { children: [(0, jsx_runtime_1.jsx)(Segment_styles_1.VertLine, { item: true }), (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: segmentAttrs, onSubmit: function (data) {
                            console.log('should update the data', data);
                        } }, { children: function () {
                            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true, container: true }, { children: Object.keys(segmentAttrs).map(function (attr) {
                                    var fieldName = attr;
                                    if (hardCodeUnitFields[fieldName]) {
                                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputUnit, { fieldAttrs: {
                                                    name: fieldName,
                                                }, unitField: {
                                                    label: fieldName,
                                                    unit: hardCodeUnitFields[fieldName],
                                                    defaultValue: '',
                                                    onChange: function (e) {
                                                        console.log('onChange', e.target.value);
                                                    },
                                                }, invalidDisplayValue: '-' }) }), fieldName));
                                    }
                                    else {
                                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                    name: fieldName,
                                                }, textField: {
                                                    label: fieldName,
                                                } }) }), fieldName));
                                    }
                                }) })));
                        } }))] }))] }))) : null;
};
exports.Segment = Segment;


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.styles.tsx":
/*!*************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.styles.tsx ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VertLine = exports.SegmentBody = exports.SegmentTitle = void 0;
var withStyles_1 = __importDefault(__webpack_require__(/*! @mui/styles/withStyles */ "@mui/styles/withStyles"));
var Grid_1 = __importDefault(__webpack_require__(/*! @mui/material/Grid */ "@mui/material/Grid"));
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.SegmentTitle = (0, withStyles_1.default)({
    root: {
        height: '47px',
        backgroundColor: '#F7F7F7',
        padding: '11px 23px',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '24px',
    },
})(Grid_1.default);
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.SegmentBody = (0, withStyles_1.default)({
    root: {
        padding: '15px 0px',
        // borderLeft: '5px solid #007CA0',
    },
})(Grid_1.default);
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.VertLine = (0, withStyles_1.default)({
    root: {
        width: '25px',
        borderLeft: '5px solid #007CA0',
    },
})(Grid_1.default);


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/Segments/Segments.component.tsx":
/*!*********************************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/Segments/Segments.component.tsx ***!
  \*********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Segments = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var Segments_styles_1 = __webpack_require__(/*! ./Segments.styles */ "./components/AssetDetails/DetailsOverview/Segments/Segments.styles.tsx");
var ExpandMore_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/ExpandMore */ "@mui/icons-material/ExpandMore"));
var Segment_component_1 = __webpack_require__(/*! ./Segment/Segment.component */ "./components/AssetDetails/DetailsOverview/Segments/Segment/Segment.component.tsx");
var assetPipe_selectors_1 = __importDefault(__webpack_require__(/*! @Selectors/assetPipe.selectors */ "./selectors/assetPipe.selectors.ts"));
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var Segments = function () {
    var _a;
    var t = (0, _Translations_1.useGlobalization)().t;
    var classes = (0, Segments_styles_1.useStyles)();
    var assetPipeStore = (0, assetPipe_selectors_1.default)();
    var segments = (_a = assetPipeStore === null || assetPipeStore === void 0 ? void 0 : assetPipeStore.asset) === null || _a === void 0 ? void 0 : _a.segments;
    var _b = (0, react_1.useState)(false), expanded = _b[0], setExpanded = _b[1];
    var showHideText = expanded ? ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.expandText }, { children: t('Hide') }))) : ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.expandText }, { children: t('Show') })));
    return segments && segments.length > 0 ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.root }, { children: (0, jsx_runtime_1.jsxs)(material_1.Accordion, __assign({ square: true, onChange: function (event, isExpanded) {
                setExpanded(isExpanded);
            } }, { children: [(0, jsx_runtime_1.jsx)(Segments_styles_1.AccordionSummary, __assign({ expandIcon: (0, jsx_runtime_1.jsx)(ExpandMore_1.default, {}), "aria-controls": "panel1a-content", id: "panel1a-header" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.heading }, { children: t('Segments') })), showHideText] })) })), (0, jsx_runtime_1.jsx)(Segments_styles_1.AccordionDetails, { children: (0, jsx_runtime_1.jsx)(_Components_1.ShowMoreOverlay, __assign({ height: 300 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: segments.map(function (segment) { return ((0, jsx_runtime_1.jsx)(Segment_component_1.Segment, { id: segment.segmentId.toString(), segmentAttrs: segment }, segment.segmentId)); }) })) })) })] })) }))) : null;
};
exports.Segments = Segments;


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/Segments/Segments.styles.tsx":
/*!******************************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/Segments/Segments.styles.tsx ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AccordionDetails = exports.AccordionSummary = exports.useStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var AccordionSummary_1 = __importDefault(__webpack_require__(/*! @mui/material/AccordionSummary */ "@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(__webpack_require__(/*! @mui/material/AccordionDetails */ "@mui/material/AccordionDetails"));
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            width: '100%',
            paddingTop: '21px',
        },
        heading: {
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '24px',
            color: '#272833',
        },
        expandText: {
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            color: '#4A6067',
        },
    });
});
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.AccordionSummary = (0, styles_1.withStyles)({
    root: {
        borderBottom: '1px solid #F1F4F4',
        //   marginBottom: -1,
        minHeight: '56px',
        '&$expanded': {
            minHeight: '56px',
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(AccordionSummary_1.default);
exports.AccordionDetails = (0, styles_1.withStyles)({
    root: {
        paddingTop: '18px',
    },
})(AccordionDetails_1.default);


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/Segments/index.ts":
/*!*******************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/Segments/index.ts ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./Segments.component */ "./components/AssetDetails/DetailsOverview/Segments/Segments.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/ValueMapping.ts":
/*!*****************************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/ValueMapping.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapUserTables = exports.mapSegments = exports.getValue = exports.extractFieldType = exports.extractValue = exports.getValueFromShortCode = exports.getFieldMappings = void 0;
var properties_utils_1 = __webpack_require__(/*! @Utils/properties.utils */ "./utils/properties.utils.ts");
var getFieldMappings = function (t, fieldName) {
    switch (fieldName.toLowerCase()) {
        case 'material'.toLowerCase():
        case 'liningMaterial'.toLowerCase():
            return {
                BL: t('Bitumen (lining)'),
                CL: t('Cement Mortar (lining)'),
                CO: t('Concrete'),
                CS: t('Concrete Segments'),
                DI: t('Ductile Iron'),
                EP: t('Epoxy'),
                FC: t('Fibre Cement'),
                GI: t('Grey Cast Iron'),
                MAC: t('Masonry - Regular Courses'),
                MAR: t('Masonry - Randomly Coursed'),
                MX: t('Mixed Material Construction'),
                PF: t('Pitch Fibre'),
                PS: t('Polyester'),
                RC: t('Reinforced Concrete'),
                SPC: t('Sprayed Concrete'),
                ST: t('Steel'),
                VC: t('Vitrified Clay'),
                X: t('Unidentified Material'),
                XI: t('Unidentified Type of Iron or Steel'),
                XP: t('Unidentified Type of Plastics'),
                Z: t('Other'),
                ABS: t('Acrylonitrile Butadiene Styrene'),
                AC: t('Asbestos Cement'),
                BR: t('Brick'),
                CAS: t('Cast Iron'),
                CLC: t('Clay-lined Concrete Pipe'),
                CMP: t('Corrugated Metal Pipe'),
                CP: t('Concrete Pipe (non-reinforced)'),
                CSB: t('Concrete Segments (bolted)'),
                CSU: t('Concrete Segments (unbolted)'),
                CT: t('Clay Tile (not vitrified clay)'),
                DIP: t('Ductile Iron Pipe'),
                FRP: t('Fiberglass Reinforced Pipe'),
                OB: t('Pitch Fiber (Orangeburg)'),
                PCP: t('Polymer Concrete Pipe'),
                PCCP: t('Pre-stressed Concrete Cylinder Pipe'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                RCP: t('Reinforced Concrete Pipe'),
                RPM: t('Reinforced Plastic Pipe (Truss Pipe)'),
                SB: t('Segmented Block'),
                SP: t('Steel Pipe'),
                VCP: t('Vitrified Clay Pipe'),
                WD: t('Wood'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
        case 'liningType'.toLowerCase():
            return {
                M: t('Lining Inserted During Manufacture'),
                SP: t('Sprayed Lining/Segmented Pipe'),
                SEG: t('Segmental Linings'),
                DP: t('Lining with Discrete Pipes'),
                CP: t('Lining with Continuous Pipes'),
                CF: t('Close Fit Lining'),
                Z: t('Other'),
                CIP: t('Cured-In-Place Pipe'),
                FF: t('Fold and Form or Deform/Reform'),
                FP: t('Formed-In-Place Liner'),
                GP: t('Grout-In-Place Liner'),
                GRC: t('Glass Reinforced Cement'),
                N: t('None'),
                SC: t('Continuous Slip Liner'),
                SE: t('Sectional Slip Liner'),
                SL: t('Spray Liner'),
                SN: t('Segmented Panel'),
                SW: t('Spiral Wound'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
        case 'pipeShape'.toLowerCase():
            return {
                A: t('Arched'),
                B: t('Barrel'),
                C: t('Circular'),
                E: t('Egg-shaped'),
                H: t('Horseshoe'),
                O: t('Oval'),
                R: t('Rectangular'),
                T: t('Trapezoidal'),
                U: t('U-shaped with Flat Top'),
                K: t('Kerb Block'),
                CSC: t('Circular with Smaller Channel'),
                RSC: t('Rectangular with Smaller Channel'),
                Z: t('Other'),
                S: t('Square'),
            };
        case 'systemType'.toLowerCase():
            return {
                CB: t('Combined Pipe'),
                DP: t('Dam Pipe'),
                FM: t('Force Main'),
                LG: t('Levee Gravity Pipe'),
                LP: t('Levee Pressure Pipe'),
                PR: t('Process Pipe'),
                SS: t('Sanitary Sewage Pipe'),
                SW: t('Stormwater Pipe'),
                XX: t('Not Known'),
                ZZ: t('Other'),
                F: t('Foul'),
                S: t('Surface'),
                C: t('Combined'),
                T: t('Trade Effluent'),
                O: t('Overflow'),
                W: t('Culverted Watercourse'),
                LD: t('Subsoil or Field Drainage'),
                U: t('Unspecified'),
                Z: t('Other'),
            };
        case 'accessAction'.toLowerCase():
            return {
                POL: t('Police Assistance'),
                PARK: t('No Parking'),
                KEYS: t('Keys Needed'),
                O: t('Other'),
            };
        case 'accessTime'.toLowerCase():
            return {
                A: t('Outside Working Hours'),
                B: t('Outside Normal Hours'),
                C: t('Outside Weekend Hours'),
                D: t('Other'),
            };
        case 'coverDuty'.toLowerCase():
            return {
                L: t('Light'),
                M: t('Medium'),
                H: t('Heavy'),
                U: t('Unspecified'),
            };
        case 'coverShape'.toLowerCase():
            return {
                S: t('Square'),
                R: t('Rectangular'),
                T: t('Triangular'),
                D: t('Double Triangle'),
                C: t('Circular'),
                O: t('Oval'),
                L: t('Clover Leaf'),
                HX: t('Hexagonal'),
                OC: t('Octagonal'),
                U: t('Unspecified'),
                Z: t('Other'),
            };
        case 'gasType'.toLowerCase():
            return {
                A: t('CH4'),
                B: t('H2S'),
                C: t('Explosive'),
                D: t('Other'),
            };
        case 'coneType'.toLowerCase():
            return {
                CC: t('Conical Centered'),
                CO: t('Conical Off Centered'),
                FT: t('Flat Top'),
                N: t('Not Present'),
                ZZ: t('Other'),
            };
        case 'inletType'.toLowerCase():
            return {
                ContCO: t('Continuous Curb-Opening'),
                ContG: t('Continuous Grate'),
                SagC: t('Sag Combination'),
                SagCO: t('Sag Curb-Opening'),
                SagG: t('Sag Grate'),
            };
        case 'locationCode'.toLowerCase():
            return {
                M: t('Continuous Curb-Opening'),
                H: t('Continuous Grate'),
                J: t('Sag Combination'),
                K: t('Sag Curb-Opening'),
                O: t('Sag Grate'),
                I: t('Ditch'),
                D: t('Easement/Right of Way'),
                P: t('Levee Pump Station'),
                N: t('Levee/Floodwall'),
                C: t('Local Rural Streets'),
                Z: t('Other'),
                G: t('Parking Lot'),
                A: t('Primary Major Arterial Roads'),
                L: t('Railway'),
                B: t('Secondary Roads'),
                F: t('Sidewalk'),
                E: t('Woods'),
                Y: t('Yard'),
            };
        case 'status'.toLowerCase():
            return {
                PU: t('Public'),
                PR: t('Private'),
                24: t('Section 24'),
                HD: t('Highway Drain'),
                WC: t('Watercourse'),
                TR: t('Trunk'),
                17: t('Section 17'),
                18: t('Section 18'),
                AB: t('Abandoned'),
                TC: t('To Be Constructed'),
                HC: t('Housing Committee'),
                U: t('Unspecified'),
            };
        case 'stepMaterial'.toLowerCase():
            return {
                AL: t('Aluminium'),
                GI: t('Galvanised Iron'),
                IR: t('Iron/Steel'),
                PL: t('Plastic'),
                PM: t('Metal Encapsulated in Plastic'),
                SS: t('Stainless Steel'),
                Z: t('Other'),
            };
        case 'owner'.toLowerCase():
            return {
                PR: t('Private'),
                PU: t('Public'),
                X: t('Not Known'),
            };
        case 'security'.toLowerCase():
            return {
                A: t('Vulnerable'),
                B: t('Moderate Risk'),
                C: t('Secure'),
            };
        default:
            return;
    }
};
exports.getFieldMappings = getFieldMappings;
var getValueFromShortCode = function (t, fieldName, shortCode) {
    var valueMap = (0, exports.getFieldMappings)(t, fieldName);
    var shortCodeValue = valueMap === null || valueMap === void 0 ? void 0 : valueMap[shortCode];
    return shortCode + (shortCodeValue ? " - ".concat(shortCodeValue) : '');
};
exports.getValueFromShortCode = getValueFromShortCode;
var extractValue = function (value) {
    if (typeof value === 'object') {
        if ((value === null || value === void 0 ? void 0 : value.type) === 'date') {
            // Years are also just marked as date :(
            if ((value === null || value === void 0 ? void 0 : value.displayValue.length) === 4)
                return value === null || value === void 0 ? void 0 : value.displayValue;
            else
                return value === null || value === void 0 ? void 0 : value.value.toString();
        }
        else if ((value === null || value === void 0 ? void 0 : value.type) === 'datetime' || (value === null || value === void 0 ? void 0 : value.type) === 'currency') {
            return value === null || value === void 0 ? void 0 : value.value.toString();
        }
        return value === null || value === void 0 ? void 0 : value.displayValue;
    }
    return value != null ? "".concat(value) : undefined;
};
exports.extractValue = extractValue;
var extractFieldType = function (value) {
    return typeof value === 'object' && (value === null || value === void 0 ? void 0 : value.type) !== 'time'
        ? value.type
        : 'string';
};
exports.extractFieldType = extractFieldType;
var getValue = function (t, item, prop, unit) {
    var _a;
    var itemValue = ((_a = item === null || item === void 0 ? void 0 : item.segments) === null || _a === void 0 ? void 0 : _a[0][prop]) || (item === null || item === void 0 ? void 0 : item[prop]);
    var value = (0, exports.extractValue)(itemValue);
    if (value == null)
        return undefined;
    return ((0, exports.getValueFromShortCode)(t, prop, value) +
        (unit && unit !== '$' ? unit : ''));
};
exports.getValue = getValue;
var mapSegments = function (segments, t) {
    return segments.map(function (segment) {
        return (0, properties_utils_1.getSegmentValues)(t, segment, exports.getFieldMappings);
    });
};
exports.mapSegments = mapSegments;
var mapUserTables = function (userDefined) {
    return Object.entries(userDefined).map(function (_a) {
        var section = _a[0], fieldsKVP = _a[1];
        var fields = Object.entries(fieldsKVP)
            .map(function (_a) {
            var name = _a[0], value = _a[1];
            return ({
                name: name,
                value: value,
            });
        })
            .filter(function (_a) {
            var name = _a.name;
            return name !== 'uploadId' && name !== 'tableName';
        });
        return { section: section, fields: fields };
    });
};
exports.mapUserTables = mapUserTables;


/***/ }),

/***/ "./components/AssetDetails/DetailsOverview/index.ts":
/*!**********************************************************!*\
  !*** ./components/AssetDetails/DetailsOverview/index.ts ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DetailsOverview.component */ "./components/AssetDetails/DetailsOverview/DetailsOverview.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./Segments */ "./components/AssetDetails/DetailsOverview/Segments/index.ts"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/DecisionPath/DecisionPath.component.tsx":
/*!**************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/DecisionPath/DecisionPath.component.tsx ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DecisionPath = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var DecisionPath = function (_a) {
    var rehabDecision = _a.rehabDecision;
    var t = (0, _Translations_1.useGlobalization)().t;
    var defaultHeaders = [
        {
            cell: t('Node Number'),
            dataCy: 'col-Node_Number',
            key: 'Node_Number',
            width: '200px',
            padding: '0 10px',
        },
        {
            cell: t('Node Name'),
            dataCy: 'col-Node_Name',
            key: 'Node_name',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Node Type'),
            dataCy: 'col-Node_Type',
            key: 'Node_Type',
            width: '200px',
            padding: '0 10px',
        },
        {
            cell: t('Result'),
            dataCy: 'col-Result',
            key: 'Result',
            width: '100px',
            padding: '0 10px',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Decision Path'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: "defect-table", headers: defaultHeaders, rows: 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rehabDecision.map(function (row, index) { return ({
                key: index,
                cells: [
                    row.node,
                    row.nodeName,
                    row.nodeType,
                    row.result,
                ],
            }); }) || [] }) })));
};
exports.DecisionPath = DecisionPath;
exports["default"] = exports.DecisionPath;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/DecisionPath/index.ts":
/*!********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/DecisionPath/index.ts ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DecisionPath.component */ "./components/AssetDetails/DetailsRehab/DecisionPath/DecisionPath.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/DetailsRehab.component.tsx":
/*!*************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/DetailsRehab.component.tsx ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsRehab = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
/* eslint-disable @typescript-eslint/no-explicit-any */
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var currency_1 = __webpack_require__(/*! @Utils/currency */ "./utils/currency.ts");
var Rehab_action_1 = __webpack_require__(/*! @Actions/Rehab.action */ "./actions/Rehab.action.ts");
var rehab_selectors_1 = __webpack_require__(/*! @Selectors/rehab.selectors */ "./selectors/rehab.selectors.ts");
var DecisionPath_1 = __webpack_require__(/*! ./DecisionPath */ "./components/AssetDetails/DetailsRehab/DecisionPath/index.ts");
var NoDetailsRehab_component_1 = __webpack_require__(/*! ./NoDetailsRehab.component */ "./components/AssetDetails/DetailsRehab/NoDetailsRehab.component.tsx");
var PerviouslyRun_component_1 = __webpack_require__(/*! ./PreviouslyRun/PerviouslyRun.component */ "./components/AssetDetails/DetailsRehab/PreviouslyRun/PerviouslyRun.component.tsx");
var RehabSummary_1 = __webpack_require__(/*! ./RehabSummary */ "./components/AssetDetails/DetailsRehab/RehabSummary/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var findPath = function (treeNodes, leafNodeId) {
    var _a;
    var leafNode = treeNodes.find(function (node) { return node.id == leafNodeId; });
    if (leafNode == undefined)
        return [];
    var path = [leafNode];
    do {
        var parentNode = treeNodes.find(function (node) { return node.id == path[path.length - 1].parentId; });
        if (parentNode == undefined)
            break;
        path.push(parentNode);
    } while (path[path.length - 1].parentId != null);
    var pathObj = [];
    if (path.length > 0) {
        for (var i = 0; i < path.length; i++) {
            pathObj.push({
                node: i + 1,
                nodeName: (_a = path[path.length - 1 - i].data) === null || _a === void 0 ? void 0 : _a.label,
                nodeType: path[path.length - 1 - i].type == 'innoInput'
                    ? 'Query'
                    : 'Action',
                result: path[path.length - 1 - i].type == 'innoInput'
                    ? path[path.length - 2 - i].connectorCondition
                    : '',
            });
        }
    }
    return pathObj;
};
// eslint-disable-next-line @typescript-eslint/naming-convention
var DetailsRehab = function (_a) {
    var adminFullAccess = _a.adminFullAccess, assetId = _a.assetId;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var isRehabPublishTreeFeatureEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info360-publish-rehab-trees');
    (0, react_1.useEffect)(function () {
        dispatch((0, Rehab_action_1.getRehabTrees)());
    }, []);
    var system = (0, stylovyze_1.useUnits)().system;
    var rehabTrees = (0, rehab_selectors_1.selectRehabTrees)();
    var isTreeLoading = (0, rehab_selectors_1.selectIsTreesLoading)();
    var hasValidTree = (0, rehab_selectors_1.selectHasValidTree)();
    var filterPublishedRehabTrees = function (value) {
        if (isRehabPublishTreeFeatureEnabled) {
            return value.publishState === 'published';
        }
        return true;
    };
    (0, react_1.useEffect)(function () {
        if (rehabTrees != undefined && rehabTrees.length > 0) {
            rehabTrees === null || rehabTrees === void 0 ? void 0 : rehabTrees.filter(filterPublishedRehabTrees).map(function (tree) {
                if (tree._id && tree.lastRun != undefined) {
                    dispatch((0, Rehab_action_1.getRehabResult)({
                        treeId: tree._id,
                        assetId: assetId,
                    }));
                }
            });
        }
    }, [rehabTrees]);
    var rehabResults = (0, rehab_selectors_1.selectRehabResults)();
    var rehabActionFields = [
        { name: 'name', alias: t('Decision Tree Name') },
        { name: 'runBy', alias: t('Run By') },
        { name: 'runCompleted', alias: t('Run Completed') },
        { name: 'finalAction', alias: t('Final Action') },
        { name: 'draftAction', alias: t('Draft Action') },
        { name: 'notes', alias: t('Notes') },
        { name: 'actionOverrideBy', alias: t('Action Override By') },
        { name: 'totalCost', alias: t('Total Cost') },
        { name: 'costCalculation', alias: t('Cost Calculation') },
        { name: 'defectCodes', alias: t('Defect Codes') },
    ];
    // TODO: NOT SURE IF THIS IS CORRECT YET
    var hardCodeUnitFields = {
    // totalCost: '$',
    };
    var _b = react_1.default.useState(0), activeTab = _b[0], setActiveTab = _b[1];
    var handleChange = function (event, newTab) {
        setActiveTab(newTab);
    };
    var rehabTabs = function (rehab, index) {
        var _a, _b;
        return ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, { label: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 11, style: {
                            textAlign: 'start',
                            alignItems: 'center',
                        } }, { children: rehab.name })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 1 }, { children: rehabResults[rehab._id].rows[0].LOCKED != '0' ? ((0, jsx_runtime_1.jsx)(icons_material_1.Lock, { style: { color: '#768D95' } })) : ((0, jsx_runtime_1.jsx)(icons_material_1.LockOpen, { style: { color: '#768D95' } })) }))] })), id: "vertical-tab-".concat(index), "aria-controls": "vertical-tabpanel-".concat(index) }, (_b = (_a = rehab._id) !== null && _a !== void 0 ? _a : rehab.name) !== null && _b !== void 0 ? _b : index));
    };
    var getHistory = function (rehab, tree) {
        return rehab.map(function (run) {
            var _a, _b;
            return ({
                LAST_MODIFIED: run.LAST_MODIFIED,
                LOCKED: run.LOCKED,
                event: run.EVENT,
                user: (_a = run.MODIFIED_BY) !== null && _a !== void 0 ? _a : tree.runBy,
                action: run.FINAL_RRHAB_ACTION,
                notes: (_b = run.NOTES) !== null && _b !== void 0 ? _b : '',
                totalCost: (0, currency_1.getCurrency)(+run.TOTAL_COST, companySettings),
                calculation: system == 'Metric'
                    ? (0, currency_1.getCostCalculation)(run.COST_CALCULATION_METER, companySettings)
                    : (0, currency_1.getCostCalculation)(run.COST_CALCULATION_FT, companySettings),
            });
        });
    };
    var getGrids = function (fields) {
        if (fields && fields.length > 0) {
            return fields.map(function (field) {
                if (hardCodeUnitFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputUnit, { fieldAttrs: { name: field.name }, unitField: {
                                label: field.alias,
                                unit: hardCodeUnitFields[field.name],
                                defaultValue: '',
                                onChange: function (e) {
                                    console.log('onChange', e.target.value);
                                },
                            }, invalidDisplayValue: '-' }) }), field.name));
                }
                else {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: { name: field.name }, textField: {
                                label: field.alias,
                            } }) }), field.name));
                }
            });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var rehabAction = function (rehab) {
        var _a, _b, _c;
        var rehabResult = rehabResults[rehab._id] && rehabResults[rehab._id].rows.length > 0
            ? rehabResults[rehab._id].rows[0]
            : null;
        if (rehabResult == null)
            return (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {});
        var action = {
            name: (_a = rehab.name) !== null && _a !== void 0 ? _a : '',
            runBy: (_b = rehab.runBy) !== null && _b !== void 0 ? _b : '',
            runCompleted: (0, _Utils_1.formatDateTimeWithFormatDate)((_c = rehab.lastRun) !== null && _c !== void 0 ? _c : '', formatDate),
            finalAction: rehabResult.FINAL_RRHAB_ACTION,
            draftAction: rehabResult.DRAFT_RRHAB_ACTION,
            actionOverrideBy: rehabResult.MODIFIED_BY,
            totalCost: (0, currency_1.getCurrency)(+rehabResult.TOTAL_COST, companySettings),
            costCalculation: system == 'Metric'
                ? (0, currency_1.getCostCalculation)(rehabResult.COST_CALCULATION_METER, companySettings)
                : (0, currency_1.getCostCalculation)(rehabResult.COST_CALCULATION_FT, companySettings),
            defectCodes: rehabResult.DEFECT_CODES,
            notes: rehabResult.NOTES,
        };
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: action, onSubmit: function (data) {
                console.log('should update the data', data);
            } }, { children: function () {
                return (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: getGrids(rehabActionFields) }));
            } })));
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var rehabTab = function (rehab) {
        // const rehabResult =
        // 	rehabResults[rehab._id] && rehabResults[rehab._id].rows.length > 0
        // 		? rehabResults[rehab._id].rows[0]
        // 		: null;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Rehab Action') }, { children: rehabAction(rehab) })), (0, jsx_runtime_1.jsx)(DecisionPath_1.DecisionPath, { rehabDecision: findPath(rehab.nodes, rehabResults[rehab._id].rows[0].ACTION_NODE_ID) }), rehabResults[rehab._id].rows ? ((0, jsx_runtime_1.jsx)(PerviouslyRun_component_1.PreviouslyRun, { rehab: getHistory(rehabResults[rehab._id].rows, rehab) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }));
    };
    var rehabTabPanels = function (rehab, index) {
        var _a, _b;
        return ((0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: activeTab, index: index }, { children: rehabTab(rehab) }), (_b = (_a = rehab._id) !== null && _a !== void 0 ? _a : rehab.name) !== null && _b !== void 0 ? _b : index));
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: isTreeLoading ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Rehab Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })) }))) : hasValidTree ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Rehab Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: activeTab, onChange: handleChange, "aria-label": "rehab-tabs" }, { children: rehabTrees
                                                .filter(filterPublishedRehabTrees)
                                                .filter(function (tree) {
                                                return rehabResults[tree._id] &&
                                                    rehabResults[tree._id]
                                                        .rows.length > 0;
                                            })
                                                .map(function (tree, index) { return rehabTabs(tree, index); }) })), rehabTrees
                                            .filter(filterPublishedRehabTrees)
                                            .filter(function (tree) {
                                            return rehabResults[tree._id] &&
                                                rehabResults[tree._id].rows
                                                    .length > 0;
                                        })
                                            .map(function (tree, index) {
                                            return rehabTabPanels(tree, index);
                                        })] }) })) })) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(RehabSummary_1.RehabSummary, { rehabTrees: rehabTrees, rehabResults: rehabResults }) }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Rehab Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(NoDetailsRehab_component_1.NoDetailsRehab, { adminFullAccess: adminFullAccess }) })) }))) })));
};
exports.DetailsRehab = DetailsRehab;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/NoDetailsRehab.component.tsx":
/*!***************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/NoDetailsRehab.component.tsx ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoDetailsRehab = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var RehabIcon_1 = __importDefault(__webpack_require__(/*! ./RehabIcon */ "./components/AssetDetails/DetailsRehab/RehabIcon.tsx"));
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoDetailsRehab = function (_a) {
    var adminFullAccess = _a.adminFullAccess;
    var history = (0, react_router_dom_1.useHistory)();
    var rehabClicked = function () {
        history.push('/rehab');
    };
    var t = (0, _Translations_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: { paddingTop: '40px', paddingBottom: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(RehabIcon_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No rehab details to show') })) })), adminFullAccess ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('Create a rehab tree to generate details.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                            paddingTop: '20px',
                            paddingBottom: '20px',
                        } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", onClick: rehabClicked }, { children: t('Create Rehab Tree') })) }))] }))) : ([])] })));
};
exports.NoDetailsRehab = NoDetailsRehab;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/PreviouslyRun/PerviouslyRun.component.tsx":
/*!****************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/PreviouslyRun/PerviouslyRun.component.tsx ***!
  \****************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreviouslyRun = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var TimelineOppositeContent_1 = __importStar(__webpack_require__(/*! @mui/lab/TimelineOppositeContent */ "@mui/lab/TimelineOppositeContent"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Paper_1 = __importDefault(__webpack_require__(/*! @mui/material/Paper */ "@mui/material/Paper"));
var RehabIcon_1 = __importDefault(__webpack_require__(/*! ../RehabIcon */ "./components/AssetDetails/DetailsRehab/RehabIcon.tsx"));
/* eslint-disable @typescript-eslint/no-explicit-any */
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var Timeline_1 = __importDefault(__webpack_require__(/*! @mui/lab/Timeline */ "@mui/lab/Timeline"));
var TimelineConnector_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineConnector */ "@mui/lab/TimelineConnector"));
var TimelineContent_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineContent */ "@mui/lab/TimelineContent"));
var TimelineDot_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineDot */ "@mui/lab/TimelineDot"));
var TimelineItem_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineItem */ "@mui/lab/TimelineItem"));
var TimelineSeparator_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineSeparator */ "@mui/lab/TimelineSeparator"));
var Typography_1 = __importDefault(__webpack_require__(/*! @mui/material/Typography */ "@mui/material/Typography"));
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var _Utilsluxon_1 = __webpack_require__(/*! @Utilsluxon */ "./utilsluxon/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var PreviouslyRun = function (_a) {
    var _b;
    var rehab = _a.rehab;
    var t = (0, _Translations_1.useGlobalization)().t;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var hasWorkHistory = false;
    if (rehab && rehab.length > 0) {
        hasWorkHistory = true;
    }
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Previously Run'), applyBodyPadding: false }, { children: hasWorkHistory ? ((0, jsx_runtime_1.jsx)(_Components_1.ShowMoreOverlay, __assign({ height: 220 }, { children: (0, jsx_runtime_1.jsx)(Timeline_1.default, __assign({ sx: (_b = {},
                    _b["& .".concat(TimelineOppositeContent_1.timelineOppositeContentClasses.root)] = {
                        flex: 0.2,
                    },
                    _b), style: { paddingLeft: '11px', paddingBottom: '25px' } }, { children: rehab === null || rehab === void 0 ? void 0 : rehab.map(function (run, index) {
                    return ((0, jsx_runtime_1.jsxs)(TimelineItem_1.default, __assign({ style: { paddingLeft: 0 } }, { children: [(0, jsx_runtime_1.jsxs)(TimelineOppositeContent_1.default, __assign({ style: {
                                    flex: 0.2,
                                    maxWidth: '200px',
                                    paddingLeft: 0,
                                    alignContent: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "body1", color: "textPrimary" }, { children: (0, _Utils_1.formatDateTimeWithFormatDate)(run.LAST_MODIFIED, formatDate) })), (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ style: {
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                        }, color: "textSecondary" }, { children: (0, _Utilsluxon_1.getTimeDifferenceText)(new Date(run.LAST_MODIFIED), companySettings) }))] })), (0, jsx_runtime_1.jsxs)(TimelineSeparator_1.default, { children: [index === 0 ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: { flexGrow: 1 } }, { children: "\u00A0" }))) : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {})), (0, jsx_runtime_1.jsx)(TimelineDot_1.default, { variant: "outlined" }), index === rehab.length - 1 ? ((0, jsx_runtime_1.jsx)("span", { children: "\u00A0" })) : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {}))] }), (0, jsx_runtime_1.jsx)(TimelineContent_1.default, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: __assign(__assign({}, run), { locked: run.LOCKED
                                            ? 'Yes'
                                            : 'No' }), onSubmit: function (data) {
                                        console.log('should update the data', data);
                                    } }, { children: function () {
                                        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, __assign({ square: true, style: {
                                                    padding: '0px 10px',
                                                    height: '100%',
                                                } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                                                        height: '100%',
                                                        alignItems: 'start',
                                                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                                                                margin: '0 12px 0 2px',
                                                            } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                                                                    height: '100%',
                                                                } }, { children: (0, jsx_runtime_1.jsx)(RehabIcon_1.default, { width: "24px", height: "24px" }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'event',
                                                                }, textField: {
                                                                    label: t('Event'),
                                                                } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'user',
                                                                }, textField: {
                                                                    label: t('User'),
                                                                } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'action',
                                                                }, textField: {
                                                                    label: t('Action'),
                                                                } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'notes',
                                                                }, textField: {
                                                                    label: t('Notes'),
                                                                } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'totalCost',
                                                                }, textField: {
                                                                    label: t('Total Cost'),
                                                                } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                                                    name: 'calculation',
                                                                }, textField: {
                                                                    label: t('Cost Calculation'),
                                                                } }) }))] })) })) }));
                                    } })) })] }), index));
                }) })) }))) : ([]) })));
};
exports.PreviouslyRun = PreviouslyRun;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/RehabIcon.tsx":
/*!************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/RehabIcon.tsx ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
function RehabIcon(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: props.width ? props.width : '100', height: props.height ? props.height : '101', fill: "none", viewBox: "0 0 100 101" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "#fff", d: "M0 0H100V100H0z", transform: "translate(0 .645)" }), (0, jsx_runtime_1.jsx)("path", { stroke: "#768D95", strokeWidth: "2", d: "M23.622 24.645H42.888999999999996V43.912H23.622z" }), (0, jsx_runtime_1.jsx)("path", { stroke: "#768D95", strokeWidth: "2", d: "M23.622 57.378H42.888999999999996V76.645H23.622z" }), (0, jsx_runtime_1.jsx)("path", { stroke: "#768D95", strokeWidth: "2", d: "M57.112 57.343H76.379V76.61H57.112z" }), (0, jsx_runtime_1.jsx)("path", { fill: "#768D95", d: "M32.42 45.256H34.09V55.278H32.42z" }), (0, jsx_runtime_1.jsx)("path", { fill: "#768D95", d: "M45.122 67.846H46.792V77.86800000000001H45.122z", transform: "rotate(-90 45.122 67.846)" }), (0, jsx_runtime_1.jsx)("path", { fill: "#768D95", d: "M31.32 69.636l-2.864-2.864-.975.969 3.838 3.838 8.241-8.24-.968-.968-7.272 7.265zM61.875 63.036l.965-.964 3.824 3.824 3.824-3.824.964.964-3.824 3.824 3.824 3.825-.964.964-3.824-3.824-3.824 3.824-.965-.965 3.824-3.824-3.824-3.824z" })] })));
}
exports["default"] = RehabIcon;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/RehabSummary/RehabSummary.component.tsx":
/*!**************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/RehabSummary/RehabSummary.component.tsx ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RehabSummary = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
/* eslint-disable @typescript-eslint/no-explicit-any */
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var currency_1 = __webpack_require__(/*! @Utils/currency */ "./utils/currency.ts");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var RehabSummary = function (_a) {
    var rehabTrees = _a.rehabTrees, rehabResults = _a.rehabResults;
    var t = (0, _Translations_1.useGlobalization)().t;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var defaultHeaders = [
        {
            cell: t('Decision Tree Name'),
            dataCy: 'col-Decision_Tree_Name',
            key: 'Decision_Tree_Name',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Final Rehab Action'),
            dataCy: 'col-Final_Rehab_Action',
            key: 'Final_Rehab_Action',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Rehab Cost'),
            dataCy: 'col-Rehab_Cost',
            key: 'Rehab_Cost',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Draft Rehab Action'),
            dataCy: 'col-Draft_Rehab_Action',
            key: 'Draft_Rehab_Action',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Last Run'),
            dataCy: 'col-Last_Run',
            key: 'Last_Run',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Run By'),
            dataCy: 'col-Run_By',
            key: 'Run_By',
            width: 'auto',
            padding: '0 10px',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Rehab Summary'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { initialized: rehabTrees.length > 0 &&
                rehabResults &&
                Object.keys(rehabResults).length > 0, className: "ScrollTable", dataCy: "defect-table", headers: defaultHeaders, rows: rehabTrees
                .filter(function (tree) {
                return rehabResults[tree._id] &&
                    rehabResults[tree._id].rows.length > 0;
            })
                .map(function (tree, index) {
                var _a;
                return ({
                    key: index,
                    cells: [
                        tree.name,
                        rehabResults[tree._id].rows[0]
                            .FINAL_RRHAB_ACTION,
                        (0, currency_1.getCurrency)(+rehabResults[tree._id].rows[0].TOTAL_COST, companySettings),
                        rehabResults[tree._id].rows[0]
                            .DRAFT_RRHAB_ACTION,
                        (0, _Utils_1.formatDateTimeWithFormatDate)((_a = tree.lastRun) !== null && _a !== void 0 ? _a : '', formatDate),
                        tree.runBy,
                    ],
                });
            }) || [] }) })));
};
exports.RehabSummary = RehabSummary;
exports["default"] = exports.RehabSummary;


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/RehabSummary/index.ts":
/*!********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/RehabSummary/index.ts ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RehabSummary.component */ "./components/AssetDetails/DetailsRehab/RehabSummary/RehabSummary.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRehab/index.ts":
/*!*******************************************************!*\
  !*** ./components/AssetDetails/DetailsRehab/index.ts ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DetailsRehab.component */ "./components/AssetDetails/DetailsRehab/DetailsRehab.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/CLOFScore/CLOFScore.component.tsx":
/*!*******************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/CLOFScore/CLOFScore.component.tsx ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CLOFScore = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var CLOFScore = function (_a) {
    var clof = _a.clof;
    var t = (0, _Translations_1.useGlobalization)().t;
    var headers = [
        {
            cell: t('Component Name'),
            dataCy: "".concat(clof, "ComponentName"),
            key: "".concat(clof, "ComponentName"),
        },
        {
            cell: t('Score'),
            dataCy: "".concat(clof, "Score"),
            key: "".concat(clof, "Score"),
        },
        {
            cell: t('Weighted Score'),
            dataCy: "".concat(clof, "WeightedScore"),
            key: "".concat(clof, "WeightedScore"),
        },
    ];
    var assetRisk = (0, _Selectors_1.selectAssetRisk)();
    var componentRows = [];
    if (clof == 'CoF') {
        if ((assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.COF_CONFIG) && assetRisk.COF_CONFIG.length > 0) {
            var index = 0;
            for (var _i = 0, _b = assetRisk.COF_CONFIG; _i < _b.length; _i++) {
                var category = _b[_i];
                if (category.components && category.components.length > 0) {
                    for (var _c = 0, _d = category.components; _c < _d.length; _c++) {
                        var component = _d[_c];
                        var rawScore = (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES) &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COFRaw_".concat(category.name, "_").concat(component.name)]) != null &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COFRaw_".concat(category.name, "_").concat(component.name)]) != undefined
                            ? assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COFRaw_".concat(category.name, "_").concat(component.name)]
                            : '-';
                        var score = (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES) &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COF_".concat(category.name, "_").concat(component.name)]) != null &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COF_".concat(category.name, "_").concat(component.name)]) != undefined
                            ? assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["COF_".concat(category.name, "_").concat(component.name)]
                            : '-';
                        componentRows.push({
                            key: index++,
                            cells: [
                                {
                                    content: component.name,
                                },
                                {
                                    content: rawScore,
                                },
                                {
                                    content: score,
                                },
                            ],
                        });
                    }
                }
            }
        }
    }
    else if (clof == 'LoF') {
        if ((assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.LOF_CONFIG) && assetRisk.LOF_CONFIG.length > 0) {
            var index = 0;
            for (var _e = 0, _f = assetRisk.LOF_CONFIG; _e < _f.length; _e++) {
                var category = _f[_e];
                if (category.components && category.components.length > 0) {
                    for (var _g = 0, _h = category.components; _g < _h.length; _g++) {
                        var component = _h[_g];
                        var rawScore = (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES) &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOFRaw_".concat(category.name, "_").concat(component.name)]) != null &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOFRaw_".concat(category.name, "_").concat(component.name)]) != undefined
                            ? assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOFRaw_".concat(category.name, "_").concat(component.name)]
                            : '-';
                        var score = (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES) &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOF_".concat(category.name, "_").concat(component.name)]) != null &&
                            (assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOF_".concat(category.name, "_").concat(component.name)]) != undefined
                            ? assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.WEIGHTED_SCORES["LOF_".concat(category.name, "_").concat(component.name)]
                            : '-';
                        componentRows.push({
                            key: index++,
                            cells: [
                                {
                                    content: component.name,
                                },
                                {
                                    content: rawScore,
                                },
                                {
                                    content: score,
                                },
                            ],
                        });
                    }
                }
            }
        }
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: clof, dataCy: "".concat(clof, "ScoreTable"), headers: headers, rows: componentRows }) })) })));
};
exports.CLOFScore = CLOFScore;
exports["default"] = exports.CLOFScore;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/CLOFScore/index.ts":
/*!****************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/CLOFScore/index.ts ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./CLOFScore.component */ "./components/AssetDetails/DetailsRisk/CLOFScore/CLOFScore.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/DetailsRisk.component.tsx":
/*!***********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/DetailsRisk.component.tsx ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var riskConfigsList_selectors_1 = __importStar(__webpack_require__(/*! @Selectors/riskConfigsList.selectors */ "./selectors/riskConfigsList.selectors.ts"));
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _1 = __webpack_require__(/*! . */ "./components/AssetDetails/DetailsRisk/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var DetailsRisk = function (_a) {
    var adminFullAccess = _a.adminFullAccess;
    var t = (0, _Translations_1.useGlobalization)().t;
    var isLoading = (0, riskConfigsList_selectors_1.selectRiskConfigsListIsLoading)();
    var configs = (0, riskConfigsList_selectors_1.default)();
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Risk') }, { children: !isLoading ? (configs.length != 0 ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3 }, { children: (0, jsx_runtime_1.jsx)(_1.Overall, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 9 }, { children: (0, jsx_runtime_1.jsx)(_1.Trend, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(_1.RiskComponents, {}) }))] }))) : ((0, jsx_runtime_1.jsx)(_1.NoDetailsRisk, { adminFullAccess: adminFullAccess }))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.DetailsRisk = DetailsRisk;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/MultiRiskDetails.component.tsx":
/*!****************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/MultiRiskDetails.component.tsx ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MultiRiskDetails = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var riskConfigsList_selectors_1 = __importStar(__webpack_require__(/*! @Selectors/riskConfigsList.selectors */ "./selectors/riskConfigsList.selectors.ts"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _1 = __webpack_require__(/*! . */ "./components/AssetDetails/DetailsRisk/index.ts");
var RiskModelTabPanel_component_1 = __webpack_require__(/*! ./RiskModelTabPanel/RiskModelTabPanel.component */ "./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.component.tsx");
var RiskSummary_1 = __webpack_require__(/*! ./RiskSummary */ "./components/AssetDetails/DetailsRisk/RiskSummary/index.ts");
var riskConfigs_actions_1 = __webpack_require__(/*! @Actions/riskConfigs.actions */ "./actions/riskConfigs.actions.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var MultiRiskDetails = function (_a) {
    var adminFullAccess = _a.adminFullAccess, assetId = _a.assetId, assetType = _a.assetType;
    var t = (0, _Translations_1.useGlobalization)().t;
    var _b = react_1.default.useState(0), activeTab = _b[0], setActiveTab = _b[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var riskConfigsList = (0, riskConfigsList_selectors_1.default)();
    var isLoading = (0, riskConfigsList_selectors_1.selectRiskConfigsListIsLoading)();
    (0, react_1.useEffect)(function () {
        dispatch((0, riskConfigs_actions_1.getRiskConfigsList)({ assetType: assetType }));
    }, []);
    var handleChange = function (event, newTab) {
        setActiveTab(newTab);
    };
    var riskTabs = function (model, index) {
        var _a, _b, _c;
        return ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, { label: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: {
                        textAlign: 'start',
                        alignItems: 'center',
                    } }, { children: (_a = model.name) !== null && _a !== void 0 ? _a : t('Default Risk model') })) })), id: "vertical-tab-".concat(index), "aria-controls": "vertical-tabpanel-".concat(index) }, (_c = (_b = model.configId) !== null && _b !== void 0 ? _b : model.name) !== null && _c !== void 0 ? _c : index));
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: !isLoading ? (riskConfigsList && riskConfigsList.length != 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Risk Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: activeTab, onChange: handleChange, "aria-label": "rehab-tabs" }, { children: riskConfigsList === null || riskConfigsList === void 0 ? void 0 : riskConfigsList.map(function (model, index) {
                                                return riskTabs(model, index);
                                            }) })), riskConfigsList.map(function (model, index) {
                                            var _a, _b;
                                            return ((0, jsx_runtime_1.jsx)(RiskModelTabPanel_component_1.RiskModelTabPanel, { activeTab: activeTab, index: index, assetId: assetId, assetType: assetType, configId: model.configId }, (_b = (_a = model.configId) !== null && _a !== void 0 ? _a : model.name) !== null && _b !== void 0 ? _b : index));
                                        })] }) })) })) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(RiskSummary_1.RiskSummary, {}) }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Risk Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(_1.NoDetailsRisk, { adminFullAccess: adminFullAccess }) })) })))) : ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Risk Details'), fullHeight: true }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })) }))) })));
};
exports.MultiRiskDetails = MultiRiskDetails;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/NoDetailsRisk.component.tsx":
/*!*************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/NoDetailsRisk.component.tsx ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoDetailsRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var RiskIcon_component_1 = __webpack_require__(/*! ./RiskIcon.component */ "./components/AssetDetails/DetailsRisk/RiskIcon.component.tsx");
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoDetailsRisk = function (_a) {
    var adminFullAccess = _a.adminFullAccess;
    var t = (0, _Translations_1.useGlobalization)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var runModelClicked = function () {
        history.push('/risk', { pageIndex: 3 });
    };
    var isLoading = (0, _Selectors_1.selectAssetRiskIsWaiting)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: { paddingTop: '40px', paddingBottom: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(RiskIcon_component_1.RiskIcon, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No risk details to show') })) })), adminFullAccess && !isLoading ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t("You have not run your model, in order to see risk\n\t\t\t\t\t\t\tdetails please run your model.") })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                            paddingTop: '20px',
                            paddingBottom: '20px',
                        } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", onClick: runModelClicked }, { children: t('Run Model') })) }))] }))) : ([])] })));
};
exports.NoDetailsRisk = NoDetailsRisk;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Overall/Overall.component.tsx":
/*!***************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Overall/Overall.component.tsx ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Overall = exports.riskCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var assetRisk_selectors_1 = __webpack_require__(/*! @Selectors/assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var riskCell = function (t, grade) {
    if (grade != undefined) {
        switch (grade) {
            case 0:
                return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Negligible'), color: "negligible" });
            case 1:
                return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Low'), color: "low" });
            case 2:
                return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Medium'), color: "medium" });
            case 3:
                return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('High'), color: "high" });
            case 4:
                return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Extreme'), color: "extreme" });
            default:
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    }
    else
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.riskCell = riskCell;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var style = (0, styles_1.makeStyles)(function (theme) { return ({
    labelDiv: {
        '&>label': {
            lineHeight: '1rem !important',
        },
        '&>h5': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '12px',
            lineHeight: '16px',
            color: ' rgba(0,0,0,0.54)',
            marginTop: '0.5rem',
            marginBottom: '0',
        },
    },
}); });
// eslint-disable-next-line @typescript-eslint/naming-convention
var Overall = function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b;
    var t = (0, _Translations_1.useGlobalization)().t;
    var classes = style();
    var riskAndCondition = (0, assetRisk_selectors_1.selectAssetRisk)();
    var isReady = (0, assetRisk_selectors_1.selectAssetRiskIsReady)();
    var riskNormalizeFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-normalize');
    var riskFormula = function () {
        var _a, _b;
        var formula = '';
        if (riskAndCondition &&
            riskAndCondition.RISK_CONFIG &&
            riskAndCondition.RISK_CONFIG.length > 0) {
            formula = t('{{lof}}% LoF {{method}} {{cof}}% CoF', {
                lof: riskAndCondition.RISK_CONFIG[0].LOFWeighting,
                method: riskAndCondition.RISK_CONFIG[0].RiskMethod == 'added'
                    ? '+'
                    : 'X',
                cof: riskAndCondition.RISK_CONFIG[0].COFWeighting,
            });
            if (riskNormalizeFlag && riskAndCondition.postProcessing) {
                var process_1 = riskAndCondition.postProcessing.find(function (process) { return process.type === 'normalize'; });
                if (process_1 && process_1.params.useNormalize) {
                    formula = "((".concat(formula, ") / ").concat((_a = process_1.params.maxRiskScore) !== null && _a !== void 0 ? _a : t('HCRS'), ") * ").concat((_b = process_1.params.normalizeValue) !== null && _b !== void 0 ? _b : t('NV'));
                }
            }
        }
        return formula;
    };
    var overallRiskVertical = riskAndCondition && isReady ? ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: __assign(__assign({}, riskAndCondition), { RiskByPercentile: '81%', RiskFormula: riskFormula() }), onSubmit: function (data) {
            console.log('should update the data', data);
        } }, { children: function () {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ elevation: 0 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.labelDiv }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "h5" }, { children: t('Risk by Grade') })), (0, exports.riskCell)(t, riskAndCondition
                                            ? riskAndCondition.GRADE
                                            : undefined)] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_RISK',
                                    }, textField: {
                                        label: t('Total Risk Score'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_COF',
                                    }, textField: {
                                        label: t('Weighted CoF'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_LOF',
                                    }, textField: {
                                        label: t('Weighted LoF'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'RiskFormula',
                                    }, textField: {
                                        label: t('Risk Formula'),
                                    } }) }))] })) })) }));
        } }))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}));
    var overallRiskHorizontal = riskAndCondition ? ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: __assign(__assign({}, riskAndCondition), { RiskByPercentile: '81%', RiskFormula: riskFormula() }), onSubmit: function (data) {
            console.log('should update the data', data);
        } }, { children: function () {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ elevation: 0 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.labelDiv }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "h5" }, { children: t('Risk by Grade') })), (0, exports.riskCell)(t, riskAndCondition
                                            ? riskAndCondition.GRADE
                                            : undefined)] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_RISK',
                                    }, textField: {
                                        label: t('Total Risk Score'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_COF',
                                    }, textField: {
                                        label: t('Weighted CoF'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'CURRENT_LOF',
                                    }, textField: {
                                        label: t('Weighted LoF'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'RiskFormula',
                                    }, textField: {
                                        label: t('Risk Formula'),
                                    } }) }))] })) })) }));
        } }))) : ((0, jsx_runtime_1.jsx)("div", {}));
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Overall') }, { children: isReady ? (orientation == 'vertical' ? (overallRiskVertical) : (overallRiskHorizontal)) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.Overall = Overall;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Overall/index.ts":
/*!**************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Overall/index.ts ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./Overall.component */ "./components/AssetDetails/DetailsRisk/Overall/Overall.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskComponents/RiskComponents.component.tsx":
/*!*****************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskComponents/RiskComponents.component.tsx ***!
  \*****************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskComponents = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var assetRisk_selectors_1 = __webpack_require__(/*! @Selectors/assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var CLOFScore_1 = __webpack_require__(/*! ../CLOFScore */ "./components/AssetDetails/DetailsRisk/CLOFScore/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var RiskComponents = function () {
    var t = (0, _Translations_1.useGlobalization)().t;
    var isRiskReady = (0, assetRisk_selectors_1.selectAssetRiskIsReady)();
    var assetRisk = (0, assetRisk_selectors_1.selectAssetRisk)();
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Components') }, { children: isRiskReady ? (assetRisk ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(CLOFScore_1.CLOFScore, { clof: "LoF" }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(CLOFScore_1.CLOFScore, { clof: "CoF" }) }))] }))) : ((0, jsx_runtime_1.jsx)("div", {}))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.RiskComponents = RiskComponents;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskComponents/index.ts":
/*!*********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskComponents/index.ts ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskComponents.component */ "./components/AssetDetails/DetailsRisk/RiskComponents/RiskComponents.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskIcon.component.tsx":
/*!********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskIcon.component.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskIcon = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var RiskIcon = function () { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "94", height: "100", viewBox: "0 0 94 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M51.4725 72.2266L77.9055 42.3353L48.0153 68.7703C46.5124 68.4237 44.8718 68.8238 43.7022 69.9934C41.8938 71.8028 41.8949 74.7313 43.7022 76.5396C45.5105 78.348 48.4401 78.348 50.2485 76.5396C51.419 75.3701 51.8202 73.7294 51.4725 72.2266Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M80.696 45.3917L75.8387 50.8836C80.6446 57.0667 83.5165 64.8237 83.5165 73.2431H90.717C90.717 62.6584 86.9553 52.9553 80.696 45.3917Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52.0019 37.0681C58.4813 37.962 64.4207 40.566 69.3567 44.4015L74.8486 39.5443C67.3954 33.3784 57.8646 29.6356 47.462 29.5277L52.0019 37.0681ZM24.571 44.4437H14.1068C7.36704 52.1354 3.2821 62.2117 3.2821 73.2425H10.4826C10.4826 61.5552 16.0018 51.1323 24.571 44.4437Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M26.1666 29.3904H22.2361V33.3205H26.1666V29.3904Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M26.1666 15.6332H22.2361V27.4253H26.1666V15.6332Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M47.3564 39.9353H1.24121L24.3005 0L47.3564 39.9353ZM8.05003 36.0043H40.5466L24.3005 7.86108L8.05003 36.0043Z", fill: "#768D95" })] }))); };
exports.RiskIcon = RiskIcon;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.component.tsx":
/*!***********************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.component.tsx ***!
  \***********************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskModelTabPanel = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
/* eslint-disable @typescript-eslint/no-explicit-any */
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var Overall_1 = __webpack_require__(/*! ../Overall */ "./components/AssetDetails/DetailsRisk/Overall/index.ts");
var RiskComponents_1 = __webpack_require__(/*! ../RiskComponents */ "./components/AssetDetails/DetailsRisk/RiskComponents/index.ts");
var Trend_1 = __webpack_require__(/*! ../Trend */ "./components/AssetDetails/DetailsRisk/Trend/index.ts");
var RiskModelTabPanel_styles_1 = __webpack_require__(/*! ./RiskModelTabPanel.styles */ "./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.styles.tsx");
var assetRisk_selectors_1 = __webpack_require__(/*! @Selectors/assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
var assetRiskHistory_selectors_1 = __webpack_require__(/*! @Selectors/assetRiskHistory.selectors */ "./selectors/assetRiskHistory.selectors.ts");
var RiskIcon_component_1 = __webpack_require__(/*! ../RiskIcon.component */ "./components/AssetDetails/DetailsRisk/RiskIcon.component.tsx");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RiskModelTabPanel = function (props) {
    var activeTab = props.activeTab, index = props.index, assetId = props.assetId, assetType = props.assetType, configId = props.configId;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, RiskModelTabPanel_styles_1.usePanelStyles)();
    var assetRisk = (0, assetRisk_selectors_1.selectAssetRisk)();
    var isAssetRiskReady = (0, assetRisk_selectors_1.selectAssetRiskIsReady)();
    var assetRiskHistory = (0, assetRiskHistory_selectors_1.selectAssetRiskHistory)();
    var isAssetRiskHistoryReady = (0, assetRiskHistory_selectors_1.selectAssetRiskHistoryIsReady)();
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        if (activeTab === index) {
            dispatch((0, assetRisk_actions_1.getAssetRisk)({
                assetId: assetId,
                assetType: assetType,
                configId: configId,
            }));
            dispatch((0, assetRisk_actions_1.getAssetRiskHistory)({
                assetId: assetId,
                assetType: assetType,
                configId: configId,
            }));
        }
    }, [activeTab]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.root, role: "tabpanel", hidden: activeTab !== index, id: "vertical-tabpanel-".concat(index), "aria-labelledby": "vertical-tab-".concat(index) }, { children: activeTab === index && ((0, jsx_runtime_1.jsx)("div", { children: isAssetRiskHistoryReady && isAssetRiskReady ? ((assetRisk === null || assetRisk === void 0 ? void 0 : assetRisk.ASSET_ID) && (assetRiskHistory === null || assetRiskHistory === void 0 ? void 0 : assetRiskHistory.length) ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Overall_1.Overall, { orientation: "horizontal" }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(RiskComponents_1.RiskComponents, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Trend_1.Trend, {}) }))] }))) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(RiskIcon_component_1.RiskIcon, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('Asset not included in risk model') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('This can happen due to filtering criteria.') })) }))] }))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })) })));
};
exports.RiskModelTabPanel = RiskModelTabPanel;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.styles.tsx":
/*!********************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskModelTabPanel/RiskModelTabPanel.styles.tsx ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.usePanelStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        width: '100%',
        '& > div': {
            minHeight: '400px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px',
        },
    },
}); });


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskSummary/RiskSummary.component.tsx":
/*!***********************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskSummary/RiskSummary.component.tsx ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskSummary = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
/* eslint-disable @typescript-eslint/no-explicit-any */
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var assetRisk_selectors_1 = __webpack_require__(/*! @Selectors/assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var date_utils_1 = __webpack_require__(/*! @Utils/date.utils */ "./utils/date.utils.ts");
var Overall_component_1 = __webpack_require__(/*! ../Overall/Overall.component */ "./components/AssetDetails/DetailsRisk/Overall/Overall.component.tsx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var RiskSummary = function () {
    var _a;
    var t = (0, _Translations_1.useGlobalization)().t;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var riskSummary = (0, assetRisk_selectors_1.selectRiskSummay)();
    var isLoading = (0, assetRisk_selectors_1.selectRiskSummayIsLoading)();
    var riskNormalizeFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-normalize');
    var defaultHeaders = [
        {
            cell: t('Risk Model Name'),
            dataCy: 'col-Risk_Model_Name',
            key: 'Risk_Model_Name',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Total Score'),
            dataCy: 'col-Total_Score',
            key: 'Total_Score',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Trend'),
            dataCy: 'col-Trend',
            key: 'Trend',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Rank'),
            dataCy: 'col-Rank',
            key: 'Rank',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Risk Grade'),
            dataCy: 'col-Risk_Grade',
            key: 'Risk_Grade',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Weighted CoF'),
            dataCy: 'col-Weighted_CoF',
            key: 'Weighted_CoF',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Weighted LoF'),
            dataCy: 'col-Weighted_LoF',
            key: 'Weight_LoF',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Formula'),
            dataCy: 'col-Formula',
            key: 'Formula',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Last Run'),
            dataCy: 'col-Last_Run',
            key: 'Last_Run',
            width: 'auto',
            padding: '0 10px',
        },
        {
            cell: t('Run By'),
            dataCy: 'col-Run_By',
            key: 'Run_by',
            width: 'auto',
            padding: '0 10px',
        },
    ];
    var formatRunBy = function (runBy) {
        if (runBy.indexOf('@') !== -1) {
            return runBy.substring(0, runBy.lastIndexOf('@'));
        }
        return runBy;
    };
    var riskFormula = function (summary) {
        var _a, _b;
        var formula = t('{{lof}}% LoF {{method}} {{cof}}% CoF', {
            lof: summary.LOFWEIGHTING,
            method: summary.RISKMETHOD == 'added' ? '+' : 'X',
            cof: summary.COFWEIGHTING,
        });
        if (riskNormalizeFlag && summary.postProcessing) {
            var process_1 = summary.postProcessing.find(function (process) { return process.type === 'normalize'; });
            if (process_1 && process_1.params.useNormalize) {
                formula = "((".concat(formula, ") / ").concat((_a = process_1.params.maxRiskScore) !== null && _a !== void 0 ? _a : t('HCRS'), ") * ").concat((_b = process_1.params.normalizeValue) !== null && _b !== void 0 ? _b : t('NV'));
            }
        }
        return formula;
    };
    var rows = (_a = riskSummary === null || riskSummary === void 0 ? void 0 : riskSummary.map(function (summary, index) {
        var _a, _b;
        return ({
            key: index,
            cells: [
                summary.CONFIG_NAME == undefined || summary.CONFIG_NAME == ''
                    ? t('Default Risk model')
                    : summary.CONFIG_NAME,
                summary.CURRENT_RISK,
                summary.RISK_CHANGE,
                summary.RANK,
                (0, Overall_component_1.riskCell)(t, summary.GRADE),
                summary.CURRENT_COF,
                summary.CURRENT_LOF,
                riskFormula(summary),
                (0, date_utils_1.formatDateTimeWithFormatDate)((_a = summary.MODIFIED_AT) !== null && _a !== void 0 ? _a : '', formatDate),
                formatRunBy((_b = summary.RUN_BY) !== null && _b !== void 0 ? _b : ''),
            ],
        });
    })) !== null && _a !== void 0 ? _a : [];
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isLoading ? ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Risk Summary'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { initialized: true, className: "ScrollTable", dataCy: "defect-table", headers: defaultHeaders, rows: rows }) }))) : ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Risk Summary') }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) }))) }));
};
exports.RiskSummary = RiskSummary;
exports["default"] = exports.RiskSummary;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/RiskSummary/index.ts":
/*!******************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/RiskSummary/index.ts ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskSummary.component */ "./components/AssetDetails/DetailsRisk/RiskSummary/RiskSummary.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Trend/NoteIcon.component.tsx":
/*!**************************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Trend/NoteIcon.component.tsx ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoteIcon = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var NoteIcon = function () { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8.46489 4.76925L8.46434 6.19712H7.16908V20.5721H17.4516V6.19712H16.156L16.1558 4.76925H18.8794V22H5.74121V4.76925H8.46489ZM8.17223 14.1076H16.4481V15.5053H8.17223V14.1076ZM8.17223 16.5881H16.4481V17.9857H8.17223V16.5881ZM8.91046 8.76239H15.7102V12.54H8.91046V8.76239ZM12.3103 2C13.2531 2 14.0207 2.76788 14.0207 3.71064C14.0207 4.6534 13.2531 5.42128 12.3103 5.42128C11.3676 5.42128 10.5997 4.6534 10.5997 3.71064C10.5997 2.76788 11.3676 2 12.3103 2ZM12.3103 2.7138C11.758 2.7138 11.3135 3.15827 11.3135 3.71064C11.3135 4.26301 11.758 4.70721 12.3103 4.70721C12.8627 4.70721 13.3069 4.26301 13.3069 3.71064C13.3069 3.15827 12.8627 2.7138 12.3103 2.7138ZM9.36812 4.07248H10.4561C10.628 4.95374 11.4066 5.59973 12.3103 5.59973C13.213 5.59973 13.9921 4.95594 14.1645 4.07248H15.2525C15.6514 4.07248 15.9776 4.3989 15.9776 4.7978V6.27618H8.64279V4.7978C8.64279 4.3989 8.96921 4.07248 9.36812 4.07248Z", fill: "#768D95" }) }))); };
exports.NoteIcon = NoteIcon;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Trend/Trend.component.tsx":
/*!***********************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Trend/Trend.component.tsx ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Trend = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var assetRiskHistory_selectors_1 = __webpack_require__(/*! @Selectors/assetRiskHistory.selectors */ "./selectors/assetRiskHistory.selectors.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var Timeline_1 = __importDefault(__webpack_require__(/*! @mui/lab/Timeline */ "@mui/lab/Timeline"));
var TimelineItem_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineItem */ "@mui/lab/TimelineItem"));
var TimelineSeparator_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineSeparator */ "@mui/lab/TimelineSeparator"));
var TimelineConnector_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineConnector */ "@mui/lab/TimelineConnector"));
var TimelineContent_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineContent */ "@mui/lab/TimelineContent"));
var TimelineDot_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineDot */ "@mui/lab/TimelineDot"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var NoteIcon_component_1 = __webpack_require__(/*! ./NoteIcon.component */ "./components/AssetDetails/DetailsRisk/Trend/NoteIcon.component.tsx");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var _Utilsluxon_1 = __webpack_require__(/*! @Utilsluxon */ "./utilsluxon/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var TimelineOppositeContent_1 = __importStar(__webpack_require__(/*! @mui/lab/TimelineOppositeContent */ "@mui/lab/TimelineOppositeContent"));
var summaryze_1 = __webpack_require__(/*! @innovyze/summaryze */ "@innovyze/summaryze");
var Trend_styles_1 = __webpack_require__(/*! ./Trend.styles */ "./components/AssetDetails/DetailsRisk/Trend/Trend.styles.ts");
var assetRisk_selectors_1 = __webpack_require__(/*! @Selectors/assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var Trend = function () {
    var _a;
    var t = (0, _Translations_1.useGlobalization)().t;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var riskAndCondition = (0, assetRisk_selectors_1.selectAssetRisk)();
    var riskHistory = (0, assetRiskHistory_selectors_1.selectAssetRiskHistory)();
    var isReady = (0, assetRiskHistory_selectors_1.selectAssetRiskHistoryIsReady)();
    var sortedRiskHistory = riskHistory === null || riskHistory === void 0 ? void 0 : riskHistory.slice().sort(function (x, y) { return +new Date(y.MODIFIED_AT) - +new Date(x.MODIFIED_AT); });
    var ChangedValueText = function (value1, value2) {
        if (value2 > value1)
            return ((0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("span", { children: t('Risk value changed from ') }), (0, jsx_runtime_1.jsx)("b", __assign({ style: { color: 'red' } }, { children: value1 + t(' to ') + value2 })), (0, jsx_runtime_1.jsx)("span", { children: t(' based on latest model run') })] }));
        else if (value2 === value1)
            return (0, jsx_runtime_1.jsx)("p", { children: t('Risk value is {{value}}', { value: value1 }) });
        else
            return ((0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("span", { children: t('Risk value changed from ') }), (0, jsx_runtime_1.jsx)("b", __assign({ style: { color: 'green' } }, { children: value1 + t(' to ') + value2 })), (0, jsx_runtime_1.jsx)("span", { children: t(' based on latest model run') })] }));
    };
    var _b = (0, react_1.useState)([]), riskTrendSeries = _b[0], setRiskTrendSeries = _b[1];
    var _c = (0, react_1.useState)(25), maxGrade = _c[0], setMaxGrade = _c[1];
    var _d = (0, react_1.useState)([2, 4, 6, 8]), grades = _d[0], setGrades = _d[1];
    (0, react_1.useEffect)(function () {
        if (sortedRiskHistory) {
            // This is incase they have adjusted the grade calculation in the past so all data is displayed
            var overflowMax_1 = maxGrade;
            var data = sortedRiskHistory.map(function (item) {
                if (item.RISK > overflowMax_1)
                    overflowMax_1 = item.RISK;
                var date = new Date(item.MODIFIED_AT);
                return [date.getTime(), item.RISK];
            });
            if (overflowMax_1 != maxGrade)
                setMaxGrade(overflowMax_1);
            setRiskTrendSeries([
                {
                    name: t('Risk Trend'),
                    data: data,
                    type: 'line',
                    zoneAxis: 'y',
                    zones: [
                        {
                            value: grades[0],
                            color: stylovyze_1.riskGradePalette.negligible.dark,
                        },
                        { value: grades[1], color: stylovyze_1.riskGradePalette.low.dark },
                        {
                            value: grades[2],
                            color: stylovyze_1.riskGradePalette.medium.main,
                        },
                        { value: grades[3], color: stylovyze_1.riskGradePalette.high.main },
                        {
                            color: stylovyze_1.riskGradePalette.extreme.dark,
                        },
                    ],
                },
            ]);
        }
    }, [riskHistory, grades]);
    (0, react_1.useEffect)(function () {
        if (riskAndCondition &&
            riskAndCondition.RISK_CONFIG &&
            riskAndCondition.RISK_CONFIG.length > 0) {
            var max = void 0;
            if (riskAndCondition.RISK_CONFIG[0].RiskMethod == 'multiplied') {
                max =
                    Math.round(riskAndCondition.RISK_CONFIG[0].LOFWeighting *
                        riskAndCondition.RISK_CONFIG[0].COFWeighting) / 100;
            }
            else {
                max =
                    Math.round(riskAndCondition.RISK_CONFIG[0].LOFWeighting +
                        riskAndCondition.RISK_CONFIG[0].COFWeighting) / 10;
            }
            setMaxGrade(max);
            var grades_1 = [
                riskAndCondition.RISK_CONFIG[0].Grades.Low,
                riskAndCondition.RISK_CONFIG[0].Grades.Medium,
                riskAndCondition.RISK_CONFIG[0].Grades.High,
                riskAndCondition.RISK_CONFIG[0].Grades.Extreme,
            ];
            setGrades(grades_1);
        }
    }, [riskAndCondition]);
    var optionsRiskTrend = (0, react_1.useMemo)(function () {
        return {
            title: {
                text: '',
            },
            xAxis: [
                {
                    type: 'datetime',
                },
            ],
            yAxis: [
                {
                    min: 0,
                    max: maxGrade,
                    title: {
                        text: t('Score'),
                    },
                },
            ],
            plotOptions: {
                series: {
                    marker: {
                        enabled: true,
                        radius: 4,
                    },
                },
            },
            legend: { enabled: false },
            tooltip: {
                formatter: function () {
                    var date = (0, _Utils_1.formatDateTimeWithFormatDate)(new Date(this.x).toISOString(), formatDate);
                    return t('{{date}}</br>Risk value <b>{{risk}}</b>', {
                        date: date,
                        risk: this.y,
                    });
                },
                split: false,
            },
            chart: {
                reflow: true,
                zoomType: 'x',
            },
        };
    }, [riskTrendSeries, maxGrade]);
    var trend = sortedRiskHistory && sortedRiskHistory.length > 0 ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(_Components_1.ShowMoreOverlay, __assign({ height: 400 }, { children: (0, jsx_runtime_1.jsx)(Timeline_1.default, __assign({ sx: (_a = {},
                            _a["& .".concat(TimelineOppositeContent_1.timelineOppositeContentClasses.root)] = {
                                flex: 0.2,
                            },
                            _a), style: {
                            paddingLeft: '11px',
                            paddingBottom: '25px',
                        } }, { children: sortedRiskHistory === null || sortedRiskHistory === void 0 ? void 0 : sortedRiskHistory.map(function (risk, index) {
                            return ((0, jsx_runtime_1.jsxs)(TimelineItem_1.default, __assign({ style: { paddingLeft: 0 } }, { children: [(0, jsx_runtime_1.jsxs)(TimelineOppositeContent_1.default, __assign({ style: {
                                            flex: 0.2,
                                            maxWidth: '200px',
                                            paddingLeft: 0,
                                            paddingTop: '28px',
                                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", color: "textPrimary" }, { children: (0, _Utils_1.formatDateTimeWithFormatDate)(risk.MODIFIED_AT, formatDate) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ style: {
                                                    fontSize: '12px',
                                                    lineHeight: '16px',
                                                }, color: "textSecondary" }, { children: (0, _Utilsluxon_1.getTimeDifferenceText)(new Date(risk.MODIFIED_AT), companySettings) }))] })), (0, jsx_runtime_1.jsxs)(TimelineSeparator_1.default, __assign({ style: index === 0
                                            ? {
                                                paddingTop: '27px',
                                            }
                                            : index ===
                                                sortedRiskHistory.length -
                                                    1
                                                ? {
                                                    paddingBottom: '27px',
                                                }
                                                : {} }, { children: [index === 0 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {})), (0, jsx_runtime_1.jsx)(TimelineDot_1.default, { variant: "outlined" }), index ===
                                                sortedRiskHistory.length -
                                                    1 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {}))] })), (0, jsx_runtime_1.jsx)(TimelineContent_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ square: true, style: {
                                                // borderLeft:
                                                // 	'6px solid #0071a4',
                                                padding: '0px 10px',
                                                height: '70px',
                                            } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                                                    height: '100%',
                                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                                                            margin: '0 12px 0 2px',
                                                        } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                                                                height: '100%',
                                                            } }, { children: (0, jsx_runtime_1.jsx)(NoteIcon_component_1.NoteIcon, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 10, item: true, container: true, alignItems: "center" }, { children: index ===
                                                            sortedRiskHistory.length -
                                                                1 ||
                                                            sortedRiskHistory.length ===
                                                                1
                                                            ? t('Risk value is {{value}}', {
                                                                value: risk.RISK,
                                                            })
                                                            : ChangedValueText(sortedRiskHistory[index +
                                                                1].RISK, risk.RISK) }))] })) })) })] }), index));
                        }) })) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(summaryze_1.ChartingErrorBoundary, __assign({ chartProps: optionsRiskTrend }, { children: (0, jsx_runtime_1.jsx)(Trend_styles_1.ChartContainer, { children: (0, jsx_runtime_1.jsx)(summaryze_1.Chart, { cy: 'risk-trend', dataCy: 'risk-trend', series: riskTrendSeries, options: optionsRiskTrend }) }) })) }))] }))) : ((0, jsx_runtime_1.jsx)("div", {}));
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Trend'), applyBodyPadding: !isReady }, { children: isReady ? trend : (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
};
exports.Trend = Trend;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Trend/Trend.styles.ts":
/*!*******************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Trend/Trend.styles.ts ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChartContainer = void 0;
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.ChartContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tpadding-bottom: 20px;\n\tpadding-top: 20px;\n\tmin-height: 0;\n\twidth: 100%;\n"], ["\n\tflex: 1 1 auto;\n\tpadding-bottom: 20px;\n\tpadding-top: 20px;\n\tmin-height: 0;\n\twidth: 100%;\n"])));
var templateObject_1;


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/Trend/index.ts":
/*!************************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/Trend/index.ts ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./Trend.component */ "./components/AssetDetails/DetailsRisk/Trend/Trend.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./NoteIcon.component */ "./components/AssetDetails/DetailsRisk/Trend/NoteIcon.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsRisk/index.ts":
/*!******************************************************!*\
  !*** ./components/AssetDetails/DetailsRisk/index.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./Overall */ "./components/AssetDetails/DetailsRisk/Overall/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskComponents */ "./components/AssetDetails/DetailsRisk/RiskComponents/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./Trend */ "./components/AssetDetails/DetailsRisk/Trend/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./DetailsRisk.component */ "./components/AssetDetails/DetailsRisk/DetailsRisk.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./NoDetailsRisk.component */ "./components/AssetDetails/DetailsRisk/NoDetailsRisk.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./MultiRiskDetails.component */ "./components/AssetDetails/DetailsRisk/MultiRiskDetails.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.component.tsx":
/*!*************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.component.tsx ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DetailsWorkHistory = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __webpack_require__(/*! react */ "react");
var TimelineOppositeContent_1 = __importStar(__webpack_require__(/*! @mui/lab/TimelineOppositeContent */ "@mui/lab/TimelineOppositeContent"));
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var NoDetailsWorkHistory_component_1 = __webpack_require__(/*! ./NoDetailsWorkHistory.component */ "./components/AssetDetails/DetailsWorkHistory/NoDetailsWorkHistory.component.tsx");
var Paper_1 = __importDefault(__webpack_require__(/*! @mui/material/Paper */ "@mui/material/Paper"));
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var DetailsWorkHistory_styles_1 = __webpack_require__(/*! ./DetailsWorkHistory.styles */ "./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.styles.tsx");
var Timeline_1 = __importDefault(__webpack_require__(/*! @mui/lab/Timeline */ "@mui/lab/Timeline"));
var TimelineConnector_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineConnector */ "@mui/lab/TimelineConnector"));
var TimelineContent_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineContent */ "@mui/lab/TimelineContent"));
var TimelineDot_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineDot */ "@mui/lab/TimelineDot"));
var TimelineItem_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineItem */ "@mui/lab/TimelineItem"));
var TimelineSeparator_1 = __importDefault(__webpack_require__(/*! @mui/lab/TimelineSeparator */ "@mui/lab/TimelineSeparator"));
var Typography_1 = __importDefault(__webpack_require__(/*! @mui/material/Typography */ "@mui/material/Typography"));
var WorkOrderIcon_component_1 = __webpack_require__(/*! ./WorkOrderIcon.component */ "./components/AssetDetails/DetailsWorkHistory/WorkOrderIcon.component.tsx");
var ValueMapping_1 = __webpack_require__(/*! ../DetailsOverview/ValueMapping */ "./components/AssetDetails/DetailsOverview/ValueMapping.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var AssetDetails_component_1 = __webpack_require__(/*! ../AssetDetails.component */ "./components/AssetDetails/AssetDetails.component.tsx");
var _Utilsluxon_1 = __webpack_require__(/*! @Utilsluxon */ "./utilsluxon/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var DetailsWorkHistory = function (_a) {
    var _b;
    var _c;
    var actions = _a.actions;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var t = (0, _Translations_1.useGlobalization)().t;
    var isWaiting = (0, _Selectors_1.selectInspectionsIsWaiting)();
    var inspAttributeList = (_c = (0, _Selectors_1.selectInspections)()) === null || _c === void 0 ? void 0 : _c.inspectionAttributes;
    var hasWorkHistory = (0, react_1.useMemo)(function () {
        if (inspAttributeList)
            return (inspAttributeList.findIndex(function (inspAttributes) {
                return !(inspAttributes === null || inspAttributes === void 0 ? void 0 : inspAttributes.event);
            }) !== -1);
        else
            return false;
    }, [inspAttributeList]);
    var handleOpen = function (videoURL, inspID, inspVersion) {
        if (actions && actions.onInspectionDetailClicked) {
            // Translate the version to the standard
            var standard = (0, AssetDetails_component_1.getStandardFromVersion)(inspVersion, false);
            actions.onInspectionDetailClicked(videoURL, inspID, standard);
        }
    };
    var handleOpenTask = function (taskID, inspVersion) {
        if (actions && actions.onTaskDetailClicked) {
            // Translate the version to the standard
            actions.onTaskDetailClicked(taskID, inspVersion);
        }
    };
    var getRow = function (inspAttributes) {
        if (inspAttributes.task) {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                    height: '100%',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                            margin: '0 12px 0 2px',
                        } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                                height: '100%',
                            } }, { children: (0, jsx_runtime_1.jsx)(WorkOrderIcon_component_1.WorkOrderIcon, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 3, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                name: 'taskId',
                            }, textField: {
                                label: t('Task ID'),
                            } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                name: 'taskTypeName',
                            }, textField: {
                                label: t('Task Type'),
                            } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                name: 'scheduled',
                            }, textField: {
                                label: t('Scheduled Date'),
                            } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                name: 'completed',
                            }, textField: {
                                label: t('Completed Date'),
                            } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "flex-end", style: {
                                height: '100%',
                            } }, { children: (0, jsx_runtime_1.jsx)(DetailsWorkHistory_styles_1.StyledButton, __assign({ size: "small", onClick: function () {
                                    handleOpenTask(inspAttributes._id, inspAttributes.inspectionVersion);
                                } }, { children: t('View Details >') })) })) }))] })));
        }
        else if (!inspAttributes.event) {
            var standard = (0, AssetDetails_component_1.getStandardFromVersion)(inspAttributes.inspectionVersion, false);
            switch (standard) {
                case inspection_types_1.InspectionStandard.WSA05:
                case inspection_types_1.InspectionStandard.MSCC:
                    {
                        return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                                height: '100%',
                            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                                        margin: '0 12px 0 2px',
                                    } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                                            height: '100%',
                                        } }, { children: (0, jsx_runtime_1.jsx)(WorkOrderIcon_component_1.WorkOrderIcon, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 3, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                            name: 'inspectionId',
                                        }, textField: {
                                            label: t('Inspection ID'),
                                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                            name: 'inspectionVersion',
                                        }, textField: {
                                            label: t('Inspection Type'),
                                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 3, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                            name: 'structuralGradeRating',
                                        }, textField: {
                                            label: t('Structural Grade'),
                                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                            name: 'serviceGradeRating',
                                        }, textField: {
                                            label: t('Service Grade'),
                                        } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "flex-end", style: {
                                            height: '100%',
                                        } }, { children: (0, jsx_runtime_1.jsx)(DetailsWorkHistory_styles_1.StyledButton, __assign({ size: "small", onClick: function () {
                                                handleOpen(inspAttributes.videoUrl
                                                    ? inspAttributes.videoUrl
                                                    : '', inspAttributes._id, inspAttributes.inspectionVersion);
                                            } }, { children: t('View Details >') })) })) }))] })));
                    }
                    break;
                default:
                    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: {
                            height: '100%',
                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, style: {
                                    margin: '0 12px 0 2px',
                                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "center", style: {
                                        height: '100%',
                                    } }, { children: (0, jsx_runtime_1.jsx)(WorkOrderIcon_component_1.WorkOrderIcon, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 3, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'inspectionId',
                                    }, textField: {
                                        label: t('Inspection ID'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'inspectionVersion',
                                    }, textField: {
                                        label: t('Inspection Type'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'overallRating',
                                    }, textField: {
                                        label: t('Overall Rating'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'structuralOverallRating',
                                    }, textField: {
                                        label: t('Structural Rating'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 1, item: true, container: true, alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                        name: 'serviceOverallRating',
                                    }, textField: {
                                        label: t('O&M'),
                                    } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, direction: "column", justifyContent: "center", alignItems: "flex-end", style: {
                                        height: '100%',
                                    } }, { children: (0, jsx_runtime_1.jsx)(DetailsWorkHistory_styles_1.StyledButton, __assign({ size: "small", onClick: function () {
                                            handleOpen(inspAttributes.videoUrl
                                                ? inspAttributes.videoUrl
                                                : '', inspAttributes._id, inspAttributes.inspectionVersion);
                                        } }, { children: t('View Details >') })) })) }))] })));
                    break;
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Work History'), applyBodyPadding: isWaiting }, { children: !isWaiting ? (hasWorkHistory ? ((0, jsx_runtime_1.jsx)(_Components_1.ShowMoreOverlay, __assign({ height: 220 }, { children: (0, jsx_runtime_1.jsx)(Timeline_1.default, __assign({ sx: (_b = {},
                    _b["& .".concat(TimelineOppositeContent_1.timelineOppositeContentClasses.root)] = {
                        flex: 0.2,
                    },
                    _b), style: {
                    paddingLeft: '11px',
                    paddingBottom: '25px',
                } }, { children: inspAttributeList === null || inspAttributeList === void 0 ? void 0 : inspAttributeList.filter(function (inspAttributes) { var _a; return (_a = !(inspAttributes === null || inspAttributes === void 0 ? void 0 : inspAttributes.event)) !== null && _a !== void 0 ? _a : true; }).map(function (inspAttributes, index) {
                    var _a, _b;
                    return ((0, jsx_runtime_1.jsxs)(TimelineItem_1.default, __assign({ style: { paddingLeft: 0 } }, { children: [(0, jsx_runtime_1.jsxs)(TimelineOppositeContent_1.default, __assign({ style: {
                                    flex: 0.2,
                                    maxWidth: '200px',
                                    paddingLeft: 0,
                                    paddingTop: '28px',
                                } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "body1", color: "textPrimary" }, { children: (0, _Utils_1.formatDateTimeWithFormatDate)(inspAttributes.surveyDateTime, formatDateUTC) })), (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ style: {
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                        }, color: "textSecondary" }, { children: (0, _Utilsluxon_1.getTimeDifferenceText)(new Date(inspAttributes.surveyDateTime), companySettings) }))] })), (0, jsx_runtime_1.jsxs)(TimelineSeparator_1.default, __assign({ style: index === 0
                                    ? {
                                        paddingTop: '27px',
                                    }
                                    : index ===
                                        inspAttributeList.length -
                                            1
                                        ? {
                                            paddingBottom: '27px',
                                        }
                                        : {} }, { children: [index === 0 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {})), (0, jsx_runtime_1.jsx)(TimelineDot_1.default, { variant: "outlined" }), index ===
                                        inspAttributeList.length -
                                            1 ? null : ((0, jsx_runtime_1.jsx)(TimelineConnector_1.default, {}))] })), (0, jsx_runtime_1.jsx)(TimelineContent_1.default, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: "view", initialValues: __assign(__assign({}, inspAttributes.ratings), { inspectionVersion: inspAttributes.inspectionVersion, inspectionId: inspAttributes.inspectionId, taskId: inspAttributes.taskId, taskTypeName: inspAttributes.taskTypeName, completed: (0, _Utils_1.formatDateTimeWithFormatDate)((_a = (0, ValueMapping_1.extractValue)(inspAttributes.completedDate)) !== null && _a !== void 0 ? _a : '', formatDateUTC), scheduled: (0, _Utils_1.formatDateTimeWithFormatDate)((_b = (0, ValueMapping_1.extractValue)(inspAttributes.scheduledDate)) !== null && _b !== void 0 ? _b : '', formatDateUTC) }), onSubmit: function (data) {
                                        console.log('should update the data', data);
                                    } }, { children: function () {
                                        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, __assign({ square: true, style: {
                                                    padding: '0px 10px',
                                                    height: '70px',
                                                } }, { children: getRow(inspAttributes) })) }));
                                    } })) })] }), inspAttributes._id));
                }) })) }))) : ((0, jsx_runtime_1.jsx)(NoDetailsWorkHistory_component_1.NoDetailsWorkHistory, {}))) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.DetailsWorkHistory = DetailsWorkHistory;


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.styles.tsx":
/*!**********************************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.styles.tsx ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButton = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.StyledButton = (0, styled_components_1.default)(stylovyze_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: black;\n"], ["\n\tcolor: black;\n"])));
var templateObject_1;


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/NoDetailsWorkHistory.component.tsx":
/*!***************************************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/NoDetailsWorkHistory.component.tsx ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoDetailsWorkHistory = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var WorkHistoryIcon_component_1 = __webpack_require__(/*! ./WorkHistoryIcon.component */ "./components/AssetDetails/DetailsWorkHistory/WorkHistoryIcon.component.tsx");
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoDetailsWorkHistory = function () {
    var t = (0, _Translations_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: { paddingTop: '40px', paddingBottom: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(WorkHistoryIcon_component_1.WorkHistoryIcon, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No History to show') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('Once work orders are completed they will show up here.') })) }))] })));
};
exports.NoDetailsWorkHistory = NoDetailsWorkHistory;


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/WorkHistoryIcon.component.tsx":
/*!**********************************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/WorkHistoryIcon.component.tsx ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkHistoryIcon = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var WorkHistoryIcon = function () { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M73.7675 26.0457H64.5066C64.2769 26.0457 64.0738 26.1229 63.9278 26.269C63.7817 26.415 63.7045 26.6181 63.7045 26.8479C63.7045 27.0776 63.7817 27.2807 63.9278 27.4267C64.0738 27.5728 64.2769 27.65 64.5066 27.65H72.9001V78.5457H27.0914V27.65H35.4849C35.7147 27.65 35.9178 27.5728 36.0638 27.4267C36.2099 27.2807 36.2871 27.0776 36.2871 26.8479C36.2871 26.6181 36.2099 26.415 36.0638 26.269C35.9178 26.1229 35.7147 26.0457 35.4849 26.0457H26.2893C26.0595 26.0457 25.8564 26.1229 25.7104 26.269C25.5643 26.415 25.4871 26.6181 25.4871 26.8479V79.3479C25.4871 79.5776 25.5643 79.7807 25.7104 79.9267C25.8564 80.0728 26.0595 80.15 26.2893 80.15H73.7023C73.932 80.15 74.1352 80.0728 74.2812 79.9267C74.4272 79.7807 74.5045 79.5776 74.5045 79.3479V26.8616C74.5417 26.6451 74.452 26.4414 74.3174 26.2971C74.1798 26.1497 73.9788 26.0457 73.7675 26.0457Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" }), (0, jsx_runtime_1.jsx)("path", { d: "M52.8084 64.1113C52.4889 63.7919 52.0027 63.7919 51.6832 64.1113C51.3638 64.4308 51.3638 64.9171 51.6832 65.2365L59.1832 72.7365C59.8643 73.4176 60.7506 73.7587 61.6371 73.7587C62.5236 73.7587 63.4099 73.4176 64.091 72.7365C65.4519 71.3756 65.4564 69.1925 64.0897 67.8926L56.5258 60.3287C56.2063 60.0093 55.7201 60.0093 55.4006 60.3287C55.0812 60.6482 55.0812 61.1345 55.4006 61.4539L62.9006 68.9539C63.6239 69.6772 63.6246 70.8198 62.9027 71.544C62.11 72.2737 60.9643 72.2672 60.2432 71.5461L52.8084 64.1113Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" }), (0, jsx_runtime_1.jsxs)("mask", __assign({ id: "path-3-outside-1", maskUnits: "userSpaceOnUse", x: "31.9062", y: "35.2391", width: "36", height: "40", fill: "black" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "white", x: "31.9062", y: "35.2391", width: "36", height: "40" }), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z" })] })), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z", stroke: "#768D95", strokeWidth: "0.6", mask: "url(#path-3-outside-1)" }), (0, jsx_runtime_1.jsx)("path", { d: "M39.4632 30.5848H60.5284C60.7582 30.5848 60.9613 30.5075 61.1073 30.3615C61.2534 30.2155 61.3306 30.0123 61.3306 29.7826V23.9783C61.3306 23.7485 61.2534 23.5454 61.1073 23.3994C60.9613 23.2533 60.7582 23.1761 60.5284 23.1761H54.0659C53.6791 21.2771 52.0172 19.85 50.0284 19.85C48.0396 19.85 46.3777 21.2771 45.991 23.1761H39.4632C39.2335 23.1761 39.0304 23.2533 38.8843 23.3994C38.7383 23.5454 38.661 23.7485 38.661 23.9783V29.7826C38.661 29.9944 38.7654 30.1937 38.9088 30.337C39.0521 30.4804 39.2514 30.5848 39.4632 30.5848ZM40.2654 24.7804H46.7023C46.9321 24.7804 47.1352 24.7032 47.2812 24.5572C47.4273 24.4111 47.5045 24.208 47.5045 23.9783C47.5045 22.5635 48.6741 21.4543 50.0284 21.4543C51.3828 21.4543 52.5523 22.5635 52.5523 23.9783C52.5523 24.208 52.6296 24.4111 52.7756 24.5572C52.9217 24.7032 53.1248 24.7804 53.3545 24.7804H59.7915V28.9804H40.2654V24.7804Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" })] }))); };
exports.WorkHistoryIcon = WorkHistoryIcon;


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/WorkOrderIcon.component.tsx":
/*!********************************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/WorkOrderIcon.component.tsx ***!
  \********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkOrderIcon = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var WorkOrderIcon = function () { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M14.3573 13.007L14.7494 8.41995C15.7912 8.8167 16.7425 9.43155 17.5174 10.2088C18.9304 11.6218 19.8167 13.5708 19.8167 15.7169V16.9072H4.18097V15.7169C4.18097 12.3944 6.29466 9.53828 9.23898 8.42227H9.24362L9.63805 13.0093M9.64037 13.007L9.24826 8.30394C9.24826 7.62877 9.80742 7.0928 10.4826 7.0928H13.5174C14.1926 7.0928 14.7517 7.62877 14.7517 8.30394L14.3596 13.0139M2 16.9072H22", stroke: "#768D95", strokeWidth: "1.5", strokeMiterlimit: "10" }) }))); };
exports.WorkOrderIcon = WorkOrderIcon;


/***/ }),

/***/ "./components/AssetDetails/DetailsWorkHistory/index.ts":
/*!*************************************************************!*\
  !*** ./components/AssetDetails/DetailsWorkHistory/index.ts ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./DetailsWorkHistory.component */ "./components/AssetDetails/DetailsWorkHistory/DetailsWorkHistory.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./NoDetailsWorkHistory.component */ "./components/AssetDetails/DetailsWorkHistory/NoDetailsWorkHistory.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/InspDetails/InspDetails.component.tsx":
/*!***********************************************************************!*\
  !*** ./components/AssetDetails/InspDetails/InspDetails.component.tsx ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InspDetails = exports.mapInsertInspection = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
__webpack_require__(/*! ./InspDetails.component.style.css */ "./components/AssetDetails/InspDetails/InspDetails.component.style.css");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styles_2 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_player_1 = __importDefault(__webpack_require__(/*! react-player */ "react-player"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var fullInspection_actions_1 = __webpack_require__(/*! @Actions/fullInspection.actions */ "./actions/fullInspection.actions.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var observations_selectors_1 = __webpack_require__(/*! @Selectors/observations.selectors */ "./selectors/observations.selectors.ts");
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var ObservationSearchBar_1 = __importDefault(__webpack_require__(/*! @Components/ObservationSearchBar */ "./components/ObservationSearchBar/index.ts"));
var observations_actions_1 = __webpack_require__(/*! @Actions/observations.actions */ "./actions/observations.actions.ts");
var PACPInspectionProps_1 = __importDefault(__webpack_require__(/*! @Components/PACPInspectionProps */ "./components/PACPInspectionProps/index.ts"));
var MSCCInspectionProps_1 = __importDefault(__webpack_require__(/*! @Components/MSCCInspectionProps */ "./components/MSCCInspectionProps/index.ts"));
var ObservationNotes_1 = __importDefault(__webpack_require__(/*! @Components/ObservationNotes */ "./components/ObservationNotes/index.ts"));
var ObservationPhoto_1 = __importDefault(__webpack_require__(/*! @Components/ObservationPhoto */ "./components/ObservationPhoto/index.ts"));
var ObservationTable_1 = __importDefault(__webpack_require__(/*! @Components/ObservationTable */ "./components/ObservationTable/index.ts"));
var user_selectors_1 = __webpack_require__(/*! @Selectors/user.selectors */ "./selectors/user.selectors.ts");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var Ratings_1 = __importDefault(__webpack_require__(/*! @Components/Ratings */ "./components/Ratings/index.ts"));
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var MACPInspectionProps_1 = __importDefault(__webpack_require__(/*! @Components/MACPInspectionProps */ "./components/MACPInspectionProps/index.ts"));
var MACPPipesTab_1 = __webpack_require__(/*! ./MACPPipesTab */ "./components/AssetDetails/InspDetails/MACPPipesTab/index.ts");
var ValidationTable_1 = __importDefault(__webpack_require__(/*! @Components/ValidationTable */ "./components/ValidationTable/index.ts"));
var MACPComponentConditions_1 = __webpack_require__(/*! @Components/MACPComponentConditions */ "./components/MACPComponentConditions/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var WSA05InspectionProps_1 = __importDefault(__webpack_require__(/*! @Components/WSA05InspectionProps */ "./components/WSA05InspectionProps/index.ts"));
var mapInsertInspection = function (standard, inspectionId, classes, t) {
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 6, item: true, container: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Map'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes }, { children: (0, jsx_runtime_1.jsx)(_Components_1.MapInsertInspection, { standard: standard, inspectionId: inspectionId }) })) })) })) })));
};
exports.mapInsertInspection = mapInsertInspection;
var useStyles = (0, styles_2.makeStyles)(function () {
    return (0, styles_2.createStyles)({
        root: {
            flexGrow: 1,
            // padding: '21px' ,
        },
        subRoot: {
            '&::first': {
                marginLeft: 0,
            },
            flexGrow: 1,
            padding: '21px',
            margin: '1rem',
        },
        paper: {
            margin: '1rem',
            textAlign: 'center',
            backgroundColor: '#F1F4F4',
        },
        pipePaper: {
            margin: '1rem',
            textAlign: 'center',
        },
        carouselItem: {
            width: '80px',
            height: '80px',
            backgroundColor: '#F1F4F4',
        },
        switchText: {
            fontSize: '0.75rem',
        },
        map: {
            height: '685px',
            padding: '20px',
        },
        overflowAuto: {
            overflow: 'auto',
        },
    });
});
// InspDetails is currently a subset of Details in app_am_inspection.
// What is here is used in other repos EXCEPT app_am_inspections.
// Idealy functionality should be moved from app_am_inspection:Details
// into here as it is needed in app_am_assets/app_am_risk etc.
//
// eslint-disable-next-line @typescript-eslint/naming-convention
var InspDetails = function (_a) {
    var _b;
    var back = _a.back, standard = _a.standard, inspectionId = _a.inspectionId, pipeIdClicked = _a.pipeIdClicked;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var enableMediaTranscode = (0, stylovyze_1.useIsFeatureEnabled)('info-360-media-convert') !== undefined;
    (0, react_1.useEffect)(function () {
        dispatch((0, fullInspection_actions_1.getFullInsp)({
            standard: standard,
            inspectionId: inspectionId,
            formatDate: formatDate,
            formatDateUTC: formatDateUTC,
            enableMediaTranscode: enableMediaTranscode,
        }));
    }, [formatDate, dispatch, inspectionId, standard]);
    var notes = (0, fullInspection_selectors_1.selectNotes)();
    var _c = (0, react_1.useState)(), player = _c[0], setPlayer = _c[1];
    var jointOnly = (0, observations_selectors_1.selectJointOnly)();
    var continuousOnly = (0, observations_selectors_1.selectContinuousOnly)();
    var stepOnly = (0, observations_selectors_1.selectStepOnly)();
    var gradeFilters = (0, observations_selectors_1.selectGradeFilters)();
    var typeFilters = (0, observations_selectors_1.selectTypeFilters)();
    var hasErrors = (0, react_1.useState)(false)[0] /*setHasErrors*/;
    var _d = (0, react_1.useState)(true), readOnly = _d[0], setReadOnly = _d[1];
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var isNotesLoading = (0, fullInspection_selectors_1.selectNotesIsWaiting)();
    var mergedValidation = (0, fullInspection_selectors_1.selectMergedValidation)(standard);
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasViewerAccess = (0, shared_utils_1.viewerAccess)(subscriptions);
    var _e = (0, react_1.useState)(''), searchCode = _e[0], setSearchCode = _e[1];
    var onSearchSubmit = function (code) {
        setSearchCode(code);
    };
    var _f = (0, react_1.useState)(), mediaInspection = _f[0], setMediaInspection = _f[1];
    var _g = (0, react_1.useState)({ played: 0 }), playerTime = _g[0], setTime = _g[1];
    var _h = (0, react_1.useState)(0), savedTime = _h[0], setSavedTime = _h[1];
    var onPlayer = function (progress) {
        if (player) {
            setTime({
                played: progress.playedSeconds,
            });
        }
    };
    var classes = useStyles();
    var getUniqueCodes = function () {
        var observations = (0, observations_selectors_1.selectObservations)(standard);
        var codes = observations === null || observations === void 0 ? void 0 : observations.map(function (observation) {
            switch (standard) {
                case inspection_types_1.InspectionStandard.MACP:
                    return observation.macpCode;
                case inspection_types_1.InspectionStandard.MSCC:
                    return observation.code;
                case inspection_types_1.InspectionStandard.WSA05:
                    return observation.code;
                case inspection_types_1.InspectionStandard.PACP:
                default:
                    return observation.PACPCode;
            }
        });
        if (codes)
            return Array.from(new Set(codes));
        else
            return [];
    };
    var videoSeekTo = function (standard, defect) {
        var sTime = '';
        switch (standard) {
            case inspection_types_1.InspectionStandard.MACP:
                sTime = defect.vcrTime;
                break;
            case inspection_types_1.InspectionStandard.MSCC:
                sTime = defect.videoRef;
                break;
            case inspection_types_1.InspectionStandard.WSA05:
                sTime = defect.videoPosition;
                break;
            case inspection_types_1.InspectionStandard.PACP:
            default:
                sTime = defect.VCRTime;
                break;
        }
        if (sTime === null || sTime.length < 6)
            return;
        var sHour = sTime.substring(0, 2);
        var sMin = sTime.substring(2, 4);
        var sSec = sTime.substring(4, 6);
        var nSec = Number(sHour) * 360 + Number(sMin) * 60 + Number(sSec);
        setSavedTime(nSec);
        if (player)
            player.seekTo(nSec);
    };
    var onRowClick = function (standard, defect) {
        var _a, _b, _c;
        if (defect.mediaInspectionId &&
            defect.mediaInspectionId !== (mediaInspection === null || mediaInspection === void 0 ? void 0 : mediaInspection.mediaInspectionId)) {
            var newMediaInspection = (_a = inspection.mediaInspections) === null || _a === void 0 ? void 0 : _a.find(function (i) {
                return i.mediaId === defect.mediaInspectionId;
            });
            setMediaInspection({
                videoLocation: (_b = newMediaInspection === null || newMediaInspection === void 0 ? void 0 : newMediaInspection.videoLocation) !== null && _b !== void 0 ? _b : '',
                mediaInspectionId: (_c = newMediaInspection === null || newMediaInspection === void 0 ? void 0 : newMediaInspection.mediaId) !== null && _c !== void 0 ? _c : '',
            });
        }
        videoSeekTo(standard, defect);
    };
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (inspection) {
            setReadOnly(isLoading ||
                inspection.inspectionStatus == inspection_types_1.UploadStatus.Approved);
            if (inspection.mediaInspections &&
                inspection.mediaInspections.length > 0) {
                setMediaInspection({
                    videoLocation: (_a = inspection === null || inspection === void 0 ? void 0 : inspection.mediaInspections[0]) === null || _a === void 0 ? void 0 : _a.videoLocation,
                    mediaInspectionId: (_b = inspection === null || inspection === void 0 ? void 0 : inspection.mediaInspections[0]) === null || _b === void 0 ? void 0 : _b.mediaId,
                });
            }
        }
    }, [inspection, isLoading]);
    var getGradeTypes = function (standard) {
        switch (standard) {
            case inspection_types_1.InspectionStandard.MSCC:
            case inspection_types_1.InspectionStandard.WSA05:
                {
                    return [
                        {
                            id: _Types_1.FilterObservationGradeType.Struct,
                            caption: t('Struct.'),
                        },
                        {
                            id: _Types_1.FilterObservationGradeType.Service,
                            caption: t('Service'),
                        },
                    ];
                }
                break;
            case inspection_types_1.InspectionStandard.MACP:
            case inspection_types_1.InspectionStandard.PACP:
            default:
                {
                    return [
                        {
                            id: _Types_1.FilterObservationGradeType.Struct,
                            caption: t('Struct.'),
                        },
                        {
                            id: _Types_1.FilterObservationGradeType.OM,
                            caption: t('O&M'),
                        },
                    ];
                }
                break;
        }
    };
    var gradeFilterChange = function (value) {
        dispatch((0, observations_actions_1.setGradeFilters)(value.value));
    };
    var gradeTypeFilterChange = function (value) {
        dispatch((0, observations_actions_1.setTypeFilters)(value.value));
    };
    var filterWidth = 3;
    if (standard == inspection_types_1.InspectionStandard.MACP)
        filterWidth = 2;
    else if (standard == inspection_types_1.InspectionStandard.WSA05)
        filterWidth = 4;
    var observationsTab = ((0, jsx_runtime_1.jsx)(styles_1.FullPage, __assign({ style: { marginTop: '-20px', overflow: 'hidden' }, className: isLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ className: classes.root }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 7, item: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true, style: { paddingTop: '15px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ id: "observationSearchBar", elevation: 0, style: { height: '50px' } }, { children: (0, jsx_runtime_1.jsx)(ObservationSearchBar_1.default, { label: t('Search Code'), codes: getUniqueCodes(), handleSearchSubmit: onSearchSubmit }) })) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 8, item: true, container: true, justifyContent: "space-between" }, { children: [standard != inspection_types_1.InspectionStandard.WSA05 ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: filterWidth, item: true, paddingRight: '10px' }, { children: (0, jsx_runtime_1.jsx)(_Components_1.FilterSelect, { column: {
                                                        id: 'grade',
                                                        caption: t('Grade'),
                                                    }, value: gradeFilters, options: [
                                                        {
                                                            id: '1',
                                                            caption: t('Grade 1'),
                                                        },
                                                        {
                                                            id: '2',
                                                            caption: t('Grade 2'),
                                                        },
                                                        {
                                                            id: '3',
                                                            caption: t('Grade 3'),
                                                        },
                                                        {
                                                            id: '4',
                                                            caption: t('Grade 4'),
                                                        },
                                                        {
                                                            id: '5',
                                                            caption: t('Grade 5'),
                                                        },
                                                    ], onFilterChange: gradeFilterChange, fullWidth: true, multiple: true, dataCy: 'gradeFilter' }) }))) : ([]), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: filterWidth, item: true, paddingRight: '15px' }, { children: (0, jsx_runtime_1.jsx)(_Components_1.FilterSelect, { column: {
                                                        id: 'type',
                                                        caption: t('Type'),
                                                    }, value: typeFilters, options: getGradeTypes(standard), onFilterChange: gradeTypeFilterChange, fullWidth: true, multiple: true, dataCy: 'gradeTypeFilter' }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: filterWidth, item: true, container: true, textAlign: 'center' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, className: classes.switchText }, { children: t('Only Joint') })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Switch, { checked: jointOnly, onChange: function () {
                                                                dispatch((0, observations_actions_1.setJointOnly)(!jointOnly));
                                                            }, color: "primary", name: "checkedB", inputProps: {
                                                                'aria-label': 'primary checkbox',
                                                            }, size: "small" }) }))] })), standard == inspection_types_1.InspectionStandard.MACP ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: filterWidth, item: true, container: true, textAlign: 'center' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, className: classes.switchText }, { children: t('Only Step') })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Switch, { checked: stepOnly, onChange: function () {
                                                                dispatch((0, observations_actions_1.setStepOnly)(!stepOnly));
                                                            }, color: "primary", name: "checkedB", inputProps: {
                                                                'aria-label': 'primary checkbox',
                                                            }, size: "small" }) }))] }))) : ([]), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: filterWidth, item: true, container: true, textAlign: 'center' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, className: classes.switchText }, { children: t('Only Continuous') })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Switch, { checked: continuousOnly, onChange: function () {
                                                                dispatch((0, observations_actions_1.setContinuousOnly)(!continuousOnly));
                                                            }, color: "primary", name: "checkedB", inputProps: {
                                                                'aria-label': 'primary checkbox',
                                                            }, size: "small" }) }))] }))] }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ id: "ObservationTable", elevation: 0, className: classes.paper }, { children: (0, jsx_runtime_1.jsx)(ObservationTable_1.default, { standard: standard, observationsSelector: observations_selectors_1.selectObservations, getObservationAction: observations_actions_1.getObservations, inspectionId: inspectionId, onObservationRowClicked: onRowClick, getMediaInspectionId: function () { var _a; return (_a = mediaInspection === null || mediaInspection === void 0 ? void 0 : mediaInspection.mediaInspectionId) !== null && _a !== void 0 ? _a : ''; }, playerTime: playerTime.played, searchCode: searchCode, jointOnly: jointOnly, continuousOnly: continuousOnly, gradeFilters: gradeFilters, typeFilters: typeFilters, readOnly: readOnly, isLoading: isLoading }) })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 5, item: true, container: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ id: "VideoPlayer", elevation: 1, className: classes.paper, style: { height: '380px' } }, { children: (0, jsx_runtime_1.jsx)(react_player_1.default, { ref: function (PlayerInput) {
                                                setPlayer(PlayerInput);
                                            }, height: "100%", width: "100%", controls: true, onReady: function () {
                                                player === null || player === void 0 ? void 0 : player.seekTo(savedTime);
                                            }, url: mediaInspection === null || mediaInspection === void 0 ? void 0 : mediaInspection.videoLocation, onProgress: onPlayer }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(ObservationPhoto_1.default, { forEdit: false, observations: (_b = (0, fullInspection_selectors_1.selectFullInspectionConditions)()) !== null && _b !== void 0 ? _b : [], time: playerTime.played, getMediaInspectionId: function () { var _a; return (_a = mediaInspection === null || mediaInspection === void 0 ? void 0 : mediaInspection.mediaInspectionId) !== null && _a !== void 0 ? _a : ''; } }) }))] })) }))] })) })) })));
    var userContext = (0, user_selectors_1.selectUserContext)();
    var onSubmitNote = function (newNotes, userInitial) {
        dispatch((0, fullInspection_actions_1.addNote)({
            _id: inspectionId,
            note: newNotes,
            name: userContext.name,
            initial: userInitial,
        }));
    };
    var pacpDetailsTab = ((0, jsx_runtime_1.jsx)("div", __assign({ className: isLoading || isNotesLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, style: { marginTop: '-35px' } }, { children: [(0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                    ? (0, exports.mapInsertInspection)(standard, inspectionId !== null && inspectionId !== void 0 ? inspectionId : '', classes.map, t)
                    : [], (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                        ? 6
                        : 12, item: true, container: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Ratings'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(Ratings_1.default, { standard: standard, ratings: inspection.ratings, mainScoreCardHeight: 116 }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, style: { paddingTop: '15px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes') }, { children: (0, jsx_runtime_1.jsx)(ObservationNotes_1.default, { Notes: notes, onSubmit: onSubmitNote, readOnly: hasViewerAccess, isWaiting: isLoading, keepHeightWhenWaiting: true, waitingHeight: '314px', bodyHeight: hasViewerAccess ? '314px' : '216px', entryHeight: hasViewerAccess ? '0px' : '90px' }) })) }))] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties'), applyBodyPadding: isLoading }, { children: (0, jsx_runtime_1.jsx)(PACPInspectionProps_1.default, {}) })) }))] })) })));
    var macpDetailsTab = ((0, jsx_runtime_1.jsx)("div", __assign({ className: isLoading || isNotesLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, style: { marginTop: '-35px' } }, { children: [(0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                    ? (0, exports.mapInsertInspection)(standard, inspectionId !== null && inspectionId !== void 0 ? inspectionId : '', classes.map, t)
                    : [], (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                        ? 6
                        : 12, item: true, container: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Component Conditions'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(MACPComponentConditions_1.MACPComponentConditions, { fullInsp: inspection }) })) })) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 6, item: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes') }, { children: (0, jsx_runtime_1.jsx)(ObservationNotes_1.default, { Notes: notes, onSubmit: onSubmitNote, readOnly: hasViewerAccess, keepHeightWhenWaiting: true, waitingHeight: '221px', bodyHeight: hasViewerAccess ? '221px' : '139px', entryHeight: hasViewerAccess ? '0px' : '90px', isWaiting: isLoading }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 6, item: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Ratings'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(Ratings_1.default, { standard: standard, ratings: inspection.ratings, mainScoreCardHeight: 116 }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties'), applyBodyPadding: isLoading }, { children: (0, jsx_runtime_1.jsx)(MACPInspectionProps_1.default, {}) })) }))] })) })));
    var msccDetailsTab = ((0, jsx_runtime_1.jsx)("div", __assign({ className: isLoading || isNotesLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, style: { marginTop: '-35px' } }, { children: [(0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                    ? (0, exports.mapInsertInspection)(standard, inspectionId !== null && inspectionId !== void 0 ? inspectionId : '', classes.map, t)
                    : [], (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                        ? 6
                        : 12, item: true, container: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Ratings'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(Ratings_1.default, { standard: standard, ratings: inspection.ratings, mainScoreCardHeight: 116 }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, style: { paddingTop: '15px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes') }, { children: (0, jsx_runtime_1.jsx)(ObservationNotes_1.default, { Notes: notes, onSubmit: onSubmitNote, readOnly: hasViewerAccess, isWaiting: isLoading, keepHeightWhenWaiting: true, waitingHeight: '417px', bodyHeight: hasViewerAccess ? '417px' : '335px', entryHeight: hasViewerAccess ? '0px' : '90px' }) })) }))] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties'), applyBodyPadding: isLoading }, { children: (0, jsx_runtime_1.jsx)(MSCCInspectionProps_1.default, {}) })) }))] })) })));
    var wsa05DetailsTab = ((0, jsx_runtime_1.jsx)("div", __assign({ className: isLoading || isNotesLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, style: { marginTop: '-35px' } }, { children: [(0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                    ? (0, exports.mapInsertInspection)(standard, inspectionId !== null && inspectionId !== void 0 ? inspectionId : '', classes.map, t)
                    : [], (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-dashboard-map')
                        ? 6
                        : 12, item: true, container: true, style: { paddingBottom: '0' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Ratings'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)(Ratings_1.default, { standard: standard, ratings: inspection.ratings, mainScoreCardHeight: 116 }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true, style: { paddingTop: '15px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes') }, { children: (0, jsx_runtime_1.jsx)(ObservationNotes_1.default, { Notes: notes, onSubmit: onSubmitNote, readOnly: hasViewerAccess, keepHeightWhenWaiting: true, waitingHeight: '417px', bodyHeight: hasViewerAccess ? '417px' : '335px', entryHeight: hasViewerAccess ? '0px' : '90px', isWaiting: isLoading }) })) }))] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties'), applyBodyPadding: isLoading }, { children: (0, jsx_runtime_1.jsx)(WSA05InspectionProps_1.default, {}) })) }))] })) })));
    var validationTab = ((0, jsx_runtime_1.jsx)(styles_1.FullPage, __assign({ style: { marginTop: '-20px', overflow: 'hidden' }, className: isLoading ? 'wait' : '' }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 2 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(ValidationTable_1.default, { dataCy: "validation-table", validationData: mergedValidation }) })) })) })));
    var getTabs = function () {
        var tabs = [];
        var content = null;
        switch (standard) {
            case inspection_types_1.InspectionStandard.MACP:
                content = macpDetailsTab;
                break;
            case inspection_types_1.InspectionStandard.MSCC:
                content = msccDetailsTab;
                break;
            case inspection_types_1.InspectionStandard.WSA05:
                content = wsa05DetailsTab;
                break;
            case inspection_types_1.InspectionStandard.PACP:
            default:
                content = pacpDetailsTab;
                break;
        }
        tabs = [
            { content: observationsTab, title: t('Observations') },
            {
                content: content,
                title: t('Details'),
            },
            {
                content: validationTab,
                title: t('Validation'),
                disabled: mergedValidation === undefined ||
                    mergedValidation.length === 0,
                icon: hasErrors ? (0, jsx_runtime_1.jsx)(icons_material_1.Error, {}) : [],
            },
        ];
        if (standard == inspection_types_1.InspectionStandard.MACP)
            tabs.push({
                content: ((0, jsx_runtime_1.jsx)(MACPPipesTab_1.MACPPipesTab, { macpInsp: inspection, pipeIdClick: pipeIdClicked })),
                title: t('Pipes'),
            });
        return tabs;
    };
    var goBack = function () {
        dispatch((0, observations_actions_1.clearFilters)());
        dispatch((0, observations_actions_1.clearObservations)());
        back.action();
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, { className: classes.overflowAuto, back: {
            action: goBack,
            label: back.label,
        }, title: t('Inspection: {{ID}}', { ID: inspection.inspectionId }), applyPadding: true, headerUnderline: true, secondaryNav: {
            items: getTabs(),
        } }));
};
exports.InspDetails = InspDetails;
exports["default"] = exports.InspDetails;


/***/ }),

/***/ "./components/AssetDetails/InspDetails/MACPPipesTab/MACPPipesTab.component.tsx":
/*!*************************************************************************************!*\
  !*** ./components/AssetDetails/InspDetails/MACPPipesTab/MACPPipesTab.component.tsx ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MACPPipesTab = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var assetDetail_selectors_1 = __webpack_require__(/*! @Selectors/assetDetail.selectors */ "./selectors/assetDetail.selectors.ts");
var assetDetail_actions_1 = __webpack_require__(/*! @Actions/assetDetail.actions */ "./actions/assetDetail.actions.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var MACPPipesTab = function (_a) {
    var macpInsp = _a.macpInsp, pipeIdClick = _a.pipeIdClick;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        if (macpInsp != undefined && macpInsp.connections != undefined) {
            var pipeIds_1 = macpInsp.connections.map(function (connection) { return connection.structureId; });
            pipeIds_1.filter(function (id, index) { return id != '' && pipeIds_1.indexOf(id) == index; });
            if (pipeIds_1.length > 0) {
                var payload = {
                    assetType: 'wwPipe',
                    assetId: pipeIds_1,
                };
                dispatch((0, assetDetail_actions_1.checkAssetIds)(payload));
            }
        }
    }, [macpInsp]);
    var validIds = (0, assetDetail_selectors_1.selectValidAssetIds)();
    var headers = [
        {
            cell: t('Pipe No.'),
            dataCy: 'col-Pipe No.',
            key: 'Pipe No.',
            padding: '0 10px',
        },
        {
            cell: t('Clock position'),
            dataCy: 'col-Clock position',
            key: 'Clock position',
            padding: '0 10px',
        },
        {
            cell: t('Rim to Invert'),
            dataCy: 'col-Rim to Invert',
            key: 'Rim to Invert',
            padding: '0 10px',
        },
        {
            cell: t('Material'),
            dataCy: 'col-Material',
            key: 'Material',
            padding: '0 10px',
        },
        {
            cell: t('Shape'),
            dataCy: 'col-Shape',
            key: 'Shape',
            padding: '0 10px',
        },
        {
            cell: t('Height'),
            dataCy: 'col-Height',
            key: 'Height',
            padding: '0 10px',
        },
        {
            cell: t('Width'),
            dataCy: 'col-Width',
            key: 'Width',
            padding: '0 10px',
        },
        {
            cell: t('Condition'),
            dataCy: 'col-Condition',
            key: 'Condition',
            padding: '0 10px',
        },
        {
            cell: t('Seal Cond.'),
            dataCy: 'col-Seal Cond.',
            key: 'Seal Cond.',
            padding: '0 10px',
        },
        {
            cell: t('Type'),
            dataCy: 'col-Type',
            key: 'Type',
            padding: '0 10px',
        },
        {
            cell: t('Struct. Id'),
            dataCy: 'col-Struct. Id',
            key: 'Struct. Id',
            padding: '0 10px',
        },
        {
            cell: t('Comments'),
            dataCy: 'col-Comments',
            key: 'Comments',
            padding: '0 10px',
        },
    ];
    var getStructureIdLink = function (structureId) {
        if (validIds &&
            (validIds === null || validIds === void 0 ? void 0 : validIds.length) > 0 &&
            validIds.find(function (id) { return id == structureId; }) != undefined) {
            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                }, title: structureId, onClick: function () {
                    if (pipeIdClick)
                        pipeIdClick(structureId);
                } }, { children: structureId })));
        }
        else {
            return structureId;
        }
    };
    var incomingRows = macpInsp.connections != undefined
        ? macpInsp.connections
            .filter(function (connection) { var _a; return ((_a = connection.direction) === null || _a === void 0 ? void 0 : _a.toUpperCase()) == 'I'; })
            .map(function (connection) { return ({
            cells: [
                connection.pipeNumber,
                connection.clockPosition,
                (0, jsx_runtime_1.jsx)(stylovyze_1.UnitDisplay, { value: "".concat(connection.rimToInvert.toString(), " m") }, "rimToInvert"),
                connection.material,
                connection.shape,
                connection.height,
                connection.width,
                connection.pipeCondition,
                connection.pipeSealCondition,
                connection.pipeType,
                getStructureIdLink(connection.structureId),
                connection.pipeComments,
            ],
            dataCy: 'row' + connection.connectionId,
            key: connection.connectionId,
        }); })
        : [];
    var outgoingRows = macpInsp.connections != undefined
        ? macpInsp.connections
            .filter(function (connection) { var _a; return ((_a = connection.direction) === null || _a === void 0 ? void 0 : _a.toUpperCase()) == 'O'; })
            .map(function (connection) { return ({
            cells: [
                connection.pipeNumber,
                connection.clockPosition,
                (0, jsx_runtime_1.jsx)(stylovyze_1.UnitDisplay, { value: "".concat(connection.rimToInvert.toString(), " m") }, "rimToInvert"),
                connection.material,
                connection.shape,
                connection.height,
                connection.width,
                connection.pipeCondition,
                connection.pipeSealCondition,
                connection.pipeType,
                getStructureIdLink(connection.structureId),
                connection.pipeComments,
            ],
            dataCy: 'row' + connection.connectionId,
            key: connection.connectionId,
        }); })
        : [];
    var incoming = ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Incoming'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: "defect-table", headers: headers, rows: incomingRows, useSkeleton: { rowCount: 10 } }) }) })));
    var outgoing = ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Outgoing'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: "defect-table", headers: headers, rows: outgoingRows, useSkeleton: { rowCount: 10 } }) }) })));
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: incoming })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: outgoing }))] })));
};
exports.MACPPipesTab = MACPPipesTab;
exports["default"] = exports.MACPPipesTab;


/***/ }),

/***/ "./components/AssetDetails/InspDetails/MACPPipesTab/index.ts":
/*!*******************************************************************!*\
  !*** ./components/AssetDetails/InspDetails/MACPPipesTab/index.ts ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./MACPPipesTab.component */ "./components/AssetDetails/InspDetails/MACPPipesTab/MACPPipesTab.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/InspDetails/index.tsx":
/*!*******************************************************!*\
  !*** ./components/AssetDetails/InspDetails/index.tsx ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var InspDetails_component_1 = __webpack_require__(/*! ./InspDetails.component */ "./components/AssetDetails/InspDetails/InspDetails.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(InspDetails_component_1).default; } }));
__exportStar(__webpack_require__(/*! ./InspDetails.component */ "./components/AssetDetails/InspDetails/InspDetails.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/TaskDetails/TaskDetails.component.tsx":
/*!***********************************************************************!*\
  !*** ./components/AssetDetails/TaskDetails/TaskDetails.component.tsx ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TaskDetails = exports.getConfigurationBasedValue = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var AssetDetails_styles_1 = __webpack_require__(/*! ../AssetDetails.styles */ "./components/AssetDetails/AssetDetails.styles.tsx");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var __1 = __webpack_require__(/*! ../.. */ "./components/index.ts");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var TaskDetailsProps_component_1 = __importDefault(__webpack_require__(/*! ./TaskDetailsProps.component */ "./components/AssetDetails/TaskDetails/TaskDetailsProps.component.tsx"));
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var getConfigurationBasedValue = function (value, formatDateUTC, mapping) {
    var _a, _b, _c;
    var displayValue = value;
    var displayType = 'text';
    if (value.length !== 0 && mapping) {
        switch (mapping.unit) {
            // Seems currency will not work as expected
            // case 'currency':
            // 	displayType = 'currency';
            // 	break;
            case 'integer':
            case 'float':
                if (mapping.usage.length == 0) {
                    displayType = 'number';
                    break;
                }
                else {
                    var displayUnit = (0, _Utils_1.unitMapping)(mapping.usage);
                    switch (displayUnit) {
                        case _Utils_1.UNITS.AMPS:
                        case _Utils_1.UNITS.REVOLUTIONS_PER_MIN:
                            displayValue = "".concat(value, " ").concat(displayUnit);
                            break;
                        case _Utils_1.UNITS.NONE:
                            break;
                        default:
                            displayValue = "".concat(value, " ").concat(displayUnit);
                            displayType = 'unit';
                            break;
                    }
                }
                break;
            case 'date':
                // Options are time, dateyear, datetime(import version which we dont care about) and date(import version which we dont care about)
                if (mapping.incomingUnit == 'time') {
                    // Convert the value
                    displayValue =
                        (_a = (0, _Utils_1.formatTimeWithFormatDate)(value
                            ? // This is to work around the filtering for null dates
                                value.replace('1111-', new Date().getFullYear() + '-')
                            : '', formatDateUTC)) !== null && _a !== void 0 ? _a : '';
                }
                else if (mapping.incomingUnit == 'dateyear') {
                    // Extact the year
                    if (value.trim().length > 4 &&
                        !value.startsWith('1111-11-11')) {
                        displayValue = value.substring(0, 4);
                    }
                    else {
                        displayValue = '';
                    }
                    displayType = 'number';
                }
                else if (mapping.incomingUnit.startsWith('datetime')) {
                    // Convert the value to give the correct time
                    displayValue =
                        (_b = (0, _Utils_1.formatDateTimeWithFormatDate)(value, formatDateUTC)) !== null && _b !== void 0 ? _b : '';
                }
                else {
                    // Convert the value to give the correct date
                    displayValue =
                        (_c = (0, _Utils_1.formatDateWithFormatDate)(value, formatDateUTC)) !== null && _c !== void 0 ? _c : '';
                }
                break;
        }
    }
    else {
        displayValue = '-';
    }
    return { displayValue: displayValue, displayType: displayType };
};
exports.getConfigurationBasedValue = getConfigurationBasedValue;
// eslint-disable-next-line @typescript-eslint/naming-convention
var TaskDetails = function (_a) {
    var back = _a.back, taskType = _a.taskType, taskId = _a.taskId, onReRender = _a.onReRender, taskTypeName = _a.taskTypeName, type = _a.type;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var classes = (0, AssetDetails_styles_1.useStyle)();
    var isLoading = (0, _Selectors_1.selectFullInspectionIsWaiting)();
    var userContext = (0, _Selectors_1.selectUserContext)();
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-tasks')
        ? true
        : false;
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasViewerAccess = (0, shared_utils_1.viewerAccess)(subscriptions);
    var config = (0, _Selectors_1.useSelectConfigurationDetails)(taskType);
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.getFullInsp)({
            standard: taskType,
            inspectionId: taskId,
            formatDate: formatDate,
            formatDateUTC: formatDateUTC,
            enableMediaTranscode: false,
        }));
    }, [formatDate, taskId, taskType]);
    (0, react_1.useEffect)(function () {
        if (taskType) {
            var configType = 'tasks';
            if (type === _Types_1.TaskType.Event)
                configType = 'events';
            if (config === undefined) {
                dispatch((0, _Actions_1.getConfigurationWithUploadId)({
                    type: configType,
                    uploadId: taskType,
                }));
            }
        }
    }, [taskType]);
    var inspection = (0, _Selectors_1.selectFullInspection)();
    var notes = (0, _Selectors_1.selectNotes)();
    var onSubmitNote = function (newNotes, userInitial) {
        dispatch((0, _Actions_1.addNote)({
            _id: taskId,
            note: newNotes,
            name: userContext.name,
            initial: userInitial,
        }));
    };
    var secondaryButton = function () {
        if (isEditAllowedFlag && inspection && !isLoading) {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, container: true, alignItems: "center", justifyContent: "flex-end", "data-cy": "grid-actionbutton", wrap: "nowrap" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ title: "Refresh", "data-cy": "refreshButton", onClick: onReRender, size: "large" }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Refresh, {}) })) })));
        }
    };
    var getTitle = function () {
        var typeName = taskTypeName;
        if (typeName === undefined && config !== undefined) {
            typeName = config.userDataType;
        }
        if (type === _Types_1.TaskType.Event) {
            return t('{{Name}}: {{ID}}', {
                Name: typeName !== null && typeName !== void 0 ? typeName : t('Event'),
                ID: inspection.eventId,
            });
        }
        else {
            return t('{{Name}}: {{ID}}', {
                Name: typeName !== null && typeName !== void 0 ? typeName : t('Task'),
                ID: inspection.taskId,
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, __assign({ className: isLoading ? classes.rootWait : classes.root, applyPadding: true, title: getTitle(), back: back, headerUnderline: true, secondary: secondaryButton() }, { children: (0, jsx_runtime_1.jsxs)(AssetDetails_styles_1.GridContainer, { children: [(0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6, rows: 2 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Map') }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { height: '637px' } }, { children: (0, jsx_runtime_1.jsx)(__1.MapInsertAsset, {}) })) })) })), (0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 6 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Notes') }, { children: (0, jsx_runtime_1.jsx)(__1.ObservationNotes, { Notes: notes, onSubmit: onSubmitNote, readOnly: hasViewerAccess, isWaiting: isLoading, keepHeightWhenWaiting: true, waitingHeight: '637px', bodyHeight: hasViewerAccess ? '637px' : '555px', entryHeight: hasViewerAccess ? '0px' : '90px' }) })) })), (0, jsx_runtime_1.jsx)(AssetDetails_styles_1.GridItem, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Properties') }, { children: (0, jsx_runtime_1.jsx)(TaskDetailsProps_component_1.default, { taskType: taskType, readonly: !isEditAllowedFlag || hasViewerAccess, onReRender: onReRender, type: type !== null && type !== void 0 ? type : _Types_1.TaskType.Task }) })) }))] }) })));
};
exports.TaskDetails = TaskDetails;


/***/ }),

/***/ "./components/AssetDetails/TaskDetails/TaskDetailsProps.component.tsx":
/*!****************************************************************************!*\
  !*** ./components/AssetDetails/TaskDetails/TaskDetailsProps.component.tsx ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TaskDetailsProps = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var ModifiedInfoCard_1 = __importDefault(__webpack_require__(/*! @Components/ModifiedInfoCard/ModifiedInfoCard */ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx"));
var common_utils_1 = __webpack_require__(/*! @Utils/common.utils */ "./utils/common.utils.tsx");
var fullInspection_types_1 = __webpack_require__(/*! @Types/fullInspection.types */ "./types/fullInspection.types.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var NON_EDITABLE_FIELDS = ['uploadedBy', 'uploadDateTime'];
var isEditableField = function (fieldName) {
    return !NON_EDITABLE_FIELDS.includes(fieldName);
};
var TaskDetailsProps = function (_a) {
    var taskType = _a.taskType, readonly = _a.readonly, type = _a.type, onReRender = _a.onReRender;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var _b = react_1.default.useState(false), formSubmitted = _b[0], setFormSubmitted = _b[1];
    var _c = react_1.default.useState(false), editDetails = _c[0], setEditDetails = _c[1];
    var _d = react_1.default.useState(0), tabValue = _d[0], setTabValue = _d[1];
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasViewerAccess = (0, shared_utils_1.viewerAccess)(subscriptions);
    var config = (0, _Selectors_1.useSelectConfiguration)(taskType);
    // const details = useSelectConfigurationDetails(taskType);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    var getMandatoryFields = function () {
        if (type === inspection_types_1.TaskType.Event)
            return (0, fullInspection_types_1.getEventMandatoryFields)(t);
        else
            return (0, fullInspection_types_1.getTaskMandatoryFields)(t);
    };
    var getOptionalFields = function () {
        if (type === inspection_types_1.TaskType.Event)
            return (0, fullInspection_types_1.getEventOptionalFields)(t);
        else
            return (0, fullInspection_types_1.getTaskOptionalFields)(t);
    };
    var getIgnoredFields = function () {
        if (type === inspection_types_1.TaskType.Event)
            return fullInspection_types_1.eventIgnoreFields;
        else
            return fullInspection_types_1.taskIgnoreFields;
    };
    // Booleans are not yet supported by the task mapping
    var booleanFields = {};
    var unitFields = (0, react_1.useMemo)(function () {
        var newUnitFields = {};
        if (config && config.length !== 0) {
            config.forEach(function (mapping) {
                switch (mapping.unit) {
                    case 'integer':
                    case 'float':
                        if (mapping.usage.length != 0) {
                            var displayUnit = (0, _Utils_1.unitMapping)(mapping.usage);
                            if (displayUnit !== _Utils_1.UNITS.NONE)
                                newUnitFields[mapping.target] = {
                                    unit: displayUnit,
                                };
                        }
                        break;
                }
            });
        }
        return newUnitFields;
    }, [config]);
    var currencyFields = (0, react_1.useMemo)(function () {
        var newCurrencyFields = {};
        if (config && config.length !== 0) {
            config.forEach(function (mapping) {
                switch (mapping.unit) {
                    case 'currency':
                        newCurrencyFields[mapping.target] = {};
                        break;
                }
            });
        }
        return newCurrencyFields;
    }, [config]);
    var numericFields = (0, react_1.useMemo)(function () {
        var newNumericFields = {};
        if (config && config.length !== 0) {
            config.forEach(function (mapping) {
                switch (mapping.unit) {
                    case 'integer':
                    case 'float':
                        if (mapping.usage.length == 0) {
                            newNumericFields[mapping.target] = {};
                            break;
                        }
                        break;
                    case 'date':
                        if (mapping.incomingUnit == 'dateyear') {
                            // Years are handled as numerics
                            newNumericFields[mapping.target] = {
                                min: 0,
                                max: 9999,
                                step: 1,
                            };
                        }
                        break;
                }
            });
        }
        return newNumericFields;
    }, [config]);
    var dateTimeFields = (0, react_1.useMemo)(function () {
        var newDateTimeFields = {};
        if (config && config.length !== 0) {
            config.forEach(function (mapping) {
                switch (mapping.unit) {
                    case 'date':
                        // Options are time, dateyear, datetime(import version which we dont care about) and date(import version which we dont care about)
                        if (mapping.incomingUnit == 'time') {
                            newDateTimeFields[mapping.target] = {
                                mode: stylovyze_1.DateTimeInputMode.TIME,
                                field: mapping.target,
                            };
                        }
                        else if (mapping.incomingUnit.startsWith('datetime')) {
                            newDateTimeFields[mapping.target] = {
                                mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
                                field: mapping.target,
                            };
                        }
                        else if (mapping.incomingUnit !== 'dateyear') {
                            newDateTimeFields[mapping.target] = {
                                mode: stylovyze_1.DateTimeInputMode.DATE,
                                field: mapping.target,
                            };
                        }
                        break;
                }
            });
        }
        return newDateTimeFields;
    }, [config]);
    var taskFields = (0, react_1.useMemo)(function () {
        var fields = [];
        if (config && config.length !== 0) {
            // First we need to sort the order of the config using the mandatory and option fields
            var optionalFields_1 = getOptionalFields();
            var mappingFields = config.map(function (mapping) {
                var field = optionalFields_1[mapping.target];
                if (field) {
                    return __assign(__assign({}, mapping), { label: field });
                }
                else {
                    return __assign(__assign({}, mapping), { label: mapping.target });
                }
            });
            var mandatoryFields_1 = getMandatoryFields();
            // Mandatory items first
            Object.keys(mandatoryFields_1).forEach(function (key) {
                var mapping = config.find(function (mapping) { return mapping.target == key; });
                if (mapping) {
                    var realKey = key;
                    // Some messing around with relatedAssetId as it or assetId may not exist
                    // assetId may not exist if there is no actual related asset
                    if (realKey === 'relatedAssetId' && inspection['assetId']) {
                        realKey = 'assetId';
                    }
                    fields.push({
                        name: mapping.target,
                        alias: mandatoryFields_1[key],
                    });
                }
            });
            var ignoredFields_1 = getIgnoredFields();
            mappingFields
                .sort(function (a, b) { return a.label.localeCompare(b.label); })
                .forEach(function (mapping) {
                // Filter out ignored fields
                if (!ignoredFields_1.find(function (field) { return field === mapping.target; })) {
                    fields.push({
                        name: mapping.target,
                        alias: mapping.label,
                    });
                }
            });
        }
        return fields;
    }, [config]);
    var origDetails = (0, react_1.useMemo)(function () {
        setFormSubmitted(false);
        var values = (0, _Utils_1.getTaskValues)(inspection, false);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            if (Object.entries(dateTimeFields).find(function (value) { return value[1].field === key; })) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key]);
            }
        });
        return values;
    }, [inspection]);
    var viewDetails = (0, react_1.useMemo)(function () {
        var values = (0, _Utils_1.getTaskValues)(inspection, true);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            if (Object.entries(dateTimeFields).find(function (value) { return value[1].field === key; })) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key]);
            }
        });
        return values;
    }, [inspection]);
    var inspUpdatestatus = (0, fullInspection_selectors_1.refreshInsp)();
    //when task has been updated, page needs to be refreshed to display latest details
    (0, react_1.useEffect)(function () {
        if (inspUpdatestatus === 200 && onReRender)
            onReRender();
    }, [inspUpdatestatus]);
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-tasks')
        ? true
        : false;
    var details = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Details'), dataCy: "modified-info-card-details", showEditBtn: !readonly && !hasViewerAccess && onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditDetails(true);
        }, onCancelClick: function () {
            setEditDetails(false);
        }, inEditMode: editDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, taskFields, unitFields, dateTimeFields, currencyFields, numericFields, booleanFields, isEditableField, true) })) })));
    var handleFormSubmit = function (data) {
        // We should really used the touched state of a field but I cant get the Formik stuff to work properly
        var changes = (0, common_utils_1.getChangedFormikFields)(origDetails, data);
        if (changes && Object.entries(changes).length !== 0) {
            setFormSubmitted(true);
            var editedFieldsList = (0, common_utils_1.processFormSubmit)(t, taskType, origDetails, changes, taskFields, dateTimeFields, unitFields, currencyFields, numericFields, booleanFields, getSystemValueFormatted, formatDateUTC, companySettings);
            dispatch((0, inspection_actions_1.refreshInspection)({ status: -1 })); //reset update flag and hide the controls
            dispatch((0, inspection_actions_1.updateInspection)(editedFieldsList)); //trigger update
        }
    };
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    if ((!isLoading && origDetails && origDetails._id !== '') ||
        formSubmitted) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeFormV2, __assign({ mode: editDetails ? 'edit' : 'view', initialValues: editDetails ? origDetails : viewDetails, enableReinitialize: true, onSubmit: function (data) {
                setEditDetails(false);
                handleFormSubmit(data);
            } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: tabValue, onChange: handleChangeTab }, { children: (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Details') }, (0, _Utils_1.a11yProps)(0))) })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 0 }, { children: details }), 0)] }) })));
            } }), editDetails ? 'edit' : 'view'));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '25px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    }
};
exports.TaskDetailsProps = TaskDetailsProps;
exports["default"] = exports.TaskDetailsProps;


/***/ }),

/***/ "./components/AssetDetails/TaskDetails/index.ts":
/*!******************************************************!*\
  !*** ./components/AssetDetails/TaskDetails/index.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./TaskDetails.component */ "./components/AssetDetails/TaskDetails/TaskDetails.component.tsx"), exports);


/***/ }),

/***/ "./components/AssetDetails/index.ts":
/*!******************************************!*\
  !*** ./components/AssetDetails/index.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var AssetDetails_component_1 = __webpack_require__(/*! ./AssetDetails.component */ "./components/AssetDetails/AssetDetails.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(AssetDetails_component_1).default; } }));
__exportStar(__webpack_require__(/*! ./InspDetails */ "./components/AssetDetails/InspDetails/index.tsx"), exports);
__exportStar(__webpack_require__(/*! ./TaskDetails */ "./components/AssetDetails/TaskDetails/index.ts"), exports);


/***/ }),

/***/ "./components/CreateInspection/CreateInspection.component.tsx":
/*!********************************************************************!*\
  !*** ./components/CreateInspection/CreateInspection.component.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CreateInspection = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var inspection_selectors_1 = __webpack_require__(/*! @Selectors/inspection.selectors */ "./selectors/inspection.selectors.ts");
var time_1 = __webpack_require__(/*! @Utils/time */ "./utils/time.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var CreateInspection = function (_a) {
    var open = _a.open, task = _a.task, standard = _a.standard, relatedAssetType = _a.relatedAssetType, name = _a.typeName, onClose = _a.onClose, relatedAssetId = _a.relatedAssetId;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(''), newId = _b[0], setNewId = _b[1];
    var _c = (0, react_1.useState)(''), newIdError = _c[0], setNewIdError = _c[1];
    var isCreating = (0, inspection_selectors_1.selectCreatingInspection)();
    var createdInspectionId = (0, inspection_selectors_1.selectCreateInspectionId)();
    var formRef = (0, react_1.useRef)(null);
    var handleCancel = function () {
        onClose(undefined);
    };
    (0, react_1.useEffect)(function () {
        if (open) {
            dispatch((0, inspection_actions_1.setCreateInspectionId)(undefined));
            setNewId('');
            setNewIdError(t('ID is required'));
        }
    }, [open]);
    var handleCreate = function () {
        if (newIdError.length == 0) {
            var date = undefined;
            var current = formRef.current;
            if (current && current.values.scheduledDateTime) {
                // We need to make the scheduled date time zone agnostic
                var scheduledDate = (0, time_1.dateTimeFromPicker)(current.values.scheduledDateTime);
                date = {
                    type: 'datetime',
                    local: '',
                    displayValue: scheduledDate.substring(0, 19),
                    value: scheduledDate,
                };
            }
            // TODO: This may need to be updated to use relatedAssetId in the correct place depending on the server. For the moment we will just pass it for tasks
            var createParam = {
                standard: standard,
                newId: newId,
                relatedAssetType: relatedAssetType,
                options: {
                    task: task,
                    scheduledDate: date,
                    assetId: task ? relatedAssetId : undefined,
                },
            };
            dispatch((0, inspection_actions_1.createInspection)(createParam));
        }
    };
    (0, react_1.useEffect)(function () {
        if (!isCreating && createdInspectionId) {
            onClose(createdInspectionId);
            dispatch((0, inspection_actions_1.setCreateInspectionId)(undefined));
        }
    }, [isCreating, createdInspectionId]);
    var handlelTaskIdChangeValue = function (event) {
        var error = '';
        if (event.target && event.target.value !== '') {
            if (event.target.value.trim().toLowerCase() !==
                name.trim().toLowerCase()) {
                setNewId(event.target.value);
                var rexp = new RegExp('^[a-zA-Z0-9 ]+$');
                var test_1 = rexp.test(event.target.value);
                if (!test_1) {
                    error = t('Only alphanumeric characters are allowed');
                }
            }
        }
        else {
            setNewId('');
            error = t('ID is required');
        }
        setNewIdError(error);
    };
    // This stops the dialog closing when clicked on the background
    var onCloseDialog = function () { return void {}; };
    var dialogProps = {
        open: open,
        fullWidth: true,
        maxWidth: 'sm',
        onClose: onCloseDialog,
        className: isCreating ? 'wait' : '',
    };
    var adpAttrs = (0, stylovyze_1.decoratedAttributes)({
        inspectionid: newId,
        inspectiontypename: name,
    });
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeDialog, __assign({ dialogProps: dialogProps, "data-cy": "new-dialog", title: t('Create {{name}}', { name: name }), open: open, cancelText: t('Cancel'), cancelButtonProps: {
            disabled: isCreating,
            dataCy: 'create-cancel',
        }, onCancel: handleCancel, confirmText: t('OK'), confirmButtonProps: __assign({ disabled: isCreating || newIdError.length !== 0, dataCy: 'create-confirm', 'adp-click': 'true', id: 'create-confirm-ok', name: 'Create Inspection', type: 'button' }, adpAttrs), onConfirm: handleCreate }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeForm, __assign({ mode: stylovyze_1.FORM_MODES.EDIT, initialValues: {}, onSubmit: function (data) {
                console.log('should update the data', data);
            }, innerRef: formRef }, { children: function () {
                return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: {
                                    name: 'newId',
                                }, textField: {
                                    label: task
                                        ? t('Task ID')
                                        : t('Inspection ID'),
                                    fullWidth: true,
                                    required: true,
                                    helperText: newIdError,
                                    error: newIdError.length !== 0,
                                    InputProps: {
                                        inputProps: {
                                            maxLength: 20,
                                        },
                                    },
                                    disabled: isCreating,
                                }, onChange: handlelTaskIdChangeValue, onDebounceChange: handlelTaskIdChangeValue, dataCy: 'newId' }), (0, jsx_runtime_1.jsx)(stylovyze_1.InputDateTime, { fieldAttrs: {
                                    name: 'scheduledDateTime',
                                }, dateTime: {
                                    name: 'scheduledDateTime',
                                    mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
                                    label: t('Scheduled Date'),
                                    disabled: isCreating,
                                }, dataCy: 'scheduledDateTime' })] })) })));
            } })) })));
};
exports.CreateInspection = CreateInspection;


/***/ }),

/***/ "./components/CreateInspection/index.ts":
/*!**********************************************!*\
  !*** ./components/CreateInspection/index.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./CreateInspection.component */ "./components/CreateInspection/CreateInspection.component.tsx"), exports);


/***/ }),

/***/ "./components/DetailsCard/DetailsCard.tsx":
/*!************************************************!*\
  !*** ./components/DetailsCard/DetailsCard.tsx ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
__webpack_require__(/*! ./DetailsCard.styles.css */ "./components/DetailsCard/DetailsCard.styles.css");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var DetailsCard = function (_a) {
    var _b = _a.highlight, highlight = _b === void 0 ? 'normal' : _b, heading = _a.heading, action = _a.action, contents = _a.contents, dataCy = _a.dataCy;
    var getHeading = function (heading) {
        if (typeof heading === 'string') {
            return (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-medium-strong" }, { children: heading }));
        }
        else {
            return heading;
        }
    };
    var getAction = function (action) {
        if (typeof action === 'string') {
            return (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-medium-strong" }, { children: action }));
        }
        else {
            return action;
        }
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ className: "".concat(highlight, "Card"), "data-cy": dataCy }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, container: true, style: {
                        justifyContent: 'space-between',
                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: action ? 8 : 12, "data-cy": dataCy + '-Heading' }, { children: getHeading(heading) })), action ? getAction(action) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, container: true, "data-cy": dataCy + '-Contents' }, { children: contents }))] })) })));
};
DetailsCard.defaultProps = {
    highlight: 'normal',
};
exports["default"] = DetailsCard;


/***/ }),

/***/ "./components/DetailsCard/index.ts":
/*!*****************************************!*\
  !*** ./components/DetailsCard/index.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var DetailsCard_1 = __webpack_require__(/*! ./DetailsCard */ "./components/DetailsCard/DetailsCard.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(DetailsCard_1).default; } }));
__exportStar(__webpack_require__(/*! ./DetailsCard */ "./components/DetailsCard/DetailsCard.tsx"), exports);


/***/ }),

/***/ "./components/FilterSelect/FilterSelect.tsx":
/*!**************************************************!*\
  !*** ./components/FilterSelect/FilterSelect.tsx ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var FilterSelect = function (props) {
    var idCaptions = props.options || [];
    var filterChange = function (event) {
        if (props.onFilterChange) {
            if (props.multiple) {
                props.onFilterChange({
                    colKey: props.column.id,
                    value: event.target.value,
                });
            }
            else {
                props.onFilterChange({
                    colKey: props.column.id,
                    value: event.target.value,
                });
            }
        }
    };
    var renderValue = function (selectedValue) {
        if (props.multiple) {
            var values = selectedValue;
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: values
                    .map(function (id) {
                    var text = idCaptions.find(function (value) { return value.id === id; });
                    return text === null || text === void 0 ? void 0 : text.caption;
                })
                    .join(', ') }));
        }
        else {
            var text = idCaptions.find(function (value) { return value.id === selectedValue; });
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: text === null || text === void 0 ? void 0 : text.caption });
        }
    };
    var options = idCaptions.map(function (idCaption, index) {
        if (props.multiple) {
            return ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ value: idCaption.id, style: { padding: '0 10px 0 0' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: props.value !== undefined
                            ? props.value.indexOf(idCaption.id) > -1
                            : false }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: idCaption.caption })] }), index));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: idCaption.id }, { children: idCaption.caption }), index));
        }
    });
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ fullWidth: props.fullWidth }, { children: [(0, jsx_runtime_1.jsxs)(material_1.InputLabel, { children: [" ", props.column.caption, " "] }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ variant: "standard", "data-cy": props.dataCy, value: props.value, onChange: filterChange, multiple: props.multiple, renderValue: renderValue }, { children: options }))] })));
};
exports["default"] = FilterSelect;


/***/ }),

/***/ "./components/FilterSelect/index.ts":
/*!******************************************!*\
  !*** ./components/FilterSelect/index.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var FilterSelect_1 = __webpack_require__(/*! ./FilterSelect */ "./components/FilterSelect/FilterSelect.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(FilterSelect_1).default; } }));


/***/ }),

/***/ "./components/MACPComponentConditions/MACPComponentConditions.component.tsx":
/*!**********************************************************************************!*\
  !*** ./components/MACPComponentConditions/MACPComponentConditions.component.tsx ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var splitCamalCase = function (input) {
    var temp = input.replace(/([A-Z])/g, ' $1');
    return temp.charAt(0).toUpperCase() + temp.slice(1);
};
var MACPComponentConditions = function (_a) {
    var fullInsp = _a.fullInsp;
    var t = (0, _Translations_1.useGlobalization)().t;
    var headers = [
        {
            key: 'desc-header',
            cell: t('Description'),
        },
        { key: 'structural-header', cell: 'Structural Grade' },
        {
            key: 'OM-header',
            cell: t('O&M Grade'),
        },
    ];
    // {
    // 	key: 'hole-number',
    // 	cells: ['Hole Number', '0', '0'],
    // }
    var observationRows = [];
    var componentCond = {
        holeNumber: [t('Hole Number'), '', ''],
        coverFrameFit: [t('Cover/Frame Fit'), '', ''],
        coverCondition: [t('Cover Condition'), '', ''],
        coverInsertCondition: [t('Cover Insert Condition'), '', ''],
        adjustmentRingCondition: [t('Adjustment Ring Condition'), '', ''],
        frameCondition: [t('Frame Condition'), '', ''],
        sealCondition: [t('Seal Condition'), '', ''],
        frameOffsetDistance: [t('Frame Offset Distance'), '', ''],
        frameSealInflow: [t('Frame Seal Inflow'), '', ''],
        chimney: [t('Chimney'), '', ''],
        pipeCondition: [t('Pipe Condition'), '', ''],
    };
    if ((fullInsp === null || fullInsp === void 0 ? void 0 : fullInsp.componentConditions) != undefined &&
        fullInsp.componentConditions.length > 0) {
        fullInsp.componentConditions.map(function (condition) {
            var service = componentCond[condition.name]
                ? componentCond[condition.name][2]
                : '';
            var structure = componentCond[condition.name]
                ? componentCond[condition.name][1]
                : '';
            if (condition.serviceScore != 0) {
                service = condition.value;
            }
            if (condition.structuralScore != 0) {
                structure = condition.value;
            }
            componentCond[condition.name] = [
                splitCamalCase(condition.name),
                structure,
                service,
            ];
        });
    }
    Object.keys(componentCond).map(function (name) {
        observationRows.push({
            key: name,
            cells: componentCond[name],
        });
    });
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, style: { height: '685px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: "defect-table", headers: headers, rows: observationRows, 
                // initialized={!isLoading}
                useSkeleton: { rowCount: 10 } }) })) })));
};
exports["default"] = MACPComponentConditions;


/***/ }),

/***/ "./components/MACPComponentConditions/index.ts":
/*!*****************************************************!*\
  !*** ./components/MACPComponentConditions/index.ts ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MACPComponentConditions = void 0;
var MACPComponentConditions_component_1 = __webpack_require__(/*! ./MACPComponentConditions.component */ "./components/MACPComponentConditions/MACPComponentConditions.component.tsx");
Object.defineProperty(exports, "MACPComponentConditions", ({ enumerable: true, get: function () { return __importDefault(MACPComponentConditions_component_1).default; } }));


/***/ }),

/***/ "./components/MACPInspectionProps/MACPInspectionProps.component.tsx":
/*!**************************************************************************!*\
  !*** ./components/MACPInspectionProps/MACPInspectionProps.component.tsx ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MACPInspectionProps = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var common_utils_1 = __webpack_require__(/*! @Utils/common.utils */ "./utils/common.utils.tsx");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var ModifiedInfoCard_1 = __importDefault(__webpack_require__(/*! @Components/ModifiedInfoCard/ModifiedInfoCard */ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx"));
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var EDITABLE_FIELDS = ['manholeNumber', 'northing', 'easting'];
var NON_EDITABLE_FIELDS = ['uploadedBy', 'uploadDateTime'];
var isEditableField = function (fieldName, fullEdit) {
    return fullEdit
        ? !NON_EDITABLE_FIELDS.includes(fieldName)
        : EDITABLE_FIELDS.includes(fieldName);
};
var HIDDEN_FIELDS = ['uploadDateTime', 'scheduledDate'];
var isHiddenField = function (fieldName, hideFields) {
    return hideFields ? HIDDEN_FIELDS.includes(fieldName) : false;
};
var surveyFields = function (t) { return [
    { name: 'uploadedBy', alias: t('Uploaded By') },
    { name: 'uploadDateTime', alias: t('Upload Date') },
    { name: 'scheduledDate', alias: t('Scheduled Date') },
    { name: 'inspectionId', alias: t('Inspection ID') },
    { name: 'date', alias: t('Inspection Date') },
    { name: 'time', alias: t('Inspection Time') },
    { name: 'preCleaning', alias: t('Pre Cleaning') },
    { name: 'dateCleaned', alias: t('Date Cleaned') },
    { name: 'inspectionLevel', alias: t('Inspection Level') },
    { name: 'drainageArea', alias: t('Drainage Area') },
    { name: 'manholeNumber', alias: t('Manhole Number') },
    { name: 'mhUse', alias: t('Manhole Use') },
    { name: 'accessType', alias: t('Access Type') },
    { name: 'rimToInvert', alias: t('Rim to Invert') },
    { name: 'rimToGrade', alias: t('Rim to Grade') },
    { name: 'gradeToInvert', alias: t('Grade to Invert') },
    { name: 'rimToGradeExposed', alias: t('Rim to Grade Exposed') },
    { name: 'northing', alias: t('Northing') },
    { name: 'easting', alias: t('Easting') },
    { name: 'elevation', alias: t('Elevation') },
    { name: 'isImperial', alias: t('Is Imperial') },
]; };
var adminFields = function (t) { return [
    { name: 'surveyedBy', alias: t('Survey By') },
    { name: 'certificateNumber', alias: t('Certificate Number') },
    { name: 'reviewedBy', alias: t('Reviewed By') },
    {
        name: 'reviewerCertificateNumber',
        alias: t('Reviewer Certificate Number'),
    },
    { name: 'owner', alias: t('Owner') },
    { name: 'customer', alias: t('Customer') },
    { name: 'poNumber', alias: t('PO Number') },
    { name: 'workOrder', alias: t('Work Order') },
    { name: 'project', alias: t('Project') },
    { name: 'sheetNumber', alias: t('Sheet Number') },
    { name: 'purpose', alias: t('Purpose') },
]; };
var detailsFields = function (t) { return [
    { name: 'coverShape', alias: t('Shape') },
    { name: 'coverSize', alias: t('Size') },
    { name: 'centerCoverSize', alias: t('Center Size') },
    { name: 'coverSizeWidth', alias: t('Width') },
    { name: 'coverMaterial', alias: t('Material') },
    { name: 'holeDiameter', alias: t('Hole Diameter') },
    { name: 'holeNumber', alias: t('Hole Number') },
    { name: 'coverBearingSurfaceDia', alias: t('Bearing Surface Diameter') },
    { name: 'coverBearingSurfaceDiaWidth', alias: t('Bearing Surface Width') },
    { name: 'coverFrameFit', alias: t('Frame Fit') },
    { name: 'coverInsertType', alias: t('Insert Type') },
]; };
var typeFields = function (t) { return [
    { name: 'coverTypeBolted', alias: t('Bolted') },
    { name: 'coverTypeGasketed', alias: t('Gasketed') },
    { name: 'coverTypeHatchDouble', alias: t('Hatch Double') },
    { name: 'coverTypeHatchSingle', alias: t('Hatch Single') },
    { name: 'coverTypeInnerCover', alias: t('Inner Cover') },
    { name: 'coverTypeLamphole', alias: t('Lamphole') },
    { name: 'coverTypeLocking', alias: t('Locking') },
    { name: 'coverTypeRemovableCenter', alias: t('Removable Center') },
    { name: 'coverTypeSolid', alias: t('Solid') },
    { name: 'coverTypeVented', alias: t('Vented') },
]; };
var benchFields = function (t) { return [
    { name: 'benchPresent', alias: t('Present') },
    { name: 'benchMaterial', alias: t('Material') },
    { name: 'benchLining', alias: t('Lining') },
    { name: 'benchCondition', alias: t('Condition') },
]; };
var channelFields = function (t) { return [
    { name: 'channelInstalled', alias: t('Installed') },
    { name: 'channelMaterial', alias: t('Material') },
    { name: 'channelType', alias: t('Type') },
    { name: 'channelExposure', alias: t('Exposure') },
    { name: 'channelCondition', alias: t('Condition') },
]; };
var locationFields = function (t) { return [
    { name: 'street', alias: t('Street') },
    { name: 'city', alias: t('City') },
    { name: 'locationCode', alias: t('Location Code') },
    { name: 'locationDetails', alias: t('Location Details') },
    { name: 'coordinateSystem', alias: t('Coordinate System') },
    { name: 'verticalDatum', alias: t('Vertical Datum') },
    { name: 'gpsAccuracy', alias: t('GPS Accuracy') },
]; };
var coverConditionFields = function (t) { return [
    { name: 'coverConditionBoltsMissing', alias: t('Bolts Missing') },
    { name: 'coverConditionBroken', alias: t('Broken') },
    { name: 'coverConditionCorroded', alias: t('Corroded') },
    { name: 'coverConditionCracked', alias: t('Cracked') },
    { name: 'coverConditionMissing', alias: t('Missing') },
    {
        name: 'coverConditionRestraintDefective',
        alias: t('Restraint Defective'),
    },
    { name: 'coverConditionRestraintMissing', alias: t('Restraint Missing') },
    { name: 'coverConditionSound', alias: t('Sound') },
]; };
var ringConditionFields = function (t) { return [
    { name: 'ringConditionBroken', alias: t('Broken') },
    { name: 'ringConditionCorroded', alias: t('Corroded') },
    { name: 'ringConditionCracked', alias: t('Cracked') },
    { name: 'ringConditionLeaking', alias: t('Leaking') },
    { name: 'ringConditionPoorInstall', alias: t('Poor Install') },
    { name: 'ringConditionSound', alias: t('Sound') },
]; };
var insertConditionFields = function (t) { return [
    { name: 'insertConditionCracked', alias: t('Cracked') },
    { name: 'insertConditionCorroded', alias: t('Corroded') },
    { name: 'insertConditionInsertFell', alias: t('Insert Fell') },
    { name: 'insertConditionLeaking', alias: t('Leaking') },
    { name: 'insertConditionPoorlyFitting', alias: t('Poorly Fitting') },
    { name: 'insertConditionSound', alias: t('Sound') },
]; };
var frameConditionFields = function (t) { return [
    { name: 'frameConditionBroken', alias: t('Broken') },
    { name: 'frameConditionCoated', alias: t('Coated') },
    { name: 'frameConditionCorroded', alias: t('Corroded') },
    { name: 'frameConditionCracked', alias: t('Cracked') },
    { name: 'frameConditionMissing', alias: t('Missing') },
    { name: 'frameConditionSound', alias: t('Sound') },
]; };
var sealConditionFields = function (t) { return [
    { name: 'sealConditionCracked', alias: t('Cracked') },
    { name: 'sealConditionLoose', alias: t('Loose') },
    { name: 'sealConditionMissing', alias: t('Missing') },
    { name: 'sealConditionOffset', alias: t('Offset') },
    { name: 'sealConditionSound', alias: t('Sound') },
]; };
var ringFields = function (t) { return [
    { name: 'adjustmentRingType', alias: t('Type') },
    { name: 'adjustmentRingMaterial', alias: t('Material') },
    { name: 'adjustmentRingHeight', alias: t('Height') },
]; };
var frameFields = function (t) { return [
    { name: 'frameMaterial', alias: t('Material') },
    { name: 'frameBearingSurfaceWidth', alias: t('Bearing Surface Width') },
    { name: 'frameBearingSurfaceDepth', alias: t('Bearing Surface Depth') },
    { name: 'frameClearOpenDiameter', alias: t('Clear Open Diameter') },
    { name: 'frameClearOpenWidth', alias: t('Clear Open Width') },
    { name: 'frameOffsetDistance', alias: t('Offset Distance') },
    { name: 'frameSealInflow', alias: t('Seal Inflow') },
    { name: 'frameDepth', alias: t('Depth') },
]; };
var coneFields = function (t) { return [
    { name: 'coneType', alias: t('Type') },
    { name: 'coneMaterial', alias: t('Material') },
    { name: 'coneDepth', alias: t('Depth') },
    { name: 'coneLiningInterior', alias: t('Lining Interior') },
    { name: 'coneLiningExterior', alias: t('Lining Exterior') },
    { name: 'coneCondition', alias: t('Condition') },
]; };
var chimneyFields = function (t) { return [
    { name: 'chimneyPresent', alias: t('Present') },
    { name: 'chimneyMaterial1', alias: t('Material 1') },
    { name: 'chimneyMaterial2', alias: t('Material 2') },
    { name: 'chimneyIni', alias: t('Inflow & Infiltration') },
    { name: 'chimneyClearOpening', alias: t('Clear Opening') },
    { name: 'chimneyDepth', alias: t('Depth') },
    { name: 'chimneyLiningInterior', alias: t('Lining Interior') },
    { name: 'chimneyLiningExterior', alias: t('Lining Exterior') },
    { name: 'chimneyCondition', alias: t('Condition') },
]; };
var stepFields = function (t) { return [
    { name: 'stepNumber', alias: t('Number') },
    { name: 'stepMaterial', alias: t('Material') },
]; };
var surfaceTypeFields = function (t) { return [
    { name: 'surfaceTypeAsphalt', alias: t('Asphalt') },
    { name: 'surfaceTypeConcretePavement', alias: t('Concrete Pavement') },
    { name: 'surfaceTypeConcreteCollar', alias: t('Concrete Collar') },
    { name: 'surfaceTypeGrassDirt', alias: t('Grass or Dirt') },
    { name: 'surfaceTypeGravel', alias: t('Gravel') },
    { name: 'surfaceTypeOther', alias: t('Other') },
]; };
var wallFields = function (t) { return [
    { name: 'wallDiameter', alias: t('Diameter') },
    { name: 'wallBySize', alias: t('By Size') },
    { name: 'wallMaterial', alias: t('Material') },
    { name: 'wallDepth', alias: t('Depth') },
    { name: 'wallLiningInterior', alias: t('Lining Inerior') },
    { name: 'wallLiningExterior', alias: t('Lining Exterior') },
    { name: 'wallCondition', alias: t('Condition') },
]; };
var otherFields = function (t) { return [
    { name: 'mediaLabel', alias: t('Media Label') },
    { name: 'weather', alias: t('Weather') },
    { name: 'consequenceOfFailure', alias: t('Consequence of Failure') },
    { name: 'inflowPotentialFromRunoff', alias: t('Potential from Runoff') },
    { name: 'yearConstructed', alias: t('Year Constructed') },
    { name: 'yearRenewed', alias: t('Year Renewed') },
    { name: 'evidenceSurcharge', alias: t('Evidence of Surcharge') },
    { name: 'additionalInfo', alias: t('Additonal Information') },
    { name: 'additionalComponentInfo', alias: t('Component Information') },
]; };
var hardCodeUnitFields = {
    rimToInvert: { unit: 'm', step: 'any' },
    rimToGrade: { unit: 'm', step: 'any' },
    gradeToInvert: { unit: 'm', step: 'any' },
    elevation: { unit: 'm', step: 'any' },
    rimToGradeExposed: { unit: 'm', step: 'any' },
    coverSize: { unit: 'mm', min: 0, step: 'any' },
    centerCoverSize: { unit: 'mm', min: 0, step: 'any' },
    coverSizeWidth: { unit: 'mm', min: 0, step: 'any' },
    coverBearingSurfaceDia: { unit: 'mm', min: 0, step: 'any' },
    coverBearingSurfaceDiaWidth: { unit: 'mm', min: 0, step: 'any' },
    adjustmentRingHeight: { unit: 'mm', min: 0, step: 'any' },
    frameBearingSurfaceWidth: { unit: 'mm', min: 0, step: 'any' },
    frameBearingSurfaceDepth: { unit: 'mm', min: 0, step: 'any' },
    frameClearOpenDiameter: { unit: 'mm', min: 0, step: 'any' },
    frameClearOpenWidth: { unit: 'mm', min: 0, step: 'any' },
    frameOffsetDistance: { unit: 'mm', step: 'any' },
    coneDepth: { unit: 'mm', step: 'any' },
    chimneyClearOpening: { unit: 'mm', step: 'any' },
    chimneyDepth: { unit: 'mm', step: 'any' },
};
var hardCodeDateTimeFields = {
    uploadDateTime: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'uploadDateTime',
        useCompanyDateTime: true,
    },
    scheduledDate: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'scheduledDate',
    },
    date: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'surveyDateTime' },
    time: { mode: stylovyze_1.DateTimeInputMode.TIME, field: 'surveyDateTime' },
    dateCleaned: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'dateCleaned' },
};
var hardCodeCurrencyFields = {};
var hardCodeNumericFields = {
    northing: { step: 0.1 },
    easting: { step: 0.1 },
    yearConstructed: { min: 0 },
    yearRenewed: { min: 0 },
};
var hardCodeBooleanFields = {
    coverTypeBolted: true,
    coverTypeGasketed: true,
    coverTypeHatchDouble: true,
    coverTypeHatchSingle: true,
    coverTypeInnerCover: true,
    coverTypeLamphole: true,
    coverTypeLocking: true,
    coverTypeRemovableCenter: true,
    coverTypeSolid: true,
    coverTypeVented: true,
    coverConditionBoltsMissing: true,
    coverConditionBroken: true,
    coverConditionCorroded: true,
    coverConditionCracked: true,
    coverConditionMissing: true,
    coverConditionRestraintDefective: true,
    coverConditionRestraintMissing: true,
    coverConditionSound: true,
    ringConditionBroken: true,
    ringConditionCorroded: true,
    ringConditionCracked: true,
    ringConditionLeaking: true,
    ringConditionPoorInstall: true,
    ringConditionSound: true,
    insertConditionCracked: true,
    insertConditionCorroded: true,
    insertConditionInsertFell: true,
    insertConditionLeaking: true,
    insertConditionPoorlyFitting: true,
    insertConditionSound: true,
    isImperial: true,
    frameConditionBroken: true,
    frameConditionCoated: true,
    frameConditionCorroded: true,
    frameConditionCracked: true,
    frameConditionMissing: true,
    frameConditionSound: true,
    sealConditionCracked: true,
    sealConditionLoose: true,
    sealConditionMissing: true,
    sealConditionOffset: true,
    sealConditionSound: true,
    surfaceTypeAsphalt: true,
    surfaceTypeConcretePavement: true,
    surfaceTypeConcreteCollar: true,
    surfaceTypeGrassDirt: true,
    surfaceTypeGravel: true,
    surfaceTypeOther: true,
};
var getDomainValues = function (t, fieldName) {
    var domainValueDic = {};
    switch (fieldName.toLowerCase()) {
        case 'mhUse'.toLowerCase():
            domainValueDic = {
                CB: t('Combined'),
                DP: t('Dam'),
                FM: t('Force Main'),
                LG: t('Levee Gravity'),
                LP: t('Levee Pressure'),
                PR: t('Processes'),
                SS: t('Sanitary'),
                SW: t('Stormwater'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
            break;
        case 'purpose'.toLowerCase():
            domainValueDic = {
                A: t('Maintenance Related'),
                B: t('Infiltration and Inflow Investigation'),
                C: t('Post Rehabilitation Survey'),
                D: t('Pre Rehabilitation Survey'),
                E: t('Pre Acceptance - New Sewers'),
                F: t('Routine Assessment'),
                G: t('Capital Improvement Program Assessment'),
                H: t('Resurvey for any Reason'),
                I: t('Sewer System Evaluation Survey'),
                R: t('Pre-Existing Video or Photographs'),
                X: t('Not Known'),
            };
            break;
        case 'preCleaning'.toLowerCase():
            domainValueDic = {
                H: t('Heavy Cleaning'),
                L: t('Light Cleaning'),
                N: t('No Pre-Cleaning'),
                X: t('Not Known'),
                Z: t('Other'),
            };
            break;
        case 'weather'.toLowerCase():
            domainValueDic = {
                1: t('Dry - No precipitation During Survey'),
                2: t('Heavy Rain'),
                3: t('Light Rain'),
                4: t('Snow'),
                5: t('Dry Weather/Wet Ground'),
            };
            break;
        case 'locationCode'.toLowerCase():
            domainValueDic = {
                A: t('Primary Major Arterial Roads'),
                B: t('Secondary Roads'),
                C: t('Local Rural Streets'),
                D: t('Easement/Right of Way'),
                E: t('Woods'),
                F: t('Sidewalk'),
                G: t('Parking lot'),
                H: t('Alley'),
                I: t('Ditch'),
                J: t('Building'),
                K: t('Creek - Includes any waterway'),
                L: t('Railway'),
                M: t('Airport'),
                N: t('Levee/Floodwall'),
                O: t('Dam'),
                P: t('Levee Pump Station'),
                Y: t('Yard'),
                Z: t('Other'),
            };
            break;
        case 'inflowPotentialFromRunoff'.toLowerCase():
            domainValueDic = {
                I: t('Inundated'),
                N: t('None'),
                P: t('Ponding'),
                S: t('Sheeting'),
            };
            break;
        case 'gpsAccuracy'.toLowerCase():
            domainValueDic = {
                L: t('Survey Level'),
                M: t('Sub-Meter'),
                N: t('Nearest Meter'),
            };
            break;
        case 'inspectionLevel'.toLowerCase():
            domainValueDic = {
                1: t('Level 1'),
                2: t('Level 2'),
            };
            break;
        case 'inspectionStatus'.toLowerCase():
            domainValueDic = {
                DI: t('Descent Inspection'),
                SI: t('Surface Inspection'),
                RI: t('Remote Inspection'),
                BM: t('Buried or Marked'),
                NA: t('No Access'),
                NF: t('Not Found'),
                NI: t('Traffic'),
                NO: t('Not Opened'),
                SD: t('Surcharged/Debris'),
            };
            break;
        case 'accessType'.toLowerCase():
            domainValueDic = {
                ACB: t('Catch Basin'),
                ACOH: t('Clean Out House'),
                ACOM: t('Clean Out Mainline'),
                ACOP: t('Clean Out Property'),
                AJB: t('Junction Box'),
                AM: t('Meter'),
                AMH: t('Manhole'),
                AOC: t('Other Special Chamber'),
                AWA: t('Wastewater Access'),
                AWW: t('Wet Well'),
            };
            break;
        case 'coverShape'.toLowerCase():
            domainValueDic = {
                C: t('Circular'),
                O: t('Oval or Elliptical'),
                R: t('Rectangular'),
                S: t('Square'),
                T: t('Triangular'),
                Z: t('Other'),
            };
            break;
        case 'coverMaterial'.toLowerCase():
            domainValueDic = {
                AL: t('Aluminum'),
                CAS: t('Cast Iron'),
                CN: t('Concrete (cast in place)'),
                CR: t('Concrete (precast)'),
                DI: t('Ductile Iron'),
                FR: t('Fiberglass Reinforced'),
                PE: t('Polyethylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                S: t('Steel'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'holeDiameter'.toLowerCase():
            domainValueDic = {
                A: t('<= 1/2 inch (10mm)'),
                B: t('> 1/2 inch (10mm) <= 1 inch (25mm)'),
                C: t('> 1 inch (25mm) <= 1 1/2 inch (38mm)'),
                D: t('> 1 1/2 inch (38mm) <= 2 inch (50mm)'),
                E: t('> 2 inch (50mm) or grated/slotted'),
            };
            break;
        case 'coverFrameFit'.toLowerCase():
            domainValueDic = {
                G: t('Good'),
                O: t('Oversized'),
                R: t('Rocks/Wobbles'),
                U: t('Undersized'),
            };
            break;
        case 'coverInsertType'.toLowerCase():
            domainValueDic = {
                M: t('Metal'),
                N: t('None'),
                P: t('Plastic'),
                Z: t('Other'),
            };
            break;
        case 'adjustmentRingType'.toLowerCase():
            domainValueDic = {
                A: t('Adjustable'),
                N: t('None'),
                S: t('Solid'),
            };
            break;
        case 'adjustmentRingMaterial'.toLowerCase():
        case 'frameMaterial'.toLowerCase():
            domainValueDic = {
                CAS: t('Cast Iron'),
                CN: t('Concrete (cast in place)'),
                CR: t('Concrete (precast)'),
                DI: t('Ductile Iron'),
                FR: t('Fiberglass Reinforced'),
                PE: t('Polyethylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                S: t('Steel'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'frameSealInflow'.toLowerCase():
            domainValueDic = {
                ID: t('Dripper'),
                IG: t('Gusher'),
                IR: t('Runner'),
                IS: t('Stains'),
                IW: t('Weeper'),
                N: t('None'),
            };
            break;
        case 'chimneyMaterial1'.toLowerCase():
        case 'chimneyMaterial2'.toLowerCase():
            domainValueDic = {
                AC: t('Asbestos Cement'),
                BR: t('Brick'),
                CM: t('Corrugated Metal'),
                CN: t('Concrete (cast in place)'),
                CR: t('Concrete (precast)'),
                CT: t('Clay Tile'),
                FR: t('Fiberglass Reinforced'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                R: t('Rubber'),
                S: t('Steel'),
                VC: t('Vitrified Clay'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'chimneyLiningInterior'.toLowerCase():
        case 'chimneyLiningExterior'.toLowerCase():
        case 'coneLiningInterior'.toLowerCase():
        case 'coneLiningExterior'.toLowerCase():
        case 'wallLiningInterior'.toLowerCase():
        case 'wallLiningExterior'.toLowerCase():
        case 'benchLining'.toLowerCase():
            domainValueDic = {
                B: t('Bitumastic'),
                C: t('Cementitious'),
                CIP: t('Cured-in-Place'),
                E: t('Epoxy'),
                F: t('Fiberglass'),
                N: t('None'),
                P: t('Polymer'),
                PL: t('Plastic'),
                R: t('Rubber'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
            break;
        case 'chimneyCondition'.toLowerCase():
        case 'coneCondition'.toLowerCase():
        case 'wallCondition'.toLowerCase():
        case 'benchCondition'.toLowerCase():
        case 'channelCondition'.toLowerCase():
            domainValueDic = {
                D: t('Defective'),
                S: t('Sound'),
                X: t('Not Known'),
            };
            break;
        case 'coneType'.toLowerCase():
            domainValueDic = {
                CC: t('Conical Centered'),
                CO: t('Conical Off Centered'),
                FT: t('Flat Top'),
                N: t('Not Present'),
                ZZ: t('Other'),
            };
            break;
        case 'coneMaterial'.toLowerCase():
        case 'wallMaterial'.toLowerCase():
        case 'channelMaterial'.toLowerCase():
            domainValueDic = {
                AC: t('Asbestos Cement'),
                BR: t('Brick'),
                CM: t('Corrugated Metal'),
                CN: t('Concrete (cast in place)'),
                CR: t('Concrete (precast)'),
                CT: t('Clay Tile'),
                FR: t('Fiberglass Reinforced'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                S: t('Steel'),
                VC: t('Vitrified Clay'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'benchPresent'.toLowerCase():
            domainValueDic = {
                N: t('None'),
                P: t('Partial - One side only'),
                Y: t('Yes'),
            };
            break;
        case 'benchMaterial'.toLowerCase():
            domainValueDic = {
                AC: t('Asbestos Cement'),
                AL: t('Aluminum'),
                BR: t('Brick'),
                CM: t('Corrugated Metal'),
                CN: t('Concrete (cast in place)'),
                CR: t('Concrete (precast)'),
                CT: t('Clay Tile'),
                FR: t('Fiberglass Reinforced'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                S: t('Steel'),
                VC: t('Vitrified Clay'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'channelType'.toLowerCase():
            domainValueDic = {
                F: t('Formed'),
                I: t('Insert'),
                N: t('None'),
                P: t('Pipe'),
                R: t('Precast'),
                Z: t('Other'),
            };
            break;
        case 'channelExposure'.toLowerCase():
            domainValueDic = {
                C: t('Closed'),
                F: t('Fully Open'),
                P: t('Partially Open'),
            };
            break;
        case 'stepMaterial'.toLowerCase():
            domainValueDic = {
                B: t('Brick'),
                M: t('Metal'),
                P: t('Plastic'),
                Z: t('Other'),
            };
            break;
        case 'chimneyPresent'.toLowerCase():
        case 'channelInstalled'.toLowerCase():
        case 'evidenceSurcharge'.toLowerCase():
            domainValueDic = {
                N: t('No'),
                Y: t('Yes'),
            };
            break;
        case 'coverTypeBolted'.toLowerCase():
        case 'coverTypeGasketed'.toLowerCase():
        case 'coverTypeHatchDouble'.toLowerCase():
        case 'coverTypeHatchSingle'.toLowerCase():
        case 'coverTypeInnerCover'.toLowerCase():
        case 'coverTypeLamphole'.toLowerCase():
        case 'coverTypeLocking'.toLowerCase():
        case 'coverTypeRemovableCenter'.toLowerCase():
        case 'coverTypeSolid'.toLowerCase():
        case 'coverTypeVented'.toLowerCase():
        case 'coverConditionBoltsMissing'.toLowerCase():
        case 'coverConditionBroken'.toLowerCase():
        case 'coverConditionCorroded'.toLowerCase():
        case 'coverConditionCracked'.toLowerCase():
        case 'coverConditionMissing'.toLowerCase():
        case 'coverConditionRestraintDefective'.toLowerCase():
        case 'coverConditionRestraintMissing'.toLowerCase():
        case 'coverConditionSound'.toLowerCase():
        case 'ringConditionBroken'.toLowerCase():
        case 'ringConditionCorroded'.toLowerCase():
        case 'ringConditionCracked'.toLowerCase():
        case 'ringConditionLeaking'.toLowerCase():
        case 'ringConditionPoorInstall'.toLowerCase():
        case 'ringConditionSound'.toLowerCase():
        case 'insertConditionCracked'.toLowerCase():
        case 'insertConditionCorroded'.toLowerCase():
        case 'insertConditionInsertFell'.toLowerCase():
        case 'insertConditionLeaking'.toLowerCase():
        case 'insertConditionPoorlyFitting'.toLowerCase():
        case 'insertConditionSound'.toLowerCase():
        case 'frameConditionBroken'.toLowerCase():
        case 'frameConditionCoated'.toLowerCase():
        case 'frameConditionCorroded'.toLowerCase():
        case 'frameConditionCracked'.toLowerCase():
        case 'frameConditionMissing'.toLowerCase():
        case 'frameConditionSound'.toLowerCase():
        case 'sealConditionCracked'.toLowerCase():
        case 'sealConditionLoose'.toLowerCase():
        case 'sealConditionMissing'.toLowerCase():
        case 'sealConditionOffset'.toLowerCase():
        case 'sealConditionSound'.toLowerCase():
        case 'surfaceTypeAsphalt'.toLowerCase():
        case 'surfaceTypeConcretePavement'.toLowerCase():
        case 'surfaceTypeConcreteCollar'.toLowerCase():
        case 'surfaceTypeGrassDirt'.toLowerCase():
        case 'surfaceTypeGravel'.toLowerCase():
        case 'surfaceTypeOther'.toLowerCase():
            domainValueDic = {
                No: '',
                Yes: '',
            };
            break;
        default:
            break;
    }
    return domainValueDic;
};
var MACPInspectionProps = function (_a) {
    var onReRender = _a.onReRender;
    var t = (0, _Translations_1.useGlobalization)().t;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentDateTime = (0, stylovyze_1.useCompanyDateTime)().currentDateTime;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var _b = react_1.default.useState(0), tabValue = _b[0], setTabValue = _b[1];
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var _c = react_1.default.useState(false), editHeaderDetails = _c[0], setEditHeaderDetails = _c[1];
    var _d = react_1.default.useState(false), formSubmitted = _d[0], setFormSubmitted = _d[1];
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    var origDetails = (0, react_1.useMemo)(function () {
        setFormSubmitted(false);
        var values = (0, _Utils_1.getJustValues)(inspection, false);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var viewDetails = (0, react_1.useMemo)(function () {
        var values = (0, _Utils_1.getJustValues)(inspection, true);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var inspUpdatestatus = (0, fullInspection_selectors_1.refreshInsp)();
    //feature to be behind a LaunchDarkley flag
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-inspections-header')
        ? true
        : false;
    var isFullEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-full-inspections')
        ? true
        : false;
    var isCreateAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-create-inspections');
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    var handleFormSubmit = function (data) {
        // We should really used the touched state of a field but I cant get the Formik stuff to work properly
        var changes = (0, common_utils_1.getChangedFormikFields)(origDetails, data);
        if (changes && Object.entries(changes).length !== 0) {
            setFormSubmitted(true);
            var allFields = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], surveyFields(t), true), adminFields(t), true), detailsFields(t), true), typeFields(t), true), benchFields(t), true), channelFields(t), true), locationFields(t), true), coverConditionFields(t), true), ringConditionFields(t), true), insertConditionFields(t), true), frameConditionFields(t), true), sealConditionFields(t), true), ringFields(t), true), frameFields(t), true), coneFields(t), true), chimneyFields(t), true), stepFields(t), true), otherFields(t), true);
            var editedFieldsList = (0, common_utils_1.processFormSubmit)(t, inspection_types_1.InspectionStandard.PACP, origDetails, changes, allFields, hardCodeDateTimeFields, hardCodeUnitFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, getSystemValueFormatted, formatDateUTC, companySettings, t('Date/Time of inspection'), { date: 'date', time: 'time' });
            dispatch((0, inspection_actions_1.refreshInspection)({ status: -1 })); //reset update flag and hide the controls
            dispatch((0, inspection_actions_1.updateInspection)(editedFieldsList)); //trigger update
        }
    };
    //when inspection has been updated, page needs to be refreshed to display latest details
    (0, react_1.useEffect)(function () {
        if (inspUpdatestatus === 200 && onReRender)
            onReRender();
    }, [inspUpdatestatus]);
    var surveyAdminDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Survey'), dataCy: "modified-info-card-survey", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, surveyFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, isHiddenField, !isCreateAllowedFlag, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Admin'), dataCy: "info-card-admin" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, adminFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var coverDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Details'), dataCy: "modified-info-card-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, detailsFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Type'), dataCy: "info-card-type" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, typeFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var benchChannelDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Bench Details'), dataCy: "modified-info-card-bench-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, benchFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Channel Details'), dataCy: "modified-info-card-channel-details" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, channelFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var locationDetails = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Location'), dataCy: "modified-info-card-location", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, locationFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    var conditions = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Cover Condition'), dataCy: "modified-info-card-cover-condition", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, coverConditionFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Ring Condition'), dataCy: "info-card-ring-condition" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, ringConditionFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Insert Condition'), dataCy: "info-card-insert-condition" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, insertConditionFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Frame Condition'), dataCy: "info-card-frame-condition" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, frameConditionFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Seal Condition'), dataCy: "info-card-seal-condition" }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, sealConditionFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var ringFrameDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Ring Details'), dataCy: "modified-info-ring-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, ringFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Frame Details') }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, frameFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var coneChimneyDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Cone Details'), dataCy: "modified-info-cone-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, coneFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Chimney Details') }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, chimneyFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var stepOtherDetails = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Step Details'), dataCy: "modified-info-step-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
                    onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
                    setEditHeaderDetails(true);
                }, onCancelClick: function () {
                    setEditHeaderDetails(false);
                }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, stepFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Surface Type') }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, surfaceTypeFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })), (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ fullHeight: true, title: t('Other Details') }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, otherFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) }))] }));
    var wallDetails = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Wall Details'), dataCy: "modified-info-card-wall", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, wallFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    if ((!isLoading && origDetails) || formSubmitted) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeFormV2, __assign({ mode: editHeaderDetails ? 'edit' : 'view', initialValues: editHeaderDetails ? origDetails : viewDetails, enableReinitialize: true, onSubmit: function (data) {
                setEditHeaderDetails(false);
                handleFormSubmit(data);
            } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, __assign({ "$height": 683 }, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: tabValue, onChange: handleChangeTab, "aria-label": "Vertical tabs example" }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Survey and Admin Details') }, (0, _Utils_1.a11yProps)(0))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Cover Details and Type') }, (0, _Utils_1.a11yProps)(1))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Bench and Channel Details') }, (0, _Utils_1.a11yProps)(2))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Location Details') }, (0, _Utils_1.a11yProps)(3))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Conditions') }, (0, _Utils_1.a11yProps)(4))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Ring and Frame Details') }, (0, _Utils_1.a11yProps)(5))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Cone and Chimney Details') }, (0, _Utils_1.a11yProps)(6))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Step and Other Details') }, (0, _Utils_1.a11yProps)(7))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Wall Details') }, (0, _Utils_1.a11yProps)(8)))] })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 0 }, { children: surveyAdminDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 1 }, { children: coverDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 2 }, { children: benchChannelDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 3 }, { children: locationDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 4 }, { children: conditions })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 5 }, { children: ringFrameDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 6 }, { children: coneChimneyDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 7 }, { children: stepOtherDetails })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 8 }, { children: wallDetails }))] })) })));
            } })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '25px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    }
};
exports.MACPInspectionProps = MACPInspectionProps;
exports["default"] = exports.MACPInspectionProps;


/***/ }),

/***/ "./components/MACPInspectionProps/index.ts":
/*!*************************************************!*\
  !*** ./components/MACPInspectionProps/index.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var MACPInspectionProps_component_1 = __webpack_require__(/*! ./MACPInspectionProps.component */ "./components/MACPInspectionProps/MACPInspectionProps.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(MACPInspectionProps_component_1).default; } }));


/***/ }),

/***/ "./components/MSCCInspectionProps/MSCCInspectionProps.component.tsx":
/*!**************************************************************************!*\
  !*** ./components/MSCCInspectionProps/MSCCInspectionProps.component.tsx ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSCCInspectionProps = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var common_utils_1 = __webpack_require__(/*! @Utils/common.utils */ "./utils/common.utils.tsx");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var ModifiedInfoCard_1 = __importDefault(__webpack_require__(/*! @Components/ModifiedInfoCard/ModifiedInfoCard */ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx"));
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var EDITABLE_FIELDS = [
    'direction',
    'pipelineRef',
    'startNodeRef',
    'finishNodeRef',
];
var NON_EDITABLE_FIELDS = ['uploadedBy', 'uploadDateTime'];
var isEditableField = function (fieldName, fullEdit) {
    return fullEdit
        ? !NON_EDITABLE_FIELDS.includes(fieldName)
        : EDITABLE_FIELDS.includes(fieldName);
};
var HIDDEN_FIELDS = ['uploadDateTime', 'scheduledDate'];
var isHiddenField = function (fieldName, hideFields) {
    return hideFields ? HIDDEN_FIELDS.includes(fieldName) : false;
};
var generalFields = function (t) { return [
    { name: 'uploadedBy', alias: t('Uploaded By') },
    { name: 'uploadDateTime', alias: t('Upload Date') },
    { name: 'scheduledDate', alias: t('Scheduled Date') },
    { name: 'client', alias: t('Client') },
    { name: 'surveyedBy', alias: t('Name of Surveyor') },
    // eslint-disable-next-line prettier/prettier, quotes
    { name: 'clientsJobRef', alias: t("Client's Job Reference") },
    // eslint-disable-next-line prettier/prettier, quotes
    { name: 'contractorsJobRef', alias: t("Contractor's Job Reference") },
    { name: 'scheduledDate', alias: t('Scheduled Date') },
    { name: 'date', alias: t('Date') },
    { name: 'time', alias: t('Time') },
    { name: 'useOfDrainSewer', alias: t('Use of Drain/Sewer') },
    { name: 'typeOfDrainSewer', alias: t('Type of Drain/Sewer') },
    { name: 'direction', alias: t('Direction') },
    { name: 'precleaned', alias: t('Pre-cleaned') },
    { name: 'criticalDrainSewer', alias: t('Critical/Strategic Drain/Sewer') },
    { name: 'purposeOfInspection', alias: t('Purpose of Inspection') },
    { name: 'inspectionStage', alias: t('Inspection Stage') },
    { name: 'flowControlMeasures', alias: t('Flow Control Measures') },
    { name: 'weather', alias: t('Weather') },
    { name: 'temperature', alias: t('Temperature') },
    { name: 'surveyedLength', alias: t('Surveyed Length') },
    { name: 'methodOfInspection', alias: t('Method of Inspection') },
    { name: 'standard', alias: t('Standard') },
    { name: 'clientDefined1', alias: t('Client Defined 1') },
    { name: 'clientDefined2', alias: t('Client Defined 2') },
    { name: 'clientDefined3', alias: t('Client Defined 3') },
    { name: 'clientDefined4', alias: t('Client Defined 4') },
    { name: 'clientDefined5', alias: t('Client Defined 5') },
    { name: 'clientDefined6', alias: t('Client Defined 6') },
    { name: 'generalRemarks', alias: t('General Remarks') },
]; };
var locationFields = function (t) { return [
    { name: 'drainageArea', alias: t('Drainage Area') },
    { name: 'divisionDistrict', alias: t('Division/District') },
    { name: 'locationStreet', alias: t('Location (Street Name)') },
    { name: 'locationTown', alias: t('Location (Town or Village)') },
    { name: 'locationTypeCode', alias: t('Location Type Code') },
    { name: 'landOwner', alias: t('Land Ownership') },
]; };
var pipeFields = function (t) { return [
    { name: 'upstreamManholeId', alias: t('Upstream Manhole Number') },
    { name: 'downstreamManholeId', alias: t('Downstream Manhole Number') },
    { name: 'pipelineRef', alias: t('Pipeline Length Reference') },
    { name: 'heightDiameter', alias: t('Height/Diameter') },
    { name: 'width', alias: t('Width') },
    { name: 'pipeUnitLength', alias: t('Pipe Unit Length') },
    { name: 'shape', alias: t('Shape') },
    { name: 'material', alias: t('Material') },
    { name: 'liningMaterial', alias: t('Lining Material') },
    { name: 'liningType', alias: t('Lining Type') },
    { name: 'yearConstructed', alias: t('Year Constructed') },
    { name: 'lateralInspStart', alias: t('Lateral Inspection Start Point') },
    {
        name: 'longLocStartLat',
        alias: t('Longitudinal Location of Start of Lateral'),
    },
    {
        name: 'circLocStartLat',
        alias: t('Circumferencial Location of Start of Lateral'),
    },
]; };
var manholesFields = function (t) { return [
    { name: 'startNodeRef', alias: t('Start Node Reference') },
    { name: 'depthAtStartNode', alias: t('Depth at Start Node') },
    { name: 'startNodeGridRefX', alias: t('Start Node Coordinate X') },
    { name: 'startNodeGridRefY', alias: t('Start Node Coordinate Y') },
    { name: 'node1Ref', alias: t('Node 1 Reference') },
    { name: 'node1GridRefX', alias: t('Node 1 Node Coordinate X') },
    { name: 'node1GridRefY', alias: t('Node 1 Node Coordinate Y') },
    { name: 'finishNodeRef', alias: t('Finish Node (Node 2 Reference)') },
    { name: 'depthAtFinishNode', alias: t('Depth at Finish Node') },
    { name: 'node2GridRefX', alias: t('Finish Node (Node 2) Coordinate X') },
    { name: 'node2GridRefY', alias: t('Finish Node (Node 2) Coordinate Y') },
    { name: 'node3Ref', alias: t('Node 3 Reference') },
    { name: 'node3GridRefX', alias: t('Node 3 Node Coordinate X') },
    { name: 'node3GridRefY', alias: t('Node 3 Node Coordinate Y') },
]; };
var mediaFields = function (t) { return [
    { name: 'videoImageStorage', alias: t('Video Image Storage Media') },
    {
        name: 'videoImageLocationSystem',
        alias: t('Video Image Location System'),
    },
    { name: 'videoImageFormat', alias: t('Video Image Format') },
    { name: 'videoImageFilename', alias: t('Video Image Filename') },
    { name: 'videoVolumeRef', alias: t('Video Volume Reference') },
    {
        name: 'photographicStorageFormat',
        alias: t('Photographic Image Storage Format'),
    },
    { name: 'photographicStorage', alias: t('Photographic Storage') },
    { name: 'photographicVolume', alias: t('Photographic Volume Reference') },
]; };
var hardCodeUnitFields = {
    heightDiameter: { unit: 'mm', min: 0, step: 'any' },
    width: { unit: 'mm', min: 0, step: 'any' },
    depthAtStartNode: { unit: 'm', step: 'any' },
    depthAtFinishNode: { unit: 'm', step: 'any' },
    expectedLength: { unit: 'm', min: 0, step: 'any' },
    surveyedLength: { unit: 'm', min: 0, step: 'any' },
    pipeUnitLength: { unit: 'm', min: 0, step: 'any' },
};
var hardCodeDateTimeFields = {
    uploadDateTime: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'uploadDateTime',
        useCompanyDateTime: true,
    },
    scheduledDate: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'scheduledDate',
    },
    date: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'surveyDateTime' },
    time: { mode: stylovyze_1.DateTimeInputMode.TIME, field: 'surveyDateTime' },
};
var hardCodeCurrencyFields = {};
var hardCodeNumericFields = {
    yearConstructed: { min: 0 },
    startNodeGridRefX: { step: 0.1 },
    startNodeGridRefY: { step: 0.1 },
    node1GridRefX: { step: 0.1 },
    node1GridRefY: { step: 0.1 },
    node2GridRefX: { step: 0.1 },
    node2GridRefY: { step: 0.1 },
    node3GridRefX: { step: 0.1 },
    node3GridRefY: { step: 0.1 },
};
var hardCodeBooleanFields = {};
var getDomainValues = function (t, fieldName) {
    var domainValueDic = {};
    switch (fieldName.toLowerCase()) {
        case 'locationCode'.toLowerCase():
            domainValueDic = {
                RD: t('Road'),
                FWY: t('A footway beside a road'),
                VG: t('Verge'),
                PD: t('Other Pedestrian area'),
                FLD: t('Fields (farmland and public open space)'),
                PR: t('Property with Buildings'),
                GDN: t('Gardens (within private property)'),
                BLG: t('Under a permanent Building'),
                WLD: t('Woodland'),
                DIF: t('Difficult access (motorway, railway, watercourse, inside building)'),
                WWY: t('Under a Waterway'),
                XS1: t('Left Outside Verge (adjacent to footway)'),
                XS2: t('Left Footway'),
                XS3: t('Left Verge/Verge'),
                XS4: t('Lane 1/Hard Shoulder'),
                XS5: t('Lane 2/Slow Lane'),
                XS6: t('Lane 3/Central Lane'),
                XS7: t('Lane 4/Fast Lane'),
                XS8: t('Right Verge/Central Reserve/Right Verge'),
                XS9: t('Right Footway'),
                XS0: t('Right Outside Verge (adjacent to footway) Not used'),
                XSE: t('Right turning lane'),
                XSQ: t('Slip Road'),
                XSR: t('Bus Lane'),
                XST: t('Crawler Lane'),
                XSW: t('Left Turning'),
                XSY: t('Any Other Option'),
            };
            break;
        case 'landObservation'.toLowerCase():
            domainValueDic = {
                PR: t('Private'),
                PU: t('Public'),
                X: t('Not Known'),
            };
            break;
        case 'useOfDrainSewer'.toLowerCase():
            domainValueDic = {
                C: t('Combined'),
                F: t('Foul'),
                S: t('Storm'),
                T: t('Trade Effluent'),
                W: t('Culverted Watercourse'),
                LD: t('Subsoil or Field Drainage'),
                Z: t('Other'),
            };
            break;
        case 'typeOfDrainSewer'.toLowerCase():
            domainValueDic = {
                A: t('Gravity Drain/Sewer'),
                B: t('Rising Main'),
                V: t('Vacuum'),
            };
            break;
        case 'direction'.toLowerCase():
            domainValueDic = {
                U: t('Survey Upstream'),
                D: t('Survey Downstream'),
                Z: t('Not Known'),
            };
            break;
        case 'shape'.toLowerCase():
            domainValueDic = {
                A: t('Arched'),
                B: t('Barrel'),
                C: t('Circular'),
                E: t('Egg-shaped'),
                H: t('Horseshoe'),
                O: t('Oval'),
                R: t('Rectangular'),
                T: t('Trapezoidal'),
                U: t('U-shaped with Flat Top'),
                K: t('Kerb Block'),
                CSC: t('Circular with Smaller Channel'),
                RSC: t('Rectangular with Smaller Channel'),
                Z: t('Other'),
            };
            break;
        case 'material'.toLowerCase():
            domainValueDic = {
                AC: t('Asbestos Cement'),
                BL: t('Bitumen (lining)'),
                BR: t('Brick'),
                CI: t('Cast Iron'),
                CL: t('Cement Mortar (lining)'),
                CO: t('Concrete'),
                CS: t('Concrete Segments'),
                DI: t('Ductile Iron'),
                EP: t('Epoxy'),
                FC: t('Fibre Cement'),
                FRP: t('Fibre Reinforced Plastics'),
                GI: t('Grey Cast Iron'),
                MAC: t('Masonry - Regular Courses'),
                MAR: t('Masonry - Randomly Coursed'),
                MX: t('Mixed Material Construction'),
                PVC: t('Polyvinyl Chloride'),
                PE: t('Polyethylene'),
                PF: t('Pitch Fibre'),
                PP: t('Polypropylene'),
                PS: t('Polyester'),
                RC: t('Reinforced Concrete'),
                SPC: t('Sprayed Concrete'),
                ST: t('Steel'),
                VC: t('Vitrified Clay'),
                X: t('Unidentified Material'),
                XI: t('Unidentified Type of Iron or Steel'),
                XP: t('Unidentified Type of Plastics'),
                Z: t('Other'),
            };
            break;
        case 'liningType'.toLowerCase():
            domainValueDic = {
                M: t('Lining Inserted During Manufacture'),
                SP: t('Sprayed Lining'),
                CIP: t('Cured-In=Place Lining'),
                SEG: t('Segmental Linings'),
                DP: t('Lining with Discrete Pipes'),
                CP: t('Lining with Continuous Pipes'),
                CF: t('Close Fit Lining'),
                SW: t('Spirally Wound Lining'),
                Z: t('Other'),
            };
            break;
        case 'preCleaned'.toLowerCase():
            domainValueDic = {
                Y: t('Yes'),
                N: t('No'),
                Z: t('Unknown'),
            };
            break;
        case 'purposeOfInspection'.toLowerCase():
            domainValueDic = {
                A: t('Investigation of known structural or service defects'),
                B: t('Investigation of infiltration problems'),
                C: t('Post completion inspection of repairs or renovations'),
                D: t('Pre-adoption survey prior to vesting as public sewer'),
                E: t('Post completion inspection of new sewers'),
                F: t('Sample survey of sewers to determine asset condition of a sewer system'),
                G: t('Routine inspection of condition'),
                H: t('Investigation of a suspected operational problem'),
                I: t('Investment planning'),
                J: t('End of warranty period'),
                X: t('Other'),
            };
            break;
        case 'inspectionStage'.toLowerCase():
            domainValueDic = {
                A: t('Information provided by client'),
                B: t('Information provided by the inspector to client'),
                Z: t('Other'),
            };
            break;
        case 'flowControlMeasures'.toLowerCase():
            domainValueDic = {
                N: t('No flow control'),
                BL: t('Flows blocked upstream'),
                PB: t('Flows partially blocked upstream'),
                X: t('Other'),
            };
            break;
        case 'weather'.toLowerCase():
            domainValueDic = {
                D: t('No rain or snow'),
                R: t('Rain'),
                S: t('Melting snow or ice'),
            };
            break;
        case 'methodOfInspection'.toLowerCase():
            domainValueDic = {
                A: t('Direct Inspection (man entry)'),
                B: t('CCTV'),
                C: t('Inspection from manhole or inspection chamber only'),
            };
            break;
        case 'videoImageStorageMedia'.toLowerCase():
            domainValueDic = {
                VHS: t('VHS video cassette tape'),
                CD: t('CD'),
                DVD: t('DAD'),
                PHD: t('Portable hard drive'),
                X: t('Other'),
            };
            break;
        case 'videoImageFormat'.toLowerCase():
            domainValueDic = {
                F: t('Fixed to media type'),
                MPEG1: t('MPEG1'),
                MPEG2: t('MPEG2'),
                MPEG4: t('MPEG4'),
                AVI: t('AVI'),
                VOB: t('VOB'),
                DIVX: t('DIVX'),
                Z: t('Other'),
            };
            break;
        case 'photographicImageStorageFormat'.toLowerCase():
            domainValueDic = {
                A: t('Still photographs'),
                C: t('Windows Meta File (WMF)'),
                D: t('Graphics Image File (GIF)'),
                E: t('JPEG file'),
                F: t('TIF'),
                G: t('PNG'),
                X: t('Other'),
            };
            break;
        case 'nodeType'.toLowerCase():
            domainValueDic = {
                MH: t('Manhole'),
                IC: t('Inspection Chamber'),
                RE: t('Rodding Eye'),
                LH: t('Lamphole'),
                OF: t('Outfall'),
                BR: t('Major Connection without Manhole'),
                GY: t('Gully'),
                CP: t('Catchpit'),
                SK: t('Soakaway'),
                OS: t('Oil Separator'),
                RG: t('Running Trap'),
                BN: t('Buchan Trap'),
                WR: t('Winser Trap'),
                OC: t('Other Special Chamber'),
            };
            break;
        case 'verticalReferencePoint'.toLowerCase():
            domainValueDic = {
                I: t('Invert lowest outgoing pipe in the manhole/inspection chamber'),
                C: t('Cover (highest corner of frame or highest point on a circular frame)'),
                OD: t('National Datum'),
                LD: t('Local Datum'),
                Z: t('Other'),
            };
            break;
        case 'useManhole'.toLowerCase():
            domainValueDic = {
                C: t('Combined'),
                F: t('Foul'),
                S: t('Surface Water'),
                T: t('Trade Effluent'),
                W: t('Culverted Watercourse'),
                Z: t('Other'),
            };
            break;
        case 'shapeOfCover'.toLowerCase():
            domainValueDic = {
                R: t('Rectangular'),
                C: t('Circular'),
                T: t('Triangular'),
                OV: t('Oval'),
                HX: t('Hexagonal'),
                OC: t('Octagonal'),
                Z: t('Other'),
            };
            break;
        case 'shapeOfAccess'.toLowerCase():
            domainValueDic = {
                C: t('Circular'),
                HX: t('Hexagonal'),
                OC: t('Octagonal'),
                OV: t('Oval'),
                R: t('Rectangular'),
                T: t('Triangular'),
                Z: t('Other'),
            };
            break;
        case 'materialOfStep'.toLowerCase():
            domainValueDic = {
                AL: t('Aluminium'),
                GI: t('Galvanised Iron'),
                IR: t('Iron/Steel'),
                PL: t('Plastic'),
                PM: t('Metal Encapsulated in Plastic'),
                SS: t('Stainless Steel'),
            };
            break;
        case 'locationOfObservation'.toLowerCase():
            domainValueDic = {
                CF: t('Cover and Frame'),
                AC: t('Adjusting Construction'),
                S: t('Shaft'),
                T: t('Taper'),
                RS: t('Reducing Slab'),
                CH: t('Chamber'),
                L: t('Landing'),
                B: t('Benching'),
                CHL: t('Channel'),
                I: t('Invert'),
            };
            break;
        default:
            break;
    }
    return domainValueDic;
};
var MSCCInspectionProps = function (_a) {
    var onReRender = _a.onReRender;
    var t = (0, _Translations_1.useGlobalization)().t;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentDateTime = (0, stylovyze_1.useCompanyDateTime)().currentDateTime;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var _b = react_1.default.useState(0), tabValue = _b[0], setTabValue = _b[1];
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var _c = react_1.default.useState(false), editHeaderDetails = _c[0], setEditHeaderDetails = _c[1];
    var _d = react_1.default.useState(false), formSubmitted = _d[0], setFormSubmitted = _d[1];
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    var origDetails = (0, react_1.useMemo)(function () {
        setFormSubmitted(false);
        var values = (0, _Utils_1.getJustValues)(inspection, false);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var viewDetails = (0, react_1.useMemo)(function () {
        var values = (0, _Utils_1.getJustValues)(inspection, true);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var inspUpdatestatus = (0, fullInspection_selectors_1.refreshInsp)();
    //feature to be behind a LaunchDarkley flag
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-inspections-header')
        ? true
        : false;
    var isFullEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-full-inspections')
        ? true
        : false;
    var isCreateAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-create-inspections');
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    var handleFormSubmit = function (data) {
        // We should really used the touched state of a field but I cant get the Formik stuff to work properly
        var changes = (0, common_utils_1.getChangedFormikFields)(origDetails, data);
        if (changes && Object.entries(changes).length !== 0) {
            setFormSubmitted(true);
            var allFields = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], generalFields(t), true), locationFields(t), true), pipeFields(t), true), manholesFields(t), true), mediaFields(t), true);
            var editedFieldsList = (0, common_utils_1.processFormSubmit)(t, inspection_types_1.InspectionStandard.PACP, origDetails, changes, allFields, hardCodeDateTimeFields, hardCodeUnitFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, getSystemValueFormatted, formatDateUTC, companySettings, t('Date/Time of inspection'), { date: 'date', time: 'time' });
            dispatch((0, inspection_actions_1.refreshInspection)({ status: -1 })); //reset update flag and hide the controls
            dispatch((0, inspection_actions_1.updateInspection)(editedFieldsList)); //trigger update
        }
    };
    //when inspection has been updated, page needs to be refreshed to display latest details
    (0, react_1.useEffect)(function () {
        if (inspUpdatestatus === 200 && onReRender)
            onReRender();
    }, [inspUpdatestatus]);
    var general = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('General'), dataCy: "modified-info-card-general", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, generalFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, isHiddenField, !isCreateAllowedFlag, getDomainValues, common_utils_1.getDomainItems) })) })));
    var location = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Location'), dataCy: "modified-info-card-location", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, locationFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    var pipe = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Construction'), dataCy: "modified-info-card-construction", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, pipeFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    var manholes = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Manholes'), dataCy: "modified-info-card-manholes", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, manholesFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    var media = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Media'), dataCy: "modified-info-card-media", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, mediaFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, getDomainValues, common_utils_1.getDomainItems) })) })));
    if (!isLoading && origDetails && !formSubmitted) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeFormV2, __assign({ mode: editHeaderDetails ? 'edit' : 'view', initialValues: editHeaderDetails ? origDetails : viewDetails, enableReinitialize: true, onSubmit: function (data) {
                setEditHeaderDetails(false);
                handleFormSubmit(data);
            } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, __assign({ "$height": 683 }, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: tabValue, onChange: handleChangeTab, "aria-label": "manhole-attributes" }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('General') }, (0, _Utils_1.a11yProps)(0))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Location') }, (0, _Utils_1.a11yProps)(1))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Pipe') }, (0, _Utils_1.a11yProps)(2))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Manholes') }, (0, _Utils_1.a11yProps)(3))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Media') }, (0, _Utils_1.a11yProps)(4)))] })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 0 }, { children: general })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 1 }, { children: location })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 2 }, { children: pipe })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 3 }, { children: manholes })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 4 }, { children: media }))] })) })));
            } })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '25px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    }
};
exports.MSCCInspectionProps = MSCCInspectionProps;
exports["default"] = exports.MSCCInspectionProps;


/***/ }),

/***/ "./components/MSCCInspectionProps/index.ts":
/*!*************************************************!*\
  !*** ./components/MSCCInspectionProps/index.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var MSCCInspectionProps_component_1 = __webpack_require__(/*! ./MSCCInspectionProps.component */ "./components/MSCCInspectionProps/MSCCInspectionProps.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(MSCCInspectionProps_component_1).default; } }));


/***/ }),

/***/ "./components/ModifiedInfoCard/ModifiedInfoCard.styles.tsx":
/*!*****************************************************************!*\
  !*** ./components/ModifiedInfoCard/ModifiedInfoCard.styles.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyle = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useStyle = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        editBtn: {
            marginRight: '24px',
        },
        cancelBtn: {
            marginRight: '10px',
        },
        saveBtn: {
            marginRight: '24px',
        },
        contentWrapper: {
            alignItems: 'center',
            display: 'flex',
            webkitBoxPack: 'justify',
            justifyContent: 'space-between',
            fontSize: '1.125rem',
            padding: '0.5rem 0.9375rem 0.5rem 1.5rem',
            webKitBoxAlign: 'center',
            fontWeight: 600,
            height: '3.281rem',
        },
    });
});


/***/ }),

/***/ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx":
/*!**********************************************************!*\
  !*** ./components/ModifiedInfoCard/ModifiedInfoCard.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModifiedInfoCard = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var ModifiedInfoCard_styles_1 = __webpack_require__(/*! ./ModifiedInfoCard.styles */ "./components/ModifiedInfoCard/ModifiedInfoCard.styles.tsx");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var ModifiedInfoCard = function (_a) {
    var title = _a.title, children = _a.children, errorMessage = _a.errorMessage, _b = _a.dataCy, dataCy = _b === void 0 ? 'modified-info-card' : _b, className = _a.className, _c = _a.showEditBtn, showEditBtn = _c === void 0 ? false : _c, _d = _a.launchDarkleyFlag, launchDarkleyFlag = _d === void 0 ? false : _d, _e = _a.onEditClick, onEditClick = _e === void 0 ? function () { return undefined; } : _e, _f = _a.onCancelClick, onCancelClick = _f === void 0 ? function () { return undefined; } : _f, _g = _a.onSaveClick, onSaveClick = _g === void 0 ? function () { return undefined; } : _g, _h = _a.inEditMode, inEditMode = _h === void 0 ? false : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j;
    var t = (0, _Translations_1.useGlobalization)().t;
    var classes = (0, ModifiedInfoCard_styles_1.useStyle)();
    var header = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.contentWrapper }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.TextOverflow, { children: title }), showEditBtn && launchDarkleyFlag && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !inEditMode ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", className: classes.editBtn, onClick: onEditClick, disabled: disabled }, { children: t('Edit') })) })) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "secondary", type: "reset", className: classes.cancelBtn, onClick: onCancelClick }, { children: t('Cancel') })), (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", className: classes.saveBtn, type: "submit", onClick: onSaveClick }, { children: t('Submit') }))] })) }))] })));
    var body = ((0, jsx_runtime_1.jsx)(stylovyze_1.WidgetErrorBoundary, __assign({ errorMessage: errorMessage }, { children: children })));
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.ContentCard, __assign({ header: header, applyHeaderDivider: true, applyBodyPadding: true, fullHeight: true, applyMarginBottom: true, className: className, dataCy: dataCy }, { children: body })));
};
exports.ModifiedInfoCard = ModifiedInfoCard;
exports["default"] = exports.ModifiedInfoCard;


/***/ }),

/***/ "./components/ObservationNotes/ObservationNotes.component.tsx":
/*!********************************************************************!*\
  !*** ./components/ObservationNotes/ObservationNotes.component.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ObservationNotes = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var ObservationNotes_styles_1 = __webpack_require__(/*! ./ObservationNotes.styles */ "./components/ObservationNotes/ObservationNotes.styles.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var user_selectors_1 = __webpack_require__(/*! @Selectors/user.selectors */ "./selectors/user.selectors.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        messageBody: {
            height: function (props) { return "".concat(props.bodyHeight); },
            overflow: 'auto',
        },
        waitingBody: {
            height: function (props) { return "".concat(props.waitingHeight); },
            overflow: 'auto',
        },
        messageEntry: {
            padding: '0 25px 0 16px',
            height: function (props) { return "".concat(props.entryHeight); },
        },
        listText: {
            display: 'grid',
            gridTemplateColumns: 'auto',
            gridTemplateRows: 'auto',
            gridTemplateAreas: '"date"	"content"',
            '&>.MuiListItemText-primary': {
                gridArea: 'content',
            },
            '&>.MuiListItemText-seconday': {
                gridArea: 'date',
            },
        },
        systemChip: {
            textTransform: 'capitalize',
            margin: '0 8px 0 0',
        },
    });
});
var ObservationNotes = function (_a) {
    var Notes = _a.Notes, dataCy = _a.dataCy, readOnly = _a.readOnly, isWaiting = _a.isWaiting, keepHeightWhenWaiting = _a.keepHeightWhenWaiting, _b = _a.bodyHeight, bodyHeight = _b === void 0 ? '173px' : _b, _c = _a.entryHeight, entryHeight = _c === void 0 ? '110px' : _c, _d = _a.waitingHeight, waitingHeight = _d === void 0 ? bodyHeight : _d, onSubmit = _a.onSubmit;
    var classes = useStyles({
        bodyHeight: bodyHeight,
        entryHeight: entryHeight,
        waitingHeight: waitingHeight,
    });
    var t = (0, _Translations_1.useGlobalization)().t;
    var _e = (0, react_1.useState)(''), newNote = _e[0], setNewNote = _e[1];
    var _f = (0, react_1.useState)(''), validation = _f[0], setValidation = _f[1];
    var userInitial = (0, user_selectors_1.selectUserInitial)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    (0, react_1.useEffect)(function () {
        var obj = document.getElementsByClassName(classes.messageBody);
        if (obj.length > 0) {
            obj[0].scrollTop = obj[0].scrollHeight;
        }
    });
    var handleSystemNotes = function (note, formattedDateTime) {
        if (note.noteType === _Types_1.NoteType.SYSTEM)
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Chip, { title: t('Automatically generated in Info360'), label: t(note.noteType), size: 'small', className: classes.systemChip }), (0, jsx_runtime_1.jsx)("span", { children: formattedDateTime })] }));
        return (0, jsx_runtime_1.jsx)("span", { children: formattedDateTime });
    };
    var translateInspectionStatus = function (note) {
        if (note.noteType === _Types_1.NoteType.SYSTEM) {
            var systemNotes = {
                STATUS_CHANGE: 'Status Changed to',
            };
            // Handle Inspection Status Change note
            if (note.note.startsWith(systemNotes.STATUS_CHANGE)) {
                // Retrieve status from note text
                var status_1 = (note.note.split('Status Changed to')[1] || '').trim();
                return "".concat(t(systemNotes.STATUS_CHANGE), " ").concat(t(status_1));
            }
            else {
                return t(note.note);
            }
        }
        return note.note;
    };
    if (isWaiting) {
        if (keepHeightWhenWaiting) {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, className: classes.waitingBody }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })) })));
        }
        else {
            return (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {});
        }
    }
    else {
        return ((0, jsx_runtime_1.jsxs)(ObservationNotes_styles_1.NotesWrapper, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, className: classes.messageBody }, { children: (0, jsx_runtime_1.jsx)(material_1.List, __assign({ "data-cy": dataCy }, { children: Notes === null || Notes === void 0 ? void 0 : Notes.filter(function (note) { return note._id && note._id.length > 0; }).map(function (Note, index) { return ((0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ alignItems: "flex-start", "data-cy": dataCy + '-' + index }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemAvatar, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, __assign({ title: Note.userName, "data-cy": dataCy + '-' + index + '-Avatar' }, { children: Note.userInitial.toUpperCase() })) }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { className: classes.listText, primary: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                            overflowWrap: 'anywhere',
                                        } }, { children: translateInspectionStatus(Note) })), secondary: handleSystemNotes(Note, (0, _Utils_1.formatDateTimeWithFormatDate)(Note.dateTime, formatDate)), "data-cy": dataCy + '-' + index + '-Item' })] }), Note._id)); }) })) })), !readOnly ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, className: classes.messageEntry, container: true, spacing: 1, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, __assign({ "data-cy": dataCy + '-Avatar' }, { children: userInitial })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: true, style: { padding: '12px' } }, { children: (0, jsx_runtime_1.jsx)("form", __assign({ noValidate: true, autoComplete: "off", onSubmit: function (event) {
                                    event.preventDefault();
                                    if (newNote.trimEnd().length == 0) {
                                        setValidation(t('Enter a note'));
                                    }
                                    else {
                                        setValidation('');
                                        if (onSubmit)
                                            onSubmit(newNote, userInitial);
                                        setNewNote('');
                                    }
                                } }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { error: validation.length != 0, helperText: validation, fullWidth: true, value: newNote, onChange: function (event) {
                                        return setNewNote(event.target.value);
                                    }, id: "input-with-icon-grid", label: t('Notes'), placeholder: t('Add Notes'), variant: "outlined", "data-cy": dataCy + '-Text' }) })) }))] }))) : ([])] })));
    }
};
exports.ObservationNotes = ObservationNotes;
exports["default"] = exports.ObservationNotes;


/***/ }),

/***/ "./components/ObservationNotes/ObservationNotes.styles.ts":
/*!****************************************************************!*\
  !*** ./components/ObservationNotes/ObservationNotes.styles.ts ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotesWrapper = void 0;
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.NotesWrapper = (0, styled_components_1.default)(material_1.Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding-left: ", ";\n\tbackground-color: ", ";\n"], ["\n\tpadding-left: ", ";\n\tbackground-color: ", ";\n"])), (0, styles_1.rem)(25), function (_a) {
    var theme = _a.theme;
    return theme.palette.background.paper;
});
var templateObject_1;


/***/ }),

/***/ "./components/ObservationNotes/index.ts":
/*!**********************************************!*\
  !*** ./components/ObservationNotes/index.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ObservationNotes_component_1 = __webpack_require__(/*! ./ObservationNotes.component */ "./components/ObservationNotes/ObservationNotes.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ObservationNotes_component_1).default; } }));


/***/ }),

/***/ "./components/ObservationPhoto/ObservationPhoto.components.tsx":
/*!*********************************************************************!*\
  !*** ./components/ObservationPhoto/ObservationPhoto.components.tsx ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ObservationPhoto = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
__webpack_require__(/*! ./ObservationPhoto.style.css */ "./components/ObservationPhoto/ObservationPhoto.style.css");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var RootDiv = styled_components_1.default.div({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    overflow: 'auto',
    backgroundColor: stylovyze_1.innovyzeTheme.palette.background.paper,
    '& .MuiGridListTile-root': {
        paddingLeft: '13px !important',
        paddingRight: '13px !important',
    },
    padding: '5px',
});
var ImagePopup = styled_components_1.default.div({
    position: 'absolute',
    width: 'fit-content',
    minWidth: '200px',
    backgroundColor: stylovyze_1.innovyzeTheme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: stylovyze_1.innovyzeTheme.shadows[5],
    padding: stylovyze_1.innovyzeTheme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
});
var ObservationPhoto = function (_a) {
    var 
    // observationId,
    time = _a.time, forEdit = _a.forEdit, observations = _a.observations, getMediaInspectionId = _a.getMediaInspectionId, noMinHeight = _a.noMinHeight;
    var _b = (0, react_1.useState)(''), imagePath = _b[0], setImage = _b[1];
    var _c = react_1.default.useState(false), open = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)(-1), observationId = _d[0], setObservationId = _d[1];
    // This allows us to size the ImageList as if it was a grid
    var isMD = (0, material_1.useMediaQuery)(stylovyze_1.innovyzeTheme.breakpoints.up('md'));
    var isLG = (0, material_1.useMediaQuery)(stylovyze_1.innovyzeTheme.breakpoints.up('lg'));
    var isXL = (0, material_1.useMediaQuery)(stylovyze_1.innovyzeTheme.breakpoints.up('xl'));
    var handleOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var selected = [];
    (0, react_1.useEffect)(function () {
        if (time >= 0) {
            selected = observations === null || observations === void 0 ? void 0 : observations.map(function (observation) {
                return {
                    id: observation.conditionId,
                    time: (0, _Utils_1.getTimeCounter)(observation),
                    mediaInspectionId: observation.mediaInspectionId,
                };
            }).filter(function (o) { return o.time <= time; }).filter(function (o) {
                if (getMediaInspectionId && o.mediaInspectionId) {
                    return getMediaInspectionId() === o.mediaInspectionId;
                }
                return true;
            }).sort(function (a, b) { return b.time - a.time; });
            if (selected &&
                selected.length > 0 &&
                selected[0].id != observationId)
                setObservationId(selected[0].id);
        }
    }, [time]);
    var body = function () {
        if (imagePath && (imagePath === null || imagePath === void 0 ? void 0 : imagePath.trim().length) > 0) {
            return ((0, jsx_runtime_1.jsx)(ImagePopup, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, style: {
                        justifyContent: 'center',
                        position: 'relative',
                    } }, { children: (0, jsx_runtime_1.jsx)("img", { src: imagePath, alt: "observation", onError: function (e) {
                            var target = e.target;
                            target.src = __webpack_require__(/*! ./missing.png */ "./components/ObservationPhoto/missing.png");
                        } }) })) }));
        }
        else
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    var columns = function () {
        if (isXL) {
            return forEdit ? 4 : 5;
        }
        else if (isLG) {
            return forEdit ? 3 : 4;
        }
        else if (isMD) {
            return forEdit ? 2 : 3;
        }
        return 1;
    };
    return ((0, jsx_runtime_1.jsxs)(RootDiv, __assign({ style: { minHeight: noMinHeight ? '' : '250px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.ImageList, __assign({ rowHeight: 120, style: { width: '98%', paddingTop: '12px', overflow: 'hidden' }, cols: columns() }, { children: observations
                    .filter(function (observation) {
                    return observation.mediaConditions &&
                        observation.mediaConditions.length > 0 &&
                        observation.mediaConditions[0].imagePath &&
                        observation.mediaConditions[0].imagePath.trim()
                            .length > 0;
                })
                    .sort(function (a, b) {
                    return a.distance - b.distance;
                })
                    .map(function (observation) {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(material_1.ImageListItem, __assign({ onClick: function () {
                            setObservationId(observation.conditionId);
                            setImage(observation.mediaConditions[0].imagePath);
                            handleOpen();
                        }, cols: 1, className: 'observationPhoto' }, { children: (0, jsx_runtime_1.jsx)("div", { className: observation.conditionId == observationId
                                ? 'selected'
                                : '', style: {
                                height: '100px',
                                width: '100px',
                                margin: '0 auto',
                                background: 'center',
                                backgroundSize: 'cover',
                                backgroundImage: "url(".concat((_a = observation.mediaConditions[0]
                                    .imageThumnailPath) !== null && _a !== void 0 ? _a : observation.mediaConditions[0].imagePath, "), url(").concat(__webpack_require__(/*! ./missing.png */ "./components/ObservationPhoto/missing.png")),
                            } }) }), observation.conditionId));
                }) })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Modal, __assign({ open: open, onClose: handleClose, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description" }, { children: body() })) })] })));
};
exports.ObservationPhoto = ObservationPhoto;
exports["default"] = exports.ObservationPhoto;


/***/ }),

/***/ "./components/ObservationPhoto/index.ts":
/*!**********************************************!*\
  !*** ./components/ObservationPhoto/index.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ObservationPhoto_components_1 = __webpack_require__(/*! ./ObservationPhoto.components */ "./components/ObservationPhoto/ObservationPhoto.components.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ObservationPhoto_components_1).default; } }));


/***/ }),

/***/ "./components/ObservationSearchBar/ObservationSearchBar.component.tsx":
/*!****************************************************************************!*\
  !*** ./components/ObservationSearchBar/ObservationSearchBar.component.tsx ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var TextField_1 = __importDefault(__webpack_require__(/*! @mui/material/TextField */ "@mui/material/TextField"));
var Autocomplete_1 = __importDefault(__webpack_require__(/*! @mui/material/Autocomplete */ "@mui/material/Autocomplete"));
var ObservationSearchBar = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 250 : _b, props = __rest(_a, ["width"]);
    var handleKeyDown = function (event) {
        if (event.key === 'Enter') {
            var target = event === null || event === void 0 ? void 0 : event.target;
            props.handleSearchSubmit(target === null || target === void 0 ? void 0 : target.value);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { width: width, paddingLeft: 14 } }, { children: (0, jsx_runtime_1.jsx)(Autocomplete_1.default, { id: "codeSearch", freeSolo: true, options: props.codes, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(TextField_1.default, __assign({}, params, { label: props.label, variant: "outlined" }))); }, onKeyDown: handleKeyDown }) })));
};
exports["default"] = ObservationSearchBar;


/***/ }),

/***/ "./components/ObservationSearchBar/index.ts":
/*!**************************************************!*\
  !*** ./components/ObservationSearchBar/index.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ObservationSearchBar_component_1 = __webpack_require__(/*! ./ObservationSearchBar.component */ "./components/ObservationSearchBar/ObservationSearchBar.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ObservationSearchBar_component_1).default; } }));


/***/ }),

/***/ "./components/ObservationSummary/ObservationSummary.component.tsx":
/*!************************************************************************!*\
  !*** ./components/ObservationSummary/ObservationSummary.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ObservationSummary = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var ObservationSummary = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 241 : _b;
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { alt: "summary", src: __webpack_require__(/*! ./summary.jpg */ "./components/ObservationSummary/summary.jpg"), style: { height: "".concat(height, "px") } }) }));
};
exports.ObservationSummary = ObservationSummary;
exports["default"] = exports.ObservationSummary;


/***/ }),

/***/ "./components/ObservationSummary/index.ts":
/*!************************************************!*\
  !*** ./components/ObservationSummary/index.ts ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ObservationSummary_component_1 = __webpack_require__(/*! ./ObservationSummary.component */ "./components/ObservationSummary/ObservationSummary.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ObservationSummary_component_1).default; } }));


/***/ }),

/***/ "./components/ObservationTable/ObservationTable.component.tsx":
/*!********************************************************************!*\
  !*** ./components/ObservationTable/ObservationTable.component.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ObservationTable = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var clsx_1 = __importDefault(__webpack_require__(/*! clsx */ "../node_modules/clsx/dist/clsx.js"));
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var editHeader = [
    {
        cell: '',
        dataCy: 'col-Edit',
        key: 'Edit',
        width: '68px',
        align: 'center',
        padding: '0 10px',
    },
];
var useStyle = (0, styles_1.makeStyles)(function () { return ({
    ObservationTable: {
        height: '100%',
        width: '100%',
        background: 'white',
        '& > div > div': {
            overflow: 'auto',
            height: '100%',
            width: '100%',
        },
        '& > div ': {
            overflow: 'auto',
            height: '100%',
            width: '100%',
        },
    },
}); });
//change VCR time format
var formatVcrTime = function (sLabel) {
    if (sLabel && sLabel.length == 6) {
        return (sLabel.substring(0, 2) +
            ':' +
            sLabel.substring(2, 4) +
            ':' +
            sLabel.substring(4, 6));
    }
    return sLabel;
};
var ObservationTable = function (_a) {
    var onObservationRowClicked = _a.onObservationRowClicked, onEditObservationClick = _a.onEditObservationClick, onDeleteClicked = _a.onDeleteClicked, observationsSelector = _a.observationsSelector, standard = _a.standard, getObservationAction = _a.getObservationAction, inspectionId = _a.inspectionId, playerTime = _a.playerTime, getMediaInspectionId = _a.getMediaInspectionId, searchCode = _a.searchCode, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.headers, headers = _c === void 0 ? [] : _c, _d = _a.jointOnly, jointOnly = _d === void 0 ? false : _d, _e = _a.continuousOnly, continuousOnly = _e === void 0 ? false : _e, _f = _a.stepOnly, stepOnly = _f === void 0 ? false : _f, _g = _a.gradeFilters, gradeFilters = _g === void 0 ? [] : _g, _h = _a.typeFilters, typeFilters = _h === void 0 ? [] : _h, _j = _a.isLoading, isLoading = _j === void 0 ? false : _j, boundaryConditionId = _a.boundaryConditionId;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var classes = useStyle();
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var observations = observationsSelector(standard);
    var _k = (0, react_1.useState)(true), firstMount = _k[0], setFirstMount = _k[1];
    (0, react_1.useEffect)(function () {
        if (firstMount && standard !== undefined && observations.length == 0) {
            dispatch(getObservationAction({
                standard: standard,
                inspectionID: inspectionId,
                jointOnly: jointOnly,
                continuousOnly: continuousOnly,
                stepOnly: stepOnly,
                gradeFilters: gradeFilters,
                typeFilters: typeFilters,
            }));
            setFirstMount(false);
        }
    }, [firstMount]);
    var _l = (0, react_1.useState)(false), isHoverMenu = _l[0], setHoverMenu = _l[1];
    var _m = (0, react_1.useState)(-1), observationId = _m[0], setObservationId = _m[1];
    var createHeader = function (cell, dataCy, key, width, padding, dontWrapCellInT) {
        return {
            cell: dontWrapCellInT ? cell : (0, _Utils_1.wrapHeader)(t(cell)),
            dataCy: dataCy,
            key: key,
            width: width,
            padding: padding,
        };
    };
    var defaultPACPHeaders = [
        createHeader('Distance', 'col-Distance', 'Distance', '100px', '0 10px'),
        createHeader('Code', 'col-Full_PACP_Code', 'Full_PACP_Code', '50px', '0 10px'),
        createHeader('CD', 'col-CD', 'CD', '50px', '0 10px'),
        createHeader('Time', 'col-Timestamp', 'Timestamp', '100px', '0 10px'),
        createHeader('At/From', 'col-At/From', 'At/From', '50px', '0 10px'),
        createHeader('To', 'col-To', 'To', '50px', '0 10px'),
        createHeader('1st', 'col-1st', '1st', '50px', '0 10px'),
        createHeader('2nd', 'col-2nd', '2nd', '50px', '0 10px'),
        createHeader('%', 'col-%', '%', '50px', '0 10px', true),
        createHeader('Struct.', 'col-SctructuralScore', 'SctructuralScore', '50px', '0 10px'),
        createHeader('O&M', 'col-ServiceScore', 'ServiceScore', '50px', '0 10px'),
        createHeader('Remarks', 'col-Remarks', 'Remarks', '200px', '0 10px'),
    ];
    var defaultMACPHeaders = [
        createHeader('Distance', 'col-Distance', 'Distance', '100px', '0 10px'),
        createHeader('Code', 'col-Full_PACP_Code', 'Full_PACP_Code', '50px', '0 10px'),
        createHeader('CD', 'col-CD', 'CD', '50px', '0 10px'),
        createHeader('Time', 'col-Time', 'Time', '100px', '0 10px'),
        createHeader('At/From', 'col-At', 'At/From', '50px', '0 10px'),
        createHeader('To', 'col-To', 'To', '50px', '0 10px'),
        createHeader('1st', 'col-Dimension1', 'Dim1', '50px', '0 10px'),
        createHeader('2nd', 'col-Dimension2', 'Dim2', '50px', '0 10px'),
        createHeader('%', 'col-%', '%', '50px', '0 10px', true),
        createHeader('Loc.', 'col-Loc', 'Loc', '50px', '0 10px'),
        createHeader('Struct.', 'col-Struct', 'Struct', '50px', '0 10px'),
        createHeader('O&M', 'col-OM', 'OM', '50px', '0 10px'),
        createHeader('Remarks', 'col-Remarks', 'Remarks', '200px', '0 10px'),
    ];
    var defaultMSCCHeaders = [
        createHeader('Distance', 'col-Distance', 'Distance', '100px', '0 10px'),
        createHeader('Code', 'col-Full_PACP_Code', 'Full_PACP_Code', '50px', '0 10px'),
        createHeader('CD', 'col-CD', 'CD', '50px', '0 10px'),
        createHeader('Time', 'col-Timestamp', 'Timestamp', '100px', '0 10px'),
        createHeader('At / From', 'col-At/From', 'At/From', '40px', '0 10px'),
        createHeader('To', 'col-To', 'To', '40px', '0 10px'),
        createHeader('Dim 1', 'col-1st', '1st', '40px', '0 10px'),
        createHeader('Dim 2', 'col-2nd', '2nd', '40px', '0 10px'),
        createHeader('Band', 'col-Band', 'Band', '50px', '0 10px'),
        createHeader('Material', 'col-Material', 'Material', '50px', '0 10px'),
        createHeader('%', 'col-%', '%', '50px', '0 10px', true),
        createHeader('Struct.', 'col-SctructuralScore', 'SctructuralScore', '50px', '0 10px'),
        createHeader('Service', 'col-ServiceScore', 'ServiceScore', '50px', '0 10px'),
        createHeader('Remarks', 'col-Remarks', 'Remarks', '200px', '0 10px'),
    ];
    var defaultWSA05Headers = [
        createHeader('Distance', 'col-Distance', 'Distance', '100px', '0 10px'),
        createHeader('Code', 'col-Full_PACP_Code', 'Full_PACP_Code', '50px', '0 10px'),
        createHeader('CD', 'col-CD', 'CD', '50px', '0 10px'),
        createHeader('Time', 'col-Timestamp', 'Timestamp', '100px', '0 10px'),
        createHeader('At/From', 'col-At/From', 'At/From', '50px', '0 10px'),
        createHeader('To', 'col-To', 'To', '50px', '0 10px'),
        createHeader('Char. 1', 'col-c1', '1st', '50px', '0 10px'),
        createHeader('Char. 2', 'col-c2', '2nd', '50px', '0 10px'),
        createHeader('Quant. 1', 'col-q1', 'quant1', '50px', '0 10px'),
        createHeader('Quant. 2', 'col-q2', 'quant2', '50px', '0 10px'),
        createHeader('Struct.', 'col-SctructuralScore', 'SctructuralScore', '50px', '0 10px'),
        createHeader('Service', 'col-ServiceScore', 'ServiceScore', '50px', '0 10px'),
        createHeader('Remarks', 'col-Remarks', 'Remarks', '200px', '0 10px'),
    ];
    var selected = [];
    (0, react_1.useEffect)(function () {
        if (playerTime >= 0) {
            selected = observations === null || observations === void 0 ? void 0 : observations.map(function (observation) {
                var obs = observation;
                return {
                    id: obs.conditionId,
                    time: (0, _Utils_1.getTimeCounter)(obs),
                    mediaInspectionId: obs.mediaInspectionId,
                };
            }).sort(function (a, b) { return b.time - a.time; }).filter(function (o) { return o.time <= playerTime; }).filter(function (o) {
                if (getMediaInspectionId && o.mediaInspectionId) {
                    return getMediaInspectionId() === o.mediaInspectionId;
                }
                return true;
            });
            if (selected &&
                selected.length > 0 &&
                selected[0].id != observationId) {
                setObservationId(selected[0].id);
            } //end if selected
        } //end if playertime
    }, [playerTime]);
    //returns a banner to indicate merged inspection
    var MergedInspectionBanner = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
                backgroundColor: '#007CA0',
                color: 'white',
                fontSize: '16px',
                fontStyle: 'italic',
                fontWeight: 600,
                marginLeft: '-11px',
                marginRight: '-11px',
                height: '32.8px',
                padding: '5px 10px 0px 0px',
                textAlign: 'center',
                flexBasis: '105%',
            } }, { children: t('Pipe section not inspected') })));
    };
    var observationRows = observations === null || observations === void 0 ? void 0 : observations.filter(function (observation) {
        if (searchCode && searchCode.trim().length > 0) {
            var code = '';
            switch (standard) {
                case _Types_1.InspectionStandard.MACP:
                    code = observation.macpCode;
                    break;
                case _Types_1.InspectionStandard.MSCC:
                    code = observation.code;
                    break;
                case _Types_1.InspectionStandard.WSA05:
                    code = observation.code;
                    break;
                case _Types_1.InspectionStandard.PACP:
                default:
                    code = observation.PACPCode;
                    break;
            }
            return code.toUpperCase() == searchCode.toUpperCase();
        }
        else {
            return true;
        }
    }).map(function (observation) {
        switch (standard) {
            case _Types_1.InspectionStandard.MACP: {
                var macpObs_1 = observation;
                if (boundaryConditionId === observation.conditionId) {
                    return {
                        cells: [
                            {
                                content: MergedInspectionBanner(),
                                props: {
                                    colSpan: 20,
                                },
                            },
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                    };
                }
                else
                    return {
                        cells: [
                            getSystemValueFormatted("".concat(macpObs_1.distance, "m"), '', 2),
                            macpObs_1.macpCode,
                            macpObs_1.continuous,
                            formatVcrTime(macpObs_1.vcrTime),
                            macpObs_1.clockAtFrom,
                            macpObs_1.clockTo,
                            macpObs_1.value1stDimension,
                            macpObs_1.value2ndDimension,
                            macpObs_1.valuePercent != undefined
                                ? Math.round(macpObs_1.valuePercent)
                                : macpObs_1.valuePercent,
                            macpObs_1.mHComponentId,
                            macpObs_1.structuralScore,
                            macpObs_1.serviceScore,
                            {
                                content: macpObs_1.remarks,
                                ellipsis: true,
                            },
                            readOnly ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)("div", __assign({ onMouseEnter: function () { return setHoverMenu(true); }, onMouseLeave: function () { return setHoverMenu(false); }, role: "button", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                                        {
                                            text: 'Edit',
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Edit, {}),
                                            onClick: function () {
                                                if (onEditObservationClick)
                                                    onEditObservationClick(standard, macpObs_1.conditionId);
                                            },
                                        },
                                        {
                                            text: 'Delete',
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}),
                                            onClick: function () {
                                                if (onDeleteClicked)
                                                    onDeleteClicked(observation);
                                            },
                                        },
                                    ], buttonCy: "actions" }) }), macpObs_1.conditionId)),
                        ],
                        dataCy: 'row' + macpObs_1.conditionId,
                        key: macpObs_1.conditionId,
                        onClick: function () {
                            if (!isHoverMenu && onObservationRowClicked) {
                                setObservationId(macpObs_1.conditionId);
                                onObservationRowClicked(standard, observation);
                            }
                        },
                        selected: observation.conditionId == observationId,
                    };
            }
            case _Types_1.InspectionStandard.MSCC: {
                var msccObs_1 = observation;
                if (boundaryConditionId === observation.conditionId) {
                    return {
                        cells: [
                            {
                                content: MergedInspectionBanner(),
                                props: {
                                    colSpan: 20,
                                },
                            },
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                    };
                }
                else {
                    return {
                        cells: [
                            getSystemValueFormatted("".concat(observation.distance, "m"), '', 2),
                            msccObs_1.code,
                            msccObs_1.continuous,
                            formatVcrTime(msccObs_1.videoRef),
                            msccObs_1.clockAtFrom,
                            msccObs_1.clockTo,
                            msccObs_1.value1stDimension,
                            msccObs_1.value2ndDimension,
                            msccObs_1.band,
                            msccObs_1.material,
                            msccObs_1.valuePercent,
                            msccObs_1.structuralScore,
                            msccObs_1.serviceScore,
                            {
                                content: msccObs_1.remarks,
                                ellipsis: true,
                            },
                            readOnly ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)("div", __assign({ onMouseEnter: function () { return setHoverMenu(true); }, onMouseLeave: function () { return setHoverMenu(false); }, role: "button", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                                        {
                                            text: t('Edit'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Edit, {}),
                                            onClick: function () {
                                                if (onEditObservationClick)
                                                    onEditObservationClick(standard, observation.conditionId);
                                            },
                                        },
                                        {
                                            text: t('Delete'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}),
                                            onClick: function () {
                                                if (onDeleteClicked)
                                                    onDeleteClicked(observation);
                                            },
                                        },
                                    ], buttonCy: "actions" }) }), observation.conditionId)),
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                        onClick: function () {
                            if (!isHoverMenu && onObservationRowClicked) {
                                setObservationId(msccObs_1.conditionId);
                                onObservationRowClicked(standard, observation);
                            }
                        },
                        selected: observation.conditionId == observationId,
                    };
                }
            }
            case _Types_1.InspectionStandard.WSA05: {
                var wsa05Obs_1 = observation;
                if (boundaryConditionId === observation.conditionId) {
                    return {
                        cells: [
                            {
                                content: MergedInspectionBanner(),
                                props: {
                                    colSpan: 20,
                                },
                            },
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                    };
                }
                else
                    return {
                        cells: [
                            getSystemValueFormatted("".concat(wsa05Obs_1.distance, "m"), '', 2),
                            wsa05Obs_1.code,
                            wsa05Obs_1.continuous,
                            formatVcrTime(wsa05Obs_1.videoPosition),
                            wsa05Obs_1.clockAtFrom,
                            wsa05Obs_1.clockTo,
                            wsa05Obs_1.char1,
                            wsa05Obs_1.char2,
                            wsa05Obs_1.quant1,
                            wsa05Obs_1.quant2,
                            wsa05Obs_1.structuralScore,
                            wsa05Obs_1.serviceScore,
                            {
                                content: wsa05Obs_1.remarks,
                                ellipsis: true,
                            },
                            readOnly ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)("div", __assign({ onMouseEnter: function () { return setHoverMenu(true); }, onMouseLeave: function () { return setHoverMenu(false); }, role: "button", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                                        {
                                            text: t('Edit'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Edit, {}),
                                            onClick: function () {
                                                if (onEditObservationClick)
                                                    onEditObservationClick(standard, observation.conditionId);
                                            },
                                        },
                                        {
                                            text: t('Delete'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}),
                                            onClick: function () {
                                                if (onDeleteClicked)
                                                    onDeleteClicked(observation);
                                            },
                                        },
                                    ], buttonCy: "actions" }) }), observation.conditionId)),
                        ],
                        dataCy: 'row' + observation.conditionId,
                        id: 'row' + observation.conditionId,
                        key: observation.conditionId,
                        onClick: function () {
                            if (!isHoverMenu && onObservationRowClicked) {
                                setObservationId(wsa05Obs_1.conditionId);
                                onObservationRowClicked(standard, observation);
                            }
                        },
                        selected: observation.conditionId == observationId,
                    };
            }
            case _Types_1.InspectionStandard.PACP:
            default: {
                var pacpObs_1 = observation;
                if (boundaryConditionId === observation.conditionId) {
                    return {
                        cells: [
                            {
                                content: MergedInspectionBanner(),
                                props: {
                                    colSpan: 20,
                                },
                            },
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                    };
                }
                else
                    return {
                        cells: [
                            getSystemValueFormatted("".concat(observation.distance, "m"), '', 2),
                            pacpObs_1.PACPCode,
                            pacpObs_1.continuous,
                            formatVcrTime(pacpObs_1.VCRTime),
                            pacpObs_1.clockAtFrom,
                            pacpObs_1.clockTo,
                            pacpObs_1.value1stDimension,
                            pacpObs_1.value2ndDimension,
                            pacpObs_1.valuePercent != undefined
                                ? Math.round(pacpObs_1.valuePercent)
                                : pacpObs_1.valuePercent,
                            pacpObs_1.structuralScore,
                            pacpObs_1.serviceScore,
                            {
                                content: pacpObs_1.remarks,
                                ellipsis: true,
                            },
                            readOnly ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)("div", __assign({ onMouseEnter: function () { return setHoverMenu(true); }, onMouseLeave: function () { return setHoverMenu(false); }, role: "button", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                                        {
                                            text: t('Edit'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Edit, {}),
                                            onClick: function () {
                                                if (onEditObservationClick)
                                                    onEditObservationClick(standard, observation.conditionId);
                                            },
                                        },
                                        {
                                            text: t('Delete'),
                                            icon: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}),
                                            onClick: function () {
                                                if (onDeleteClicked)
                                                    onDeleteClicked(observation);
                                            },
                                        },
                                    ], buttonCy: "actions" }) }), observation.conditionId)),
                        ],
                        dataCy: 'row' + observation.conditionId,
                        key: observation.conditionId,
                        onClick: function () {
                            if (!isHoverMenu && onObservationRowClicked) {
                                setObservationId(pacpObs_1.conditionId);
                                onObservationRowClicked(standard, observation);
                            }
                        },
                        selected: observation.conditionId == observationId,
                    };
            }
        }
    });
    var getHeader = function () {
        if (headers == undefined || headers.length == 0) {
            if (readOnly) {
                switch (standard) {
                    case _Types_1.InspectionStandard.MACP:
                        return defaultMACPHeaders;
                    case _Types_1.InspectionStandard.MSCC:
                        return defaultMSCCHeaders;
                    case _Types_1.InspectionStandard.WSA05:
                        return defaultWSA05Headers;
                    case _Types_1.InspectionStandard.PACP:
                    default:
                        return defaultPACPHeaders;
                }
            }
            else {
                switch (standard) {
                    case _Types_1.InspectionStandard.MACP:
                        return __spreadArray(__spreadArray([], defaultMACPHeaders, true), editHeader, true);
                    case _Types_1.InspectionStandard.MSCC:
                        return __spreadArray(__spreadArray([], defaultMSCCHeaders, true), editHeader, true);
                    case _Types_1.InspectionStandard.WSA05:
                        return __spreadArray(__spreadArray([], defaultWSA05Headers, true), editHeader, true);
                    case _Types_1.InspectionStandard.PACP:
                    default:
                        return __spreadArray(__spreadArray([], defaultPACPHeaders, true), editHeader, true);
                }
            }
        }
        else
            return headers;
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)(classes.ObservationTable), style: { minHeight: '300px' } }, { children: (observations === null || observations === void 0 ? void 0 : observations.length) >= 0 ? ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: "defect-table", headers: getHeader(), rows: observationRows, initialized: !isLoading, useSkeleton: { rowCount: 10 } })) : ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) })));
};
exports.ObservationTable = ObservationTable;
exports["default"] = exports.ObservationTable;


/***/ }),

/***/ "./components/ObservationTable/index.ts":
/*!**********************************************!*\
  !*** ./components/ObservationTable/index.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ObservationTable_component_1 = __webpack_require__(/*! ./ObservationTable.component */ "./components/ObservationTable/ObservationTable.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ObservationTable_component_1).default; } }));
__exportStar(__webpack_require__(/*! ./ObservationTable.component */ "./components/ObservationTable/ObservationTable.component.tsx"), exports);


/***/ }),

/***/ "./components/PACPInspectionProps/PACPInspectionProps.component.tsx":
/*!**************************************************************************!*\
  !*** ./components/PACPInspectionProps/PACPInspectionProps.component.tsx ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PACPInspectionProps = exports.getDomainValues = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var ModifiedInfoCard_1 = __importDefault(__webpack_require__(/*! @Components/ModifiedInfoCard/ModifiedInfoCard */ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx"));
var common_utils_1 = __webpack_require__(/*! @Utils/common.utils */ "./utils/common.utils.tsx");
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var EDITABLE_FIELDS = [
    'direction',
    'pipelineRef',
    'upstreamManholeId',
    'downstreamManholeId',
];
var NON_EDITABLE_FIELDS = ['uploadedBy', 'uploadDateTime'];
var isEditableField = function (fieldName, fullEdit) {
    return fullEdit
        ? !NON_EDITABLE_FIELDS.includes(fieldName)
        : EDITABLE_FIELDS.includes(fieldName);
};
var HIDDEN_FIELDS = ['uploadDateTime', 'scheduledDate'];
var isHiddenField = function (fieldName, hideFields) {
    return hideFields ? HIDDEN_FIELDS.includes(fieldName) : false;
};
var generalFields = function (t) { return [
    { name: 'uploadedBy', alias: t('Uploaded By') },
    { name: 'uploadDateTime', alias: t('Upload Date') },
    { name: 'scheduledDate', alias: t('Scheduled Date') },
    { name: 'surveyedBy', alias: t('Surveyed By') },
    { name: 'certificateNumber', alias: t('Certificate No') },
    {
        name: 'reviewerCertificateNumber',
        alias: t('Reviewer Certificate No.'),
    },
    { name: 'owner', alias: t('Owner') },
    { name: 'poNumber', alias: t('P/O Number') },
    { name: 'workOrder', alias: t('Work Order Number') },
    { name: 'mediaLabel', alias: t('Media Label') },
    { name: 'project', alias: t('Project') },
    { name: 'customer', alias: t('Customer') },
    { name: 'inspectionDate', alias: t('Date') },
    { name: 'inspectionTime', alias: t('Time') },
    { name: 'sheetNumber', alias: t('Sheet Number') },
    { name: 'weather', alias: t('Weather') },
    { name: 'preCleaning', alias: t('Pre-Cleaning') },
    { name: 'dateCleaned', alias: t('Date Cleaned') },
    { name: 'flowControl', alias: t('Flow Control') },
    { name: 'purpose', alias: t('Purpose of Survey') },
    { name: 'direction', alias: t('Direction of Survey') },
    { name: 'reverseSetup', alias: t('Reverse Setup') },
    {
        name: 'inspectionTechnologyUsedCCTV',
        alias: t('Inspection Technology Used CCTV'),
    },
    {
        name: 'inspectionTechnologyUsedLaser',
        alias: t('Inspection Technology Used Laser'),
    },
    {
        name: 'inspectionTechnologyUsedSonar',
        alias: t('Inspection Technology Used Sonar'),
    },
    {
        name: 'inspectionTechnologyUsedSidewall',
        alias: t('Inspection Technology Used Sidewall'),
    },
    {
        name: 'inspectionTechnologyUsedZoom',
        alias: t('Inspection Technology Used Zoom'),
    },
    {
        name: 'inspectionTechnologyUsedOther',
        alias: t('Inspection Technology Used Other'),
    },
    { name: 'status', alias: t('Status of Inspection') },
    {
        name: 'consequenceOfFailure',
        alias: t('Consequence of Failure'),
    },
    { name: 'pressureValue', alias: t('Pressure Value') },
    { name: 'sewerCategory', alias: t('Sewer Category') },
    { name: 'additionalInfo', alias: t('Additional Info') },
    { name: 'isImperial', alias: t('Is Imperial') },
]; };
var locationFields = function (t) { return [
    { name: 'drainageArea', alias: t('Drainage Area') },
    { name: 'pipelineRef', alias: t('Pipe Segment Reference') },
    { name: 'street', alias: t('Street Name and Number') },
    { name: 'city', alias: t('City') },
    { name: 'locationCode', alias: t('Location Code') },
    { name: 'locationDetails', alias: t('Location Details') },
]; };
var pipeFields = function (t) { return [
    { name: 'pipeUse', alias: t('Pipe Use') },
    { name: 'height', alias: t('Height') },
    { name: 'width', alias: t('Width') },
    { name: 'shape', alias: t('Shape') },
    { name: 'material', alias: t('Material') },
    { name: 'liningMethod', alias: t('Lining Method') },
    { name: 'coatingMethod', alias: t('Coating Method') },
    { name: 'pipeJointLength', alias: t('Pipe Joint Length') },
    { name: 'totalLength', alias: t('Total Length') },
    {
        name: 'lengthSurveyed',
        alias: t('Length of Pipe Surveyed'),
    },
    { name: 'yearConstructed', alias: t('Year Constructed') },
    { name: 'yearRenewed', alias: t('Year Renewed') },
]; };
var manholesFields = function (t) { return [
    {
        name: 'upstreamManholeId',
        alias: t('Upstream Manhole Number'),
    },
    {
        name: 'upRimToInvert',
        alias: t('Upstream Rim to Invert'),
    },
    {
        name: 'upRimToGrade',
        alias: t('Upstream Rim to Grade'),
    },
    {
        name: 'upGradeToInvert',
        alias: t('Upstream Grade to Invert'),
    },
    {
        name: 'upNorthing',
        alias: t('Upstream Manhole Northing'),
    },
    {
        name: 'upEasting',
        alias: t('Upstream Manhole Easting'),
    },
    {
        name: 'upElevation',
        alias: t('Upstream Manhole Elevation'),
    },
    {
        name: 'downstreamManholeId',
        alias: t('Downstream Manhole Number'),
    },
    {
        name: 'downRimToInvert',
        alias: t('Downstream Rim to Invert'),
    },
    {
        name: 'downRimToGrade',
        alias: t('Downstream Rim to Grade'),
    },
    {
        name: 'downGradeToInvert',
        alias: t('Downstream Grade to Invert'),
    },
    {
        name: 'downNorthing',
        alias: t('Downstream Manhole Northing'),
    },
    {
        name: 'downEasting',
        alias: t('Downstream Manhole Easting'),
    },
    {
        name: 'downElevation',
        alias: t('Downstream Manhole Elevation'),
    },
    {
        name: 'mhCoordinateSystem',
        alias: t('Coordinate System'),
    },
    { name: 'verticalDatum', alias: t('Vertical Datum') },
    { name: 'gpsAccuracy', alias: t('GPS Accuracy') },
]; };
var hardCodeUnitFields = {
    height: { unit: 'mm', min: 0, step: 'any' },
    width: { unit: 'mm', min: 0, step: 'any' },
    pipeJointLength: { unit: 'm', min: 0, step: 'any' },
    totalLength: { unit: 'm', min: 0, step: 'any' },
    lengthSurveyed: { unit: 'm', min: 0, step: 'any' },
    upRimToInvert: { unit: 'm', step: 'any' },
    upRimToGrade: { unit: 'm', step: 'any' },
    upGradeToInvert: { unit: 'm', step: 'any' },
    upElevation: { unit: 'm', step: 'any' },
    downRimToInvert: { unit: 'm', step: 'any' },
    downRimToGrade: { unit: 'm', step: 'any' },
    downGradeToInvert: { unit: 'm', step: 'any' },
    downElevation: { unit: 'm', step: 'any' },
};
var hardCodeDateTimeFields = {
    uploadDateTime: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'uploadDateTime',
        useCompanyDateTime: true,
    },
    scheduledDate: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'scheduledDate',
    },
    inspectionDate: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'surveyDateTime' },
    inspectionTime: { mode: stylovyze_1.DateTimeInputMode.TIME, field: 'surveyDateTime' },
    dateCleaned: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'dateCleaned' },
};
var hardCodeCurrencyFields = {};
var hardCodeNumericFields = {
    yearConstructed: { min: 0 },
    yearRenewed: { min: 0 },
    upNorthing: { step: 0.1 },
    upEasting: { step: 0.1 },
    downNorthing: { step: 0.1 },
    downEasting: { step: 0.1 },
};
var hardCodeBooleanFields = {
    inspectionTechnologyUsedCCTV: true,
    inspectionTechnologyUsedLaser: true,
    inspectionTechnologyUsedSonar: true,
    inspectionTechnologyUsedSidewall: true,
    inspectionTechnologyUsedZoom: true,
    inspectionTechnologyUsedOther: true,
    reverseSetup: true,
    isImperial: true,
};
var getDomainValues = function (t, fieldName) {
    var domainValueDic = {};
    switch (fieldName.toLowerCase()) {
        case 'coatingMethod'.toLowerCase():
            domainValueDic = {
                CM: t('Cement Mortar'),
                CT: t('Coal Tar or Bituminous'),
                EP: t('Epoxy'),
                PE: t('Polyethylene'),
                PO: t('Polyurethane'),
                PU: t('Polyurea'),
                PVC: t('Polyvinyl Chloride'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
            break;
        case 'direction'.toLowerCase():
            domainValueDic = {
                D: t('Downstream'),
                U: t('Upstream'),
            };
            break;
        case 'flowControl'.toLowerCase():
            domainValueDic = {
                B: t('Bypassed'),
                D: t('De-watered Using Jetter'),
                L: t('Lift Station'),
                N: t('Not Controlled'),
                P: t('Plugged'),
            };
            break;
        case 'gpsAccuracy'.toLowerCase():
            domainValueDic = {
                L: t('Survey Level'),
                M: t('Sub-Meter'),
                N: t('Nearest Meter'),
            };
            break;
        case 'locationCode'.toLowerCase():
            domainValueDic = {
                A: t('Primary Major Arterial Roads'),
                B: t('Secondary Roads'),
                C: t('Local Rural Streets'),
                D: t('Easement/Right of way'),
                E: t('Woods'),
                F: t('Sidewalk'),
                G: t('Parking lot'),
                H: t('Alley'),
                I: t('Ditch'),
                J: t('Building'),
                K: t('Creek'),
                L: t('Railway'),
                M: t('Airport'),
                N: t('Levee/Floodwall'),
                O: t('Dam'),
                P: t('Levee Pump Station'),
                Y: t('Yard'),
                Z: t('Other'),
            };
            break;
        case 'liningMethod'.toLowerCase():
            domainValueDic = {
                CIP: t('Cured-In-Place Pipe'),
                FF: t('Fold and Form or Deform/Reform'),
                FP: t('Formed-In-Place Liner'),
                GP: t('Grout-In-Place Liner'),
                GRC: t('Glass Reinforced Cement'),
                N: t('None'),
                SC: t('Continuous Slip Liner'),
                SE: t('Sectional Slip Liner'),
                SL: t('Spray Liner'),
                SN: t('Segmented Panel'),
                SP: t('Segmented Pipe'),
                SW: t('Spiral Wound'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
            break;
        case 'material'.toLowerCase():
            domainValueDic = {
                ABS: t('Acrylonitrile Butadiene Styrene'),
                AC: t('Asbestos Cement'),
                BR: t('Brick'),
                CAS: t('Cast Iron'),
                CLC: t('Clay-lined Concrete Pipe'),
                CMP: t('Corrugated Metal Pipe'),
                CP: t('Concrete Pipe (non-reinforced)'),
                CSB: t('Concrete Segments (bolted)'),
                CSU: t('Concrete Segments (unbolted)'),
                CT: t('Clay Tile (not vitrified clay)'),
                DIP: t('Ductile Iron Pipe'),
                FRP: t('Fiberglass Reinforced Pipe'),
                OB: t('Pitch Fiber (Orangeburg)'),
                PCP: t('Polymer Concrete Pipe'),
                PCCP: t('Pre-stressed Concrete Cylinder Pipe'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PSC: t('Plastic/Steel Composite'),
                PVC: t('Polyvinyl Chloride'),
                RCP: t('Reinforced Concrete Pipe'),
                RPM: t('Reinforced Plastic Pipe (Truss Pipe)'),
                SB: t('Segmented Block'),
                SP: t('Steel Pipe'),
                VCP: t('Vitrified Clay Pipe'),
                WD: t('Wood'),
                XXX: t('Not Known'),
                ZZZ: t('Other'),
            };
            break;
        case 'shape'.toLowerCase():
            {
                domainValueDic = {
                    A: t('Arched'),
                    B: t('Barrel'),
                    C: t('Circular'),
                    E: t('Egg-Shaped'),
                    H: t('Horseshoe'),
                    O: t('Oval (Elliptical)'),
                    R: t('Rectangular'),
                    S: t('Square'),
                    T: t('Trapezoidal'),
                    U: t('U-Shaped with Flat Top (straight walls)'),
                    Z: t('Other'),
                };
            }
            break;
        case 'pipeUse'.toLowerCase():
            domainValueDic = {
                CB: t('Combined Pipe'),
                DP: t('Dam Pipe'),
                FM: t('Force Main'),
                LG: t('Levee Gravity Pipe'),
                LP: t('Levee Pressure Pipe'),
                PR: t('Process Pipe'),
                SS: t('Sanitary Sewage Pipe'),
                SW: t('Stormwater Pipe'),
                XX: t('Not Known'),
                ZZ: t('Other'),
            };
            break;
        case 'purpose'.toLowerCase():
            domainValueDic = {
                A: t('Maintenance Related'),
                B: t('Infiltration/Inflow Investigation'),
                C: t('Post Rehabilitation Survey'),
                D: t('Pre-Rehabilitation Survey'),
                E: t('Pre-Acceptance New Sewers'),
                F: t('Routine Assessment'),
                G: t('Capital Improvement Program Assessment'),
                H: t('Resurvey For Any Reason'),
                I: t('Sewer System Evaluation Survey (SSES)'),
                R: t('Pre-Existing Video'),
                X: t('Not Known'),
            };
            break;
        case 'preCleaning'.toLowerCase():
            domainValueDic = {
                H: t('Heavy Cleaning'),
                L: t('Light Cleaning'),
                N: t('No Pre-Cleaning'),
                X: t('Not Known'),
                Z: t('Other'),
            };
            break;
        case 'status'.toLowerCase():
            domainValueDic = {
                CI: t('Complete Inspection'),
                BM: t('Buried and Marked'),
                NA: t('No Access'),
                NE: t('Does Not Exist'),
                NF: t('Not Found'),
                NI: t('Traffic'),
                NO: t('Not Opened'),
                SD: t('Surcharged/Debris'),
            };
            break;
        case 'weather'.toLowerCase():
            domainValueDic = {
                1: t('Dry - No precipitation during survey'),
                2: t('Heavy Rain'),
                3: t('Light Rain'),
                4: t('Snow'),
                5: t('Dry Weather/Wet Ground'),
            };
            break;
        case 'inspectionTechnologyUsedCCTV'.toLowerCase():
        case 'inspectionTechnologyUsedLaser'.toLowerCase():
        case 'inspectionTechnologyUsedSonar'.toLowerCase():
        case 'inspectionTechnologyUsedSidewall'.toLowerCase():
        case 'inspectionTechnologyUsedZoom'.toLowerCase():
        case 'inspectionTechnologyUsedOther'.toLowerCase():
            domainValueDic = {
                No: '',
                Yes: '',
            };
            break;
        default:
            break;
    }
    return domainValueDic;
};
exports.getDomainValues = getDomainValues;
var PACPInspectionProps = function (_a) {
    var onReRender = _a.onReRender;
    var t = (0, _Translations_1.useGlobalization)().t;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentDateTime = (0, stylovyze_1.useCompanyDateTime)().currentDateTime;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var _b = react_1.default.useState(0), tabValue = _b[0], setTabValue = _b[1];
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var _c = react_1.default.useState(false), editHeaderDetails = _c[0], setEditHeaderDetails = _c[1];
    var _d = react_1.default.useState(false), formSubmitted = _d[0], setFormSubmitted = _d[1];
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    var origDetails = (0, react_1.useMemo)(function () {
        setFormSubmitted(false);
        var values = (0, _Utils_1.getJustValues)(inspection, false);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var viewDetails = (0, react_1.useMemo)(function () {
        var values = (0, _Utils_1.getJustValues)(inspection, true);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var inspUpdatestatus = (0, fullInspection_selectors_1.refreshInsp)();
    //feature to be behind a LaunchDarkley flag
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-inspections-header')
        ? true
        : false;
    var isFullEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-full-inspections')
        ? true
        : false;
    var isCreateAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-create-inspections');
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    var handleFormSubmit = function (data) {
        // We should really used the touched state of a field but I cant get the Formik stuff to work properly
        var changes = (0, common_utils_1.getChangedFormikFields)(origDetails, data);
        if (changes && Object.entries(changes).length !== 0) {
            setFormSubmitted(true);
            var allFields = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], generalFields(t), true), locationFields(t), true), pipeFields(t), true), manholesFields(t), true);
            var editedFieldsList = (0, common_utils_1.processFormSubmit)(t, inspection_types_1.InspectionStandard.PACP, origDetails, changes, allFields, hardCodeDateTimeFields, hardCodeUnitFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, getSystemValueFormatted, formatDateUTC, companySettings, t('Date/Time of inspection'), { date: 'date', time: 'time' });
            dispatch((0, inspection_actions_1.refreshInspection)({ status: -1 })); //reset update flag and hide the controls
            dispatch((0, inspection_actions_1.updateInspection)(editedFieldsList)); //trigger update
        }
    };
    // //when inspection has been updated, page needs to be refreshed to display latest details
    (0, react_1.useEffect)(function () {
        if (inspUpdatestatus === 200 && onReRender)
            onReRender();
    }, [inspUpdatestatus]);
    var general = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('General'), dataCy: "modified-info-card-general", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, generalFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, isHiddenField, !isCreateAllowedFlag, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var location = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Location'), dataCy: "modified-info-card-location", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, locationFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var pipe = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Construction'), dataCy: "modified-info-card-construction", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, pipeFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var manholes = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Manholes'), dataCy: "modified-info-card-manholes", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, manholesFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, isHiddenField, !isCreateAllowedFlag, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    if (!isLoading && origDetails && !formSubmitted) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeFormV2, __assign({ mode: editHeaderDetails ? 'edit' : 'view', initialValues: editHeaderDetails ? origDetails : viewDetails, enableReinitialize: true, onSubmit: function (data) {
                setEditHeaderDetails(false);
                handleFormSubmit(data);
            } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, __assign({ "$height": 683 }, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: tabValue, onChange: handleChangeTab, "aria-label": "manhole-attributes" }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('General') }, (0, _Utils_1.a11yProps)(0))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Location') }, (0, _Utils_1.a11yProps)(1))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Pipe') }, (0, _Utils_1.a11yProps)(2))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Manholes') }, (0, _Utils_1.a11yProps)(3)))] })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 0 }, { children: general })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 1 }, { children: location })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 2 }, { children: pipe })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 3 }, { children: manholes }))] })) })));
            } })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '25px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    }
};
exports.PACPInspectionProps = PACPInspectionProps;
exports["default"] = exports.PACPInspectionProps;


/***/ }),

/***/ "./components/PACPInspectionProps/index.ts":
/*!*************************************************!*\
  !*** ./components/PACPInspectionProps/index.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPACPDomainValues = exports["default"] = void 0;
var PACPInspectionProps_component_1 = __webpack_require__(/*! ./PACPInspectionProps.component */ "./components/PACPInspectionProps/PACPInspectionProps.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(PACPInspectionProps_component_1).default; } }));
var PACPInspectionProps_component_2 = __webpack_require__(/*! ./PACPInspectionProps.component */ "./components/PACPInspectionProps/PACPInspectionProps.component.tsx");
Object.defineProperty(exports, "getPACPDomainValues", ({ enumerable: true, get: function () { return PACPInspectionProps_component_2.getDomainValues; } }));


/***/ }),

/***/ "./components/Ratings/NoRatings.component.tsx":
/*!****************************************************!*\
  !*** ./components/Ratings/NoRatings.component.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoRatings = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var WorkHistoryIcon_1 = __webpack_require__(/*! ./WorkHistoryIcon */ "./components/Ratings/WorkHistoryIcon.tsx");
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoRatings = function () {
    var t = (0, _Translations_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '40px' } }, { children: (0, jsx_runtime_1.jsx)(WorkHistoryIcon_1.WorkHistoryIcon, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No ratings to show') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('You must have inspections to view ratings.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, item: true, xs: 12, justifyContent: "center", style: {
                    paddingTop: '20px',
                    paddingBottom: '20px',
                } })] })));
};
exports.NoRatings = NoRatings;


/***/ }),

/***/ "./components/Ratings/Ratings.component.tsx":
/*!**************************************************!*\
  !*** ./components/Ratings/Ratings.component.tsx ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Ratings = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var useStyle = (0, styles_1.makeStyles)(function () { return ({
    ratingRoot: {
        overflow: 'hidden',
        padding: '15px',
    },
    card: function (props) { return ({
        marginTop: '5px',
        '&>div>div:nth-child(n+2):nth-child(-n+4)': {
            paddingTop: '7px',
            gridTemplateColumns: 'auto',
            gridTemplateRows: 'auto',
            // eslint-disable-next-line prettier/prettier
            // eslint-disable-next-line quotes
            gridTemplateAreas: "'title''subtitle'",
            justifyContent: 'center',
            '&>p:nth-child(1)': {
                color: props.topCardColors,
                gridArea: 'title',
                display: 'flex',
                justifyContent: 'center',
                fontSize: '32px',
                lineHeight: '40px',
            },
            '&>p:nth-child(2)': {
                color: props.mainCardColor,
                gridArea: 'subtitle',
                display: 'flex',
                justifyContent: 'center',
            },
        },
    }); },
    extraTopMargin: {
        marginTop: '10px',
        // height: '189px',
    },
    grayCard: function (props) { return ({
        height: "".concat(props.mainScoreCardHeight, "px"),
    }); },
    topBar: {
        background: '#A5BDC6',
        height: '0.5rem',
        width: '100%',
    },
}); });
var Ratings = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var standard = _a.standard, ratings = _a.ratings, _1 = _a.mainScoreCardHeight, mainScoreCardHeight = _1 === void 0 ? 189 : _1, _2 = _a.topCardColors, topCardColors = _2 === void 0 ? '#01ABD1' : _2, _3 = _a.mainCardColor, mainCardColor = _3 === void 0 ? '#4A6067' : _3;
    var t = (0, _Translations_1.useGlobalization)().t;
    var classes = useStyle({
        mainScoreCardHeight: mainScoreCardHeight,
        topCardColors: topCardColors,
        mainCardColor: mainCardColor,
    });
    switch (standard) {
        case inspection_types_1.InspectionStandard.MSCC:
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ className: classes.ratingRoot, container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.structuralGradeRating, height: 92, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                            textAlign: 'center',
                                            fontSize: '14px',
                                            lineHeight: '20px',
                                            color: '#4A6067',
                                            paddingBottom: '10px',
                                        } }, { children: t('Structural') })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", align: "center", style: {
                                                fontSize: '14px',
                                                lineHeight: '15px',
                                                color: '#4A6067',
                                                paddingBottom: '15px',
                                                whiteSpace: 'pre-wrap',
                                            } }, { children: t('Total: {{total}} | Mean: {{mean}} | Peak: {{peak}} | Quick: {{quick}}', {
                                                total: (_b = ratings === null || ratings === void 0 ? void 0 : ratings.structuralTotalRating) !== null && _b !== void 0 ? _b : '-',
                                                mean: (_c = ratings === null || ratings === void 0 ? void 0 : ratings.structuralMeanRating) !== null && _c !== void 0 ? _c : '-',
                                                peak: (_d = ratings === null || ratings === void 0 ? void 0 : ratings.structuralPeakRating) !== null && _d !== void 0 ? _d : '-',
                                                quick: (_e = ratings === null || ratings === void 0 ? void 0 : ratings.structuralQuickRating) !== null && _e !== void 0 ? _e : '-',
                                            }) })) })] }) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.serviceGradeRating, height: 92, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                            textAlign: 'center',
                                            fontSize: '14px',
                                            lineHeight: '20px',
                                            color: '#4A6067',
                                            paddingBottom: '10px',
                                        } }, { children: t('Service') })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", align: "center", style: {
                                                fontSize: '14px',
                                                lineHeight: '15px',
                                                color: '#4A6067',
                                                paddingBottom: '10px',
                                                whiteSpace: 'pre-wrap',
                                            } }, { children: t('Total: {{total}} | Mean: {{mean}} | Peak: {{peak}} | Quick: {{quick}}', {
                                                total: (_f = ratings === null || ratings === void 0 ? void 0 : ratings.serviceTotalRating) !== null && _f !== void 0 ? _f : '-',
                                                mean: (_g = ratings === null || ratings === void 0 ? void 0 : ratings.serviceMeanRating) !== null && _g !== void 0 ? _g : '-',
                                                peak: (_h = ratings === null || ratings === void 0 ? void 0 : ratings.servicePeakRating) !== null && _h !== void 0 ? _h : '-',
                                                quick: (_j = ratings === null || ratings === void 0 ? void 0 : ratings.serviceQuickRating) !== null && _j !== void 0 ? _j : '-',
                                            }) })) })] }) }) }))] })));
        case inspection_types_1.InspectionStandard.WSA05:
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ className: classes.ratingRoot, container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.structuralGradeRating, height: 92, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                            textAlign: 'center',
                                            fontSize: '14px',
                                            lineHeight: '20px',
                                            color: '#4A6067',
                                            paddingBottom: '10px',
                                        } }, { children: t('Structural') })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", align: "center", style: {
                                                fontSize: '14px',
                                                lineHeight: '15px',
                                                color: '#4A6067',
                                                paddingBottom: '15px',
                                                whiteSpace: 'pre-wrap',
                                            } }, { children: t('Total: {{total}} | Number: {{number}} | Mean: {{mean}} | Peak: {{peak}} | Average: {{average}}', {
                                                total: (_k = ratings === null || ratings === void 0 ? void 0 : ratings.structuralTotalRating) !== null && _k !== void 0 ? _k : '-',
                                                number: (_l = ratings === null || ratings === void 0 ? void 0 : ratings.structuralNumRating) !== null && _l !== void 0 ? _l : '-',
                                                mean: (_m = ratings === null || ratings === void 0 ? void 0 : ratings.structuralMeanRating) !== null && _m !== void 0 ? _m : '-',
                                                peak: (_o = ratings === null || ratings === void 0 ? void 0 : ratings.structuralPeakRating) !== null && _o !== void 0 ? _o : '-',
                                                average: (_p = ratings === null || ratings === void 0 ? void 0 : ratings.structuralAverageRating) !== null && _p !== void 0 ? _p : '-',
                                            }) })) })] }) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.serviceGradeRating, height: 92, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                            textAlign: 'center',
                                            fontSize: '14px',
                                            lineHeight: '20px',
                                            color: '#4A6067',
                                            paddingBottom: '10px',
                                        } }, { children: t('Service') })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", align: "center", style: {
                                                fontSize: '14px',
                                                lineHeight: '15px',
                                                color: '#4A6067',
                                                paddingBottom: '10px',
                                                whiteSpace: 'pre-wrap',
                                            } }, { children: t('Total: {{total}} | Number: {{number}} | Mean: {{mean}} | Peak: {{peak}} | Average: {{average}}', {
                                                total: (_q = ratings === null || ratings === void 0 ? void 0 : ratings.serviceTotalRating) !== null && _q !== void 0 ? _q : '-',
                                                number: (_r = ratings === null || ratings === void 0 ? void 0 : ratings.serviceNumRating) !== null && _r !== void 0 ? _r : '-',
                                                mean: (_s = ratings === null || ratings === void 0 ? void 0 : ratings.serviceMeanRating) !== null && _s !== void 0 ? _s : '-',
                                                peak: (_t = ratings === null || ratings === void 0 ? void 0 : ratings.servicePeakRating) !== null && _t !== void 0 ? _t : '-',
                                                average: (_u = ratings === null || ratings === void 0 ? void 0 : ratings.serviceAverageRating) !== null && _u !== void 0 ? _u : '-',
                                            }) })) })] }) }) }))] })));
        case inspection_types_1.InspectionStandard.MACP:
        case inspection_types_1.InspectionStandard.PACP:
        default:
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ className: classes.ratingRoot, container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.overallRating, height: 35, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: '#4A6067',
                                } }, { children: t('Overall Rating') })) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.quickRating, height: 35, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: '#4A6067',
                                } }, { children: t('Overall Quick Rating') })) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.card }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: ratings === null || ratings === void 0 ? void 0 : ratings.ratingIndex, height: 35, topColor: "#01ABD1", topText: (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: '#4A6067',
                                } }, { children: t('Overall Rating Index') })) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, className: classes.extraTopMargin }, { children: (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ square: true, className: classes.grayCard }, { children: [(0, jsx_runtime_1.jsx)("div", { className: classes.topBar }), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, style: { paddingTop: '26px' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 6, style: { paddingLeft: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", gutterBottom: true, align: "center", style: {
                                                        fontSize: '18px',
                                                        lineHeight: '24px',
                                                        color: '#252F33',
                                                    } }, { children: t('Structural Score') })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", gutterBottom: true, align: "center", style: {
                                                        fontSize: '14px',
                                                        lineHeight: '15px',
                                                        color: '#4A6067',
                                                        whiteSpace: 'pre-wrap',
                                                    } }, { children: t('Rating: {{rating}} | Quick Rating: {{quick}} | Rating Index: {{index}}', {
                                                        rating: (_v = ratings === null || ratings === void 0 ? void 0 : ratings.structuralOverallRating) !== null && _v !== void 0 ? _v : '-',
                                                        quick: (_w = ratings === null || ratings === void 0 ? void 0 : ratings.structuralQuickRating) !== null && _w !== void 0 ? _w : '-',
                                                        index: (_x = ratings === null || ratings === void 0 ? void 0 : ratings.structuralRatingIndex) !== null && _x !== void 0 ? _x : '-',
                                                    }) }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 6, style: { paddingLeft: '40px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", gutterBottom: true, align: "center", style: {
                                                        fontSize: '18px',
                                                        lineHeight: '24px',
                                                        color: '#252F33',
                                                    } }, { children: t('O&M') })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", gutterBottom: true, align: "center", style: {
                                                        fontSize: '14px',
                                                        lineHeight: '15px',
                                                        color: '#4A6067',
                                                        whiteSpace: 'pre-wrap',
                                                    } }, { children: t('Rating: {{rating}} | Quick Rating: {{quick}} | Rating Index: {{index}}', {
                                                        rating: (_y = ratings === null || ratings === void 0 ? void 0 : ratings.serviceOverallRating) !== null && _y !== void 0 ? _y : '-',
                                                        quick: (_z = ratings === null || ratings === void 0 ? void 0 : ratings.serviceQuickRating) !== null && _z !== void 0 ? _z : '-',
                                                        index: (_0 = ratings === null || ratings === void 0 ? void 0 : ratings.serviceRatingIndex) !== null && _0 !== void 0 ? _0 : '-',
                                                    }) }))] }))] }))] })) }))] })));
    }
};
exports.Ratings = Ratings;
exports["default"] = exports.Ratings;


/***/ }),

/***/ "./components/Ratings/WorkHistoryIcon.tsx":
/*!************************************************!*\
  !*** ./components/Ratings/WorkHistoryIcon.tsx ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkHistoryIcon = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var WorkHistoryIcon = function () { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M73.7675 26.0457H64.5066C64.2769 26.0457 64.0738 26.1229 63.9278 26.269C63.7817 26.415 63.7045 26.6181 63.7045 26.8479C63.7045 27.0776 63.7817 27.2807 63.9278 27.4267C64.0738 27.5728 64.2769 27.65 64.5066 27.65H72.9001V78.5457H27.0914V27.65H35.4849C35.7147 27.65 35.9178 27.5728 36.0638 27.4267C36.2099 27.2807 36.2871 27.0776 36.2871 26.8479C36.2871 26.6181 36.2099 26.415 36.0638 26.269C35.9178 26.1229 35.7147 26.0457 35.4849 26.0457H26.2893C26.0595 26.0457 25.8564 26.1229 25.7104 26.269C25.5643 26.415 25.4871 26.6181 25.4871 26.8479V79.3479C25.4871 79.5776 25.5643 79.7807 25.7104 79.9267C25.8564 80.0728 26.0595 80.15 26.2893 80.15H73.7023C73.932 80.15 74.1352 80.0728 74.2812 79.9267C74.4272 79.7807 74.5045 79.5776 74.5045 79.3479V26.8616C74.5417 26.6451 74.452 26.4414 74.3174 26.2971C74.1798 26.1497 73.9788 26.0457 73.7675 26.0457Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" }), (0, jsx_runtime_1.jsx)("path", { d: "M52.8084 64.1113C52.4889 63.7919 52.0027 63.7919 51.6832 64.1113C51.3638 64.4308 51.3638 64.9171 51.6832 65.2365L59.1832 72.7365C59.8643 73.4176 60.7506 73.7587 61.6371 73.7587C62.5236 73.7587 63.4099 73.4176 64.091 72.7365C65.4519 71.3756 65.4564 69.1925 64.0897 67.8926L56.5258 60.3287C56.2063 60.0093 55.7201 60.0093 55.4006 60.3287C55.0812 60.6482 55.0812 61.1345 55.4006 61.4539L62.9006 68.9539C63.6239 69.6772 63.6246 70.8198 62.9027 71.544C62.11 72.2737 60.9643 72.2672 60.2432 71.5461L52.8084 64.1113Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" }), (0, jsx_runtime_1.jsxs)("mask", __assign({ id: "path-3-outside-1", maskUnits: "userSpaceOnUse", x: "31.9062", y: "35.2391", width: "36", height: "40", fill: "black" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "white", x: "31.9062", y: "35.2391", width: "36", height: "40" }), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z" })] })), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z", fill: "#768D95" }), (0, jsx_runtime_1.jsx)("path", { d: "M58.1806 40.4783L53.6806 43.6087C53.6154 43.6739 53.5502 43.7391 53.485 43.8044L51.8545 46.8044C51.7893 46.9348 51.7893 47.0652 51.7893 47.1957L52.2458 50.6522L49.4415 53.4565L43.1806 47.1957L45.0719 45.3044L45.5284 45.7609C45.6589 45.8913 45.8545 45.9565 45.985 45.9565C46.1154 45.9565 46.3111 45.8913 46.4415 45.7609L49.2458 42.9565C49.3763 42.8261 49.4415 42.6957 49.4415 42.5C49.4415 42.3044 49.3763 42.1739 49.2458 42.0435L43.6371 36.4348C43.3763 36.1739 42.985 36.1739 42.7241 36.4348L39.9197 39.2391C39.6589 39.5 39.6589 39.8913 39.9197 40.1522L40.3763 40.6087L34.5067 46.4783C34.4415 46.5435 30.398 50.7174 35.4197 55.8044C35.5502 55.9348 35.7458 56 35.8763 56C36.0067 56 36.2024 55.9348 36.3328 55.8044C36.5937 55.5435 36.5937 55.1522 36.3328 54.8913C32.2241 50.7826 35.2893 47.587 35.4197 47.4565L41.2893 41.587L44.0937 44.3913L41.7458 46.7391C41.485 47 41.485 47.3913 41.7458 47.6522L48.4632 54.3696L45.6589 57.1739L38.9415 50.4565C38.6806 50.1957 38.2893 50.1957 38.0284 50.4565C37.7676 50.7174 37.7676 51.1087 38.0284 51.3696L44.7458 58.087L44.6806 58.1522C44.1589 58.7391 43.7676 59.1304 43.5067 59.3913L40.0502 58.9348C39.9197 58.9348 39.7893 58.9348 39.6589 59L36.5937 60.6957C36.5284 60.7609 36.4632 60.8261 36.398 60.8913L33.3328 65.2609C33.2024 65.4565 33.2024 65.6522 33.2676 65.8478L34.5719 69.6957C34.6371 69.8913 34.8328 70.087 35.0284 70.087C35.2241 70.1522 35.485 70.087 35.6154 69.8913L40.1154 65.3913L42.0067 67.2826L37.5067 71.7826C37.3763 71.913 37.3111 72.1739 37.3111 72.3696C37.3763 72.5652 37.5067 72.7609 37.7024 72.8261L41.5502 74.1304C41.6154 74.1304 41.6806 74.1957 41.7458 74.1957C41.8763 74.1957 42.0067 74.1304 42.1371 74.0652L46.6371 70.9348C46.7024 70.8696 46.7676 70.8044 46.8328 70.7391L48.4632 67.7391C48.5284 67.6087 48.5284 67.4783 48.5284 67.3478L48.0719 63.8913L56.8111 55.1522L60.2676 55.6087C60.398 55.6087 60.5284 55.6087 60.6589 55.5435L63.7241 53.8478C63.7893 53.7826 63.8545 53.7174 63.9198 53.6522L66.985 49.2826C67.1154 49.087 67.1154 48.8913 67.0502 48.6957L65.7458 44.8478C65.6806 44.6522 65.485 44.4565 65.2893 44.4565C65.0937 44.3913 64.8328 44.4565 64.7024 44.6522L60.2024 49.1522L58.3111 47.2609L62.8111 42.7609C62.9415 42.6304 63.0067 42.3696 63.0067 42.1739C62.9415 41.9783 62.8111 41.7826 62.6154 41.7174L58.7676 40.413C58.5719 40.3478 58.3111 40.3478 58.1806 40.4783ZM41.7458 40.2174L41.2893 39.7609L43.1806 37.8696L47.8763 42.5652L45.985 44.4565L45.4632 43.9348L41.7458 40.2174ZM56.9415 46.8696C56.6806 47.1304 56.6806 47.5217 56.9415 47.7826L59.7458 50.587C60.0067 50.8478 60.398 50.8478 60.6589 50.587L64.898 46.3478L65.7458 48.8913L62.9415 52.8696L60.2024 54.4348L56.6806 53.9783C56.485 53.9783 56.2893 54.0435 56.1589 54.1739L46.9632 63.3696C46.8328 63.5 46.7676 63.6957 46.7676 63.8913L47.2241 67.413L45.7893 70.087L41.6806 72.9565L39.1371 72.1087L43.3763 67.8696C43.6371 67.6087 43.6371 67.2174 43.3763 66.9565L40.5719 64.1522C40.4415 64.0217 40.3111 63.9565 40.1154 63.9565C39.9197 63.9565 39.7893 64.0217 39.6589 64.1522L35.4197 68.3913L34.5719 65.8478L37.3763 61.8696L40.1154 60.3044L43.6371 60.7609C43.8328 60.7609 44.0284 60.6957 44.1589 60.5652C44.1589 60.5652 45.398 59.3261 46.9632 57.7609L51.2024 53.5217C53.485 51.2391 53.6806 51.0435 53.5502 50.7174L53.0937 47.2609L54.5284 44.587L58.6371 41.7174L61.1806 42.5652L56.9415 46.8696Z", stroke: "#768D95", strokeWidth: "0.6", mask: "url(#path-3-outside-1)" }), (0, jsx_runtime_1.jsx)("path", { d: "M39.4632 30.5848H60.5284C60.7582 30.5848 60.9613 30.5075 61.1073 30.3615C61.2534 30.2155 61.3306 30.0123 61.3306 29.7826V23.9783C61.3306 23.7485 61.2534 23.5454 61.1073 23.3994C60.9613 23.2533 60.7582 23.1761 60.5284 23.1761H54.0659C53.6791 21.2771 52.0172 19.85 50.0284 19.85C48.0396 19.85 46.3777 21.2771 45.991 23.1761H39.4632C39.2335 23.1761 39.0304 23.2533 38.8843 23.3994C38.7383 23.5454 38.661 23.7485 38.661 23.9783V29.7826C38.661 29.9944 38.7654 30.1937 38.9088 30.337C39.0521 30.4804 39.2514 30.5848 39.4632 30.5848ZM40.2654 24.7804H46.7023C46.9321 24.7804 47.1352 24.7032 47.2812 24.5572C47.4273 24.4111 47.5045 24.208 47.5045 23.9783C47.5045 22.5635 48.6741 21.4543 50.0284 21.4543C51.3828 21.4543 52.5523 22.5635 52.5523 23.9783C52.5523 24.208 52.6296 24.4111 52.7756 24.5572C52.9217 24.7032 53.1248 24.7804 53.3545 24.7804H59.7915V28.9804H40.2654V24.7804Z", fill: "#768D95", stroke: "#768D95", strokeWidth: "0.3" })] }))); };
exports.WorkHistoryIcon = WorkHistoryIcon;


/***/ }),

/***/ "./components/Ratings/index.ts":
/*!*************************************!*\
  !*** ./components/Ratings/index.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Ratings_component_1 = __webpack_require__(/*! ./Ratings.component */ "./components/Ratings/Ratings.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Ratings_component_1).default; } }));
__exportStar(__webpack_require__(/*! ./Ratings.component */ "./components/Ratings/Ratings.component.tsx"), exports);


/***/ }),

/***/ "./components/RowsPerPage/RowsPerPage.component.style.ts":
/*!***************************************************************!*\
  !*** ./components/RowsPerPage/RowsPerPage.component.style.ts ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledDiv = exports.StyledText = void 0;
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
exports.StyledText = (0, styled_components_1.default)(stylovyze_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-left: 16px;\n"], ["\n\tmargin-left: 16px;\n"])));
exports.StyledDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: -45px 0 0 7px;\n"], ["\n\tmargin: -45px 0 0 7px;\n"])));
var templateObject_1, templateObject_2;


/***/ }),

/***/ "./components/RowsPerPage/RowsPerPage.component.tsx":
/*!**********************************************************!*\
  !*** ./components/RowsPerPage/RowsPerPage.component.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var RowsPerPage_component_style_1 = __webpack_require__(/*! ./RowsPerPage.component.style */ "./components/RowsPerPage/RowsPerPage.component.style.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
function RowsPerPage(_a) {
    var options = _a.options, handleDropdownSwitch = _a.handleDropdownSwitch, _b = _a.width, width = _b === void 0 ? 170 : _b, _c = _a.height, height = _c === void 0 ? 26 : _c, other = __rest(_a, ["options", "handleDropdownSwitch", "width", "height"]);
    // const rowsPerPageOptions, handleDropdownSwitch = ...props;
    var t = (0, _Translations_1.useGlobalization)().t;
    var dropdownOptions = options.map(function (option) {
        return {
            name: option.toString(),
            onClick: function () {
                if (handleDropdownSwitch) {
                    handleDropdownSwitch(option);
                }
            },
        };
    });
    return ((0, jsx_runtime_1.jsxs)(RowsPerPage_component_style_1.StyledDiv, __assign({ id: other.id }, { children: [(0, jsx_runtime_1.jsx)(RowsPerPage_component_style_1.StyledText, __assign({ variant: "text-large" }, { children: t('Rows per page:') })), (0, jsx_runtime_1.jsx)(stylovyze_1.DropDownButton, { arrow: true, color: "secondary", options: dropdownOptions, placement: "bottom-start", variant: "text", width: width, height: height })] })));
}
exports["default"] = RowsPerPage;


/***/ }),

/***/ "./components/RowsPerPage/index.ts":
/*!*****************************************!*\
  !*** ./components/RowsPerPage/index.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var RowsPerPage_component_1 = __webpack_require__(/*! ./RowsPerPage.component */ "./components/RowsPerPage/RowsPerPage.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(RowsPerPage_component_1).default; } }));


/***/ }),

/***/ "./components/SearchBar/SearchBar.styles.ts":
/*!**************************************************!*\
  !*** ./components/SearchBar/SearchBar.styles.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledTextField = exports.StyledSearchIcon = exports.StyledSearch = void 0;
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
exports.StyledSearch = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\twidth: 90%;\n"], ["\n\tposition: relative;\n\twidth: 90%;\n"])));
exports.StyledSearchIcon = (0, styled_components_1.default)(icons_material_1.Search)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", ";\n\tleft: ", ";\n"], ["\n\tposition: absolute;\n\ttop: ", ";\n\tleft: ", ";\n"])), (0, styles_1.rem)(16), (0, styles_1.rem)(15));
exports.StyledTextField = (0, styled_components_1.default)(material_1.TextField)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-top: 0px;\n\tmargin-bottom: 0px;\n\twidth: 100%;\n\t.MuiInputLabel-outlined {\n\t\tmargin-left: ", ";\n\t}\n\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\tmargin-left: 0px;\n\t}\n\t.MuiOutlinedInput-input {\n\t\tmargin-left: ", ";\n\t}\n"], ["\n\tmargin-top: 0px;\n\tmargin-bottom: 0px;\n\twidth: 100%;\n\t.MuiInputLabel-outlined {\n\t\tmargin-left: ", ";\n\t}\n\t.MuiInputLabel-outlined.MuiInputLabel-shrink {\n\t\tmargin-left: 0px;\n\t}\n\t.MuiOutlinedInput-input {\n\t\tmargin-left: ", ";\n\t}\n"])), (0, styles_1.rem)(25), (0, styles_1.rem)(25));
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),

/***/ "./components/SearchBar/SearchBar.tsx":
/*!********************************************!*\
  !*** ./components/SearchBar/SearchBar.tsx ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var SearchBar_styles_1 = __webpack_require__(/*! ../SearchBar/SearchBar.styles */ "./components/SearchBar/SearchBar.styles.ts");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var styles_2 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var useStyle = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        search: function (props) { return ({
            position: 'absolute',
            top: "".concat((0, styles_2.rem)(props.topRem)),
            left: "".concat((0, styles_2.rem)(props.leftRem)),
        }); },
    });
});
var SearchBar = function (_a) {
    var _b = _a.topRem, topRem = _b === void 0 ? 16 : _b, _c = _a.leftRem, leftRem = _c === void 0 ? 15 : _c, props = __rest(_a, ["topRem", "leftRem"]);
    var classes = useStyle({ topRem: topRem, leftRem: leftRem });
    var handleKeyDown = function (event) {
        if (event.key === 'Enter') {
            var target = event === null || event === void 0 ? void 0 : event.target;
            props.handleSearchSubmit(target === null || target === void 0 ? void 0 : target.value);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(SearchBar_styles_1.StyledSearch, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.Search, { className: classes.search }), (0, jsx_runtime_1.jsx)(SearchBar_styles_1.StyledTextField, { label: props.label, defaultValue: props.defaultValue, margin: "normal", variant: "outlined", onKeyDown: handleKeyDown })] }));
};
exports["default"] = SearchBar;


/***/ }),

/***/ "./components/SearchBar/index.ts":
/*!***************************************!*\
  !*** ./components/SearchBar/index.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var SearchBar_1 = __webpack_require__(/*! ./SearchBar */ "./components/SearchBar/SearchBar.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(SearchBar_1).default; } }));
__exportStar(__webpack_require__(/*! ./SearchBar */ "./components/SearchBar/SearchBar.tsx"), exports);


/***/ }),

/***/ "./components/ShowMoreOverlay/ShowMoreOverlay.component.tsx":
/*!******************************************************************!*\
  !*** ./components/ShowMoreOverlay/ShowMoreOverlay.component.tsx ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var ShowMoreOverlay_styles_1 = __webpack_require__(/*! ./ShowMoreOverlay.styles */ "./components/ShowMoreOverlay/ShowMoreOverlay.styles.tsx");
var ExpandMore_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/ExpandMore */ "@mui/icons-material/ExpandMore"));
var clsx_1 = __importDefault(__webpack_require__(/*! clsx */ "../node_modules/clsx/dist/clsx.js"));
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var ShowMoreOverlay = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.height, height = _b === void 0 ? 200 : _b;
    var t = (0, _Translations_1.useGlobalization)().t;
    var _c = (0, react_1.useState)(false), isExpanded = _c[0], setIsExpanded = _c[1];
    var showMoreClicked = function () {
        setIsExpanded(!isExpanded);
    };
    var squareRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)({
        width: 0,
        height: 0,
    }), size = _d[0], setSize = _d[1];
    var updateSize = (0, react_1.useCallback)(function () {
        var node = squareRef === null || squareRef === void 0 ? void 0 : squareRef.current;
        if (node) {
            setSize({
                width: node.offsetWidth || 0,
                height: node.offsetHeight || 0,
            });
        }
    }, [squareRef]);
    (0, react_1.useEffect)(function () {
        updateSize();
    }, [children]);
    var needShowMore = size.height > height;
    var classes = (0, ShowMoreOverlay_styles_1.useStyles)(height, size.height, isExpanded, needShowMore)();
    var showMoreText = isExpanded ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('Show Less'), (0, jsx_runtime_1.jsx)(icons_material_1.ExpandLess, {})] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('Show More'), (0, jsx_runtime_1.jsx)(ExpandMore_1.default, {})] }));
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)(className, classes.root) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ ref: squareRef }, { children: children })), needShowMore ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(classes.whiteGradient, isExpanded && classes.displayNone) }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, className: classes.buttonDiv, justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ className: classes.showMoreButton, onClick: showMoreClicked }, { children: showMoreText })) }))] })) : null] })));
};
exports["default"] = ShowMoreOverlay;


/***/ }),

/***/ "./components/ShowMoreOverlay/ShowMoreOverlay.styles.tsx":
/*!***************************************************************!*\
  !*** ./components/ShowMoreOverlay/ShowMoreOverlay.styles.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var useStyles = function (height, fullHeight, isExpanded, needShowMore) {
    var additionalPadding = needShowMore ? 50 : 0;
    return (0, styles_1.makeStyles)(function () {
        return (0, styles_1.createStyles)({
            root: {
                height: isExpanded || !needShowMore ? '100%' : "".concat(height, "px"),
                minHeight: isExpanded || !needShowMore
                    ? "".concat(fullHeight + additionalPadding, "px")
                    : "".concat(height, "px"),
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
                transition: 'height 378ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
            whiteGradient: {
                position: 'absolute',
                bottom: '32px',
                width: '100%',
                height: '100px',
                background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 111.75%, rgba(196, 196, 196, 0) 111.76%, rgba(255, 255, 255, 0) 111.76%)',
                transform: 'rotate(180deg)',
            },
            buttonDiv: {
                width: '100%',
                background: 'white',
                position: 'absolute',
                bottom: 0,
            },
            showMoreButton: {
                lineHeight: '20px',
                // position: 'absolute',
                // bottom: 0,
                // right: 0,
                // background: 'white',
                // '&:hover': {
                // 	background: 'white',
                // },
            },
            displayNone: {
                display: 'none',
            },
        });
    });
};
exports.useStyles = useStyles;


/***/ }),

/***/ "./components/ShowMoreOverlay/index.ts":
/*!*********************************************!*\
  !*** ./components/ShowMoreOverlay/index.ts ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ShowMoreOverlay_component_1 = __webpack_require__(/*! ./ShowMoreOverlay.component */ "./components/ShowMoreOverlay/ShowMoreOverlay.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ShowMoreOverlay_component_1).default; } }));


/***/ }),

/***/ "./components/Tabs/Tab.tsx":
/*!*********************************!*\
  !*** ./components/Tabs/Tab.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tab = exports.Tabs = exports.TabWrapper = void 0;
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styled_components_1 = __importStar(__webpack_require__(/*! styled-components */ "styled-components"));
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
exports.TabWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-grow: 1;\n\tbackground-color: ", ";\n\t", "\n"], ["\n\tdisplay: flex;\n\tflex-grow: 1;\n\tbackground-color: ", ";\n\t", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.background.paper;
}, function (_a) {
    var $height = _a.$height;
    return $height && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\theight: ", ";\n\t\t"], ["\n\t\t\theight: ", ";\n\t\t"])), (0, styles_1.rem)($height));
});
exports.Tabs = (0, styled_components_1.default)(material_1.Tabs)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tborder-right: 1px solid ", ";\n\twidth: ", ";\n"], ["\n\tborder-right: 1px solid ", ";\n\twidth: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.divider;
}, (0, styles_1.rem)(350));
exports.Tab = (0, styled_components_1.default)(material_1.Tab)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\talign-items: start;\n\t.MuiTab-wrapper {\n\t\talign-items: start;\n\t}\n"], ["\n\talign-items: start;\n\t.MuiTab-wrapper {\n\t\talign-items: start;\n\t}\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),

/***/ "./components/Tabs/TabPanel.tsx":
/*!**************************************!*\
  !*** ./components/Tabs/TabPanel.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabPanel = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var Panel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\toverflow-y: auto;\n\t> div {\n\t\tpadding: 0;\n\t}\n"], ["\n\twidth: 100%;\n\toverflow-y: auto;\n\t> div {\n\t\tpadding: 0;\n\t}\n"])));
var TabPanel = function (_a) {
    var children = _a.children, value = _a.value, index = _a.index;
    return ((0, jsx_runtime_1.jsx)(Panel, __assign({ role: "tabpanel", hidden: value !== index, id: "vertical-tabpanel-".concat(index), "aria-labelledby": "vertical-tab-".concat(index) }, { children: value === index && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ p: 3 }, { children: children })) })));
};
exports.TabPanel = TabPanel;
var templateObject_1;


/***/ }),

/***/ "./components/Tabs/index.ts":
/*!**********************************!*\
  !*** ./components/Tabs/index.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./Tab */ "./components/Tabs/Tab.tsx"), exports);
__exportStar(__webpack_require__(/*! ./TabPanel */ "./components/Tabs/TabPanel.tsx"), exports);


/***/ }),

/***/ "./components/ValidationTable/ValidationTable.tsx":
/*!********************************************************!*\
  !*** ./components/ValidationTable/ValidationTable.tsx ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __webpack_require__(/*! react */ "react");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var ValidationTable = function (_a) {
    var dataCy = _a.dataCy, validationData = _a.validationData;
    var t = (0, _Translations_1.useGlobalization)().t;
    var _b = (0, react_1.useState)([]), rows = _b[0], setRows = _b[1];
    (0, react_1.useEffect)(function () {
        setRows(validationData ? validationData : []);
    }, [validationData]);
    var counts = [0, 0, 0];
    var statusCell = function (status) {
        switch (status.toLowerCase()) {
            case _Types_1.ValidationStatus.Error:
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Error'), color: "danger", width: '100%' }));
            case _Types_1.ValidationStatus.Warning:
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Warning'), color: "warning", width: '100%' }));
            case _Types_1.ValidationStatus.Information:
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Information'), color: "standard", width: '100%' }));
        }
    };
    var headerReactNodes = function () {
        return [
            {
                key: 'severity',
                cell: t('Severity'),
                sortable: true,
                align: 'left',
                width: '130px',
            },
            {
                key: 'code',
                cell: t('Code'),
                sortable: true,
                align: 'left',
                width: '80px',
            },
            {
                key: 'target',
                cell: t('Target'),
                sortable: true,
                align: 'left',
                width: '100px',
            },
            {
                key: 'message',
                cell: t('Message'),
                sortable: true,
                align: 'left',
            },
        ];
    };
    var rowReactNodes = function (row) {
        var cells = [4];
        cells[0] = statusCell(row.type);
        cells[1] = row.errorCode;
        cells[2] = row.target;
        cells[3] = row.errorMessage;
        return cells;
    };
    validationData === null || validationData === void 0 ? void 0 : validationData.map(function (row) {
        switch (row.type.toLowerCase()) {
            case _Types_1.ValidationStatus.Error:
                counts[0]++;
                break;
            case _Types_1.ValidationStatus.Warning:
                counts[1]++;
                break;
            case _Types_1.ValidationStatus.Information:
                counts[2]++;
                break;
        }
    });
    var sortRows = function (rows, name, order) {
        var newRows = [];
        if ((rows === null || rows === void 0 ? void 0 : rows.length) != 0) {
            if (name == '') {
                newRows = __spreadArray([], rows, true);
            }
            else {
                switch (name) {
                    case 'severity':
                        {
                            if (order === 'asc') {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) { return a.type.localeCompare(b.type); });
                            }
                            else {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) { return b.type.localeCompare(a.type); });
                            }
                        }
                        break;
                    case 'code':
                        {
                            if (order === 'asc') {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return a.errorCode.localeCompare(b.errorCode);
                                });
                            }
                            else {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return b.errorCode.localeCompare(a.errorCode);
                                });
                            }
                        }
                        break;
                    case 'target':
                        {
                            if (order === 'asc') {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return a.errorCode.localeCompare(b.errorCode);
                                });
                            }
                            else {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return b.errorCode.localeCompare(a.errorCode);
                                });
                            }
                        }
                        break;
                    case 'message':
                        {
                            if (order === 'asc') {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return a.errorMessage.localeCompare(b.errorMessage);
                                });
                            }
                            else {
                                newRows = rows
                                    .slice()
                                    .sort(function (a, b) {
                                    return b.errorMessage.localeCompare(a.errorMessage);
                                });
                            }
                        }
                        break;
                }
            }
        }
        return newRows;
    };
    var onSort = function (_e, name, order) {
        setRows(sortRows(rows, name, order));
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: counts[0], height: 35, titlePosition: "right", topText: t('Errors'), topColor: stylovyze_1.palette.error.dark }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: counts[1], height: 35, titlePosition: "right", topText: t('Warnings'), topColor: stylovyze_1.palette.warning.dark }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeCard, { countText: counts[2], height: 35, titlePosition: "right", topText: t('Information'), topColor: stylovyze_1.palette.primary.dark }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", dataCy: dataCy, headers: headerReactNodes(), rows: rows.map(function (row, nRow) { return ({
                        key: nRow,
                        cells: rowReactNodes(row),
                    }); }) || [], rowHeight: (0, stylovyze_1.rem)(40), sort: {
                        onRequestSort: function (_e, name, order) {
                            onSort(_e, name, order);
                        },
                    } }) }))] })));
};
exports["default"] = ValidationTable;


/***/ }),

/***/ "./components/ValidationTable/index.ts":
/*!*********************************************!*\
  !*** ./components/ValidationTable/index.ts ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ValidationTable_1 = __webpack_require__(/*! ./ValidationTable */ "./components/ValidationTable/ValidationTable.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ValidationTable_1).default; } }));


/***/ }),

/***/ "./components/WSA05InspectionProps/WSA05InspectionProps.component.tsx":
/*!****************************************************************************!*\
  !*** ./components/WSA05InspectionProps/WSA05InspectionProps.component.tsx ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WSA05InspectionProps = exports.getDomainValues = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Tabs_1 = __webpack_require__(/*! @Components/Tabs */ "./components/Tabs/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var fullInspection_selectors_1 = __webpack_require__(/*! @Selectors/fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Translations_1 = __webpack_require__(/*! @Translations */ "./i18n/index.ts");
var ModifiedInfoCard_1 = __importDefault(__webpack_require__(/*! @Components/ModifiedInfoCard/ModifiedInfoCard */ "./components/ModifiedInfoCard/ModifiedInfoCard.tsx"));
var common_utils_1 = __webpack_require__(/*! @Utils/common.utils */ "./utils/common.utils.tsx");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var EDITABLE_FIELDS = [
    'pipelineRef',
    'startNodeRef',
    'finishNodeRef',
    'direction',
];
var NON_EDITABLE_FIELDS = ['uploadedBy', 'uploadDateTime'];
var isEditableField = function (fieldName, fullEdit) {
    return fullEdit
        ? !NON_EDITABLE_FIELDS.includes(fieldName)
        : EDITABLE_FIELDS.includes(fieldName);
};
var HIDDEN_FIELDS = ['uploadDateTime', 'scheduledDate'];
var isHiddenField = function (fieldName, hideFields) {
    return hideFields ? HIDDEN_FIELDS.includes(fieldName) : false;
};
var detailsFields = function (t) { return [
    { name: 'uploadedBy', alias: t('Uploaded By') },
    { name: 'uploadDateTime', alias: t('Upload Date') },
    { name: 'scheduledDate', alias: t('Scheduled Date') },
    { name: 'standard', alias: t('ABA - Standard') },
    {
        name: 'originalCodingStandard',
        alias: t('ABB - Original coding standard'),
    },
    {
        name: 'longitudinalReferencePoint',
        alias: t('ABC - Longitudinal reference point'),
    },
    {
        name: 'conduitLocationRiskFactorObservedByOperator',
        alias: t('ABD - Conduit location risk factor observed by operator'),
    },
    { name: 'methodOfInspection', alias: t('ABE - Method of inspection') },
    { name: 'inspectionDate', alias: t('ABF - Date of inspection') },
    { name: 'inspectionTime', alias: t('ABG - Time of inspection') },
    { name: 'surveyedBy', alias: t('ABH - Operator') },
    {
        name: 'companyJobRef',
        alias: t('ABI - Inspection companys job reference'),
    },
    { name: 'assetOwnerJobRef', alias: t('ABJ - Asset owners job reference') },
    { name: 'coderAssessor', alias: t('ABL - Coder/Assessor') },
    {
        name: 'videoImageLocationSystem',
        alias: t('ABM - Video image location system'),
    },
    {
        name: 'evidenceOfSurchargeInStartNode',
        alias: t('ABN - Evidence of surcharge in start node'),
    },
    { name: 'purposeOfInspection', alias: t('ABP - Purpose of inspection') },
    {
        name: 'anticipatedLength',
        alias: t('ABQ - Anticipated length of inspection'),
    },
    { name: 'actualLength', alias: t('ABR - Actual inspection length') },
    {
        name: 'nameOfCompanyResponsibleForInspection',
        alias: t('ABS - Name of company responsible for inspection'),
    },
]; };
var locationFields = function (t) { return [
    { name: 'pipelineRef', alias: t('AAA - Conduit reference') },
    { name: 'startNodeRef', alias: t('AAB - Start node reference') },
    { name: 'startNodeCoordinates', alias: t('AAC - Start node coordinates') },
    { name: 'finishNodeRef', alias: t('AAF - Finish node reference') },
    {
        name: 'finishNodeCoordinates',
        alias: t('AAG - Finish Node Coordinates'),
    },
    {
        name: 'longLocStartLat',
        alias: t('AAH - Longitudinal location of start of lateral'),
    },
    {
        name: 'circLocStartLat',
        alias: t('AAI - Circumferential location of start of lateral'),
    },
    { name: 'location', alias: t('AAJ - Location') },
    { name: 'direction', alias: t('AAK - Direction of inspection') },
    { name: 'locationTypeCode', alias: t('AAL - Location Type') },
    {
        name: 'assetOwnerOrEngagingAgency',
        alias: t('AAM - Asset owner or engaging agency'),
    },
    { name: 'locationTown', alias: t('AAN - Town or suburb') },
    { name: 'divisionDistrict', alias: t('AAO - District') },
    { name: 'nameOfConduitSystem', alias: t('AAP - Name of conduit system') },
    { name: 'landOwner', alias: t('AAQ - Land ownership') },
    {
        name: 'mappingGridDatumSystem',
        alias: t('AAR - Mapping grid datum system'),
    },
    { name: 'mappingGridZone', alias: t('AAS - Mapping grid zone') },
]; };
var pipeFields = function (t) { return [
    { name: 'shape', alias: t('ACA - Shape') },
    { name: 'height', alias: t('ACB - Height') },
    { name: 'width', alias: t('ACC - Width') },
    { name: 'material', alias: t('ACD - Material') },
    { name: 'liningType', alias: t('ACE - Lining Type') },
    { name: 'liningMaterial', alias: t('ACF - Lining material') },
    { name: 'conduitUnitLength', alias: t('ACG - Conduit unit length') },
    { name: 'depthAtStartNode', alias: t('ACH - Depth at start node') },
    { name: 'depthAtFinishNode', alias: t('ACI - Depth at finish node') },
    { name: 'operationOfConduit', alias: t('ACJ - Operation of conduit') },
    { name: 'useOfConduit', alias: t('ACK - Use of conduit') },
    { name: 'criticality', alias: t('ACL - Criticality') },
    { name: 'cleaning', alias: t('ACM - Cleaning') },
    {
        name: 'yearCameIntoOperation',
        alias: t('ACN - Year came into operation'),
    },
    { name: 'jointingMethod', alias: t('ACO - Jointing method') },
]; };
var miscellaneousFields = function (t) { return [
    { name: 'precipitation', alias: t('ADA - Precipitation') },
    { name: 'temperature', alias: t('ADB - Temperature') },
    { name: 'flowControlMeasures', alias: t('ADC - Flow control measures') },
    {
        name: 'tidalInfluence',
        alias: t('ADD - Tidal influence (where applicable)'),
    },
    { name: 'generalComment', alias: t('ADE - General comment') },
]; };
var userDefinedFields = function (t) { return [
    { name: 'userDefined1', alias: t('AEA') },
    { name: 'userDefined2', alias: t('AEB') },
    { name: 'userDefined3', alias: t('AEC') },
    { name: 'userDefined4', alias: t('AED') },
    { name: 'userDefined5', alias: t('AEE') },
]; };
var hardCodeUnitFields = {
    longLocStartLat: { unit: 'm', step: 'any' },
    evidenceOfSurchargeInStartNode: { unit: 'm', min: 0, step: 'any' },
    anticipatedLength: { unit: 'm', min: 0, step: 'any' },
    actualLength: { unit: 'm', min: 0, step: 'any' },
    height: { unit: 'mm', min: 0, step: 'any' },
    width: { unit: 'mm', min: 0, step: 'any' },
    conduitUnitLength: { unit: 'm', min: 0, step: 'any' },
    depthAtStartNode: { unit: 'm', step: 'any' },
    depthAtFinishNode: { unit: 'm', step: 'any' },
};
var hardCodeDateTimeFields = {
    uploadDateTime: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'uploadDateTime',
        useCompanyDateTime: true,
    },
    scheduledDate: {
        mode: stylovyze_1.DateTimeInputMode.DATE_TIME,
        field: 'scheduledDate',
    },
    inspectionDate: { mode: stylovyze_1.DateTimeInputMode.DATE, field: 'surveyDateTime' },
    inspectionTime: { mode: stylovyze_1.DateTimeInputMode.TIME, field: 'surveyDateTime' },
};
var hardCodeCurrencyFields = {};
var hardCodeNumericFields = {
    yearCameIntoOperation: { min: 0 },
};
var hardCodeBooleanFields = {};
var getDomainValues = function (t, fieldName) {
    var domainValueDic = {};
    switch (fieldName.toLowerCase()) {
        case 'direction'.toLowerCase():
            domainValueDic = {
                D: t('Downstream'),
                U: t('Upstream'),
                Q: t('Unknown'),
            };
            break;
        case 'landOwner'.toLowerCase():
            domainValueDic = {
                C: t('Public land'),
                Q: t('Not Know'),
                T: t('Private land'),
            };
            break;
        case 'locationTypeCode'.toLowerCase():
            domainValueDic = {
                B: t('Bushland/parkland'),
                BO: t('Under a permanent building (Built over)'),
                C: t('Under a waterway (Creek) or body of water'),
                D: t('On property with buildings (Developed)'),
                E: t('Easement'),
                F: t('In a footway beside road'),
                G: t('Gardens'),
                M: t('In other pedestrian area (Mall)'),
                MR: t('Motorway or operational railway'),
                NS: t('In verge beside a road (Nature Strip)'),
                P: t('In a field (Paddock)'),
                R: t('In a road carriageway'),
                RE: t('Road to easement'),
                W: t('Water foreshore'),
                Z: t('Other'),
            };
            break;
        case 'longitudinalReferencePoint'.toLowerCase():
            domainValueDic = {
                C: t('Centre of the starting MH, MS or IS'),
                IP: t('Intersection of incoming and outgoing conduits'),
                P: t('Soffit of the end of the conduit in start node'),
                SA: t('Adjacent surface area'),
                W: t('Inside face of the starting node (MH, MS, IS or headwall etc.)'),
                Z: t('Other'),
            };
            break;
        case 'conduitLocationRiskFactorObservedByOperator'.toLowerCase():
            domainValueDic = {
                M: t('Motorway'),
                B: t('Under a building'),
                R: t('Under a railway'),
                T: t('Under a tramway'),
                S: t('Under a school Playground'),
                H: t('Under high value properties'),
                O: t('Other'),
            };
            break;
        case 'methodOfInspection'.toLowerCase():
            domainValueDic = {
                FZ: t('Fixed position zoom pipeline camera'),
                LP: t('Laser profiler'),
                M: t('Person walking through the conduit'),
                PR: t('Push rod'),
                PS: t('3D optical pipeline scanner'),
                SS: t('Sonar scanner'),
                TV: t('Television camera'),
                Z: t('Other'),
            };
            break;
        case 'videoImageLocationSystem'.toLowerCase():
            domainValueDic = {
                HM: t('Elapsed time in hours and minutes'),
                LP: t('Longitudinal location from the reference point'),
                MC: t('Machine dependent numeric counter'),
                Z: t('Other'),
            };
            break;
        case 'purposeOfInspection'.toLowerCase():
            domainValueDic = {
                B: t('Before and after building works over/near conduit'),
                C: t('Completion of abandoned inspection'),
                IE: t('Suspected infiltration problem'),
                IP: t('Investment planning'),
                LP: t('Locate conduit, connection or a maintenance structure'),
                NC: t('Final control of new construction'),
                OE: t('Suspected operational problem'),
                R: t('Routine inspection of condition'),
                RC: t('Final renovation/repair control'),
                S: t('Sample inspection'),
                SE: t('Suspected structural problem'),
                T: t('Transfer of ownership'),
                W: t('End of warranty period'),
                Z: t('Other'),
            };
            break;
        case 'shape'.toLowerCase():
            domainValueDic = {
                A: t('Arch'),
                C: t('Cicular'),
                E: t('Oviform (egg shaped)'),
                O: t('Oval'),
                R: t('Rectangular'),
                U: t('U shape - circular'),
                X: t('Specified by asset owner'),
                Z: t('Other'),
            };
            break;
        case 'material'.toLowerCase():
            domainValueDic = {
                ABS: t('Acrylonitrile butadiene styrene '),
                AL: t('Aluminium alloy'),
                AC: t('Asbestos cement'),
                AM: t('Cast iron (type unknown)'),
                VC: t('Clay—vitrified'),
                RC: t('Concrete reinforced'),
                CS: t('Concrete segments'),
                GU: t('Concrete sprayed'),
                CP: t('Concrete unreinforced'),
                DI: t('Ductile cast iron'),
                FC: t('Fibre reinforced cement'),
                FRP: t('Fibre reinforced plastics'),
                GI: t('Galvanised iron or steel'),
                GRP: t('Glass reinforced plastics'),
                CI: t('Grey cast iron'),
                MBC: t('Masonry - brick (coursed)'),
                MBSC: t('Masonry - bluestone/basalt (coursed)'),
                MOSC: t('Masonry - other stone (coursed)'),
                MBSU: t('Masonry - bluestone/basalt (uncoursed)'),
                MOSU: t('Masonry - other stone (uncoursed)'),
                MCON: t('Masonry-concrete composite'),
                PF: t('Pitch fibre'),
                P: t('Plastics (type unknown)'),
                PE: t('Polyethylene'),
                PP: t('Polypropylene'),
                PVC: t('Polyvinylchloride'),
                SS: t('Stainless steel'),
                S: t('Steel'),
                AG: t('Unidentified type of concrete or cement mortar'),
                AQ: t('Unidentified type of steel'),
                AY: t('Unidentified type of plastics'),
                ZZ: t('Unidentified material'),
                Z: t('Other'),
            };
            break;
        case 'liningType'.toLowerCase():
            domainValueDic = {
                CFL: t('Close fit lining'),
                CIP: t('Cured in place lining'),
                LCP: t('Continuous conduit - slip lining'),
                LDP: t('Discrete pipe units transported into and joined in host conduit'),
                MFL: t('Lining inserted during manufacture (Manufacturer’s lining)'),
                SEG: t('Segmental linings'),
                SPL: t('Sprayed lining'),
                SWL: t('Spirally wound lining'),
                Z: t('Other'),
            };
            break;
        case 'liningMaterial'.toLowerCase():
            domainValueDic = {
                CL: t('Cement (mortar) lining'),
                E: t('Epoxy'),
                FRP: t('Fibre reinforced plastics'),
                GRC: t('Glass fibre reinforced cement'),
                GRP: t('Glass fibre reinforced plastics'),
                PE: t('Polyethylene'),
                PIS: t('Plastics (thermosetting) impregnated feld or woven sock'),
                PU: t('Polyurethane'),
                PUA: t('Polyurea'),
                PVC: t('Polyvinylchloride'),
                Z: t('Other'),
            };
            break;
        case 'operationOfConduit'.toLowerCase():
            domainValueDic = {
                G: t('Gravity'),
                O: t('Other e.g., duct'),
                P: t('Pressure'),
            };
            break;
        case 'useOfConduit'.toLowerCase():
            domainValueDic = {
                COM: t('Combined'),
                CUL: t('Culverted'),
                D: t('Drain'),
                S: t('Sanitary'),
                TW: t('Trade'),
                Z: t('Other'),
            };
            break;
        case 'cleaning'.toLowerCase():
            domainValueDic = {
                C: t('Cleaned prior to inspection'),
                NC: t('Not cleaned prior to inspection'),
            };
            break;
        case 'jointingMethod'.toLowerCase():
            domainValueDic = {
                A: t('Sections abutted with no jointing'),
                BF: t('Butt fusion welded'),
                BFD: t('Butt fusion welded with reinforcement or debeading'),
                CMJ: t('Cement mortar jointed'),
                EF: t('Electrofusion coupling weld (PE only)'),
                F: t('Flange jointed – steel, cast or ductile iron'),
                L: t('Lap fillet weld (steel only)'),
                MC: t('Mechanical coupling'),
                RRJ: t('Rubber ring'),
                SCJ: t('Solvent cement jointed'),
                Z: t('Other'),
            };
            break;
        case 'precipitation'.toLowerCase():
            domainValueDic = {
                N: t('No precipitation'),
                R: t('Precipitation (rain)'),
                S: t('Melting snow or ice'),
            };
            break;
        case 'flowControlMeasures'.toLowerCase():
            domainValueDic = {
                B: t('Flows have been blocked or diverted upstream'),
                N: t('No measures taken'),
                P: t('Flows partially blocked or diverted upstream'),
                Z: t('Other'),
            };
            break;
        case 'tidalInfluence'.toLowerCase():
            domainValueDic = {
                A: t('Conduit is at or above the high tide level'),
                B: t('Conduit is below the high tide level'),
            };
            break;
        default:
            break;
    }
    return domainValueDic;
};
exports.getDomainValues = getDomainValues;
var WSA05InspectionProps = function (_a) {
    var onReRender = _a.onReRender;
    var t = (0, _Translations_1.useGlobalization)().t;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentDateTime = (0, stylovyze_1.useCompanyDateTime)().currentDateTime;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var _b = react_1.default.useState(0), tabValue = _b[0], setTabValue = _b[1];
    var isLoading = (0, fullInspection_selectors_1.selectFullInspectionIsWaiting)();
    var _c = react_1.default.useState(false), editHeaderDetails = _c[0], setEditHeaderDetails = _c[1];
    var _d = react_1.default.useState(false), formSubmitted = _d[0], setFormSubmitted = _d[1];
    var inspection = (0, fullInspection_selectors_1.selectFullInspection)();
    var origDetails = (0, react_1.useMemo)(function () {
        setFormSubmitted(false);
        var values = (0, _Utils_1.getJustValues)(inspection, false);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var viewDetails = (0, react_1.useMemo)(function () {
        var values = (0, _Utils_1.getJustValues)(inspection, true);
        var keys = Object.keys(values);
        keys.forEach(function (key) {
            // Adjust any date time fields for timezone/dst offsets caused by the datetime control
            var field = Object.entries(hardCodeDateTimeFields).find(function (value) { return value[1].field === key; });
            if (field) {
                values[key] = (0, _Utils_1.fixupDateTimeForInputDateTime)(values[key], field[1].useCompanyDateTime ? currentDateTime() : undefined);
            }
        });
        return values;
    }, [inspection]);
    var inspUpdatestatus = (0, fullInspection_selectors_1.refreshInsp)();
    //feature to be behind a LaunchDarkley flag
    var isEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-inspections-header')
        ? true
        : false;
    var isFullEditAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-edit-full-inspections')
        ? true
        : false;
    var isCreateAllowedFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-create-inspections');
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    var handleFormSubmit = function (data) {
        // We should really used the touched state of a field but I cant get the Formik stuff to work properly
        var changes = (0, common_utils_1.getChangedFormikFields)(origDetails, data);
        if (changes && Object.entries(changes).length !== 0) {
            setFormSubmitted(true);
            var allFields = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], detailsFields(t), true), locationFields(t), true), pipeFields(t), true), miscellaneousFields(t), true), userDefinedFields(t), true);
            var editedFieldsList = (0, common_utils_1.processFormSubmit)(t, _Types_1.InspectionStandard.PACP, origDetails, changes, allFields, hardCodeDateTimeFields, hardCodeUnitFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, getSystemValueFormatted, formatDate, companySettings, t('ABF/ABG Date/Time of inspection'), { date: 'date', time: 'time' });
            dispatch((0, inspection_actions_1.refreshInspection)({ status: -1 })); //reset update flag and hide the controls
            dispatch((0, inspection_actions_1.updateInspection)(editedFieldsList)); //trigger update
        }
    };
    //when inspection has been updated, page needs to be refreshed to display latest details
    (0, react_1.useEffect)(function () {
        if (inspUpdatestatus === 200 && onReRender)
            onReRender();
    }, [inspUpdatestatus]);
    var general = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Details'), dataCy: "modified-info-card-details", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, detailsFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, isHiddenField, !isCreateAllowedFlag, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var location = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Location'), dataCy: "modified-info-card", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, locationFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var pipe = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Pipe'), dataCy: "modified-info-card-pipe", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, pipeFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var miscellaneous = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('Miscellaneous'), dataCy: "modified-info-card-miscellaneous", showEditBtn: origDetails['inspectionStatus'] !== 'approved' &&
            onReRender !== undefined, launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, miscellaneousFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    var userDefined = ((0, jsx_runtime_1.jsx)(ModifiedInfoCard_1.default, __assign({ title: t('User Defined'), dataCy: "modified-info-card-userdefined", showEditBtn: origDetails['inspectionStatus'] !== 'approved', launchDarkleyFlag: isEditAllowedFlag, onEditClick: function () {
            setEditHeaderDetails(true);
        }, onCancelClick: function () {
            setEditHeaderDetails(false);
        }, inEditMode: editHeaderDetails, disabled: inspUpdatestatus === -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, common_utils_1.getDetailGrid)(t, userDefinedFields(t), hardCodeUnitFields, hardCodeDateTimeFields, hardCodeCurrencyFields, hardCodeNumericFields, hardCodeBooleanFields, isEditableField, isFullEditAllowedFlag, undefined, undefined, exports.getDomainValues, common_utils_1.getDomainItems) })) })));
    if (!isLoading && origDetails && !formSubmitted) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeFormV2, __assign({ mode: editHeaderDetails ? 'edit' : 'view', initialValues: editHeaderDetails ? origDetails : viewDetails, enableReinitialize: true, onSubmit: function (data) {
                setEditHeaderDetails(false);
                handleFormSubmit(data);
            } }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.TabWrapper, __assign({ "$height": 683 }, { children: [(0, jsx_runtime_1.jsxs)(Tabs_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: tabValue, onChange: handleChangeTab, "aria-label": "manhole-attributes" }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Details') }, (0, _Utils_1.a11yProps)(0))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Location') }, (0, _Utils_1.a11yProps)(1))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Pipe') }, (0, _Utils_1.a11yProps)(2))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('Miscellaneous') }, (0, _Utils_1.a11yProps)(3))), (0, jsx_runtime_1.jsx)(Tabs_1.Tab, __assign({ label: t('User Defined') }, (0, _Utils_1.a11yProps)(4)))] })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 0 }, { children: general })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 1 }, { children: location })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 2 }, { children: pipe })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 3 }, { children: miscellaneous })), (0, jsx_runtime_1.jsx)(Tabs_1.TabPanel, __assign({ value: tabValue, index: 4 }, { children: userDefined }))] })) })));
            } })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '25px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    }
};
exports.WSA05InspectionProps = WSA05InspectionProps;
exports["default"] = exports.WSA05InspectionProps;


/***/ }),

/***/ "./components/WSA05InspectionProps/index.ts":
/*!**************************************************!*\
  !*** ./components/WSA05InspectionProps/index.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getWSA05DomainValues = exports["default"] = void 0;
var WSA05InspectionProps_component_1 = __webpack_require__(/*! ./WSA05InspectionProps.component */ "./components/WSA05InspectionProps/WSA05InspectionProps.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(WSA05InspectionProps_component_1).default; } }));
var WSA05InspectionProps_component_2 = __webpack_require__(/*! ./WSA05InspectionProps.component */ "./components/WSA05InspectionProps/WSA05InspectionProps.component.tsx");
Object.defineProperty(exports, "getWSA05DomainValues", ({ enumerable: true, get: function () { return WSA05InspectionProps_component_2.getDomainValues; } }));


/***/ }),

/***/ "./components/index.ts":
/*!*****************************!*\
  !*** ./components/index.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CreateInspection = exports.getWSA05DomainValues = exports.WSA05InspectionProps = exports.MSCCInspectionProps = exports.MapInsertSpatialComponent = exports.MapInsertSpatial = exports.MapInsertInspection = exports.MapInsertAsset = exports.Ratings = exports.MACPInspectionProps = exports.MACPComponentConditions = exports.TaskDetails = exports.InspDetails = exports.AssetDetails = exports.FilterSelect = exports.ShowMoreOverlay = exports.ValidationTable = exports.DetailsCard = exports.ObservationSearchBar = exports.ObservationPhoto = exports.getPACPDomainValues = exports.InspectionProps = exports.ObservationSummary = exports.ObservationNotes = exports.ObservationTable = exports.RowsPerPage = exports.SearchBar = void 0;
var DetailsCard_1 = __importDefault(__webpack_require__(/*! ./DetailsCard */ "./components/DetailsCard/index.ts"));
exports.DetailsCard = DetailsCard_1.default;
var PACPInspectionProps_1 = __importDefault(__webpack_require__(/*! ./PACPInspectionProps */ "./components/PACPInspectionProps/index.ts"));
exports.InspectionProps = PACPInspectionProps_1.default;
var PACPInspectionProps_2 = __webpack_require__(/*! ./PACPInspectionProps */ "./components/PACPInspectionProps/index.ts");
Object.defineProperty(exports, "getPACPDomainValues", ({ enumerable: true, get: function () { return PACPInspectionProps_2.getPACPDomainValues; } }));
var ObservationNotes_1 = __importDefault(__webpack_require__(/*! ./ObservationNotes */ "./components/ObservationNotes/index.ts"));
exports.ObservationNotes = ObservationNotes_1.default;
var ObservationPhoto_1 = __importDefault(__webpack_require__(/*! ./ObservationPhoto */ "./components/ObservationPhoto/index.ts"));
exports.ObservationPhoto = ObservationPhoto_1.default;
var ObservationSearchBar_1 = __importDefault(__webpack_require__(/*! ./ObservationSearchBar */ "./components/ObservationSearchBar/index.ts"));
exports.ObservationSearchBar = ObservationSearchBar_1.default;
var ObservationSummary_1 = __importDefault(__webpack_require__(/*! ./ObservationSummary */ "./components/ObservationSummary/index.ts"));
exports.ObservationSummary = ObservationSummary_1.default;
var ObservationTable_1 = __importDefault(__webpack_require__(/*! ./ObservationTable */ "./components/ObservationTable/index.ts"));
exports.ObservationTable = ObservationTable_1.default;
var RowsPerPage_1 = __importDefault(__webpack_require__(/*! ./RowsPerPage */ "./components/RowsPerPage/index.ts"));
exports.RowsPerPage = RowsPerPage_1.default;
var SearchBar_1 = __importDefault(__webpack_require__(/*! ./SearchBar */ "./components/SearchBar/index.ts"));
exports.SearchBar = SearchBar_1.default;
var ShowMoreOverlay_1 = __importDefault(__webpack_require__(/*! ./ShowMoreOverlay */ "./components/ShowMoreOverlay/index.ts"));
exports.ShowMoreOverlay = ShowMoreOverlay_1.default;
var ValidationTable_1 = __importDefault(__webpack_require__(/*! ./ValidationTable */ "./components/ValidationTable/index.ts"));
exports.ValidationTable = ValidationTable_1.default;
var FilterSelect_1 = __importDefault(__webpack_require__(/*! ./FilterSelect */ "./components/FilterSelect/index.ts"));
exports.FilterSelect = FilterSelect_1.default;
var AssetDetails_1 = __importDefault(__webpack_require__(/*! ./AssetDetails */ "./components/AssetDetails/index.ts"));
exports.AssetDetails = AssetDetails_1.default;
var AssetDetails_2 = __webpack_require__(/*! ./AssetDetails */ "./components/AssetDetails/index.ts");
Object.defineProperty(exports, "InspDetails", ({ enumerable: true, get: function () { return AssetDetails_2.InspDetails; } }));
Object.defineProperty(exports, "TaskDetails", ({ enumerable: true, get: function () { return AssetDetails_2.TaskDetails; } }));
var MACPInspectionProps_1 = __importDefault(__webpack_require__(/*! ./MACPInspectionProps */ "./components/MACPInspectionProps/index.ts"));
exports.MACPInspectionProps = MACPInspectionProps_1.default;
var Ratings_1 = __importDefault(__webpack_require__(/*! ./Ratings */ "./components/Ratings/index.ts"));
exports.Ratings = Ratings_1.default;
var MACPComponentConditions_1 = __webpack_require__(/*! ./MACPComponentConditions */ "./components/MACPComponentConditions/index.ts");
Object.defineProperty(exports, "MACPComponentConditions", ({ enumerable: true, get: function () { return MACPComponentConditions_1.MACPComponentConditions; } }));
var MapInsertAsset_1 = __webpack_require__(/*! ./maps/MapInsertAsset */ "./components/maps/MapInsertAsset/index.ts");
Object.defineProperty(exports, "MapInsertAsset", ({ enumerable: true, get: function () { return MapInsertAsset_1.MapInsertAsset; } }));
var MapInsertInspection_1 = __webpack_require__(/*! ./maps/MapInsertInspection */ "./components/maps/MapInsertInspection/index.ts");
Object.defineProperty(exports, "MapInsertInspection", ({ enumerable: true, get: function () { return MapInsertInspection_1.MapInsertInspection; } }));
var MapInsertSpatial_1 = __webpack_require__(/*! ./maps/MapInsertSpatial */ "./components/maps/MapInsertSpatial/index.ts");
Object.defineProperty(exports, "MapInsertSpatial", ({ enumerable: true, get: function () { return MapInsertSpatial_1.MapInsertSpatial; } }));
Object.defineProperty(exports, "MapInsertSpatialComponent", ({ enumerable: true, get: function () { return MapInsertSpatial_1.MapInsertSpatialComponent; } }));
var MSCCInspectionProps_1 = __importDefault(__webpack_require__(/*! ./MSCCInspectionProps */ "./components/MSCCInspectionProps/index.ts"));
exports.MSCCInspectionProps = MSCCInspectionProps_1.default;
var WSA05InspectionProps_1 = __importDefault(__webpack_require__(/*! ./WSA05InspectionProps */ "./components/WSA05InspectionProps/index.ts"));
exports.WSA05InspectionProps = WSA05InspectionProps_1.default;
var WSA05InspectionProps_2 = __webpack_require__(/*! ./WSA05InspectionProps */ "./components/WSA05InspectionProps/index.ts");
Object.defineProperty(exports, "getWSA05DomainValues", ({ enumerable: true, get: function () { return WSA05InspectionProps_2.getWSA05DomainValues; } }));
var CreateInspection_1 = __webpack_require__(/*! ./CreateInspection */ "./components/CreateInspection/index.ts");
Object.defineProperty(exports, "CreateInspection", ({ enumerable: true, get: function () { return CreateInspection_1.CreateInspection; } }));
exports["default"] = {
    SearchBar: SearchBar_1.default,
    RowsPerPage: RowsPerPage_1.default,
    ObservationTable: ObservationTable_1.default,
    ObservationNotes: ObservationNotes_1.default,
    ObservationSummary: ObservationSummary_1.default,
    InspectionProps: PACPInspectionProps_1.default,
    getPACPDomainValues: PACPInspectionProps_2.getPACPDomainValues,
    ObservationPhoto: ObservationPhoto_1.default,
    ObservationSearchBar: ObservationSearchBar_1.default,
    ValidationTable: ValidationTable_1.default,
    ShowMoreOverlay: ShowMoreOverlay_1.default,
    FilterSelect: FilterSelect_1.default,
    AssetDetails: AssetDetails_1.default,
    InspDetails: AssetDetails_2.InspDetails,
    TaskDetails: AssetDetails_2.TaskDetails,
    MACPComponentConditions: MACPComponentConditions_1.MACPComponentConditions,
    MACPInspectionProps: MACPInspectionProps_1.default,
    Ratings: Ratings_1.default,
    MapInsertAsset: MapInsertAsset_1.MapInsertAsset,
    MapInsertInspection: MapInsertInspection_1.MapInsertInspection,
    MapInsertSpatial: MapInsertSpatial_1.MapInsertSpatial,
    MSCCInspectionProps: MSCCInspectionProps_1.default,
    WSA05InspectionProps: WSA05InspectionProps_1.default,
    getWSA05DomainValues: WSA05InspectionProps_2.getWSA05DomainValues,
    CreateInspection: CreateInspection_1.CreateInspection,
};


/***/ }),

/***/ "./components/maps/MapInsertAsset/MapInsertAsset.tsx":
/*!***********************************************************!*\
  !*** ./components/maps/MapInsertAsset/MapInsertAsset.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var stylovyze_2 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var MapInsertAsset = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.logLevel, logLevel = _f === void 0 ? _Types_1.MapStatusType.WARN : _f;
    var token = (0, stylovyze_1.useAuth0)().token;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var inputs = (0, _Selectors_1.useSelectMapInsertAsset)(token);
    var showArcGISBasemap = !!(0, stylovyze_1.useIsFeatureEnabled)(stylovyze_1.STYLOVYZE_FLAGS.ARCGIS_BASEMAPS);
    var basemapOrigin = showArcGISBasemap
        ? (_c = (_b = companySettings.mapSettings) === null || _b === void 0 ? void 0 : _b.basemapOrigin) !== null && _c !== void 0 ? _c : 'mapbox'
        : 'mapbox';
    var background = basemapOrigin == 'arcgis'
        ? inno_map_1.BackgroundTypes.OSMStandard
        : inno_map_1.BackgroundTypes.Streets;
    var reactMapConfig = (0, stylovyze_2.useReactMapConfig)();
    return ((0, jsx_runtime_1.jsx)(inno_map_1.ReactMap, { config: reactMapConfig, mode: inno_map_1.MapModes.Navigation, dataServices: inputs.sources, layerConfig: inputs.layers, autoResize: false, position: (_e = (_d = inputs.location) === null || _d === void 0 ? void 0 : _d.position) !== null && _e !== void 0 ? _e : undefined, selectedAssets: inputs.selected, showMinZoomWarning: false, logLevel: logLevel !== null && logLevel !== void 0 ? logLevel : _Types_1.MapStatusType.WARN, background: background }));
};
exports["default"] = MapInsertAsset;


/***/ }),

/***/ "./components/maps/MapInsertAsset/index.ts":
/*!*************************************************!*\
  !*** ./components/maps/MapInsertAsset/index.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MapInsertAsset = void 0;
var MapInsertAsset_1 = __webpack_require__(/*! ./MapInsertAsset */ "./components/maps/MapInsertAsset/MapInsertAsset.tsx");
Object.defineProperty(exports, "MapInsertAsset", ({ enumerable: true, get: function () { return __importDefault(MapInsertAsset_1).default; } }));


/***/ }),

/***/ "./components/maps/MapInsertInspection/MapInsertInspection.tsx":
/*!*********************************************************************!*\
  !*** ./components/maps/MapInsertInspection/MapInsertInspection.tsx ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
var fullInspection_actions_1 = __webpack_require__(/*! @Actions/fullInspection.actions */ "./actions/fullInspection.actions.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_2 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var MapInsertInspection = function (_a) {
    var _b, _c, _d, _e;
    var standard = _a.standard, inspectionId = _a.inspectionId, _f = _a.logLevel, logLevel = _f === void 0 ? _Types_1.MapStatusType.WARN : _f;
    var dispatch = (0, react_redux_1.useDispatch)();
    var token = (0, stylovyze_1.useAuth0)().token;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var inputs = (0, _Selectors_1.useSelectMapInsertInspection)(token);
    var fullInspectionIsWaiting = (0, _Selectors_1.selectFullInspectionIsWaiting)();
    var inspection = (0, _Selectors_1.selectFullInspection)();
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var enableMediaTranscode = (0, stylovyze_1.useIsFeatureEnabled)('info-360-media-convert')
        ? true
        : false;
    var showArcGISBasemap = !!(0, stylovyze_1.useIsFeatureEnabled)(stylovyze_1.STYLOVYZE_FLAGS.ARCGIS_BASEMAPS);
    var basemapOrigin = showArcGISBasemap
        ? (_c = (_b = companySettings.mapSettings) === null || _b === void 0 ? void 0 : _b.basemapOrigin) !== null && _c !== void 0 ? _c : 'mapbox'
        : 'mapbox';
    var background = basemapOrigin == 'arcgis'
        ? inno_map_1.BackgroundTypes.OSMStandard
        : inno_map_1.BackgroundTypes.Streets;
    react_1.default.useEffect(function () {
        if (standard !== undefined &&
            !fullInspectionIsWaiting &&
            inspection._id !== inspectionId) {
            // Ensure map.reducers are triggered with the appropriate inspection geometry
            dispatch((0, fullInspection_actions_1.getFullInsp)({
                standard: standard,
                inspectionId: inspectionId,
                formatDate: formatDate,
                formatDateUTC: formatDateUTC,
                enableMediaTranscode: enableMediaTranscode,
            }));
        }
    }, [
        standard,
        inspectionId,
        formatDate,
        dispatch,
        fullInspectionIsWaiting,
        inspection,
    ]);
    var reactMapConfig = (0, stylovyze_2.useReactMapConfig)();
    return ((0, jsx_runtime_1.jsx)(inno_map_1.ReactMap, { config: reactMapConfig, mode: inno_map_1.MapModes.Navigation, dataServices: inputs.sources, layerConfig: inputs.layers, autoResize: false, position: (_e = (_d = inputs.location) === null || _d === void 0 ? void 0 : _d.position) !== null && _e !== void 0 ? _e : undefined, showMinZoomWarning: false, logLevel: logLevel !== null && logLevel !== void 0 ? logLevel : _Types_1.MapStatusType.WARN, background: background }));
};
exports["default"] = MapInsertInspection;


/***/ }),

/***/ "./components/maps/MapInsertInspection/index.ts":
/*!******************************************************!*\
  !*** ./components/maps/MapInsertInspection/index.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MapInsertInspection = void 0;
var MapInsertInspection_1 = __webpack_require__(/*! ./MapInsertInspection */ "./components/maps/MapInsertInspection/MapInsertInspection.tsx");
Object.defineProperty(exports, "MapInsertInspection", ({ enumerable: true, get: function () { return __importDefault(MapInsertInspection_1).default; } }));


/***/ }),

/***/ "./components/maps/MapInsertSpatial/MapInsertSpatial.tsx":
/*!***************************************************************!*\
  !*** ./components/maps/MapInsertSpatial/MapInsertSpatial.tsx ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var MapInsertSpatialComponent_1 = __importDefault(__webpack_require__(/*! ./MapInsertSpatialComponent */ "./components/maps/MapInsertSpatial/MapInsertSpatialComponent.tsx"));
var MapInsertSpatial = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        console.warn('MapInsertSpatial is deprecated', 'use MapInsertSpatialComponent instead and consume the dispatches directly', 'We want to avoid duplicates calls to getSpatialLayers');
    }, []);
    // Copy next useEffect to your parent component instead of using this component
    (0, react_1.useEffect)(function () {
        // import {	mapSpatialTilesSourceHide,	getSpatialLayers } from '@innovyze/lib_am_common/Actions';
        dispatch((0, _Actions_1.mapSpatialTilesSourceHide)(true));
        // map redux populated with getSpatialLayers response
        dispatch((0, _Actions_1.getSpatialLayers)());
    }, []);
    return (0, jsx_runtime_1.jsx)(MapInsertSpatialComponent_1.default, __assign({}, props));
};
exports["default"] = MapInsertSpatial;


/***/ }),

/***/ "./components/maps/MapInsertSpatial/MapInsertSpatialComponent.tsx":
/*!************************************************************************!*\
  !*** ./components/maps/MapInsertSpatial/MapInsertSpatialComponent.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var spatial_actions_1 = __webpack_require__(/*! @Actions/spatial.actions */ "./actions/spatial.actions.ts");
var stylovyze_2 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var MapInsertSpatialComponent = function (_a) {
    var _b, _c, _d, _e;
    var layerName = _a.layerName, _f = _a.showSystemTypeLayers, showSystemTypeLayers = _f === void 0 ? false : _f, _g = _a.logLevel, logLevel = _g === void 0 ? _Types_1.MapStatusType.WARN : _g;
    var token = (0, stylovyze_1.useAuth0)().token;
    var dispatch = (0, react_redux_1.useDispatch)();
    var inputs = (0, _Selectors_1.useSelectMapInsertSpatial)(token, layerName, showSystemTypeLayers);
    (0, react_1.useEffect)(function () {
        if (!(inputs === null || inputs === void 0 ? void 0 : inputs.layers)) {
            dispatch((0, spatial_actions_1.getSpatialLayers)());
        }
    }, [dispatch, inputs, layerName]);
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var showArcGISBasemap = !!(0, stylovyze_1.useIsFeatureEnabled)(stylovyze_1.STYLOVYZE_FLAGS.ARCGIS_BASEMAPS);
    var basemapOrigin = showArcGISBasemap
        ? (_c = (_b = companySettings.mapSettings) === null || _b === void 0 ? void 0 : _b.basemapOrigin) !== null && _c !== void 0 ? _c : 'mapbox'
        : 'mapbox';
    var background = basemapOrigin == 'arcgis'
        ? inno_map_1.BackgroundTypes.OSMStandard
        : inno_map_1.BackgroundTypes.Streets;
    var reactMapConfig = (0, stylovyze_2.useReactMapConfig)();
    return ((0, jsx_runtime_1.jsx)(inno_map_1.ReactMap, { config: reactMapConfig, mode: inno_map_1.MapModes.Navigation, dataServices: inputs.sources, layerConfig: inputs.layers, autoResize: false, position: (_e = (_d = inputs.location) === null || _d === void 0 ? void 0 : _d.position) !== null && _e !== void 0 ? _e : undefined, hiddenLayers: inputs.hiddenLayers, showMinZoomWarning: false, logLevel: logLevel !== null && logLevel !== void 0 ? logLevel : _Types_1.MapStatusType.WARN, background: background }));
};
exports["default"] = MapInsertSpatialComponent;


/***/ }),

/***/ "./components/maps/MapInsertSpatial/index.ts":
/*!***************************************************!*\
  !*** ./components/maps/MapInsertSpatial/index.ts ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MapInsertSpatialComponent = exports.MapInsertSpatial = void 0;
var MapInsertSpatial_1 = __webpack_require__(/*! ./MapInsertSpatial */ "./components/maps/MapInsertSpatial/MapInsertSpatial.tsx");
Object.defineProperty(exports, "MapInsertSpatial", ({ enumerable: true, get: function () { return __importDefault(MapInsertSpatial_1).default; } }));
var MapInsertSpatialComponent_1 = __webpack_require__(/*! ./MapInsertSpatialComponent */ "./components/maps/MapInsertSpatial/MapInsertSpatialComponent.tsx");
Object.defineProperty(exports, "MapInsertSpatialComponent", ({ enumerable: true, get: function () { return __importDefault(MapInsertSpatialComponent_1).default; } }));


/***/ }),

/***/ "./i18n/index.ts":
/*!***********************!*\
  !*** ./i18n/index.ts ***!
  \***********************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./useGlobalization */ "./i18n/useGlobalization.ts"), exports);
__exportStar(__webpack_require__(/*! ./types */ "./i18n/types.ts"), exports);


/***/ }),

/***/ "./i18n/types.ts":
/*!***********************!*\
  !*** ./i18n/types.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./i18n/useGlobalization.ts":
/*!**********************************!*\
  !*** ./i18n/useGlobalization.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGlobalization = void 0;
var react_i18next_1 = __webpack_require__(/*! react-i18next */ "react-i18next");
var settings_json_1 = __webpack_require__(/*! ./settings.json */ "./i18n/settings.json");
/**
 * Translate text with react-i18next useTranslate with
 * predefined namespace for the mini-app
 * @param i18nNs overide namespace
 * @returns string
 */
var useGlobalization = function (i18nNs) {
    if (i18nNs === void 0) { i18nNs = settings_json_1.ns; }
    var _a = (0, react_i18next_1.useTranslation)(i18nNs), t = _a.t, other = __rest(_a, ["t"]);
    return __assign({ t: t }, other);
};
exports.useGlobalization = useGlobalization;


/***/ }),

/***/ "./reducers/assetDetail.reducer.ts":
/*!*****************************************!*\
  !*** ./reducers/assetDetail.reducer.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetDetail_actions_1 = __webpack_require__(/*! @Actions/assetDetail.actions */ "./actions/assetDetail.actions.ts");
var initAssetDetails = [
    {
        FieldName: '',
        FieldTitle: '',
        FieldValue: '',
    },
];
exports.initState = {
    assetDetails: initAssetDetails,
    notes: [],
    isReady: false,
    isWaiting: false,
    notesIsWaiting: false,
    assetLocationIsWaiting: false,
};
var reducer = (_a = {},
    _a[assetDetail_actions_1.getAssetCounts.toString()] = function (state) { return (__assign(__assign({}, state), { assetCounts: [], isAssetCountsReady: false })); },
    _a[assetDetail_actions_1.getAssetCountsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetCounts: action.payload, isAssetCountsReady: true })); },
    _a[assetDetail_actions_1.getAssetCountsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { assetCounts: [], isAssetCountsReady: true })); },
    _a[assetDetail_actions_1.getAssetDetail.toString()] = function (state) { return (__assign(__assign({}, state), { assetDetails: [], notes: [], isReady: false })); },
    _a[assetDetail_actions_1.getAssetDetailResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, assetDetails: action.payload.assetDetails, notes: action.payload.notes, isReady: true, isWaiting: false, notesIsWaiting: false })); },
    _a[assetDetail_actions_1.getAssetDetailRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, isWaiting: false, notesIsWaiting: false })); },
    _a[assetDetail_actions_1.checkAssetIdsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { validAssetIdsList: action.payload })); },
    _a[assetDetail_actions_1.checkAssetIdsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { validAssetIdsList: [] })); },
    _a[assetDetail_actions_1.clearValidAssetIds.toString()] = function (state) { return (__assign(__assign({}, state), { validAssetIdsList: [] })); },
    _a[assetDetail_actions_1.setInspectionsValidatingAsset.toString()] = function (state, action) { return (__assign(__assign({}, state), { validatingAssets: action.payload })); },
    _a[assetDetail_actions_1.setAssetDetailIsWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isWaiting: action.payload })); },
    _a[assetDetail_actions_1.setAssetDetailNotesIsWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { notesIsWaiting: action.payload })); },
    _a[assetDetail_actions_1.setAssetLocation.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetLocation: action.payload })); },
    _a[assetDetail_actions_1.setAssetLocationIsWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetLocationIsWaiting: action.payload })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/assetManhole.reducer.ts":
/*!******************************************!*\
  !*** ./reducers/assetManhole.reducer.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetManhole_actions_1 = __webpack_require__(/*! @Actions/assetManhole.actions */ "./actions/assetManhole.actions.ts");
var initAssetManhole = {
    assetId: '',
    yearLaid: '',
    layerSystemType: '',
    location: '',
    street: '',
    assetType: '',
    owner: '',
    status: '',
    systemType: '',
};
exports.initState = {
    asset: initAssetManhole,
    isReady: false,
};
var reducer = (_a = {},
    _a[assetManhole_actions_1.getAssetManholeResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, asset: action.payload.asset, isReady: true })); },
    _a[assetManhole_actions_1.getAssetManhole.toString()] = function (state) { return (__assign(__assign({}, state), { isReady: false })); },
    _a[assetManhole_actions_1.getAssetManholeRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/assetPipe.reducer.ts":
/*!***************************************!*\
  !*** ./reducers/assetPipe.reducer.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetPipe_actions_1 = __webpack_require__(/*! @Actions/assetPipe.actions */ "./actions/assetPipe.actions.ts");
var initAssetPipe = {
    assetId: '',
    pipeType: 'G',
    yearLaid: '',
    diameter: 0,
    usNodeId: '',
    dsNodeId: '',
    material: '',
    usInvert: 0,
    dsInvert: 0,
};
exports.initState = {
    asset: initAssetPipe,
    isReady: false,
};
var reducer = (_a = {},
    _a[assetPipe_actions_1.getAssetPipeResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, asset: action.payload.asset, isReady: true })); },
    _a[assetPipe_actions_1.getAssetPipe.toString()] = function (state) { return (__assign(__assign({}, state), { isReady: false })); },
    _a[assetPipe_actions_1.getAssetPipeRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, isReady: true })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/assetRisk.reducer.ts":
/*!***************************************!*\
  !*** ./reducers/assetRisk.reducer.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var initAssetRisk = {
    ASSET_ID: '',
    CURRENT_STRUCTURAL: 0,
    CURRENT_SERVICE: 0,
    COF_CONFIG: [],
    LOF_CONFIG: [],
    RISK_CONFIG: [],
    RISK_PERCENTILE: 0,
    WEIGHTED_SCORES: {},
};
exports.initState = {
    assetRisk: initAssetRisk,
    riskSummary: [],
    isReady: false,
    isRejected: false,
    isWaiting: false,
    riskSummaryIsLoading: false,
};
var reducer = (_a = {},
    _a[assetRisk_actions_1.getAssetRisk.toString()] = function (state) { return (__assign(__assign({}, state), { assetRisk: initAssetRisk, isReady: false, isRejected: false, isWaiting: true })); },
    _a[assetRisk_actions_1.getAssetRiskResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, assetRisk: action.payload, isReady: true, isRejected: false, isWaiting: false })); },
    _a[assetRisk_actions_1.getAssetRiskWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isWaiting: action.payload })); },
    _a[assetRisk_actions_1.getAssetRiskRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, isReady: true, isRejected: true, isWaiting: false })); },
    _a[assetRisk_actions_1.setRiskSummaryIsLoading.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskSummaryIsLoading: action.payload, riskSummary: action.payload === true ? [] : state.riskSummary })); },
    _a[assetRisk_actions_1.getRiskSummary.toString()] = function (state) { return (__assign(__assign({}, state), { riskSummary: [], riskSummaryIsLoading: true })); },
    _a[assetRisk_actions_1.getRiskSummaryResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskSummary: action.payload, riskSummaryIsLoading: false })); },
    _a[assetRisk_actions_1.getRiskSummaryRejected.toString()] = function (state) { return (__assign(__assign({}, state), { riskSummaryIsLoading: false })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/assetRiskHistory.reducer.ts":
/*!**********************************************!*\
  !*** ./reducers/assetRiskHistory.reducer.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var initAssetRiskHistory = [];
exports.initState = {
    assetRiskHistory: initAssetRiskHistory,
    isReady: false,
};
var reducer = (_a = {},
    _a[assetRisk_actions_1.getAssetRiskHistory.toString()] = function (state) { return (__assign(__assign({}, state), { assetRiskHistory: initAssetRiskHistory, isReady: false })); },
    _a[assetRisk_actions_1.getAssetRiskHistoryResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, assetRiskHistory: action.payload, isReady: true })); },
    _a[assetRisk_actions_1.getAssetRiskHistoryRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, isReady: false })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/charts.reducer.ts":
/*!************************************!*\
  !*** ./reducers/charts.reducer.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var AM_COMMON = __importStar(__webpack_require__(/*! . */ "./reducers/index.ts"));
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.initialState = {
    charts: [],
    isLoading: false,
};
var updateIsLoading = function (state, isLoading) {
    state.isLoading = isLoading;
    return state;
};
var updateChart = function (state, chartId, status, data) {
    var charts = state.charts;
    var chart = charts.find(function (chart) {
        return chart.chartId === chartId;
    });
    if (chart) {
        chart.data = data;
        chart.status = status;
    }
    else {
        charts.push({
            chartId: chartId,
            data: data,
            status: status,
        });
    }
    state.isLoading = false;
    return state;
};
var doClearChart = function (state, chartId) {
    state.charts = state.charts.filter(function (chart) {
        return chart.chartId !== chartId;
    });
    return state;
};
var doClearCharts = function (state) {
    state.charts = [];
    return state;
};
var reducer = (_a = {},
    _a[_Actions_1.getCharts.toString()] = function (state) { return updateIsLoading(state, true); },
    _a[_Actions_1.getChartsResolved.toString()] = function (state, action) {
        return updateChart(state, action.payload.chartId, AM_COMMON.status200(), action.payload.result);
    },
    _a[_Actions_1.getChartsRejected.toString()] = function (state, action) {
        return updateChart(state, action.payload.chartId, action.payload.result, undefined);
    },
    _a[_Actions_1.clearChart.toString()] = function (state, action) {
        return doClearChart(state, action.payload);
    },
    _a[_Actions_1.clearCharts.toString()] = function (state) { return doClearCharts(state); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initialState, reducer);


/***/ }),

/***/ "./reducers/configuration.reducer.ts":
/*!*******************************************!*\
  !*** ./reducers/configuration.reducer.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var paginationUtils_1 = __webpack_require__(/*! ./paginationUtils */ "./reducers/paginationUtils.ts");
exports.initialState = {
    configurations: {},
    isLoadingConfiguration: false,
    status: (0, paginationUtils_1.statusDefault)(),
};
var reducer = (_a = {},
    _a[_Actions_1.getConfigurationWithMapping.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingConfiguration: true, status: (0, paginationUtils_1.statusLoading)() })); },
    _a[_Actions_1.getConfigurationWithUploadId.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingConfiguration: true, status: (0, paginationUtils_1.statusLoading)() })); },
    _a[_Actions_1.getConfigurationResolved.toString()] = function (state, action) {
        var mapping = new Array();
        // Parse the config
        Object.entries(action.payload.configuration['config']).forEach(function (_a) {
            var _b, _c, _d;
            var key = _a[0], value = _a[1];
            mapping.push({
                target: value.display_name,
                unit: value.data_type,
                source: key,
                incomingUnit: (_b = value.incoming_unit) !== null && _b !== void 0 ? _b : '',
                sampleValue: '',
                usage: (_c = value.system_unit_name) !== null && _c !== void 0 ? _c : '',
                primaryKey: (_d = value.primary_key) !== null && _d !== void 0 ? _d : false,
            });
        });
        var details = {
            targetType: action.payload.configuration['importRecord']['targetType'],
            userDataType: action.payload.configuration['importRecord']['userDataType'],
        };
        var configuration = {
            mapping: mapping,
            details: details,
        };
        state.configurations[action.payload.key] = configuration;
        state.isLoadingConfiguration = false;
        state.status = (0, paginationUtils_1.status200)();
        return state;
    },
    _a[_Actions_1.getConfigurationRejected.toString()] = function (state, action) { return (__assign(__assign({}, state), { isLoadingConfiguration: false, status: action.payload })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initialState, reducer);


/***/ }),

/***/ "./reducers/correctRehabDetails.ts":
/*!*****************************************!*\
  !*** ./reducers/correctRehabDetails.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.correctRehabDetails = void 0;
var lib_asset_schema_1 = __webpack_require__(/*! @innovyze/lib_asset_schema */ "@innovyze/lib_asset_schema");
var lodash_1 = __webpack_require__(/*! lodash */ "lodash");
/**
 * TODO: Fix backend response @AssetSchemaMigration
 * @see RehabTreeCard component in app-am-rehab
 *      {@link https://git.autodesk.com/aec-water/app-am-rehab/blob/812a302a53f1f0db0c4e1f52a39ee93557cf225a/src/components/RehabTreeList/RehabTreeCard.component.tsx#L226-L277}
 *
 * Note: The backend seems to be returning 'pipe' by default for 'Sanitary Sewer' systems.
 * Also, in some rehab models, the asset type is returned as 'PIPE'.
 */
var correctAssetType = function (assetType, systemType) {
    // Remove spaces to convert display name to System Type ID.
    var normalizedSystemType = systemType.split(' ').join('');
    var assetTypePrefix = (0, lib_asset_schema_1.getAssetTypePrefixBySystemType)(normalizedSystemType);
    if (assetTypePrefix && !assetType.startsWith(assetTypePrefix)) {
        return "".concat(assetTypePrefix).concat((0, lodash_1.upperFirst)((0, lodash_1.camelCase)(assetType)));
    }
    return assetType;
};
function correctRehabDetails(rehab) {
    var _a, _b, _c, _d;
    var systemType = (_a = rehab.systemType) !== null && _a !== void 0 ? _a : 'Sanitary Sewer';
    var assetType = correctAssetType((_b = rehab.assetType) !== null && _b !== void 0 ? _b : 'wwPipe', systemType);
    return {
        layerName: rehab.name,
        id: rehab._id,
        lastRun: (_c = rehab.lastRun) !== null && _c !== void 0 ? _c : '',
        assetType: assetType,
        systemType: systemType,
        layers: (_d = rehab.actions) === null || _d === void 0 ? void 0 : _d.map(function (a) { return ({
            layerName: a.actionId,
            id: a._id,
        }); }),
    };
}
exports.correctRehabDetails = correctRehabDetails;


/***/ }),

/***/ "./reducers/filterUtils.ts":
/*!*********************************!*\
  !*** ./reducers/filterUtils.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.updateTranslations = exports.updateColumnFilterSelectOptions = exports.changeMultipleFiltersSelect = exports.updateChangeFilterSelect = exports.translateSelectProps = exports.translate = exports.translations = exports.queryParamFilters = exports.filterByDatesSelect = exports.filterByMultipleIdSelect = exports.filterByIdSelect = exports.filterDateOptions = exports.noFilters = void 0;
var filter_types_1 = __webpack_require__(/*! @Types/filter.types */ "./types/filter.types.ts");
var noFilters = function () { return ({ id: 'all', caption: 'All' }); };
exports.noFilters = noFilters;
var filterDateOptions = function () { return [
    (0, exports.noFilters)(),
    { id: filter_types_1.FilterDateTime.Today, caption: 'Today' },
    { id: filter_types_1.FilterDateTime.LastWeek, caption: 'Last Week' },
    { id: filter_types_1.FilterDateTime.LastMonth, caption: 'Last Month' },
    { id: filter_types_1.FilterDateTime.LastYear, caption: 'Last Year' },
]; };
exports.filterDateOptions = filterDateOptions;
var getDateGTE = function (when) {
    var now = new Date();
    switch (when) {
        case filter_types_1.FilterDateTime.LastWeek:
            now.setHours(now.getHours() - 24 * 7);
            break;
        case filter_types_1.FilterDateTime.LastMonth:
            now.setMonth(now.getMonth() - 1);
            break;
        case filter_types_1.FilterDateTime.LastYear:
            now.setFullYear(now.getFullYear() - 1);
            break;
    }
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
var filterByIdSelect = function (option, idCaptions) {
    if (option.value !== 'all') {
        var value = idCaptions.find(function (value) { return value.id === option.value; });
        if (value) {
            return [
                {
                    colKey: option.colKey,
                    value: value.id,
                },
            ];
        }
    }
    return [];
};
exports.filterByIdSelect = filterByIdSelect;
var filterByMultipleIdSelect = function (option, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_idCaptions) {
    if (option.value.length != 0) {
        return [
            {
                colKey: option.colKey,
                value: option.value,
            },
        ];
    }
    return [];
};
exports.filterByMultipleIdSelect = filterByMultipleIdSelect;
var filterByDatesSelect = function (option, idCaptions) {
    if (option.value !== 'all') {
        var value = idCaptions.find(function (value) { return value.id === option.value; });
        if (value) {
            return [
                {
                    colKey: option.colKey,
                    value: getDateGTE(value.id).toISOString(),
                    operator: filter_types_1.FilterOperator.GreaterOrEqual,
                },
            ];
        }
    }
    return [];
};
exports.filterByDatesSelect = filterByDatesSelect;
var queryParamFilter = function (filter) {
    var _a, _b, _c;
    if (filter.value === (0, exports.noFilters)().id) {
        return '';
    }
    var f = '';
    if (((_a = filter === null || filter === void 0 ? void 0 : filter.colKey.length) !== null && _a !== void 0 ? _a : 0) > 0) {
        if (filter === null || filter === void 0 ? void 0 : filter.multiple) {
            var values = filter.value;
            f = "".concat(filter.colKey, "|").concat(encodeURIComponent(values.join('|')));
        }
        else {
            f = "".concat(filter.colKey, "|").concat(encodeURIComponent(filter.value));
        }
    }
    if (f.length &&
        ((_b = filter === null || filter === void 0 ? void 0 : filter.operator) !== null && _b !== void 0 ? _b : filter_types_1.FilterOperator.Equal) !== filter_types_1.FilterOperator.Equal) {
        f += '|' + encodeURIComponent((_c = filter.operator) !== null && _c !== void 0 ? _c : filter_types_1.FilterOperator.Equal);
    }
    return f;
};
var queryParamFilters = function (filters) {
    var fs = filters.reduce(function (acc, cur) {
        var q = queryParamFilter(cur);
        return q.length ? "".concat(acc, ",").concat(encodeURIComponent(q)) : acc;
    }, '');
    return fs.length > 1 ? encodeURI("&filters=".concat(fs.substr(1))) : '';
};
exports.queryParamFilters = queryParamFilters;
var translations = function (translations) {
    return Object.fromEntries(translations.map(function (t) { return [t.id, t.caption]; }));
};
exports.translations = translations;
var translate = function (idCaption, translations) {
    var _a;
    var caption = (_a = translations === null || translations === void 0 ? void 0 : translations[idCaption.id]) !== null && _a !== void 0 ? _a : idCaption.caption;
    return { id: idCaption.id, caption: caption };
};
exports.translate = translate;
var translateSelectProps = function (props, translations) {
    return props.map(function (p) { return (__assign(__assign({}, p), { column: (0, exports.translate)(p.column, translations), options: p.options.map(function (o) { return (0, exports.translate)(o, translations); }) })); });
};
exports.translateSelectProps = translateSelectProps;
var updateChangeFilterSelect = function (state, column) {
    if (!(column.colKey in state.selects)) {
        return __assign({}, state);
    }
    var select = __assign(__assign({}, state.selects[column.colKey]), { value: column.value });
    var filters = __assign({}, state.filters);
    if (select.filterBy)
        filters[column.colKey] = select.filterBy(column, select.options);
    var all = Object.values(filters).flatMap(function (f) { return f; });
    var query = (0, exports.queryParamFilters)(all);
    var selects = {};
    for (var k in state.selects) {
        selects[k] = k === column.colKey ? select : state.selects[k];
    }
    return __assign(__assign({}, state), { selects: selects, query: query, filters: filters });
};
exports.updateChangeFilterSelect = updateChangeFilterSelect;
var changeMultipleFiltersSelect = function (oldState, columns) {
    var newState = __assign({}, oldState);
    columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
        if (!(column.colKey in newState.selects))
            return;
        var select = __assign(__assign({}, newState.selects[column.colKey]), { value: column.value });
        var filters = __assign({}, newState.filters);
        if (select.filterBy) {
            filters[column.colKey] = select.filterBy(column, select.options);
        }
        var all = Object.values(filters).flatMap(function (f) { return f; });
        var query = (0, exports.queryParamFilters)(all);
        var selects = {};
        for (var key in newState.selects) {
            selects[key] =
                key === column.colKey ? select : newState.selects[key];
        }
        newState = __assign(__assign({}, newState), { selects: selects, query: query, filters: filters });
    });
    return newState;
};
exports.changeMultipleFiltersSelect = changeMultipleFiltersSelect;
var updateColumnFilterSelectOptions = function (state, opts) {
    var select = state.selects[opts.colKey];
    if (!select) {
        return __assign({}, state);
    }
    var options = opts.options.length
        ? opts.options
        : [(0, exports.noFilters)()];
    var selects = __assign({}, state.selects);
    selects[opts.colKey] = __assign(__assign({}, select), { options: options });
    return __assign(__assign({}, state), { selects: selects });
};
exports.updateColumnFilterSelectOptions = updateColumnFilterSelectOptions;
var updateTranslations = function (state, translations) {
    var selects = {};
    (0, exports.translateSelectProps)(Object.values(state.selects), translations).forEach(function (d) { return (selects[d.column.id] = d); });
    return __assign(__assign({}, state), { selects: selects });
};
exports.updateTranslations = updateTranslations;


/***/ }),

/***/ "./reducers/fullInspection.reducer.ts":
/*!********************************************!*\
  !*** ./reducers/fullInspection.reducer.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FullInspReducer = exports.initialState = void 0;
var fullInspection_actions_1 = __webpack_require__(/*! @Actions/fullInspection.actions */ "./actions/fullInspection.actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.initialState = {
    fullInspection: {
        _id: '',
        inspectionId: '-',
        validationState: '-',
        uploadedBy: '-',
        uploadDateTime: '-',
        missingMedia: false,
        isImperial: false,
        tenantId: '',
        inspectionStatus: '',
    },
    isWaiting: true,
    notesIsWaiting: false,
};
var reducer = (_a = {},
    _a[fullInspection_actions_1.getFullInsp.toString()] = function () { return (__assign(__assign({}, exports.initialState), { isWaiting: true })); },
    _a[fullInspection_actions_1.getFullInspResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, fullInspection: action.payload.inspection[0], notes: action.payload.notes, isWaiting: false })); },
    _a[fullInspection_actions_1.getFullInspRejected.toString()] = function () { return (__assign(__assign({}, exports.initialState), { isWaiting: false })); },
    _a[fullInspection_actions_1.getNotes.toString()] = function (state) { return (__assign(__assign({}, state), { notesIsWaiting: true })); },
    _a[fullInspection_actions_1.clearFullInsp.toString()] = function () { return (__assign(__assign({}, exports.initialState), { isWaiting: false })); },
    _a[fullInspection_actions_1.getNotesResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { notes: action.payload, notesIsWaiting: false })); },
    _a[fullInspection_actions_1.getNotesRejected.toString()] = function (state) { return (__assign(__assign({}, state), { notes: [], notesIsWaiting: false })); },
    _a[fullInspection_actions_1.setFullInspectionIsWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isWaiting: action.payload })); },
    _a[fullInspection_actions_1.setNotesIsWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { notesIsWaiting: action.payload })); },
    _a);
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.FullInspReducer = (0, toolkit_1.createReducer)(exports.initialState, reducer);
exports["default"] = (0, toolkit_1.createReducer)(exports.initialState, reducer);


/***/ }),

/***/ "./reducers/index.ts":
/*!***************************!*\
  !*** ./reducers/index.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducerWhiteList = exports.reducerKey = exports.initialState = void 0;
var rehab_reducer_1 = __webpack_require__(/*! ./rehab.reducer */ "./reducers/rehab.reducer.ts");
var assetDetail_reducer_1 = __importStar(__webpack_require__(/*! ./assetDetail.reducer */ "./reducers/assetDetail.reducer.ts"));
var assetManhole_reducer_1 = __importStar(__webpack_require__(/*! ./assetManhole.reducer */ "./reducers/assetManhole.reducer.ts"));
var assetPipe_reducer_1 = __importStar(__webpack_require__(/*! ./assetPipe.reducer */ "./reducers/assetPipe.reducer.ts"));
var assetRisk_reducer_1 = __importStar(__webpack_require__(/*! ./assetRisk.reducer */ "./reducers/assetRisk.reducer.ts"));
var assetRiskHistory_reducer_1 = __importStar(__webpack_require__(/*! ./assetRiskHistory.reducer */ "./reducers/assetRiskHistory.reducer.ts"));
var charts_reducer_1 = __importStar(__webpack_require__(/*! ./charts.reducer */ "./reducers/charts.reducer.ts"));
var configuration_reducer_1 = __importStar(__webpack_require__(/*! ./configuration.reducer */ "./reducers/configuration.reducer.ts"));
var fullInspection_reducer_1 = __webpack_require__(/*! ./fullInspection.reducer */ "./reducers/fullInspection.reducer.ts");
var riskSetting_reducer_1 = __webpack_require__(/*! ./riskSetting.reducer */ "./reducers/riskSetting.reducer.ts");
var inspection_reducer_1 = __importStar(__webpack_require__(/*! ./inspection.reducer */ "./reducers/inspection.reducer.ts"));
var map_reducer_1 = __importStar(__webpack_require__(/*! ./map.reducer */ "./reducers/map.reducer.ts"));
var observations_reducer_1 = __webpack_require__(/*! ./observations.reducer */ "./reducers/observations.reducer.ts");
var riskConfigsList_reducer_1 = __webpack_require__(/*! ./riskConfigsList.reducer */ "./reducers/riskConfigsList.reducer.ts");
var spatial_reducer_1 = __webpack_require__(/*! ./spatial.reducer */ "./reducers/spatial.reducer.ts");
var redux_1 = __webpack_require__(/*! redux */ "redux");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var paginationUtils_1 = __webpack_require__(/*! ./paginationUtils */ "./reducers/paginationUtils.ts");
var riskConfigs_reducer_1 = __webpack_require__(/*! ./riskConfigs.reducer */ "./reducers/riskConfigs.reducer.ts");
exports.initialState = {
    assetRisk: assetRisk_reducer_1.initState,
    assetDetails: assetDetail_reducer_1.initState,
    assetPipe: assetPipe_reducer_1.initState,
    assetManhole: assetManhole_reducer_1.initState,
    inspections: inspection_reducer_1.initState,
    assetRiskHistory: assetRiskHistory_reducer_1.initState,
    map: map_reducer_1.initialState,
    riskSetting: riskSetting_reducer_1.initState,
    riskConfigs: paginationUtils_1.paginationInitialState,
    riskConfigsList: riskConfigsList_reducer_1.initialState,
    fullInspection: fullInspection_reducer_1.initialState,
    observations: observations_reducer_1.initState,
    spatial: spatial_reducer_1.spatialInitialState,
    RehabStore: rehab_reducer_1.initState,
    charts: charts_reducer_1.initialState,
    configuration: configuration_reducer_1.initialState,
};
exports["default"] = (0, redux_1.combineReducers)({
    inspections: inspection_reducer_1.default,
    assetDetails: assetDetail_reducer_1.default,
    assetRisk: assetRisk_reducer_1.default,
    assetPipe: assetPipe_reducer_1.default,
    assetManhole: assetManhole_reducer_1.default,
    observations: observations_reducer_1.observationReducer,
    fullInspection: fullInspection_reducer_1.FullInspReducer,
    assetRiskHistory: assetRiskHistory_reducer_1.default,
    map: map_reducer_1.default,
    riskSetting: riskSetting_reducer_1.riskSettingReducer,
    riskConfigs: riskConfigs_reducer_1.riskConfigsReducer,
    riskConfigsList: riskConfigsList_reducer_1.riskConfigsListReducer,
    spatial: spatial_reducer_1.spatialReducer,
    RehabStore: rehab_reducer_1.rehabReducer,
    charts: charts_reducer_1.default,
    configuration: configuration_reducer_1.default,
});
exports.reducerKey = config_store_1.moduleNamespace;
__exportStar(__webpack_require__(/*! ./paginationUtils */ "./reducers/paginationUtils.ts"), exports);
__exportStar(__webpack_require__(/*! ./filterUtils */ "./reducers/filterUtils.ts"), exports);
exports.reducerWhiteList = ["".concat(config_store_1.moduleNamespace, ".map.main")];


/***/ }),

/***/ "./reducers/inspection.reducer.ts":
/*!****************************************!*\
  !*** ./reducers/inspection.reducer.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
exports.initState = {
    inspectionAttributes: [],
    isWaiting: false,
    updateStatus: 0,
    creatingInspection: false,
};
var reducer = (_a = {},
    _a[inspection_actions_1.getInspectionAttributes.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, inspectionAttributes: [], isWaiting: true })); },
    _a[inspection_actions_1.getInspectionAttributesWaiting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isWaiting: action.payload })); },
    _a[inspection_actions_1.getInspectionAttributesResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, inspectionAttributes: action.payload.data, isWaiting: false })); },
    _a[inspection_actions_1.getInspectionAttributesRejected.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, isWaiting: false })); },
    _a[inspection_actions_1.refreshInspection.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, updateStatus: action.payload.status })); },
    _a[inspection_actions_1.setCreateInspectionId.toString()] = function (state, action) { return (__assign(__assign({}, state), { createInspectionId: action.payload })); },
    _a[inspection_actions_1.setCreatingInspection.toString()] = function (state, action) { return (__assign(__assign({}, state), { creatingInspection: action.payload })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/map.reducer.ts":
/*!*********************************!*\
  !*** ./reducers/map.reducer.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialState = exports.mapInsertInitial = exports.findSpatialLayer = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var map_types_1 = __webpack_require__(/*! @Types/map.types */ "./types/map.types.ts");
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var assetManhole_actions_1 = __webpack_require__(/*! @Actions/assetManhole.actions */ "./actions/assetManhole.actions.ts");
var assetPipe_actions_1 = __webpack_require__(/*! @Actions/assetPipe.actions */ "./actions/assetPipe.actions.ts");
var fullInspection_actions_1 = __webpack_require__(/*! @Actions/fullInspection.actions */ "./actions/fullInspection.actions.ts");
var map_actions_1 = __webpack_require__(/*! @Actions/map.actions */ "./actions/map.actions.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var paginationUtils_1 = __webpack_require__(/*! ./paginationUtils */ "./reducers/paginationUtils.ts");
var map_components_1 = __webpack_require__(/*! @innovyze/map-components */ "@innovyze/map-components");
var correctRehabDetails_1 = __webpack_require__(/*! ./correctRehabDetails */ "./reducers/correctRehabDetails.ts");
// If the inspection geometry is missing the condition geometries might do the job.
var getAllGeometries = function (params) {
    var _a;
    var geoms = [];
    ((_a = params === null || params === void 0 ? void 0 : params.inspection) !== null && _a !== void 0 ? _a : []).forEach(function (insp) {
        var _a;
        if ('geometry' in insp && insp.geometry) {
            geoms.push(insp.geometry);
        }
        if ('conditions' in insp) {
            (_a = insp.conditions) === null || _a === void 0 ? void 0 : _a.forEach(function (c) {
                if ('geometry' in c && c.geometry) {
                    geoms.push(c.geometry);
                }
            });
        }
    });
    return geoms;
};
var mapPosition = function (extent, zoom) {
    var centre = (0, shared_utils_1.centreExtent)(extent);
    return centre
        ? {
            center: centre,
            zoom: zoom,
        }
        : undefined;
};
var mapLocation = function (extent, zoom) {
    var ex = (0, shared_utils_1.fixLonLatExtent)(extent, _Utils_1.minPositionExtent);
    return extent
        ? {
            position: mapPosition(ex, zoom),
            radius: ex
                ? Math.max(_Utils_1.minPositionSearchRadius, (0, shared_utils_1.haversine)(ex[0], ex[1], ex[2], ex[3]))
                : undefined,
            extent: ex,
        }
        : undefined;
};
var inspectionInsert = function (standard, background, params) {
    var geoms = getAllGeometries(params);
    var extent = (0, shared_utils_1.geometriesExtent)(geoms);
    var location = mapLocation(extent, _Utils_1.zoomShowInspections);
    var options = {
        generalOptions: __assign(__assign({}, _Utils_1.generalOptionsDefault), { noMinZoom: true }),
        tilesSource: _Utils_1.tileOptions,
        showRisk: false,
        tilesSourceHide: false,
        inspectionSources: (0, _Utils_1.inspectionSources)(standard),
    };
    return {
        options: options,
        background: background,
        location: location,
        // Following for diagnotics only, will be generated on fly in selectors
        // with valid token
        sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, options, location),
        layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, options),
    };
};
var assetMapId = function (assetType, assetId) {
    return "".concat(assetType, "#").concat(assetId);
};
var assetMapLayer = function (assetId, assetType, systemType, layerId) {
    var layer = systemType ? (0, map_components_1.getMapLayerId)(assetType, systemType) : layerId;
    return {
        layerId: layer !== null && layer !== void 0 ? layer : '',
        id: assetMapId(assetType, assetId),
    };
};
var assetInsert = function (assetId, assetType, background, asset) {
    var extent = (0, shared_utils_1.geometriesExtent)(asset.geometry ? [asset.geometry] : []);
    var zoom = asset.geometry.type === shared_utils_1.PointType
        ? _Utils_1.zoomSelectionPoint
        : _Utils_1.zoomSelectionDefault;
    var location = mapLocation(extent, zoom);
    var options = {
        generalOptions: _Utils_1.generalOptionsDefault,
        tilesSource: _Utils_1.tileOptions,
        showRisk: false,
        tilesSourceHide: false,
    };
    return {
        options: options,
        background: background,
        location: location,
        selected: [assetMapLayer(assetId, assetType, asset.layerSystemType)],
        // Following for diagnotics only, will be generated on fly in selectors
        // with valid token
        sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, options, location),
        layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, options),
    };
};
var assetInsertGeneric = function (assetId, assetType, background, params) {
    var extent = (0, shared_utils_1.geometriesExtent)(params.geometry ? [params.geometry] : []);
    var zoom = params.geometry.type === shared_utils_1.PointType
        ? _Utils_1.zoomSelectionPoint
        : _Utils_1.zoomSelectionDefault;
    var location = mapLocation(extent, zoom);
    var options = {
        generalOptions: _Utils_1.generalOptionsDefault,
        tilesSource: _Utils_1.tileOptions,
        showRisk: false,
        tilesSourceHide: false,
    };
    return {
        options: options,
        background: background,
        location: location,
        selected: [
            assetMapLayer(assetId, assetType, undefined, params.layerId),
        ],
        // Following for diagnotics only, will be generated on fly in selectors
        // with valid token
        sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, options, location),
        layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, options),
    };
};
var positionSpatial = function (extent) {
    if (!extent || extent.length < 4) {
        return undefined;
    }
    var width = (0, shared_utils_1.haversine)(extent[0], extent[1], extent[2], extent[1]);
    // Would like to use known bounds on map but currently the bounds calculated in the
    // amSpatial tiling overrides any map API bounds setting.
    // So have to use Zoom and centre. Centre is trivial from the extent but
    // zoom is truely a can of worms.
    // Rather than be too clever have just chosen 2 explicit zoom values
    //   16 - max value for extent width < 1km
    //        catches small grouping and single points well
    //   12 - for extent width < 15km
    //   undefined - max value - defaults to 'amSpatial' tile endpoint bounds
    if (width > 15000) {
        return undefined;
    }
    var zoom = width < 1000 ? 16 : 12;
    var lon = 0.5 * (extent[0] + extent[2]);
    var lat = 0.5 * (extent[1] + extent[3]);
    return {
        center: [lon, lat],
        zoom: zoom,
    };
};
var spatialLayerInitial = {
    _ID: '',
    TENANT_ID: '',
    LAYER_NAME: '',
    EXTENT: undefined,
    GEOMETRY_TYPE: undefined,
};
var findSpatialLayer = function (layerName, layers) {
    var layer = layers.filter(function (l) { return l.LAYER_NAME.toLowerCase() === layerName.toLowerCase(); });
    return layer.length > 0 ? layer[0] : spatialLayerInitial;
};
exports.findSpatialLayer = findSpatialLayer;
var hiddenLayers = function (visibleLayer, layers) {
    return layers
        .filter(function (l) { return l.LAYER_NAME !== visibleLayer.LAYER_NAME; })
        .map(function (l) { return "other/".concat((0, _Utils_1.layerNameToId)(l.LAYER_NAME)); });
};
var spatialInsert = function (layer, background, layers, tilesSourceHide) {
    var _a;
    var extent = (0, _Utils_1.toExtent)(layer === null || layer === void 0 ? void 0 : layer.EXTENT);
    var position = positionSpatial(extent);
    var location = {
        position: position,
        extent: extent,
    };
    var options = {
        generalOptions: _Utils_1.generalOptionsDefault,
        tilesSource: tilesSourceHide ? undefined : _Utils_1.tileOptions,
        otherSource: _Utils_1.otherOptions,
        showRisk: false,
        tilesSourceHide: tilesSourceHide,
        useSpecifiedSpatialLayer: true,
    };
    return {
        options: options,
        background: background,
        location: location,
        // Following for diagnotics only, will be generated on fly in selectors
        // with valid token
        sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, options, location),
        layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, options, [layer]),
        hiddenLayers: ((_a = options === null || options === void 0 ? void 0 : options.useSpecifiedSpatialLayer) !== null && _a !== void 0 ? _a : false)
            ? undefined
            : hiddenLayers(layer, layers),
    };
};
var extentRadius = function (options, extent) {
    var rad = options.radiusDefault;
    var lon1 = extent[0] + 0.5 * (extent[2] - extent[0]);
    var lat1 = extent[1] + 0.5 * (extent[3] - extent[1]);
    rad = (0, shared_utils_1.haversine)(lat1, lon1, extent[3], extent[2]);
    rad *= options.boundMargin;
    return Math.ceil(rad);
};
exports.mapInsertInitial = {
    options: {
        generalOptions: _Utils_1.generalOptionsDefault,
        showRisk: false,
        tilesSourceHide: false,
    },
    background: inno_map_1.BackgroundTypes.Streets,
};
exports.initialState = {
    main: {
        background: inno_map_1.BackgroundTypes.Streets,
        selected: [],
        hiddenLayers: [],
        url: '',
        byTenant: {},
        insert: {
            options: {
                generalOptions: _Utils_1.generalOptionsDefault,
                showRisk: true,
                tilesSourceHide: false,
                tilesSource: _Utils_1.tileOptions,
                inspectionSources: _Utils_1.defaultInspectionSources,
                otherSource: _Utils_1.otherOptions,
            },
            background: inno_map_1.BackgroundTypes.Streets,
        },
    },
    assetInsert: {
        assetId: '',
        assetType: map_types_1.AssetTypeUnknown,
        insert: __assign({}, exports.mapInsertInitial),
        layerId: '',
    },
    inspectionInsert: {
        inspectionId: '',
        standard: _Types_1.InspectionStandard.PACP,
        insert: __assign({}, exports.mapInsertInitial),
    },
    spatialTilesSourceHide: false,
    spatialInserts: [],
    risk: {
        layers: [],
        status: (0, paginationUtils_1.statusDefault)(),
    },
    rehab: {
        layers: [],
        status: (0, paginationUtils_1.statusDefault)(),
    },
};
var reducer = (_a = {},
    _a[map_actions_1.mapMain.toString()] = function (state, action) { return (__assign(__assign({}, state), { main: __assign({}, action.payload) })); },
    _a[map_actions_1.mapStateUrl.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { main: __assign(__assign(__assign({}, state.main), action.payload), { byTenant: __assign(__assign({}, state.main.byTenant), (_a = {}, _a[action.payload.tenantId] = action.payload, _a)) }) }));
    },
    _a[fullInspection_actions_1.getFullInsp.toString()] = function (state, action) { return (__assign(__assign({}, state), { inspectionInsert: {
            inspectionId: action.payload.inspectionId,
            standard: action.payload.standard,
            insert: __assign({}, exports.mapInsertInitial),
        } })); },
    _a[fullInspection_actions_1.getFullInspResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { inspectionInsert: __assign(__assign({}, state.inspectionInsert), { insert: __assign({}, inspectionInsert(state.inspectionInsert.standard, state.main.background, action.payload)) }) })); },
    // TODO merge into generic getAsset action (used in risk and inspections)
    _a[assetPipe_actions_1.getAssetPipe.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: {
            assetId: action.payload.assetId,
            assetType: action.payload.assetType,
            insert: __assign({}, exports.mapInsertInitial),
        } })); },
    _a[assetPipe_actions_1.getAssetPipeResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: __assign(__assign({}, state.assetInsert), { insert: __assign({}, assetInsert(state.assetInsert.assetId, state.assetInsert.assetType, state.main.background, action.payload.asset)) }) })); },
    _a[assetManhole_actions_1.getAssetManhole.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: {
            assetId: action.payload.assetId,
            assetType: action.payload.assetType,
            insert: __assign({}, exports.mapInsertInitial),
        } })); },
    _a[assetManhole_actions_1.getAssetManholeResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: __assign(__assign({}, state.assetInsert), { insert: __assign({}, assetInsert(state.assetInsert.assetId, state.assetInsert.assetType, state.main.background, action.payload.asset)) }) })); },
    _a[_Actions_1.getAssetDetail.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: {
            systemType: action.payload.systemType,
            assetId: action.payload.assetId,
            assetType: action.payload.assetType,
            insert: __assign({}, exports.mapInsertInitial),
        } })); },
    _a[_Actions_1.getAssetDetailMapInsertResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetInsert: __assign(__assign({}, state.assetInsert), { insert: __assign({}, assetInsertGeneric(state.assetInsert.assetId, state.assetInsert.assetType, state.main.background, action.payload)) }) })); },
    _a[_Actions_1.mapSpatialTilesSourceHide.toString()] = function (state, action) { return (__assign(__assign({}, state), { spatialTilesSourceHide: action.payload, 
        // this will need to be improved if we start calling action
        // getSpatialLayersResolved before mapSpatialTilesSourceHide
        spatialInserts: state.spatialInserts.map(function (s) { return (__assign(__assign({}, s), { insert: __assign(__assign({}, s.insert), { tilesSourceHide: action.payload }) })); }) })); },
    _a[_Actions_1.getSpatialLayersResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { spatialInserts: action.payload.map(function (s) {
            var layer = (0, exports.findSpatialLayer)(s.LAYER_NAME, action.payload);
            return {
                layer: layer,
                insert: __assign({}, spatialInsert(layer, state.main.background, action.payload, state.spatialTilesSourceHide)),
            };
        }) })); },
    _a[_Actions_1.mapMainPosition.toString()] = function (state, action) {
        var location = __assign(__assign({}, state.main.insert.location), { position: action.payload });
        return __assign(__assign({}, state), { main: __assign(__assign({}, state.main), { insert: __assign(__assign({}, state.main.insert), { location: location, 
                    // Following for diagnotics only, will be generated on fly in selectors
                    // with valid token
                    sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, state.main.insert.options, location), layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, state.main.insert.options) }) }) });
    },
    _a[_Actions_1.mapMainExtent.toString()] = function (state, action) {
        var location = __assign(__assign({}, state.main.insert.location), { extent: action.payload, radius: extentRadius(state.main.insert.options.generalOptions, action.payload) });
        return __assign(__assign({}, state), { main: __assign(__assign({}, state.main), { insert: __assign(__assign({}, state.main.insert), { location: location, 
                    // Following for diagnotics only, will be generated on fly in selectors
                    // with valid token
                    sources: (0, _Utils_1.dataServices)(_Utils_1.dummyToken, state.main.insert.options, location), layers: (0, _Utils_1.configLayers)(_Utils_1.dummyToken, state.main.insert.options) }) }) });
    },
    _a[_Actions_1.mapMainSelection.toString()] = function (state, action) { return (__assign(__assign({}, state), { main: __assign(__assign({}, state.main), { insert: __assign(__assign({}, state.main.insert), { selected: action.payload }) }) })); },
    _a[_Actions_1.getMapRiskLayers.toString()] = function (state) { return (__assign(__assign({}, state), { risk: {
            layers: [],
            status: (0, paginationUtils_1.statusLoading)(),
        } })); },
    _a[_Actions_1.getMapRiskLayersResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { risk: {
            layers: __spreadArray([], action.payload, true).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            }),
            status: (0, paginationUtils_1.status200)(),
        } })); },
    _a[_Actions_1.getMapRiskLayersRejected.toString()] = function (state, action) { return (__assign(__assign({}, state), { risk: {
            layers: [],
            status: action.payload,
        } })); },
    _a[map_actions_1.getMapRehabLayers.toString()] = function (state) { return (__assign(__assign({}, state), { rehab: {
            layers: [],
            status: (0, paginationUtils_1.statusLoading)(),
        } })); },
    _a[map_actions_1.getMapRehabLayersResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { rehab: {
            layers: __spreadArray([], action.payload, true).map(function (r) {
                return (0, correctRehabDetails_1.correctRehabDetails)(r);
            }),
            status: (0, paginationUtils_1.status200)(),
        } })); },
    _a[map_actions_1.getMapRehabLayersRejected.toString()] = function (state, action) { return (__assign(__assign({}, state), { rehab: {
            layers: [],
            status: action.payload,
        } })); },
    _a);
exports["default"] = (0, toolkit_1.createReducer)(exports.initialState, reducer);


/***/ }),

/***/ "./reducers/observations.reducer.ts":
/*!******************************************!*\
  !*** ./reducers/observations.reducer.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.observationReducer = exports.initState = void 0;
var observations_actions_1 = __webpack_require__(/*! @Actions/observations.actions */ "./actions/observations.actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
exports.initState = {
    observations: [],
    status: 'loading',
};
var reducer = (_a = {},
    _a[observations_actions_1.getObservations.toString()] = function (state, action) { return (__assign(__assign({}, state), { status: 'loading', jointOnly: action.payload.jointOnly, stepOnly: action.payload.stepOnly, continuousOnly: action.payload.continuousOnly, gradeFilters: action.payload.gradeFilters, typeFilters: action.payload.typeFilters, observations: [] })); },
    _a[observations_actions_1.getObservationsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, observations: (0, _Utils_1.fixupObservationsCounterAndTime)(action.payload.observations) })); },
    _a[observations_actions_1.clearObservations.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, observations: [] })); },
    _a[observations_actions_1.deleteObservationsResolved.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { observations: (_a = state.observations) === null || _a === void 0 ? void 0 : _a.filter(function (observation) {
                return action.payload.findIndex(function (id) { return id == (observation === null || observation === void 0 ? void 0 : observation.conditionId); }) < 0;
            }) }));
    },
    _a[observations_actions_1.setJointOnly.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, jointOnly: action.payload })); },
    _a[observations_actions_1.setContinuousOnly.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, continuousOnly: action.payload })); },
    _a[observations_actions_1.setStepOnly.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, stepOnly: action.payload })); },
    _a[observations_actions_1.setGradeFilters.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, gradeFilters: action.payload })); },
    _a[observations_actions_1.setTypeFilters.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialized: true, typeFilters: action.payload })); },
    _a[observations_actions_1.clearFilters.toString()] = function (state) { return (__assign(__assign({}, state), { initialized: true, jointOnly: false, stepOnly: false, continuousOnly: false, gradeFilters: [], typeFilters: [] })); },
    _a);
exports.observationReducer = (0, toolkit_1.createReducer)(exports.initState, reducer);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/paginationUtils.ts":
/*!*************************************!*\
  !*** ./reducers/paginationUtils.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.updateServerFilter = exports.updateFilter = exports.rowsPerPage = exports.updateIsBusyCards = exports.updateIsBusy = exports.updateIsWaiting = exports.updateIsLoading = exports.updateRejected = exports.updateResolvedRiskConfigCard = exports.updateResolvedCard = exports.updateResolved = exports.updateGet = exports.setSelected = exports.setCurrentDbId = exports.indexToDbId = exports.removeSelected = exports.addSelected = exports.updateSort = exports.updatePage1 = exports.updateSearch = exports.updateSlice = exports.updatePage = exports.clearPagination = exports.makePaginationQuery = exports.paginationInitialState = exports.paginationDefault = exports.status200 = exports.statusLoading = exports.statusDefault = exports.rowsPerPageOptions = void 0;
var rowsPerPageOptions = function () { return [5, 10, 15, 25, 50, 100]; };
exports.rowsPerPageOptions = rowsPerPageOptions;
var statusDefault = function () { return ({ code: 800, text: 'Uncalled' }); };
exports.statusDefault = statusDefault;
var statusLoading = function () { return ({ code: 801, text: 'Loading' }); };
exports.statusLoading = statusLoading;
var status200 = function () { return ({ code: 200, text: '' }); };
exports.status200 = status200;
var queryParamPage = function (page) {
    return page && page > 1 ? "&page=".concat(page) : '';
};
var queryParamSlice = function (slice) {
    return slice && slice !== 10 && slice > 0 ? "&slice=".concat(slice) : '';
};
var queryParamSort = function (sortKey, sortDescending) {
    var q = '';
    if (sortKey === null || sortKey === void 0 ? void 0 : sortKey.length) {
        q += "&sort=".concat(encodeURIComponent(sortKey));
        if (sortDescending) {
            q += "&sortDescending=".concat(encodeURIComponent(sortDescending));
        }
    }
    return q;
};
// params that might change subtotal
var makeQueryReducers = function (pagination) {
    var q = queryParamPage(pagination.page);
    q += queryParamSlice(pagination.slice);
    q += queryParamSort(pagination === null || pagination === void 0 ? void 0 : pagination.sortKey, pagination === null || pagination === void 0 ? void 0 : pagination.sortDescending);
    return q;
};
exports.paginationDefault = {
    total: 0,
    subtotal: 0,
    slice: 10,
    pages: 1,
    page: 1,
};
exports.paginationInitialState = {
    query: '',
    status: (0, exports.statusDefault)(),
    pagination: __assign({}, exports.paginationDefault),
    rows: [],
    cards: [],
    selectedDbIds: [],
    currentDbId: '',
    isLoading: false,
    isWaiting: false,
    filter: undefined,
    serverFilter: undefined,
};
var makePaginationQuery = function (pagination) {
    var q = makeQueryReducers(pagination);
    return q.length ? '?' + q.substring(1) : '';
};
exports.makePaginationQuery = makePaginationQuery;
var clearPagination = function (state, pagination) { return (__assign(__assign({}, exports.paginationInitialState), { pagination: pagination, query: (0, exports.makePaginationQuery)(pagination) })); };
exports.clearPagination = clearPagination;
var updatePage = function (state, page) {
    var pagination = __assign(__assign({}, state.pagination), { page: page });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updatePage = updatePage;
var updateSlice = function (state, slice) {
    // If we change rows per page need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { slice: slice, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSlice = updateSlice;
var updateSearch = function (state, search) {
    // If we change search need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { search: search, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSearch = updateSearch;
var updatePage1 = function (state) {
    var pagination = __assign(__assign({}, state.pagination), { page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updatePage1 = updatePage1;
var updateSort = function (state, sort) {
    // If we change sort need to start again from page 1
    var pagination = __assign(__assign({}, state.pagination), { sortKey: sort.key, sortDescending: sort.descending, page: 1 });
    return __assign(__assign({}, state), { status: (0, exports.statusLoading)(), pagination: pagination, query: (0, exports.makePaginationQuery)(pagination), isWaiting: true });
};
exports.updateSort = updateSort;
var addSelected = function (state, add) {
    var s = new Set(state.selectedDbIds);
    add.forEach(function (a) { return s.add(a); });
    return __assign(__assign({}, state), { selectedDbIds: Array.from(s) });
};
exports.addSelected = addSelected;
var removeSelected = function (state, remove) { return (__assign(__assign({}, state), { selectedDbIds: state.selectedDbIds.filter(function (s) { return !remove.some(function (r) { return r === s; }); }) })); };
exports.removeSelected = removeSelected;
var indexToDbId = function (rows, index) {
    return index in rows && '_id' in rows[index] ? rows[index]['_id'] : '';
};
exports.indexToDbId = indexToDbId;
var setCurrentDbId = function (state, rowIndex) { return (__assign(__assign({}, state), { currentDbId: (0, exports.indexToDbId)(state.rows, rowIndex) })); };
exports.setCurrentDbId = setCurrentDbId;
var setSelected = function (state, selectedDbIds) { return (__assign(__assign({}, state), { selectedDbIds: selectedDbIds })); };
exports.setSelected = setSelected;
var updateGet = function (state, pagination) { return (__assign(__assign({}, state), { pagination: pagination, query: (0, exports.makePaginationQuery)(pagination) })); };
exports.updateGet = updateGet;
/**
 * Default update resolved for row based pagination
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolved = function (state, response) {
    var rows = response.data;
    // reloads should retain current and selection if still valid
    var selectedDbIds = state.selectedDbIds.filter(function (id) {
        return rows.some(function (row) { return '_id' in row && row._id === id; });
    });
    var currentDbId = rows.some(function (row) { return '_id' in row && row._id === state.currentDbId; })
        ? state.currentDbId
        : '';
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), rows: response.data, scanId: response.scanId, query: (0, exports.makePaginationQuery)(response.pagination), selectedDbIds: selectedDbIds, currentDbId: currentDbId, filter: state.filter, serverFilter: state.serverFilter });
};
exports.updateResolved = updateResolved;
/**
 * Update resolved for cards
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolvedCard = function (state, response) {
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), cards: response.data, query: (0, exports.makePaginationQuery)(response.pagination) });
};
exports.updateResolvedCard = updateResolvedCard;
/**
 * Update resolved for risk config cards
 * @param state current redux state
 * @param response response from the server
 * @returns the pagination object to put into redux
 */
var updateResolvedRiskConfigCard = function (state, response) {
    return __assign(__assign({}, exports.paginationInitialState), { status: (0, exports.status200)(), pagination: __assign({}, response.pagination), cards: response.data, query: (0, exports.makePaginationQuery)(response.pagination) });
};
exports.updateResolvedRiskConfigCard = updateResolvedRiskConfigCard;
var updateRejected = function (state, status) {
    return __assign(__assign({}, exports.paginationInitialState), { status: status });
};
exports.updateRejected = updateRejected;
var updateIsLoading = function (state, isLoading) { return (__assign(__assign({}, state), { isLoading: isLoading })); };
exports.updateIsLoading = updateIsLoading;
var updateIsWaiting = function (state, isWaiting) { return (__assign(__assign({}, state), { isWaiting: isWaiting })); };
exports.updateIsWaiting = updateIsWaiting;
var updateIsBusy = function (state, isBusy) {
    // get the loading spinner if firstLoad else get wait cursor
    var firstLoad = state.rows === undefined || state.rows.length === 0;
    return __assign(__assign({}, state), { isLoading: isBusy && firstLoad, isWaiting: isBusy && !firstLoad });
};
exports.updateIsBusy = updateIsBusy;
var updateIsBusyCards = function (state, isBusy) {
    // get the loading spinner if firstLoad else get wait cursor
    var firstLoad = state.cards === undefined || state.cards.length === 0;
    return __assign(__assign({}, state), { isLoading: isBusy && firstLoad, isWaiting: isBusy && !firstLoad });
};
exports.updateIsBusyCards = updateIsBusyCards;
var rowsPerPage = function (slice, dispatchSliceFn) {
    var opts = (0, exports.rowsPerPageOptions)();
    var options = opts.map(function (o, n) {
        return {
            name: o.toString(),
            onClick: function () {
                dispatchSliceFn(o);
            },
            cy: 'rowsPerPage-' + n,
        };
    });
    var s = slice.toString();
    var selectedIndex = options.findIndex(function (o) { return o.name === s; });
    return {
        options: options,
        selectedIndex: selectedIndex,
    };
};
exports.rowsPerPage = rowsPerPage;
var updateFilter = function (state, filter) { return (__assign(__assign({}, state), { filter: filter })); };
exports.updateFilter = updateFilter;
var updateServerFilter = function (state, filter, serverFilter) { return (__assign(__assign({}, state), { filter: filter, serverFilter: serverFilter })); };
exports.updateServerFilter = updateServerFilter;


/***/ }),

/***/ "./reducers/rehab.reducer.ts":
/*!***********************************!*\
  !*** ./reducers/rehab.reducer.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rehabReducer = exports.reducer = exports.initState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var Rehab_action_1 = __webpack_require__(/*! @Actions/Rehab.action */ "./actions/Rehab.action.ts");
var paginationUtils_1 = __webpack_require__(/*! ./paginationUtils */ "./reducers/paginationUtils.ts");
exports.initState = {
    isDetailLoading: false,
    rehabDetails: {},
    rehabTrees: [],
};
exports.reducer = (_a = {},
    _a[Rehab_action_1.getRehabResult.toString()] = function (state, action) {
        var _a;
        var _b, _c;
        return (__assign(__assign({}, state), { rehabDetails: __assign(__assign({}, state.rehabDetails), (_a = {}, _a[action.payload.treeId] = __assign(__assign({}, (0, paginationUtils_1.updateGet)(state.rehabDetails[action.payload.treeId], (_c = (_b = state.rehabDetails[action.payload.treeId]) === null || _b === void 0 ? void 0 : _b.pagination) !== null && _c !== void 0 ? _c : paginationUtils_1.paginationInitialState)), { loading: true }), _a)) }));
    },
    _a[Rehab_action_1.getRehabResultResolved.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { rehabDetails: __assign(__assign({}, state.rehabDetails), (_a = {}, _a[action.payload.treeId] = __assign(__assign({}, (0, paginationUtils_1.updateResolved)(state.rehabDetails[action.payload.treeId], action.payload)), { loading: false }), _a)) }));
    },
    _a[Rehab_action_1.getRehabResultRejected.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { rehabDetails: __assign(__assign({}, state.rehabDetails), (_a = {}, _a[action.payload.treeId] = __assign(__assign({}, (0, paginationUtils_1.updateRejected)(state.rehabDetails[action.payload.treeId], action.payload)), { loading: false }), _a)) }));
    },
    _a[Rehab_action_1.getRehabTrees.toString()] = function (state) { return (__assign(__assign({}, state), { isDetailLoading: true, rehabDetails: {}, rehabTrees: [] })); },
    _a[Rehab_action_1.getRehabTreesResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { rehabTrees: action.payload, rehabDetails: action.payload.reduce(function (obj, tree) {
            var _a;
            return (__assign(__assign({}, obj), (_a = {}, _a[tree._id] = __assign(__assign({}, paginationUtils_1.paginationInitialState), { loading: false }), _a)));
        }, {}), isDetailLoading: false })); },
    _a[Rehab_action_1.getRehabTreesRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isDetailLoading: false })); },
    _a);
exports.rehabReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/riskConfigs.reducer.ts":
/*!*****************************************!*\
  !*** ./reducers/riskConfigs.reducer.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskConfigsReducer = exports.reducer = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Reducers_1 = __webpack_require__(/*! @Reducers */ "./reducers/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
// I HAVE NO IDEA WHY I HAVE TO DUPLICATE THIS HERE... without it I get this error when runnin in a module
// Uncaught Error: The slice reducer for key "riskConfigs" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state.
// It seems the paginationInitialState is getting initilized AFTER the reducers but I cant see why
var paginationInitialState = {
    query: '',
    status: { code: 800, text: 'Uncalled' },
    pagination: {
        total: 0,
        subtotal: 0,
        slice: 10,
        pages: 1,
        page: 1,
    },
    rows: [],
    cards: [],
    selectedDbIds: [],
    currentDbId: '',
    isLoading: false,
    isWaiting: false,
};
exports.reducer = (_a = {},
    _a[_Actions_1.getRiskConfigs.toString()] = function (state, action) {
        return (0, _Reducers_1.updateGet)(state, action.payload);
    },
    _a[_Actions_1.clearRiskConfigs.toString()] = function (state, action) {
        return (0, _Reducers_1.clearPagination)(state, action.payload);
    },
    _a[_Actions_1.getRiskConfigsResolved.toString()] = function (state, action) {
        return (0, _Reducers_1.updateResolvedRiskConfigCard)(state, action.payload);
    },
    _a[_Actions_1.getRiskConfigsRejected.toString()] = function (state, action) {
        return (0, _Reducers_1.updateRejected)(state, action.payload);
    },
    _a[_Actions_1.changeRiskConfigsPage.toString()] = function (state, action) {
        return (0, _Reducers_1.updatePage)(state, action.payload);
    },
    _a[_Actions_1.changeRiskConfigsSlice.toString()] = function (state, action) {
        return (0, _Reducers_1.updateSlice)(state, action.payload);
    },
    _a[_Actions_1.changeRiskConfigsSort.toString()] = function (state, action) {
        return (0, _Reducers_1.updateSort)(state, action.payload);
    },
    _a[_Actions_1.setRiskConfigsIsBusy.toString()] = function (state, action) {
        return (0, _Reducers_1.updateIsBusyCards)(state, action.payload);
    },
    _a);
exports.riskConfigsReducer = (0, toolkit_1.createReducer)(paginationInitialState, exports.reducer);
exports["default"] = (0, toolkit_1.createReducer)(paginationInitialState, exports.reducer);


/***/ }),

/***/ "./reducers/riskConfigsList.reducer.ts":
/*!*********************************************!*\
  !*** ./reducers/riskConfigsList.reducer.ts ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskConfigsListReducer = exports.reducer = exports.initialState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
// I HAVE NO IDEA WHY I HAVE TO DUPLICATE THIS HERE... without it I get this error when runnin in a module
// Uncaught Error: The slice reducer for key "riskConfigs" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state.
// It seems the paginationInitialState is getting initilized AFTER the reducers but I cant see why
exports.initialState = {
    configs: [],
    isLoading: false,
};
exports.reducer = (_a = {},
    _a[_Actions_1.getRiskConfigsList.toString()] = function () { return (__assign(__assign({}, exports.initialState), { isLoading: true })); },
    _a[_Actions_1.getRiskConfigsListResolved.toString()] = function (_state, action) { return ({
        configs: action.payload,
        isLoading: false,
    }); },
    _a[_Actions_1.getRiskConfigsListRejected.toString()] = function () { return (__assign({}, exports.initialState)); },
    _a);
exports.riskConfigsListReducer = (0, toolkit_1.createReducer)(exports.initialState, exports.reducer);
exports["default"] = (0, toolkit_1.createReducer)(exports.initialState, exports.reducer);


/***/ }),

/***/ "./reducers/riskSetting.reducer.ts":
/*!*****************************************!*\
  !*** ./reducers/riskSetting.reducer.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskSettingReducer = exports.initState = exports.initRiskSetting = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
exports.initRiskSetting = {
    RiskMethod: 'multiplied',
    LOFWeighting: 50,
    COFWeighting: 50,
    Grades: {
        Low: -1,
        Medium: -1,
        High: -1,
        Extreme: -1,
        Max: -1,
    },
    LastRun: '',
};
exports.initState = __assign(__assign({}, exports.initRiskSetting), { rejected: false });
var reducer = (_a = {},
    _a[assetRisk_actions_1.getRiskSetting.toString()] = function () { return (__assign({}, exports.initState)); },
    _a[assetRisk_actions_1.getRiskSettingRejected.toString()] = function () { return (__assign(__assign({}, exports.initState), { rejected: true })); },
    _a[assetRisk_actions_1.getRiskSettingResolved.toString()] = function (state, action) { return (__assign(__assign({}, action.payload), { rejected: false })); },
    _a);
exports.riskSettingReducer = (0, toolkit_1.createReducer)(exports.initState, reducer);
exports["default"] = (0, toolkit_1.createReducer)(exports.initState, reducer);


/***/ }),

/***/ "./reducers/spatial.reducer.ts":
/*!*************************************!*\
  !*** ./reducers/spatial.reducer.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.spatialReducer = exports.spatialInitialState = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var paginationUtils_1 = __webpack_require__(/*! ../reducers/paginationUtils */ "./reducers/paginationUtils.ts");
exports.spatialInitialState = {
    spatialLayers: [],
    status: (0, paginationUtils_1.statusDefault)(),
};
var spatialReducerLocal = (_a = {},
    _a[_Actions_1.getSpatialLayersResolved.toString()] = function (state, action) {
        return __assign(__assign({}, state), { spatialLayers: action.payload, status: (0, paginationUtils_1.status200)() });
    },
    _a[_Actions_1.getSpatialLayersRejected.toString()] = function (state, action) {
        return __assign(__assign({}, state), { spatialLayers: [], status: action.payload });
    },
    _a);
exports.spatialReducer = (0, toolkit_1.createReducer)(exports.spatialInitialState, spatialReducerLocal);
exports["default"] = (0, toolkit_1.createReducer)(exports.spatialInitialState, spatialReducerLocal);


/***/ }),

/***/ "./sagas/assetDetail.sagas.ts":
/*!************************************!*\
  !*** ./sagas/assetDetail.sagas.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var assetDetail_actions_1 = __webpack_require__(/*! @Actions/assetDetail.actions */ "./actions/assetDetail.actions.ts");
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var map_components_1 = __webpack_require__(/*! @innovyze/map-components */ "@innovyze/map-components");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var assetManhole_actions_1 = __webpack_require__(/*! @Actions/assetManhole.actions */ "./actions/assetManhole.actions.ts");
var assetPipe_actions_1 = __webpack_require__(/*! @Actions/assetPipe.actions */ "./actions/assetPipe.actions.ts");
var center_1 = __importDefault(__webpack_require__(/*! @turf/center */ "../node_modules/@turf/center/dist/js/index.js"));
function getAssetCountsSaga(action) {
    var payload, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getAssetCountsApi, action.payload)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetCountsResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetCountsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetCounts() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.getAssetCounts, getAssetCountsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAssetDetailSaga(action) {
    var payload_1, formatDateUTC, attributes, result, layerId, systemType, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetDetailIsWaiting)(!action.payload.forNotes))];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetDetailNotesIsWaiting)(action.payload.forNotes))];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getSummaryApi, action.payload)];
            case 3:
                payload_1 = _a.sent();
                formatDateUTC = action.payload.formatDateUTC;
                // Fixup date/time fields
                if (payload_1.data.asset['yearLaid']) {
                    payload_1.data.asset['yearLaid'] = (0, _Utils_1.parseServerObjectToFormattedString)(payload_1.data.asset['yearLaid'], 2 /* ExpectedStringType.Date */, formatDateUTC);
                }
                if (payload_1.data.asset['yearInstalled']) {
                    payload_1.data.asset['yearInstalled'] =
                        (0, _Utils_1.parseServerObjectToFormattedString)(payload_1.data.asset['yearInstalled'], 2 /* ExpectedStringType.Date */, formatDateUTC);
                }
                if (payload_1.data.asset['yearRenewed']) {
                    payload_1.data.asset['yearRenewed'] =
                        (0, _Utils_1.parseServerObjectToFormattedString)(payload_1.data.asset['yearRenewed'], 2 /* ExpectedStringType.Date */, formatDateUTC);
                }
                attributes = Object.keys(payload_1.data.asset)
                    .filter(function (property) {
                    return property !== 'geometry' &&
                        property !== 'segments' &&
                        property !== 'tenantId' &&
                        property !== 'notes';
                })
                    .map(function (property) { return ({
                    FieldName: property,
                    FieldTitle: property,
                    FieldValue: payload_1.data.asset[property] === null
                        ? ''
                        : String(payload_1.data.asset[property]),
                }); });
                if (payload_1.data.asset &&
                    payload_1.data.asset.segments &&
                    payload_1.data.asset.segments.length == 1) {
                    attributes = __spreadArray(__spreadArray([], attributes, true), Object.keys(payload_1.data.asset.segments[0])
                        .filter(function (property) {
                        return property !== 'startDistance' &&
                            property !== 'segmentId' &&
                            property !== 'startLength';
                    })
                        .map(function (property) { return ({
                        FieldName: property,
                        FieldTitle: property,
                        FieldValue: payload_1.data.asset.segments[0][property] === null
                            ? ''
                            : String(payload_1.data.asset.segments[0][property]),
                    }); }), true);
                }
                result = {
                    notes: payload_1.data.asset.notes,
                    assetDetails: attributes,
                };
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetDetailResolved)(result))];
            case 4:
                _a.sent();
                if (!payload_1.data.asset['geometry']) return [3 /*break*/, 6];
                layerId = action.payload.layerId;
                systemType = payload_1.data.asset['layerSystemType'];
                if (layerId === undefined && systemType !== undefined) {
                    layerId = (0, map_components_1.getMapLayerId)(action.payload.assetType, systemType);
                }
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetDetailMapInsertResolved)({
                        geometry: payload_1.data.asset['geometry'],
                        layerId: layerId,
                    }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetDetailRejected)())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchGetAssetDetail() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.getAssetDetail, getAssetDetailSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function addAssetDetailNoteSaga(action) {
    var e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetDetailNotesIsWaiting)(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.addAssetNoteApi, action.payload.assetDetailParams, action.payload.addNoteParams)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetDetail)(action.payload.assetDetailParams))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetDetailNotesIsWaiting)(false))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchAddAssetDetailNote() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.addAssetDetailNote, addAssetDetailNoteSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function checkAssetIdsSaga(action) {
    var payload, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setInspectionsValidatingAsset)(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.checkAssetIdsApi, action.payload)];
            case 2:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.checkAssetIdsResolved)(payload.data))];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setInspectionsValidatingAsset)(false))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.checkAssetIdsRejected)())];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setInspectionsValidatingAsset)(false))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function watchCheckAssetIds() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.checkAssetIds, checkAssetIdsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// TODO make it generic @AssetSchemaMigration
function loadAssetDetailsSaga(action) {
    var _a, id, riskForAsset, inspectionsForAsset;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload.assetType;
                switch (_a) {
                    case 'wwManhole': return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, effects_1.put)((0, assetManhole_actions_1.getAssetManhole)(action.payload))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)((0, assetPipe_actions_1.getAssetPipe)(action.payload))];
            case 4:
                _b.sent();
                return [3 /*break*/, 5];
            case 5: return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.getAssetDetail)(action.payload))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskHistory)(action.payload))];
            case 7:
                _b.sent();
                id = "".concat(action.payload.assetType, "#").concat(action.payload.assetId);
                return [4 /*yield*/, (0, effects_1.select)(function (state) {
                        return (0, map_components_1.selectRiskScoreByAssetId)(state, id);
                    })];
            case 8:
                riskForAsset = _b.sent();
                if (!riskForAsset) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskResolved)(riskForAsset))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRisk)(action.payload))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.select)(function (state) { return (0, map_components_1.selectInspectionsByAssetId)(state, id); })];
            case 13:
                inspectionsForAsset = _b.sent();
                if (!inspectionsForAsset) return [3 /*break*/, 15];
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.getInspectionAttributesResolved)({
                        data: inspectionsForAsset,
                    }))];
            case 14:
                _b.sent();
                return [3 /*break*/, 17];
            case 15: return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.getInspectionAttributes)(action.payload))];
            case 16:
                _b.sent();
                _b.label = 17;
            case 17: 
            // new dynamic properties need slightly different structure
            // of data to old get asset details
            return [4 /*yield*/, (0, effects_1.put)((0, map_components_1.getAsset)(id))];
            case 18:
                // new dynamic properties need slightly different structure
                // of data to old get asset details
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetMapAssetDetails() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.loadAssetDetails, loadAssetDetailsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getAssetLocationSaga(action) {
    var payload, geometry, result, position, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetLocationIsWaiting)(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getSummaryApi, action.payload)];
            case 2:
                payload = _a.sent();
                geometry = payload.data.asset.geometry;
                result = undefined;
                if (geometry) {
                    position = undefined;
                    // Find the center
                    switch (geometry.type) {
                        case 'Point':
                            position = geometry.coordinates;
                            break;
                        case 'LineString':
                            position = (0, center_1.default)(geometry).geometry
                                .coordinates;
                            break;
                        case 'Polygon':
                            position = (0, center_1.default)(geometry).geometry
                                .coordinates;
                            break;
                        case 'MultiPoint':
                            position = (0, center_1.default)(geometry).geometry
                                .coordinates;
                            break;
                        case 'MultiLineString':
                            position = (0, center_1.default)(geometry)
                                .geometry.coordinates;
                            break;
                        case 'MultiPolygon':
                            position = (0, center_1.default)(geometry).geometry
                                .coordinates;
                            break;
                    }
                    if (position) {
                        result = {
                            assetId: payload.data.asset.assetId,
                            position: position,
                        };
                    }
                }
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetLocation)(result))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetLocation)(undefined))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [4 /*yield*/, (0, effects_1.put)((0, assetDetail_actions_1.setAssetLocationIsWaiting)(false))];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetAssetLocation() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetDetail_actions_1.getAssetLocation, getAssetLocationSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetAssetDetail(),
    watchGetAssetCounts(),
    watchAddAssetDetailNote(),
    watchCheckAssetIds(),
    watchGetMapAssetDetails(),
    watchGetAssetLocation(),
];


/***/ }),

/***/ "./sagas/assetManhole.sagas.ts":
/*!*************************************!*\
  !*** ./sagas/assetManhole.sagas.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var assetManhole_actions_1 = __webpack_require__(/*! @Actions/assetManhole.actions */ "./actions/assetManhole.actions.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
// TODO make it generic @AssetSchemaMigration
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAssetManholeSaga(action) {
    var payload, formatDateUTC, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getSummaryApi, action.payload)];
            case 1:
                payload = _b.sent();
                if ((_a = payload.data) === null || _a === void 0 ? void 0 : _a.asset) {
                    formatDateUTC = action.payload.formatDateUTC;
                    if (payload.data.asset['yearLaid']) {
                        payload.data.asset['yearLaid'] =
                            (0, _Utils_1.parseServerObjectToFormattedString)(payload.data.asset['yearLaid'], 2 /* ExpectedStringType.Date */, formatDateUTC);
                    }
                }
                return [4 /*yield*/, (0, effects_1.put)((0, assetManhole_actions_1.getAssetManholeResolved)(payload.data))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetManhole_actions_1.getAssetManholeRejected)())];
            case 4:
                _b.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetManhole() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetManhole_actions_1.getAssetManhole, getAssetManholeSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetAssetManhole()];


/***/ }),

/***/ "./sagas/assetPipe.sagas.ts":
/*!**********************************!*\
  !*** ./sagas/assetPipe.sagas.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var assetPipe_actions_1 = __webpack_require__(/*! @Actions/assetPipe.actions */ "./actions/assetPipe.actions.ts");
var map_actions_1 = __webpack_require__(/*! @Actions/map.actions */ "./actions/map.actions.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
// TODO make it generic @AssetSchemaMigration
function getAssetPipeSaga(action) {
    var payload, result, segment, formatDateUTC, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getSummaryApi, action.payload)];
            case 1:
                payload = _a.sent();
                result = payload.data;
                if (payload.data.asset &&
                    payload.data.asset.segments &&
                    payload.data.asset.segments.length == 1) {
                    segment = payload.data.asset.segments[0];
                    result.asset.material = segment.material;
                    result.asset.diameter = segment.width;
                }
                if (payload.data.asset) {
                    formatDateUTC = action.payload.formatDateUTC;
                    if (payload.data.asset['yearLaid']) {
                        payload.data.asset['yearLaid'] =
                            (0, _Utils_1.parseServerObjectToFormattedString)(payload.data.asset['yearLaid'], 2 /* ExpectedStringType.Date */, formatDateUTC);
                    }
                }
                return [4 /*yield*/, (0, effects_1.put)((0, assetPipe_actions_1.getAssetPipeResolved)(result))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetPipe_actions_1.getAssetPipeRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetPipe() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetPipe_actions_1.getAssetPipe, getAssetPipeSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getAssetPipeResolvedSaga(action) {
    var asset, extent, center, position;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                asset = action.payload.asset;
                if (!asset) return [3 /*break*/, 4];
                extent = asset.geometry
                    ? (0, shared_utils_1.geometriesExtent)([asset.geometry])
                    : undefined;
                center = (0, shared_utils_1.centreExtent)(extent);
                if (!center) return [3 /*break*/, 2];
                position = {
                    center: center,
                    zoom: 15,
                };
                return [4 /*yield*/, (0, effects_1.put)((0, map_actions_1.mapMainPosition)(position))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, (0, effects_1.put)((0, map_actions_1.mapMainSelection)([
                    { id: asset.assetId, layerId: 'risk_levels_medium' },
                ]))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function watchGetAssetPipeResolved() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetPipe_actions_1.getAssetPipeResolved, getAssetPipeResolvedSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetAssetPipe(), watchGetAssetPipeResolved()];


/***/ }),

/***/ "./sagas/assetRisk.sagas.ts":
/*!**********************************!*\
  !*** ./sagas/assetRisk.sagas.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAssetRiskSaga(action) {
    var payload, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskApi, action.payload)];
            case 1:
                payload = _a.sent();
                if (!(payload.data && payload.data.length > 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskResolved)(payload.data[0]))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskRejected)())];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getRiskSettingSaga() {
    var payload, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskSettingApi)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getRiskSettingResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getRiskSettingRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetRisk() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetRisk_actions_1.getAssetRisk, getAssetRiskSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetRiskSetting() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetRisk_actions_1.getRiskSetting, getRiskSettingSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getRiskSummarySaga(action) {
    var payload, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskSummaryApi, action.payload)];
            case 1:
                payload = _a.sent();
                if (payload.data.statusCode != 200) {
                    throw new Error('Failed to get data from endpoint');
                }
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getRiskSummaryResolved)(payload.data.payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getRiskSummaryRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchgetRiskSummary() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetRisk_actions_1.getRiskSummary, getRiskSummarySaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetAssetRisk(),
    watchGetRiskSetting(),
    watchgetRiskSummary(),
];


/***/ }),

/***/ "./sagas/assetRiskHistory.sagas.ts":
/*!*****************************************!*\
  !*** ./sagas/assetRiskHistory.sagas.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var assetRisk_actions_1 = __webpack_require__(/*! @Actions/assetRisk.actions */ "./actions/assetRisk.actions.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAssetRiskHistorySaga(action) {
    var initAssetRiskHistory, payload, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                initAssetRiskHistory = [];
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskHistoryApi, action.payload)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskHistoryResolved)(payload.data ? payload.data : initAssetRiskHistory))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, assetRisk_actions_1.getAssetRiskHistoryRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetRiskHistory() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(assetRisk_actions_1.getAssetRiskHistory, getAssetRiskHistorySaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetAssetRiskHistory()];


/***/ }),

/***/ "./sagas/charts.sagas.ts":
/*!*******************************!*\
  !*** ./sagas/charts.sagas.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var charts_services_1 = __webpack_require__(/*! @Services/charts.services */ "./services/charts.services.ts");
function getChartsSaga(action) {
    var _a, payload, payload, payload, payload, payload, e_1, err, rejection;
    var _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 17, , 19]);
                _a = action.payload.chartType;
                switch (_a) {
                    case _Types_1.ChartType.InspectionOverview: return [3 /*break*/, 1];
                    case _Types_1.ChartType.InspectionAssetDrilldown: return [3 /*break*/, 4];
                    case _Types_1.ChartType.InspectionMonthDrilldown: return [3 /*break*/, 7];
                    case _Types_1.ChartType.RiskOverview: return [3 /*break*/, 10];
                    case _Types_1.ChartType.RiskDrilldown: return [3 /*break*/, 13];
                }
                return [3 /*break*/, 16];
            case 1: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, charts_services_1.getInspectionOverviewChartsApi, action.payload.standard)];
            case 2:
                payload = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsResolved)({
                        chartId: action.payload.chartId,
                        result: payload.data,
                    }))];
            case 3:
                _g.sent();
                return [3 /*break*/, 16];
            case 4: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, charts_services_1.getInspectionAssetChartsQueryApi, action.payload.standard, action.payload.query, action.payload.assetFields)];
            case 5:
                payload = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsResolved)({
                        chartId: action.payload.chartId,
                        result: payload.data,
                    }))];
            case 6:
                _g.sent();
                return [3 /*break*/, 16];
            case 7: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, charts_services_1.getInspectionMonthChartsQueryApi, action.payload.standard, action.payload.query, action.payload.month)];
            case 8:
                payload = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsResolved)({
                        chartId: action.payload.chartId,
                        result: payload.data,
                    }))];
            case 9:
                _g.sent();
                return [3 /*break*/, 16];
            case 10: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, charts_services_1.getRiskChartsApi, action.payload.configId)];
            case 11:
                payload = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsResolved)({
                        chartId: action.payload.chartId,
                        result: payload.data,
                    }))];
            case 12:
                _g.sent();
                return [3 /*break*/, 16];
            case 13: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, charts_services_1.getRiskChartsQueryApi, action.payload.configId, action.payload.query, action.payload.assetFields)];
            case 14:
                payload = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsResolved)({
                        chartId: action.payload.chartId,
                        result: payload.data,
                    }))];
            case 15:
                _g.sent();
                return [3 /*break*/, 16];
            case 16: return [3 /*break*/, 19];
            case 17:
                e_1 = _g.sent();
                err = e_1;
                rejection = {
                    code: (_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : -1,
                    text: (_f = (_e = (_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.statusText) !== null && _e !== void 0 ? _e : (0, i18next_1.t)('No additional information')) !== null && _f !== void 0 ? _f : '',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getChartsRejected)({
                        chartId: action.payload.chartId,
                        result: rejection,
                    }))];
            case 18:
                _g.sent();
                return [3 /*break*/, 19];
            case 19: return [2 /*return*/];
        }
    });
}
function watchGetCharts() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCharts, getChartsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetCharts()];


/***/ }),

/***/ "./sagas/configuration.sagas.ts":
/*!**************************************!*\
  !*** ./sagas/configuration.sagas.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getConfigurationWithMappingSaga(action) {
    var payload, e_1, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, _Services_1.getConfigurationWithMappingApi, action.payload.mappingKey, action.payload.type)];
            case 1:
                payload = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getConfigurationResolved)({
                        configuration: payload.data,
                        key: action.payload.mappingKey,
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _c.sent();
                response = e_1.response;
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getConfigurationRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetConfigurationMapping() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getConfigurationWithMapping, getConfigurationWithMappingSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getConfigurationWithUploadIdSaga(action) {
    var payload, e_2, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, _Services_1.getConfigurationWithUploadIdApi, action.payload.uploadId, action.payload.type)];
            case 1:
                payload = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getConfigurationResolved)({
                        configuration: payload.data,
                        key: action.payload.uploadId,
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _c.sent();
                response = e_2.response;
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getConfigurationRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetConfigurationUpload() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getConfigurationWithUploadId, getConfigurationWithUploadIdSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetConfigurationMapping(), watchGetConfigurationUpload()];


/***/ }),

/***/ "./sagas/fullInsp.sagas.ts":
/*!*********************************!*\
  !*** ./sagas/fullInsp.sagas.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var fullInspection_actions_1 = __webpack_require__(/*! @Actions/fullInspection.actions */ "./actions/fullInspection.actions.ts");
var date_utils_1 = __webpack_require__(/*! @Utils/date.utils */ "./utils/date.utils.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var ValueMapping_1 = __webpack_require__(/*! @Components/AssetDetails/DetailsOverview/ValueMapping */ "./components/AssetDetails/DetailsOverview/ValueMapping.ts");
var defaultValue = function (orig, out) {
    if (out === void 0) { out = '-'; }
    if (orig == null || orig == undefined || orig.toString().trim().length == 0)
        return out;
    else {
        var returnStr = orig.toString();
        if (returnStr.toLowerCase() == 'true') {
            return 'Yes';
        }
        else if (returnStr.toLowerCase() == 'false') {
            return 'No';
        }
        return returnStr;
    }
};
function parsePACPInspection(insp, formatDateUTC) {
    var _a, _b, _c, _d;
    var scheduledDate = '';
    var inspectionDate = '';
    var inspectionTime = '';
    var dateCleaned = '';
    if (insp.scheduledDate) {
        scheduledDate = (_a = (0, ValueMapping_1.extractValue)(insp.scheduledDate)) !== null && _a !== void 0 ? _a : '';
    }
    if (insp.surveyDateTime && insp.surveyDateTime != '') {
        inspectionDate =
            (_b = (0, date_utils_1.formatDateWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _b !== void 0 ? _b : '';
        inspectionTime =
            (_c = (0, date_utils_1.formatTimeWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _c !== void 0 ? _c : '';
    }
    if (insp.dateCleaned) {
        dateCleaned = (_d = (0, ValueMapping_1.extractValue)(insp.dateCleaned)) !== null && _d !== void 0 ? _d : '';
    }
    var fullInsp = __assign(__assign({}, insp), { 
        // Inspection generic
        _id: insp._id, inspectionId: insp.inspectionId, validationState: defaultValue(insp.validationState), uploadedBy: defaultValue(insp.uploadedBy), uploadDateTime: defaultValue(insp.uploadDateTime), scheduledDate: defaultValue(scheduledDate), missingMedia: insp.missingMedia, validationData: insp.validationData, mediaInspections: insp.mediaInspections, conditions: insp.conditions
            ? (0, _Utils_1.fixupObservationsCounterAndTime)(insp.conditions)
            : insp.conditions, isImperial: insp.isImperial, tenantId: defaultValue(insp.tenantId), inspectionStatus: defaultValue(insp.inspectionStatus), 
        // PACP Specific
        surveyedBy: defaultValue(insp.surveyedBy), certificateNumber: defaultValue(insp.certificateNumber), owner: defaultValue(insp.owner), customer: defaultValue(insp.customer), drainageArea: defaultValue(insp.drainageArea), poNumber: defaultValue(insp.poNumber), pipelineRef: defaultValue(insp.pipelineRef), inspectionDate: defaultValue(inspectionDate), inspectionTime: defaultValue(inspectionTime), street: defaultValue(insp.street), city: defaultValue(insp.city), locationDetails: defaultValue(insp.locationDetails), upstreamManholeId: defaultValue(insp.upstreamManholeId), upRimToInvert: defaultValue(insp.upRimToInvert), upGradeToInvert: defaultValue(insp.upGradeToInvert), upRimToGrade: defaultValue(insp.upRimToGrade), downstreamManholeId: defaultValue(insp.downstreamManholeId), downRimToInvert: defaultValue(insp.downRimToInvert), downGradeToInvert: defaultValue(insp.downGradeToInvert), downRimToGrade: defaultValue(insp.downRimToGrade), sewerUse: defaultValue(insp.sewerUse), direction: defaultValue(insp.direction), 
        // inspectionTechnologyUsedCCTV: defaultValue(
        // 	insp.inspectionTechnologyUsedCCTV,
        // ),
        // inspectionTechnologyUsedLaser: defaultValue(
        // 	insp.inspectionTechnologyUsedLaser,
        // ),
        // inspectionTechnologyUsedSonar: defaultValue(
        // 	insp.inspectionTechnologyUsedSonar,
        // ),
        // inspectionTechnologyUsedSidewall: defaultValue(
        // 	insp.inspectionTechnologyUsedSidewall,
        // ),
        // inspectionTechnologyUsedZoom: defaultValue(
        // 	insp.inspectionTechnologyUsedZoom,
        // ),
        // inspectionTechnologyUsedOther: defaultValue(
        // 	insp.inspectionTechnologyUsedOther,
        // ),
        flowControl: defaultValue(insp.flowControl), height: defaultValue(insp.height), width: defaultValue(insp.width), shape: defaultValue(insp.shape), material: defaultValue(insp.material), liningMethod: defaultValue(insp.liningMethod), coatingMethod: defaultValue(insp.coatingMethod), pipeJointLength: defaultValue(insp.pipeJointLength), totalLength: defaultValue(insp.totalLength), lengthSurveyed: defaultValue(insp.lengthSurveyed), yearConstructed: defaultValue(insp.yearConstructed), yearRenewed: defaultValue(insp.yearRenewed), mediaLabel: defaultValue(insp.mediaLabel), purpose: defaultValue(insp.purpose), sewerCategory: defaultValue(insp.sewerCategory), preCleaning: defaultValue(insp.preCleaning), dateCleaned: defaultValue(dateCleaned), weather: defaultValue(insp.weather), locationCode: defaultValue(insp.locationCode), additionalInfo: defaultValue(insp.additionalInfo), reverseSetup: defaultValue(insp.reverseSetup), sheetNumber: defaultValue(insp.sheetNumber), pressureValue: defaultValue(insp.pressureValue), workOrder: defaultValue(insp.workOrder), project: defaultValue(insp.project), upNorthing: defaultValue(insp.upNorthing), upEasting: defaultValue(insp.upEasting), upElevation: defaultValue(insp.upElevation), downNorthing: defaultValue(insp.downNorthing), downEasting: defaultValue(insp.downEasting), downElevation: defaultValue(insp.downElevation), mhCoordinateSystem: defaultValue(insp.mhCoordinateSystem), verticalDatum: defaultValue(insp.verticalDatum), gpsAccuracy: defaultValue(insp.gpsAccuracy), status: defaultValue(insp.status), exported: defaultValue(insp.exported), projectId: defaultValue(insp.projectId), surveyDateTime: insp.surveyDateTime, reviewedBy: defaultValue(insp.reviewedBy), reviewerCertificateNumber: defaultValue(insp.reviewerCertificateNumber), consequenceOfFailure: defaultValue(insp.consequenceOfFailure), coordinateSystem: defaultValue(insp.coordinateSystem), date: defaultValue(insp.date), easting: defaultValue(insp.easting), elevation: defaultValue(insp.elevation), northing: defaultValue(insp.northing), time: defaultValue(insp.time), yearLaid: defaultValue(insp.yearLaid) });
    return fullInsp;
}
function parseMACPInspection(insp, formatDateUTC) {
    var _a, _b, _c, _d, _e;
    var scheduledDate = '';
    var date = '';
    var time = '';
    var dateCleaned = '';
    if (insp.scheduledDate) {
        scheduledDate = (_a = (0, ValueMapping_1.extractValue)(insp.scheduledDate)) !== null && _a !== void 0 ? _a : '';
    }
    if (insp.surveyDateTime && insp.surveyDateTime != '') {
        date =
            (_b = (0, date_utils_1.formatDateWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _b !== void 0 ? _b : '';
        time =
            (_c = (0, date_utils_1.formatTimeWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _c !== void 0 ? _c : '';
    }
    if (insp.dateCleaned) {
        dateCleaned =
            (_e = (0, date_utils_1.formatDateWithFormatDate)((_d = (0, ValueMapping_1.extractValue)(insp.dateCleaned)) !== null && _d !== void 0 ? _d : '', formatDateUTC)) !== null && _e !== void 0 ? _e : '';
    }
    var fullInsp = __assign(__assign({}, insp), { 
        // Inspection generic
        _id: insp._id, inspectionId: insp.inspectionId, validationState: defaultValue(insp.validationState), uploadedBy: defaultValue(insp.uploadedBy), uploadDateTime: defaultValue(insp.uploadDateTime), scheduledDate: defaultValue(scheduledDate), missingMedia: insp.missingMedia, validationData: insp.validationData, mediaInspections: insp.mediaInspections, conditions: insp.conditions
            ? (0, _Utils_1.fixupObservationsCounterAndTime)(insp.conditions)
            : insp.conditions, isImperial: insp.isImperial, tenantId: defaultValue(insp.tenantId), inspectionStatus: defaultValue(insp.inspectionStatus), 
        // MACP Specific
        surveyedBy: defaultValue(insp.surveyedBy), certificateNumber: defaultValue(insp.certificateNumber), owner: defaultValue(insp.owner), customer: defaultValue(insp.customer), drainageArea: defaultValue(insp.drainageArea), sheetNumber: defaultValue(insp.sheetNumber), poNumber: defaultValue(insp.poNumber), date: date, time: time, street: defaultValue(insp.street), city: defaultValue(insp.city), locationDetails: defaultValue(insp.locationDetails), manholeNumber: defaultValue(insp.manholeNumber), rimToInvert: defaultValue(insp.rimToInvert), gradeToInvert: defaultValue(insp.gradeToInvert), rimToGrade: defaultValue(insp.rimToGrade), mhUse: defaultValue(insp.mhUse), yearBuilt: defaultValue(insp.yearBuilt), yearRenewed: defaultValue(insp.yearRenewed), mediaLabel: defaultValue(insp.mediaLabel), purpose: defaultValue(insp.purpose), category: defaultValue(insp.category), preCleaning: defaultValue(insp.preCleaning), dateCleaned: dateCleaned, weather: defaultValue(insp.weather), locationCode: defaultValue(insp.locationCode), additionalInfo: defaultValue(insp.additionalInfo), surfaceTypeAsphalt: defaultValue(insp.surfaceTypeAsphalt), surfaceTypeConcretePavement: defaultValue(insp.surfaceTypeConcretePavement), surfaceTypeConcreteCollar: defaultValue(insp.surfaceTypeConcreteCollar), surfaceTypeGrassDirt: defaultValue(insp.surfaceTypeGrassDirt), surfaceTypeGravel: defaultValue(insp.surfaceTypeGravel), surfaceTypeOther: defaultValue(insp.surfaceTypeOther), potentialForRunoff: defaultValue(insp.potentialForRunoff), accessType: defaultValue(insp.accessType), northing: defaultValue(insp.northing), easting: defaultValue(insp.easting), elevation: defaultValue(insp.elevation), coordinateSystem: defaultValue(insp.coordinateSystem), gpsAccuracy: defaultValue(insp.gpsAccuracy), evidenceSurcharge: defaultValue(insp.evidenceSurcharge), coverShape: defaultValue(insp.coverShape), coverSize: defaultValue(insp.coverSize), coverSizeWidth: defaultValue(insp.coverSizeWidth), coverMaterial: defaultValue(insp.coverMaterial), coverTypeSolid: defaultValue(insp.coverTypeSolid), coverTypeVented: defaultValue(insp.coverTypeVented), coverTypeGasketed: defaultValue(insp.coverTypeGasketed), coverTypeBolted: defaultValue(insp.coverTypeBolted), coverTypeInnerCover: defaultValue(insp.coverTypeInnerCover), coverTypeLocking: defaultValue(insp.coverTypeLocking), coverTypeHatchSingle: defaultValue(insp.coverTypeHatchSingle), coverTypeHatchDouble: defaultValue(insp.coverTypeHatchDouble), coverTypeLamphole: defaultValue(insp.coverTypeLamphole), holeDiameter: defaultValue(insp.holeDiameter), holeNumber: defaultValue(insp.holeNumber), coverBearingSurfaceDia: defaultValue(insp.coverBearingSurfaceDia), coverBearingSurfaceDiaWidth: defaultValue(insp.coverBearingSurfaceDiaWidth), coverFrameFit: defaultValue(insp.coverFrameFit), coverConditionSound: defaultValue(insp.coverConditionSound), coverConditionCracked: defaultValue(insp.coverConditionCracked), coverConditionBroken: defaultValue(insp.coverConditionBroken), coverConditionCorroded: defaultValue(insp.coverConditionCorroded), coverConditionBoltsMissing: defaultValue(insp.coverConditionBoltsMissing), coverConditionMissing: defaultValue(insp.coverConditionMissing), coverConditionRestraintMissing: defaultValue(insp.coverConditionRestraintMissing), coverConditionRestraintDefective: defaultValue(insp.coverConditionRestraintDefective), coverInsertType: defaultValue(insp.coverInsertType), insertConditionSound: defaultValue(insp.insertConditionSound), insertConditionPoorlyFitting: defaultValue(insp.insertConditionPoorlyFitting), insertConditionCracked: defaultValue(insp.insertConditionCracked), insertConditionLeaking: defaultValue(insp.insertConditionLeaking), insertConditionInsertFell: defaultValue(insp.insertConditionInsertFell), insertConditionCorroded: defaultValue(insp.insertConditionCorroded), adjustmentRingType: defaultValue(insp.adjustmentRingType), adjustmentRingMaterial: defaultValue(insp.adjustmentRingMaterial), ringConditionSound: defaultValue(insp.ringConditionSound), ringConditionCracked: defaultValue(insp.ringConditionCracked), ringConditionBroken: defaultValue(insp.ringConditionBroken), ringConditionCorroded: defaultValue(insp.ringConditionCorroded), ringConditionLeaking: defaultValue(insp.ringConditionLeaking), ringConditionPoorInstall: defaultValue(insp.ringConditionPoorInstall), adjustmentRingHeight: defaultValue(insp.adjustmentRingHeight), frameMaterial: defaultValue(insp.frameMaterial), frameBearingSurfaceWidth: defaultValue(insp.frameBearingSurfaceWidth), frameBearingSurfaceDepth: defaultValue(insp.frameBearingSurfaceDepth), frameClearOpenDiam: defaultValue(insp.frameClearOpenDiam), frameConditionSound: defaultValue(insp.frameConditionSound), frameConditionCracked: defaultValue(insp.frameConditionCracked), frameConditionBroken: defaultValue(insp.frameConditionBroken), frameConditionMissing: defaultValue(insp.frameConditionMissing), frameConditionCorroded: defaultValue(insp.frameConditionCorroded), frameConditionCoated: defaultValue(insp.frameConditionCoated), sealConditionSound: defaultValue(insp.frameConditionSound), sealConditionCracked: defaultValue(insp.frameConditionCracked), sealConditionLoose: defaultValue(insp.sealConditionLoose), sealConditionOffset: defaultValue(insp.sealConditionOffset), sealConditionMissing: defaultValue(insp.sealConditionMissing), frameOffsetDistance: defaultValue(insp.frameOffsetDistance), frameSealInflow: defaultValue(insp.frameSealInflow), frameDepth: defaultValue(insp.frameDepth), chimneyMaterial1: defaultValue(insp.chimneyMaterial1), chimneyMaterial2: defaultValue(insp.chimneyMaterial2), chimneyInI: defaultValue(insp.chimneyInI), chimneyClearOpening: defaultValue(insp.chimneyClearOpening), chimneyDepth: defaultValue(insp.chimneyDepth), chimneyLiningInterior: defaultValue(insp.chimneyLiningInterior), chimneyLiningExterior: defaultValue(insp.chimneyLiningExterior), coneType: defaultValue(insp.coneType), coneMaterial: defaultValue(insp.coneMaterial), coneDepth: defaultValue(insp.coneDepth), coneLiningInterior: defaultValue(insp.coneLiningInterior), coneLiningExterior: defaultValue(insp.coneLiningExterior), wallDiam: defaultValue(insp.wallDiam), wallBySize: defaultValue(insp.wallBySize), wallMaterial: defaultValue(insp.wallMaterial), wallDepth: defaultValue(insp.wallDepth), wallLiningInterior: defaultValue(insp.wallLiningInterior), wallLiningExterior: defaultValue(insp.wallLiningExterior), benchPresent: defaultValue(insp.benchPresent), benchMaterial: defaultValue(insp.benchMaterial), benchLining: defaultValue(insp.benchLining), channelInstalled: defaultValue(insp.channelInstalled), channelMaterial: defaultValue(insp.channelMaterial), channelType: defaultValue(insp.channelType), channelExposure: defaultValue(insp.channelExposure), stepNumber: defaultValue(insp.stepNumber), stepMaterial: defaultValue(insp.stepMaterial), workOrder: defaultValue(insp.workOrder), project: defaultValue(insp.project), pressureValue: defaultValue(insp.pressureValue), additionalComponentInfo: defaultValue(insp.additionalComponentInfo), inspectionLevel: defaultValue(insp.inspectionLevel), exported: defaultValue(insp.exported), status: defaultValue(insp.status), wallDiameter: defaultValue(insp.wallDiameter), frameClearOpenDiameter: defaultValue(insp.frameClearOpenDiameter), frameClearOpenWidth: defaultValue(insp.frameClearOpenWidth), rimToGradeExposed: defaultValue(insp.rimToGradeExposed), centerCoverSize: defaultValue(insp.centerCoverSize), consequenceOfFailure: defaultValue(insp.consequenceOfFailure), inflowPotentialFromRunoff: defaultValue(insp.inflowPotentialFromRunoff), yearConstructed: defaultValue(insp.yearConstructed), chimneyIni: defaultValue(insp.chimneyIni), verticalDatum: defaultValue(insp.verticalDatum), benchCondition: defaultValue(insp.benchCondition), coverTypeRemovableCenter: defaultValue(insp.coverTypeRemovableCenter), reviewedBy: defaultValue(insp.reviewedBy), reviewerCertificateNumber: defaultValue(insp.reviewerCertificateNumber) });
    return fullInsp;
}
function parseMSCCInspection(insp, formatDateUTC) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var scheduledDate = '';
    var date = '';
    var time = '';
    if (insp.scheduledDate) {
        scheduledDate = (_a = (0, ValueMapping_1.extractValue)(insp.scheduledDate)) !== null && _a !== void 0 ? _a : '';
    }
    if (insp.surveyDateTime && insp.surveyDateTime != '') {
        date =
            (_b = (0, date_utils_1.formatDateWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _b !== void 0 ? _b : '';
        time =
            (_c = (0, date_utils_1.formatTimeWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _c !== void 0 ? _c : '';
    }
    var fullInsp = __assign(__assign({}, insp), { 
        // Inspection generic
        _id: insp._id, inspectionId: insp.inspectionId, validationState: defaultValue(insp.validationState), uploadedBy: defaultValue(insp.uploadedBy), uploadDateTime: defaultValue(insp.uploadDateTime), scheduledDate: defaultValue(scheduledDate), missingMedia: insp.missingMedia, validationData: insp.validationData, mediaInspections: insp.mediaInspections, conditions: insp.conditions
            ? (0, _Utils_1.fixupObservationsCounterAndTime)(insp.conditions)
            : insp.conditions, isImperial: insp.isImperial, tenantId: defaultValue(insp.tenantId), inspectionStatus: defaultValue(insp.inspectionStatus), 
        // MSCC Specific
        client: defaultValue(insp.client), surveyedBy: defaultValue(insp.surveyedBy), clientsJobRef: defaultValue(insp.clientsJobRef), contractorsJobRef: defaultValue(insp.contractorsJobRef), date: defaultValue(date), time: defaultValue(time), useOfDrainSewer: defaultValue(insp.useOfDrainSewer), typeOfDrainSewer: defaultValue(insp.typeOfDrainSewer), direction: defaultValue(insp.direction), precleaned: defaultValue(insp.precleaned), criticalDrainSewer: defaultValue(insp.criticalDrainSewer), purposeOfInspection: defaultValue(insp.purposeOfInspection), inspectionStage: defaultValue(insp.inspectionStage), flowControlMeasures: defaultValue(insp.flowControlMeasures), weather: defaultValue(insp.weather), temperature: defaultValue(insp.temperature), expectedLength: defaultValue(insp.expectedLength), methodOfInspection: defaultValue(insp.methodOfInspection), standard: defaultValue(insp.standard), clientDefined1: defaultValue(insp.clientDefined1), clientDefined2: defaultValue(insp.clientDefined2), clientDefined3: defaultValue(insp.clientDefined3), clientDefined4: defaultValue(insp.clientDefined4), clientDefined5: defaultValue(insp.clientDefined5), clientDefined6: defaultValue(insp.clientDefined6), generalRemarks: defaultValue(insp.generalRemarks), drainageArea: defaultValue(insp.drainageArea), divisionDistrict: defaultValue(insp.divisionDistrict), locationStreet: defaultValue(insp.locationStreet), locationTown: defaultValue(insp.locationTown), locationTypeCode: defaultValue(insp.locationTypeCode), landOwner: defaultValue(insp.landOwner), upstreamManholeId: defaultValue(insp.upstreamManholeId), downstreamManholeId: defaultValue(insp.downstreamManholeId), pipelineLengthRef: defaultValue(insp.pipelineLengthRef), heightDiameter: defaultValue(insp.heightDiameter), width: defaultValue(insp.width), pipeUnitLength: defaultValue(insp.pipeUnitLength), shape: defaultValue(insp.shape), material: defaultValue(insp.material), liningMaterial: defaultValue(insp.liningMaterial), liningType: defaultValue(insp.liningType), yearConstructed: defaultValue(insp.yearConstructed), longLocStartLat: defaultValue(insp.longLocStartLat), circLocStartLat: defaultValue(insp.circLocStartLat), startNodeRef: defaultValue(insp.startNodeRef), depthAtStartNode: defaultValue(insp.depthAtStartNode), startNodeGridRefX: defaultValue((_d = insp.startNodeGridRef) === null || _d === void 0 ? void 0 : _d.startNodeGridRefX), startNodeGridRefY: defaultValue((_e = insp.startNodeGridRef) === null || _e === void 0 ? void 0 : _e.startNodeGridRefY), node1Ref: defaultValue(insp.node1Ref), node1GridRefX: defaultValue((_f = insp.node1GridRef) === null || _f === void 0 ? void 0 : _f.node1GridRefX), node1GridRefY: defaultValue((_g = insp.node1GridRef) === null || _g === void 0 ? void 0 : _g.node1GridRefY), finishNodeRef: defaultValue(insp.finishNodeRef), depthAtFinishNode: defaultValue(insp.depthAtFinishNode), node2GridRefX: defaultValue((_h = insp.node2GridRef) === null || _h === void 0 ? void 0 : _h.node2GridRefX), node2GridRefY: defaultValue((_j = insp.node2GridRef) === null || _j === void 0 ? void 0 : _j.node2GridRefY), node3Ref: defaultValue(insp.node3Ref), node3GridRefX: defaultValue((_k = insp.node3GridRef) === null || _k === void 0 ? void 0 : _k.node3GridRefX), node3GridRefY: defaultValue((_l = insp.node3GridRef) === null || _l === void 0 ? void 0 : _l.node3GridRefY), videoImageStorage: defaultValue(insp.videoImageStorage), videoImageLocationSystem: defaultValue(insp.videoImageLocationSystem), videoImageFormat: defaultValue(insp.videoImageFormat), videoImageFilename: defaultValue(insp.videoImageFilename), videoImageVolume: defaultValue(insp.videoImageVolume), photographicStorageFormat: defaultValue(insp.photographicStorageFormat), photographicStorage: defaultValue(insp.photographicStorage) });
    return fullInsp;
}
function parseWSA05Inspection(insp, formatDateUTC) {
    var _a, _b, _c;
    var scheduledDate = '';
    var inspectionDate = '';
    var inspectionTime = '';
    if (insp.scheduledDate) {
        scheduledDate = (_a = (0, ValueMapping_1.extractValue)(insp.scheduledDate)) !== null && _a !== void 0 ? _a : '';
    }
    if (insp.surveyDateTime && insp.surveyDateTime != '') {
        inspectionDate =
            (_b = (0, date_utils_1.formatDateWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _b !== void 0 ? _b : '';
        inspectionTime =
            (_c = (0, date_utils_1.formatTimeWithFormatDate)(insp.surveyDateTime.toString(), formatDateUTC)) !== null && _c !== void 0 ? _c : '';
    }
    var fullInsp = __assign(__assign({}, insp), { 
        // Inspection generic
        _id: insp._id, inspectionId: insp.inspectionId, validationState: defaultValue(insp.validationState), uploadedBy: defaultValue(insp.uploadedBy), uploadDateTime: defaultValue(insp.uploadDateTime), scheduledDate: defaultValue(scheduledDate), missingMedia: insp.missingMedia, validationData: insp.validationData, mediaInspections: insp.mediaInspections, conditions: insp.conditions
            ? (0, _Utils_1.fixupObservationsCounterAndTime)(insp.conditions)
            : insp.conditions, isImperial: insp.isImperial, tenantId: defaultValue(insp.tenantId), inspectionStatus: defaultValue(insp.inspectionStatus), 
        // WSA Specific
        surveyDateTime: defaultValue(insp.surveyDateTime), inspectionDate: defaultValue(inspectionDate), inspectionTime: defaultValue(inspectionTime), pipelineRef: defaultValue(insp.pipelineRef), startNodeRef: defaultValue(insp.startNodeRef), startNodeCoordinates: defaultValue(insp.startNodeCoordinates), finishNodeRef: defaultValue(insp.finishNodeRef), finishNodeCoordinates: defaultValue(insp.finishNodeCoordinates), longLocStartLat: defaultValue(insp.longLocStartLat), circLocStartLat: defaultValue(insp.circLocStartLat), location: defaultValue(insp.location), direction: defaultValue(insp.direction), locationTypeCode: defaultValue(insp.locationTypeCode), assetOwnerOrEngagingAgency: defaultValue(insp.assetOwnerOrEngagingAgency), locationTown: defaultValue(insp.locationTown), divisionDistrict: defaultValue(insp.divisionDistrict), nameOfConduitSystem: defaultValue(insp.nameOfConduitSystem), landOwner: defaultValue(insp.landOwner), mappingGridDatumSystem: defaultValue(insp.mappingGridDatumSystem), mappingGridZone: defaultValue(insp.mappingGridZone), standard: defaultValue(insp.standard), originalCodingStandard: defaultValue(insp.originalCodingStandard), longitudinalReferencePoint: defaultValue(insp.longitudinalReferencePoint), conduitLocationRiskFactorObservedByOperator: defaultValue(insp.conduitLocationRiskFactorObservedByOperator), methodOfInspection: defaultValue(insp.methodOfInspection), operator: defaultValue(insp.operator), companyJobRef: defaultValue(insp.companyJobRef), assetOwnerJobRef: defaultValue(insp.assetOwnerJobRef), coderAssessor: defaultValue(insp.coderAssessor), videoImageLocationSystem: defaultValue(insp.videoImageLocationSystem), evidenceOfSurchargeInStartNode: defaultValue(insp.evidenceOfSurchargeInStartNode), purposeOfInspection: defaultValue(insp.purposeOfInspection), anticipatedLength: defaultValue(insp.anticipatedLength), actualLength: defaultValue(insp.actualLength), nameOfCompanyResponsibleForInspection: defaultValue(insp.nameOfCompanyResponsibleForInspection), shape: defaultValue(insp.shape), height: defaultValue(insp.height), width: defaultValue(insp.width), material: defaultValue(insp.material), liningType: defaultValue(insp.liningType), liningMaterial: defaultValue(insp.liningMaterial), conduitUnitLength: defaultValue(insp.conduitUnitLength), depthAtStartNode: defaultValue(insp.depthAtStartNode), depthAtFinishNode: defaultValue(insp.depthAtFinishNode), operationOfConduit: defaultValue(insp.operationOfConduit), useOfConduit: defaultValue(insp.useOfConduit), criticality: defaultValue(insp.criticality), cleaning: defaultValue(insp.cleaning), yearCameIntoOperation: defaultValue(insp.yearCameIntoOperation), jointingMethod: defaultValue(insp.jointingMethod), precipitation: defaultValue(insp.precipitation), temperature: defaultValue(insp.temperature), flowControlMeasures: defaultValue(insp.flowControlMeasures), tidalInfluence: defaultValue(insp.tidalInfluence), generalComment: defaultValue(insp.generalComment), userDefined1: defaultValue(insp.userDefined1), userDefined2: defaultValue(insp.userDefined2), userDefined3: defaultValue(insp.userDefined3), userDefined4: defaultValue(insp.userDefined4), userDefined5: defaultValue(insp.userDefined5) });
    return fullInsp;
}
function getFullInspSaga(action) {
    var payload, _a, fullInsp, fullInsp, fullInsp, fullInsp, e_1;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 13, , 16]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getFullInspApi, action.payload.inspectionId, action.payload.standard, action.payload.enableMediaTranscode)];
            case 1:
                payload = _d.sent();
                if (!(((_b = payload === null || payload === void 0 ? void 0 : payload.data) === null || _b === void 0 ? void 0 : _b.inspection) && ((_c = payload === null || payload === void 0 ? void 0 : payload.data) === null || _c === void 0 ? void 0 : _c.inspection.length) > 0)) return [3 /*break*/, 12];
                _a = action.payload.standard;
                switch (_a) {
                    case _Types_1.InspectionStandard.PACP: return [3 /*break*/, 2];
                    case _Types_1.InspectionStandard.MACP: return [3 /*break*/, 4];
                    case _Types_1.InspectionStandard.MSCC: return [3 /*break*/, 6];
                    case _Types_1.InspectionStandard.WSA05: return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                fullInsp = parsePACPInspection(payload.data.inspection[0], action.payload.formatDateUTC);
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspResolved)({
                        inspection: [fullInsp],
                        notes: payload.data.inspection[0].notes,
                    }))];
            case 3:
                _d.sent();
                return [3 /*break*/, 12];
            case 4:
                fullInsp = parseMACPInspection(payload.data.inspection[0], action.payload.formatDateUTC);
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspResolved)({
                        inspection: [fullInsp],
                        notes: payload.data.inspection[0].notes,
                    }))];
            case 5:
                _d.sent();
                return [3 /*break*/, 12];
            case 6:
                fullInsp = parseMSCCInspection(payload.data.inspection[0], action.payload.formatDateUTC);
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspResolved)({
                        inspection: [fullInsp],
                        notes: payload.data.inspection[0].notes,
                    }))];
            case 7:
                _d.sent();
                return [3 /*break*/, 12];
            case 8:
                fullInsp = parseWSA05Inspection(payload.data.inspection[0], action.payload.formatDateUTC);
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspResolved)({
                        inspection: [fullInsp],
                        notes: payload.data.inspection[0].notes,
                    }))];
            case 9:
                _d.sent();
                return [3 /*break*/, 12];
            case 10: 
            // Tasks
            return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspResolved)({
                    inspection: [payload.data.inspection[0]],
                    notes: payload.data.inspection[0].notes,
                }))];
            case 11:
                // Tasks
                _d.sent();
                return [3 /*break*/, 12];
            case 12: return [3 /*break*/, 16];
            case 13:
                e_1 = _d.sent();
                console.log(e_1);
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getFullInspRejected)())];
            case 14:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setFullInspectionIsWaiting)(false))];
            case 15:
                _d.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function watchGetFullInsp() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(fullInspection_actions_1.getFullInsp, getFullInspSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getNotesSaga(action) {
    var payload, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(true))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getNotesApi, action.payload._id)];
            case 3:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getNotesResolved)(payload.data))];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(false))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getNotesRejected)())];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(false))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchGetNotes() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(fullInspection_actions_1.getNotes, getNotesSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function addNoteSaga(action) {
    var e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(true))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.addNoteApi, action.payload)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(false))];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.getNotes)({ _id: action.payload._id }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.addNoteRejected)())];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, fullInspection_actions_1.setNotesIsWaiting)(false))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchAddNote() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(fullInspection_actions_1.addNote, addNoteSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetFullInsp(), watchGetNotes(), watchAddNote()];


/***/ }),

/***/ "./sagas/index.ts":
/*!************************!*\
  !*** ./sagas/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var assetDetail_sagas_1 = __importDefault(__webpack_require__(/*! ./assetDetail.sagas */ "./sagas/assetDetail.sagas.ts"));
var assetManhole_sagas_1 = __importDefault(__webpack_require__(/*! ./assetManhole.sagas */ "./sagas/assetManhole.sagas.ts"));
var assetPipe_sagas_1 = __importDefault(__webpack_require__(/*! ./assetPipe.sagas */ "./sagas/assetPipe.sagas.ts"));
var assetRiskHistory_sagas_1 = __importDefault(__webpack_require__(/*! ./assetRiskHistory.sagas */ "./sagas/assetRiskHistory.sagas.ts"));
var assetRisk_sagas_1 = __importDefault(__webpack_require__(/*! ./assetRisk.sagas */ "./sagas/assetRisk.sagas.ts"));
var charts_sagas_1 = __importDefault(__webpack_require__(/*! ./charts.sagas */ "./sagas/charts.sagas.ts"));
var configuration_sagas_1 = __importDefault(__webpack_require__(/*! ./configuration.sagas */ "./sagas/configuration.sagas.ts"));
var observations_sagas_1 = __importDefault(__webpack_require__(/*! ./observations.sagas */ "./sagas/observations.sagas.ts"));
var fullInsp_sagas_1 = __importDefault(__webpack_require__(/*! ./fullInsp.sagas */ "./sagas/fullInsp.sagas.ts"));
var inspection_sagas_1 = __importDefault(__webpack_require__(/*! ./inspection.sagas */ "./sagas/inspection.sagas.ts"));
var map_sagas_1 = __importDefault(__webpack_require__(/*! ./map.sagas */ "./sagas/map.sagas.ts"));
var observations_sagas_2 = __importDefault(__webpack_require__(/*! ./observations.sagas */ "./sagas/observations.sagas.ts"));
var rehab_sagas_1 = __importDefault(__webpack_require__(/*! ./rehab.sagas */ "./sagas/rehab.sagas.ts"));
var riskConfigsList_sagas_1 = __importDefault(__webpack_require__(/*! ./riskConfigsList.sagas */ "./sagas/riskConfigsList.sagas.ts"));
var riskConfigs_sagas_1 = __importDefault(__webpack_require__(/*! ./riskConfigs.sagas */ "./sagas/riskConfigs.sagas.ts"));
var spatial_sagas_1 = __importDefault(__webpack_require__(/*! ./spatial.sagas */ "./sagas/spatial.sagas.ts"));
function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.all)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], assetRisk_sagas_1.default, true), assetDetail_sagas_1.default, true), assetPipe_sagas_1.default, true), assetManhole_sagas_1.default, true), inspection_sagas_1.default, true), observations_sagas_1.default, true), fullInsp_sagas_1.default, true), assetRiskHistory_sagas_1.default, true), spatial_sagas_1.default, true), rehab_sagas_1.default, true), observations_sagas_2.default, true), riskConfigs_sagas_1.default, true), map_sagas_1.default, true), riskConfigsList_sagas_1.default, true), charts_sagas_1.default, true), configuration_sagas_1.default, true))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = rootSaga;


/***/ }),

/***/ "./sagas/inspection.sagas.ts":
/*!***********************************!*\
  !*** ./sagas/inspection.sagas.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var inspection_actions_1 = __webpack_require__(/*! @Actions/inspection.actions */ "./actions/inspection.actions.ts");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getInspectionsSaga(action) {
    var payload, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getInspectionApi, action.payload.assetId)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.getInspectionAttributesResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.getInspectionAttributesRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetInspections() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(inspection_actions_1.getInspectionAttributes, getInspectionsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateInspectionsSaga(action) {
    var payload, e_2, err, rejection;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 7]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getUpdateInspectionApi, action.payload)];
            case 1:
                payload = _f.sent();
                if (!((payload === null || payload === void 0 ? void 0 : payload.status) === 200)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Inspection Updated Successfully')))];
            case 2:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.refreshInspection)(payload))];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4: return [3 /*break*/, 7];
            case 5:
                e_2 = _f.sent();
                err = e_2;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_e = (_c = err === null || err === void 0 ? void 0 : err.message) !== null && _c !== void 0 ? _c : (_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.statusText) !== null && _e !== void 0 ? _e : (0, i18next_1.t)('No additional information'),
                };
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('{{message}} Failed: {{reason}}', {
                        message: 'Inspection Update',
                        reason: rejection.text,
                    })))];
            case 6:
                _f.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function watchUpdateInspections() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(inspection_actions_1.updateInspection, updateInspectionsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function createInspectionSaga(action) {
    var payload, e_3, err, rejection;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.setCreatingInspection)(true))];
            case 1:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.call)(_Services_1.createInspectionApi, action.payload)];
            case 2:
                payload = _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.setCreateInspectionId)(payload.data._id))];
            case 3:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.setCreatingInspection)(false))];
            case 4:
                _f.sent();
                return [3 /*break*/, 9];
            case 5:
                e_3 = _f.sent();
                console.log(e_3);
                err = e_3;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_e = (_c = err === null || err === void 0 ? void 0 : err.message) !== null && _c !== void 0 ? _c : (_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.statusText) !== null && _e !== void 0 ? _e : (0, i18next_1.t)('No additional information'),
                };
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.setCreateInspectionId)(undefined))];
            case 6:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspection_actions_1.setCreatingInspection)(false))];
            case 7:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('New {{type}} Failed: {{reason}}', {
                        type: action.payload.options.task
                            ? (0, i18next_1.t)('Inspection')
                            : (0, i18next_1.t)('Task'),
                        reason: rejection.text,
                    })))];
            case 8:
                _f.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchCreateInspection() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(inspection_actions_1.createInspection, createInspectionSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetInspections(),
    watchUpdateInspections(),
    watchCreateInspection(),
];


/***/ }),

/***/ "./sagas/map.sagas.ts":
/*!****************************!*\
  !*** ./sagas/map.sagas.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var Rehab_servies_1 = __webpack_require__(/*! @Services/Rehab.servies */ "./services/Rehab.servies.ts");
function getMapRiskLayersSaga() {
    var payload, e_1, err, rejection;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getMapRiskLayersApi)];
            case 1:
                payload = _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRiskLayersResolved)(payload.data))];
            case 2:
                _e.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _e.sent();
                err = e_1;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : 'No additional information',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRiskLayersRejected)(rejection))];
            case 4:
                _e.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getMapRehabLayersSaga() {
    var payload, e_2, err, rejection;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, Rehab_servies_1.getRehabTreesApi, {
                        publishedOnly: true,
                        listTreesAndActions: true,
                        slice: 10,
                    })];
            case 1:
                payload = _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRehabLayersResolved)(payload.data.data))];
            case 2:
                _e.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _e.sent();
                err = e_2;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : 'No additional information',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRehabLayersRejected)(rejection))];
            case 4:
                _e.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getMapLayersSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRiskLayers)())];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getMapRehabLayers)())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetMapLayers() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getMapLayers, getMapLayersSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetMapRiskLayers() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getMapRiskLayers, getMapRiskLayersSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetMapRehabLayers() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getMapRehabLayers, getMapRehabLayersSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetMapRiskLayers(),
    watchGetMapRehabLayers(),
    watchGetMapLayers(),
];


/***/ }),

/***/ "./sagas/observations.sagas.ts":
/*!*************************************!*\
  !*** ./sagas/observations.sagas.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var observations_actions_1 = __webpack_require__(/*! @Actions/observations.actions */ "./actions/observations.actions.ts");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
function getObservationsSaga(action) {
    var payload, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.getObservationsApi, action.payload)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.getObservationsResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.getObservationsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetObservations() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(observations_actions_1.getObservations, getObservationsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function editObservationsSaga(action) {
    var e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 4, 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.editObservationsApi, action.payload.params)];
            case 1:
                _a.sent();
                return [3 /*break*/, 5];
            case 2:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.editObservationsRejected)())];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                if (action.payload.history)
                    action.payload.history.goBack();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}
function watchEditObservations() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(observations_actions_1.editObservations, editObservationsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function createObservationsSaga(action) {
    var e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 5, 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.createObservationsApi, action.payload.params)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.createObservationsResolved)())];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.createObservationsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 6];
            case 5:
                if (action.payload.history)
                    action.payload.history.goBack();
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}
function watchCreateObservation() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(observations_actions_1.createObservations, createObservationsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function deleteObservationsSaga(action) {
    var e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, _Services_1.deleteObservationsApi, action.payload.inspectionId, action.payload.observationIds)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.deleteObservationsResolved)(action.payload.observationIds))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, observations_actions_1.deleteObservationsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchDeleteObservation() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(observations_actions_1.deleteObservations, deleteObservationsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetObservations(),
    watchEditObservations(),
    watchCreateObservation(),
    watchDeleteObservation(),
];


/***/ }),

/***/ "./sagas/rehab.sagas.ts":
/*!******************************!*\
  !*** ./sagas/rehab.sagas.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-explicit-any */
var Rehab_action_1 = __webpack_require__(/*! @Actions/Rehab.action */ "./actions/Rehab.action.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var Rehab_servies_1 = __webpack_require__(/*! @Services/Rehab.servies */ "./services/Rehab.servies.ts");
var treeUtils_1 = __webpack_require__(/*! @Utils/treeUtils */ "./utils/treeUtils.ts");
var effects_2 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getRehabTreesSaga() {
    var payload, reactFlowDecisionTrees_1, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, Rehab_servies_1.getRehabTreesApi)];
            case 1:
                payload = _a.sent();
                reactFlowDecisionTrees_1 = [];
                payload.data.map(function (decisionTree) {
                    var treeNodes = (0, treeUtils_1.convertTreeToReactFlowObject)(decisionTree.treeNodes);
                    var reactFlowDecisionTree = {
                        _id: decisionTree._id,
                        name: decisionTree.name,
                        thumbnail: decisionTree.thumbnail,
                        nodes: treeNodes,
                        status: decisionTree.status,
                        runBy: decisionTree.runBy,
                        lastRun: decisionTree.lastRun,
                        assetType: decisionTree.assetType,
                        assetCount: decisionTree.assetCount,
                        nodeCount: decisionTree.nodeCount,
                        publishState: decisionTree.publishState,
                    };
                    reactFlowDecisionTrees_1 = __spreadArray(__spreadArray([], reactFlowDecisionTrees_1, true), [
                        reactFlowDecisionTree,
                    ], false);
                });
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.getRehabTreesResolved)(reactFlowDecisionTrees_1))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.getRehabTreesRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetRehabTrees() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Rehab_action_1.getRehabTrees, getRehabTreesSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getRehabResultSaga(action) {
    var query, treeId, payload, rows, data, e_2, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                query = "?sort=LAST_RUN&sortDescending=true&filters=AllHistory%257Ctrue,ASSET_ID%257C".concat(action.payload.assetId);
                treeId = action.payload.treeId;
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, Rehab_servies_1.getRehabResultApi, treeId, query)];
            case 1:
                payload = _c.sent();
                rows = payload.data.data;
                data = __assign(__assign({}, payload.data), { treeId: action.payload.treeId, data: rows.map(function (rehabResult) {
                        if (rehabResult.ASSET_ID.indexOf('#') > 0) {
                            return __assign(__assign({}, rehabResult), { ASSET_ID: rehabResult.ASSET_ID.split('#')[1] });
                        }
                        else {
                            return rehabResult;
                        }
                    }) });
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.getRehabResultResolved)(data))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _c.sent();
                response = e_2.response;
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.getRehabResultRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : 'No additional information',
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetRehabResult() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_2.takeEvery)([Rehab_action_1.getRehabResult], getRehabResultSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function toggleRehabTreePublishStateSaga(action) {
    var _a, treeId, newPublishState, cb, err_1, response;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 6]);
                _a = action.payload, treeId = _a.treeId, newPublishState = _a.newPublishState, cb = _a.cb;
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, Rehab_servies_1.toggleRehabTreePublishStateApi, treeId, newPublishState)];
            case 1:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.toggleRehabTreePublishStateResolved)())];
            case 2:
                _d.sent();
                if (cb && typeof cb === 'function') {
                    cb();
                }
                return [3 /*break*/, 6];
            case 3:
                err_1 = _d.sent();
                response = err_1.response;
                return [4 /*yield*/, (0, effects_1.put)((0, Rehab_action_1.toggleRehabTreePublishStateRejected)({
                        code: (_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : -1,
                        text: (_c = response === null || response === void 0 ? void 0 : response.statusText) !== null && _c !== void 0 ? _c : 'No additional information',
                    }))];
            case 4:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to update Rehab Tree state.')))];
            case 5:
                _d.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchToggleRehabTreePublishState() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_2.takeEvery)(Rehab_action_1.toggleRehabTreePublishState, toggleRehabTreePublishStateSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [
    watchGetRehabTrees(),
    watchGetRehabResult(),
    watchToggleRehabTreePublishState(),
];


/***/ }),

/***/ "./sagas/riskConfigs.sagas.ts":
/*!************************************!*\
  !*** ./sagas/riskConfigs.sagas.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var riskConfigs_actions_1 = __webpack_require__(/*! @Actions/riskConfigs.actions */ "./actions/riskConfigs.actions.ts");
var effects_2 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var riskConfigs_selectors_1 = __webpack_require__(/*! @Selectors/riskConfigs.selectors */ "./selectors/riskConfigs.selectors.ts");
function getRiskConfigsSaga() {
    var query, payload, e_1, err, rejection;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(true))];
            case 1:
                _f.sent();
                return [4 /*yield*/, (0, effects_2.select)(riskConfigs_selectors_1.selectorRiskConfigsPaginationQuery)];
            case 2:
                query = _f.sent();
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskConfigurationsApi, query)];
            case 3:
                payload = _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.getRiskConfigsResolved)({
                        pagination: payload.data.pagination,
                        data: payload.data.data,
                    }))];
            case 4:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(false))];
            case 5:
                _f.sent();
                return [3 /*break*/, 9];
            case 6:
                e_1 = _f.sent();
                err = e_1;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_e = (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information')) !== null && _e !== void 0 ? _e : '',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.getRiskConfigsRejected)(rejection))];
            case 7:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(false))];
            case 8:
                _f.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchGetRiskConfigs() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)([riskConfigs_actions_1.getRiskConfigs, riskConfigs_actions_1.clearRiskConfigs, riskConfigs_actions_1.reloadRiskConfigs], getRiskConfigsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchChangePagination() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)([riskConfigs_actions_1.changeRiskConfigsPage, riskConfigs_actions_1.changeRiskConfigsSlice, riskConfigs_actions_1.changeRiskConfigsSort], getRiskConfigsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetRiskConfigs(), watchChangePagination()];


/***/ }),

/***/ "./sagas/riskConfigsList.sagas.ts":
/*!****************************************!*\
  !*** ./sagas/riskConfigsList.sagas.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var riskConfigs_actions_1 = __webpack_require__(/*! @Actions/riskConfigs.actions */ "./actions/riskConfigs.actions.ts");
function getRiskConfigsListSaga(action) {
    var assetType, payload, e_1, err, rejection;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(true))];
            case 1:
                _f.sent();
                assetType = action.payload.assetType;
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getRiskConfigurationsApi, "?assetType=".concat(assetType, "&listAll=true"))];
            case 2:
                payload = _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.getRiskConfigsListResolved)(payload.data))];
            case 3:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(false))];
            case 4:
                _f.sent();
                return [3 /*break*/, 8];
            case 5:
                e_1 = _f.sent();
                err = e_1;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_e = (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information')) !== null && _e !== void 0 ? _e : '',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.getRiskConfigsListRejected)(rejection))];
            case 6:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, riskConfigs_actions_1.setRiskConfigsIsBusy)(false))];
            case 7:
                _f.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function watchGetRiskConfigsList() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)([riskConfigs_actions_1.getRiskConfigsList], getRiskConfigsListSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetRiskConfigsList()];


/***/ }),

/***/ "./sagas/spatial.sagas.ts":
/*!********************************!*\
  !*** ./sagas/spatial.sagas.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Services_1 = __webpack_require__(/*! @Services */ "./services/index.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getSpatialLayersSaga() {
    var payload, e_1, err, rejection;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 30000, _Services_1.getSpatialLayersApi)];
            case 1:
                payload = _f.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getSpatialLayersResolved)(payload.data))];
            case 2:
                _f.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _f.sent();
                err = e_1;
                rejection = {
                    code: (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                    text: (_e = (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information')) !== null && _e !== void 0 ? _e : '',
                };
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getSpatialLayersRejected)(rejection))];
            case 4:
                _f.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetSpatialLayers() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getSpatialLayers, getSpatialLayersSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = [watchGetSpatialLayers()];


/***/ }),

/***/ "./selectors/assetDetail.selectors.ts":
/*!********************************************!*\
  !*** ./selectors/assetDetail.selectors.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSelectAssetLocationIsWaiting = exports.useSelectAssetLocation = exports.selectValidatingAssets = exports.selectValidAssetIds = exports.selectDetailSelectedMapIds = exports.selectAssetDetailAssetId = exports.selectAssetDetailType = exports.selectAssetDetailId = exports.selectAssetDetailNotesIsWaiting = exports.selectIsAssetCountsReady = exports.selectAssetCounts = exports.selectAssetDetailIsWaiting = exports.selectAssetDetailDetail = exports.selectAssetDetail = exports.SelectedAssetLocationIsWaiting = exports.SelectedAssetLocation = void 0;
var map_selectors_1 = __webpack_require__(/*! ./map.selectors */ "./selectors/map.selectors.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var assetDetailSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.assetDetails; });
var assetCountsSelector = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.assetCounts; });
var isAssetCountsReadySelector = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.isAssetCountsReady; });
var assetDetailIsWaitingSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetDetails) === null || _a === void 0 ? void 0 : _a.isWaiting; });
var assetDetailNotesIsWaitingSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetDetails) === null || _a === void 0 ? void 0 : _a.notesIsWaiting; });
var getAssetDetailDetailSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetDetails) === null || _a === void 0 ? void 0 : _a.assetDetails; });
var getDetailId = (0, toolkit_1.createSelector)(assetDetailSelector, function (details) {
    var _a, _b;
    return ((_b = (_a = details === null || details === void 0 ? void 0 : details.assetDetails) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.FieldName === '_id'; })) === null || _b === void 0 ? void 0 : _b.FieldValue) ||
        undefined;
});
var getDetailType = (0, toolkit_1.createSelector)(assetDetailSelector, function (details) {
    var _a, _b;
    return ((_b = (_a = details === null || details === void 0 ? void 0 : details.assetDetails) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.FieldName === 'assetType'; })) === null || _b === void 0 ? void 0 : _b.FieldValue) || undefined;
});
var getDetailAssetId = (0, toolkit_1.createSelector)(assetDetailSelector, function (details) {
    var _a, _b;
    return ((_b = (_a = details === null || details === void 0 ? void 0 : details.assetDetails) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.FieldName === 'assetId'; })) === null || _b === void 0 ? void 0 : _b.FieldValue) || undefined;
});
var getDetailSelectedMapIds = (0, toolkit_1.createSelector)(getDetailId, map_selectors_1.getMapSelectedIds, function (detailId, mapIds) {
    return mapIds.filter(function (m) { return m.id === detailId; });
});
var ValidAssetIdSelector = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.validAssetIdsList; });
var ValidatingAssetsSelector = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.validatingAssets; });
exports.SelectedAssetLocation = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.assetLocation; });
exports.SelectedAssetLocationIsWaiting = (0, toolkit_1.createSelector)(assetDetailSelector, function (state) { return state === null || state === void 0 ? void 0 : state.assetLocationIsWaiting; });
var selectAssetDetail = function () { return (0, react_redux_1.useSelector)(assetDetailSelector); };
exports.selectAssetDetail = selectAssetDetail;
var selectAssetDetailDetail = function () {
    return (0, react_redux_1.useSelector)(getAssetDetailDetailSelector);
};
exports.selectAssetDetailDetail = selectAssetDetailDetail;
var selectAssetDetailIsWaiting = function () {
    return (0, react_redux_1.useSelector)(assetDetailIsWaitingSelector);
};
exports.selectAssetDetailIsWaiting = selectAssetDetailIsWaiting;
var selectAssetCounts = function () { return (0, react_redux_1.useSelector)(assetCountsSelector); };
exports.selectAssetCounts = selectAssetCounts;
var selectIsAssetCountsReady = function () {
    return (0, react_redux_1.useSelector)(isAssetCountsReadySelector);
};
exports.selectIsAssetCountsReady = selectIsAssetCountsReady;
var selectAssetDetailNotesIsWaiting = function () {
    return (0, react_redux_1.useSelector)(assetDetailNotesIsWaitingSelector);
};
exports.selectAssetDetailNotesIsWaiting = selectAssetDetailNotesIsWaiting;
var selectAssetDetailId = function () { return (0, react_redux_1.useSelector)(getDetailId); };
exports.selectAssetDetailId = selectAssetDetailId;
var selectAssetDetailType = function () { return (0, react_redux_1.useSelector)(getDetailType); };
exports.selectAssetDetailType = selectAssetDetailType;
var selectAssetDetailAssetId = function () { return (0, react_redux_1.useSelector)(getDetailAssetId); };
exports.selectAssetDetailAssetId = selectAssetDetailAssetId;
var selectDetailSelectedMapIds = function () {
    return (0, react_redux_1.useSelector)(getDetailSelectedMapIds);
};
exports.selectDetailSelectedMapIds = selectDetailSelectedMapIds;
var selectValidAssetIds = function () { return (0, react_redux_1.useSelector)(ValidAssetIdSelector); };
exports.selectValidAssetIds = selectValidAssetIds;
var selectValidatingAssets = function () {
    return (0, react_redux_1.useSelector)(ValidatingAssetsSelector);
};
exports.selectValidatingAssets = selectValidatingAssets;
var useSelectAssetLocation = function () {
    return (0, react_redux_1.useSelector)(exports.SelectedAssetLocation);
};
exports.useSelectAssetLocation = useSelectAssetLocation;
var useSelectAssetLocationIsWaiting = function () {
    return (0, react_redux_1.useSelector)(exports.SelectedAssetLocationIsWaiting);
};
exports.useSelectAssetLocationIsWaiting = useSelectAssetLocationIsWaiting;
exports["default"] = {
    selectAssetDetail: exports.selectAssetDetail,
    selectAssetDetailDetail: exports.selectAssetDetailDetail,
    selectAssetDetailIsWaiting: exports.selectAssetDetailIsWaiting,
    selectAssetDetailNotesIsWaiting: exports.selectAssetDetailNotesIsWaiting,
    selectAssetDetailId: exports.selectAssetDetailId,
    selectAssetDetailType: exports.selectAssetDetailType,
    selectDetailSelectedMapIds: exports.selectDetailSelectedMapIds,
    selectValidAssetIds: exports.selectValidAssetIds,
    selectValidatingAssets: exports.selectValidatingAssets,
    useSelectAssetLocation: exports.useSelectAssetLocation,
    useSelectAssetLocationIsWaiting: exports.useSelectAssetLocationIsWaiting,
};


/***/ }),

/***/ "./selectors/assetManhole.selectors.ts":
/*!*********************************************!*\
  !*** ./selectors/assetManhole.selectors.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectAssetManholeAsset = exports.selectAssetManhole = exports.assetMaholeAssetSelector = exports.assetManholeSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.assetManholeSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.assetManhole; });
exports.assetMaholeAssetSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetManhole) === null || _a === void 0 ? void 0 : _a.asset; });
var selectAssetManhole = function () { return (0, react_redux_1.useSelector)(exports.assetManholeSelector); };
exports.selectAssetManhole = selectAssetManhole;
var selectAssetManholeAsset = function () {
    return (0, react_redux_1.useSelector)(exports.assetMaholeAssetSelector);
};
exports.selectAssetManholeAsset = selectAssetManholeAsset;
exports["default"] = exports.selectAssetManhole;


/***/ }),

/***/ "./selectors/assetPipe.selectors.ts":
/*!******************************************!*\
  !*** ./selectors/assetPipe.selectors.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectAssetPipeAsset = exports.selectAssetPipe = exports.assetPipeAssetSelector = exports.assetPipeSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.assetPipeSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.assetPipe; });
exports.assetPipeAssetSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetPipe) === null || _a === void 0 ? void 0 : _a.asset; });
var selectAssetPipe = function () { return (0, react_redux_1.useSelector)(exports.assetPipeSelector); };
exports.selectAssetPipe = selectAssetPipe;
var selectAssetPipeAsset = function () { return (0, react_redux_1.useSelector)(exports.assetPipeAssetSelector); };
exports.selectAssetPipeAsset = selectAssetPipeAsset;
exports["default"] = exports.selectAssetPipe;


/***/ }),

/***/ "./selectors/assetRisk.selectors.ts":
/*!******************************************!*\
  !*** ./selectors/assetRisk.selectors.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectRiskSummayIsLoading = exports.selectRiskSummay = exports.selectAssetRisk = exports.selectAssetRiskIsReady = exports.selectAssetRiskIsRejected = exports.selectAssetRiskIsWaiting = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var assetRiskSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.assetRisk; });
var assetRiskSummarySelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.riskSummary; });
var assetRiskReadySelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.isReady; });
var assetRiskRejectedSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.isReady; });
var assetRiskIsWaitingSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.isWaiting; });
var assetRiskSummaryIsLoadingSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRisk) === null || _a === void 0 ? void 0 : _a.riskSummaryIsLoading; });
var selectAssetRiskIsWaiting = function () {
    return (0, react_redux_1.useSelector)(assetRiskIsWaitingSelector);
};
exports.selectAssetRiskIsWaiting = selectAssetRiskIsWaiting;
var selectAssetRiskIsRejected = function () {
    return (0, react_redux_1.useSelector)(assetRiskRejectedSelector);
};
exports.selectAssetRiskIsRejected = selectAssetRiskIsRejected;
var selectAssetRiskIsReady = function () { return (0, react_redux_1.useSelector)(assetRiskReadySelector); };
exports.selectAssetRiskIsReady = selectAssetRiskIsReady;
var selectAssetRisk = function () { return (0, react_redux_1.useSelector)(assetRiskSelector); };
exports.selectAssetRisk = selectAssetRisk;
var selectRiskSummay = function () { return (0, react_redux_1.useSelector)(assetRiskSummarySelector); };
exports.selectRiskSummay = selectRiskSummay;
var selectRiskSummayIsLoading = function () {
    return (0, react_redux_1.useSelector)(assetRiskSummaryIsLoadingSelector);
};
exports.selectRiskSummayIsLoading = selectRiskSummayIsLoading;
exports["default"] = {
    selectAssetRiskIsWaiting: exports.selectAssetRiskIsWaiting,
    selectAssetRiskIsRejected: exports.selectAssetRiskIsRejected,
    selectAssetRiskIsReady: exports.selectAssetRiskIsReady,
    selectAssetRisk: exports.selectAssetRisk,
};


/***/ }),

/***/ "./selectors/assetRiskHistory.selectors.ts":
/*!*************************************************!*\
  !*** ./selectors/assetRiskHistory.selectors.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectAssetRiskHistory = exports.selectAssetRiskHistoryIsReady = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var assetRiskHistorySelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRiskHistory) === null || _a === void 0 ? void 0 : _a.assetRiskHistory; });
var assetRiskHistoryReadySelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.assetRiskHistory) === null || _a === void 0 ? void 0 : _a.isReady; });
var selectAssetRiskHistoryIsReady = function () {
    return (0, react_redux_1.useSelector)(assetRiskHistoryReadySelector);
};
exports.selectAssetRiskHistoryIsReady = selectAssetRiskHistoryIsReady;
var selectAssetRiskHistory = function () {
    return (0, react_redux_1.useSelector)(assetRiskHistorySelector);
};
exports.selectAssetRiskHistory = selectAssetRiskHistory;
exports["default"] = { selectAssetRiskHistoryIsReady: exports.selectAssetRiskHistoryIsReady, selectAssetRiskHistory: exports.selectAssetRiskHistory };


/***/ }),

/***/ "./selectors/charts.selectors.ts":
/*!***************************************!*\
  !*** ./selectors/charts.selectors.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectChartIsLoading = exports.selectCharts = exports.selectorChartsIsLoading = exports.selectorCharts = exports.ChartsStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.ChartsStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.charts; });
var selectorCharts = function (chartId) {
    return (0, toolkit_1.createSelector)(exports.ChartsStoreSelector, function (state) {
        if (state.charts) {
            var chart = state.charts.find(function (chart) {
                return chart.chartId === chartId;
            });
            return chart === null || chart === void 0 ? void 0 : chart.data;
        }
    });
};
exports.selectorCharts = selectorCharts;
var selectorChartsIsLoading = function () {
    return (0, toolkit_1.createSelector)(exports.ChartsStoreSelector, function (state) {
        return state.isLoading;
    });
};
exports.selectorChartsIsLoading = selectorChartsIsLoading;
var selectCharts = function (chartId) {
    return (0, react_redux_1.useSelector)((0, exports.selectorCharts)(chartId));
};
exports.selectCharts = selectCharts;
var selectChartIsLoading = function () {
    return (0, react_redux_1.useSelector)((0, exports.selectorChartsIsLoading)());
};
exports.selectChartIsLoading = selectChartIsLoading;
exports["default"] = exports.selectCharts;


/***/ }),

/***/ "./selectors/configuration.selectors.ts":
/*!**********************************************!*\
  !*** ./selectors/configuration.selectors.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSelectConfigurationIsLoading = exports.useSelectConfigurationDetails = exports.useSelectConfiguration = void 0;
var configuration_reducer_1 = __webpack_require__(/*! ../reducers/configuration.reducer */ "./reducers/configuration.reducer.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var ConfigurationStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.configuration) !== null && _a !== void 0 ? _a : configuration_reducer_1.initialState; });
var ConfigurationsSelector = (0, toolkit_1.createSelector)(ConfigurationStoreSelector, function (state) { return state.configurations; });
var IsLoadingSelector = (0, toolkit_1.createSelector)(ConfigurationStoreSelector, function (state) {
    var _a, _b;
    return ((_a = state === null || state === void 0 ? void 0 : state.isLoadingConfiguration) !== null && _a !== void 0 ? _a : false) ||
        ((_b = state === null || state === void 0 ? void 0 : state.isLoadingConfiguration) !== null && _b !== void 0 ? _b : false);
});
var selectorConfigurationState = function (key) {
    return (0, toolkit_1.createSelector)(ConfigurationsSelector, function (state) {
        var _a;
        if (state && state[key]) {
            return (_a = state[key]) === null || _a === void 0 ? void 0 : _a.mapping;
        }
    });
};
var selectorConfigurationDetailsState = function (key) {
    return (0, toolkit_1.createSelector)(ConfigurationsSelector, function (state) {
        var _a;
        if (state && state[key]) {
            return (_a = state[key]) === null || _a === void 0 ? void 0 : _a.details;
        }
    });
};
var useSelectConfiguration = function (key) {
    return (0, react_redux_1.useSelector)(selectorConfigurationState(key));
};
exports.useSelectConfiguration = useSelectConfiguration;
var useSelectConfigurationDetails = function (key) {
    return (0, react_redux_1.useSelector)(selectorConfigurationDetailsState(key));
};
exports.useSelectConfigurationDetails = useSelectConfigurationDetails;
var useSelectConfigurationIsLoading = function () {
    return (0, react_redux_1.useSelector)(IsLoadingSelector);
};
exports.useSelectConfigurationIsLoading = useSelectConfigurationIsLoading;


/***/ }),

/***/ "./selectors/fullInspection.selectors.ts":
/*!***********************************************!*\
  !*** ./selectors/fullInspection.selectors.ts ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMergedValidation = exports.selectFullInspectionConditions = exports.hasValidationIssues = exports.selectNotesIsWaiting = exports.selectFullInspectionIsWaiting = exports.selectNotes = exports.selectFullInspection = exports.refreshInsp = exports.fullInspSelector = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var fullInspStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.fullInspection; });
var inspectionStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.inspections; });
exports.fullInspSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.fullInspection; });
var notesSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.notes; });
var fullInspectionIsWaitingSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.isWaiting; });
var notesIsWaitingSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.notesIsWaiting; });
var validationIssuesSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) {
    var _a;
    return (state === null || state === void 0 ? void 0 : state.fullInspection.validationData) &&
        ((_a = state === null || state === void 0 ? void 0 : state.fullInspection.validationData) === null || _a === void 0 ? void 0 : _a.length) != 0;
});
var fullInspectionConditionSelector = (0, toolkit_1.createSelector)(fullInspStoreSelector, function (store) { return store.fullInspection.conditions; });
var refreshInspectionSelector = (0, toolkit_1.createSelector)(inspectionStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.updateStatus; });
var refreshInsp = function () { return (0, react_redux_1.useSelector)(refreshInspectionSelector); };
exports.refreshInsp = refreshInsp;
var selectFullInspection = function () { return (0, react_redux_1.useSelector)(exports.fullInspSelector); };
exports.selectFullInspection = selectFullInspection;
var selectNotes = function () { return (0, react_redux_1.useSelector)(notesSelector); };
exports.selectNotes = selectNotes;
var selectFullInspectionIsWaiting = function () {
    return (0, react_redux_1.useSelector)(fullInspectionIsWaitingSelector);
};
exports.selectFullInspectionIsWaiting = selectFullInspectionIsWaiting;
var selectNotesIsWaiting = function () { return (0, react_redux_1.useSelector)(notesIsWaitingSelector); };
exports.selectNotesIsWaiting = selectNotesIsWaiting;
var hasValidationIssues = function () { return (0, react_redux_1.useSelector)(validationIssuesSelector); };
exports.hasValidationIssues = hasValidationIssues;
var selectFullInspectionConditions = function () {
    return (0, react_redux_1.useSelector)(fullInspectionConditionSelector);
};
exports.selectFullInspectionConditions = selectFullInspectionConditions;
var mergedValidationSelector = function (standard) {
    return (0, toolkit_1.createSelector)(fullInspStoreSelector, function (state) {
        var validationData = [];
        var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
        if (state.fullInspection.validationData &&
            state.fullInspection.validationData.length > 0) {
            for (var _i = 0, _a = state.fullInspection.validationData; _i < _a.length; _i++) {
                var each = _a[_i];
                var message = each.errorMessage;
                if (each.target === 'lengthSurveyed' &&
                    each.errorMessage.includes('asset.Length')) {
                    message = each.errorMessage.replace(/-?\d+(\.\d+)?/g, function (match) {
                        var convertedString = getSystemValueFormatted("".concat(match, "m"), '', 2);
                        if (!convertedString) {
                            convertedString = "".concat(match, "m");
                        }
                        return convertedString;
                    });
                }
                validationData.push(__assign(__assign({}, each), { errorMessage: message }));
            }
        }
        if (state.fullInspection.conditions &&
            state.fullInspection.conditions.length > 0) {
            switch (standard) {
                case _Types_1.InspectionStandard.MACP:
                    var _loop_1 = function (each) {
                        var obs = each;
                        if (obs.validationData && obs.validationData.length) {
                            validationData.push.apply(validationData, obs.validationData.map(function (condValidation) {
                                return __assign(__assign({}, condValidation), { errorMessage: (0, i18next_1.t)('Distance: {{distance}}, MACP Code: {{code}}, Message: {{message}}', {
                                        distance: getSystemValueFormatted("".concat(obs.distance, "m"), '', 2),
                                        code: obs.macpCode,
                                        message: condValidation.errorMessage,
                                    }) });
                            }));
                        }
                    };
                    for (var _b = 0, _c = state.fullInspection.conditions; _b < _c.length; _b++) {
                        var each = _c[_b];
                        _loop_1(each);
                    }
                    break;
                case _Types_1.InspectionStandard.MSCC:
                    var _loop_2 = function (each) {
                        var obs = each;
                        if (obs.validationData && obs.validationData.length) {
                            validationData.push.apply(validationData, obs.validationData.map(function (condValidation) {
                                return __assign(__assign({}, condValidation), { errorMessage: (0, i18next_1.t)('Distance: {{distance}}, MSCC Code: {{code}}, Message: {{message}}', {
                                        distance: getSystemValueFormatted("".concat(obs.distance, "m"), '', 2),
                                        code: obs.code,
                                        message: condValidation.errorMessage,
                                    }) });
                            }));
                        }
                    };
                    for (var _d = 0, _e = state.fullInspection.conditions; _d < _e.length; _d++) {
                        var each = _e[_d];
                        _loop_2(each);
                    }
                    break;
                case _Types_1.InspectionStandard.WSA05:
                    var _loop_3 = function (each) {
                        var obs = each;
                        if (obs.validationData && obs.validationData.length) {
                            validationData.push.apply(validationData, obs.validationData.map(function (condValidation) {
                                return __assign(__assign({}, condValidation), { errorMessage: (0, i18next_1.t)('Distance: {{distance}}, WSA05 Code: {{code}}, Message: {{message}}', {
                                        distance: getSystemValueFormatted("".concat(obs.distance, "m"), '', 2),
                                        code: obs.code,
                                        message: condValidation.errorMessage,
                                    }) });
                            }));
                        }
                    };
                    for (var _f = 0, _g = state.fullInspection.conditions; _f < _g.length; _f++) {
                        var each = _g[_f];
                        _loop_3(each);
                    }
                    break;
                default:
                    var _loop_4 = function (each) {
                        var obs = each;
                        if (obs.validationData && obs.validationData.length) {
                            validationData.push.apply(validationData, obs.validationData.map(function (condValidation) {
                                return __assign(__assign({}, condValidation), { errorMessage: (0, i18next_1.t)('Distance: {{distance}}, PACP Code: {{code}}, Message: {{message}}', {
                                        distance: getSystemValueFormatted("".concat(obs.distance, "m"), '', 2),
                                        code: obs.PACPCode,
                                        message: condValidation.errorMessage,
                                    }) });
                            }));
                        }
                    };
                    for (var _h = 0, _j = state.fullInspection.conditions; _h < _j.length; _h++) {
                        var each = _j[_h];
                        _loop_4(each);
                    }
                    break;
            }
        }
        return validationData;
    });
};
var selectMergedValidation = function (standard) {
    return (0, react_redux_1.useSelector)(mergedValidationSelector(standard));
};
exports.selectMergedValidation = selectMergedValidation;
exports["default"] = {
    selectNotes: exports.selectNotes,
    selectFullInspection: exports.selectFullInspection,
    selectFullInspectionIsWaiting: exports.selectFullInspectionIsWaiting,
    selectNotesIsWaiting: exports.selectNotesIsWaiting,
    hasValidationIssues: exports.hasValidationIssues,
    selectFullInspectionConditions: exports.selectFullInspectionConditions,
    selectMergedValidation: exports.selectMergedValidation,
};


/***/ }),

/***/ "./selectors/index.ts":
/*!****************************!*\
  !*** ./selectors/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getMapSelectedPosition = exports.getMapSelectedIds = exports.getMapSelected = exports.getMapBackground = exports.getMapPosition = exports.selectRiskLayers = exports.selectMapInsertSpatial = exports.selectMapInsertAsset = exports.selectMapInsertInspection = exports.selectCreatingInspection = exports.selectInspectionsIsWaiting = exports.selectInspections = exports.fullInspSelector = exports.selectMergedValidation = exports.selectFullInspectionConditions = exports.hasValidationIssues = exports.selectNotesIsWaiting = exports.selectFullInspectionIsWaiting = exports.selectNotes = exports.selectFullInspection = exports.selectAssetRiskHistory = exports.selectAssetRiskHistoryIsReady = exports.selectAssetRiskIsWaiting = exports.selectAssetRisk = exports.selectAssetRiskIsReady = exports.selectAssetRiskIsRejected = exports.selectAssetManhole = exports.selectAssetPipeAsset = exports.selectAssetPipe = exports.useSelectAssetLocationIsWaiting = exports.useSelectAssetLocation = exports.selectValidatingAssets = exports.selectValidAssetIds = exports.selectDetailSelectedMapIds = exports.selectAssetDetailNotesIsWaiting = exports.selectAssetDetailIsWaiting = exports.selectAssetDetailType = exports.selectAssetDetailId = exports.selectIsAssetCountsReady = exports.selectAssetCounts = exports.selectAssetDetailDetail = exports.selectAssetDetail = exports.selectRiskConfigsListIsLoading = exports.selectRiskConfigsList = exports.selectRiskConfigsPagination = exports.selectRiskConfigsPerPage = exports.selectRiskConfigsIsLoading = exports.selectRiskConfigsIsWaiting = exports.selectRiskConfigsStatus = exports.selectRiskConfigsPage = void 0;
exports.selectChartIsLoading = exports.selectCharts = exports.useSelectConfigurationIsLoading = exports.useSelectConfigurationDetails = exports.useSelectConfiguration = exports.typeFiltersSelector = exports.gradeFiltersSelector = exports.stepOnlySelector = exports.continuousOnlySelector = exports.jointOnlySelector = exports.observationStoreSelector = exports.observationSelector = exports.selectTypeFilters = exports.selectGradeFilters = exports.selectStepOnly = exports.selectObservations = exports.selectJointOnly = exports.selectContinuousOnly = exports.selectUserInitial = exports.selectUserContext = exports.selectMapRehabLayers = exports.riskLayersSelector = exports.useSelectRiskLayers = exports.useSelectMapInsertSpatial = exports.mapInsertSpatialSelector = exports.useSelectMapInsertAsset = exports.mapInsertAssetSelector = exports.useSelectMapInsertInspection = exports.getTenant = exports.getMapHiddenLayers = void 0;
var observations_selectors_1 = __webpack_require__(/*! ./observations.selectors */ "./selectors/observations.selectors.ts");
Object.defineProperty(exports, "continuousOnlySelector", ({ enumerable: true, get: function () { return observations_selectors_1.continuousOnlySelector; } }));
Object.defineProperty(exports, "gradeFiltersSelector", ({ enumerable: true, get: function () { return observations_selectors_1.gradeFiltersSelector; } }));
Object.defineProperty(exports, "jointOnlySelector", ({ enumerable: true, get: function () { return observations_selectors_1.jointOnlySelector; } }));
Object.defineProperty(exports, "observationSelector", ({ enumerable: true, get: function () { return observations_selectors_1.observationSelector; } }));
Object.defineProperty(exports, "observationStoreSelector", ({ enumerable: true, get: function () { return observations_selectors_1.observationStoreSelector; } }));
Object.defineProperty(exports, "selectContinuousOnly", ({ enumerable: true, get: function () { return observations_selectors_1.selectContinuousOnly; } }));
Object.defineProperty(exports, "selectGradeFilters", ({ enumerable: true, get: function () { return observations_selectors_1.selectGradeFilters; } }));
Object.defineProperty(exports, "selectJointOnly", ({ enumerable: true, get: function () { return observations_selectors_1.selectJointOnly; } }));
Object.defineProperty(exports, "selectObservations", ({ enumerable: true, get: function () { return observations_selectors_1.selectObservations; } }));
Object.defineProperty(exports, "selectStepOnly", ({ enumerable: true, get: function () { return observations_selectors_1.selectStepOnly; } }));
Object.defineProperty(exports, "selectTypeFilters", ({ enumerable: true, get: function () { return observations_selectors_1.selectTypeFilters; } }));
Object.defineProperty(exports, "stepOnlySelector", ({ enumerable: true, get: function () { return observations_selectors_1.stepOnlySelector; } }));
Object.defineProperty(exports, "typeFiltersSelector", ({ enumerable: true, get: function () { return observations_selectors_1.typeFiltersSelector; } }));
var fullInspection_selectors_1 = __webpack_require__(/*! ./fullInspection.selectors */ "./selectors/fullInspection.selectors.ts");
Object.defineProperty(exports, "fullInspSelector", ({ enumerable: true, get: function () { return fullInspection_selectors_1.fullInspSelector; } }));
Object.defineProperty(exports, "hasValidationIssues", ({ enumerable: true, get: function () { return fullInspection_selectors_1.hasValidationIssues; } }));
Object.defineProperty(exports, "selectFullInspection", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectFullInspection; } }));
Object.defineProperty(exports, "selectFullInspectionConditions", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectFullInspectionConditions; } }));
Object.defineProperty(exports, "selectFullInspectionIsWaiting", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectFullInspectionIsWaiting; } }));
Object.defineProperty(exports, "selectMergedValidation", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectMergedValidation; } }));
Object.defineProperty(exports, "selectNotes", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectNotes; } }));
Object.defineProperty(exports, "selectNotesIsWaiting", ({ enumerable: true, get: function () { return fullInspection_selectors_1.selectNotesIsWaiting; } }));
var inspection_selectors_1 = __webpack_require__(/*! ./inspection.selectors */ "./selectors/inspection.selectors.ts");
Object.defineProperty(exports, "selectInspections", ({ enumerable: true, get: function () { return inspection_selectors_1.selectInspections; } }));
Object.defineProperty(exports, "selectInspectionsIsWaiting", ({ enumerable: true, get: function () { return inspection_selectors_1.selectInspectionsIsWaiting; } }));
Object.defineProperty(exports, "selectCreatingInspection", ({ enumerable: true, get: function () { return inspection_selectors_1.selectCreatingInspection; } }));
var map_selectors_1 = __webpack_require__(/*! ./map.selectors */ "./selectors/map.selectors.ts");
Object.defineProperty(exports, "getMapBackground", ({ enumerable: true, get: function () { return map_selectors_1.getMapBackground; } }));
Object.defineProperty(exports, "getMapHiddenLayers", ({ enumerable: true, get: function () { return map_selectors_1.getMapHiddenLayers; } }));
Object.defineProperty(exports, "getMapPosition", ({ enumerable: true, get: function () { return map_selectors_1.getMapPosition; } }));
Object.defineProperty(exports, "getMapSelected", ({ enumerable: true, get: function () { return map_selectors_1.getMapSelected; } }));
Object.defineProperty(exports, "getMapSelectedIds", ({ enumerable: true, get: function () { return map_selectors_1.getMapSelectedIds; } }));
Object.defineProperty(exports, "getMapSelectedPosition", ({ enumerable: true, get: function () { return map_selectors_1.getMapSelectedPosition; } }));
Object.defineProperty(exports, "getTenant", ({ enumerable: true, get: function () { return map_selectors_1.getTenant; } }));
Object.defineProperty(exports, "mapInsertAssetSelector", ({ enumerable: true, get: function () { return map_selectors_1.mapInsertAssetSelector; } }));
Object.defineProperty(exports, "mapInsertSpatialSelector", ({ enumerable: true, get: function () { return map_selectors_1.mapInsertSpatialSelector; } }));
Object.defineProperty(exports, "riskLayersSelector", ({ enumerable: true, get: function () { return map_selectors_1.riskLayersSelector; } }));
Object.defineProperty(exports, "selectMapInsertAsset", ({ enumerable: true, get: function () { return map_selectors_1.selectMapInsertAsset; } }));
Object.defineProperty(exports, "selectMapInsertInspection", ({ enumerable: true, get: function () { return map_selectors_1.selectMapInsertInspection; } }));
Object.defineProperty(exports, "selectMapInsertSpatial", ({ enumerable: true, get: function () { return map_selectors_1.selectMapInsertSpatial; } }));
Object.defineProperty(exports, "selectMapRehabLayers", ({ enumerable: true, get: function () { return map_selectors_1.selectMapRehabLayers; } }));
Object.defineProperty(exports, "selectRiskLayers", ({ enumerable: true, get: function () { return map_selectors_1.selectRiskLayers; } }));
Object.defineProperty(exports, "useSelectMapInsertAsset", ({ enumerable: true, get: function () { return map_selectors_1.useSelectMapInsertAsset; } }));
Object.defineProperty(exports, "useSelectMapInsertInspection", ({ enumerable: true, get: function () { return map_selectors_1.useSelectMapInsertInspection; } }));
Object.defineProperty(exports, "useSelectMapInsertSpatial", ({ enumerable: true, get: function () { return map_selectors_1.useSelectMapInsertSpatial; } }));
Object.defineProperty(exports, "useSelectRiskLayers", ({ enumerable: true, get: function () { return map_selectors_1.useSelectRiskLayers; } }));
var assetDetail_selectors_1 = __webpack_require__(/*! ./assetDetail.selectors */ "./selectors/assetDetail.selectors.ts");
Object.defineProperty(exports, "selectAssetCounts", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetCounts; } }));
Object.defineProperty(exports, "selectIsAssetCountsReady", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectIsAssetCountsReady; } }));
Object.defineProperty(exports, "selectAssetDetail", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetail; } }));
Object.defineProperty(exports, "selectAssetDetailDetail", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetailDetail; } }));
Object.defineProperty(exports, "selectAssetDetailId", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetailId; } }));
Object.defineProperty(exports, "selectAssetDetailIsWaiting", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetailIsWaiting; } }));
Object.defineProperty(exports, "selectAssetDetailNotesIsWaiting", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetailNotesIsWaiting; } }));
Object.defineProperty(exports, "selectAssetDetailType", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectAssetDetailType; } }));
Object.defineProperty(exports, "selectDetailSelectedMapIds", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectDetailSelectedMapIds; } }));
Object.defineProperty(exports, "selectValidAssetIds", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectValidAssetIds; } }));
Object.defineProperty(exports, "selectValidatingAssets", ({ enumerable: true, get: function () { return assetDetail_selectors_1.selectValidatingAssets; } }));
Object.defineProperty(exports, "useSelectAssetLocation", ({ enumerable: true, get: function () { return assetDetail_selectors_1.useSelectAssetLocation; } }));
Object.defineProperty(exports, "useSelectAssetLocationIsWaiting", ({ enumerable: true, get: function () { return assetDetail_selectors_1.useSelectAssetLocationIsWaiting; } }));
var assetPipe_selectors_1 = __webpack_require__(/*! ./assetPipe.selectors */ "./selectors/assetPipe.selectors.ts");
Object.defineProperty(exports, "selectAssetPipe", ({ enumerable: true, get: function () { return assetPipe_selectors_1.selectAssetPipe; } }));
Object.defineProperty(exports, "selectAssetPipeAsset", ({ enumerable: true, get: function () { return assetPipe_selectors_1.selectAssetPipeAsset; } }));
var assetRisk_selectors_1 = __webpack_require__(/*! ./assetRisk.selectors */ "./selectors/assetRisk.selectors.ts");
Object.defineProperty(exports, "selectAssetRisk", ({ enumerable: true, get: function () { return assetRisk_selectors_1.selectAssetRisk; } }));
Object.defineProperty(exports, "selectAssetRiskIsReady", ({ enumerable: true, get: function () { return assetRisk_selectors_1.selectAssetRiskIsReady; } }));
Object.defineProperty(exports, "selectAssetRiskIsRejected", ({ enumerable: true, get: function () { return assetRisk_selectors_1.selectAssetRiskIsRejected; } }));
Object.defineProperty(exports, "selectAssetRiskIsWaiting", ({ enumerable: true, get: function () { return assetRisk_selectors_1.selectAssetRiskIsWaiting; } }));
var assetRiskHistory_selectors_1 = __webpack_require__(/*! ./assetRiskHistory.selectors */ "./selectors/assetRiskHistory.selectors.ts");
Object.defineProperty(exports, "selectAssetRiskHistory", ({ enumerable: true, get: function () { return assetRiskHistory_selectors_1.selectAssetRiskHistory; } }));
Object.defineProperty(exports, "selectAssetRiskHistoryIsReady", ({ enumerable: true, get: function () { return assetRiskHistory_selectors_1.selectAssetRiskHistoryIsReady; } }));
var charts_selectors_1 = __webpack_require__(/*! ./charts.selectors */ "./selectors/charts.selectors.ts");
Object.defineProperty(exports, "selectChartIsLoading", ({ enumerable: true, get: function () { return charts_selectors_1.selectChartIsLoading; } }));
Object.defineProperty(exports, "selectCharts", ({ enumerable: true, get: function () { return charts_selectors_1.selectCharts; } }));
var riskConfigs_selectors_1 = __webpack_require__(/*! ./riskConfigs.selectors */ "./selectors/riskConfigs.selectors.ts");
Object.defineProperty(exports, "selectRiskConfigsIsLoading", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsIsLoading; } }));
Object.defineProperty(exports, "selectRiskConfigsIsWaiting", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsIsWaiting; } }));
Object.defineProperty(exports, "selectRiskConfigsPage", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsPage; } }));
Object.defineProperty(exports, "selectRiskConfigsPagination", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsPagination; } }));
Object.defineProperty(exports, "selectRiskConfigsPerPage", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsPerPage; } }));
Object.defineProperty(exports, "selectRiskConfigsStatus", ({ enumerable: true, get: function () { return riskConfigs_selectors_1.selectRiskConfigsStatus; } }));
var riskConfigsList_selectors_1 = __webpack_require__(/*! ./riskConfigsList.selectors */ "./selectors/riskConfigsList.selectors.ts");
Object.defineProperty(exports, "selectRiskConfigsList", ({ enumerable: true, get: function () { return riskConfigsList_selectors_1.selectRiskConfigsList; } }));
Object.defineProperty(exports, "selectRiskConfigsListIsLoading", ({ enumerable: true, get: function () { return riskConfigsList_selectors_1.selectRiskConfigsListIsLoading; } }));
var user_selectors_1 = __webpack_require__(/*! ./user.selectors */ "./selectors/user.selectors.ts");
Object.defineProperty(exports, "selectUserContext", ({ enumerable: true, get: function () { return user_selectors_1.selectUserContext; } }));
Object.defineProperty(exports, "selectUserInitial", ({ enumerable: true, get: function () { return user_selectors_1.selectUserInitial; } }));
var configuration_selectors_1 = __webpack_require__(/*! ./configuration.selectors */ "./selectors/configuration.selectors.ts");
Object.defineProperty(exports, "useSelectConfiguration", ({ enumerable: true, get: function () { return configuration_selectors_1.useSelectConfiguration; } }));
Object.defineProperty(exports, "useSelectConfigurationDetails", ({ enumerable: true, get: function () { return configuration_selectors_1.useSelectConfigurationDetails; } }));
Object.defineProperty(exports, "useSelectConfigurationIsLoading", ({ enumerable: true, get: function () { return configuration_selectors_1.useSelectConfigurationIsLoading; } }));
var assetManhole_selectors_1 = __importDefault(__webpack_require__(/*! ./assetManhole.selectors */ "./selectors/assetManhole.selectors.ts"));
exports.selectAssetManhole = assetManhole_selectors_1.default;
exports["default"] = {
    selectAssetDetail: assetDetail_selectors_1.selectAssetDetail,
    selectAssetDetailDetail: assetDetail_selectors_1.selectAssetDetailDetail,
    selectAssetDetailId: assetDetail_selectors_1.selectAssetDetailId,
    selectAssetDetailType: assetDetail_selectors_1.selectAssetDetailType,
    selectAssetDetailIsWaiting: assetDetail_selectors_1.selectAssetDetailIsWaiting,
    selectAssetDetailNotesIsWaiting: assetDetail_selectors_1.selectAssetDetailNotesIsWaiting,
    selectValidAssetIds: assetDetail_selectors_1.selectValidAssetIds,
    selectValidatingAssets: assetDetail_selectors_1.selectValidatingAssets,
    selectDetailSelectedMapIds: assetDetail_selectors_1.selectDetailSelectedMapIds,
    selectAssetPipe: assetPipe_selectors_1.selectAssetPipe,
    selectAssetPipeAsset: assetPipe_selectors_1.selectAssetPipeAsset,
    selectAssetManhole: assetManhole_selectors_1.default,
    selectAssetRiskIsRejected: assetRisk_selectors_1.selectAssetRiskIsRejected,
    selectAssetRiskIsReady: assetRisk_selectors_1.selectAssetRiskIsReady,
    selectAssetRisk: assetRisk_selectors_1.selectAssetRisk,
    selectAssetRiskHistoryIsReady: assetRiskHistory_selectors_1.selectAssetRiskHistoryIsReady,
    selectAssetRiskHistory: assetRiskHistory_selectors_1.selectAssetRiskHistory,
    selectFullInspection: fullInspection_selectors_1.selectFullInspection,
    selectNotes: fullInspection_selectors_1.selectNotes,
    selectFullInspectionIsWaiting: fullInspection_selectors_1.selectFullInspectionIsWaiting,
    selectNotesIsWaiting: fullInspection_selectors_1.selectNotesIsWaiting,
    hasValidationIssues: fullInspection_selectors_1.hasValidationIssues,
    selectFullInspectionConditions: fullInspection_selectors_1.selectFullInspectionConditions,
    selectMergedValidation: fullInspection_selectors_1.selectMergedValidation,
    selectInspections: inspection_selectors_1.selectInspections,
    selectInspectionsIsWaiting: inspection_selectors_1.selectInspectionsIsWaiting,
    getMapPosition: map_selectors_1.getMapPosition,
    getMapBackground: map_selectors_1.getMapBackground,
    getMapSelected: map_selectors_1.getMapSelected,
    getMapSelectedIds: map_selectors_1.getMapSelectedIds,
    getMapSelectedPosition: map_selectors_1.getMapSelectedPosition,
    getMapHiddenLayers: map_selectors_1.getMapHiddenLayers,
    getTenant: map_selectors_1.getTenant,
    selectMapInsertInspection: map_selectors_1.selectMapInsertInspection,
    mapInsertAssetSelector: map_selectors_1.mapInsertAssetSelector,
    selectMapInsertAsset: map_selectors_1.selectMapInsertAsset,
    mapInsertSpatialSelector: map_selectors_1.mapInsertSpatialSelector,
    selectMapInsertSpatial: map_selectors_1.selectMapInsertSpatial,
    selectUserContext: user_selectors_1.selectUserContext,
    selectUserInitial: user_selectors_1.selectUserInitial,
    selectContinuousOnly: observations_selectors_1.selectContinuousOnly,
    selectJointOnly: observations_selectors_1.selectJointOnly,
    selectObservations: observations_selectors_1.selectObservations,
    selectStepOnly: observations_selectors_1.selectStepOnly,
    selectGradeFilters: observations_selectors_1.selectGradeFilters,
    selectTypeFilters: observations_selectors_1.selectTypeFilters,
    observationSelector: observations_selectors_1.observationSelector,
    observationStoreSelector: observations_selectors_1.observationStoreSelector,
    jointOnlySelector: observations_selectors_1.jointOnlySelector,
    continuousOnlySelector: observations_selectors_1.continuousOnlySelector,
    stepOnlySelector: observations_selectors_1.stepOnlySelector,
    gradeFiltersSelector: observations_selectors_1.gradeFiltersSelector,
    typeFiltersSelector: observations_selectors_1.typeFiltersSelector,
    selectRiskLayers: map_selectors_1.selectRiskLayers,
    riskLayersSelector: map_selectors_1.riskLayersSelector,
    useSelectMapInsertInspection: map_selectors_1.useSelectMapInsertInspection,
    useSelectMapInsertAsset: map_selectors_1.useSelectMapInsertAsset,
    useSelectMapInsertSpatial: map_selectors_1.useSelectMapInsertSpatial,
    useSelectRiskLayers: map_selectors_1.useSelectRiskLayers,
    useSelectConfiguration: configuration_selectors_1.useSelectConfiguration,
    useSelectConfigurationDetails: configuration_selectors_1.useSelectConfigurationDetails,
    useSelectConfigurationIsLoading: configuration_selectors_1.useSelectConfigurationIsLoading,
    selectMapRehabLayers: map_selectors_1.selectMapRehabLayers,
    useSelectAssetLocation: assetDetail_selectors_1.useSelectAssetLocation,
    useSelectAssetLocationIsWaiting: assetDetail_selectors_1.useSelectAssetLocationIsWaiting,
};


/***/ }),

/***/ "./selectors/inspection.selectors.ts":
/*!*******************************************!*\
  !*** ./selectors/inspection.selectors.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectCreatingInspection = exports.selectCreateInspectionId = exports.selectInspectionsIsWaiting = exports.selectInspections = exports.CreatingInspectionSelector = exports.CreateInspectionIdSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var inspectionsSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.inspections; });
var inspectionsIsWaitingSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.inspections) === null || _a === void 0 ? void 0 : _a.isWaiting; });
exports.CreateInspectionIdSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.inspections) === null || _a === void 0 ? void 0 : _a.createInspectionId; });
exports.CreatingInspectionSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { var _a; return (_a = state.inspections) === null || _a === void 0 ? void 0 : _a.creatingInspection; });
var selectInspections = function () { return (0, react_redux_1.useSelector)(inspectionsSelector); };
exports.selectInspections = selectInspections;
var selectInspectionsIsWaiting = function () {
    return (0, react_redux_1.useSelector)(inspectionsIsWaitingSelector);
};
exports.selectInspectionsIsWaiting = selectInspectionsIsWaiting;
var selectCreateInspectionId = function () {
    return (0, react_redux_1.useSelector)(exports.CreateInspectionIdSelector);
};
exports.selectCreateInspectionId = selectCreateInspectionId;
var selectCreatingInspection = function () {
    return (0, react_redux_1.useSelector)(exports.CreatingInspectionSelector);
};
exports.selectCreatingInspection = selectCreatingInspection;
exports["default"] = {
    selectInspectionsIsWaiting: exports.selectInspectionsIsWaiting,
    selectInspections: exports.selectInspections,
    selectCreateInspectionId: exports.selectCreateInspectionId,
    selectCreatingInspection: exports.selectCreatingInspection,
};


/***/ }),

/***/ "./selectors/map.selectors.ts":
/*!************************************!*\
  !*** ./selectors/map.selectors.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMapInsertSpatial = exports.useSelectMapInsertSpatial = exports.mapInsertSpatialSelector = exports.selectMapInsertAsset = exports.useSelectMapInsertAsset = exports.mapInsertAssetSelector = exports.selectMapInsertInspection = exports.useSelectMapInsertInspection = exports.mapInsertInspectionSelector = exports.selectRiskLayers = exports.useSelectRiskLayers = exports.riskLayersSelector = exports.selectMapRehabLayers = exports.getMapHiddenLayers = exports.getMapSelectedPosition = exports.getMapSelectedIds = exports.getMapSelected = exports.getMapBackground = exports.getMapPosition = exports.getTenant = void 0;
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var map_reducer_1 = __webpack_require__(/*! ../reducers/map.reducer */ "./reducers/map.reducer.ts");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var getTenant = function (state) {
    return state.userContext.defaultSite;
};
exports.getTenant = getTenant;
var mapSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.map; });
var mapMain = (0, toolkit_1.createSelector)([mapSelector, exports.getTenant], function (base, tenantId) {
    if (tenantId && base.main.byTenant && base.main.byTenant[tenantId]) {
        return base.main.byTenant[tenantId];
    }
    return base.main;
});
exports.getMapPosition = (0, toolkit_1.createSelector)(mapMain, function (main) { return main.position; });
exports.getMapBackground = (0, toolkit_1.createSelector)(mapMain, function (main) { return main.background; });
exports.getMapSelected = (0, toolkit_1.createSelector)(mapMain, function (main) { return main.selected; });
exports.getMapSelectedIds = (0, toolkit_1.createSelector)(mapSelector, function (baseState) {
    return (0, _Utils_1.selectedAssets)(baseState.main.selected);
});
var getMapSelectedPosition = function (zoom) {
    return (0, toolkit_1.createSelector)(exports.getMapSelected, function (selected) {
        return (0, _Utils_1.selectedPosition)(selected, zoom);
    });
};
exports.getMapSelectedPosition = getMapSelectedPosition;
exports.getMapHiddenLayers = (0, toolkit_1.createSelector)(mapMain, function (main) { return main.hiddenLayers; });
var riskLayers = (0, toolkit_1.createSelector)(mapSelector, function (base) { var _a, _b; return (_b = (_a = base.risk) === null || _a === void 0 ? void 0 : _a.layers) !== null && _b !== void 0 ? _b : []; });
exports.selectMapRehabLayers = (0, toolkit_1.createSelector)(mapSelector, function (base) { var _a, _b; return (_b = (_a = base.rehab) === null || _a === void 0 ? void 0 : _a.layers) !== null && _b !== void 0 ? _b : []; });
var showRiskLayer = function (mask, value) {
    if (mask !== undefined) {
        // Should match RiskConfigPublishState in saas_risk_management
        switch (value) {
            case 'published':
                return ((mask & _Types_1.RiskLayersMask.Published) ===
                    _Types_1.RiskLayersMask.Published);
            case 'unpublished':
                return ((mask & _Types_1.RiskLayersMask.Unpublished) ===
                    _Types_1.RiskLayersMask.Unpublished);
        }
    }
    return false;
};
var riskLayersSelector = function (mask) {
    return (0, toolkit_1.createSelector)(riskLayers, function (riskLayers) {
        return riskLayers.filter(function (x) {
            return showRiskLayer(mask, x.publishState);
        });
    });
};
exports.riskLayersSelector = riskLayersSelector;
var useSelectRiskLayers = function (mask) {
    return (0, react_redux_1.useSelector)((0, exports.riskLayersSelector)(mask));
};
exports.useSelectRiskLayers = useSelectRiskLayers;
var selectRiskLayers = function (mask) {
    var data = (0, exports.useSelectRiskLayers)(mask);
    (0, react_1.useEffect)(function () {
        console.warn('Deprecated', 'Due to the rules of hooks we should call hooks with `use` prefix', 'use useSelectRiskLayers instead of selectRiskLayers');
    }, []);
    return data;
};
exports.selectRiskLayers = selectRiskLayers;
var mapInspection = (0, toolkit_1.createSelector)(mapSelector, function (base) { return base.inspectionInsert; });
var mapInspectionInsert = (0, toolkit_1.createSelector)(mapInspection, function (base) { var _a; return (_a = base.insert) !== null && _a !== void 0 ? _a : []; });
var sourceLayersFixedLocation = function (token, insert) { return (__assign(__assign({}, insert), { sources: insert ? (0, _Utils_1.dataServices)(token, insert.options, insert.location) : [], layers: insert ? (0, _Utils_1.configLayers)(token, insert.options) : [] })); };
var mapInsertInspectionSelector = function (token) {
    return (0, toolkit_1.createSelector)(mapInspectionInsert, function (insert) {
        return sourceLayersFixedLocation(token, insert);
    });
};
exports.mapInsertInspectionSelector = mapInsertInspectionSelector;
var useSelectMapInsertInspection = function (token) { return (0, react_redux_1.useSelector)((0, exports.mapInsertInspectionSelector)(token)); };
exports.useSelectMapInsertInspection = useSelectMapInsertInspection;
var selectMapInsertInspection = function (token) {
    var data = (0, exports.useSelectMapInsertInspection)(token);
    (0, react_1.useEffect)(function () {
        console.warn('Deprecated', 'Due to the rules of hooks we should call hooks with `use` prefix', 'use useSelectMapInsertInspection instead of selectMapInsertInspection');
    }, []);
    return data;
};
exports.selectMapInsertInspection = selectMapInsertInspection;
var mapAsset = (0, toolkit_1.createSelector)(mapSelector, function (base) { var _a; return (_a = base.assetInsert) !== null && _a !== void 0 ? _a : []; });
var mapAssetInsert = (0, toolkit_1.createSelector)(mapAsset, function (base) { return base.insert; });
var mapInsertAssetSelector = function (token) {
    return (0, toolkit_1.createSelector)(mapAssetInsert, function (insert) {
        return sourceLayersFixedLocation(token, insert);
    });
};
exports.mapInsertAssetSelector = mapInsertAssetSelector;
var useSelectMapInsertAsset = function (token) {
    return (0, react_redux_1.useSelector)((0, exports.mapInsertAssetSelector)(token));
};
exports.useSelectMapInsertAsset = useSelectMapInsertAsset;
var selectMapInsertAsset = function (token) {
    var data = (0, exports.useSelectMapInsertAsset)(token);
    (0, react_1.useEffect)(function () {
        console.warn('Deprecated', 'Due to the rules of hooks we should call hooks with `use` prefix', 'use useSelectMapInsertAsset instead of selectMapInsertAsset');
    }, []);
    return data;
};
exports.selectMapInsertAsset = selectMapInsertAsset;
var mapSpatials = (0, toolkit_1.createSelector)(mapSelector, function (base) { return base.spatialInserts; });
var sourceLayersSpatialLocation = function (token, layerName, inserts, showSystemTypeLayers) {
    if (showSystemTypeLayers === void 0) { showSystemTypeLayers = false; }
    var spatial = inserts.find(function (f) { return f.layer.LAYER_NAME.toLowerCase() === layerName.toLowerCase(); });
    if (!spatial) {
        return __assign({}, map_reducer_1.mapInsertInitial);
    }
    var options = __assign({}, spatial.insert.options);
    if (showSystemTypeLayers) {
        options.tilesSource = __assign({}, _Utils_1.tileOptions);
        options.tilesSourceHide = false;
    }
    return __assign(__assign({}, spatial.insert), { sources: (0, _Utils_1.dataServices)(token, options, spatial.insert.location), layers: (0, _Utils_1.configLayers)(token, options, [spatial.layer]) });
};
var mapInsertSpatialSelector = function (token, layerName, showSystemTypeLayers) {
    if (showSystemTypeLayers === void 0) { showSystemTypeLayers = false; }
    return (0, toolkit_1.createSelector)(mapSpatials, function (mapSpatials) {
        return sourceLayersSpatialLocation(token, layerName, mapSpatials, showSystemTypeLayers);
    });
};
exports.mapInsertSpatialSelector = mapInsertSpatialSelector;
var useSelectMapInsertSpatial = function (token, layerName, showSystemTypeLayers) {
    if (showSystemTypeLayers === void 0) { showSystemTypeLayers = false; }
    return (0, react_redux_1.useSelector)((0, exports.mapInsertSpatialSelector)(token, layerName, showSystemTypeLayers));
};
exports.useSelectMapInsertSpatial = useSelectMapInsertSpatial;
var selectMapInsertSpatial = function (token, layerName, showSystemTypeLayers) {
    if (showSystemTypeLayers === void 0) { showSystemTypeLayers = false; }
    var data = (0, exports.useSelectMapInsertSpatial)(token, layerName, showSystemTypeLayers);
    (0, react_1.useEffect)(function () {
        console.warn('Deprecated', 'Due to the rules of hooks we should call hooks with `use` prefix', 'use useSelectMapInsertSpatial instead of selectMapInsertSpatial');
    }, []);
    return data;
};
exports.selectMapInsertSpatial = selectMapInsertSpatial;
exports["default"] = {
    useSelectMapInsertSpatial: exports.useSelectMapInsertSpatial,
    useSelectRiskLayers: exports.useSelectRiskLayers,
    useSelectMapInsertInspection: exports.useSelectMapInsertInspection,
    useSelectMapInsertAsset: exports.useSelectMapInsertAsset,
    getMapPosition: exports.getMapPosition,
    getMapBackground: exports.getMapBackground,
    getMapSelected: exports.getMapSelected,
    getMapSelectedIds: exports.getMapSelectedIds,
    getMapSelectedPosition: exports.getMapSelectedPosition,
    getMapHiddenLayers: exports.getMapHiddenLayers,
    mapInsertInspectionSelector: exports.mapInsertInspectionSelector,
    selectMapInsertInspection: exports.selectMapInsertInspection,
    mapInsertAssetSelector: exports.mapInsertAssetSelector,
    selectMapInsertAsset: exports.selectMapInsertAsset,
    mapInsertSpatialSelector: exports.mapInsertSpatialSelector,
    selectMapInsertSpatial: exports.selectMapInsertSpatial,
    selectRiskLayers: exports.selectRiskLayers,
    riskLayersSelector: exports.riskLayersSelector,
    selectMapRehabLayers: exports.selectMapRehabLayers,
};


/***/ }),

/***/ "./selectors/observations.selectors.ts":
/*!*********************************************!*\
  !*** ./selectors/observations.selectors.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectTypeFilters = exports.selectGradeFilters = exports.selectContinuousOnly = exports.selectStepOnly = exports.selectJointOnly = exports.selectObservations = exports.typeFiltersSelector = exports.gradeFiltersSelector = exports.continuousOnlySelector = exports.stepOnlySelector = exports.jointOnlySelector = exports.observationSelector = exports.observationStoreSelector = void 0;
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.observationStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.observations; });
var observationSelector = function (standard) {
    return (0, toolkit_1.createSelector)(parseNamespace, function (state) {
        if (state.observations && state.observations.observations) {
            return state.observations.observations
                .filter(function (observation) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                var obs = observation;
                if (state.observations.continuousOnly &&
                    !((_a = obs.continuous) === null || _a === void 0 ? void 0 : _a.toUpperCase().startsWith('S')) &&
                    !((_b = obs.continuous) === null || _b === void 0 ? void 0 : _b.toUpperCase().startsWith('F')))
                    return false;
                if (state.observations.jointOnly && !obs.joint)
                    return false;
                if (state.observations.gradeFilters &&
                    state.observations.gradeFilters.length !== 0) {
                    switch (standard) {
                        case _Types_1.InspectionStandard.WSA05:
                            {
                                var wsaObs = observation;
                                var wsaResult = false;
                                if (((_c = state.observations.typeFilters) === null || _c === void 0 ? void 0 : _c.length) == 0 ||
                                    ((_d = state.observations.typeFilters) === null || _d === void 0 ? void 0 : _d.includes(_Types_1.FilterObservationGradeType.Struct))) {
                                    if (wsaObs.structuralScore !==
                                        undefined &&
                                        state.observations.gradeFilters.includes(wsaObs.structuralScore.toString()))
                                        wsaResult = true;
                                }
                                if (!wsaResult &&
                                    (((_e = state.observations.typeFilters) === null || _e === void 0 ? void 0 : _e.length) == 0 ||
                                        ((_f = state.observations.typeFilters) === null || _f === void 0 ? void 0 : _f.includes(_Types_1.FilterObservationGradeType.Service)))) {
                                    if (wsaObs.serviceScore !== undefined &&
                                        state.observations.gradeFilters.includes(wsaObs.serviceScore.toString()))
                                        wsaResult = true;
                                }
                                if (!wsaResult)
                                    return false;
                            }
                            break;
                        case _Types_1.InspectionStandard.MSCC:
                            {
                                var msccObs = observation;
                                var msccResult = false;
                                if (((_g = state.observations.typeFilters) === null || _g === void 0 ? void 0 : _g.length) == 0 ||
                                    ((_h = state.observations.typeFilters) === null || _h === void 0 ? void 0 : _h.includes(_Types_1.FilterObservationGradeType.Struct))) {
                                    if (msccObs.structuralScore !==
                                        undefined) {
                                        if (state.observations.gradeFilters.includes('1') &&
                                            msccObs.structuralScore < 10)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('2') &&
                                            msccObs.structuralScore >= 10 &&
                                            msccObs.structuralScore <= 39)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('3') &&
                                            msccObs.structuralScore >= 40 &&
                                            msccObs.structuralScore <= 79)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('4') &&
                                            msccObs.structuralScore >= 80 &&
                                            msccObs.structuralScore <= 164)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('5') &&
                                            msccObs.structuralScore >= 165)
                                            msccResult = true;
                                    }
                                }
                                if (!msccResult &&
                                    (((_j = state.observations.typeFilters) === null || _j === void 0 ? void 0 : _j.length) == 0 ||
                                        ((_k = state.observations.typeFilters) === null || _k === void 0 ? void 0 : _k.includes(_Types_1.FilterObservationGradeType.Service)))) {
                                    if (msccObs.serviceScore !== undefined) {
                                        if (state.observations.gradeFilters.includes('1') &&
                                            msccObs.serviceScore < 1)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('2') &&
                                            msccObs.serviceScore >= 1 &&
                                            msccObs.serviceScore <= 1.9)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('3') &&
                                            msccObs.serviceScore >= 2 &&
                                            msccObs.serviceScore <= 4.9)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('4') &&
                                            msccObs.serviceScore >= 5 &&
                                            msccObs.serviceScore <= 9.9)
                                            msccResult = true;
                                        if (!msccResult &&
                                            state.observations.gradeFilters.includes('5') &&
                                            msccObs.serviceScore >= 10)
                                            msccResult = true;
                                    }
                                }
                                if (!msccResult)
                                    return false;
                            }
                            break;
                        case _Types_1.InspectionStandard.MACP:
                            {
                                var macpObs = observation;
                                if (state.observations.stepOnly &&
                                    !macpObs.step)
                                    return false;
                                var macpResult = false;
                                if (((_l = state.observations.typeFilters) === null || _l === void 0 ? void 0 : _l.length) == 0 ||
                                    ((_m = state.observations.typeFilters) === null || _m === void 0 ? void 0 : _m.includes(_Types_1.FilterObservationGradeType.Struct))) {
                                    if (macpObs.structuralScore !==
                                        undefined &&
                                        state.observations.gradeFilters.includes(macpObs.structuralScore.toString()))
                                        macpResult = true;
                                }
                                if (!macpResult &&
                                    (((_o = state.observations.typeFilters) === null || _o === void 0 ? void 0 : _o.length) == 0 ||
                                        ((_p = state.observations.typeFilters) === null || _p === void 0 ? void 0 : _p.includes(_Types_1.FilterObservationGradeType.OM)))) {
                                    if (macpObs.serviceScore !==
                                        undefined &&
                                        state.observations.gradeFilters.includes(macpObs.serviceScore.toString()))
                                        macpResult = true;
                                }
                                if (!macpResult)
                                    return false;
                            }
                            break;
                        case _Types_1.InspectionStandard.PACP:
                        default:
                            {
                                var pacpObs = observation;
                                var pacpResult = false;
                                if (((_q = state.observations.typeFilters) === null || _q === void 0 ? void 0 : _q.length) == 0 ||
                                    ((_r = state.observations.typeFilters) === null || _r === void 0 ? void 0 : _r.includes(_Types_1.FilterObservationGradeType.Struct))) {
                                    if (pacpObs.structuralScore !==
                                        undefined &&
                                        state.observations.gradeFilters.includes(pacpObs.structuralScore.toString()))
                                        pacpResult = true;
                                }
                                if (!pacpResult &&
                                    (((_s = state.observations.typeFilters) === null || _s === void 0 ? void 0 : _s.length) == 0 ||
                                        ((_t = state.observations.typeFilters) === null || _t === void 0 ? void 0 : _t.includes(_Types_1.FilterObservationGradeType.OM)))) {
                                    if (pacpObs.serviceScore !==
                                        undefined &&
                                        state.observations.gradeFilters.includes(pacpObs.serviceScore.toString()))
                                        pacpResult = true;
                                }
                                if (!pacpResult)
                                    return false;
                            }
                            break;
                    }
                }
                return true;
            })
                .sort(function (a, b) {
                return a.distance - b.distance;
            });
        }
        else {
            return [];
        }
    });
};
exports.observationSelector = observationSelector;
exports.jointOnlySelector = (0, toolkit_1.createSelector)(exports.observationStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.jointOnly; });
exports.stepOnlySelector = (0, toolkit_1.createSelector)(exports.observationStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.stepOnly; });
exports.continuousOnlySelector = (0, toolkit_1.createSelector)(exports.observationStoreSelector, function (state) { return state === null || state === void 0 ? void 0 : state.continuousOnly; });
exports.gradeFiltersSelector = (0, toolkit_1.createSelector)(exports.observationStoreSelector, function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.gradeFilters) !== null && _a !== void 0 ? _a : []; });
exports.typeFiltersSelector = (0, toolkit_1.createSelector)(exports.observationStoreSelector, function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.typeFilters) !== null && _a !== void 0 ? _a : []; });
var selectObservations = function (standard) {
    return (0, react_redux_1.useSelector)((0, exports.observationSelector)(standard));
};
exports.selectObservations = selectObservations;
var selectJointOnly = function () { return (0, react_redux_1.useSelector)(exports.jointOnlySelector); };
exports.selectJointOnly = selectJointOnly;
var selectStepOnly = function () { return (0, react_redux_1.useSelector)(exports.stepOnlySelector); };
exports.selectStepOnly = selectStepOnly;
var selectContinuousOnly = function () { return (0, react_redux_1.useSelector)(exports.continuousOnlySelector); };
exports.selectContinuousOnly = selectContinuousOnly;
var selectGradeFilters = function () { return (0, react_redux_1.useSelector)(exports.gradeFiltersSelector); };
exports.selectGradeFilters = selectGradeFilters;
var selectTypeFilters = function () { return (0, react_redux_1.useSelector)(exports.typeFiltersSelector); };
exports.selectTypeFilters = selectTypeFilters;
exports["default"] = {
    observationSelector: exports.observationSelector,
    selectObservations: exports.selectObservations,
    selectJointOnly: exports.selectJointOnly,
    selectStepOnly: exports.selectStepOnly,
    selectContinuousOnly: exports.selectContinuousOnly,
    selectGradeFilters: exports.selectGradeFilters,
    selectTypeFilters: exports.selectTypeFilters,
};


/***/ }),

/***/ "./selectors/rehab.selectors.ts":
/*!**************************************!*\
  !*** ./selectors/rehab.selectors.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectHasValidTree = exports.selectRehabResults = exports.selectRehabTrees = exports.selectIsTreesLoading = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var rehabStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.RehabStore; });
var treeSelector = (0, toolkit_1.createSelector)(rehabStoreSelector, function (state) { return state.rehabTrees; });
var rehabResultSelector = (0, toolkit_1.createSelector)(rehabStoreSelector, function (state) { return state.rehabDetails; });
var isTreeLoadingSelector = (0, toolkit_1.createSelector)(rehabStoreSelector, function (state) {
    if (state.isDetailLoading)
        return true;
    var trees = state.rehabTrees;
    if (trees == undefined || trees.length == 0)
        return false;
    var ranTree = trees.filter(function (tree) { return tree.lastRun != undefined; });
    if (ranTree.length == 0)
        return false;
    var results = state.rehabDetails;
    var loadingResults = ranTree.filter(function (tree) {
        if (results[tree._id]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var result = results[tree._id];
            if (result === null || result === void 0 ? void 0 : result.loading)
                return true;
        }
        else
            return false;
    });
    if (loadingResults.length > 0)
        return true;
    return false;
});
var hasValidTreeSelector = (0, toolkit_1.createSelector)(rehabStoreSelector, function (state) {
    if (state.isDetailLoading)
        return false;
    var trees = state.rehabTrees;
    if (trees == undefined || trees.length == 0)
        return false;
    var ranTree = trees.filter(function (tree) { return tree.lastRun != undefined; });
    if (ranTree.length == 0)
        return false;
    var results = state.rehabDetails;
    var validResults = ranTree.filter(function (tree) {
        if (results[tree._id]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var result = results[tree._id];
            if ((result === null || result === void 0 ? void 0 : result.loading) != undefined && result.loading == false) {
                if (result.rows.length > 0)
                    return true;
            }
            return false;
        }
    });
    if (validResults.length > 0)
        return true;
    return false;
});
var selectIsTreesLoading = function () { return (0, react_redux_1.useSelector)(isTreeLoadingSelector); };
exports.selectIsTreesLoading = selectIsTreesLoading;
var selectRehabTrees = function () { return (0, react_redux_1.useSelector)(treeSelector); };
exports.selectRehabTrees = selectRehabTrees;
var selectRehabResults = function () { return (0, react_redux_1.useSelector)(rehabResultSelector); };
exports.selectRehabResults = selectRehabResults;
var selectHasValidTree = function () { return (0, react_redux_1.useSelector)(hasValidTreeSelector); };
exports.selectHasValidTree = selectHasValidTree;
exports["default"] = [exports.selectRehabTrees, exports.selectRehabResults];


/***/ }),

/***/ "./selectors/riskConfigs.selectors.ts":
/*!********************************************!*\
  !*** ./selectors/riskConfigs.selectors.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectRiskConfigsPagination = exports.selectRiskConfigsIsWaiting = exports.selectRiskConfigsIsLoading = exports.selectRiskConfigsPage = exports.selectRiskConfigsPerPage = exports.selectorRiskConfigsPerPage = exports.selectRiskConfigsStatus = exports.selectRiskConfigs = exports.riskConfigsIsWaitingSelector = exports.riskConfigsStatusSelector = exports.selectorPaginationQuery = exports.selectCanReload = exports.riskConfigsSelector = exports.selectorRiskConfigsPaginationQuery = exports.selectorRiskConfigsPagination = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var paginationUtils_1 = __webpack_require__(/*! @Reducers/paginationUtils */ "./reducers/paginationUtils.ts");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var riskConfigsBaseSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs; });
exports.selectorRiskConfigsPagination = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.pagination; });
exports.selectorRiskConfigsPaginationQuery = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.query; });
exports.riskConfigsSelector = (0, toolkit_1.createSelector)(riskConfigsBaseSelector, function (baseState) { return baseState.cards; });
var selectorCanReload = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.pagination.total > 0; });
var selectCanReload = function () { return (0, react_redux_1.useSelector)(selectorCanReload); };
exports.selectCanReload = selectCanReload;
exports.selectorPaginationQuery = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.query; });
exports.riskConfigsStatusSelector = (0, toolkit_1.createSelector)(riskConfigsBaseSelector, function (baseState) { return baseState.status; });
exports.riskConfigsIsWaitingSelector = (0, toolkit_1.createSelector)(riskConfigsBaseSelector, function (baseState) { return baseState.isWaiting; });
var selectorRiskConfigsPage = function () {
    var pagination = exports.selectorRiskConfigsPagination;
    var cards = exports.riskConfigsSelector;
    return (0, toolkit_1.createSelector)(pagination, cards, function (pagination, cards) { return ({
        total: pagination.total,
        pages: pagination.pages,
        page: pagination.page,
        cards: cards,
        sortKey: pagination.sortKey,
        sortDescending: pagination.sortDescending,
    }); });
};
var selectorRiskConfigsSlice = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.pagination.slice; });
var selectorRiskConfigIsLoading = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.isLoading; });
var selectorRiskConfigIsWaiting = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigs.isWaiting; });
var selectRiskConfigs = function () { return (0, react_redux_1.useSelector)(exports.riskConfigsSelector); };
exports.selectRiskConfigs = selectRiskConfigs;
var selectRiskConfigsStatus = function () {
    return (0, react_redux_1.useSelector)(exports.riskConfigsStatusSelector);
};
exports.selectRiskConfigsStatus = selectRiskConfigsStatus;
var selectorRiskConfigsPerPage = function (dispatchSliceFn) {
    return (0, toolkit_1.createSelector)(selectorRiskConfigsSlice, function (slice) {
        return (0, paginationUtils_1.rowsPerPage)(slice || 10, dispatchSliceFn);
    });
};
exports.selectorRiskConfigsPerPage = selectorRiskConfigsPerPage;
var selectRiskConfigsPerPage = function (dispatchSliceFn) { return (0, react_redux_1.useSelector)((0, exports.selectorRiskConfigsPerPage)(dispatchSliceFn)); };
exports.selectRiskConfigsPerPage = selectRiskConfigsPerPage;
var selectRiskConfigsPage = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigsPage());
};
exports.selectRiskConfigsPage = selectRiskConfigsPage;
var selectRiskConfigsIsLoading = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigIsLoading);
};
exports.selectRiskConfigsIsLoading = selectRiskConfigsIsLoading;
var selectRiskConfigsIsWaiting = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigIsWaiting);
};
exports.selectRiskConfigsIsWaiting = selectRiskConfigsIsWaiting;
var selectRiskConfigsPagination = function () {
    return (0, react_redux_1.useSelector)(exports.selectorRiskConfigsPagination);
};
exports.selectRiskConfigsPagination = selectRiskConfigsPagination;
exports["default"] = exports.selectRiskConfigs;


/***/ }),

/***/ "./selectors/riskConfigsList.selectors.ts":
/*!************************************************!*\
  !*** ./selectors/riskConfigsList.selectors.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectRiskConfigsListIsLoading = exports.selectRiskConfigsList = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var riskConfigsListBaseSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.riskConfigsList; });
var riskConfigsListSelector = (0, toolkit_1.createSelector)(riskConfigsListBaseSelector, function (baseState) { return baseState.configs; });
var riskConfigsIsLoadingSelector = (0, toolkit_1.createSelector)(riskConfigsListBaseSelector, function (baseState) { return baseState.isLoading; });
var selectRiskConfigsList = function () { return (0, react_redux_1.useSelector)(riskConfigsListSelector); };
exports.selectRiskConfigsList = selectRiskConfigsList;
var selectRiskConfigsListIsLoading = function () {
    return (0, react_redux_1.useSelector)(riskConfigsIsLoadingSelector);
};
exports.selectRiskConfigsListIsLoading = selectRiskConfigsListIsLoading;
exports["default"] = exports.selectRiskConfigsList;


/***/ }),

/***/ "./selectors/user.selectors.ts":
/*!*************************************!*\
  !*** ./selectors/user.selectors.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectUserInitial = exports.selectUserContext = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state['userContext']; };
var userContextSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state; });
var selectUserContext = function () { return (0, react_redux_1.useSelector)(userContextSelector); };
exports.selectUserContext = selectUserContext;
var selectUserInitial = function () {
    var userContext = (0, react_redux_1.useSelector)(userContextSelector);
    var name = userContext === null || userContext === void 0 ? void 0 : userContext.name;
    if (!name || name.length <= 0)
        return '';
    var components;
    // Name could be an email with @, but not necessarily, so
    // If @ present treat as email and use initials of . seperated words before @
    // If missing treat as sentence and use initials of space seperated words
    //   notably multiple spaces in a row
    if (name.indexOf('@') >= 0) {
        components = name.substr(0, name.indexOf('@')).split('.');
    }
    else {
        components = name.split(' ');
    }
    var initials = components
        .map(function (m) { return m.trim(); })
        .filter(function (f) { return f.length > 0; })
        .map(function (m) { return m[0].toUpperCase(); });
    if (initials.length == 1) {
        return initials[0];
    }
    else {
        // 1st and last
        return initials[0] + initials[initials.length - 1];
    }
};
exports.selectUserInitial = selectUserInitial;
exports["default"] = {
    selectUserContext: exports.selectUserContext,
    selectUserInitial: exports.selectUserInitial,
};


/***/ }),

/***/ "./services/Rehab.servies.ts":
/*!***********************************!*\
  !*** ./services/Rehab.servies.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRehabActions = exports.toggleRehabTreePublishStateApi = exports.getRehabResultApi = exports.getRehabTreesApi = void 0;
var rehab_api_1 = __importDefault(__webpack_require__(/*! @Apis/rehab.api */ "./apis/rehab.api.ts"));
var getRehabTreesApi = function (params) {
    if (params === void 0) { params = { listAllTrees: true }; }
    var query = new URLSearchParams(__spreadArray([], Object.entries(params)
        .filter(function (_a) {
        var value = _a[1];
        return !!value;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, "".concat(value)];
    }), true)).toString();
    return rehab_api_1.default.get("/rehabTrees?".concat(query));
};
exports.getRehabTreesApi = getRehabTreesApi;
var getRehabResultApi = function (treeId, query) {
    var address = "/rehabResults/".concat(treeId);
    return rehab_api_1.default.get("".concat(address).concat(query));
};
exports.getRehabResultApi = getRehabResultApi;
var toggleRehabTreePublishStateApi = function (treeId, newPublishState) {
    var address = "/rehabTree/".concat(treeId);
    return rehab_api_1.default.put(address, { newPublishState: newPublishState });
};
exports.toggleRehabTreePublishStateApi = toggleRehabTreePublishStateApi;
var getRehabActions = function (treeId) {
    var address = "/rehabActions/".concat(treeId);
    return rehab_api_1.default.get(address);
};
exports.getRehabActions = getRehabActions;


/***/ }),

/***/ "./services/charts.services.ts":
/*!*************************************!*\
  !*** ./services/charts.services.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskChartsQueryApi = exports.getRiskChartsApi = exports.getInspectionMonthChartsQueryApi = exports.getInspectionAssetChartsQueryApi = exports.getInspectionOverviewChartsApi = void 0;
var inspection_api_1 = __importDefault(__webpack_require__(/*! @Apis/inspection.api */ "./apis/inspection.api.ts"));
var risks_api_1 = __importDefault(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var getInspectionOverviewChartsApi = function (standard) {
    return inspection_api_1.default.get("inspections/charts?standard=".concat(standard));
};
exports.getInspectionOverviewChartsApi = getInspectionOverviewChartsApi;
var getInspectionAssetChartsQueryApi = function (standard, query, assetFields) {
    return inspection_api_1.default.get("inspections/charts?standard=".concat(standard, "&query=").concat(encodeURIComponent(query), "&assetFields=").concat(encodeURIComponent(assetFields)));
};
exports.getInspectionAssetChartsQueryApi = getInspectionAssetChartsQueryApi;
var getInspectionMonthChartsQueryApi = function (standard, query, month) {
    return inspection_api_1.default.get("inspections/charts?standard=".concat(standard, "&query=").concat(encodeURIComponent(query), "&month=").concat(encodeURIComponent(month)));
};
exports.getInspectionMonthChartsQueryApi = getInspectionMonthChartsQueryApi;
var getRiskChartsApi = function (configId) {
    return risks_api_1.default.get("charts/".concat(configId));
};
exports.getRiskChartsApi = getRiskChartsApi;
// Not sure what fields will be need for the query... putting in as a place holder
var getRiskChartsQueryApi = function (configId, query, assetFields) {
    return inspection_api_1.default.get("charts/".concat(configId, "?query=").concat(encodeURIComponent(query), "&assetFields=").concat(encodeURIComponent(assetFields)));
};
exports.getRiskChartsQueryApi = getRiskChartsQueryApi;


/***/ }),

/***/ "./services/index.ts":
/*!***************************!*\
  !*** ./services/index.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createInspectionApi = exports.getConfigurationWithUploadIdApi = exports.getConfigurationWithMappingApi = exports.getRiskSummaryApi = exports.editObservationsApi = exports.checkAssetIdsApi = exports.getInspectionOverviewApi = exports.getSpatialLayersApi = exports.getNotesApi = exports.getFullInspApi = exports.addNoteApi = exports.deleteObservationsApi = exports.createObservationsApi = exports.getObservationsApi = exports.getUpdateInspectionApi = exports.getInspectionApi = exports.getRiskHistoryApi = exports.getMapRiskLayersApi = exports.mapRiskLayersAddress = exports.getRiskConfigurationsApi = exports.getRiskSettingApi = exports.getRiskApi = exports.getSummaryApi = exports.addAssetNoteApi = exports.getAssetCountsApi = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var asset_api_1 = __importDefault(__webpack_require__(/*! @Apis/asset.api */ "./apis/asset.api.ts"));
var inspection_api_1 = __importDefault(__webpack_require__(/*! @Apis/inspection.api */ "./apis/inspection.api.ts"));
var risks_api_1 = __importDefault(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var upload_api_1 = __importDefault(__webpack_require__(/*! @Apis/upload.api */ "./apis/upload.api.ts"));
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var getAssetCountsApi = function (systemType) {
    var address = "/assets-count/?systemType=".concat(systemType);
    return asset_api_1.default.get(address);
};
exports.getAssetCountsApi = getAssetCountsApi;
var addAssetNoteApi = function (assetParams, addNoteParams) {
    var address = "/assets/".concat(assetParams.assetId, "/addnote?assetType=").concat(assetParams.assetType);
    return asset_api_1.default.post(address, addNoteParams);
};
exports.addAssetNoteApi = addAssetNoteApi;
var getSummaryApi = function (assetParams) {
    var address = "/assets/".concat(assetParams.assetId, "?assetType=").concat(assetParams.assetType);
    return asset_api_1.default.get(address);
};
exports.getSummaryApi = getSummaryApi;
var getRiskApi = function (assetParams) {
    var newAssetID = encodeURIComponent("".concat(assetParams.assetType, "#").concat(assetParams.assetId));
    var configId = assetParams.configId
        ? "?configId=".concat(assetParams.configId)
        : '';
    var address = "/risk/singlescore/".concat(newAssetID).concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskApi = getRiskApi;
var getRiskSettingApi = function () {
    var address = '/risk/config';
    return risks_api_1.default.get(address);
};
exports.getRiskSettingApi = getRiskSettingApi;
var getRiskConfigurationsApi = function (query) {
    var address = '/risk/configurations' + query;
    return risks_api_1.default.get(address);
};
exports.getRiskConfigurationsApi = getRiskConfigurationsApi;
var mapRiskLayersAddress = function (mapTheme, hiddenRanges) {
    if (mapTheme === void 0) { mapTheme = 'layers'; }
    if (hiddenRanges === void 0) { hiddenRanges = ''; }
    return "risk/score?mapTheme=".concat(mapTheme, "&sort=modifiedAt&sortDescending=true").concat(hiddenRanges);
};
exports.mapRiskLayersAddress = mapRiskLayersAddress;
var getMapRiskLayersApi = function (mapTheme, hiddenRanges) {
    if (mapTheme === void 0) { mapTheme = 'layers'; }
    if (hiddenRanges === void 0) { hiddenRanges = ''; }
    return risks_api_1.default.get("/".concat((0, exports.mapRiskLayersAddress)(mapTheme, hiddenRanges)));
};
exports.getMapRiskLayersApi = getMapRiskLayersApi;
var getRiskHistoryApi = function (assetParams) {
    var newAssetID = encodeURIComponent("".concat(assetParams.assetType, "#").concat(assetParams.assetId));
    var configId = assetParams.configId
        ? "?configId=".concat(assetParams.configId)
        : '';
    var address = "/risk/history/".concat(newAssetID).concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskHistoryApi = getRiskHistoryApi;
var getInspectionApi = function (assetId) {
    var address = "/inspections/".concat(assetId);
    return inspection_api_1.default.get(address);
};
exports.getInspectionApi = getInspectionApi;
var getUpdateInspectionApi = function (params) {
    var inspectionID = params.inspectionID, standard = params.standard;
    var address = "/inspections/update/".concat(inspectionID, "?standard=").concat(standard);
    return inspection_api_1.default.put(address, {
        inspectionData: params.updateDetails,
        note: params.notes,
    });
};
exports.getUpdateInspectionApi = getUpdateInspectionApi;
var getObservationsApi = function (params) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var InspectionID = params.inspectionID, standard = params.standard;
    var address = "/observations/".concat(InspectionID, "?standard=").concat(standard);
    return inspection_api_1.default.get(address);
};
exports.getObservationsApi = getObservationsApi;
var createObservationsApi = function (params) {
    var inspectionId = params.inspectionId;
    var address = "/observations/".concat(inspectionId);
    return inspection_api_1.default.post(address, params);
};
exports.createObservationsApi = createObservationsApi;
var deleteObservationsApi = function (insepctionId, ids) {
    var address = "/observations/".concat(insepctionId, "?observationIds=").concat(ids.join(','));
    return inspection_api_1.default.delete(address);
};
exports.deleteObservationsApi = deleteObservationsApi;
var addNoteApi = function (params) {
    var address = '/inspections/note';
    if (params.note) {
        //convert notes that are in array to a single string
        if (Array.isArray(params.note)) {
            params.note = params.note.join('\n');
        }
    }
    return inspection_api_1.default.post(address, {
        _id: params._id,
        userName: params.name,
        userInitial: params.initial,
        note: params.note,
        dateTime: new Date(),
        noteType: params.noteType || _Types_1.NoteType.USER,
    });
};
exports.addNoteApi = addNoteApi;
var getFullInspApi = function (inspectionUniqueId, standard, enableMediaTranscode) {
    if (enableMediaTranscode == undefined) {
        enableMediaTranscode = false;
    }
    var address = "/fullInspections?inspectionId=".concat(inspectionUniqueId, "&standard=").concat(standard, "&mediaTranscode=").concat(enableMediaTranscode);
    return inspection_api_1.default.get(address);
};
exports.getFullInspApi = getFullInspApi;
var getNotesApi = function (inspectionUniqueId) {
    var address = "/inspections/notes?_id=".concat(inspectionUniqueId);
    return inspection_api_1.default.get(address);
};
exports.getNotesApi = getNotesApi;
var getSpatialLayersApi = function () {
    var address = '/spatial/layerlist';
    return risks_api_1.default.get(address);
};
exports.getSpatialLayersApi = getSpatialLayersApi;
var getInspectionOverviewApi = function () {
    var address = '/inspections?overview';
    return risks_api_1.default.get(address);
};
exports.getInspectionOverviewApi = getInspectionOverviewApi;
var checkAssetIdsApi = function (params) {
    var address = '/assets/ids';
    return asset_api_1.default.post(address, params);
};
exports.checkAssetIdsApi = checkAssetIdsApi;
var editObservationsApi = function (params) {
    var address = "/observations/".concat(params.inspectionId);
    return inspection_api_1.default.put(address, params.observations);
};
exports.editObservationsApi = editObservationsApi;
var getRiskSummaryApi = function (_a) {
    var assetId = _a.assetId, assetType = _a.assetType;
    var address = "/risk/summary/".concat(assetType, "%23").concat(assetId);
    return risks_api_1.default.get(address);
};
exports.getRiskSummaryApi = getRiskSummaryApi;
var getConfigurationWithMappingApi = function (mappingKey, type) {
    var address = "/mapping/".concat(encodeURIComponent(mappingKey), "?uploadType=").concat(type);
    return upload_api_1.default.get(address);
};
exports.getConfigurationWithMappingApi = getConfigurationWithMappingApi;
var getConfigurationWithUploadIdApi = function (uploadId, type) {
    var address = "/mapping/".concat(encodeURIComponent(uploadId), "?uploadId=true&uploadType=").concat(type);
    return upload_api_1.default.get(address);
};
exports.getConfigurationWithUploadIdApi = getConfigurationWithUploadIdApi;
var createInspectionApi = function (params) {
    var address = "/inspections/blank/".concat(encodeURIComponent(params.newId));
    return inspection_api_1.default.post(address, {
        standard: params.standard,
        relatedAssetType: params.relatedAssetType,
        inspectionStatus: params.options.task ? 'approved' : 'ready',
        options: params.options,
    });
};
exports.createInspectionApi = createInspectionApi;


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.moduleNamespace = void 0;
exports.moduleNamespace = 'libAmCommon';


/***/ }),

/***/ "./store/index.ts":
/*!************************!*\
  !*** ./store/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
var redux_1 = __webpack_require__(/*! redux */ "redux");
var redux_devtools_extension_1 = __webpack_require__(/*! redux-devtools-extension */ "../node_modules/redux-devtools-extension/index.js");
var redux_saga_1 = __importDefault(__webpack_require__(/*! redux-saga */ "../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js"));
var config_store_1 = __webpack_require__(/*! ./config.store */ "./store/config.store.ts");
var _Reducers_1 = __importDefault(__webpack_require__(/*! @Reducers */ "./reducers/index.ts"));
var sagas_1 = __importDefault(__webpack_require__(/*! ../sagas */ "./sagas/index.ts"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var sagaMiddleware = (0, redux_saga_1.default)();
var store = (0, redux_1.createStore)((0, redux_1.combineReducers)(__assign(__assign((_a = {}, _a[config_store_1.moduleNamespace] = _Reducers_1.default, _a), stylovyze_1.reducers), lib_asset_schema_store_1.assetSchemaRootReducer)), (0, redux_devtools_extension_1.composeWithDevTools)((0, redux_1.applyMiddleware)(sagaMiddleware)));
var mainSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.all)([sagas_1.default, (0, lib_asset_schema_store_1.assetSchemaRootSaga)()])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
sagaMiddleware.run(mainSaga);
exports["default"] = store;


/***/ }),

/***/ "./types/ObservationNotes.types.ts":
/*!*****************************************!*\
  !*** ./types/ObservationNotes.types.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["SYSTEM"] = "system";
    NoteType["USER"] = "user";
})(NoteType = exports.NoteType || (exports.NoteType = {}));


/***/ }),

/***/ "./types/asset.types.ts":
/*!******************************!*\
  !*** ./types/asset.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PipeType = exports.RiskByGrade = void 0;
var RiskByGrade;
(function (RiskByGrade) {
    RiskByGrade["Negligible"] = "Negligible";
    RiskByGrade["Low"] = "Low";
    RiskByGrade["Median"] = "Median";
    RiskByGrade["High"] = "High";
    RiskByGrade["Extreme"] = "Extreme";
})(RiskByGrade = exports.RiskByGrade || (exports.RiskByGrade = {}));
var PipeType;
(function (PipeType) {
    PipeType["GravityMain"] = "Gravity Main";
    PipeType["PressurizedMain"] = "Pressurized Main";
})(PipeType = exports.PipeType || (exports.PipeType = {}));


/***/ }),

/***/ "./types/charts.types.ts":
/*!*******************************!*\
  !*** ./types/charts.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChartType = void 0;
var ChartType;
(function (ChartType) {
    ChartType[ChartType["InspectionOverview"] = 1] = "InspectionOverview";
    ChartType[ChartType["InspectionAssetDrilldown"] = 2] = "InspectionAssetDrilldown";
    ChartType[ChartType["InspectionMonthDrilldown"] = 3] = "InspectionMonthDrilldown";
    ChartType[ChartType["RiskOverview"] = 4] = "RiskOverview";
    ChartType[ChartType["RiskDrilldown"] = 5] = "RiskDrilldown";
})(ChartType = exports.ChartType || (exports.ChartType = {}));


/***/ }),

/***/ "./types/configuration.types.ts":
/*!**************************************!*\
  !*** ./types/configuration.types.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/filter.types.ts":
/*!*******************************!*\
  !*** ./types/filter.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FilterObservationGradeType = exports.FilterDateTime = exports.FilterOperator = void 0;
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Equal"] = "eq";
    FilterOperator["GreaterOrEqual"] = "gte";
    FilterOperator["LessThan"] = "lt";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
var FilterDateTime;
(function (FilterDateTime) {
    FilterDateTime["Today"] = "today";
    FilterDateTime["LastWeek"] = "lastweek";
    FilterDateTime["LastMonth"] = "lastmonth";
    FilterDateTime["LastYear"] = "lastyear";
})(FilterDateTime = exports.FilterDateTime || (exports.FilterDateTime = {}));
var FilterObservationGradeType;
(function (FilterObservationGradeType) {
    FilterObservationGradeType["Struct"] = "struct";
    FilterObservationGradeType["OM"] = "o&m";
    FilterObservationGradeType["Service"] = "service";
})(FilterObservationGradeType = exports.FilterObservationGradeType || (exports.FilterObservationGradeType = {}));


/***/ }),

/***/ "./types/fullInspection.types.ts":
/*!***************************************!*\
  !*** ./types/fullInspection.types.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getEventOptionalFields = exports.getEventMandatoryFields = exports.getTaskOptionalFields = exports.getTaskMandatoryFields = exports.eventIgnoreFields = exports.taskIgnoreFields = void 0;
exports.taskIgnoreFields = [
    '_id',
    'taskId',
    'assetId',
    'relatedAssetId',
    'completedDate',
    'scheduledDate',
    'inspectionStatus',
    'inspectionVersion',
    'taskTypeName',
    'task',
    'tenantId',
    'uploadedById',
    'uploadedBy',
    'statusSetByUserId',
    'statusSetByUserName',
    'statusSetDate',
    'validationState',
];
exports.eventIgnoreFields = [
    '_id',
    'eventId',
    'assetId',
    'relatedAssetId',
    'openedDate',
    'reportedDate',
    'verifiedDate',
    'resolvedDate',
    'closedDate',
    'status',
    'inspectionStatus',
    'inspectionVersion',
    'eventTypeName',
    'event',
    'tenantId',
    'uploadedById',
    'uploadedBy',
    'statusSetByUserId',
    'statusSetByUserName',
    'statusSetDate',
    'validationState',
];
var getTaskMandatoryFields = function (t) {
    return {
        taskId: t('Task ID'),
        relatedAssetId: t('Asset ID'),
        scheduledDate: t('Scheduled Date'),
        completedDate: t('Completed Date'),
    };
};
exports.getTaskMandatoryFields = getTaskMandatoryFields;
var getTaskOptionalFields = function (t) {
    return {
        distance: t('Distance'),
        lat: t('Lat (WGS84)'),
        long: t('Long (WGS84)'),
        startChainage: t('Start Chainage'),
        uploadedBy: t('Uploaded By'),
    };
};
exports.getTaskOptionalFields = getTaskOptionalFields;
var getEventMandatoryFields = function (t) {
    return {
        eventId: t('Event ID'),
        relatedAssetId: t('Asset ID'),
        openedDate: t('Opened Date'),
        reportedDate: t('Reported Date'),
        verifiedDate: t('Verified Date'),
        resolvedDate: t('Resolved Date'),
        closedDate: t('Closed Date'),
    };
};
exports.getEventMandatoryFields = getEventMandatoryFields;
var getEventOptionalFields = function (t) {
    return {
        lat: t('Lat (WGS84)'),
        long: t('Long (WGS84)'),
        uploadedBy: t('Uploaded By'),
    };
};
exports.getEventOptionalFields = getEventOptionalFields;


/***/ }),

/***/ "./types/general.types.ts":
/*!********************************!*\
  !*** ./types/general.types.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/index.ts":
/*!************************!*\
  !*** ./types/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./store.types */ "./types/store.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./general.types */ "./types/general.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./filter.types */ "./types/filter.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./pagination.types */ "./types/pagination.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./ObservationNotes.types */ "./types/ObservationNotes.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspection.types */ "./types/inspection.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspectionAttributes.types */ "./types/inspectionAttributes.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./observation.types */ "./types/observation.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./fullInspection.types */ "./types/fullInspection.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./search.types */ "./types/search.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./spatial.types */ "./types/spatial.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.types */ "./types/map.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.types */ "./types/asset.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./riskConfig.types */ "./types/riskConfig.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./charts.types */ "./types/charts.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./configuration.types */ "./types/configuration.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./rehab.types */ "./types/rehab.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./webSocket.types */ "./types/webSocket.types.ts"), exports);


/***/ }),

/***/ "./types/inspection.types.ts":
/*!***********************************!*\
  !*** ./types/inspection.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TaskType = exports.ValidationStatus = exports.SortDirection = exports.Direction = exports.UploadStatus = exports.InspectionStandard = void 0;
var InspectionStandard;
(function (InspectionStandard) {
    InspectionStandard["PACP"] = "PACP";
    InspectionStandard["MACP"] = "MACP";
    InspectionStandard["MSCC"] = "MSCC";
    InspectionStandard["WSA05"] = "WSA05";
})(InspectionStandard = exports.InspectionStandard || (exports.InspectionStandard = {}));
var UploadStatus;
(function (UploadStatus) {
    UploadStatus["MissingMedia"] = "missing_media";
    UploadStatus["Ready"] = "ready";
    UploadStatus["Submitted"] = "submitted";
    UploadStatus["InReview"] = "inReview";
    UploadStatus["Approved"] = "approved";
    UploadStatus["Rejected"] = "rejected";
    UploadStatus["AIProcessing"] = "ai_processing";
    UploadStatus["AIProcessed"] = "ai_processed";
    UploadStatus["AIFailed"] = "ai_failed";
    UploadStatus["VaparEdit"] = "vapar_edit";
    UploadStatus["Superseded"] = "superseded";
    UploadStatus["EventActive"] = "active";
    UploadStatus["EventVerified"] = "verified";
    UploadStatus["EventResolved"] = "resolved";
    UploadStatus["EventClosed"] = "closed";
})(UploadStatus = exports.UploadStatus || (exports.UploadStatus = {}));
var Direction;
(function (Direction) {
    Direction["Upstream"] = "upstream";
    Direction["Downstream"] = "downstream";
})(Direction = exports.Direction || (exports.Direction = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["Error"] = "error";
    ValidationStatus["Warning"] = "warning";
    ValidationStatus["Information"] = "information";
})(ValidationStatus = exports.ValidationStatus || (exports.ValidationStatus = {}));
var TaskType;
(function (TaskType) {
    TaskType["Inspection"] = "insp";
    TaskType["Task"] = "task";
    TaskType["Event"] = "event";
})(TaskType = exports.TaskType || (exports.TaskType = {}));


/***/ }),

/***/ "./types/inspectionAttributes.types.ts":
/*!*********************************************!*\
  !*** ./types/inspectionAttributes.types.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/map.types.ts":
/*!****************************!*\
  !*** ./types/map.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AssetTypeUnknown = exports.AssetTypeManhole = exports.AssetTypePipe = exports.RiskLayersMask = exports.MapStatusType = void 0;
// This is a copy of map StatusType - would like to use directly via...
// import { StatusType } from '@innovyze/inno-map/map/logger/Logger';
// but the export appears broken so for now just replicate.
// So watch out for string changes in original StatusType
var MapStatusType;
(function (MapStatusType) {
    MapStatusType["DEBUG"] = "debug";
    MapStatusType["INFO"] = "info";
    MapStatusType["WARN"] = "warn";
    MapStatusType["ERROR"] = "error";
})(MapStatusType = exports.MapStatusType || (exports.MapStatusType = {}));
var RiskLayersMask;
(function (RiskLayersMask) {
    RiskLayersMask[RiskLayersMask["None"] = 0] = "None";
    RiskLayersMask[RiskLayersMask["Published"] = 1] = "Published";
    RiskLayersMask[RiskLayersMask["Unpublished"] = 2] = "Unpublished";
})(RiskLayersMask = exports.RiskLayersMask || (exports.RiskLayersMask = {}));
// TODO replace with generic solution @AssetSchemaMigration
// Used in app-am-activities
exports.AssetTypePipe = 'wwPipe';
exports.AssetTypeManhole = 'wwManhole';
exports.AssetTypeUnknown = 'assetTypeUnknown';


/***/ }),

/***/ "./types/observation.types.ts":
/*!************************************!*\
  !*** ./types/observation.types.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/pagination.types.ts":
/*!***********************************!*\
  !*** ./types/pagination.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/rehab.types.ts":
/*!******************************!*\
  !*** ./types/rehab.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CostUnit = void 0;
var CostUnit;
(function (CostUnit) {
    CostUnit["each"] = "each";
    CostUnit["length"] = "length";
})(CostUnit = exports.CostUnit || (exports.CostUnit = {}));


/***/ }),

/***/ "./types/riskConfig.types.ts":
/*!***********************************!*\
  !*** ./types/riskConfig.types.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskConfigsPaginationDefault = exports.ConfigPublishState = void 0;
var paginationUtils_1 = __webpack_require__(/*! @Reducers/paginationUtils */ "./reducers/paginationUtils.ts");
var ConfigPublishState;
(function (ConfigPublishState) {
    ConfigPublishState["published"] = "published";
    ConfigPublishState["unpublished"] = "unpublished";
})(ConfigPublishState = exports.ConfigPublishState || (exports.ConfigPublishState = {}));
var riskConfigsPaginationDefault = function () { return (__assign(__assign({}, paginationUtils_1.paginationDefault), { search: undefined, sortKey: 'createdAt', sortDescending: true })); };
exports.riskConfigsPaginationDefault = riskConfigsPaginationDefault;


/***/ }),

/***/ "./types/search.types.ts":
/*!*******************************!*\
  !*** ./types/search.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/spatial.types.ts":
/*!********************************!*\
  !*** ./types/spatial.types.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/store.types.ts":
/*!******************************!*\
  !*** ./types/store.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");


/***/ }),

/***/ "./types/webSocket.types.ts":
/*!**********************************!*\
  !*** ./types/webSocket.types.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;


/***/ }),

/***/ "./utils/common.utils.tsx":
/*!********************************!*\
  !*** ./utils/common.utils.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.processFormSubmit = exports.getDetailGrid = exports.getDomainItems = exports.getChangedFormikFields = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _1 = __webpack_require__(/*! . */ "./utils/index.ts");
//compares two objects for only the items passed in the list, returns an object with fields which differ
var getChangedFormikFields = function (origList, values) {
    var changes = {};
    var keys = Object.keys(values);
    keys.forEach(function (item) {
        if (origList[item] !== values[item]) {
            changes[item] = values[item];
        }
    });
    return changes;
};
exports.getChangedFormikFields = getChangedFormikFields;
var getDomainItems = function (t, values) {
    var keys = Object.keys(values);
    return keys.map(function (key) {
        if (values[key].length === 0)
            return { label: t(key), value: key, key: key };
        else
            return { label: "".concat(key, " - ").concat(values[key]), value: key, key: key };
    });
};
exports.getDomainItems = getDomainItems;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getDetailGrid = function (t, fields, unitFields, dateTimeFields, currencyFields, numericFields, booleanFields, isEditableField, fullEdit, isHiddenField, hideFields, getDomainValues, getDomainItems) {
    if (fields && fields.length > 0) {
        return fields.map(function (field) {
            var _a, _b;
            if (isHiddenField == undefined ||
                !isHiddenField(field.name, hideFields !== null && hideFields !== void 0 ? hideFields : false)) {
                if (unitFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputUnit, { fieldAttrs: { name: field.name }, unitField: {
                                disabled: !isEditableField(field.name, fullEdit),
                                label: field.alias,
                                unit: unitFields[field.name].unit,
                                min: unitFields[field.name].min,
                                max: unitFields[field.name].max,
                                step: unitFields[field.name].step,
                                defaultValue: (_a = unitFields[field.name].defaultValue) !== null && _a !== void 0 ? _a : '0',
                                onChange: function () {
                                    // console.log('onChange', e.target.value);
                                },
                            }, invalidDisplayValue: '-' }) }), "".concat(field.name).concat(Date.now)));
                }
                else if (currencyFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputCurrency, { fieldAttrs: { name: field.name }, currencyField: {
                                defaultValue: '0',
                                label: field.alias,
                                disabled: !isEditableField(field.name, fullEdit),
                                onChange: function () {
                                    // console.log('onChange', e.target.value);
                                },
                            } }) }), "".concat(field.name).concat(Date.now)));
                }
                else if (numericFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: { name: field.name }, textField: {
                                label: field.alias,
                                type: 'number',
                                inputProps: {
                                    min: numericFields[field.name].min,
                                    max: numericFields[field.name].max,
                                    step: numericFields[field.name].step,
                                },
                                disabled: !isEditableField(field.name, fullEdit),
                            } }) }), "".concat(field.name).concat(Date.now)));
                }
                else if (dateTimeFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputDateTime, { fieldAttrs: {
                                name: dateTimeFields[field.name].field,
                            }, dateTime: {
                                name: dateTimeFields[field.name].field,
                                mode: dateTimeFields[field.name].mode,
                                keepLocalTime: (_b = dateTimeFields[field.name]
                                    .useCompanyDateTime) !== null && _b !== void 0 ? _b : false,
                                label: field.alias,
                                disabled: !isEditableField(field.name, fullEdit),
                            }, invalidDateTimeString: "-" }) }), "".concat(field.name).concat(Date.now)));
                }
                else if (booleanFields[field.name]) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: {
                            paddingRight: '10px',
                            alignSelf: 'center',
                        } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputCheckbox, { fieldAttrs: {
                                name: field.name,
                                disabled: !isEditableField(field.name, fullEdit),
                            }, trueText: t('Yes'), falseText: t('No'), label: field.alias, checkbox: {} }) }), "".concat(field.name).concat(Date.now)));
                }
                else {
                    var domainValues = getDomainValues
                        ? getDomainValues(t, field.name)
                        : undefined;
                    if (domainValues &&
                        getDomainItems &&
                        Object.keys(domainValues).length !== 0) {
                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputSelect, { fieldAttrs: {
                                    name: field.name,
                                }, selectProps: {
                                    label: field.alias,
                                    disabled: !isEditableField(field.name, fullEdit),
                                }, menuItems: getDomainItems(t, domainValues) }) }), "".concat(field.name).concat(Date.now)));
                    }
                    else {
                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 3, style: { paddingRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InputText, { fieldAttrs: { name: field.name }, textField: {
                                    label: field.alias,
                                    disabled: !isEditableField(field.name, fullEdit),
                                } }) }), "".concat(field.name).concat(Date.now)));
                    }
                }
            }
        });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.getDetailGrid = getDetailGrid;
var processFormSubmit = function (t, standard, origDetails, changes, allFields, dateTimeFields, unitFields, currencyFields, numericFields, booleanFields, getSystemValueFormatted, formatDateUTC, companySettings, surveyDateTimeName, dateTimeKeys) {
    var keys = Object.keys(changes);
    // Now sort the change log
    var log = [];
    keys.forEach(function (key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var name = undefined;
        var fromValue = origDetails[key];
        var toValue = changes[key];
        // Since Date & Time are actually the one field we need to check for that differently
        if (key === 'surveyDateTime' && surveyDateTimeName) {
            name = surveyDateTimeName;
            // We need to adjust the value as well as translate the log values
            toValue = (0, _1.dateTimeFromPicker)(toValue);
            changes[key] = toValue;
            if (dateTimeKeys) {
                if (toValue.length === 0) {
                    changes[dateTimeKeys.date] = '';
                    changes[dateTimeKeys.time] = '';
                }
                else {
                    changes[dateTimeKeys.date] = {
                        type: 'date',
                        local: '',
                        displayValue: toValue.substring(0, 10),
                        value: "".concat(toValue.substring(0, 10), "T00:00:00.000Z"),
                    };
                    changes[dateTimeKeys.time] = {
                        type: 'time',
                        local: '',
                        displayValue: toValue.substring(11, 19),
                        value: "1111-11-11T".concat(toValue.substring(11, 19)),
                    };
                }
            }
            // Get fomatted values for the log
            fromValue =
                (_a = (0, _1.formatDateTimeWithFormatDate)(fromValue, formatDateUTC)) !== null && _a !== void 0 ? _a : fromValue;
            if (fromValue.length === 0 || fromValue === 'Invalid DateTime') {
                // This happens with an empty initial date/time
                fromValue = '';
            }
            toValue =
                (_b = (0, _1.formatDateTimeWithFormatDate)(toValue, formatDateUTC)) !== null && _b !== void 0 ? _b : toValue;
            if (toValue.length === 0 || toValue === 'Invalid DateTime') {
                // This happens with an empty date/time
                toValue = '';
            }
        }
        else {
            var field = allFields.find(function (field) { return field.name === key; });
            if (field) {
                name = field.alias;
                // Do we need to adjust the values
                if (dateTimeFields[key]) {
                    // User clearing the field ?
                    if (toValue.length === 0) {
                        toValue = '';
                        changes[key] = '';
                    }
                    else {
                        toValue = (0, _1.dateTimeFromPicker)(toValue);
                        // They are clearing the value
                        switch (dateTimeFields[key].mode) {
                            case stylovyze_1.DateTimeInputMode.DATE:
                                // We need to change the toValue into the SAASObject
                                changes[key] = {
                                    type: 'date',
                                    local: '',
                                    displayValue: toValue.substring(0, 10),
                                    value: "".concat(toValue.substring(0, 10), "T00:00:00.000Z"),
                                };
                                // Now format for the logs
                                toValue =
                                    (_c = (0, _1.formatDateWithFormatDate)(toValue, formatDateUTC)) !== null && _c !== void 0 ? _c : toValue;
                                break;
                            case stylovyze_1.DateTimeInputMode.TIME:
                                // We need to change the toValue into the SAASObject
                                changes[key] = {
                                    type: 'time',
                                    local: '',
                                    displayValue: toValue.substring(11, 19),
                                    value: "1111-11-11T".concat(toValue.substring(11, 18)),
                                };
                                // Now format for the logs
                                toValue =
                                    (_d = (0, _1.formatTimeWithFormatDate)(toValue, formatDateUTC)) !== null && _d !== void 0 ? _d : toValue;
                                break;
                            case stylovyze_1.DateTimeInputMode.DATE_TIME:
                                // We need to change the toValue into the SAASObject
                                changes[key] = {
                                    type: 'datetime',
                                    local: '',
                                    displayValue: toValue.substring(0, 19),
                                    value: toValue,
                                };
                                // Now format for the logs
                                toValue =
                                    (_e = (0, _1.formatDateTimeWithFormatDate)(toValue, formatDateUTC)) !== null && _e !== void 0 ? _e : toValue;
                                break;
                        }
                        // If we have invalid date then clear it... may not actually happen but make sure we dont push bad data
                        if (toValue.length == 0 ||
                            toValue === 'Invalid DateTime') {
                            toValue = '';
                            changes[key] = '';
                        }
                    }
                    // Now format for from time for the logs
                    switch (dateTimeFields[key].mode) {
                        case stylovyze_1.DateTimeInputMode.DATE:
                            // Now format for the logs
                            fromValue =
                                (_f = (0, _1.formatDateWithFormatDate)(fromValue, formatDateUTC)) !== null && _f !== void 0 ? _f : fromValue;
                            break;
                        case stylovyze_1.DateTimeInputMode.TIME:
                            fromValue =
                                (_g = (0, _1.formatTimeWithFormatDate)(fromValue, formatDateUTC)) !== null && _g !== void 0 ? _g : fromValue;
                            break;
                        case stylovyze_1.DateTimeInputMode.DATE_TIME:
                            fromValue =
                                (_h = (0, _1.formatDateTimeWithFormatDate)(fromValue, formatDateUTC)) !== null && _h !== void 0 ? _h : fromValue;
                            break;
                    }
                    if (fromValue.length === 0 ||
                        fromValue === 'Invalid DateTime') {
                        // This happens with an empty initial date/time
                        fromValue = '';
                    }
                }
                else if (currencyFields[key]) {
                    // We need to change the toValue into the SAASObject
                    changes[key] = {
                        type: 'currency',
                        local: 'USD',
                        displayValue: '$' + toValue,
                        value: +toValue,
                    };
                    fromValue = (_j = (0, stylovyze_1.getCurrency)(+fromValue, companySettings)) !== null && _j !== void 0 ? _j : '-';
                    toValue = (_k = (0, stylovyze_1.getCurrency)(+toValue, companySettings)) !== null && _k !== void 0 ? _k : '-';
                }
                else if (unitFields[key]) {
                    fromValue =
                        (_l = getSystemValueFormatted("".concat(fromValue, " ").concat(unitFields[field.name].unit), '-')) !== null && _l !== void 0 ? _l : '-';
                    toValue =
                        (_m = getSystemValueFormatted("".concat(toValue, " ").concat(unitFields[field.name].unit), '-')) !== null && _m !== void 0 ? _m : '-';
                }
                else if (booleanFields[key]) {
                    toValue = changes[key] ? t('Yes') : t('No');
                    fromValue = fromValue ? t('Yes') : t('No');
                }
            }
        }
        if (name)
            log.push(t(
            // eslint-disable-next-line quotes
            "{{name}} Changed From '{{from}}' To '{{to}}'", {
                name: name,
                from: fromValue,
                to: toValue,
            }));
    });
    return {
        inspectionID: origDetails['_id'],
        standard: standard,
        updateDetails: changes,
        notes: log,
    };
};
exports.processFormSubmit = processFormSubmit;


/***/ }),

/***/ "./utils/currency.ts":
/*!***************************!*\
  !*** ./utils/currency.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCostCalculation = exports.getCurrencySymbol = exports.getCurrency = void 0;
var getCurrencySettings = function (companySettings) {
    var currencyShortCode = 'en-US';
    var currencyType = 'USD';
    if (companySettings != undefined &&
        companySettings.currencyFormatting != undefined &&
        companySettings.currencyFormatting.shortCode != undefined &&
        companySettings.currencyFormatting.currency != undefined) {
        currencyShortCode = companySettings.currencyFormatting.shortCode;
        currencyType = companySettings.currencyFormatting.currency;
    }
    return {
        shortCode: currencyShortCode,
        type: currencyType,
    };
};
/**
 * Get a formatted currency string
 * @param number Value to format
 * @param companySettings Compay Settings object for formatting
 * @param currency Optional currency code, use companySettings if not supplied
 * @returns Formated string or the number if invalid
 */
var getCurrency = function (number, companySettings, currency) {
    if (number == undefined)
        number = 0;
    try {
        var _a = getCurrencySettings(companySettings), shortCode = _a.shortCode, type = _a.type;
        return Intl.NumberFormat(shortCode, {
            style: 'currency',
            currency: currency !== null && currency !== void 0 ? currency : type,
        }).format(number);
    }
    catch (_b) {
        return number.toString();
    }
};
exports.getCurrency = getCurrency;
/**
 * Get the currency symbol
 * @param companySettings Compay Settings object for formatting
 * @param currency Optional currency code, use companySettings if not supplied
 * @returns Currency symbol or undefined if invalid
 */
var getCurrencySymbol = function (companySettings, currency) {
    var _a = getCurrencySettings(companySettings), shortCode = _a.shortCode, type = _a.type;
    try {
        var parts = Intl.NumberFormat(shortCode, {
            style: 'currency',
            currency: currency !== null && currency !== void 0 ? currency : type,
        }).formatToParts(undefined);
        var currencySymbol = parts.find(function (x) { return x.type == 'currency'; });
        return currencySymbol ? currencySymbol.value : undefined;
    }
    catch (_b) {
        return undefined;
    }
};
exports.getCurrencySymbol = getCurrencySymbol;
var getCostCalculation = function (costCalculation, companySettings) {
    if (costCalculation == undefined || costCalculation == '')
        return '';
    var _a = getCurrencySettings(companySettings), shortCode = _a.shortCode, type = _a.type;
    var regex = /\$\d*,?\d*,?\d*,?\d*,?\d*,?\d*\.?\d*/;
    return costCalculation.replace(regex, function (match) {
        return Intl.NumberFormat(shortCode, {
            style: 'currency',
            currency: type,
        }).format(+match.substring(1).replace(/,/g, ''));
    });
};
exports.getCostCalculation = getCostCalculation;


/***/ }),

/***/ "./utils/date.utils.ts":
/*!*****************************!*\
  !*** ./utils/date.utils.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fixupDateTimeForFilter = exports.formatTimeWithFormatDate = exports.formatDateWithFormatDate = exports.formatDateTimeWithFormatDate = exports.fixupDateTimeForInputDateTime = exports.formatTime = exports.formatDate = exports.formatDateTime = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var luxon_1 = __webpack_require__(/*! luxon */ "luxon");
/** @deprecated switch to using formatDateTimeWithFormatDate to use the useCompanyDateTime-FormatDate */
var formatDateTime = function (dateTime, companySettings, applyTimezoneConversion, returnEmpty) {
    try {
        if (dateTime.trim().length === 0 || dateTime.startsWith('1111-11-11')) {
            return returnEmpty ? '-' : '';
        }
        else {
            if (dateTime.length > 10) {
                // This somewhat ugly but expediant until we change to
                // using useCompayDateTime()
                // If string is datetime could be missing T and Z formatters - so add them in
                dateTime = dateTime.trimEnd().replace(' ', 'T');
                dateTime = dateTime.replace('+00:00', '');
                if (!dateTime.endsWith('Z'))
                    dateTime = dateTime + 'Z';
            }
            if (!dateTime) {
                return returnEmpty ? '-' : '';
            }
            var timezone = companySettings === null || companySettings === void 0 ? void 0 : companySettings.timeZoneIANA;
            var format = (0, stylovyze_1.getDateTimeFormat)(companySettings === null || companySettings === void 0 ? void 0 : companySettings.dateFormat, companySettings === null || companySettings === void 0 ? void 0 : companySettings.hourCycle12);
            if (timezone && applyTimezoneConversion) {
                return (0, stylovyze_1.iso8601DateToTimeZone)(dateTime, timezone, format);
            }
            return (0, stylovyze_1.iso8601DateToLocal)(dateTime, format);
        }
    }
    catch (_a) {
        return returnEmpty ? '-' : '';
    }
};
exports.formatDateTime = formatDateTime;
/** @deprecated switch to using formatDateWithFormatDate to use the useCompanyDateTime-FormatDate */
var formatDate = function (dateTime, companySettings, applyTimezoneConversion, returnEmpty) {
    try {
        if (dateTime.trim().length === 0 || dateTime.startsWith('1111-11-11')) {
            return returnEmpty ? '-' : '';
        }
        else {
            if (!dateTime) {
                return returnEmpty ? '-' : '';
            }
            // The format is (currently) fixed as 'date - time' so we can just split it out and get the correct date format
            var format = (0, stylovyze_1.getDateTimeFormat)(companySettings === null || companySettings === void 0 ? void 0 : companySettings.dateFormat, companySettings === null || companySettings === void 0 ? void 0 : companySettings.hourCycle12);
            var formatParts = format.split(' - ');
            var timezone = companySettings === null || companySettings === void 0 ? void 0 : companySettings.timeZoneIANA;
            if (timezone && applyTimezoneConversion) {
                return (0, stylovyze_1.iso8601DateToTimeZone)(dateTime, timezone, formatParts[0]);
            }
            return (0, stylovyze_1.iso8601DateToLocal)(dateTime, formatParts[0]);
        }
    }
    catch (_a) {
        return returnEmpty ? '-' : '';
    }
};
exports.formatDate = formatDate;
/** @deprecated switch to using formatTimeWithFormatDate to use the useCompanyDateTime-FormatDate */
var formatTime = function (dateTime, companySettings, applyTimezoneConversion, returnEmpty) {
    try {
        if (!dateTime) {
            return returnEmpty ? '-' : '';
        }
        if (dateTime.startsWith('1111-11-11')) {
            return returnEmpty ? '-' : '';
        }
        else {
            // The format is (currently) fixed as 'date - time' so we can just split it out and get the correct date format
            var format = (0, stylovyze_1.getDateTimeFormat)(companySettings === null || companySettings === void 0 ? void 0 : companySettings.dateFormat, companySettings === null || companySettings === void 0 ? void 0 : companySettings.hourCycle12);
            var formatParts = format.split(' - ');
            var timezone = companySettings === null || companySettings === void 0 ? void 0 : companySettings.timeZoneIANA;
            if (timezone && applyTimezoneConversion) {
                return (0, stylovyze_1.iso8601DateToTimeZone)(dateTime, timezone, formatParts[formatParts.length - 1]);
            }
            return (0, stylovyze_1.iso8601DateToLocal)(dateTime, formatParts[formatParts.length - 1]);
        }
    }
    catch (_a) {
        return returnEmpty ? '-' : '';
    }
};
exports.formatTime = formatTime;
/**
 * Fixup date time strings for use in InputDateTime to allow for naive or system locale dates
 * @param dateTime the date time to adjust
 * @param currentDateTime optional if adjusting to system locale dates as supplied by useCompanyDateTime() -> currentDateTime()
 * @param returnEmpty true to return '-' for empty or invalid date times
 * @returns an adjusted datetime string
 */
var fixupDateTimeForInputDateTime = function (dateTime, currentDateTime, returnEmpty) {
    try {
        if (dateTime === undefined ||
            dateTime.trim().length === 0 ||
            dateTime === '1111-11-11T00:00:00.000Z') {
            return returnEmpty ? '-' : '';
        }
        else {
            if (dateTime.length > 10) {
                dateTime = dateTime.trimEnd().replace(' ', 'T');
                dateTime = dateTime.replace('+00:00', '');
                dateTime = dateTime.replace('Z', '');
            }
            // Adjust the date time time zone if needed
            if (currentDateTime !== undefined) {
                // Get the correct offset based on the actuall date time to account for BST
                var filterZone = luxon_1.DateTime.fromISO(dateTime + 'Z');
                filterZone = filterZone.setZone(currentDateTime.zone);
                var offset = filterZone.offset * 60000;
                if (offset !== 0) {
                    // Add the offset to get to the currentDateTime time zone
                    var filterDate = new Date(dateTime + 'Z');
                    filterDate.setTime(filterDate.getTime() + offset);
                    return filterDate.toISOString().substring(0, 16);
                }
                else {
                    return dateTime;
                }
            }
            else {
                return dateTime;
            }
        }
    }
    catch (_a) {
        return returnEmpty ? '-' : '';
    }
};
exports.fixupDateTimeForInputDateTime = fixupDateTimeForInputDateTime;
/**
 * Format a dateTime string to a Date+Time according the the formatDate object
 * @param dateTime the date string to convert
 * @param formatDate the formatDate object from useCompanyDateTime() or useTzDateTime({ timeZone: 'UTC' }) for displaying naive dates
 * @param returnEmpty if the date is empty then true to return the empty '-', false to return ''
 * @param keepLocalTime the functionality of this will depend on where formatDate is from but probably not needed.
 * @returns a formatted date string or '-'/''
 */
var formatDateTimeWithFormatDate = function (dateTime, formatDate, returnEmpty, keepLocalTime) {
    // Check for empty dates
    var fixup = (0, exports.fixupDateTimeForInputDateTime)(dateTime);
    if (fixup !== '') {
        // Is it actually a year object?
        if (fixup.endsWith('11-11T11:11:11')) {
            return fixup.substring(0, 4);
        }
        else {
            // Add the Z back otherwise formatDate has odd behaviour with the keepLocalTime
            fixup += 'Z';
            return formatDate({
                date: fixup,
                format: 'date-time',
                zoneOptions: { keepLocalTime: keepLocalTime },
                dateTimeSeparator: ' - ',
            });
        }
    }
    else {
        return returnEmpty ? '-' : '';
    }
};
exports.formatDateTimeWithFormatDate = formatDateTimeWithFormatDate;
/**
 * Format a dateTime string to a Date according the the formatDate object
 * @param dateTime the date string to convert
 * @param formatDate the formatDate object from useCompanyDateTime() or useTzDateTime({ timeZone: 'UTC' }) for displaying naive dates
 * @param returnEmpty if the date is empty then true to return the empty '-', false to return ''
 * @param keepLocalTime the functionality of this will depend on where formatDate is from but probably not needed.
 * @returns a formatted date string or '-'/''
 */
var formatDateWithFormatDate = function (dateTime, formatDate, returnEmpty, keepLocalTime) {
    // Check for empty dates
    var fixup = (0, exports.fixupDateTimeForInputDateTime)(dateTime);
    if (fixup !== '') {
        // Add the Z back otherwise formatDate has odd behaviour with the keepLocalTime
        fixup += 'Z';
        return formatDate({
            date: fixup,
            format: 'date',
            zoneOptions: { keepLocalTime: keepLocalTime },
        });
    }
    else {
        return returnEmpty ? '-' : '';
    }
};
exports.formatDateWithFormatDate = formatDateWithFormatDate;
/**
 * Format a dateTime string to a Time according the the formatDate object
 * @param dateTime the date string to convert
 * @param formatDate the formatDate object from useCompanyDateTime() or useTzDateTime({ timeZone: 'UTC' }) for displaying naive dates
 * @param keepLocalTime the functionality of this will depend on where formatDate is from but probably not needed.
 * @param returnEmpty if the date is empty then true to return the empty '-', false to return ''
 * @returns a formatted date string or '-'/''
 */
var formatTimeWithFormatDate = function (dateTime, formatDate, keepLocalTime, returnEmpty) {
    // Check for empty dates
    var fixup = (0, exports.fixupDateTimeForInputDateTime)(dateTime);
    if (fixup !== '') {
        // Add the Z back otherwise formatDate has odd behaviour with the keepLocalTime
        fixup += 'Z';
        return formatDate({
            date: fixup,
            format: 'time',
            zoneOptions: { keepLocalTime: keepLocalTime },
        });
    }
    else {
        return returnEmpty ? '-' : '';
    }
};
exports.formatTimeWithFormatDate = formatTimeWithFormatDate;
/** Fixup the filter before sending it to the server to adjust the sent value for any LOCAL times as these are kept in zulu time on the server and the default DataGrid filter date editor just returns a non timezone datetime
 * Made even more akward as the timezone displayed is based on the I360 time zone setting
 * @param filterModel the filter from the datagrid
 * @param fields a list of the fields to adjust
 * @param currentDateTime the currentDateTime as supplied by useCompanyDateTime() -> currentDateTime() or useTzDateTime({ timeZone: 'UTC' }) -> currentDateTime() depending on normal or naive date
 */
var fixupDateTimeForFilter = function (filterModel, fields, currentDateTime) {
    if (filterModel.items.length !== 0) {
        // Adjust from mins to ms
        var offset_1 = currentDateTime.offset * 60000;
        if (offset_1 !== 0) {
            var items = filterModel.items.map(function (item) {
                if (fields.find(function (value) { return value === item.field; })) {
                    var filterDate = new Date(item.value);
                    // Subtract the offset to get to the zulu time
                    filterDate.setTime(filterDate.getTime() - offset_1);
                    return __assign(__assign({}, item), { value: (0, exports.fixupDateTimeForInputDateTime)(filterDate.toISOString()).substring(0, 16) });
                }
                else {
                    return item;
                }
            });
            return __assign(__assign({}, filterModel), { items: items });
        }
    }
    return filterModel;
};
exports.fixupDateTimeForFilter = fixupDateTimeForFilter;


/***/ }),

/***/ "./utils/index.ts":
/*!************************!*\
  !*** ./utils/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./search.utils */ "./utils/search.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./date.utils */ "./utils/date.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./mapConfigLayers.utils */ "./utils/mapConfigLayers.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./mapDataServices.utils */ "./utils/mapDataServices.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./mapDataServicesMainMap.utils */ "./utils/mapDataServicesMainMap.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./mapDefinitions.utils */ "./utils/mapDefinitions.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./mapSelections.utils */ "./utils/mapSelections.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./server.utils */ "./utils/server.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./standard.utils */ "./utils/standard.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./properties.utils */ "./utils/properties.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./table.utils */ "./utils/table.utils.tsx"), exports);
__exportStar(__webpack_require__(/*! ./currency */ "./utils/currency.ts"), exports);
__exportStar(__webpack_require__(/*! ./time */ "./utils/time.ts"), exports);
__exportStar(__webpack_require__(/*! ./observationCodes */ "./utils/observationCodes.ts"), exports);
__exportStar(__webpack_require__(/*! ./units.utils */ "./utils/units.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./videoPlayer.utils */ "./utils/videoPlayer.utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./urlFormatting */ "./utils/urlFormatting.ts"), exports);
__exportStar(__webpack_require__(/*! ./useWebSockets */ "./utils/useWebSockets.ts"), exports);


/***/ }),

/***/ "./utils/mapConfigLayers.utils.ts":
/*!****************************************!*\
  !*** ./utils/mapConfigLayers.utils.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.configLayers = exports.mapGeometryType = exports.layerNameToId = exports.riskLayers = void 0;
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var index_1 = __webpack_require__(/*! ./index */ "./utils/index.ts");
var lib_asset_schema_1 = __webpack_require__(/*! @innovyze/lib_asset_schema */ "@innovyze/lib_asset_schema");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var index_2 = __importDefault(__webpack_require__(/*! @Store/index */ "./store/index.ts"));
var debugRiskValues = false;
var riskValues = debugRiskValues
    ? [-1, 0, 1, 2, 3, 4, 5]
    : [0, 1, 2, 3, 4, 5];
// This function just to dance around the TS array/tuple madness
// of LSP that gets confused between [number, number] and number[]
var propertyLevel = function (key, level) {
    var p = {};
    p[key] = [level - 0.5, level + 0.5];
    return p;
};
function createTileSourceRegExp(assetType) {
    var systemType = (0, lib_asset_schema_1.getSystemTypeIdByAssetTypePrefix)(assetType);
    return new RegExp("^".concat(systemType, "(-").concat(assetType, ")?$"));
}
var riskLayerGroup = function (opts, name, zIndex, groupCount, groupIndex, assetType) {
    var _a;
    if (assetType === void 0) { assetType = 'wwPipe'; }
    var isManhole = assetType.toLowerCase().includes('manhole');
    var layers = isManhole
        ? [0, 1, 2, 3, 4].map(function (n) { return ({
            layerName: index_1.riskGradeLayerNames[n],
            type: 'symbol',
            icon: 'manhole-survey',
            color: index_1.riskGradeColours[n],
            properties: propertyLevel("risk".concat(groupIndex), n),
            selectable: false,
        }); })
        : [0, 1, 2, 3, 4].map(function (n) { return ({
            layerName: index_1.riskGradeLayerNames[n],
            type: 'line',
            color: index_1.riskGradeColours[n],
            properties: propertyLevel("risk".concat(groupIndex), n),
            selectable: false,
        }); });
    return {
        layerName: name,
        dataServiceId: (_a = opts === null || opts === void 0 ? void 0 : opts.dataServiceId) !== null && _a !== void 0 ? _a : '',
        tileSource: createTileSourceRegExp(assetType),
        tileLayerName: assetType,
        zIndex: zIndex + groupCount - groupIndex,
        layers: layers,
    };
};
var getGeometryType = function (assetType) {
    index_2.default.dispatch((0, lib_asset_schema_store_1.getAssetSchemaAction)({ assetType: assetType !== null && assetType !== void 0 ? assetType : '' }));
    var state = index_2.default.getState();
    var assetSchema = (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, assetType !== null && assetType !== void 0 ? assetType : '');
    return assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.geometryType;
};
var getLayerConfigFromGeometryType = function (geometryType) {
    switch (geometryType) {
        case 'Point':
            return {
                type: 'symbol',
                icon: 'manhole-survey',
            };
        case 'Polygon':
            return {
                type: 'polygon',
            };
        default:
            return {
                type: 'line',
            };
    }
};
var riskTilesLayerGroup = function (name, zIndex, groupCount, groupIndex, configId, assetType) {
    if (assetType === void 0) { assetType = 'wwPipe'; }
    var geometryType = getGeometryType(assetType);
    var layerConfig = getLayerConfigFromGeometryType(geometryType);
    var layers = [0, 1, 2, 3, 4].map(function (n) { return (__assign(__assign({ layerName: index_1.riskGradeLayerNames[n], id: "risk".concat(configId, "-").concat(n), dataServiceId: "Risk/".concat(configId) }, layerConfig), { color: index_1.riskGradeColours[n], properties: {
            riskGrade: [n - 0.5, n + 0.5],
        }, selectable: false })); });
    var layer = {
        layerName: name,
        tileSource: "Risk/".concat(configId),
        tileLayerName: configId.replaceAll('-', ''),
        zIndex: zIndex + groupCount - groupIndex,
        layers: layers,
    };
    return layer;
};
var riskLayers = function (opts, riskLayers, isTiledRiskEnabled) {
    if (riskLayers === void 0) { riskLayers = []; }
    if (isTiledRiskEnabled === void 0) { isTiledRiskEnabled = false; }
    if (riskLayers.length < 1) {
        return [];
    }
    var zIndexLevelRisk = 10;
    if (isTiledRiskEnabled) {
        return [
            {
                layerName: 'Risk levels',
                dataServiceId: 'tiled-risk',
                layers: riskLayers.map(function (l, n) {
                    var _a;
                    return riskTilesLayerGroup(l.name, zIndexLevelRisk, riskLayers.length, n, (_a = l.configId) !== null && _a !== void 0 ? _a : '', l.assetType);
                }),
            },
        ];
    }
    else {
        return [
            {
                layerName: 'Risk levels',
                layers: riskLayers.map(function (l, n) {
                    return riskLayerGroup(opts, l.name, zIndexLevelRisk, riskLayers.length, n, l.assetType);
                }),
            },
        ];
    }
};
exports.riskLayers = riskLayers;
var cctvLayers = function (opts, noMinZoom) {
    if (noMinZoom === void 0) { noMinZoom = false; }
    return riskValues.map(function (n) {
        var _a, _b;
        return ({
            layerName: "".concat(n),
            id: "cctv".concat(n),
            dataServiceId: (_a = opts === null || opts === void 0 ? void 0 : opts.dataServiceId) !== null && _a !== void 0 ? _a : '',
            type: 'line',
            color: index_1.ratingColours[n],
            lineWidth: 5,
            zIndex: 1000 + n,
            minZoom: noMinZoom ? 0 : (_b = opts === null || opts === void 0 ? void 0 : opts.minZoom) !== null && _b !== void 0 ? _b : 0,
            properties: {
                rating: [n - 0.5, n + 0.5],
            },
            selectable: false,
        });
    });
};
var tiledCctvLayers = function () {
    return riskValues.map(function (n) { return ({
        layerName: "".concat(n),
        id: "cctv".concat(n),
        dataServiceId: 'tiled-inspections',
        type: 'line',
        color: index_1.ratingColours[n],
        lineWidth: 5,
        zIndex: 1000 + n,
        properties: {
            rating: [n - 0.5, n + 0.5],
        },
        selectable: false,
    }); });
};
var observationLayers = function (opts, noMinZoom) {
    if (noMinZoom === void 0) { noMinZoom = false; }
    return riskValues.map(function (n) {
        var _a, _b;
        return ({
            layerName: "".concat(n),
            id: "obs".concat(n),
            dataServiceId: (_a = opts === null || opts === void 0 ? void 0 : opts.dataServiceId) !== null && _a !== void 0 ? _a : '',
            type: 'symbol',
            icon: 'defect',
            color: index_1.ratingColours[n],
            labelColor: index_1.ratingColours[n],
            zIndex: 1100 + n,
            minZoom: noMinZoom ? 0 : (_b = opts === null || opts === void 0 ? void 0 : opts.minZoom) !== null && _b !== void 0 ? _b : 0,
            properties: {
                rating: [n - 0.5, n + 0.5],
            },
            selectable: false,
        });
    });
};
var tiledObservationLayers = function () {
    return riskValues.map(function (n) { return ({
        layerName: "".concat(n),
        id: "obs".concat(n),
        dataServiceId: 'tiled-inspections',
        type: 'symbol',
        icon: 'defect',
        color: index_1.ratingColours[n],
        labelColor: index_1.ratingColours[n],
        zIndex: 1100 + n,
        properties: {
            rating: [n - 0.5, n + 0.5],
        },
        selectable: false,
    }); });
};
var manholeSurveyLayers = function (opts, noMinZoom) {
    if (noMinZoom === void 0) { noMinZoom = false; }
    return riskValues.map(function (n) {
        var _a;
        return ({
            layerName: "".concat(n),
            id: "manhole-survey-".concat(n),
            dataServiceId: opts === null || opts === void 0 ? void 0 : opts.dataServiceId,
            type: 'symbol',
            icon: 'manhole-survey',
            color: index_1.ratingColours[n],
            lineWidth: 5,
            zIndex: 1000 + n,
            minZoom: noMinZoom ? 0 : (_a = opts === null || opts === void 0 ? void 0 : opts.minZoom) !== null && _a !== void 0 ? _a : 0,
            properties: {
                rating: [n - 0.5, n + 0.5],
            },
            selectable: false,
        });
    });
};
var tiledManholeSurveyLayers = function () {
    return riskValues.map(function (n) { return ({
        layerName: "".concat(n),
        id: "manhole-survey-".concat(n),
        dataServiceId: 'tiled-inspections',
        type: 'symbol',
        icon: 'manhole-survey',
        color: index_1.ratingColours[n],
        lineWidth: 5,
        zIndex: 1000 + n,
        properties: {
            rating: [n - 0.5, n + 0.5],
        },
        selectable: false,
    }); });
};
var inspectionLayers = function (inspectionSources, noMinZoom, isTiledInspectionsEnabled) {
    var _a, _b, _c;
    if (noMinZoom === void 0) { noMinZoom = false; }
    if (isTiledInspectionsEnabled === void 0) { isTiledInspectionsEnabled = false; }
    var cctvSource = inspectionSources.find(function (n) { return n.dataServiceId === index_1.inspectionCctv; });
    var cctvObsSource = inspectionSources.find(function (n) { return n.dataServiceId === index_1.inspectionCctvObs; });
    var manholeSource = inspectionSources.find(function (n) { return n.dataServiceId === index_1.inspectionManhole; });
    var hasCctv = cctvSource || cctvObsSource;
    var cctvs = hasCctv
        ? [
            {
                layerName: (_a = cctvSource === null || cctvSource === void 0 ? void 0 : cctvSource.layerName) !== null && _a !== void 0 ? _a : '',
                layers: [
                    cctvLayers(cctvSource, noMinZoom),
                    {
                        layerName: (_b = cctvObsSource === null || cctvObsSource === void 0 ? void 0 : cctvObsSource.layerName) !== null && _b !== void 0 ? _b : '',
                        layers: observationLayers(cctvObsSource, noMinZoom),
                    },
                ].flat(),
            },
        ]
        : [];
    var tiledCctvs = [
        {
            layerName: 'CCTV',
            tileSource: 'tiled-inspections',
            tileLayerName: /[Ii]nspections/,
            layers: [
                tiledCctvLayers(),
                {
                    layerName: 'Observations',
                    tileSource: 'tiled-inspections',
                    tileLayerName: /[Dd]efects/,
                    layers: tiledObservationLayers(),
                },
            ].flat(),
        },
    ];
    var manholes = manholeSource
        ? [
            {
                layerName: (_c = manholeSource === null || manholeSource === void 0 ? void 0 : manholeSource.layerName) !== null && _c !== void 0 ? _c : '',
                layers: manholeSurveyLayers(manholeSource, noMinZoom),
            },
        ]
        : [];
    var tiledManholes = [
        {
            layerName: 'Manhole surveys',
            tileSource: 'tiled-inspections',
            tileLayerName: /[Mm]anhole_[Ss]urveys/,
            layers: tiledManholeSurveyLayers(),
        },
    ];
    var layers = [cctvs, manholes].flat();
    var tiledLayers = [tiledCctvs, tiledManholes].flat();
    if (isTiledInspectionsEnabled) {
        return tiledLayers.length > 0
            ? [
                {
                    layerName: 'Inspections',
                    dataServiceId: 'tiled-inspections',
                    layers: tiledLayers,
                },
            ]
            : [];
    }
    return layers.length > 0
        ? [
            {
                layerName: index_1.inspectionsLayerName,
                layers: layers,
            },
        ]
        : [];
};
var rehabLayers = function (opts, mapLayers) {
    var _a;
    if (mapLayers === void 0) { mapLayers = []; }
    if (mapLayers.length < 1) {
        return;
    }
    return {
        layerName: 'Rehab',
        dataServiceId: (_a = opts === null || opts === void 0 ? void 0 : opts.dataServiceId) !== null && _a !== void 0 ? _a : '',
        layers: mapLayers.map(function (l, treeIndex) {
            var _a;
            var geometryType = getGeometryType(l.assetType);
            var layerConfig = getLayerConfigFromGeometryType(geometryType);
            return {
                layerName: l.layerName,
                id: l.id,
                tileSource: createTileSourceRegExp(l.assetType),
                tileLayerName: l.assetType,
                zIndex: 100 + treeIndex,
                layers: (_a = l.layers) === null || _a === void 0 ? void 0 : _a.map(function (layer, i) {
                    var _a;
                    return (__assign(__assign(__assign({}, layer), layerConfig), { color: index_1.rehabColors[i], properties: (_a = {},
                            _a["rehab".concat(treeIndex)] = layer.layerName,
                            _a) }));
                }),
            };
        }),
    };
};
var layerNameToId = function (layerName) {
    return layerName.replace(/[\s-]/g, '').toLowerCase();
};
exports.layerNameToId = layerNameToId;
var mapGeometryType = function (layer) {
    // SpatialLayer return CSV for all the GeoJson geometry types
    // in the imported FaetureCollection.
    // Hopfully these will all be of the same type, but that is
    // not actually guarentied. Hence the CSV
    var _a, _b;
    // 2do refactor
    // saas_risk_management provides a GEOMETRY_TYPE called feature_type
    // in an interface confusingly also called SPATIAL_LAYER in app_am_asset_upload
    // Sadly this is actually only the value of the 1st feature in the FeatureCollection
    // so could be misleading, it is got from the SPATIAL_DATA snowflake table.
    // Currently the risk version is just used as a label in the
    // UI so just misleading rather than wrong. As mentioned earlier we cannot really
    // support mixed geometry types in a single FeatureCollection upload currently
    // (at least as far as the map is concerned). When
    // we do; we should also change the saas_risk_management response to use this method.
    // 'Like' as these pick up on 'Multi' versions as well
    var geometryType = (_b = (_a = layer.GEOMETRY_TYPE) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
    var isPointLike = geometryType.includes(shared_utils_1.PointType.toLowerCase());
    var isLineStringLike = geometryType.includes(shared_utils_1.LineStringType.toLowerCase());
    var isPolygonLike = geometryType.includes(shared_utils_1.PolygonType.toLowerCase());
    if (!isPolygonLike && !isLineStringLike && !isPointLike) {
        // Not specified, was layer ingested pre GEOMETRY_TYPE table
        console.warn('mapGeometryType SPATIAL_LAYERS missing valid GEOMETRY_TYPE (guessed "symbol")');
        console.warn(layer);
        // guessing symol as at least coords of line/polygon should render as symbols - so showing something
        return 'symbol';
    }
    if (isPolygonLike && !isLineStringLike && !isPointLike) {
        return 'polygon';
    }
    if (!isPolygonLike && isLineStringLike && !isPointLike) {
        return 'line';
    }
    if (!isPolygonLike && !isLineStringLike && isPointLike) {
        return 'symbol';
    }
    // Got a mixture, not supported - return 'highest' type
    console.warn('mapGeometryType contains mixture (highest used now)');
    console.warn("  Polygon: ".concat(isPolygonLike));
    console.warn("  LineString: ".concat(isLineStringLike));
    console.warn("  Point: ".concat(isPointLike));
    return isPolygonLike ? 'polygon' : 'line';
};
exports.mapGeometryType = mapGeometryType;
var configLayers = function (token, options, spatialLayers, isTiledInspectionsEnabled, isTiledRiskEnabled) {
    var _a;
    if (spatialLayers === void 0) { spatialLayers = []; }
    if (isTiledInspectionsEnabled === void 0) { isTiledInspectionsEnabled = false; }
    if (isTiledRiskEnabled === void 0) { isTiledRiskEnabled = false; }
    var layers = [];
    if (options.tilesSource && !options.tilesSourceHide) {
        layers.push((0, inno_map_1.tilesConfigCreator)({
            layerName: options.tilesSource.layerName,
            dataServiceId: options.tilesSource.dataServiceId,
            requestToken: token,
        }, options.tilesSource.url));
    }
    if (options.rehabLayers) {
        var rehabLayerConfig = rehabLayers(options.tilesSource, options.rehabLayers);
        if (rehabLayerConfig) {
            layers.push(rehabLayerConfig);
        }
    }
    if (options.showRisk) {
        (0, exports.riskLayers)(options.tilesSource, options.riskLayers, isTiledRiskEnabled).forEach(function (l) { return layers.push(l); });
    }
    if (options.inspectionSources && options.inspectionSources.length > 0) {
        inspectionLayers(options.inspectionSources, options.generalOptions.noMinZoom, isTiledInspectionsEnabled).forEach(function (l) { return layers.push(l); });
    }
    if (options.otherSource) {
        if (spatialLayers.length &&
            ((_a = options === null || options === void 0 ? void 0 : options.useSpecifiedSpatialLayer) !== null && _a !== void 0 ? _a : false)) {
            spatialLayers.forEach(function (l) {
                var _a, _b, _c, _d;
                return layers.push({
                    id: (0, exports.layerNameToId)(l.LAYER_NAME),
                    layerName: l.LAYER_NAME,
                    tileSource: (_b = (_a = options.otherSource) === null || _a === void 0 ? void 0 : _a.dataServiceId) !== null && _b !== void 0 ? _b : 'UNDEFINED',
                    tileLayerName: (0, exports.layerNameToId)(l.LAYER_NAME),
                    dataServiceId: (_d = (_c = options.otherSource) === null || _c === void 0 ? void 0 : _c.dataServiceId) !== null && _d !== void 0 ? _d : 'UNDEFINED',
                    type: (0, exports.mapGeometryType)(l),
                });
            });
        }
        else {
            layers.push((0, inno_map_1.tilesJsonConfigCreator)({
                layerName: options.otherSource.layerName,
                dataServiceId: options.otherSource.dataServiceId,
                tileSource: options.otherSource.dataServiceId,
                requestToken: token,
            }, options.otherSource.url));
        }
    }
    return layers;
};
exports.configLayers = configLayers;


/***/ }),

/***/ "./utils/mapDataServices.utils.ts":
/*!****************************************!*\
  !*** ./utils/mapDataServices.utils.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataServices = void 0;
var _Apis_1 = __webpack_require__(/*! @Apis */ "./apis/index.ts");
var mapDefinitions_utils_1 = __webpack_require__(/*! ./mapDefinitions.utils */ "./utils/mapDefinitions.utils.ts");
var queryExtent = function (opts, extent) {
    return opts.useBBox && extent && extent.length === 4
        ? "&bbox=".concat(extent[0].toFixed(opts.precisionLonLat)) +
            ",".concat(extent[1].toFixed(opts.precisionLonLat)) +
            ",".concat(extent[2].toFixed(opts.precisionLonLat)) +
            ",".concat(extent[3].toFixed(opts.precisionLonLat))
        : '';
};
var queryLLR = function (opts, position, radius) {
    return position && radius
        ? "&lon=".concat(position.center[0].toFixed(opts.precisionLonLat)) +
            "&lat=".concat(position.center[1].toFixed(opts.precisionLonLat)) +
            "&rad=".concat(radius.toFixed(opts.precisionRadius))
        : '';
};
var queryOthers = function (opts) {
    return opts.singlePage ? '&singlePage=1' : '';
};
var query = function (opts, location) {
    return queryLLR(opts, location.position, location.radius) +
        queryExtent(opts, location.extent) +
        queryOthers(opts);
};
var url = function (source, opts, location) { return "".concat(source.url, "?").concat(query(opts, location).slice(1)); };
var dataServices = function (token, options, location) {
    if (!token) {
        return [];
    }
    var sources = [];
    if (options.tilesSource) {
        sources.push({
            displayName: options.tilesSource.layerName,
            id: options.tilesSource.dataServiceId,
            type: options.tilesSource.type,
            url: options.tilesSource.url,
            token: token,
            propsUrl: {
                any: "".concat(_Apis_1.assetsBaseUrl, "assets/{{assetId}}?assetId={{assetId}}&assetType={{assetType}}"),
                sensor: "".concat(_Apis_1.assetsBaseUrl, "sensors/{{assetId}}"),
            },
            propertyLookup: {
                risk: (0, mapDefinitions_utils_1.propertyLookupRiskScore)(),
            },
        });
    }
    if (options.inspectionSources && location && location.extent) {
        options.inspectionSources.forEach(function (s) {
            sources.push({
                displayName: s.layerName,
                id: s.dataServiceId,
                type: s.type,
                url: url(s, options.generalOptions, location),
                token: token,
            });
        });
    }
    if (options.otherSource) {
        sources.push({
            displayName: options.otherSource.layerName,
            id: options.otherSource.dataServiceId,
            type: options.otherSource.type,
            url: options.otherSource.url,
            token: token,
        });
    }
    return sources;
};
exports.dataServices = dataServices;


/***/ }),

/***/ "./utils/mapDataServicesMainMap.utils.ts":
/*!***********************************************!*\
  !*** ./utils/mapDataServicesMainMap.utils.ts ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataServicesMainMap = exports.queryOptionsDefault = void 0;
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var _Apis_1 = __webpack_require__(/*! @Apis */ "./apis/index.ts");
var index_1 = __webpack_require__(/*! ./index */ "./utils/index.ts");
var mapDefinitions_utils_1 = __webpack_require__(/*! ./mapDefinitions.utils */ "./utils/mapDefinitions.utils.ts");
exports.queryOptionsDefault = {
    radiusDefault: 5000,
    boundMargin: 1.02,
    useBBox: true,
    singlePage: true,
    precisionLonLat: 6,
    precisionRadius: 0,
};
var queryBBox = function (opts, bbox) {
    return opts.useBBox && bbox && bbox.length === 4
        ? "&bbox=".concat(bbox[0].toFixed(opts.precisionLonLat)) +
            ",".concat(bbox[1].toFixed(opts.precisionLonLat)) +
            ",".concat(bbox[2].toFixed(opts.precisionLonLat)) +
            ",".concat(bbox[3].toFixed(opts.precisionLonLat))
        : '';
};
var queryLLR = function (opts, position, radius) {
    return position && radius
        ? "&lon=".concat(position.center[0].toFixed(opts.precisionLonLat)) +
            "&lat=".concat(position.center[1].toFixed(opts.precisionLonLat)) +
            "&rad=".concat(radius.toFixed(opts.precisionRadius))
        : '';
};
var queryOthers = function (opts) {
    return opts.singlePage ? '&singlePage=1' : '';
};
var query = function (opts, position, radius, bbox) {
    return queryLLR(opts, position, radius) +
        queryBBox(opts, bbox) +
        queryOthers(opts);
};
var url = function (source, opts, position, radius, bbox) { return "".concat(source.url, "?").concat(query(opts, position, radius, bbox).slice(1)); };
// Would like to use this rather than propertyLookupIndex
// but currently need to set propertyLookup to valid calls
// on first dataServices load - subsequent changes are
// ignored in inno-map
var propertyLookupVersion = function (layers) {
    if (layers === void 0) { layers = []; }
    var p = {};
    for (var n = 0; n < layers.length; ++n) {
        p["risk".concat(n)] = (0, mapDefinitions_utils_1.propertyLookupRiskScoreVersion)(layers[n].versionId);
    }
    return p;
};
var propertyLookupIndex = function (riskGroupCount) {
    if (riskGroupCount === void 0) { riskGroupCount = 0; }
    var p = {};
    for (var n = 0; n < riskGroupCount; ++n) {
        p["risk".concat(n)] = (0, mapDefinitions_utils_1.propertyLookupRiskScoreGroup)(n);
    }
    return p;
};
var propertyLookupRehab = function (layers) {
    if (layers === void 0) { layers = []; }
    var p = {};
    for (var n = 0; n < layers.length; ++n) {
        p["rehab".concat(n)] = (0, mapDefinitions_utils_1.propertyLookupRehabResults)(layers[n].id, layers[n].lastRun, layers[n].assetType);
    }
    return p;
};
var dataServicesMainMap = function (options, token, position, radius, bbox, riskGroupCountLimit, isTiledInspectionsEnabled, isTiledRiskEnabled) {
    var _a, _b, _c, _d, _e;
    if (riskGroupCountLimit === void 0) { riskGroupCountLimit = -1; }
    if (isTiledInspectionsEnabled === void 0) { isTiledInspectionsEnabled = false; }
    if (isTiledRiskEnabled === void 0) { isTiledRiskEnabled = false; }
    if (!token) {
        return [];
    }
    // Would like to use version rather than index
    // but currently need to set propertyLookup to valid calls
    // on first dataServices load - as subsequent changes are
    // ignored in inno-map
    var propertyLookup = !isTiledRiskEnabled && riskGroupCountLimit > 1
        ? propertyLookupIndex(riskGroupCountLimit)
        : propertyLookupVersion((_a = options.riskLayers) !== null && _a !== void 0 ? _a : []);
    var rehabPropertyLookup = propertyLookupRehab((_b = options.rehabLayers) !== null && _b !== void 0 ? _b : []);
    var tiles = options.tilesSource
        ? [
            {
                id: options.tilesSource.dataServiceId,
                type: options.tilesSource.type,
                url: options.tilesSource.url,
                token: token,
                propertyLookup: __assign(__assign({}, propertyLookup), rehabPropertyLookup),
                attributesUrl: _Apis_1.assetsBaseUrl,
            },
        ]
        : [];
    var inspections = [];
    if (position && !isTiledInspectionsEnabled) {
        var inspectionSources = (_c = options.inspectionSources) !== null && _c !== void 0 ? _c : index_1.defaultInspectionSources;
        var inspectionQueryOptions_1 = (_d = options.generalOptions) !== null && _d !== void 0 ? _d : exports.queryOptionsDefault;
        inspectionSources.forEach(function (s) {
            var _a;
            if (((_a = s === null || s === void 0 ? void 0 : s.minZoom) !== null && _a !== void 0 ? _a : 0) <= position.zoom) {
                inspections === null || inspections === void 0 ? void 0 : inspections.push({
                    type: s.type,
                    id: s.dataServiceId,
                    displayName: s.layerName,
                    token: token,
                    url: url(s, inspectionQueryOptions_1, position, radius, bbox),
                });
            }
        });
    }
    var risk = [];
    // Create risk tile data services if tiled risk is enabled and we have valid risk layers
    if (isTiledRiskEnabled && options.riskLayers) {
        var riskSources = options.riskLayers;
        riskSources.forEach(function (s) {
            risk.push({
                id: "Risk/".concat(s.configId),
                type: inno_map_1.SourceType.TILES,
                url: "".concat(_Apis_1.tilesBaseUrl, "/v1/tile-json/Risk/").concat(s.configId),
                token: token,
            });
        });
    }
    var otherSource = (_e = options.otherSource) !== null && _e !== void 0 ? _e : index_1.otherOptions;
    var other = otherSource
        ? [
            {
                id: otherSource.dataServiceId,
                type: otherSource.type,
                url: otherSource.url,
                token: token,
                attributesUrl: _Apis_1.riskBaseUrl,
            },
        ]
        : [];
    var tiledInspections = isTiledInspectionsEnabled
        ? [
            {
                id: 'tiled-inspections',
                type: inno_map_1.SourceType.TILES,
                url: "".concat(_Apis_1.tilesBaseUrl, "/v1/tile-json/Inspections"),
                token: token,
            },
        ]
        : [];
    return [tiles, inspections, other, tiledInspections, risk].flat(2);
};
exports.dataServicesMainMap = dataServicesMainMap;


/***/ }),

/***/ "./utils/mapDefinitions.utils.ts":
/*!***************************************!*\
  !*** ./utils/mapDefinitions.utils.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rehabColors = exports.toExtent = exports.inspectionSources = exports.assetType = exports.riskGradeLayerNames = exports.riskGradeColours = exports.ratingColours = exports.generalOptionsDefault = exports.defaultInspectionSources = exports.manholeSurveys = exports.cctvObservations = exports.cctv = exports.inspectionsLayerName = exports.inspectionManhole = exports.inspectionCctvObs = exports.inspectionCctv = exports.otherOptions = exports.tileOptions = exports.minPositionExtent = exports.minPositionSearchRadius = exports.zoomSelectionPoint = exports.zoomSelectionDefault = exports.zoomShowManholeSurveys = exports.zoomShowPipeSurveys = exports.zoomShowInspections = exports.propertyLookupRehabResults = exports.propertyLookupRiskScoreVersion = exports.propertyLookupRiskScoreGroup = exports.propertyLookupRiskScore = exports.dummyToken = void 0;
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var _Apis_1 = __webpack_require__(/*! @Apis */ "./apis/index.ts");
var _Utils_1 = __webpack_require__(/*! @Utils */ "./utils/index.ts");
var inno_map_1 = __webpack_require__(/*! @innovyze/inno-map */ "@innovyze/inno-map");
var index_1 = __webpack_require__(/*! @Services/index */ "./services/index.ts");
var rehab_api_1 = __webpack_require__(/*! @Apis/rehab.api */ "./apis/rehab.api.ts");
var _Apis_2 = __webpack_require__(/*! @Apis */ "./apis/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
exports.dummyToken = 'dummy-token';
var propertyLookupRiskScore = function (hiddenRanges) {
    if (hiddenRanges === void 0) { hiddenRanges = ''; }
    return "".concat(_Apis_2.riskBaseUrl).concat((0, index_1.mapRiskLayersAddress)('grades', hiddenRanges));
};
exports.propertyLookupRiskScore = propertyLookupRiskScore;
// 2do combine with above
var propertyLookupRiskScoreGroup = function (groupIndex) {
    if (groupIndex === void 0) { groupIndex = 0; }
    return "".concat(_Apis_2.riskBaseUrl, "risk/score?mapTheme=group&sort=alpha&mapThemeGroup=").concat(groupIndex);
};
exports.propertyLookupRiskScoreGroup = propertyLookupRiskScoreGroup;
var propertyLookupRiskScoreVersion = function (versionId) {
    return "".concat(_Apis_2.riskBaseUrl, "risk/score?mapTheme=version&mapThemeVersion=").concat(versionId);
};
exports.propertyLookupRiskScoreVersion = propertyLookupRiskScoreVersion;
var propertyLookupRehabResults = function (treeId, lastRun, assetType) {
    return "".concat(rehab_api_1.rehabBaseUrl, "rehabResults/").concat(treeId, "?mapTheme=lookup&lastRun=").concat(lastRun, "&assetType=\n\t").concat(assetType);
};
exports.propertyLookupRehabResults = propertyLookupRehabResults;
// There is a performance cost to showing geojson surveys, so dont show at too low a zoom
exports.zoomShowInspections = 17;
exports.zoomShowPipeSurveys = 18;
exports.zoomShowManholeSurveys = 17;
// zoomSelection's need to be quite aggressive as used in MapInsert's with limited size
// obviously greater than corresponding zoomShow's
exports.zoomSelectionDefault = 17;
exports.zoomSelectionPoint = 19;
exports.minPositionSearchRadius = 10; // m
// 1e-2 ~ 1km, 1e-3 ~ 111m, 1e-4 ~ 11m, 1e-5 ~ 1m
exports.minPositionExtent = 1e-4;
exports.tileOptions = {
    dataServiceId: 'tiles',
    layerName: 'System Type',
    type: inno_map_1.SourceType.INFO360_TILES_V2,
    url: _Apis_1.tilesBaseUrl,
};
exports.otherOptions = {
    dataServiceId: 'tiles-other',
    layerName: 'Spatial Data',
    type: inno_map_1.SourceType.TILES,
    url: "".concat(_Apis_1.tilesBaseUrl, "/v1/tile-json/amSpatial"),
};
exports.inspectionCctv = 'cctv';
exports.inspectionCctvObs = 'cctvObs';
exports.inspectionManhole = 'manholeSurveys';
exports.inspectionsLayerName = 'Inspections';
exports.cctv = {
    dataServiceId: exports.inspectionCctv,
    layerName: 'CCTV',
    type: inno_map_1.SourceType.ONU,
    url: "".concat(_Apis_1.inspectionBaseUrl, "map/inspections"),
    minZoom: exports.zoomShowInspections,
};
exports.cctvObservations = {
    dataServiceId: exports.inspectionCctvObs,
    layerName: 'Observations',
    type: inno_map_1.SourceType.ONU,
    url: "".concat(_Apis_1.inspectionBaseUrl, "map/observations"),
    minZoom: exports.zoomShowPipeSurveys,
};
exports.manholeSurveys = {
    dataServiceId: exports.inspectionManhole,
    layerName: 'Manhole surveys',
    type: inno_map_1.SourceType.ONU,
    url: "".concat(_Apis_1.inspectionBaseUrl, "map/manhole-surveys"),
    minZoom: exports.zoomShowManholeSurveys,
};
exports.defaultInspectionSources = [
    exports.cctv,
    exports.cctvObservations,
    exports.manholeSurveys,
];
exports.generalOptionsDefault = {
    radiusDefault: 5000,
    boundMargin: 1.02,
    useBBox: true,
    singlePage: true,
    precisionLonLat: 6,
    precisionRadius: 0,
    noMinZoom: false,
};
// Provided by Sasha/UX directly for inspection ratings
exports.ratingColours = [
    '#43575D',
    '#00A3FF',
    '#84E206',
    '#FFBE00',
    '#FF7A00',
    '#ED0000',
];
// These choices are as currently hard coded in app_am_risk, need moving to lib_am_common
// Also colours might need changing wrt map background?
exports.riskGradeColours = [
    stylovyze_1.riskGradePalette.negligible.dark,
    stylovyze_1.riskGradePalette.low.dark,
    stylovyze_1.riskGradePalette.medium.main,
    stylovyze_1.riskGradePalette.high.main,
    stylovyze_1.riskGradePalette.extreme.dark,
];
exports.riskGradeLayerNames = [
    'Negligible',
    'Low',
    'Medium',
    'High',
    'Extreme',
];
// Used in app_am_inspections @AssetSchemaMigration
var assetType = function (standard) {
    if ((0, _Utils_1.isPipeStandard)(standard)) {
        return _Types_1.AssetTypePipe;
    }
    else if ((0, _Utils_1.isManholeStandard)(standard)) {
        return _Types_1.AssetTypeManhole;
    }
    return _Types_1.AssetTypeUnknown;
};
exports.assetType = assetType;
var inspectionSources = function (standard) {
    if ((0, _Utils_1.isPipeStandard)(standard)) {
        return [exports.cctv, exports.cctvObservations];
    }
    if ((0, _Utils_1.isManholeStandard)(standard)) {
        return [exports.manholeSurveys];
    }
    return [];
};
exports.inspectionSources = inspectionSources;
// 2do move to shared_utils
var toExtent = function (arr) {
    return (arr === null || arr === void 0 ? void 0 : arr.length) === 4 ? [arr[0], arr[1], arr[2], arr[3]] : undefined;
};
exports.toExtent = toExtent;
exports.rehabColors = [
    '#e41a1c',
    '#377eb8',
    '#4daf4a',
    '#984ea3',
    '#ff7f00',
    '#ffff33',
    '#a65628',
    '#f781bf',
    '#999999',
];


/***/ }),

/***/ "./utils/mapSelections.utils.ts":
/*!**************************************!*\
  !*** ./utils/mapSelections.utils.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectedAssets = exports.selectedPosition = exports.selectedCentre = exports.selectedExtent = void 0;
var geojson_1 = __webpack_require__(/*! @innovyze/shared-utils/lib/geometry/geojson */ "@innovyze/shared-utils/lib/geometry/geojson");
var selectedExtent = function (assets) {
    var geometries = assets
        .map(function (a) { return ('geometry' in a ? a['geometry'] : undefined); })
        .filter(function (a) { return a !== undefined; });
    var extent = (0, geojson_1.geometriesExtent)(geometries);
    if (!extent) {
        return undefined;
    }
    return extent;
};
exports.selectedExtent = selectedExtent;
var selectedCentre = function (assets) { return (0, geojson_1.centreExtent)((0, exports.selectedExtent)(assets)); };
exports.selectedCentre = selectedCentre;
var selectedPosition = function (assets, zoom) {
    var center = (0, exports.selectedCentre)(assets);
    return center
        ? {
            center: center,
            zoom: zoom,
        }
        : undefined;
};
exports.selectedPosition = selectedPosition;
var selectedAssets = function (assets) {
    return assets
        .map(function (a) { return ({ id: a.id, layerId: a.layerId }); })
        .filter(function (s) { return (s === null || s === void 0 ? void 0 : s.id.length) && (s === null || s === void 0 ? void 0 : s.layerId.length); });
};
exports.selectedAssets = selectedAssets;


/***/ }),

/***/ "./utils/observationCodes.ts":
/*!***********************************!*\
  !*** ./utils/observationCodes.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.macpObservationCodes = exports.pacpObservationCodes = exports.wsa05ObservationCodes = exports.msccObservationCodes = exports.getObservationCodes = void 0;
var inspection_types_1 = __webpack_require__(/*! @Types/inspection.types */ "./types/inspection.types.ts");
var getObservationCodes = function (standard, t) {
    switch (standard) {
        case inspection_types_1.InspectionStandard.MACP:
            return (0, exports.macpObservationCodes)(t);
        case inspection_types_1.InspectionStandard.MSCC:
            return (0, exports.msccObservationCodes)(t);
        case inspection_types_1.InspectionStandard.PACP:
            return (0, exports.pacpObservationCodes)(t);
        case inspection_types_1.InspectionStandard.WSA05:
            return (0, exports.wsa05ObservationCodes)(t);
        default:
            return {};
    }
};
exports.getObservationCodes = getObservationCodes;
var msccObservationCodes = function (t) {
    return {
        B: t('Broken Pipe'),
        BN: t('Buchan Trap (start)'),
        BNF: t('Buchan Trap (finish)'),
        BR: t('Major connection without manhole (start)'),
        BRF: t('Major connection without manhole (finish)'),
        CC: t('Crack Circumferential'),
        CL: t('Crack Longitudinal'),
        CM: t('Crack Multiple'),
        CN: t('Connection'),
        CNC: t('Connection other than junction closed'),
        CP: t('Catchpit (start)'),
        CPF: t('Catchpit (finish)'),
        CR: t('Crack Radiating'),
        CS: t('Cracks Spiral'),
        CU: t('Loss of vision'),
        CUD: t('Loss of vision, silt'),
        CUS: t('Loss of vision, steam'),
        CUW: t('Loss of vision camera underwater'),
        CUZ: t('Loss of vision, other'),
        CX: t('Connection Defective'),
        CXB: t('Connection Defective - connecting pipe blocked'),
        CXBI: t('Connection Defective - connecting pipe blocked with intrusion'),
        CXD: t('Connection Defective - connecting pipe damaged'),
        CXDI: t('Connection Defective - connecting pipe damaged with intrusion'),
        CXI: t('Connection Intruding'),
        CXP: t('Connection Defective - position incorrect'),
        CXPI: t('Connection Defective - position incorrect with intrusion'),
        CXZ: t('Connection Defective - other'),
        D: t('Deformation'),
        DB: t('Displaced Bricks'),
        DEC: t('Settled deposits hard or compact'),
        DEE: t('Attached Deposits, encrustation'),
        DEF: t('Attached Deposits, fouling'),
        DEG: t('Attached Deposits, grease'),
        DER: t('Settled Deposits, coarse'),
        DES: t('Settled Deposits, fine'),
        DEX: t('Other settled Deposits'),
        DEZ: t('Other attached Deposits'),
        DH: t('Deformation Horizontal'),
        DI: t('Dropped Invert'),
        DV: t('Deformation Vertical'),
        EX: t('Exfiltration'),
        FC: t('Fracture Circumferential'),
        FL: t('Fracture Longitudinal'),
        FM: t('Fractures Multiple'),
        FR: t('Fracture Radiating'),
        FS: t('Fracture spiral'),
        FW: t('Flow in incoming pipe'),
        FWC: t('Clear flow in incoming pipe'),
        FWCS: t('Wrong clear flow in foul pipe'),
        FWT: t('Turbid flow in incoming pipe'),
        FWTF: t('Wrong turbid flow in s-w pipe'),
        GP: t('General Photograph'),
        GY: t('Gully (start)'),
        GYF: t('Gully (finish)'),
        GZ: t('Hazardous atmosphere, other'),
        H: t('Hole'),
        HS: t('Hydrogen Sulphide'),
        I: t('Infiltration'),
        IC: t('Inspection chamber (start)'),
        ICF: t('Inspection chamber (finish)'),
        ID: t('Infiltration Dripper'),
        IG: t('Infiltration Gusher'),
        ING: t('Ingress of soil'),
        INGF: t('Ingress of fine material'),
        INGG: t('Ingress of gravel'),
        INGP: t('Ingress of peat'),
        INGS: t('Ingress of sand'),
        INGZ: t('Ingress of soil, other'),
        IR: t('Infiltration Runner'),
        IS: t('Infiltration Seeper'),
        JD: t('Joint Displacement'),
        JDL: t('Joint Displacement Large'),
        JDM: t('Joint Displacement Medium'),
        JN: t('Junction'),
        JNC: t('Junction, closed'),
        JX: t('Junction Defective'),
        JXB: t('Jnct defect - conn pipe blocked'),
        JXD: t('Jnct defect - conn pipe damaged'),
        JXP: t('Jnct defect - position incorrect'),
        JXZ: t('Junction defective - other'),
        LC: t('Lining of drain changes'),
        'LC+': t('Lining of drain changes + material change'),
        LD: t('Line Deviates Down'),
        LH: t('Lamphole (start)'),
        LHF: t('Lamphole (finish)'),
        LL: t('Line Deviates Left'),
        LR: t('Line Deviates Right'),
        LU: t('Line Deviates Up'),
        LX: t('Lining Defective'),
        LXB: t('Defective lining - blistered'),
        LXC: t('Defective lining - discolouration'),
        LXCX: t('Defective lining - lining defect at connection'),
        LXD: t('Defective lining - detached'),
        LXE: t('Defective lining - defective end'),
        LXEB: t('Defective lining - external bulge'),
        LXES: t('Defective lining - end not sealed'),
        LXF: t('Defective lining - separated film'),
        LXH: t('Defective lining - hole in lining'),
        LXR: t('Defective lining - resin missing'),
        LXS: t('Defective lining - crack or split in lining or weld failure'),
        LXSC: t('Defective lining - circumferential crack or split in lining or weld failure'),
        LXSF: t('Defective lining - lining appears soft'),
        LXSH: t('Defective lining - spiral crack or split in lining or weld failure'),
        LXSL: t('Defective lining - longitudinal crack or split in lining or weld failure'),
        LXSM: t('Defective lining - complex crack or split in lining or weld failure'),
        LXSS: t('Defective lining - separated seam cover'),
        LXWC: t('Defective lining - circumferential wrinkled'),
        LXWH: t('Defective lining - spiral wrinkled'),
        LXWL: t('Defective lining - longitudinal wrinkled'),
        LXWM: t('Defective lining - complex (multiple) wrinkled'),
        LXZ: t('Defective lining - other defect'),
        MB: t('Missing Bricks'),
        MC: t('Material Change + Material change'),
        ME: t('Hazardous atmosphere, methane'),
        MH: t('Manhole (start)'),
        MHF: t('Manhole (finish)'),
        MM: t('Mortar missing slight (5 mm - 15 mm)'),
        MMM: t('Mortar missing medium (15 mm - 50 mm)'),
        MMS: t('Mortar missing slight (5 mm - 15 mm)'),
        MMT: t('Mortar missing total (50 mm - 100 mm)'),
        OB: t('Obstruction'),
        OBB: t('Brick or masonry in invert'),
        OBC: t('Obstacles through connection/junct'),
        OBI: t('Obstacles protuding through wall'),
        OBM: t('Pipe material in invert'),
        OBP: t('Obstacles, external pipe/cable'),
        OBS: t('Obstacles built into structure'),
        OBX: t('Other obstacles, other object'),
        OBZ: t('Other obstacles, other'),
        OC: t('Other special chamber (start)'),
        OCF: t('Other special chamber (finish)'),
        OD: t('Hazardous atmosphere, oxygen deficiency'),
        OF: t('Outfall (start)'),
        OFF: t('Outfall (finish)'),
        OJ: t('Open Joint'),
        OJL: t('Open Joint Large'),
        OJM: t('Open Joint Medium'),
        OS: t('Oil seperator (start)'),
        OSF: t('Oil seperator (finish)'),
        PC: t('Pipe Length Change'),
        PP: t('Pipe material is porous'),
        PVR: t('Photographic volume reference new volume'),
        RE: t('Rodding eye (start)'),
        REF: t('Rodding eye (finish)'),
        REM: t('General remark'),
        RF: t('Roots fine'),
        RG: t('Running trap (start)'),
        RGF: t('Running trap (finish)'),
        RM: t('Roots Mass'),
        RPC: t('Point repair - other repair to connection'),
        RPH: t('Point repair - hole repaired'),
        RPI: t('Point repair - injected mortar'),
        RPL: t('Point repair - localised lining'),
        RPR: t('Point repair - pipe replaced'),
        RPS: t('Point repair - other injected sealing material'),
        RPT: t('Point repair - localised lining of connection'),
        RPZ: t('Point repair - other trenchless method'),
        RT: t('Roots Tap'),
        RXC: t('Defective repair - crack in material'),
        RXH: t('Defective repair - hole in material'),
        RXM: t('Defective repair - part wall missing'),
        RXMR: t('Defective repair - missing repair material'),
        RXS: t('Defective repair - separation from host pipe'),
        RXXM: t('Defective repair - excessive material obstruction'),
        RXZ: t('Defective repair - other'),
        S: t('Surface damage'),
        SA: t('Survey abandoned'),
        SAP: t('Aggregate projecting frm surface'),
        SAV: t('Visible aggregate'),
        SB: t('Internal blister/bulge'),
        SC: t('Shape Change'),
        'SC+': t('Shape Change + shape code'),
        SCP: t('Corrosion products'),
        SK: t('Soakaway (start)'),
        SKF: t('Soakaway (finish)'),
        SO: t('Other sealant intruding'),
        SR: t('Sealing ring intruding'),
        SRB: t('Sealing ring intruding and broken'),
        SRC: t('Corroded reinforcement'),
        SRP: t('Reinforcement projecting'),
        SRV: t('Visible reinforcement'),
        SS: t('Spalling'),
        SV: t('Soil visible through defect'),
        SW: t('Increased roughness'),
        SZ: t('Other damage'),
        V: t('Vermin'),
        VR: t('Vermin, rat'),
        VRC: t('Vermin, rats observed in connection'),
        VRJ: t('Vermin, rats observed in open joint'),
        VRZ: t('Vermin, rats observed other'),
        VV: t('Void visible beyond defect'),
        VVR: t('Video volume reference new volume'),
        WL: t('Water level'),
        WLC: t('Clear water level'),
        WLT: t('Turbid water level'),
        WR: t('Winser trap (start)'),
        WRF: t('Winser trap (finish)'),
        WXC: t('Weld failure circumferential'),
        WXL: t('Weld failure longitudinal'),
        WXS: t('Weld failure spiral'),
        XB: t('Collapse brickwork or masonry'),
        XP: t('Collapsed drain/sewer'),
    };
};
exports.msccObservationCodes = msccObservationCodes;
var wsa05ObservationCodes = function (t) {
    return {
        B: t('Breaking'),
        C: t('Cracking'),
        CC: t('Change of Cross Section'),
        CI: t('Intruding Connection'),
        CN: t('Connection'),
        CX: t('Defective connection'),
        D: t('Deformation'),
        DE: t('Deposits on Wall and Invert'),
        DI: t('Dropped Invert'),
        DJS: t('Defective Joint Seal'),
        DJW: t('Defective Joint Weld'),
        DMU: t('Displaced Masonry Units'),
        EX: t('Exfiltration'),
        FH: t('Finish Node'),
        GAS: t('Atmosphere in Conduit'),
        GC: t('General Comment'),
        GP: t('General Photograph'),
        I: t('Infiltration'),
        IF: t('Flow in Connecting Conduits'),
        ING: t('Ingress of Soil'),
        JD: t('Displaced Joint'),
        JN: t('Junction'),
        JX: t('Defective junction'),
        L: t('Line of Conduit Deviates'),
        LC: t('Change of Lining'),
        LD: t('Lining Defective (Structural)'),
        LH: t('Lifting Hole'),
        LOV: t('Loss of Vision'),
        MBC: t('Masonry (brick) cracking'),
        MC: t('Change of Conduit Material'),
        MDI: t('Masonry Dropped Invert'),
        MM: t('Missing Mortar'),
        MMU: t('Missing Masonry Units'),
        MS: t('Masonry Spalling'),
        MUS: t('Masonry Unit Separation'),
        OB: t('Obstruction'),
        PC: t('Change in Conduit Unit Length'),
        PP: t('Porous Conduit'),
        PR: t('Point Repair (Defective)'),
        R: t('Roots'),
        SA: t('Inspection Survey Abandoned'),
        SAC: t('Surface damage asbestos cement'),
        SC: t('Surface Damage Concrete'),
        SDC: t('Surface Damage Concrete'),
        SO: t('Surface damage other (VC, metals) '),
        ST: t('Start Node'),
        SV: t('Soil Visible'),
        V: t('Vermin'),
        VV: t('Void Visible'),
        WL: t('Water Level'),
        X: t('Collapse Conduit'),
        XM: t('Masonry Conduit Collapsed'),
    };
};
exports.wsa05ObservationCodes = wsa05ObservationCodes;
var pacpObservationCodes = function (t) {
    return {
        ACB: t('Access Point Catch Basin'),
        ACOH: t('Access Point Cleanout House'),
        ACOM: t('Access Point Cleanout Mainline'),
        ACOP: t('Access Point Cleanout Propertyline'),
        ADP: t('Access Point Discharge Point'),
        AEP: t('Access Point End of Pipe'),
        AJB: t('Access Point Junction Box'),
        AM: t('Access Point Meter'),
        AMH: t('Manhole'),
        AOC: t('Access Point Special Chamber'),
        ATC: t('Access Point Tee Connection'),
        AWA: t('Access Point Wastewater Access Device'),
        AWW: t('Access Point Wet Well'),
        AZ: t('Access Point Other'),
        B: t('Broken'),
        BSV: t('Broken Soil Visible'),
        BVV: t('Broken Void Visible'),
        CC: t('Crack Circumferential'),
        CH2: t('Crack Longitudinal Hinge, 2'),
        CH3: t('Crack Longitudinal Hinge, 3'),
        CH4: t('Crack Longitudinal Hinge, 4'),
        CL: t('Crack Longitudinal'),
        CM: t('Crack Multiple'),
        CS: t('Crack Spiral'),
        D: t('Deformed'),
        DAE: t('Deposits Attached Encrustation'),
        DAGS: t('Deposits Attached Grease'),
        DAR: t('Deposits Attached Ragging'),
        DAZ: t('Deposits Attached Other'),
        DB: t('Displaced Brick'),
        DFBI: t('Deformed Flexible Bulging Inverse Curvature'),
        DFBR: t('Deformed Flexible Bulging Round'),
        DFC: t('Deformed Flexible Creasing'),
        DFE: t('Deformed Flexible Elliptical'),
        DH: t('Deformed Horizontal'),
        DI: t('Brickwork Dropped Invert'),
        DNF: t('Deposits Ingress Fine'),
        DNGV: t('Deposits Ingress Gravel'),
        DNZ: t('Deposits Ingress Other'),
        DR: t('Deformed Rigid'),
        DSC: t('Deposits Settled Hard/Compacted'),
        DSF: t('Deposits Settled Fine'),
        DSGV: t('Deposits Settled Gravel'),
        DSZ: t('Deposits Settled Other'),
        DTBI: t('Deformed Brick Bulging Inverse Curvature'),
        DTBR: t('Deformed Brick Bulging Round'),
        DV: t('Defomed Vertical'),
        FC: t('Fracture Circumferential'),
        FH2: t('Fracture Longitudinal Hinge, 2'),
        FH3: t('Fracture Longitudinal Hinge, 3'),
        FH4: t('Fracture Longitudinal Hinge, 4'),
        FL: t('Fracture Longitudinal'),
        FM: t('Fracture Multiple'),
        FS: t('Fracture Spiral'),
        GRT: t('Grout at a Location'),
        GTFJ: t('Grout Test Fail Joint'),
        GTFL: t('Grout Test Fail Lateral'),
        GTPJ: t('Grout Test Pass Joint'),
        GTPL: t('Grout Test Pass Lateral'),
        GTUJ: t('Grout Test Unable to Test Joint'),
        GTUL: t('Grout Test Unable to Test Lateral'),
        H: t('Hole'),
        HSV: t('Hole Soil Visible'),
        HVV: t('Hole Void Visible'),
        ID: t('Infiltration Dripper'),
        IDB: t('Infiltration Dripper Barrel'),
        IDC: t('Infiltration Dripper Connection'),
        IDJ: t('Infiltration Dripper Joint'),
        IDL: t('Infiltration Dripper Lateral'),
        IG: t('Infiltration Gusher'),
        IGB: t('Infiltration Gusher Barrel'),
        IGC: t('Infiltration Gusher Connection'),
        IGJ: t('Infiltration Gusher Joint'),
        IGL: t('Infiltration Gusher Lateral'),
        IR: t('Infiltration Runner'),
        IRB: t('Infiltration Runner Barrel'),
        IRC: t('Infiltration Runner Connection'),
        IRJ: t('Infiltration Runner Joint'),
        IRL: t('Infiltration Runner Lateral'),
        IS: t('Infitration Stain'),
        ISB: t('Infiltration Stain Barrel'),
        ISC: t('Infiltration Stain Connection'),
        ISGT: t('Intruding Sealing Material Grout'),
        ISJ: t('Infiltration Stain Joint'),
        ISL: t('Infiltration Stain Lateral'),
        ISSR: t('Intruding Sealing Material Sealing Ring'),
        ISSRB: t('Intruding Sealing Material Sealing Ring Broken'),
        ISSRH: t('Intruding Sealing Material Sealing Ring Hanging'),
        ISSRL: t('Intruding Sealing Material Sealing Ring Loose/Poorly Fitting'),
        ISZ: t('Intruding Sealing Material Other'),
        IW: t('Infiltration Weeper'),
        IWB: t('Infiltration Weeper Barrel'),
        IWC: t('Infiltration Weeper Connection'),
        IWJ: t('Infiltration Weeper Joint'),
        IWL: t('Infiltration Weeper Lateral'),
        JAL: t('Joint Angular Large'),
        JAM: t('Joint Angular Medium'),
        JAS: t('Joint Angular Small'),
        JOL: t('Joint Offset Large'),
        JOLD: t('Joint Offset Large Defective'),
        JOM: t('Joint Offset Medium'),
        JOMD: t('Joint Offset Medium Defective'),
        JOS: t('Joint Offset Small'),
        JOSD: t('Joint Offset Small Defective'),
        JSL: t('Joint Separated Large'),
        JSM: t('Joint Separated Medium'),
        JSS: t('Joint Separated Small'),
        KD: t('Buckling Dimpling'),
        KI: t('Inverse Curvature'),
        KW: t('Buckling Wall'),
        LD: t('Line Down'),
        LFAC: t('Lining Feature Abandoned Connection'),
        LFAS: t('Lining Feature Annular Space'),
        LFB: t('Lining Feature Blistered'),
        LFBK: t('Lining Failure Buckled'),
        LFBU: t('Lining Failure Bulges'),
        LFCS: t('Lining Feature Service Cut Shifted'),
        LFD: t('Lining Feature Detached'),
        LFDC: t('Lining Feature Discoloration'),
        LFDE: t('Lining Feature Defective End'),
        LFDL: t('Lining Feature Delaminating'),
        LFOC: t('Lining Feature Overcut Service'),
        LFPH: t('Lining Failure Pinhole'),
        LFRS: t('Lining Feature Resin slug'),
        LFUC: t('Lining Feature Undercut Service'),
        LFW: t('Lining Feature Wrinkled'),
        LFZ: t('Lining Feature Other'),
        LL: t('Line Left'),
        LLD: t('Line Left Down'),
        LLU: t('Line Left Up'),
        LR: t('Line Right'),
        LRD: t('Line Right Down'),
        LRU: t('Line Right Up'),
        LU: t('Line Up'),
        MB: t('Missing Brick'),
        MCU: t('Miscellaneous Camera Underwater'),
        MGO: t('Miscellaneous General Observation'),
        MGP: t('Miscellaneous General Photograph'),
        MJL: t('Miscellaneous Pipe Joint Length Change'),
        MLC: t('Miscellaneous Lining Change'),
        MMC: t('Miscellaneous Material Change'),
        MML: t('Missing Mortar Large'),
        MMM: t('Missing Mortar Medium'),
        MMS: t('Missing Mortar Small'),
        MSA: t('Miscellaneous Survey Abandoned'),
        MSC: t('Miscellaneous Shape/Size Change'),
        MWL: t('Miscellaneous Water Level'),
        MWLS: t('Miscellaneous Water Level Sag'),
        MWM: t('Miscellaneous Water Mark'),
        MYN: t('Miscellaneous Dye Test Not Visible'),
        MYV: t('Miscellaneous Dye Test Visible'),
        OBB: t('Obstruction Brick or Masonry'),
        OBC: t('Obstruction Through Connection'),
        OBI: t('Obstruction Intruding Through Wall'),
        OBJ: t('Obstruction Wedged In The Joint'),
        OBM: t('Obstruction Pipe Material in Invert'),
        OBN: t('Obstruction Construction Debris'),
        OBP: t('Obstruction External Pipe or Cable'),
        OBR: t('Obstruction Rocks'),
        OBS: t('Obstruction Built Into Structure'),
        OBZ: t('Obstruction Other'),
        RBB: t('Roots Ball Barrel'),
        RBC: t('Roots Ball Connection'),
        RBJ: t('Roots Ball Joint'),
        RBL: t('Roots Ball Lateral'),
        RFB: t('Roots Fine Barrel'),
        RFC: t('Roots Fine Connection'),
        RFJ: t('Roots Fine Joint'),
        RFL: t('Roots Fine Lateral'),
        RMB: t('Roots Medium Barrel'),
        RMC: t('Roots Medium Connection'),
        RMJ: t('Roots Medium Joint'),
        RML: t('Roots Medium Lateral'),
        RPL: t('Point Repair Liner'),
        RPLD: t('Point Repair Liner Defective'),
        RPP: t('Point Repair Patch'),
        RPPD: t('Point Repair Patch Patch Defective'),
        RPR: t('Point Repair Replacement'),
        RPRD: t('Point Repair Replacement Defective'),
        RPZ: t('Point Repair Other'),
        RPZD: t('Point Repair Other Defective'),
        RTB: t('Roots Tap Barrel'),
        RTC: t('Roots Tap Connection'),
        RTJ: t('Roots Tap Joint'),
        RTL: t('Roots Tap Lateral'),
        SAM: t('Surface Damage Aggregate Missing'),
        SAMC: t('Surface Aggregate Missing Chemical'),
        SAMM: t('Surface Aggregate Missing Mechanical'),
        SAMZ: t('Surface Aggregate Missing Unknown'),
        SAP: t('Surface Damage Aggregate Projecting'),
        SAPC: t('Surface Aggregate Projecting Chemical'),
        SAPM: t('Surface Aggregate Projecting Mechanical'),
        SAPZ: t('Surface Aggregate Projecting Unknown'),
        SAV: t('Surface Damage Aggregate Visible'),
        SAVC: t('Surface Aggregate Visible Chemical'),
        SAVM: t('Surface Aggregate Visible Mechanical'),
        SAVZ: t('Surface Aggregate Visible Unknown'),
        SCP: t('Surface Damage Corrosion'),
        SMW: t('Surface Damage Missing Wall'),
        SMWC: t('Surface Missing Wall Chemical'),
        SMWM: t('Surface Missing Wall Mechanical'),
        SMWZ: t('Surface Missing Wall Unknown'),
        SRC: t('Surface Damage Reinforcement Corroded'),
        SRCC: t('Surface Reinforcement Corroded Chemical'),
        SRCM: t('Surface Reinforcement Corroded Mechanical'),
        SRCZ: t('Surface Reinforcement Corroded Unknown'),
        SRI: t('Surface Damage Roughness Increased'),
        SRIC: t('Surface Roughness Increased Chemical'),
        SRIM: t('Surface Roughness Increased Mechanical'),
        SRIZ: t('Surface Roughness Increased Unknown'),
        SRP: t('Surface Damage Reinforcement Projecting'),
        SRPC: t('Surface Reinforcement Projecting Chemical'),
        SRPM: t('Surface Reinforcement Projecting Mechanical'),
        SRPZ: t('Surface Reinforcement Projecting Unknown'),
        SRV: t('Surface Damage Reinforcement Visible'),
        SRVC: t('Surface Reinforcement Visible Chemical'),
        SRVM: t('Surface Reinforcement Visible Mechanical'),
        SRVZ: t('Surface Reinforcement Visible Unknown'),
        SSC: t('Surface Spalling of Damage Coating'),
        SSS: t('Surface Damage Surface Spalling'),
        SSSC: t('Surface Spalling Chemical'),
        SSSM: t('Surface Spalling Mechanical'),
        SSSZ: t('Surface Spalling Other'),
        SZ: t('Surface Damage Other'),
        SZC: t('Surface Other Chemical'),
        SZM: t('Surface Other Mechanical'),
        SZZ: t('Surface Other Unknown'),
        TB: t('Tap Break-in/Hammer'),
        TBA: t('Tap Break-in Activity'),
        TBB: t('Tap Break-in Abandoned'),
        TBC: t('Tap Break-in Capped'),
        TBD: t('Tap Break-in/Hammer Defective'),
        TBI: t('Tap Break-in Intruding'),
        TF: t('Tap Factory'),
        TFA: t('Tap Factory Activity'),
        TFB: t('Tap Factory Abandoned'),
        TFC: t('Tap Factory Capped'),
        TFD: t('Tap Factory Defective'),
        TFI: t('Tap Factory Intruding'),
        TR: t('Tap Rehabilitated'),
        TRA: t('Tap Rehabilitated Activity'),
        TRB: t('Tap Rehabilitated Abandoned'),
        TRC: t('Tap Rehabilitated Capped'),
        TRD: t('Tap Rehabilitated Defective'),
        TRI: t('Tap Rehabilitated Intruding'),
        TS: t('Tap Saddle'),
        TSA: t('Tap Saddle Activity'),
        TSB: t('Tap Saddle Abandoned'),
        TSC: t('Tap Saddle Capped'),
        TSD: t('Tap Saddle Defective'),
        TSI: t('Tap Saddle Intruding'),
        VC: t('Vermin Cockroach'),
        VR: t('Vermin Rat'),
        VZ: t('Vermin Other'),
        WFC: t('Weld Feature Circumferential'),
        WFL: t('Weld Feature Longitudinal'),
        WFM: t('Weld Feature Multiple'),
        WFS: t('Weld Feature Spiral'),
        WFZ: t('Weld Feature Other'),
        X: t('Collapse'),
        XB: t('Collapse Brick Sewer'),
        XP: t('Collapse Pipe Sewer'),
    };
};
exports.pacpObservationCodes = pacpObservationCodes;
var macpObservationCodes = function (t) {
    return {
        B: t('Broken'),
        BSV: t('Broken Soil Visible'),
        BVV: t('Broken Void Visible'),
        CC: t('Crack Circumferential'),
        CL: t('Crack Longitudinal'),
        CM: t('Crack Multiple'),
        CS: t('Crack Spiral'),
        DAE: t('Deposits Attached Encrustation'),
        DAGS: t('Deposits Attached Grease'),
        DAR: t('Deposits Attached Ragging'),
        DAZ: t('Deposits Attached Other'),
        DB: t('Displaced Brick'),
        DFBI: t('Deformed Flexible Bulging Inverse Curvature'),
        DFBR: t('Deformed Flexible Bulging Round'),
        DFC: t('Deformed Flexible Creasing'),
        DFE: t('Deformed Flexible Elliptical'),
        DI: t('Brickwork Dropped Invert'),
        DNF: t('Deposits Ingressed Fine'),
        DNGV: t('Deposits Ingressed Gravel'),
        DNZ: t('Deposits Ingressed Other'),
        DR: t('Deformed Rigid'),
        DSC: t('Deposits Settled Compacted'),
        DSF: t('Deposits Settled Fine'),
        DSGV: t('Deposits Settled Gravel'),
        DSZ: t('Deposits Settled Other'),
        DTBI: t('Deformed Brick Bulging Inverse Curvature'),
        DTBR: t('Deformed Brick Bulging Round'),
        FC: t('Fracture Circumferential'),
        FL: t('Fracture Longitudinal'),
        FM: t('Fracture Multiple'),
        FS: t('Fracture Spiral'),
        GRT: t('Grout at a Location'),
        GTFJ: t('Grout Test Fail Joint'),
        GTFL: t('Grout Test Fail Lateral'),
        GTPJ: t('Grout Test Pass Joint'),
        GTPL: t('Grout Test Pass Lateral'),
        GTUJ: t('Grout Test Unable to Test Joint'),
        GTUL: t('Grout Test Unable to Test Lateral'),
        H: t('Hole'),
        HSV: t('Hole Soil Visible'),
        HVV: t('Hole Void Visible'),
        ID: t('Infiltration Dripper'),
        IDB: t('Infiltration Dripper Barrel'),
        IDC: t('Infiltration Dripper Connection'),
        IDJ: t('Infiltration Dripper Joint'),
        IDL: t('Infiltration Dripper Lateral'),
        IG: t('Infiltration Gusher'),
        IGB: t('Infiltration Gusher Barrel'),
        IGC: t('Infiltration Gusher Connection'),
        IGJ: t('Infiltration Gusher Joint'),
        IGL: t('Infiltration Gusher Lateral'),
        IR: t('Infiltration Runner'),
        IRB: t('Infiltration Runner Barrel'),
        IRC: t('Infiltration Runner Connection'),
        IRJ: t('Infiltration Runner Joint'),
        IRL: t('Infiltration Runner Lateral'),
        IS: t('Infiltration Stain'),
        ISB: t('Infiltration Stain Barrel'),
        ISC: t('Infiltration Stain Connection'),
        ISGT: t('Intruding Sealing Material Grout'),
        ISJ: t('Infiltration Stain Joint'),
        ISL: t('Infiltration Stain Lateral'),
        ISSR: t('Intruding Sealing Material Sealing Ring'),
        ISSRB: t('Intruding Sealing Material Sealing Ring Broken'),
        ISSRH: t('Intruding Sealing Material Sealing Ring Hanging'),
        ISSRL: t('Intruding Sealing Material Sealing Ring Loose/Poorly Fitting'),
        ISZ: t('Intruding Sealing Material Other'),
        IW: t('Infiltration Weeper'),
        IWB: t('Infiltration Weeper Barrel'),
        IWC: t('Infiltration Weeper Connection'),
        IWJ: t('Infiltration Weeper Joint'),
        IWL: t('Infiltration Weeper Lateral'),
        JAL: t('Joint Angular Large'),
        JAM: t('Joint Angular Medium'),
        JOL: t('Joint Offset Large'),
        JOM: t('Joint Offset Medium'),
        JSL: t('Joint Separated Large'),
        JSM: t('Joint Separated Medium'),
        LFAC: t('Lining Feature Abandoned Connection'),
        LFAS: t('Lining Feature Annular Space'),
        LFB: t('Lining Feature Blistered'),
        LFCS: t('Lining Feature Service Cut Shifted'),
        LFD: t('Lining Feature Detached'),
        LFDC: t('Lining Feature Discoloration'),
        LFDE: t('Lining Feature Defective End'),
        LFDL: t('Lining Feature Delaminating'),
        LFOC: t('Lining Feature Overcut Service'),
        LFRS: t('Lining Feature Resin slug'),
        LFUC: t('Lining Feature Undercut Service'),
        LFW: t('Lining Feature Wrinkled'),
        LFZ: t('Lining Feature Other'),
        MB: t('Missing Brick'),
        MGO: t('Miscellaneous General Observation'),
        MGP: t('Miscellaneous General Photo'),
        MJL: t('Miscellaneous Pipe Joint Length Change'),
        MLC: t('Miscellaneous Lining Change'),
        MMC: t('Miscellaneous Material Change'),
        MML: t('Missing Mortar Large'),
        MMM: t('Missing Mortar Medium'),
        MMS: t('Missing Mortar Small'),
        MSA: t('Miscellaneous Survey Abandoned '),
        MSC: t('Miscellaneous Shape/Size Change'),
        MWM: t('Miscellaneous Water Mark'),
        MYN: t('Miscellaneous Dye Test Not Visible'),
        MYV: t('Miscellaneous Dye Test Visible'),
        OBB: t('Obstruction Brick or Masonry'),
        OBC: t('Obstruction Through Connection'),
        OBI: t('Obstruction Intruding Through Wall'),
        OBJ: t('Obstruction Wedged In The Joint'),
        OBM: t('Obstruction Pipe Material in Invert'),
        OBN: t('Obstruction Construction Debris'),
        OBP: t('Obstruction External Pipe or Cable'),
        OBR: t('Obstruction Rocks'),
        OBS: t('Obstruction Built Into Structure'),
        OBZ: t('Obstruction Other'),
        RBB: t('Roots Ball Barrel'),
        RBC: t('Roots Ball Connection'),
        RBJ: t('Roots Ball Joint'),
        RBL: t('Roots Ball Lateral'),
        RFB: t('Roots Fine Barrel'),
        RFC: t('Roots Fine Connection'),
        RFJ: t('Roots Fine Joint'),
        RFL: t('Roots Fine Lateral'),
        RMB: t('Roots Medium Barrel'),
        RMC: t('Roots Medium Connection'),
        RMJ: t('Roots Medium Joint'),
        RML: t('Roots Medium Lateral'),
        RPL: t('Point Repair Liner'),
        RPLD: t('Point Repair Liner Defective'),
        RPP: t('Point Repair Patch'),
        RPPD: t('Point Repair Patch Patch Defective'),
        RPR: t('Point Repair Replacement'),
        RPRD: t('Point Repair Replacement Defective'),
        RPZ: t('Point Repair Other'),
        RPZD: t('Point Repair Other Defective'),
        RTB: t('Roots Tap Barrel'),
        RTC: t('Roots Tap Connection'),
        RTJ: t('Roots Tap Joint'),
        RTL: t('Roots Tap Lateral'),
        SAM: t('Surface Damage Aggregate Missing'),
        SAP: t('Surface Damage Aggregate Projecting'),
        SAV: t('Surface Damage Aggregate Visible'),
        SCP: t('Surface Damage Corrosion'),
        SMW: t('Surface Damage Missing Wall'),
        SRC: t('Surface Damage Reinforcement Corroded'),
        SRI: t('Surface Damage Roughness Increased'),
        SRP: t('Surface Damage Reinforcement Projecting'),
        SRV: t('Surface Damage Reinforcement Visible'),
        SSC: t('Surface Spalling of Damage Coating'),
        SSS: t('Surface Spalling of Damage'),
        SZ: t('Surface Damage Other'),
        VC: t('Vermin Cockroach'),
        VR: t('Vermin Rat'),
        VZ: t('Vermin Other'),
        WFC: t('Weld Feature Circumferential'),
        WFL: t('Weld Feature Longitudinal'),
        WFM: t('Weld Feature Multiple'),
        WFS: t('Weld Feature Spiral'),
        WFZ: t('Weld Feature Other'),
        X: t('Collapse'),
    };
};
exports.macpObservationCodes = macpObservationCodes;


/***/ }),

/***/ "./utils/properties.utils.ts":
/*!***********************************!*\
  !*** ./utils/properties.utils.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTaskValues = exports.getAssetValues = exports.getSegmentValues = exports.getJustValues = exports.getObjectValues = exports.fixupGrid = exports.a11yProps = void 0;
var ValueMapping_1 = __webpack_require__(/*! @Components/AssetDetails/DetailsOverview/ValueMapping */ "./components/AssetDetails/DetailsOverview/ValueMapping.ts");
function a11yProps(index) {
    return {
        id: "vertical-tab-".concat(index),
        'aria-controls': "vertical-tabpanel-".concat(index),
    };
}
exports.a11yProps = a11yProps;
var fixupGrid = function (fields, details) {
    // Fix up any missing asset fields so it displays '-'
    fields.forEach(function (field) {
        if (details[field.name] == null ||
            details[field.name] == undefined ||
            details[field.name].toString().trim().length == 0)
            details[field.name] = '-';
    });
};
exports.fixupGrid = fixupGrid;
var getObjectValues = function (t, 
// eslint-disable-next-line @typescript-eslint/ban-types
inspection, getDomainValues) {
    var values = {};
    if (inspection) {
        for (var _i = 0, _a = Object.entries(inspection); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value != null &&
                value != undefined &&
                typeof value === 'string' &&
                value.trim().length != 0 &&
                value.trim() != '-') {
                var domainValues = getDomainValues(t, key.trim());
                if (domainValues && value.trim() in domainValues) {
                    values[key] = "".concat(value.trim(), " - ").concat(domainValues[value.trim()]);
                    continue;
                }
            }
            values[key] = value;
        }
    }
    return values;
};
exports.getObjectValues = getObjectValues;
var getJustValues = function (inspection, forView) {
    var values = {};
    if (inspection) {
        for (var _i = 0, _a = Object.entries(inspection); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (typeof value !== 'object')
                values[key] = forView ? value : value === '-' ? '' : value;
        }
    }
    return values;
};
exports.getJustValues = getJustValues;
var getSegmentValues = function (t, segment, getDomainValues) {
    var values = {};
    if (segment) {
        for (var _i = 0, _a = Object.entries(segment); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value != null &&
                value != undefined &&
                typeof value === 'string' &&
                value.trim().length != 0 &&
                value.trim() != '-') {
                var domainValues = getDomainValues(t, key.trim());
                if (domainValues && value.trim() in domainValues) {
                    values[key] = "".concat(value.trim(), " - ").concat(domainValues[value.trim()]);
                    continue;
                }
            }
            values[key] = value;
        }
    }
    return values;
};
exports.getSegmentValues = getSegmentValues;
var getAssetValues = function (t, details, getDomainValues) {
    var values = {};
    if (details && details.length > 0) {
        for (var _i = 0, details_1 = details; _i < details_1.length; _i++) {
            var detail = details_1[_i];
            if (detail.FieldValue != null &&
                detail.FieldValue != undefined &&
                detail.FieldValue.trim().length != 0) {
                var domainValues = getDomainValues(t, detail.FieldName.trim());
                if (domainValues && detail.FieldValue.trim() in domainValues) {
                    values[detail.FieldName] = "".concat(detail.FieldValue.trim(), " - ").concat(domainValues[detail.FieldValue.trim()]);
                    continue;
                }
            }
            values[detail.FieldName] = detail.FieldValue;
        }
    }
    return values;
};
exports.getAssetValues = getAssetValues;
var getTaskValues = function (inspection, forView) {
    var _a;
    var values = {};
    if (inspection) {
        for (var _i = 0, _b = Object.entries(inspection); _i < _b.length; _i++) {
            var _c = _b[_i], key = _c[0], value = _c[1];
            var field = (_a = (0, ValueMapping_1.extractValue)(value)) !== null && _a !== void 0 ? _a : '';
            values[key] = forView ? field : field === '-' ? '' : field;
        }
    }
    return values;
};
exports.getTaskValues = getTaskValues;


/***/ }),

/***/ "./utils/search.utils.ts":
/*!*******************************!*\
  !*** ./utils/search.utils.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.searchStoreStateInitial = void 0;
var searchStoreStateInitial = function () { return ({
    caption: 'Search',
    value: '',
}); };
exports.searchStoreStateInitial = searchStoreStateInitial;


/***/ }),

/***/ "./utils/server.utils.ts":
/*!*******************************!*\
  !*** ./utils/server.utils.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseServerObjectToFormattedString = void 0;
var date_utils_1 = __webpack_require__(/*! ./date.utils */ "./utils/date.utils.ts");
/** @param formatDate pass useCompanyDateTime() for normal datetimes or useTzDateTime({ timeZone: 'UTC' }) for naive datetime */
var parseServerObjectToFormattedString = function (value, stringType, formatDate) {
    var _a, _b, _c, _d, _e, _f;
    try {
        if (typeof value === 'string') {
            switch (stringType) {
                case 1 /* ExpectedStringType.DateTime */: {
                    var date = new Date(Date.parse(value));
                    if (date) {
                        return ((_a = (0, date_utils_1.formatDateTimeWithFormatDate)(date.toISOString(), formatDate)) !== null && _a !== void 0 ? _a : '');
                    }
                    else
                        return '';
                }
                case 2 /* ExpectedStringType.Date */: {
                    var date = new Date(Date.parse(value));
                    if (date) {
                        return ((_b = (0, date_utils_1.formatDateWithFormatDate)(date.toISOString(), formatDate)) !== null && _b !== void 0 ? _b : '');
                    }
                    else
                        return '';
                }
                case 3 /* ExpectedStringType.Time */: {
                    var date = new Date(Date.parse(value));
                    if (date) {
                        return ((_c = (0, date_utils_1.formatTimeWithFormatDate)(date.toISOString(), formatDate)) !== null && _c !== void 0 ? _c : '');
                    }
                    else
                        return '';
                }
                case 4 /* ExpectedStringType.Currency */: {
                    return value;
                }
                default: {
                    return value;
                }
            }
        }
        else {
            var val = value;
            switch (val === null || val === void 0 ? void 0 : val.type) {
                case 'date': {
                    var date = new Date(Date.parse(val.value));
                    if (date) {
                        switch (stringType) {
                            case 2 /* ExpectedStringType.Date */:
                                return ((_d = (0, date_utils_1.formatDateWithFormatDate)(date.toISOString(), formatDate)) !== null && _d !== void 0 ? _d : '');
                            case 3 /* ExpectedStringType.Time */:
                                return ((_e = (0, date_utils_1.formatTimeWithFormatDate)(date.toISOString(), formatDate)) !== null && _e !== void 0 ? _e : '');
                            default:
                                return ((_f = (0, date_utils_1.formatDateTimeWithFormatDate)(date.toISOString(), formatDate)) !== null && _f !== void 0 ? _f : '');
                        }
                    }
                    else
                        return '';
                }
                case 'currency': {
                    return val.displayValue;
                }
            }
        }
    }
    catch (_g) {
        return '';
    }
    return '';
};
exports.parseServerObjectToFormattedString = parseServerObjectToFormattedString;


/***/ }),

/***/ "./utils/standard.utils.ts":
/*!*********************************!*\
  !*** ./utils/standard.utils.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isManholeStandard = exports.isPipeStandard = void 0;
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var isPipeStandard = function (standard) {
    return [
        _Types_1.InspectionStandard.WSA05,
        _Types_1.InspectionStandard.PACP,
        _Types_1.InspectionStandard.MSCC,
    ].includes(standard);
};
exports.isPipeStandard = isPipeStandard;
var isManholeStandard = function (standard) {
    return standard === _Types_1.InspectionStandard.MACP;
};
exports.isManholeStandard = isManholeStandard;


/***/ }),

/***/ "./utils/styles.ts":
/*!*************************!*\
  !*** ./utils/styles.ts ***!
  \*************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableBodyCellMenu = exports.TableBodyCell = exports.StyledMoreVert = exports.actionStyles = exports.Title = exports.StyledFormControl = exports.TableHeader = exports.StyledTable = exports.StyledGrid = exports.OuterGrid = exports.PaperStyled = exports.FullPage = exports.FullPageWrapper = exports.rem = exports.em = void 0;
var styled_components_1 = __importStar(__webpack_require__(/*! styled-components */ "styled-components"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var em = function (px, basePx) {
    if (basePx === void 0) { basePx = 16; }
    return "".concat(px / basePx, "em");
};
exports.em = em;
var rem = function (px, basePx) {
    if (basePx === void 0) { basePx = 16; }
    return "".concat(px / basePx, "rem");
};
exports.rem = rem;
exports.FullPageWrapper = (0, styled_components_1.default)(stylovyze_1.PageWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tpadding-bottom: 0px;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tpadding-bottom: 0px;\n"])));
exports.FullPage = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 100%;\n\toverflow: auto;\n"], ["\n\theight: 100%;\n\toverflow: auto;\n"])));
exports.PaperStyled = (0, styled_components_1.default)(material_1.Paper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
exports.OuterGrid = (0, styled_components_1.default)(material_1.Grid)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex-direction: column;\n\tflex-grow: 1;\n"], ["\n\tflex-direction: column;\n\tflex-grow: 1;\n"])));
exports.StyledGrid = (0, styled_components_1.default)(material_1.Grid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: ", " ", ";\n"], ["\n\tpadding: ", " ", ";\n"])), (0, exports.rem)(12), (0, exports.rem)(21));
exports.StyledTable = (0, styled_components_1.default)(material_1.Table)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\ttable-layout: 'auto';\n\toverflow: hidden;\n"], ["\n\ttable-layout: 'auto';\n\toverflow: hidden;\n"])));
exports.TableHeader = (0, styled_components_1.default)(material_1.TableHead)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbackground: #f2f2f2;\n"], ["\n\tbackground: #f2f2f2;\n"])));
exports.StyledFormControl = (0, styled_components_1.default)(material_1.FormControl)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\twidth: 90%;\n"], ["\n\twidth: 90%;\n"])));
exports.Title = (0, styled_components_1.default)(material_1.Typography)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 24px;\n\ttext-align: left;\n\tcolor: #272833;\n\tmargin-bottom: 0;\n"], ["\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 24px;\n\ttext-align: left;\n\tcolor: #272833;\n\tmargin-bottom: 0;\n"])));
exports.actionStyles = (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tcolor: #768d95;\n"], ["\n\tcolor: #768d95;\n"])));
exports.StyledMoreVert = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t", "\n\tfloat: right;\n"], ["\n\t", "\n\tfloat: right;\n"])), exports.actionStyles);
exports.TableBodyCell = (0, styled_components_1.default)(material_1.TableCell)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tcursor: default;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tcursor: default;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
exports.TableBodyCellMenu = (0, styled_components_1.default)(exports.TableBodyCell)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tcursor: inherit;\n\twidth: 5%;\n"], ["\n\tcursor: inherit;\n\twidth: 5%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


/***/ }),

/***/ "./utils/table.utils.tsx":
/*!*******************************!*\
  !*** ./utils/table.utils.tsx ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapHeader = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var wrapHeader = function (header) {
    return (0, jsx_runtime_1.jsx)("span", __assign({ style: { whiteSpace: 'pre-wrap' } }, { children: header }));
};
exports.wrapHeader = wrapHeader;


/***/ }),

/***/ "./utils/time.ts":
/*!***********************!*\
  !*** ./utils/time.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dateTimeFromPicker = exports.dateTimeForPicker = exports.fixupObservationsCounterAndTime = exports.fixupCounterAndTime = exports.formatDisplayTime = exports.timeToSeconds = exports.secondsToTime = void 0;
var luxon_1 = __webpack_require__(/*! luxon */ "luxon");
/** Convert seconds to a HHMMSS string
 */
var secondsToTime = function (seconds) {
    if (seconds === undefined)
        seconds = 0;
    var date = new Date(seconds * 1000);
    return "".concat(date.getUTCHours().toString().padStart(2, '0')).concat(date
        .getUTCMinutes()
        .toString()
        .padStart(2, '0')).concat(date.getUTCSeconds().toString().padStart(2, '0'));
};
exports.secondsToTime = secondsToTime;
/** Convert HHMMSS to seconds
 */
var timeToSeconds = function (time) {
    var result = 0;
    if (time && (time.length == 6 || time.length == 8)) {
        try {
            time = time.replace(/[:]/g, '');
            var hour = time.substring(0, 2);
            var min = time.substring(2, 4);
            var sec = time.substring(4, 6);
            result = Number(hour) * 360 + Number(min) * 60 + Number(sec);
        }
        catch (ex) {
            var error = ex;
            console.error(error.message);
        }
    }
    return result;
};
exports.timeToSeconds = timeToSeconds;
/** Format HHMMSS to HH:MM:SS for display
 */
var formatDisplayTime = function (label) {
    if (label && label.length == 6) {
        return (label.substring(0, 2) +
            ':' +
            label.substring(2, 4) +
            ':' +
            label.substring(4, 6));
    }
    return label;
};
exports.formatDisplayTime = formatDisplayTime;
var fixupCounterAndTime = function (observation) {
    if ('VCRTime' in observation) {
        var obs = observation;
        // Make sure we have both counter and time
        if (obs.counter && obs.VCRTime !== '') {
            obs.counter = (0, exports.timeToSeconds)(obs.VCRTime);
        }
        else if (obs.VCRTime === '' && obs.counter) {
            obs.VCRTime = (0, exports.secondsToTime)(Number(obs.counter));
        }
    }
    else if ('vcrTime' in observation) {
        var obs = observation;
        // Make sure we have both counter and time
        if (obs.counter && obs.vcrTime !== '') {
            obs.counter = (0, exports.timeToSeconds)(obs.vcrTime);
        }
        else if (obs.vcrTime === '' && obs.counter) {
            obs.vcrTime = (0, exports.secondsToTime)(Number(obs.counter));
        }
    }
    else if ('videoRef' in observation) {
        var obs = observation;
        // MSCC does not have a counter so we want to fix that from the time in videoRef
        if (obs.videoRef !== '') {
            obs.counter = (0, exports.timeToSeconds)(obs.videoRef);
        }
    }
    else if ('videoPosition' in observation) {
        var obs = observation;
        // WSA05 does not have a counter so we want to fix that from the time in videoRef
        if (obs.videoPosition !== '') {
            obs.counter = (0, exports.timeToSeconds)(obs.videoPosition);
        }
    }
    return observation;
};
exports.fixupCounterAndTime = fixupCounterAndTime;
var fixupObservationsCounterAndTime = function (observations) {
    return observations.map(function (observation) {
        return (0, exports.fixupCounterAndTime)(observation);
    });
};
exports.fixupObservationsCounterAndTime = fixupObservationsCounterAndTime;
var dateTimeForPicker = function (dateTime) {
    var _a;
    //Date picker can only work with local datetime. This adjustment is
    //neded to keep the date true and prevent from the selected date
    //from jumping backward and foward
    var jsDate = new Date(dateTime);
    var dt = luxon_1.DateTime.fromJSDate(jsDate);
    dt = dt.plus({ minutes: dt.offset });
    return (_a = dt.toUTC().toISO()) !== null && _a !== void 0 ? _a : '';
};
exports.dateTimeForPicker = dateTimeForPicker;
var dateTimeFromPicker = function (dateTime) {
    var _a;
    //Date picker can only work with local datetime. This adjustment is
    //neded to keep the date true and prevent from the selected date
    //from jumping backward and foward
    var jsDate = new Date(dateTime);
    var dt = luxon_1.DateTime.fromJSDate(jsDate);
    dt = dt.plus({ minutes: dt.offset });
    return (_a = dt.toUTC().toISO()) !== null && _a !== void 0 ? _a : '';
};
exports.dateTimeFromPicker = dateTimeFromPicker;


/***/ }),

/***/ "./utils/treeUtils.ts":
/*!****************************!*\
  !*** ./utils/treeUtils.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.convertTreeToReactFlowObject = exports.printRootToLeaf = void 0;
var _ = __importStar(__webpack_require__(/*! lodash */ "lodash"));
// convert tree to ReactFlow object
function printTopToBottomPath(curr, parent) {
    var _a;
    var stk = [];
    var connections = [];
    var connectionsWithEl = [];
    while (curr != null) {
        var reactFlowObj = {
            id: curr.id,
            parentId: curr.parentId ? curr.parentId : null,
            data: {
                label: curr.title ? curr.title : '',
                nodeData: {
                    title: curr.title,
                    filterCondition: curr.filterCondition,
                    rules: curr.rules ? curr.rules : [],
                    actionDefectCodes: curr.actionDefectCodes
                        ? curr.actionDefectCodes
                        : [],
                    assetsCount: curr.assetsCount,
                    actionId: curr.actionId,
                    treeId: curr.treeId,
                    unitCost: curr.unitCost,
                    costUnit: curr.costUnit,
                    unit: curr.unit,
                },
            },
            connectorCondition: curr.connectorCondition,
            type: curr.type,
            position: {
                x: curr.position ? curr.position.x : 0,
                y: curr.position ? (_a = curr.position) === null || _a === void 0 ? void 0 : _a.y : 0,
            },
        };
        connections.push(reactFlowObj);
        stk.push(curr);
        curr = parent.get(curr);
    }
    while (stk.length != 0) {
        curr = stk[stk.length - 1];
        stk.pop();
    }
    if (connections && connections.length > 0) {
        connections
            .reverse()
            .forEach(function (connection, index) {
            var _a, _b, _c, _d, _e, _f;
            connectionsWithEl.push(connection);
            if (index > 0) {
                var connectionLabel = connection.connectorCondition;
                if (((_b = (_a = connection.data) === null || _a === void 0 ? void 0 : _a.nodeData.assetsCount) === null || _b === void 0 ? void 0 : _b.currentNode) ||
                    ((_d = (_c = connection.data) === null || _c === void 0 ? void 0 : _c.nodeData.assetsCount) === null || _d === void 0 ? void 0 : _d.currentNode) === 0) {
                    connectionLabel =
                        connectionLabel +
                            ' (' +
                            ((_f = (_e = connection.data) === null || _e === void 0 ? void 0 : _e.nodeData.assetsCount) === null || _f === void 0 ? void 0 : _f.currentNode) +
                            ')';
                }
                var connectionObj = {
                    id: "e".concat(connection.parentId, "-").concat(connection.id),
                    source: connection.parentId,
                    target: connection.id,
                    label: connectionLabel,
                };
                connectionsWithEl.push(connectionObj);
            }
        });
    }
    return connectionsWithEl;
}
function printRootToLeaf(root) {
    var reactFlowArr = [];
    // Corner Case
    if (root == null)
        return [];
    // Create an empty stack and push root to it
    var nodeStack = [];
    nodeStack.push(root);
    var parent = new Map();
    // parent of root is NULL
    parent.set(root, null);
    while (nodeStack.length != 0) {
        // pop the top item from stack
        var current = nodeStack[nodeStack.length - 1];
        nodeStack.pop();
        if (current.left == null && current.right == null) {
            var x = printTopToBottomPath(current, parent);
            x.forEach(function (ele) {
                if (!_.some(reactFlowArr, function (reactFlowEle) {
                    return _.isEqual(reactFlowEle, ele);
                })) {
                    reactFlowArr.push(ele);
                }
            });
        }
        if (current.right != null) {
            parent.set(current.right, current);
            nodeStack.push(current.right);
        }
        if (current.left != null) {
            parent.set(current.left, current);
            nodeStack.push(current.left);
        }
    }
    return reactFlowArr;
}
exports.printRootToLeaf = printRootToLeaf;
function convertTreeToReactFlowObject(treeNodes) {
    var newTreeNodes = __assign({}, treeNodes);
    var reactFlow = [];
    if (treeNodes)
        reactFlow = printRootToLeaf(newTreeNodes);
    return reactFlow;
}
exports.convertTreeToReactFlowObject = convertTreeToReactFlowObject;


/***/ }),

/***/ "./utils/units.utils.ts":
/*!******************************!*\
  !*** ./utils/units.utils.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unitMapping = exports.UNITS = exports.SYSTEM_UNIT_TYPE = exports.MEASUREMENT_SYSTEM = void 0;
var MEASUREMENT_SYSTEM;
(function (MEASUREMENT_SYSTEM) {
    MEASUREMENT_SYSTEM["METRIC"] = "Metric";
    MEASUREMENT_SYSTEM["IMPERIAL"] = "Imperial";
})(MEASUREMENT_SYSTEM = exports.MEASUREMENT_SYSTEM || (exports.MEASUREMENT_SYSTEM = {}));
var SYSTEM_UNIT_TYPE;
(function (SYSTEM_UNIT_TYPE) {
    SYSTEM_UNIT_TYPE["LENGTH_LONG"] = "LengthLong";
    SYSTEM_UNIT_TYPE["LENGTH"] = "Length";
    SYSTEM_UNIT_TYPE["VOLUME"] = "Volume";
    SYSTEM_UNIT_TYPE["PRESSURE"] = "Pressure";
    SYSTEM_UNIT_TYPE["FLOW"] = "Flow";
    SYSTEM_UNIT_TYPE["ANGLE"] = "Angle";
    SYSTEM_UNIT_TYPE["AREA"] = "Area";
    SYSTEM_UNIT_TYPE["POWER"] = "Power";
    SYSTEM_UNIT_TYPE["ROTATION"] = "Rotation";
    SYSTEM_UNIT_TYPE["VELOCITY"] = "Velocity";
    SYSTEM_UNIT_TYPE["ELECTRIC_CURRENT"] = "ElectricCurrent";
    SYSTEM_UNIT_TYPE["STRING"] = "String";
})(SYSTEM_UNIT_TYPE = exports.SYSTEM_UNIT_TYPE || (exports.SYSTEM_UNIT_TYPE = {}));
var UNITS;
(function (UNITS) {
    UNITS["DEGREE"] = "degree";
    UNITS["CUBIC_METER_PER_SECOND"] = "m3/s";
    UNITS["CUBIC_FEET_PER_SECOND"] = "ft3/s";
    UNITS["MILLIMETER"] = "mm";
    UNITS["METER"] = "m";
    UNITS["METER_OF_HEAD"] = "mH2O";
    UNITS["CUBIC_METER"] = "m3";
    UNITS["FOOT"] = "foot";
    UNITS["INCH"] = "inch";
    UNITS["PSI"] = "psi";
    UNITS["METER_SQUARE"] = "m2";
    UNITS["KILO_WATT"] = "kw";
    UNITS["REVOLUTIONS_PER_MIN"] = "rpm";
    UNITS["METER_PER_SECOND"] = "m/s";
    UNITS["LITRE_PER_SECOND"] = "l/s";
    UNITS["CUBIC_FEET"] = "ft3";
    UNITS["FEET_SQUARE"] = "ft2";
    UNITS["FEET_PER_SECOND"] = "ft/s";
    UNITS["AMPS"] = "A";
    UNITS["RPM"] = "rpm";
    UNITS["NONE"] = "";
})(UNITS = exports.UNITS || (exports.UNITS = {}));
var unitMapping = function (fieldUnitType) {
    switch (fieldUnitType) {
        case SYSTEM_UNIT_TYPE.LENGTH_LONG:
            return UNITS.METER;
        case SYSTEM_UNIT_TYPE.LENGTH:
            return UNITS.MILLIMETER;
        case SYSTEM_UNIT_TYPE.VOLUME:
            return UNITS.CUBIC_METER;
        case SYSTEM_UNIT_TYPE.PRESSURE:
            return UNITS.METER_OF_HEAD;
        case SYSTEM_UNIT_TYPE.FLOW:
            return UNITS.CUBIC_METER_PER_SECOND;
        case SYSTEM_UNIT_TYPE.ANGLE:
            return UNITS.DEGREE;
        case SYSTEM_UNIT_TYPE.AREA:
            return UNITS.METER_SQUARE;
        case SYSTEM_UNIT_TYPE.POWER:
            return UNITS.KILO_WATT;
        case SYSTEM_UNIT_TYPE.VELOCITY:
            return UNITS.METER_PER_SECOND;
        case SYSTEM_UNIT_TYPE.ELECTRIC_CURRENT:
            return UNITS.AMPS;
        case SYSTEM_UNIT_TYPE.ROTATION:
            return UNITS.RPM;
        default:
            return UNITS.NONE;
    }
};
exports.unitMapping = unitMapping;


/***/ }),

/***/ "./utils/urlFormatting.ts":
/*!********************************!*\
  !*** ./utils/urlFormatting.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeMapURL = exports.formatUrlTrailing = void 0;
var lib_asset_schema_1 = __webpack_require__(/*! @innovyze/lib_asset_schema */ "@innovyze/lib_asset_schema");
var formatUrlTrailing = function (url) {
    return url.endsWith('/') ? url : "".concat(url, "/");
};
exports.formatUrlTrailing = formatUrlTrailing;
function toSnakeCase(str) {
    return str
        .replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); })
        .replace(/^_/, '');
}
function getBaseAssetType(assetType) {
    var prefixPattern = new RegExp("^(".concat((0, lib_asset_schema_1.getSystemTypePrefixes)().join('|'), ")"));
    return assetType
        .replace(prefixPattern, '')
        .replace(/[^a-z]+/gi, '_')
        .toLowerCase();
}
function makeMapURL(assetType, assetId, position) {
    var systemType = toSnakeCase((0, lib_asset_schema_1.getSystemTypeIdByAssetTypePrefix)(assetType));
    var baseAssetType = getBaseAssetType(assetType);
    var positionAndZoom = "".concat(position[0], ",").concat(position[1], "/18");
    var assetInfo = "".concat(systemType, "_").concat(baseAssetType, ":").concat(assetType, "=~").concat(assetId);
    return "/map#/map/streets/".concat(positionAndZoom, "/").concat(assetInfo);
}
exports.makeMapURL = makeMapURL;


/***/ }),

/***/ "./utils/useWebSockets.ts":
/*!********************************!*\
  !*** ./utils/useWebSockets.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useWebSockets = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var isomorphic_ws_1 = __importDefault(__webpack_require__(/*! isomorphic-ws */ "../node_modules/isomorphic-ws/browser.js"));
var browser_cookies_1 = __importDefault(__webpack_require__(/*! browser-cookies */ "../node_modules/browser-cookies/src/browser-cookies.js"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var URL = (0, lib_get_service_1.getService)('amRiskWss', {}, (0, stylovyze_1.getApiEnvironment)());
var webSocket;
var useWebSockets = function () {
    if (webSocket === undefined) {
        webSocket = new WebSocketClass();
    }
    return webSocket;
};
exports.useWebSockets = useWebSockets;
var WebSocketClass = /** @class */ (function () {
    function WebSocketClass() {
        var _this = this;
        this.webSocket = null;
        this.pingInterval = null;
        this.pingIntervalTime = 480000;
        this.maxRetries = 5;
        this.retries = 0;
        this.WebSocketRoutes = new Map();
        this.WebSockeErrorRoutes = new Map();
        this.enabled = false;
        this.connectionId = '';
        this.lastRequestId = '';
        this.setupRoutes = function (route, resultsCallBack, errorsCallBack) {
            if (!_this.WebSocketRoutes.has(route)) {
                console.log('setupRoutes', route);
                _this.WebSocketRoutes.set(route, resultsCallBack);
                _this.WebSockeErrorRoutes.set(route, errorsCallBack);
            }
        };
        this.getHandler = function (route) {
            var handler = _this.WebSocketRoutes.get(route);
            if (handler) {
                return handler;
            }
            throw new Error("Route Handler Mapping is missing for route: ".concat(route));
        };
        this.getErrorHandler = function (route) {
            var handler = _this.WebSockeErrorRoutes.get(route);
            if (handler) {
                return handler;
            }
            throw new Error("Route Handler Mapping is missing for route: ".concat(route));
        };
        this.onConnOpen = function () {
            _this.enabled = true;
            _this.setupPing();
        };
        this.onConnClose = function () {
            _this.enabled = false;
            if (_this.pingInterval) {
                _this.clearInterval();
                _this.pingInterval = null;
            }
            if (_this.retries < _this.maxRetries) {
                _this.retries++;
                _this.connect();
                _this.setupPing();
            }
        };
        this.onMessage = function (event) {
            // console.log('Received message: ', event.data);
            try {
                if (event.data === 'pong') {
                    _this.enabled = true;
                    _this.setupPing();
                    return;
                }
                var data = JSON.parse(event.data);
                var type = data.type;
                var handler = void 0;
                // console.log('type', type);
                switch (type) {
                    case 'msgReceived':
                        _this.connectionId = data.connectionId;
                        _this.lastRequestId = data.requestId;
                        break;
                    case 'ping':
                        if (_this.enabled && _this.webSocket) {
                            _this.webSocket.send('pong');
                        }
                        break;
                    case 'results':
                        handler = _this.getHandler(data.route);
                        handler(data);
                        break;
                    case 'error':
                        try {
                            handler = _this.getErrorHandler(data.route);
                            handler(data);
                        }
                        catch (error) {
                            console.error('Error handling message: ', error);
                        }
                        finally {
                            console.error('Error: ', data.error);
                            (0, effects_1.put)((0, stylovyze_1.error)(typeof data.payload == 'string'
                                ? data.payload
                                : data.payload.payload, data.error));
                        }
                        break;
                }
            }
            catch (error) {
                console.error('Error handling message: ', error);
            }
        };
        this.onError = function (event) {
            console.error('Websocket error: ', event);
        };
        this.setupPing = function () {
            _this.pingInterval = setInterval(function () {
                if (_this.webSocket &&
                    _this.webSocket.readyState === _this.webSocket.OPEN) {
                    _this.sendMessage('ping');
                    _this.enabled = false;
                    _this.clearInterval();
                    _this.pingInterval = null;
                }
            }, _this.pingIntervalTime);
        };
        this.connect = function () {
            if (_this.webSocket === null ||
                _this.webSocket.readyState === _this.webSocket.CLOSED) {
                _this.webSocket = new isomorphic_ws_1.default(URL + '?token=Bearer ' + browser_cookies_1.default.get('auth0.user.token'));
                _this.webSocket.onopen = _this.onConnOpen;
                _this.webSocket.onmessage = _this.onMessage;
                _this.webSocket.onclose = _this.onConnClose;
                _this.webSocket.onerror = _this.onError;
            }
        };
        this.clearInterval = function () {
            if (_this.pingInterval) {
                clearInterval(_this.pingInterval);
            }
        };
        this.reset = function () {
            if (_this.pingInterval) {
                _this.clearInterval();
            }
            if (_this.webSocket &&
                _this.webSocket.readyState !== _this.webSocket.CLOSED) {
                _this.webSocket.onclose = null;
                _this.webSocket.close();
            }
            _this.webSocket = null;
            _this.pingInterval = null;
            _this.maxRetries = 5;
            _this.retries = 0;
            _this.enabled = false;
            _this.connectionId = '';
            _this.lastRequestId = '';
        };
        this.sendMessage = function (message) {
            var _a;
            if (_this.webSocket === null ||
                _this.webSocket.readyState == _this.webSocket.CLOSED) {
                _this.reset();
                _this.connect();
                setTimeout(function () {
                    _this.sendMessage(message);
                }, 1000);
            }
            else if (_this.webSocket.readyState == _this.webSocket.CONNECTING ||
                _this.webSocket.readyState == _this.webSocket.CLOSING) {
                setTimeout(function () {
                    _this.sendMessage(message);
                }, 1000);
            }
            else if (_this.enabled &&
                _this.webSocket.readyState == _this.webSocket.OPEN) {
                (_a = _this.webSocket) === null || _a === void 0 ? void 0 : _a.send(message);
            }
        };
        this.connect();
    }
    return WebSocketClass;
}());


/***/ }),

/***/ "./utils/videoPlayer.utils.ts":
/*!************************************!*\
  !*** ./utils/videoPlayer.utils.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTimeCounter = void 0;
var moment_1 = __webpack_require__(/*! moment */ "../node_modules/moment/moment.js");
var getTimeCounter = function (observation) {
    var _a, _b, _c;
    if (observation.counter) {
        return observation.counter;
    }
    var timeStringValue = ((_c = (_b = (_a = observation.videoPosition) !== null && _a !== void 0 ? _a : observation.VCRTime) !== null && _b !== void 0 ? _b : observation.videoRef) !== null && _c !== void 0 ? _c : observation.vcrTime);
    if (timeStringValue) {
        try {
            return (0, moment_1.duration)(timeStringValue).asSeconds();
        }
        catch (e) {
            console.error(e);
        }
    }
    return -1;
};
exports.getTimeCounter = getTimeCounter;


/***/ }),

/***/ "./utilsluxon/datetime.ts":
/*!********************************!*\
  !*** ./utilsluxon/datetime.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTimeDifferenceText = void 0;
var luxon_1 = __webpack_require__(/*! luxon */ "luxon");
// have converted this function from moment to luxon which
// reduces module sizes quite drastically. However, luxon
// is still quite a big overhead for just this usage here.
// 2do there should be a luxon implementation of datetime functions
// in shared_ui from Donnie soon. This method could sensibly be moved
// there or replaced with equivalent from there.
var getTimeDifferenceText = function (date, companySettings) {
    var _a, _b;
    // Default locale set to current hard code default in stylovyze
    var locale = (_a = companySettings === null || companySettings === void 0 ? void 0 : companySettings.language) !== null && _a !== void 0 ? _a : 'America/New_York';
    return ((_b = luxon_1.DateTime.fromJSDate(date).toRelativeCalendar({ locale: locale })) !== null && _b !== void 0 ? _b : '');
};
exports.getTimeDifferenceText = getTimeDifferenceText;


/***/ }),

/***/ "./utilsluxon/index.ts":
/*!*****************************!*\
  !*** ./utilsluxon/index.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./datetime */ "./utilsluxon/datetime.ts"), exports);


/***/ }),

/***/ "./components/ObservationPhoto/missing.png":
/*!*************************************************!*\
  !*** ./components/ObservationPhoto/missing.png ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAN/SURBVHhe7Z07rw1RGIYPQpC4RFQSCYW4JCqtQoGEH6BwK4RSq+YPuBUK13+gJSqFQkHjEolGopIIhUtEEN7P3jv5zux3Zs+sdfaa75z9PsmT2Vhr5VvrZWaPnJk1J4QQQgghhBBCCCGEEELMYw+8DF/DL/DvEtfmaHO1Odvcw7ASXoe/ISt8FrS52xrYWvSKFfAIsiJnUVuLXkO5Bllhs6ytSS/YeXOWT1N12pokX1OWD48pnIUrBh+Fw9bE1iaJnEAOD49inOS1WTY8pmBf+9YNPooKX+H6wcdu5ARi58smcsZeDExl/jmnLDEFFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwFEgwZimQ/cPjksU/E8GMxCFoz20c//+rhYHN2VscVoQ3ClvhR2g12U/s74QLQXW+VYvDivBGYBV8Cn1dL+AamIsfk1kcVoQ3Ajcgq+0WzIWN6y0OK8Kbwya4efAxmZOQ1TXyBMyBjektDivCm4p983sIH8PUR4z3wu+Q1TXSnnLaBVNhY3qLw4rwpnIJjsa4ab/RkQ3wLfS11PkSpl5P2Hje4rAivCkchX+gH+c8bIs9RnYf+v6TvA1TYGN5i8OK8HZlO/wMq+P8ggdhGy7Aav822vWmK2wcb3FYEd4urIbPIRvHtKB2wCYOQAuP9Z9kyvWEjeMtDivC24U7kI3hfQM3QsYW+AGyfm3tej1hY3iLw4rwtsXeesD6M+3bV/XtEfZN7Alk7btqfzHawvp7i8OK8LZhH/wBWf86r0DPVcjapXoKtoH19RaHFeGdhN38vYOs7yTPQOMYZH+e4ze4G06C9fUWhxXhbcJu/h5A1q+NP+E5OK03172Ca2ETrJ+3OKwIbxMXIesTybuwCdbHWxxWhLeOI7B68xfV07AO1t5bHFaEl7ENfoKsfUSbriesvbc4rAhvFbv5ewZZ28jWXU9YW29xWBHeKvZ/RqzdYvAerMLaeZPQ+7LSmcr89WNAwVAgwVAgwVAgwVAgwVAgwVAgwci5V9CLlOtJfpFyzr+Q98OjGCd5bXICsb0yBKeXtdF2Fdys7Spy0YYu4/a2oYuhLY/m2/uWR4YVoE3BgmwK5rHzprbNE0IIIYQQQgghhBBCCDHzzM39A8vKzozmA5DQAAAAAElFTkSuQmCC";

/***/ }),

/***/ "./components/ObservationSummary/summary.jpg":
/*!***************************************************!*\
  !*** ./components/ObservationSummary/summary.jpg ***!
  \***************************************************/
/***/ ((module) => {

"use strict";
module.exports = "data:image/jpeg;base64,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";

/***/ }),

/***/ "@innovyze/lib_asset_schema":
/*!*********************************************!*\
  !*** external "@innovyze/lib_asset_schema" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__;

/***/ }),

/***/ "@innovyze/lib_asset_schema_store":
/*!***************************************************!*\
  !*** external "@innovyze/lib_asset_schema_store" ***!
  \***************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__;

/***/ }),

/***/ "@innovyze/lib_get_service":
/*!********************************************!*\
  !*** external "@innovyze/lib_get_service" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__;

/***/ }),

/***/ "@innovyze/map-components/Translations":
/*!********************************************************!*\
  !*** external "@innovyze/map-components/Translations" ***!
  \********************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_map_components_Translations__;

/***/ }),

/***/ "@innovyze/shared-utils":
/*!*****************************************!*\
  !*** external "@innovyze/shared-utils" ***!
  \*****************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils__;

/***/ }),

/***/ "@innovyze/shared-utils/lib/geometry/geojson":
/*!**************************************************************!*\
  !*** external "@innovyze/shared-utils/lib/geometry/geojson" ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils_lib_geometry_geojson__;

/***/ }),

/***/ "@innovyze/summaryze":
/*!**************************************!*\
  !*** external "@innovyze/summaryze" ***!
  \**************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_summaryze__;

/***/ }),

/***/ "@mui/icons-material":
/*!**************************************!*\
  !*** external "@mui/icons-material" ***!
  \**************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material__;

/***/ }),

/***/ "@mui/icons-material/AssignmentLateOutlined":
/*!*************************************************************!*\
  !*** external "@mui/icons-material/AssignmentLateOutlined" ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_AssignmentLateOutlined__;

/***/ }),

/***/ "@mui/icons-material/ExpandMore":
/*!*************************************************!*\
  !*** external "@mui/icons-material/ExpandMore" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ExpandMore__;

/***/ }),

/***/ "@mui/lab/Timeline":
/*!************************************!*\
  !*** external "@mui/lab/Timeline" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_Timeline__;

/***/ }),

/***/ "@mui/lab/TimelineConnector":
/*!*********************************************!*\
  !*** external "@mui/lab/TimelineConnector" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineConnector__;

/***/ }),

/***/ "@mui/lab/TimelineContent":
/*!*******************************************!*\
  !*** external "@mui/lab/TimelineContent" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineContent__;

/***/ }),

/***/ "@mui/lab/TimelineDot":
/*!***************************************!*\
  !*** external "@mui/lab/TimelineDot" ***!
  \***************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineDot__;

/***/ }),

/***/ "@mui/lab/TimelineItem":
/*!****************************************!*\
  !*** external "@mui/lab/TimelineItem" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineItem__;

/***/ }),

/***/ "@mui/lab/TimelineOppositeContent":
/*!***************************************************!*\
  !*** external "@mui/lab/TimelineOppositeContent" ***!
  \***************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineOppositeContent__;

/***/ }),

/***/ "@mui/lab/TimelineSeparator":
/*!*********************************************!*\
  !*** external "@mui/lab/TimelineSeparator" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_lab_TimelineSeparator__;

/***/ }),

/***/ "@mui/material/AccordionDetails":
/*!*************************************************!*\
  !*** external "@mui/material/AccordionDetails" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails__;

/***/ }),

/***/ "@mui/material/AccordionSummary":
/*!*************************************************!*\
  !*** external "@mui/material/AccordionSummary" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary__;

/***/ }),

/***/ "@mui/material/Autocomplete":
/*!*********************************************!*\
  !*** external "@mui/material/Autocomplete" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete__;

/***/ }),

/***/ "@mui/material/Grid":
/*!*************************************!*\
  !*** external "@mui/material/Grid" ***!
  \*************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Grid__;

/***/ }),

/***/ "@mui/material/Paper":
/*!**************************************!*\
  !*** external "@mui/material/Paper" ***!
  \**************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Paper__;

/***/ }),

/***/ "@mui/material/TextField":
/*!******************************************!*\
  !*** external "@mui/material/TextField" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_TextField__;

/***/ }),

/***/ "@mui/material/Typography":
/*!*******************************************!*\
  !*** external "@mui/material/Typography" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Typography__;

/***/ }),

/***/ "@mui/styles/withStyles":
/*!*****************************************!*\
  !*** external "@mui/styles/withStyles" ***!
  \*****************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_styles_withStyles__;

/***/ }),

/***/ "@redux-saga/core":
/*!***********************************!*\
  !*** external "@redux-saga/core" ***!
  \***********************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__redux_saga_core__;

/***/ }),

/***/ "@redux-saga/core/effects":
/*!*******************************************!*\
  !*** external "@redux-saga/core/effects" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__;

/***/ }),

/***/ "@innovyze/inno-map":
/*!****************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/inno-map","commonjs2":"@innovyze/inno-map","amd":"@Innovyze/InnoMap","root":"@Innovyze/InnoMap"} ***!
  \****************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_inno_map__;

/***/ }),

/***/ "@innovyze/map-components":
/*!****************************************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/map-components","commonjs2":"@innovyze/map-components","amd":"@Innovyze/MapComponents","root":"@Innovyze/MapComponents"} ***!
  \****************************************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_map_components__;

/***/ }),

/***/ "@innovyze/stylovyze":
/*!**********************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/stylovyze","commonjs2":"@innovyze/stylovyze","amd":"@Innovyze/Stylovyze","root":"@Innovyze/Stylovyze"} ***!
  \**********************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__;

/***/ }),

/***/ "@mui/material":
/*!****************************************************************************************************************************!*\
  !*** external {"commonjs":"@mui/material","commonjs2":"@mui/material","amd":"@MaterialUi/Core","root":"@MaterialUi/Core"} ***!
  \****************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material__;

/***/ }),

/***/ "@mui/styles":
/*!****************************************************************************************************************************!*\
  !*** external {"commonjs":"@mui/styles","commonjs2":"@mui/styles","amd":"@MaterialUi/styles","root":"@MaterialUi/styles"} ***!
  \****************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__mui_styles__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "i18next":
/*!**********************************************************************************************!*\
  !*** external {"commonjs":"i18next","commonjs2":"i18next","amd":"I18next","root":"I18next"} ***!
  \**********************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_i18next__;

/***/ }),

/***/ "lodash":
/*!******************************************************************************************!*\
  !*** external {"commonjs":"lodash","commonjs2":"lodash","amd":"Lodash","root":"Lodash"} ***!
  \******************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "luxon":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"luxon","commonjs2":"luxon","amd":"Luxon","root":"Luxon"} ***!
  \**************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_luxon__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"} ***!
  \**************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-i18next":
/*!********************************************************************************************************************!*\
  !*** external {"commonjs":"react-i18next","commonjs2":"react-i18next","amd":"ReactI18next","root":"ReactI18next"} ***!
  \********************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react_i18next__;

/***/ }),

/***/ "react-player":
/*!****************************************************************************************************************!*\
  !*** external {"commonjs":"react-player","commonjs2":"react-player","amd":"ReactPlayer","root":"ReactPlayer"} ***!
  \****************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react_player__;

/***/ }),

/***/ "react-redux":
/*!************************************************************************************************************!*\
  !*** external {"commonjs":"react-redux","commonjs2":"react-redux","amd":"ReactRedux","root":"ReactRedux"} ***!
  \************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react_redux__;

/***/ }),

/***/ "react-router-dom":
/*!******************************************************************************************************************************!*\
  !*** external {"commonjs":"react-router-dom","commonjs2":"react-router-dom","amd":"ReactRouterDom","root":"ReactRouterDom"} ***!
  \******************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react_router_dom__;

/***/ }),

/***/ "redux":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"redux","commonjs2":"redux","amd":"Redux","root":"Redux"} ***!
  \**************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;

/***/ }),

/***/ "styled-components":
/*!************************************************************************************************************************************!*\
  !*** external {"commonjs":"styled-components","commonjs2":"styled-components","amd":"StyledComponents","root":"StyledComponents"} ***!
  \************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ }),

/***/ "./i18n/settings.json":
/*!****************************!*\
  !*** ./i18n/settings.json ***!
  \****************************/
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"contextSeparator":" [[translation context:]] ","keySeparator":false,"nsSeparator":false,"defaultLanguage":"en-US","ns":"lib-am-common"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./components/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Components.js.map